webpackJsonp([3],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(569);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularRoute = __webpack_require__(156);
	
	var _angularRoute2 = _interopRequireDefault(_angularRoute);
	
	var _angularCookies = __webpack_require__(155);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _dropdown = __webpack_require__(203);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _modal = __webpack_require__(413);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _progressbar = __webpack_require__(415);
	
	var _progressbar2 = _interopRequireDefault(_progressbar);
	
	var _factboxApp = __webpack_require__(432);
	
	var _factboxApp2 = _interopRequireDefault(_factboxApp);
	
	var _factboxApp3 = __webpack_require__(431);
	
	var _factboxApp4 = _interopRequireDefault(_factboxApp3);
	
	var _factboxApp5 = __webpack_require__(427);
	
	var _factboxApp6 = _interopRequireDefault(_factboxApp5);
	
	var _factboxApp7 = __webpack_require__(428);
	
	var _factboxApp8 = _interopRequireDefault(_factboxApp7);
	
	var _factboxApp9 = __webpack_require__(430);
	
	var _factboxApp10 = _interopRequireDefault(_factboxApp9);
	
	var _factboxApp11 = __webpack_require__(429);
	
	var _factboxApp12 = _interopRequireDefault(_factboxApp11);
	
	var _lexicon = __webpack_require__(213);
	
	var _lexicon2 = _interopRequireDefault(_lexicon);
	
	var _unauthorized = __webpack_require__(484);
	
	var _unauthorized2 = _interopRequireDefault(_unauthorized);
	
	var _errorFeedback = __webpack_require__(482);
	
	var _errorFeedback2 = _interopRequireDefault(_errorFeedback);
	
	var _loadingFeedback = __webpack_require__(483);
	
	var _loadingFeedback2 = _interopRequireDefault(_loadingFeedback);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _browser = __webpack_require__(161);
	
	var _browser2 = _interopRequireDefault(_browser);
	
	var _signin = __webpack_require__(314);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _errors = __webpack_require__(116);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _account = __webpack_require__(530);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _download = __webpack_require__(533);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _fact = __webpack_require__(536);
	
	var _fact2 = _interopRequireDefault(_fact);
	
	var _forgot = __webpack_require__(539);
	
	var _forgot2 = _interopRequireDefault(_forgot);
	
	var _home = __webpack_require__(544);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _oauthCompleted = __webpack_require__(545);
	
	var _oauthCompleted2 = _interopRequireDefault(_oauthCompleted);
	
	var _reset = __webpack_require__(547);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	var _signin3 = __webpack_require__(322);
	
	var _signin4 = _interopRequireDefault(_signin3);
	
	var _signup = __webpack_require__(552);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _tutorial = __webpack_require__(555);
	
	var _tutorial2 = _interopRequireDefault(_tutorial);
	
	var _verify = __webpack_require__(558);
	
	var _verify2 = _interopRequireDefault(_verify);
	
	var _help = __webpack_require__(541);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _fbLoading = __webpack_require__(444);
	
	var _fbLoading2 = _interopRequireDefault(_fbLoading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(286);
	
	// Application Settings
	
	
	// Filters
	
	
	// Interceptors
	
	
	// Services
	
	
	// Modals
	
	
	// Models
	
	
	// Pages
	
	// import DebugPage from '../../pages/debug';
	
	// Directives
	
	
	_angular2.default.module('factbox-app', [_angularRoute2.default, _angularCookies2.default, _dropdown2.default, _modal2.default, _progressbar2.default, _unauthorized2.default, _errorFeedback2.default, _errors2.default, _loadingFeedback2.default, _analytics2.default, _browser2.default, _home2.default, _fact2.default, _signin4.default, _signup2.default, _account2.default, _download2.default, _forgot2.default, _help2.default, _oauthCompleted2.default, _reset2.default, _tutorial2.default, _verify2.default, _fbLoading2.default, _signin2.default, _lexicon2.default]).config(_factboxApp2.default).config(_factboxApp8.default).config(_factboxApp10.default).config(_factboxApp12.default).run(_factboxApp4.default).run(_factboxApp6.default).run(['$templateCache', function ($templateCache) {
	    $templateCache.put('/modals/default/modal-container.html', __webpack_require__(848));
	}]);

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var core = __webpack_require__(57);
	var hide = __webpack_require__(41);
	var redefine = __webpack_require__(42);
	var ctx = __webpack_require__(51);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(226);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(235), __esModule: true };

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(228);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(225);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(140);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(140);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 8 */
[912, 12],
/* 9 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(76);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _browser = __webpack_require__(161);
	
	var _browser2 = _interopRequireDefault(_browser);
	
	var _analytics = __webpack_require__(127);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _version = __webpack_require__(159);
	
	var _version2 = _interopRequireDefault(_version);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnalyticsServ = function () {
	  function AnalyticsServ($window, Browser, VersionConst) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, AnalyticsServ);
	
	    this.analytics = (0, _analytics2.default)({
	      writeKey: $window.conf.segment,
	      skipPageCall: true
	    });
	
	    this.olark = $window.olark;
	    this.browser = Browser;
	    this.analytics.ready(function () {
	      Rollbar && Rollbar.configure({
	        checkIgnore: _this.ignoreRemoteUncaught,
	        payload: {
	          client: {
	            javascript: {
	              source_map_enabled: true,
	              /* provided by webpack define plugin*/
	              code_version: ("1.62.5"),
	              guess_uncaught_frames: true
	            }
	          }
	        }
	      });
	    });
	    this.analytics.identify({
	      Version: VersionConst
	    });
	  }
	
	  // Stricter tracking events in the future, methods passed through for now
	
	
	  (0, _createClass3.default)(AnalyticsServ, [{
	    key: 'page',
	    value: function page(path) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var page = (0, _assign2.default)({ path: path }, data);
	      this.analytics.page(path, page);
	    }
	  }, {
	    key: 'clicked',
	    value: function clicked(eventName) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.analytics.track('Clicked ' + eventName, data);
	    }
	  }, {
	    key: 'blurredField',
	    value: function blurredField(fieldName) {
	      this.analytics.track(fieldName + ' Field Blurred');
	    }
	  }, {
	    key: 'focusedField',
	    value: function focusedField(fieldName) {
	      this.analytics.track(fieldName + ' Field Focused');
	    }
	  }, {
	    key: 'setUser',
	    value: function setUser(user) {
	      this.analytics.identify(user.id, user);
	    }
	  }, {
	    key: 'signedUp',
	    value: function signedUp(data, invited) {
	      var user = {
	        firstName: data.firstName,
	        lastName: data.lastName,
	        email: data.email,
	        currentAccountId: data.currentAccountId,
	        id: data.id,
	        'Signed Up': new Date(),
	        'Browser Version': this.browser.name + ' ' + this.browser.version,
	        'Invited': invited || false,
	        'Lexicon': data.lexicon || 'legal',
	        'Paid': null
	      };
	
	      this.analytics.alias(user.id);
	      this.setUser(user);
	      this.analytics.track('Signed Up');
	    }
	  }, {
	    key: 'signedIn',
	    value: function signedIn(user) {
	      user['Browser Version'] = this.browser.name + ' ' + this.browser.version;
	      this.setUser(user);
	      this.analytics.track('Signed In');
	    }
	  }, {
	    key: 'signedOut',
	    value: function signedOut() {
	      this.analytics.track('Signed Out');
	      this.analytics.reset();
	    }
	  }, {
	    key: 'userVerified',
	    value: function userVerified(user) {
	      user['Verified On'] = new Date();
	      this.setUser(user);
	      this.analytics.track('User Verified');
	    }
	  }, {
	    key: 'userMfaEnabled',
	    value: function userMfaEnabled(user) {
	      user['MFA'] = true;
	      user['MFA Enabled'] = new Date();
	      this.setUser(user);
	      this.analytics.track('User Enabled MFA');
	    }
	  }, {
	    key: 'userMfaDisabled',
	    value: function userMfaDisabled(user) {
	      user['MFA'] = false;
	      user['MFA Disabled'] = new Date();
	      this.setUser(user);
	      this.analytics.track('User Disabled MFA');
	    }
	  }, {
	    key: 'added',
	    value: function added(attr) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      // Track event, increment <Attr>s Added prop, set Attr Last Added
	      var user = {};
	      user['Last ' + attr + ' Added'] = new Date();
	      this.analytics.identify(user);
	
	      this.analytics.track(attr + ' Added', data);
	    }
	  }, {
	    key: 'updated',
	    value: function updated(attr) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this.analytics.track(attr + ' Updated', data);
	    }
	  }, {
	    key: 'removed',
	    value: function removed(attr) {
	      this.analytics.track(attr + ' Removed');
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.analytics.reset();
	    }
	  }, {
	    key: 'setFirstSeen',
	    value: function setFirstSeen() {
	      this.analytics.ready(function () {
	        mixpanel && mixpanel.people.set_once({
	          'First Seen': new Date()
	        });
	      });
	    }
	  }, {
	    key: 'setChatVisibility',
	    value: function setChatVisibility(show) {
	      this.analytics.ready(function () {
	        olark && olark(show ? 'api.box.show' : 'api.box.hide');
	      });
	    }
	  }, {
	    key: 'ignoreRemoteUncaught',
	    value: function ignoreRemoteUncaught(isUncaught, args, payload) {
	      // adapted from https://gist.github.com/coryvirok/2bd77c35db1ab758afe5
	      try {
	        var filename = payload.data.body.trace.frames[0].filename;
	        if (isUncaught && !/^https?:\/\/(staging\.)?getfactbox\.com/.test(filename)) {
	          return true;
	        }
	      } catch (e) {}
	      return false;
	    }
	  }]);
	  return AnalyticsServ;
	}();
	
	AnalyticsServ.$inject = ['$window', 'Browser', 'VersionConst'];
	
	exports.default = _angular2.default.module('services.analytics', [_browser2.default, _version2.default]).service('AnalyticsServ', AnalyticsServ).name;

/***/ }),
/* 14 */
[964, 179, 109, 10],
/* 15 */
10,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularResource = __webpack_require__(62);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ModelFactory($route, $resource, $rootScope) {
	  return function () {
	    function Model() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      (0, _classCallCheck3.default)(this, Model);
	
	
	      this.data = data;
	      this.api = {};
	      this.promises = {};
	      this.error = {};
	      this.busy = false;
	      this.setters = [];
	    }
	
	    (0, _createClass3.default)(Model, [{
	      key: 'registerErrorCleaner',
	      value: function registerErrorCleaner() {
	        var _this = this;
	
	        // $on returns an a function to deregister listener
	        var deregisterListener = $rootScope.$on('$routeChangeStart', function () {
	          delete _this.error;
	          deregisterListener();
	        });
	      }
	    }, {
	      key: 'setData',
	      value: function setData() {
	        var _this2 = this;
	
	        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.data;
	
	        this.data = data;
	        this.setters.forEach(function (setter) {
	          setter(_this2.data);
	        });
	      }
	    }, {
	      key: 'setProp',
	      value: function setProp(key, value) {
	        if (!key) {
	          return;
	        }
	        this.data[key] = value;
	        this.setData();
	      }
	    }, {
	      key: 'setMethod',
	      value: function setMethod(name, method, defaultParams, conf) {
	        var _this3 = this;
	
	        this.api[name] = function () {
	          var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var payload = arguments[1];
	
	
	          // Block 'replay' requests for non-GET methods unless
	          // cancellable requests are enabled
	          if (_this3.busy && !method.cancellable && method.method !== 'GET') {
	            return _this3.promises[name].$promise;
	          }
	          if ((method.cancellable || conf.cancellable) && _this3.promises[name] && _this3.promises[name].hasOwnProperty('$cancelRequest')) {
	            _this3.promises[name].$cancelRequest();
	          }
	          _this3.busy = true;
	
	          // set default params and payload
	          if (/GET|PUT|POST|DELETE/.test(method.method) && !payload) {
	            payload = _this3.data;
	          }
	          if (defaultParams && defaultParams.caseId && !params.caseId) {
	            params.caseId = $route.current.params.caseId;
	          }
	
	          _this3.promises[name] = _this3.resource[name](params, payload, function (data) {
	
	            if (typeof method.success === 'undefined') {
	              _this3.success(data);
	            } else {
	              method.success.forEach(function (cb) {
	                cb(data);
	              });
	            }
	
	            _this3.busy = false;
	
	            delete _this3.error;
	          }, function (response) {
	
	            if (typeof method.fail === 'undefined') {
	              _this3.fail(response);
	            } else {
	              method.fail.forEach(function (cb) {
	                cb(response);
	              });
	            }
	
	            _this3.busy = false;
	          });
	          return _this3.promises[name].$promise;
	        };
	      }
	    }, {
	      key: 'setApi',
	      value: function setApi(enpoint, defaultParams, methods) {
	        var _this4 = this;
	
	        var conf = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	        this.resource = $resource(enpoint, defaultParams, methods, conf);
	
	        // wrap resource in promise, set busy, run success / fail callbacks
	        // declared in model methods
	        (0, _keys2.default)(methods).forEach(function (method) {
	          return _this4.setMethod(method, methods[method], defaultParams, conf);
	        });
	      }
	    }, {
	      key: 'getData',
	      value: function getData() {
	        return this.data;
	      }
	    }, {
	      key: 'subscribe',
	      value: function subscribe(setter) {
	        this.setters.push(setter);
	        setter(this.data);
	      }
	    }, {
	      key: 'success',
	      value: function success(data) {
	        this.setData(data);
	      }
	    }, {
	      key: 'fail',
	      value: function fail(response) {
	        this.registerErrorCleaner();
	        this.error = response.data;
	      }
	    }]);
	    return Model;
	  }();
	}
	ModelFactory.$inject = ['$route', '$resource', '$rootScope'];
	
	exports.default = _angular2.default.module('models.model', [_angularResource2.default]).factory('Model', ModelFactory).name;

/***/ }),
/* 17 */
[923, 25],
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var core = __webpack_require__(9);
	var ctx = __webpack_require__(44);
	var hide = __webpack_require__(31);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 19 */
[940, 32, 91, 70, 17],
/* 20 */
[923, 11],
/* 21 */
[940, 8, 340, 61, 20],
/* 22 */
[958, 60],
/* 23 */
[964, 69, 49, 15],
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCache = __webpack_require__(154);
	
	var _angularCache2 = _interopRequireDefault(_angularCache);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _reload = __webpack_require__(139);
	
	var _reload2 = _interopRequireDefault(_reload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UserFactory(Model, AnalyticsServ, $cacheFactory, $window, ReloadServ) {
	  return function (_Model) {
	    (0, _inherits3.default)(UserModel, _Model);
	
	    function UserModel() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      (0, _classCallCheck3.default)(this, UserModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (UserModel.__proto__ || (0, _getPrototypeOf2.default)(UserModel)).call(this, data));
	
	      _this.setApi('/user', null, {
	        get: {
	          method: 'GET',
	          cache: true
	        },
	        fetch: {
	          method: 'GET',
	          params: {
	            registered: true
	          }
	        },
	        update: {
	          method: 'PUT',
	          success: [function (data) {
	            return $cacheFactory.get('$http').remove('/user');
	          }, function (data) {
	            return _this.success(data);
	          }, function (data) {
	            return AnalyticsServ.updated('User');
	          }]
	        },
	        signin: {
	          method: 'POST',
	          url: '/login',
	          params: {
	            rememberMe: '@rememberMe'
	          },
	          success: [function (data) {
	            return _this.success(data);
	          }, function (data) {
	            ReloadServ.updateTabs();
	            AnalyticsServ.signedIn(data);
	          }]
	        },
	        signup: {
	          method: 'POST',
	          url: '/signup',
	          success: [function (data) {
	            return _this.success(data);
	          }, function (data) {
	            return AnalyticsServ.signedUp(data);
	          }]
	        },
	        signout: {
	          method: 'POST',
	          url: '/logout',
	          success: [function (data) {
	            return _this.success(data);
	          }, function () {
	            $cacheFactory.get('$http').remove('/user');
	            AnalyticsServ.signedOut();
	            ReloadServ.updateTabs();
	            $window.location.href = "/";
	          }]
	        },
	        changePassword: {
	          method: 'POST',
	          url: '/user/changePassword',
	          success: [function (data) {
	            return _this.success(data);
	          }, function (data) {
	            return AnalyticsServ.updated('Password');
	          }]
	        },
	        resetPassword: {
	          method: 'POST',
	          url: '/user/reset',
	          fail: [function () {
	            return _this.data.password = '';
	          }, function (data) {
	            return _this.fail(data);
	          }]
	        },
	        initPassword: {
	          method: 'POST',
	          url: '/user/init',
	          fail: [function () {
	            return _this.data.password = '';
	          }, function (data) {
	            return _this.fail(data);
	          }]
	        },
	        requestReset: {
	          method: 'POST',
	          url: '/user/requestReset',
	          params: {
	            email: '@email'
	          },
	          success: [function (data) {
	            return _this.success(data);
	          }, function (data) {
	            return AnalyticsServ.analytics.track('Password Reset Requested');
	          }],
	          fail: [function () {
	            return _this.data.email = '';
	          }, function (data) {
	            return _this.fail(data);
	          }]
	        },
	        changeAccount: {
	          method: 'PUT',
	          url: '/user/account/:accountId',
	          params: {
	            accountId: '@accountId'
	          },
	          success: [function (data) {
	            return $cacheFactory.get('$http').remove('/user');
	          }, function (data) {
	            return _this.success(data);
	          }, function (data) {
	            return ReloadServ.updateTabs();
	          }]
	        },
	        verify: {
	          method: 'PUT',
	          url: '/user/verify',
	          success: [function (data) {
	            return $cacheFactory.get('$http').remove('/user');
	          }, function (data) {
	            return _this.success(data);
	          }, function (data) {
	            return AnalyticsServ.userVerified(data);
	          }]
	        },
	        addPhone: {
	          method: 'POST',
	          url: '/user/mfa'
	        },
	        removePhone: {
	          method: 'PUT',
	          url: '/user/mfa',
	          success: [function (data) {
	            return $cacheFactory.get('$http').remove('/user');
	          }, function (data) {
	            return AnalyticsServ.userMfaDisabled(_this.data);
	          }]
	        },
	        sendSMS: {
	          method: 'GET',
	          url: '/user/mfa/verify'
	        },
	        verifyAuthCode: {
	          method: 'POST',
	          url: '/user/mfa/verify',
	          success: [function (data) {
	            return $cacheFactory.get('$http').remove('/user');
	          }, function (data) {
	            return AnalyticsServ.userMfaEnabled(_this.data);
	          }]
	        },
	        purchaseCase: {
	          method: 'PUT',
	          url: '/user/pay-for',
	          params: {
	            caseId: '@caseId'
	          }
	        },
	        queryInviter: {
	          method: 'GET',
	          url: '/invite/:id',
	          params: {
	            id: '@id'
	          },
	          success: [function (data) {
	            _this.data.referredBy = data.referrerCode;
	            _this.setData();
	          }]
	        },
	        invite: {
	          method: 'POST',
	          url: '/invite',
	          success: [function (data) {
	            return AnalyticsServ.analytics.track('Referrals Sent');
	          }]
	        }
	      });
	      return _this;
	    }
	
	    return UserModel;
	  }(Model);
	}
	
	UserFactory.$inject = ['Model', 'AnalyticsServ', '$cacheFactory', '$window', 'ReloadServ'];
	
	exports.default = _angular2.default.module('models.user', [_model2.default, _analytics2.default, _reload2.default, _angularCache2.default]).factory('User', UserFactory).service('CurrentUser', ['User', function (User) {
	  return new User();
	}]).name;

/***/ }),
/* 25 */
11,
/* 26 */
12,
/* 27 */
[957, 78, 53],
/* 28 */
[959, 58],
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultGrouping = function () {
	  function DefaultGrouping() {
	    (0, _classCallCheck3.default)(this, DefaultGrouping);
	
	    this.name = '';
	    this.displayName = '';
	    this.ungroupedName = '';
	    this.selectorReverseSorted = false;
	    this.groupByPulldown = true;
	    this.secondarySortable = true;
	    this.reverseSortable = false;
	    this.groupingReverseSorted = null;
	    this.sortDirectionText = {
	      true: {
	        text: '',
	        icon: ''
	      },
	      false: {
	        text: '',
	        icon: ''
	      }
	    };
	    // sort branches based on their id (constructed in buildTree)
	    this.sortingKey = 'displayName';
	  }
	
	  (0, _createClass3.default)(DefaultGrouping, [{
	    key: 'setColumns',
	    value: function setColumns(cols) {
	      return cols.map(function (col, i) {
	        return {
	          key: col,
	          visible: i < 5
	        };
	      });
	    }
	  }, {
	    key: 'getDocDisplayStyles',
	    value: function getDocDisplayStyles() {
	      return {
	        'border-style': 'solid',
	        'border-width': '1px',
	        'width': '11%',
	        'padding': '3px'
	      };
	    }
	  }, {
	    key: 'getDisplayText',
	    value: function getDisplayText(value) {
	      return value;
	    }
	  }, {
	    key: 'getDisplayName',
	    value: function getDisplayName(branch) {
	      // called from a Branch
	      return branch.displayName || this.ungroupedName;
	    }
	  }, {
	    key: 'getOutlineText',
	    value: function getOutlineText(branch) {
	      return this.getDisplayName(branch);
	    }
	  }, {
	    key: 'getFactItems',
	    value: function getFactItems(fact) {
	      return [];
	    }
	  }, {
	    key: 'getItemsByFact',
	    value: function getItemsByFact(fact) {
	      var items = [];
	      items.push(fact[this.name]);
	      return items;
	    }
	  }]);
	  return DefaultGrouping;
	}();
	
	exports.default = DefaultGrouping;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 31 */
[927, 19, 45, 17],
/* 32 */
[912, 26],
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(141), __esModule: true };

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(227);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _trees = __webpack_require__(64);
	
	var _trees2 = _interopRequireDefault(_trees);
	
	var _factQuery = __webpack_require__(63);
	
	var _factQuery2 = _interopRequireDefault(_factQuery);
	
	var _factList = __webpack_require__(89);
	
	var _factList2 = _interopRequireDefault(_factList);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CaseFactory(Model, Trees, FactQuery, FactList, AnalyticsServ, $window) {
	  return function (_Model) {
	    (0, _inherits3.default)(CaseModel, _Model);
	
	    function CaseModel() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      (0, _classCallCheck3.default)(this, CaseModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (CaseModel.__proto__ || (0, _getPrototypeOf2.default)(CaseModel)).call(this, data));
	
	      _this.window = $window;
	      _this.analyticsServ = AnalyticsServ;
	      _this.revisionInterceptor = {
	        response: function response(_response) {
	          var revNo = parseInt(_response.headers("X-CASE-REVISION"));
	          if (revNo) {
	            // Show the Updates Available status indicator
	            // only when the local case has fallen behind the servers version
	            // If the user incurs the case revision (by a PUT)
	            // do not display the status indicator
	
	            if (_response.config.method !== 'GET') {
	              this.data.revisionNumber++;
	            }
	            if (revNo > this.data.revisionNumber) {
	              this.data.hasUpdates = true;
	            }
	          }
	          return _response.resource;
	        }
	      };
	      _this.setApi("/case/:caseId", {}, {
	        ping: {
	          method: 'GET',
	          url: '/case/:caseId/ping'
	        },
	        create: {
	          url: '/case',
	          method: 'POST',
	          success: [function (data) {
	            return _this.success(data);
	          }, function (data) {
	            return AnalyticsServ.added('Case');
	          }]
	        },
	        copy: {
	          method: 'POST',
	          url: '/case/:copyCaseId/copy',
	          success: [function (data) {
	            return _this.success(data);
	          }, function (data) {
	            return AnalyticsServ.analytics.track('Case Copied');
	          }]
	        },
	        get: {
	          method: 'GET',
	          params: {
	            caseId: '@id'
	          },
	          interceptor: _this.revisionInterceptor,
	          success: [function (data) {
	            return _this.setCase(data);
	          }]
	        },
	        getReport: {
	          method: 'GET',
	          url: '/case/:caseId/report',
	          params: {
	            caseId: '@id'
	          },
	          success: [function (data) {}]
	        },
	        update: {
	          method: 'PUT',
	          params: {
	            caseId: '@id'
	          },
	          success: [function (data) {
	            return _this.setCase(data);
	          }, function (data) {
	            return AnalyticsServ[data.status === 'archived' ? 'removed' : 'updated']('Case');
	          }]
	        }
	      });
	      return _this;
	    }
	
	    (0, _createClass3.default)(CaseModel, [{
	      key: 'setCase',
	      value: function setCase(data) {
	        if (data) {
	          // Set 'side loaded' data if available
	          if (data.hasOwnProperty('valueTrees')) {
	            (0, _keys2.default)(data.valueTrees).forEach(function (key) {
	              Trees[key].setData(data.valueTrees[key]);
	              Trees[key].setExcludedByQuery(data.query.filterPipeline.filter(function (f) {
	                return f.attribute === key;
	              }).shift());
	              Trees[key].setCollapsedByQuery(data.query.filterPipeline.filter(function (f) {
	                return f.attribute === key;
	              }).shift());
	            });
	          }
	          if (data.hasOwnProperty('factResult')) {
	            FactList.setData(data.factResult);
	          }
	          if (data.hasOwnProperty('query')) {
	            FactQuery.setData(data.query);
	          }
	          this.setData(data);
	        } else {
	          FactQuery.setData({});
	          (0, _keys2.default)(Trees).forEach(function (key) {
	            Trees[key].setData([]);
	          });
	          FactList.setData({});
	          this.setData({});
	        }
	      }
	    }, {
	      key: 'getReport',
	      value: function getReport() {
	        this.window.location.href = '/case/' + this.data.id + '/report';
	        this.analyticsServ.analytics.track('Case Report Generated');
	      }
	    }, {
	      key: 'getOutline',
	      value: function getOutline(attr, queryId) {
	        var params = {
	          attr: attr,
	          queryId: queryId
	        };
	        var paramStr = (0, _keys2.default)(params).filter(function (key) {
	          return params[key];
	        }).map(function (key, index) {
	          return (index ? '&' : '?') + (key + '=' + params[key]);
	        }).join('');
	        this.window.location.href = '/case/' + this.data.id + '/outline' + paramStr;
	        this.analyticsServ.analytics.track('Case Outline Generated');
	      }
	    }]);
	    return CaseModel;
	  }(Model);
	}
	CaseFactory.$inject = ['Model', 'Trees', 'FactQuery', 'FactList', 'AnalyticsServ', '$window'];
	
	exports.default = _angular2.default.module('models.case', [_model2.default, _trees2.default, _factQuery2.default, _factList2.default, _analytics2.default]).factory('Case', CaseFactory).service('CurrentCase', ['Case', function (Case) {
	  return new Case();
	}]).name;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TreeModelFactory(Model) {
	  return function (_Model) {
	    (0, _inherits3.default)(TreeModel, _Model);
	
	    function TreeModel(Grouping) {
	      (0, _classCallCheck3.default)(this, TreeModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (TreeModel.__proto__ || (0, _getPrototypeOf2.default)(TreeModel)).call(this, new Array()));
	
	      _this.grouping = Grouping;
	      return _this;
	    }
	
	    (0, _createClass3.default)(TreeModel, [{
	      key: 'findExcluded',
	      value: function findExcluded(node, excluded, groups) {
	        var _this2 = this;
	
	        if (node.excluded === excluded) {
	          groups.push(node.id);
	        }
	        if (node.children && node.children.length !== 0) {
	          node.children.forEach(function (child) {
	            _this2.findExcluded(child, excluded, groups);
	          });
	        }
	      }
	    }, {
	      key: 'findCollapsed',
	      value: function findCollapsed(node, collapsed, groups) {
	        var _this3 = this;
	
	        if (node.collapsed === collapsed) {
	          groups.push(node.id);
	        }
	        if (node.children && node.children.length !== 0) {
	          node.children.forEach(function (child) {
	            _this3.findCollapsed(child, collapsed, groups);
	          });
	        }
	      }
	    }, {
	      key: 'setExcludedByQuery',
	      value: function setExcludedByQuery(viewBy) {
	        if (viewBy.includes && viewBy.includes.length === 0 && viewBy.excludes && viewBy.excludes.length === 0) {
	          this.setAllExcluded(true);
	        } else if (viewBy.includes && viewBy.includes.length > 0) {
	          this.setAllExcluded(true);
	          this.findIds(viewBy.includes).forEach(function (node) {
	            if (node) {
	              node.excluded = false;
	            }
	          });
	        } else {
	          this.findIds(viewBy.excludes).forEach(function (node) {
	            if (node) {
	              node.excluded = true;
	            }
	          });
	        }
	      }
	    }, {
	      key: 'setCollapsedByQuery',
	      value: function setCollapsedByQuery(viewBy) {
	        if (viewBy.uncollapsed && viewBy.uncollapsed.length === 0 && viewBy.collapsed && viewBy.collapsed.length === 0) {
	          this.setAllCollapsed(true);
	        } else if (viewBy.uncollapsed && viewBy.uncollapsed.length > 0) {
	          this.setAllCollapsed(true);
	          this.findIds(viewBy.uncollapsed).forEach(function (node) {
	            if (node) {
	              node.collapsed = false;
	            }
	          });
	        } else {
	          this.findIds(viewBy.collapsed).forEach(function (node) {
	            if (node) {
	              node.collapsed = true;
	            }
	          });
	        }
	      }
	    }, {
	      key: 'findAllExcluded',
	      value: function findAllExcluded(viewBy) {
	        var _this4 = this;
	
	        if (viewBy.includes && viewBy.includes.length === 0 && viewBy.excludes && viewBy.excludes.length === 0 || viewBy.includes && viewBy.includes.length > 0) {
	          viewBy.includes = [];
	          this.data.forEach(function (node) {
	            _this4.findExcluded(node, false, viewBy.includes);
	          });
	          viewBy.excludes = [];
	        } else {
	          viewBy.excludes = [];
	          this.data.forEach(function (node) {
	            _this4.findExcluded(node, true, viewBy.excludes);
	          });
	          viewBy.includes = null;
	        }
	        return viewBy;
	      }
	    }, {
	      key: 'findAllCollapsed',
	      value: function findAllCollapsed(viewBy) {
	        var _this5 = this;
	
	        if (viewBy.uncollapsed && viewBy.uncollapsed.length === 0 && viewBy.collapsed && viewBy.collapsed.length === 0 || viewBy.uncollapsed && viewBy.uncollapsed.length > 0) {
	          viewBy.uncollapsed = [];
	          this.data.forEach(function (node) {
	            _this5.findCollapsed(node, false, viewBy.uncollapsed);
	          });
	          viewBy.collapsed = [];
	        } else {
	          viewBy.collapsed = [];
	          this.data.forEach(function (node) {
	            _this5.findCollapsed(node, true, viewBy.collapsed);
	          });
	          viewBy.uncollapsed = null;
	        }
	        return viewBy;
	      }
	    }, {
	      key: 'toGroup',
	      value: function toGroup(node) {
	        var _this6 = this;
	
	        var parentsArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	        var groups = arguments[2];
	
	        // drill-down and accumulate parents (in order to set names)
	
	        parentsArray.push(node);
	
	        if (!node.excluded) {
	          groups.push({
	            id: node.id,
	            displayName: parentsArray.map(function (parent) {
	              return parent.displayName;
	            }).join(' / '),
	            facts: []
	          });
	        }
	
	        if (node.children && node.children.length !== 0) {
	          node.children.forEach(function (child) {
	            _this6.toGroup(child, parentsArray, groups);
	          });
	        }
	      }
	    }, {
	      key: 'toGroups',
	      value: function toGroups() {
	        var _this7 = this;
	
	        var groups = [];
	        // convert tree to 1d array (single level)
	        this.data.forEach(function (node) {
	          _this7.toGroup(node, [], groups);
	        });
	
	        return groups;
	      }
	    }, {
	      key: 'findNode',
	      value: function findNode(id, tree) {
	        var parentsArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	        if (!tree) {
	          tree = this.data;
	        }
	
	        for (var i = 0; i < tree.length; i++) {
	
	          if (tree[i].id === id) {
	            parentsArray.push(tree[i]);
	            tree[i].headerDisplayName = parentsArray.map(function (parent) {
	              return parent.displayName;
	            }).join(' / ');
	            return tree[i];
	          }
	          if (tree[i].children && tree[i].children.length !== 0) {
	            parentsArray.push(tree[i]);
	            var val = this.findNode(id, tree[i].children, parentsArray);
	            if (val) {
	              return val;
	            } else {
	              parentsArray.pop();
	            }
	          }
	        };
	      }
	    }, {
	      key: 'sortNodes',
	      value: function sortNodes(a, b, tree) {
	        // returns sort order int based on which node is found first
	        if (a.id === b.id) {
	          return 0;
	        }
	        if (!tree) {
	          tree = this.data;
	        }
	
	        for (var i = 0; i < tree.length; i++) {
	          if (tree[i].id === a.id) {
	            return -1;
	          } else if (tree[i].id === b.id) {
	            return 1;
	          } else if (tree[i].children && tree[i].children.length !== 0) {
	            var match = this.sortNodes(a, b, tree[i].children);
	            if (match) {
	              return match;
	            }
	          }
	        }
	      }
	    }, {
	      key: 'findIds',
	      value: function findIds(array) {
	        var _this8 = this;
	
	        return array.map(function (id) {
	          return _this8.findNode(id);
	        });
	      }
	    }, {
	      key: 'setExcluded',
	      value: function setExcluded(node, excluded) {
	        var _this9 = this;
	
	        if (typeof excluded === 'undefined') {
	          excluded = !node.excluded;
	        }
	        node.excluded = excluded;
	        if (node.children && node.children.length !== 0) {
	          node.children.forEach(function (child) {
	            _this9.setExcluded(child, excluded);
	          });
	        }
	      }
	    }, {
	      key: 'toggleExcluded',
	      value: function toggleExcluded(node) {
	        this.setExcluded(node, !node.excluded);
	        this.setData(this.data);
	      }
	    }, {
	      key: 'setAllExcluded',
	      value: function setAllExcluded(excluded) {
	        var _this10 = this;
	
	        this.data.forEach(function (node) {
	          _this10.setExcluded(node, excluded);
	        });
	        this.setData(this.data);
	      }
	    }, {
	      key: 'setCollapsed',
	      value: function setCollapsed(node, collapsed) {
	        var _this11 = this;
	
	        if (typeof collapsed === 'undefined') {
	          collapsed = !node.collapsed;
	        }
	        node.collapsed = collapsed;
	        if (node.children && node.children.length !== 0) {
	          node.children.forEach(function (child) {
	            _this11.setCollapsed(child, collapsed);
	          });
	        }
	      }
	    }, {
	      key: 'toggleCollapsed',
	      value: function toggleCollapsed(node) {
	        this.setCollapsed(node, !node.collapsed);
	        this.setData(this.data);
	      }
	    }, {
	      key: 'setAllCollapsed',
	      value: function setAllCollapsed(collapsed) {
	        var _this12 = this;
	
	        this.data.forEach(function (node) {
	          _this12.setCollapsed(node, collapsed);
	        });
	        this.setData(this.data);
	      }
	    }, {
	      key: 'set',
	      value: function set(item) {
	        // find item in tree and replace it
	        this.data.set(item.id, item);
	      }
	    }, {
	      key: 'add',
	      value: function add(item) {
	        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        item.children = item.children || [];
	        parent.children = parent.children || [];
	        if (parent.id) {
	          parent.children.push(item);
	        } else if (!this.data.some(function (i) {
	          return i.id === item.id;
	        })) {
	          this.data.push(item);
	        }
	      }
	    }, {
	      key: 'remove',
	      value: function remove(item, array) {
	        var _this13 = this;
	
	        if (!array) {
	          array = this.data;
	        }
	        var index;
	        for (var i = 0; i < array.length; i++) {
	          if (array[i].id === item.id) {
	            index = i;
	          }
	        };
	        if (index > -1) {
	          array.splice(index, 1);
	        } else {
	          array.forEach(function (node) {
	            if (node.children && node.children.length !== 0) {
	              _this13.remove(item, node.children);
	            }
	          });
	        }
	      }
	    }, {
	      key: 'get',
	      value: function get(id) {
	        return this.data.get(id);
	      }
	    }]);
	    return TreeModel;
	  }(Model);
	}
	TreeModelFactory.$inject = ['Model'];
	
	exports.default = _angular2.default.module('trees.tree', [_model2.default]).factory('TreeModel', TreeModelFactory).name;

/***/ }),
/* 38 */
[947, 95, 65],
/* 39 */
[959, 53],
/* 40 */
30,
/* 41 */
[927, 21, 105, 20],
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var hide = __webpack_require__(41);
	var has = __webpack_require__(40);
	var SRC = __webpack_require__(109)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(57).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var fails = __webpack_require__(11);
	var defined = __webpack_require__(58);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 44 */
[922, 117],
/* 45 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 46 */
[942, 151, 105, 48, 61, 40, 340, 20],
/* 47 */
[945, 40, 28, 276],
/* 48 */
[957, 150, 58],
/* 49 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 51 */
[922, 35],
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(11);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 56 */
[915, 51, 150, 28, 22, 261],
/* 57 */
9,
/* 58 */
53,
/* 59 */
[948, 2, 57, 11],
/* 60 */
55,
/* 61 */
[960, 12],
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _factList = __webpack_require__(89);
	
	var _factList2 = _interopRequireDefault(_factList);
	
	var _trees = __webpack_require__(64);
	
	var _trees2 = _interopRequireDefault(_trees);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FactQueryFactory(Model, FactList, Trees) {
	  return function (_Model) {
	    (0, _inherits3.default)(FactQueryModel, _Model);
	
	    function FactQueryModel() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      (0, _classCallCheck3.default)(this, FactQueryModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (FactQueryModel.__proto__ || (0, _getPrototypeOf2.default)(FactQueryModel)).call(this, data));
	
	      _this.setApi("/case/:caseId/query/:queryId", {
	        caseId: '@caseId',
	        queryId: '@id'
	      }, {
	        get: {
	          method: 'GET',
	          success: [function (data) {
	            return _this.setQuery(data);
	          }]
	        },
	        update: {
	          method: 'PUT',
	          success: [function (data) {
	            return _this.setQuery(data);
	          }],
	          cancellable: true,
	          url: "/user/case/:caseId/query/:queryId"
	        },
	        setViewBy: {
	          params: {
	            attribute: '@attribute'
	          },
	          url: "/case/:caseId/query/:queryId/viewby/:attribute",
	          method: 'PUT',
	          success: [function (data) {
	            return _this.setQuery(data);
	          }]
	        }
	      });
	
	      return _this;
	    }
	
	    (0, _createClass3.default)(FactQueryModel, [{
	      key: 'setQuery',
	      value: function setQuery(data) {
	        if (FactList) {
	          FactList.setData(data.factResult);
	        }
	        if (Trees) {
	          (0, _keys2.default)(data.valueTrees).forEach(function (key) {
	            Trees[key].setData(data.valueTrees[key]);
	            Trees[key].setExcludedByQuery(data.query.filterPipeline.filter(function (f) {
	              return f.attribute === key;
	            }).shift());
	            Trees[key].setCollapsedByQuery(data.query.filterPipeline.filter(function (f) {
	              return f.attribute === key;
	            }).shift());
	          });
	        }
	        this.setData(data.query);
	      }
	    }]);
	    return FactQueryModel;
	  }(Model);
	}
	FactQueryFactory.$inject = ['Model', 'FactList', 'Trees'];
	
	exports.default = _angular2.default.module('models.fact-query', [_model2.default, _factList2.default, _trees2.default]).factory('FactQueryFactory', FactQueryFactory).service('FactQuery', ['FactQueryFactory', function (FactQueryFactory) {
	  return new FactQueryFactory();
	}]).name;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _creationDate = __webpack_require__(221);
	
	var _creationDate2 = _interopRequireDefault(_creationDate);
	
	var _contributors = __webpack_require__(220);
	
	var _contributors2 = _interopRequireDefault(_contributors);
	
	var _factDateish = __webpack_require__(222);
	
	var _factDateish2 = _interopRequireDefault(_factDateish);
	
	var _issues = __webpack_require__(136);
	
	var _issues2 = _interopRequireDefault(_issues);
	
	var _sources = __webpack_require__(137);
	
	var _sources2 = _interopRequireDefault(_sources);
	
	var _tags = __webpack_require__(138);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Trees(CreationDateTree, ContributorsTree, FactDateishTree, IssuesTree, SourcesTree, TagsTree) {
		return {
			'creationDate': CreationDateTree,
			'contributors': ContributorsTree,
			'factDateish': FactDateishTree,
			'legalIssues': IssuesTree,
			'sources': SourcesTree,
			'tags': TagsTree
		};
	}
	Trees.$inject = ['CreationDateTree', 'ContributorsTree', 'FactDateishTree', 'IssuesTree', 'SourcesTree', 'TagsTree'];
	
	exports.default = angular.module('trees.index', [_creationDate2.default, _contributors2.default, _factDateish2.default, _issues2.default, _sources2.default, _tags2.default]).factory('Trees', Trees).name;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 67 */
[948, 18, 9, 25],
/* 68 */
[953, 69, 49],
/* 69 */
[954, 15],
/* 70 */
[960, 26],
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(361);
	var $export = __webpack_require__(2);
	var shared = __webpack_require__(179)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(364))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(20)) {
	  var LIBRARY = __webpack_require__(101);
	  var global = __webpack_require__(10);
	  var fails = __webpack_require__(11);
	  var $export = __webpack_require__(2);
	  var $typed = __webpack_require__(181);
	  var $buffer = __webpack_require__(282);
	  var ctx = __webpack_require__(51);
	  var anInstance = __webpack_require__(99);
	  var propertyDesc = __webpack_require__(105);
	  var hide = __webpack_require__(41);
	  var redefineAll = __webpack_require__(106);
	  var toInteger = __webpack_require__(60);
	  var toLength = __webpack_require__(22);
	  var toIndex = __webpack_require__(359);
	  var toAbsoluteIndex = __webpack_require__(108);
	  var toPrimitive = __webpack_require__(61);
	  var has = __webpack_require__(40);
	  var classof = __webpack_require__(149);
	  var isObject = __webpack_require__(12);
	  var toObject = __webpack_require__(28);
	  var isArrayIter = __webpack_require__(268);
	  var create = __webpack_require__(102);
	  var getPrototypeOf = __webpack_require__(47);
	  var gOPN = __webpack_require__(103).f;
	  var getIterFn = __webpack_require__(284);
	  var uid = __webpack_require__(109);
	  var wks = __webpack_require__(14);
	  var createArrayMethod = __webpack_require__(56);
	  var createArrayIncludes = __webpack_require__(168);
	  var speciesConstructor = __webpack_require__(180);
	  var ArrayIterators = __webpack_require__(285);
	  var Iterators = __webpack_require__(120);
	  var $iterDetect = __webpack_require__(174);
	  var setSpecies = __webpack_require__(107);
	  var arrayFill = __webpack_require__(260);
	  var arrayCopyWithin = __webpack_require__(332);
	  var $DP = __webpack_require__(21);
	  var $GOPD = __webpack_require__(46);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AccountFactory(Model, AnalyticsServ) {
		return function (_Model) {
			(0, _inherits3.default)(AccountModel, _Model);
	
			function AccountModel() {
				var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				(0, _classCallCheck3.default)(this, AccountModel);
	
				var _this = (0, _possibleConstructorReturn3.default)(this, (AccountModel.__proto__ || (0, _getPrototypeOf2.default)(AccountModel)).call(this, data));
	
				_this.setApi("/account", null, {
					'get': {
						method: 'GET',
						url: '/cases',
						success: [function (data) {
							_this.setData(data.accounts.current);
						}]
					},
					'update': {
						method: 'PUT',
						success: [function (data) {
							_this.setData(data);
							AnalyticsServ.updated('Account');
						}]
					}
				});
				return _this;
			}
	
			return AccountModel;
		}(Model);
	}
	AccountFactory.$inject = ['Model', 'AnalyticsServ'];
	
	exports.default = _angular2.default.module('models.account', [_model2.default, _analytics2.default]).factory('Account', AccountFactory).service('CurrentAccount', ['Account', function (Account) {
		return new Account();
	}]).name;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(231), __esModule: true };

/***/ }),
/* 77 */
50,
/* 78 */
[930, 77],
/* 79 */
[939, 32, 245, 65, 68, 90, 242],
/* 80 */
[952, 19, 30, 23],
/* 81 */
[958, 55],
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(14)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(41)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 83 */
[937, 109, 12, 40, 21, 11],
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _headerNav = __webpack_require__(471);
	
	var _headerNav2 = _interopRequireDefault(_headerNav);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HeaderNav(CurrentUser) {
	  return {
	    restrict: 'E',
	    template: __webpack_require__(832),
	    controller: _headerNav2.default,
	    link: function link(scope, element, attrs) {
	      scope.user = CurrentUser.data;
	      scope.userMenu = attrs.userMenu; // bool
	      scope.links = attrs.links; // bool
	      // may include 'signup' and 'signin'
	      scope.headerNavClass = attrs.headerNavClass;
	      scope.setActions(attrs.actions && attrs.actions.split(' '));
	    }
	  };
	}
	HeaderNav.$inject = ['CurrentUser'];
	
	exports.default = _angular2.default.module('directives.header-nav', [_user2.default]).directive('headerNav', HeaderNav).name;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function lwPageFooter() {
		return {
			restrict: 'E',
			transclude: true,
			template: __webpack_require__(840)
		};
	}
	lwPageFooter.$inject = [];
	
	exports.default = _angular2.default.module('directives.lw-page-footer', []).directive('lwPageFooter', lwPageFooter).name;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FactList(Model, $q) {
		return function (_Model) {
			(0, _inherits3.default)(FactListModel, _Model);
	
			function FactListModel() {
				var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				(0, _classCallCheck3.default)(this, FactListModel);
	
				var _this = (0, _possibleConstructorReturn3.default)(this, (FactListModel.__proto__ || (0, _getPrototypeOf2.default)(FactListModel)).call(this, data));
	
				_this.setApi("/case/:caseId/facts", {
					caseId: '@caseId',
					queryId: '@queryId',
					skip: '@skip',
					limit: '@limit'
				}, {
					get: {
						method: 'GET'
					},
					getMore: {
						method: 'GET',
						success: [function (data) {
							_this.setMore(data);
						}]
					},
					getFactsByCreationDate: {
						method: 'GET',
						url: '/case/:caseId/factsByCreationDate'
					},
					getMoreByCreationDate: {
						method: 'GET',
						url: '/case/:caseId/factsByCreationDate',
						success: [function (data) {
							_this.setMore(data);
						}]
					}
				});
				return _this;
			}
	
			(0, _createClass3.default)(FactListModel, [{
				key: 'setMore',
				value: function setMore(data) {
					this.data.lastResult = data.lastResult;
					this.data.limit = data.limit;
					this.data.skip = data.skip;
					this.data.rows = this.data.rows.concat(data.rows);
					this.setData();
				}
			}, {
				key: 'loadMore',
				value: function loadMore() {
					if (this.data.lastResult) {
						var q = $q.defer();
						q.resolve();
						return q.promise;
					} else {
						this.data.skip = this.data.skip + this.data.limit;
						return this.api.getMore();
					}
				}
			}, {
				key: 'loadMoreByCreationDate',
				value: function loadMoreByCreationDate() {
					if (this.data.lastResult) {
						var q = $q.defer();
						q.resolve();
						return q.promise;
					} else {
						this.data.skip = this.data.skip + this.data.limit;
						return this.api.getMoreByCreationDate();
					}
				}
			}, {
				key: 'reload',
				value: function reload() {
					var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
					this.data.limit = index + 20;
					this.data.skip = 0;
					return this.api.get();
				}
			}, {
				key: 'setFact',
				value: function setFact(fact) {
					var factRows = this.data.rows.filter(function (row) {
						return row.row && row.row.id === fact.id;
					});
					if (factRows && factRows.length !== 0) {
						factRows.forEach(function (row) {
							return row.row = fact;
						});
					} else {
						this.data.rows.unshift({
							row: fact
						});
					}
					this.setData();
				}
			}, {
				key: 'removeFact',
				value: function removeFact(fact) {
					this.data.rows = this.data.rows.filter(function (row) {
						return row.row ? row.row.id !== fact.id : true;
					});
				}
			}]);
			return FactListModel;
		}(Model);
	}
	FactList.$inject = ['Model', '$q'];
	
	exports.default = _angular2.default.module('models.fact-list', [_model2.default]).factory('FactListFactory', FactList).service('FactList', ['FactListFactory', function (FactListFactory) {
		return new FactListFactory();
	}]).name;

/***/ }),
/* 90 */
[924, 26, 15],
/* 91 */
[929, 17, 25, 90],
/* 92 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 93 */
[942, 66, 45, 27, 70, 30, 91, 17],
/* 94 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 95 */
[946, 30, 27, 142, 68],
/* 96 */
[962, 15, 9, 92, 97, 19],
/* 97 */
[963, 23],
/* 98 */
[976, 248, 118],
/* 99 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 100 */
[926, 51, 343, 268, 8, 22, 284],
/* 101 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 102 */
[939, 8, 349, 264, 276, 263, 266],
/* 103 */
[944, 351, 264],
/* 104 */
[947, 351, 264],
/* 105 */
45,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(42);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(10);
	var dP = __webpack_require__(21);
	var DESCRIPTORS = __webpack_require__(20);
	var SPECIES = __webpack_require__(14)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 108 */
[956, 60],
/* 109 */
49,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _errors = __webpack_require__(116);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _version = __webpack_require__(224);
	
	var _version2 = _interopRequireDefault(_version);
	
	var _statusMessage = __webpack_require__(307);
	
	var _statusMessage2 = _interopRequireDefault(_statusMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StatusRow() {
		return {
			restrict: 'A',
			template: __webpack_require__(842),
			controller: _statusMessage2.default,
			scope: {
				statusRow: '='
			},
			link: function link(scope) {
				scope.message = scope.statusRow;
			}
		};
	}
	
	exports.default = _angular2.default.module('directives.status-nav', [_case2.default, _errors2.default, _version2.default]).directive('statusRow', StatusRow).name;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _date = __webpack_require__(131);
	
	var _date2 = _interopRequireDefault(_date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FactDateishGrouping = function (_DateGrouping) {
	  (0, _inherits3.default)(FactDateishGrouping, _DateGrouping);
	
	  function FactDateishGrouping() {
	    (0, _classCallCheck3.default)(this, FactDateishGrouping);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FactDateishGrouping.__proto__ || (0, _getPrototypeOf2.default)(FactDateishGrouping)).call(this));
	
	    _this.key = 'factDateish';
	    _this.displayName = 'Key Date';
	
	    _this.columnsByGroup = _this.setColumns(['legalIssues', 'title', 'content', 'sources', 'tags', 'contributors', 'creationDate']);
	
	    _this.reverseSortable = true;
	    _this.sortDirectionText = {
	      true: {
	        text: '9 - 1',
	        icon: 'glyphicon-sort-by-order-alt'
	      },
	      false: {
	        text: '1 - 9',
	        icon: 'glyphicon-sort-by-order'
	      }
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(FactDateishGrouping, [{
	    key: 'getDisplayText',
	    value: function getDisplayText(dateish) {
	      return dateish && dateish.displayName || '<span class="text-muted">No Date</span>';
	    }
	  }, {
	    key: 'getMemoText',
	    value: function getMemoText(dateish) {
	      return dateish && dateish.displayName;
	    }
	  }, {
	    key: 'getSortingValue',
	    value: function getSortingValue(dateish) {
	      return dateish ? dateish.sortableString : '';
	    }
	  }, {
	    key: 'getItemsByFact',
	    value: function getItemsByFact(fact) {
	      var items = [];
	      var d = fact[this.key];
	      if (d) {
	        // matches 'id' created by addDateToDates in buildTree below
	        items.push(d.sortableString);
	      } else {
	        items.push('ungrouped');
	      }
	      return items;
	    }
	  }, {
	    key: 'getDocDisplayText',
	    value: function getDocDisplayText(value) {
	      return this.getDisplayText(value);
	    }
	  }, {
	    key: 'getHeaderDisplayName',
	    value: function getHeaderDisplayName(value) {
	      return value.headerDisplayName || this.ungroupedName;
	    }
	  }]);
	  return FactDateishGrouping;
	}(_date2.default);
	
	exports.default = _angular2.default.module('groupings.fact-dateish-grouping', []).service('FactDateishGrouping', FactDateishGrouping).name;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ErrorsFactory() {
	  return function ErrorsModel() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, ErrorsModel);
	
	    this.data = data;
	  };
	}
	
	exports.default = _angular2.default.module('models.errors', []).factory('ErrorsFactory', ErrorsFactory).service('Errors', ['ErrorsFactory', function (ErrorsFactory) {
	  return new ErrorsFactory();
	}]).name;

/***/ }),
/* 117 */
35,
/* 118 */
[935, 92, 18, 146, 31, 30, 54, 243, 80, 145, 23],
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(250);
	var global = __webpack_require__(15);
	var hide = __webpack_require__(31);
	var Iterators = __webpack_require__(54);
	var TO_STRING_TAG = __webpack_require__(23)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 120 */
54,
/* 121 */
[952, 21, 40, 14],
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var defined = __webpack_require__(58);
	var fails = __webpack_require__(11);
	var spaces = __webpack_require__(280);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 123 */
[961, 12],
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports) {

	module.exports = load;
	
	var analytics = [];
	
	function load(opts) {
	  // If the real analytics.js is already on the page return.
	  if (analytics.initialize) return;
	
	  // If the snippet was invoked already show an error.
	  if (analytics.invoked) {
	    if (window.console && console.error) {
	      console.error('Segment snippet included twice.');
	    }
	    return;
	  }
	
	  // Invoked flag, to make sure the snippet
	  // is never invoked twice.
	  analytics.invoked = true;
	
	  // A list of the methods in Analytics.js to stub.
	  analytics.methods = [
	    'trackSubmit',
	    'trackClick',
	    'trackLink',
	    'trackForm',
	    'pageview',
	    'identify',
	    'group',
	    'track',
	    'ready',
	    'reset',
	    'alias',
	    'page',
	    'once',
	    'off',
	    'on'
	  ];
	
	  // Define a factory to create stubs. These are placeholders
	  // for methods in Analytics.js so that you never have to wait
	  // for it to load to actually record data. The `method` is
	  // stored as the first argument, so we can replay the data.
	  analytics.factory = function(method){
	    return function(){
	      var args = Array.prototype.slice.call(arguments);
	      args.unshift(method);
	      analytics.push(args);
	      return analytics;
	    };
	  };
	
	  // For each of our methods, generate a queueing stub.
	  for (var i = 0; i < analytics.methods.length; i++) {
	    var key = analytics.methods[i];
	    analytics[key] = analytics.factory(key);
	  }
	
	  // Define a method to load Analytics.js from our CDN,
	  // and that will be sure to only ever load it once.
	  analytics.load = function(key){
	    // Create an async script element based on your key.
	    var script = document.createElement('script');
	    script.type = 'text/javascript';
	    script.async = true;
	    script.src = ('http:' === document.location.protocol
	      ? 'http://' : 'https://')
	      + 'cdn.segment.com/analytics.js/v1/'
	      + key + '/analytics.min.js';
	
	    // Insert our script next to the first script element.
	    var first = document.getElementsByTagName('script')[0];
	    first.parentNode.insertBefore(script, first);
	  };
	
	  // Add a version to keep track of what's in the wild.
	  analytics.SNIPPET_VERSION = '3.0.1';
	
	  // Load Analytics.js with your key, which will automatically
	  // load the tools you've enabled for your account. Boosh!
	  analytics.load(opts.writeKey);
	
	  // Make the first page call to load the integrations. If
	  // you'd like to manually name or tag the page, edit or
	  // move this call however you'd like.
	  if (!opts.skipPageCall) {
	    analytics.page();
	  }
	
	  /*
	  * The analytics.js-loader module returns the "initial" analytics
	  * object, which is basically just a queue to hold events until the
	  * "real" one is loaded with a global script.  Problem is, the "real"
	  * one simply replaces `window.analytics`, and doesn't change over
	  * this initial "queue" object, meaning that nothing gets registered
	  * after the "real" one is loaded - things just keep adding to the queue.
	  *
	  * This is why we save off `initialAnalytics`, and then always run
	  * methods through `window.analytics`, which might be the queue, and
	  * might be the real one.
	  */
	
	  var initialAnalytics = analytics;
	  var actualAnalytics = {};
	
	  window.analytics = initialAnalytics;
	
	  initialAnalytics.methods.forEach(function(method) {
	    actualAnalytics[method] = function() {
	      window.analytics[method].apply(window.analytics, arguments);
	    }
	  });
	
	  return actualAnalytics;
	}


/***/ }),
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(34);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _default = __webpack_require__(29);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContributorsGrouping = function (_DefaultGrouping) {
	  (0, _inherits3.default)(ContributorsGrouping, _DefaultGrouping);
	
	  function ContributorsGrouping() {
	    (0, _classCallCheck3.default)(this, ContributorsGrouping);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ContributorsGrouping.__proto__ || (0, _getPrototypeOf2.default)(ContributorsGrouping)).call(this));
	
	    _this.key = 'contributors';
	    _this.displayName = "Contributors";
	    _this.groupByPulldown = true;
	    _this.secondarySortable = true;
	    _this.columnsByGroup = (0, _get3.default)(ContributorsGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(ContributorsGrouping.prototype), 'setColumns', _this).call(_this, ['creationDate', 'title', 'content', 'sources', 'legalIssues', 'contributors', 'factDateish', 'tags']);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ContributorsGrouping, [{
	    key: 'getFactItems',
	    value: function getFactItems(contributors, branchId) {
	      return contributors;
	      // var items = [];
	      // for (var i = 0; i < contributors.length; i++) {
	      //   if (contributors[i].id !== branchId) {
	      //     items.push(
	      //       contributors[i].firstName.substring(0, 1) +
	      //       contributors[i].lastName.substring(0, 1)
	      //     );
	      //   }
	      // }
	      // return items;
	    }
	  }, {
	    key: 'getDisplayText',
	    value: function getDisplayText(contributors, branchId) {
	      return this.getFactItems(contributors, branchId);
	    }
	  }, {
	    key: 'getMemoText',
	    value: function getMemoText(contributors, branchId) {
	      return this.getFactItems(contributors, branchId);
	    }
	  }, {
	    key: 'getDocDisplayText',
	    value: function getDocDisplayText(value) {
	      return this.getDisplayText(value);
	    }
	  }, {
	    key: 'getSortingValue',
	    value: function getSortingValue(contributors, branchId) {
	      return this.getMemoText(contributors, branchId);
	    }
	  }, {
	    key: 'getHeaderDisplayName',
	    value: function getHeaderDisplayName(branch) {
	      return (0, _get3.default)(ContributorsGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(ContributorsGrouping.prototype), 'getDisplayName', this).call(this, branch);
	    }
	  }]);
	  return ContributorsGrouping;
	}(_default2.default);
	
	exports.default = _angular2.default.module('groupings.contributors-grouping', []).service('ContributorsGrouping', ContributorsGrouping).name;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(34);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _date = __webpack_require__(131);
	
	var _date2 = _interopRequireDefault(_date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreationDateGrouping = function (_DateGrouping) {
	  (0, _inherits3.default)(CreationDateGrouping, _DateGrouping);
	
	  function CreationDateGrouping($filter) {
	    (0, _classCallCheck3.default)(this, CreationDateGrouping);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CreationDateGrouping.__proto__ || (0, _getPrototypeOf2.default)(CreationDateGrouping)).call(this));
	
	    _this.dateFilter = $filter('date');
	    _this.key = 'creationDate';
	    _this.displayName = 'Creation Date';
	
	    // #74524284: creation data selectors should be ordered by most recent first.
	    _this.groupingReverseSorted = true;
	
	    _this.columnsByGroup = _this.setColumns(['contributors', 'title', 'content', 'sources', 'legalIssues', 'factDateish', 'tags']);
	    return _this;
	  }
	
	  (0, _createClass3.default)(CreationDateGrouping, [{
	    key: 'getDisplayText',
	    value: function getDisplayText(rawDate) {
	      return this.dateFilter(rawDate, 'MMM d, y');
	    }
	  }, {
	    key: 'getItemsByFact',
	    value: function getItemsByFact(fact) {
	      var items = [];
	      items.push(this.dateFilter(fact[this.key], 'yyyyMMdd'));
	      return items;
	    }
	  }, {
	    key: 'getDocDisplayText',
	    value: function getDocDisplayText(value) {
	      return this.getDisplayText(value);
	    }
	  }, {
	    key: 'getSortingValue',
	    value: function getSortingValue(value) {
	      return this.getDisplayText(value);
	    }
	  }, {
	    key: 'getMemoText',
	    value: function getMemoText(value) {
	      return this.getDisplayText(value);
	    }
	  }, {
	    key: 'getHeaderDisplayName',
	    value: function getHeaderDisplayName(value) {
	      return (0, _get3.default)(CreationDateGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(CreationDateGrouping.prototype), 'getDisplayName', this).call(this, value);
	    }
	  }]);
	  return CreationDateGrouping;
	}(_date2.default);
	
	CreationDateGrouping.$inject = ['$filter'];
	
	exports.default = _angular2.default.module('groupings.creation-date-grouping', []).service('CreationDateGrouping', CreationDateGrouping).name;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _default = __webpack_require__(29);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DateGrouping = function (_DefaultGrouping) {
	  (0, _inherits3.default)(DateGrouping, _DefaultGrouping);
	
	  function DateGrouping() {
	    (0, _classCallCheck3.default)(this, DateGrouping);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DateGrouping.__proto__ || (0, _getPrototypeOf2.default)(DateGrouping)).call(this));
	
	    _this.ungroupedName = 'No Date';
	    // sort branches based on their id (constructed in buildTree)
	    _this.sortingKey = 'id';
	    return _this;
	  }
	
	  return DateGrouping;
	}(_default2.default);
	
	exports.default = DateGrouping;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(34);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _default = __webpack_require__(29);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IssuesGrouping = function (_DefaultGrouping) {
	  (0, _inherits3.default)(IssuesGrouping, _DefaultGrouping);
	
	  function IssuesGrouping() {
	    (0, _classCallCheck3.default)(this, IssuesGrouping);
	
	    // this.currentCase = CurrentCase.data;
	    var _this = (0, _possibleConstructorReturn3.default)(this, (IssuesGrouping.__proto__ || (0, _getPrototypeOf2.default)(IssuesGrouping)).call(this));
	
	    _this.displayName = 'Issues';
	    _this.key = 'legalIssues';
	    _this.ungroupedName = 'Organize Later';
	
	    // null flags alphaSort to skip sorting this grouping
	    _this.groupingReverseSorted = null;
	
	    _this.columnsByGroup = (0, _get3.default)(IssuesGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(IssuesGrouping.prototype), 'setColumns', _this).call(_this, ['factDateish', 'title', 'content', 'sources', 'tags', _this.key, 'contributors', 'creationDate']);
	
	    _this.reverseSortable = true;
	    _this.sortDirectionText = {
	      true: {
	        text: 'Z - A',
	        icon: 'glyphicon-sort-by-alphabet-alt'
	      },
	      false: {
	        text: 'A - Z',
	        icon: 'glyphicon-sort-by-alphabet'
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(IssuesGrouping, [{
	    key: 'getDisplayName',
	    value: function getDisplayName(branch) {
	      var issues = this.currentCase.legalIssues;
	      return issues && issues[branch.id] ? issues[branch.id].displayName : this.ungroupedName;
	    }
	  }, {
	    key: 'getHeaderDisplayName',
	    value: function getHeaderDisplayName(branch) {
	      var _this2 = this;
	
	      var issues = this.currentCase.legalIssues;
	
	      var traverse = function traverse(branchId) {
	        var branch = issues && issues[branchId];
	        return (branch && branch.parentId ? traverse(branch.parentId) : []).concat(branch ? branch.displayName : _this2.ungroupedName);
	      };
	
	      return traverse(branch.id).join(' / ');
	    }
	  }, {
	    key: 'getFactItems',
	    value: function getFactItems(objs, branchId) {
	      var items = [];
	      for (var i = 0; i < objs.length; i++) {
	        if (objs[i].id !== branchId) {
	          items.push(objs[i].displayName);
	        }
	      }
	      return items;
	    }
	  }, {
	    key: 'getDisplayText',
	    value: function getDisplayText(tags, branchId) {
	      return this.getFactItems(tags, branchId).join(',<br />');
	    }
	  }, {
	    key: 'getMemoText',
	    value: function getMemoText(tags, branchId) {
	      return this.getFactItems(tags, branchId).join(', ');
	    }
	  }, {
	    key: 'getItemsByFact',
	    value: function getItemsByFact(fact) {
	      var items = fact[this.key].map(function (item) {
	        return item.id;
	      });
	      return items.length > 0 ? items : ['ungrouped'];
	    }
	  }, {
	    key: 'getDocDisplayText',
	    value: function getDocDisplayText(value) {
	      return this.getDisplayText(value);
	    }
	  }, {
	    key: 'getSortingValue',
	    value: function getSortingValue(value) {
	      return this.getMemoText(value);
	    }
	  }]);
	  return IssuesGrouping;
	}(_default2.default);
	
	IssuesGrouping.$inject = [];
	
	exports.default = _angular2.default.module('groupings.issues-grouping', []).service('IssuesGrouping', IssuesGrouping).name;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(34);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularSanitize = __webpack_require__(128);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _default = __webpack_require__(29);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _truncate = __webpack_require__(160);
	
	var _truncate2 = _interopRequireDefault(_truncate);
	
	var _sourceInfo = __webpack_require__(163);
	
	var _sourceInfo2 = _interopRequireDefault(_sourceInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SourcesGrouping = function (_DefaultGrouping) {
	  (0, _inherits3.default)(SourcesGrouping, _DefaultGrouping);
	
	  function SourcesGrouping($rootScope, $sanitize, $filter, SourceInfoServ) {
	    (0, _classCallCheck3.default)(this, SourcesGrouping);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SourcesGrouping.__proto__ || (0, _getPrototypeOf2.default)(SourcesGrouping)).call(this));
	
	    _this.sanitize = $sanitize;
	    _this.filter = $filter;
	    _this.sourceInfo = SourceInfoServ;
	    _this.currentCase = $rootScope.currentCase;
	
	    _this.key = 'sources';
	    _this.displayName = "Sources";
	    _this.ungroupedName = 'No Sources';
	
	    _this.columnsByGroup = (0, _get3.default)(SourcesGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(SourcesGrouping.prototype), 'setColumns', _this).call(_this, ['factDateish', 'title', 'content', 'tags', 'legalIssues', _this.key, 'contributors', 'creationDate']);
	
	    _this.getSortingValue = _this.getMemoText;
	    _this.getHeaderDisplayName = (0, _get3.default)(SourcesGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(SourcesGrouping.prototype), 'getDisplayName', _this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(SourcesGrouping, [{
	    key: 'getDocDisplayStyles',
	    value: function getDocDisplayStyles() {
	      var result = (0, _get3.default)(SourcesGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(SourcesGrouping.prototype), 'getDocDisplayStyles', this).call(this);
	      result['width'] = '16%';
	      // required to wrap looong words
	      result['word-wrap'] = 'break-word';
	      result['word-break'] = 'break-all';
	      return result;
	    }
	  }, {
	    key: 'getMarkup',
	    value: function getMarkup(source, icon) {
	      var bookmark = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var page = bookmark && parseInt(bookmark.page);
	      var link = page && !isNaN(page) ? source.link + '#page=' + page : source.link;
	      var displayName = bookmark ? source.displayName + ', p' + bookmark.page : source.displayName;
	
	      return [icon ? '<i class="table-source-icon ' + this.sourceInfo.sourceTypes[source.format].icon + '"></i> ' : '', link ? '<a href="' + link + '" target="_blank">' : '', icon ? displayName : this.filter('truncate')(displayName, 35), link ? '</a>' : ''].join('');
	    }
	  }, {
	    key: 'getFactItems',
	    value: function getFactItems(sources, branchId, icon) {
	      var _this2 = this;
	
	      if (!sources) {
	        return;
	      }
	      var items = sources.filter(function (source) {
	        return source.id !== branchId;
	      }).map(function (source) {
	        source = _this2.sourceInfo.getLink(source);
	        if (source.bookmarks && source.bookmarks.length) {
	          var bookmarks = [];
	          source.bookmarks.sort(function (a, b) {
	            return parseInt(a.page) - parseInt(b.page);
	          }).forEach(function (bookmark) {
	            bookmarks.push(_this2.getMarkup(source, icon, bookmark));
	          });
	          return bookmarks;
	        } else {
	          return [_this2.getMarkup(source, icon)];
	        }
	      });
	      return [].concat.apply([], items);
	    }
	  }, {
	    key: 'getDisplayText',
	    value: function getDisplayText(sources, branchId) {
	      return this.getFactItems(sources, branchId, true).join('<br />');
	    }
	  }, {
	    key: 'getMemoText',
	    value: function getMemoText(sources, branchId) {
	      return this.getFactItems(sources, branchId).join(', ');
	    }
	  }, {
	    key: 'getDocDisplayText',
	    value: function getDocDisplayText(sources, branchId) {
	      var sources = this.currentCase.sources;
	
	      return sources.map(function (id) {
	        if (id !== branchId && sources[id]) {
	          return '[' + this.sourceInfo.sourceTypes[sources[id].format].displayName + '] ' + this.sanitize(sources[id].displayName).replace(/([0-9A-Za-z])\.([0-9A-Za-z]{4})/g, '$1. $2').replace(/([0-9A-Za-z])([/&_?=+$%-])([0-9A-Za-z])/g, '$1$2 $3/');
	        }
	      }).join(',<br />');
	    }
	  }, {
	    key: 'getItemsByFact',
	    value: function getItemsByFact(fact) {
	      var items = fact[this.key].map(function (item) {
	        return item;
	      });
	      return items.length > 0 ? items : ['ungrouped'];
	    }
	  }, {
	    key: 'getOutlineText',
	    value: function getOutlineText(branch) {
	      // called from a Branch
	      var result = branch.displayName;
	      var s = this.currentCase.sources[branch.id];
	      if (s && s.format === 'person') {
	        result += s.role ? '<br/>' + s.role : '';
	        result += s.phone ? '<br/>' + s.phone : '';
	        result += s.email ? '<br/>' + s.email : '';
	        result += s.address ? '<br/>' + s.address.replace(/\n/, '<br/>') : '';
	      }
	      return result;
	    }
	  }]);
	  return SourcesGrouping;
	}(_default2.default);
	
	SourcesGrouping.$inject = ['$rootScope', '$sanitize', '$filter', 'SourceInfoServ'];
	
	exports.default = _angular2.default.module('groupings.sources-grouping', [_sourceInfo2.default, _angularSanitize2.default]).service('SourcesGrouping', SourcesGrouping).name;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(34);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _default = __webpack_require__(29);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagsGrouping = function (_DefaultGrouping) {
	  (0, _inherits3.default)(TagsGrouping, _DefaultGrouping);
	
	  function TagsGrouping($rootScope) {
	    (0, _classCallCheck3.default)(this, TagsGrouping);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TagsGrouping.__proto__ || (0, _getPrototypeOf2.default)(TagsGrouping)).call(this));
	
	    _this.currentCase = $rootScope.currentCase;
	
	    _this.displayName = 'Tags';
	    _this.key = 'tags';
	    _this.ungroupedName = 'No Tags';
	
	    _this.columnsByGroup = (0, _get3.default)(TagsGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(TagsGrouping.prototype), 'setColumns', _this).call(_this, ['factDateish', 'title', 'content', 'sources', 'legalIssues', _this.key, 'contributors', 'creationDate']);
	
	    _this.getDocDisplayText = _this.getDisplayText;
	    _this.getSortingValue = _this.getMemoText;
	    _this.getHeaderDisplayName = (0, _get3.default)(TagsGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(TagsGrouping.prototype), 'getDisplayName', _this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(TagsGrouping, [{
	    key: 'getDocDisplayStyles',
	    value: function getDocDisplayStyles() {
	      var result = _default2.default.getDocDisplayStyles();
	      result['width'] = '16%';
	      return result;
	    }
	  }, {
	    key: 'getFactItems',
	    value: function getFactItems(tags, branchId) {
	      return tags.filter(function (tag) {
	        return tag.id !== branchId;
	      }).map(function (tag) {
	        return tag.displayName;
	      });
	    }
	  }, {
	    key: 'getDisplayText',
	    value: function getDisplayText(tags, branchId) {
	      return this.getFactItems(tags, branchId).join(',<br />');
	    }
	  }, {
	    key: 'getMemoText',
	    value: function getMemoText(tags, branchId) {
	      return this.getFactItems(tags, branchId).join(', ');
	    }
	  }, {
	    key: 'getItemsByFact',
	    value: function getItemsByFact(fact) {
	      var items = fact[this.key].map(function (item) {
	        return item;
	      });
	      return items.length > 0 ? items : ['ungrouped'];
	    }
	  }]);
	  return TagsGrouping;
	}(_default2.default);
	
	TagsGrouping.$inject = ['$rootScope'];
	
	exports.default = _angular2.default.module('groupings.tags-grouping', []).service('TagsGrouping', TagsGrouping).name;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Customer(Model, AnalyticsServ) {
		return function (_Model) {
			(0, _inherits3.default)(CustomerModel, _Model);
	
			function CustomerModel() {
				var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				(0, _classCallCheck3.default)(this, CustomerModel);
	
				var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerModel.__proto__ || (0, _getPrototypeOf2.default)(CustomerModel)).call(this, data));
	
				_this.setApi('/customer', null, {
					'get': {
						method: 'GET'
					},
					'create': {
						method: 'POST',
						success: [function (data) {
							return _this.setData(data);
						}, function (data) {
							return AnalyticsServ.added('Subscription', {
								'Plan': data.plan.displayName,
								'Period': data.plan.period
							});
						}]
					},
					'update': {
						method: 'PUT',
						success: [function (data) {
							return _this.setData(data);
						}, function (data) {
							return AnalyticsServ.updated('Subscription', {
								'Plan': data.plan.displayName,
								'Period': data.plan.period
							});
						}]
					},
					'validateCoupon': {
						url: '/coupon',
						method: 'GET'
					}
				});
				return _this;
			}
	
			return CustomerModel;
		}(Model);
	};
	Customer.$inject = ['Model', 'AnalyticsServ'];
	
	exports.default = _angular2.default.module('models.customer', [_model2.default, _analytics2.default]).factory('Customer', Customer).service('CurrentCustomer', ['Customer', function (Customer) {
		return new Customer();
	}]).name;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tree = __webpack_require__(37);
	
	var _tree2 = _interopRequireDefault(_tree);
	
	var _issues = __webpack_require__(132);
	
	var _issues2 = _interopRequireDefault(_issues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IssuesTreeFactory(TreeModel, IssuesGrouping) {
	  return function (_TreeModel) {
	    (0, _inherits3.default)(IssueTreeModel, _TreeModel);
	
	    function IssueTreeModel() {
	      (0, _classCallCheck3.default)(this, IssueTreeModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (IssueTreeModel.__proto__ || (0, _getPrototypeOf2.default)(IssueTreeModel)).call(this));
	
	      _this.grouping = IssuesGrouping;
	      _this.setApi("/case/:caseId/values/legalIssues", {
	        caseId: '@caseId'
	      }, { // actions
	        'get': {
	          method: 'GET',
	          isArray: true
	        },
	        'update': {
	          method: 'PUT',
	          isArray: true
	        }
	      });
	      return _this;
	    }
	
	    return IssueTreeModel;
	  }(TreeModel);
	}
	
	IssuesTreeFactory.$inject = ['TreeModel', 'IssuesGrouping'];
	
	exports.default = _angular2.default.module('models.issue-tree', [_tree2.default, _issues2.default]).factory('IssuesTreeFactory', IssuesTreeFactory).service('IssuesTree', ['IssuesTreeFactory', function (IssuesTreeFactory) {
	  return new IssuesTreeFactory();
	}]).name;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tree = __webpack_require__(37);
	
	var _tree2 = _interopRequireDefault(_tree);
	
	var _sources = __webpack_require__(133);
	
	var _sources2 = _interopRequireDefault(_sources);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SourcesTreeFactory(TreeModel, SourcesGrouping) {
	  return function (_TreeModel) {
	    (0, _inherits3.default)(SourcesTreeModel, _TreeModel);
	
	    function SourcesTreeModel() {
	      (0, _classCallCheck3.default)(this, SourcesTreeModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (SourcesTreeModel.__proto__ || (0, _getPrototypeOf2.default)(SourcesTreeModel)).call(this));
	
	      _this.grouping = SourcesGrouping;
	      _this.setApi("/case/:caseId/values/sources", {
	        caseId: '@caseId'
	      }, { // actions
	        'get': {
	          method: 'GET',
	          isArray: true
	        }
	      });
	      return _this;
	    }
	
	    return SourcesTreeModel;
	  }(TreeModel);
	}
	
	SourcesTreeFactory.$inject = ['TreeModel', 'SourcesGrouping'];
	
	exports.default = _angular2.default.module('models.sources-tree', [_tree2.default, _sources2.default]).factory('SourcesTreeFactory', SourcesTreeFactory).service('SourcesTree', ['SourcesTreeFactory', function (SourcesTreeFactory) {
	  return new SourcesTreeFactory();
	}]).name;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tree = __webpack_require__(37);
	
	var _tree2 = _interopRequireDefault(_tree);
	
	var _tags = __webpack_require__(134);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TagsTreeFactory(TreeModel, TagsGrouping) {
	  return function (_TreeModel) {
	    (0, _inherits3.default)(TagsTreeModel, _TreeModel);
	
	    function TagsTreeModel() {
	      (0, _classCallCheck3.default)(this, TagsTreeModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (TagsTreeModel.__proto__ || (0, _getPrototypeOf2.default)(TagsTreeModel)).call(this));
	
	      _this.grouping = TagsGrouping;
	      _this.setApi("/case/:caseId/values/tags", {
	        caseId: '@caseId'
	      }, { // actions
	        'get': {
	          method: 'GET',
	          isArray: true
	        }
	      });
	      return _this;
	    }
	
	    return TagsTreeModel;
	  }(TreeModel);
	}
	
	TagsTreeFactory.$inject = ['TreeModel', 'TagsGrouping'];
	
	exports.default = _angular2.default.module('models.tags-tree', [_tree2.default, _tags2.default]).factory('TagsTreeFactory', TagsTreeFactory).service('TagsTree', ['TagsTreeFactory', function (TagsTreeFactory) {
	  return new TagsTreeFactory();
	}]).name;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReloadServ = function () {
	  function ReloadServ($rootScope, $cookies, $route, $location, $interval, $cacheFactory) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ReloadServ);
	
	    this.cookies = $cookies;
	    this.cacheFactory = $cacheFactory;
	    this.location = $location;
	    this.route = $route;
	
	    this.updateTabs = this.updateTabs.bind(this);
	    this.watchCookie = this.watchCookie.bind(this);
	
	    this.value = this.cookies.get('factbox_browser_message');
	
	    $rootScope.$on('$destroy', function () {
	      $interval.cancel(_this.watchCookie);
	    });
	    $interval(this.watchCookie, 1000);
	  }
	
	  (0, _createClass3.default)(ReloadServ, [{
	    key: 'updateTabs',
	    value: function updateTabs() {
	      this.browserUpdater = true;
	      this.cookies.put('factbox_browser_message', new Date().getTime());
	    }
	  }, {
	    key: 'watchCookie',
	    value: function watchCookie() {
	      var newValue = this.cookies.get('factbox_browser_message');
	      if (!this.browserUpdater && newValue && newValue !== this.value) {
	        this.value = newValue;
	
	        // Clear the cached user so the user object is refreshed
	        this.cacheFactory.get('$http').remove('/user');
	        // the auto-tab refresh should redirect to /home or /fact if the user
	        // has a case selected, since a selected case in a background tab will
	        // set the account to the previous account when switching accts. #84390466
	        var path = this.route.current.originalPath;
	        if (/^\/home/.test(path) && !/signin/.test(path)) {
	
	          this.location.search('redirect', '/home');
	          this.location.path('/signin');
	        } else if (/^\/fact/.test(path) && !/signin/.test(path)) {
	
	          this.location.search('redirect', '/fact');
	          this.location.path('/signin');
	        } else {
	          this.route.reload();
	        }
	      }
	      this.browserUpdater = false;
	    }
	  }]);
	  return ReloadServ;
	}();
	
	ReloadServ.$inject = ['$rootScope', '$cookies', '$route', '$location', '$interval', '$cacheFactory'];
	
	exports.default = _angular2.default.module('services.reload', []).service('ReloadServ', ReloadServ).name;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(230);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(229);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(148);
	module.exports = __webpack_require__(9).Object.keys;


/***/ }),
/* 142 */
[914, 27, 81, 147],
/* 143 */
[937, 49, 26, 30, 19, 25],
/* 144 */
[944, 95, 65],
/* 145 */
[945, 30, 39, 68],
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(31);


/***/ }),
/* 147 */
[956, 55],
/* 148 */
[974, 39, 38, 67],
/* 149 */
[918, 50, 14],
/* 150 */
[930, 50],
/* 151 */
66,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(204);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(205);
	
	var MODULE_NAME = 'ui.bootstrap.module.position';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.position']);
	
	module.exports = MODULE_NAME;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	// VERSION global variable is defined in webpack config file
	exports.default = angular.module('contants.version', []).constant('VersionConst', ("1.62.5")).name;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TruncateFilter() {
		return function (s) {
			var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
	
			// len should be at least 13, default is 25
			len = len < 13 ? 13 : len;
			// ['s' truncated to 'len' with space for tail]...[last 7 chars]
			return s && s.length > len ? s.slice(0, len - 9) + '&hellip;' + s.slice(-7, s.length) : s;
		};
	}
	
	exports.default = _angular2.default.module('filters.truncate', []).filter('truncate', TruncateFilter).name;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Browser = function Browser($window) {
		(0, _classCallCheck3.default)(this, Browser);
	
		var ua = $window.navigator.userAgent;
		var temp;
		var matches = ua.match(/(opr|chrome|safari|firefox|msie|trident(?=\/))\/?\s*([\d\.]+)/i) || [];
		if (/trident/i.test(matches[1])) {
			temp = /\brv[ :]+(\d+(\.\d+)?)/g.exec(ua) || [];
			return {
				name: 'Internet Explorer',
				version: temp[1] || ''
			};
		}
		if ((temp = ua.match(/version\/([\.\d]+)/i)) !== null) {
			matches[2] = temp[1];
		}
		matches = matches[2] ? [matches[1], matches[2]] : [navigator.appName, navigator.appVersion];
		// Limit to major version
		matches[1] = /^\d([^.]+)?/.exec(matches[1])[0] || matches[1];
		// Rewrite IE match name
		matches[0] = matches[0] === 'MSIE' ? 'Internet Explorer' : matches[0];
	
		this.name = matches[0];
		this.version = matches[1];
		this.isMobile = ua.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i) ? true : false;
	};
	
	Browser.$inject = ['$window'];
	
	exports.default = _angular2.default.module('services.browser', []).service('Browser', Browser).name;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularResource = __webpack_require__(62);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ClioServ($resource) {
	  return $resource("/account/clio", {
	    id: '@id'
	  }, {
	    'getFolder': {
	      method: 'GET',
	      url: '/account/clio/folder'
	    },
	    'getFile': {
	      method: 'GET',
	      url: '/account/clio/file'
	    },
	    'sync': {
	      method: 'GET',
	      url: '/account/clio/sync'
	    },
	    'userDisconnect': {
	      method: 'DELETE',
	      url: '/user/clio'
	    },
	    'disconnect': {
	      method: 'DELETE'
	    }
	  });
	}
	ClioServ.$inject = ['$resource'];
	
	exports.default = _angular2.default.module('services.clio', [_angularResource2.default]).factory('Clio', ClioServ).name;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _encodeUri = __webpack_require__(212);
	
	var _encodeUri2 = _interopRequireDefault(_encodeUri);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SourceInfoServ = function () {
	  function SourceInfoServ($filter, $sanitize, $routeParams) {
	    (0, _classCallCheck3.default)(this, SourceInfoServ);
	
	    this.encodeURI = $filter('encodeURI');
	    this.sanitize = $sanitize;
	    this.routeParams = $routeParams;
	    this.baseUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	    this.sourceTypes = {
	      file: {
	        displayName: 'File',
	        icon: 'icon-file',
	        pluralName: 'Files'
	      },
	      link: {
	        displayName: 'Link',
	        icon: 'icon-link',
	        pluralName: 'Links'
	      },
	      note: {
	        displayName: 'Note',
	        icon: 'icon-note',
	        pluralName: 'Notes'
	      },
	      person: {
	        displayName: 'Person',
	        icon: 'glyphicon glyphicon-user',
	        pluralName: 'People'
	      },
	      worksite: {
	        displayName: 'iManage Doc',
	        icon: 'icon-worksite',
	        pluralName: 'iManage Docs'
	      },
	      box: {
	        displayName: 'Box File',
	        icon: 'icon-box',
	        pluralName: 'Box Files',
	        integration: true
	      },
	      dropbox: {
	        displayName: 'Dropbox',
	        icon: 'icon-dropbox',
	        pluralName: 'Dropbox',
	        integration: true
	      },
	      clio: {
	        displayName: 'Clio',
	        icon: 'icon-clio',
	        pluralName: 'Clio',
	        integration: true
	      }
	    };
	  }
	
	  (0, _createClass3.default)(SourceInfoServ, [{
	    key: 'getLink',
	    value: function getLink(s) {
	      var caseId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.routeParams.caseId;
	
	      if (!s) {
	        return;
	      }
	      s.bookmarksEnabled = /\.pdf$/.test(s.url) && /^(file|link|box|dropbox|clio)$/.test(s.format);
	      if (/^(file|worksite|box|dropbox|clio)$/.test(s.format)) {
	        s.link = this.sanitize(this.baseUrl + '/case/' + caseId + '/upload/' + s.id + '/' + this.encodeURI(s.displayName));
	      } else if (/^link$/.test(s.format)) {
	        s.link = this.sanitize(s.url);
	      }
	      return s;
	    }
	  }]);
	  return SourceInfoServ;
	}();
	
	SourceInfoServ.$inject = ['$filter', '$sanitize', '$routeParams'];
	
	exports.default = _angular2.default.module('services.source-info', [_encodeUri2.default]).service('SourceInfoServ', SourceInfoServ).name;

/***/ }),
/* 164 */
[926, 44, 328, 327, 32, 81, 249],
/* 165 */
[932, 77],
/* 166 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 167 */
/***/ (function(module, exports) {



/***/ }),
/* 168 */
[914, 48, 22, 108],
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(10);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(42);
	var redefineAll = __webpack_require__(106);
	var meta = __webpack_require__(83);
	var forOf = __webpack_require__(100);
	var anInstance = __webpack_require__(99);
	var isObject = __webpack_require__(12);
	var fails = __webpack_require__(11);
	var $iterDetect = __webpack_require__(174);
	var setToStringTag = __webpack_require__(121);
	var inheritIfRequired = __webpack_require__(267);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(41);
	var redefine = __webpack_require__(42);
	var fails = __webpack_require__(11);
	var defined = __webpack_require__(58);
	var wks = __webpack_require__(14);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(8);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 172 */
[932, 50],
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(12);
	var cof = __webpack_require__(50);
	var MATCH = __webpack_require__(14)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 174 */
[936, 14],
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(101) || !__webpack_require__(11)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(10)[K];
	});


/***/ }),
/* 176 */
94,
/* 177 */
[949, 2, 35, 51, 100],
/* 178 */
[950, 2],
/* 179 */
[954, 10],
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(8);
	var aFunction = __webpack_require__(35);
	var SPECIES = __webpack_require__(14)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var hide = __webpack_require__(41);
	var uid = __webpack_require__(109);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports) {

	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])
	
	.constant('uibDropdownConfig', {
	  appendToOpenClass: 'uib-dropdown-open',
	  openClass: 'open'
	})
	
	.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
	  var openScope = null;
	  var openedContainers = $$multiMap.createNew();
	
	  this.isOnlyOpen = function(dropdownScope, appendTo) {
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (openDropdown) {
	        return openedDropdowns.length === 1;
	      }
	    }
	
	    return false;
	  };
	
	  this.open = function(dropdownScope, element, appendTo) {
	    if (!openScope) {
	      $document.on('click', closeDropdown);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openedScopes = openedDropdowns.map(function(dropdown) {
	        return dropdown.scope;
	      });
	      if (openedScopes.indexOf(dropdownScope) === -1) {
	        openedContainers.put(appendTo, {
	          scope: dropdownScope
	        });
	      }
	    } else {
	      openedContainers.put(appendTo, {
	        scope: dropdownScope
	      });
	    }
	  };
	
	  this.close = function(dropdownScope, element, appendTo) {
	    if (openScope === dropdownScope) {
	      $document.off('click', closeDropdown);
	      $document.off('keydown', this.keybindFilter);
	      openScope = null;
	    }
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (dropdownToClose) {
	        openedContainers.remove(appendTo, dropdownToClose);
	      }
	    }
	  };
	
	  var closeDropdown = function(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope || !openScope.isOpen) { return; }
	
	    if (evt && openScope.getAutoClose() === 'disabled') { return; }
	
	    if (evt && evt.which === 3) { return; }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' &&
	      dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.focusToggleElement();
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  this.keybindFilter = function(evt) {
	    if (!openScope) {
	      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    var toggleElement = openScope.getToggleElement();
	    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
	    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}])
	
	.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    appendToOpenClass = dropdownConfig.appendToOpenClass,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    keynavEnabled = false,
	    selectedOption = null,
	    body = $document.find('body');
	
	  $element.addClass('dropdown');
	
	  this.init = function() {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    keynavEnabled = angular.isDefined($attrs.keyboardNav);
	  };
	
	  this.toggle = function(open) {
	    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen(scope, scope.isOpen);
	    }
	
	    return scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function() {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function() {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function() {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function(keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	      angular.element(self.dropdownMenu).find('a') :
	      $element.find('ul').eq(0).find('a');
	
	    switch (keyCode) {
	      case 40: {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = 0;
	        } else {
	          self.selectedOption = self.selectedOption === elems.length - 1 ?
	            self.selectedOption :
	            self.selectedOption + 1;
	        }
	        break;
	      }
	      case 38: {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = elems.length - 1;
	        } else {
	          self.selectedOption = self.selectedOption === 0 ?
	            0 : self.selectedOption - 1;
	        }
	        break;
	      }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function() {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function() {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  function removeDropdownMenu() {
	    $element.append(self.dropdownMenu);
	  }
	
	  scope.$watch('isOpen', function(isOpen, wasOpen) {
	    var appendTo = null,
	      appendToBody = false;
	
	    if (angular.isDefined($attrs.dropdownAppendTo)) {
	      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
	      if (appendToEl) {
	        appendTo = angular.element(appendToEl);
	      }
	    }
	
	    if (angular.isDefined($attrs.dropdownAppendToBody)) {
	      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
	      if (appendToBodyValue !== false) {
	        appendToBody = true;
	      }
	    }
	
	    if (appendToBody && !appendTo) {
	      appendTo = body;
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      if (isOpen) {
	        appendTo.append(self.dropdownMenu);
	        $element.on('$destroy', removeDropdownMenu);
	      } else {
	        $element.off('$destroy', removeDropdownMenu);
	        removeDropdownMenu();
	      }
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
	        css,
	        rightalign,
	        scrollbarPadding,
	        scrollbarWidth = 0;
	
	      css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        scrollbarPadding = $position.scrollbarPadding(appendTo);
	
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          scrollbarWidth = scrollbarPadding.scrollbarWidth;
	        }
	
	        css.right = window.innerWidth - scrollbarWidth -
	          (pos.left + $element.prop('offsetWidth')) + 'px';
	      }
	
	      // Need to adjust our positioning to be relative to the appendTo container
	      // if it's not the body element
	      if (!appendToBody) {
	        var appendOffset = $position.offset(appendTo);
	
	        css.top = pos.top - appendOffset.top + 'px';
	
	        if (!rightalign) {
	          css.left = pos.left - appendOffset.left + 'px';
	        } else {
	          css.right = window.innerWidth -
	            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
	        }
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    var openContainer = appendTo ? appendTo : $element;
	    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
	    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
	    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);
	
	    if (hasOpenClass === !isOpen) {
	      var toggleClass;
	      if (appendTo) {
	        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
	      } else {
	        toggleClass = isOpen ? 'addClass' : 'removeClass';
	      }
	      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
	        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	          toggleInvoker($scope, { open: !!isOpen });
	        }
	      });
	    }
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	            $document.on('keydown', uibDropdownService.keybindFilter);
	          });
	        });
	      } else {
	        $document.on('keydown', uibDropdownService.keybindFilter);
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope, $element, appendTo);
	    } else {
	      uibDropdownService.close(scope, $element, appendTo);
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	}])
	
	.directive('uibDropdown', function() {
	  return {
	    controller: 'UibDropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	})
	
	.directive('uibDropdownMenu', function() {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	})
	
	.directive('uibDropdownToggle', function() {
	  return {
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.on('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.off('click', toggleDropdown);
	      });
	    }
	  };
	});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(201);
	
	var MODULE_NAME = 'ui.bootstrap.module.dropdown';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.dropdown']);
	
	module.exports = MODULE_NAME;


/***/ }),
/* 203 */
[911, 202],
/* 204 */
/***/ (function(module, exports) {

	angular.module('ui.bootstrap.multiMap', [])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	  .factory('$$multiMap', function() {
	    return {
	      createNew: function() {
	        var map = {};
	
	        return {
	          entries: function() {
	            return Object.keys(map).map(function(key) {
	              return {
	                key: key,
	                value: map[key]
	              };
	            });
	          },
	          get: function(key) {
	            return map[key];
	          },
	          hasKey: function(key) {
	            return !!map[key];
	          },
	          keys: function() {
	            return Object.keys(map);
	          },
	          put: function(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }
	
	            map[key].push(value);
	          },
	          remove: function(key, value) {
	            var values = map[key];
	
	            if (!values) {
	              return;
	            }
	
	            var idx = values.indexOf(value);
	
	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }
	
	            if (!values.length) {
	              delete map[key];
	            }
	          }
	        };
	      }
	    };
	  });


/***/ }),
/* 205 */
/***/ (function(module, exports) {

	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
	    /**
	     * Used by scrollbarWidth() function to cache scrollbar's width.
	     * Do not access this variable directly, use scrollbarWidth() instead.
	     */
	    var SCROLLBAR_WIDTH;
	    /**
	     * scrollbar on body and html element in IE and Edge overlay
	     * content and should be considered 0 width.
	     */
	    var BODY_SCROLLBAR_WIDTH;
	    var OVERFLOW_REGEX = {
	      normal: /(auto|scroll)/,
	      hidden: /(auto|scroll|hidden)/
	    };
	    var PLACEMENT_REGEX = {
	      auto: /\s?auto?\s?/i,
	      primary: /^(top|bottom|left|right)$/,
	      secondary: /^(top|bottom|left|right|center)$/,
	      vertical: /^(top|bottom)$/
	    };
	    var BODY_REGEX = /(HTML|BODY)/;
	
	    return {
	
	      /**
	       * Provides a raw DOM element from a jQuery/jQLite element.
	       *
	       * @param {element} elem - The element to convert.
	       *
	       * @returns {element} A HTML element.
	       */
	      getRawNode: function(elem) {
	        return elem.nodeName ? elem : elem[0] || elem;
	      },
	
	      /**
	       * Provides a parsed number for a style property.  Strips
	       * units and casts invalid numbers to 0.
	       *
	       * @param {string} value - The style value to parse.
	       *
	       * @returns {number} A valid number.
	       */
	      parseStyle: function(value) {
	        value = parseFloat(value);
	        return isFinite(value) ? value : 0;
	      },
	
	      /**
	       * Provides the closest positioned ancestor.
	       *
	       * @param {element} element - The element to get the offest parent for.
	       *
	       * @returns {element} The closest positioned ancestor.
	       */
	      offsetParent: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	        function isStaticPositioned(el) {
	          return ($window.getComputedStyle(el).position || 'static') === 'static';
	        }
	
	        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	          offsetParent = offsetParent.offsetParent;
	        }
	
	        return offsetParent || $document[0].documentElement;
	      },
	
	      /**
	       * Provides the scrollbar width, concept from TWBS measureScrollbar()
	       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	       * In IE and Edge, scollbar on body and html element overlay and should
	       * return a width of 0.
	       *
	       * @returns {number} The width of the browser scollbar.
	       */
	      scrollbarWidth: function(isBody) {
	        if (isBody) {
	          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
	            var bodyElem = $document.find('body');
	            bodyElem.addClass('uib-position-body-scrollbar-measure');
	            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
	            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
	            bodyElem.removeClass('uib-position-body-scrollbar-measure');
	          }
	          return BODY_SCROLLBAR_WIDTH;
	        }
	
	        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	          $document.find('body').append(scrollElem);
	          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	          scrollElem.remove();
	        }
	
	        return SCROLLBAR_WIDTH;
	      },
	
	      /**
	       * Provides the padding required on an element to replace the scrollbar.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
	       *     <li>**widthOverflow**: whether the the width is overflowing</li>
	       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
	       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
	       *     <li>**heightOverflow**: whether the the height is overflowing</li>
	       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
	       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
	       *   </ul>
	       */
	      scrollbarPadding: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemStyle = $window.getComputedStyle(elem);
	        var paddingRight = this.parseStyle(elemStyle.paddingRight);
	        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
	        var scrollParent = this.scrollParent(elem, false, true);
	        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));
	
	        return {
	          scrollbarWidth: scrollbarWidth,
	          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
	          right: paddingRight + scrollbarWidth,
	          originalRight: paddingRight,
	          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
	          bottom: paddingBottom + scrollbarWidth,
	          originalBottom: paddingBottom
	         };
	      },
	
	      /**
	       * Checks to see if the element is scrollable.
	       *
	       * @param {element} elem - The element to check.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       *
	       * @returns {boolean} Whether the element is scrollable.
	       */
	      isScrollable: function(elem, includeHidden) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var elemStyle = $window.getComputedStyle(elem);
	        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	      },
	
	      /**
	       * Provides the closest scrollable ancestor.
	       * A port of the jQuery UI scrollParent method:
	       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	       *
	       * @param {element} elem - The element to find the scroll parent of.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       * @param {boolean=} [includeSelf=false] - Should the element being passed be
	       * included in the scrollable llokup.
	       *
	       * @returns {element} A HTML element.
	       */
	      scrollParent: function(elem, includeHidden, includeSelf) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var documentEl = $document[0].documentElement;
	        var elemStyle = $window.getComputedStyle(elem);
	        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
	          return elem;
	        }
	        var excludeStatic = elemStyle.position === 'absolute';
	        var scrollParent = elem.parentElement || documentEl;
	
	        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	          return documentEl;
	        }
	
	        while (scrollParent.parentElement && scrollParent !== documentEl) {
	          var spStyle = $window.getComputedStyle(scrollParent);
	          if (excludeStatic && spStyle.position !== 'static') {
	            excludeStatic = false;
	          }
	
	          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	            break;
	          }
	          scrollParent = scrollParent.parentElement;
	        }
	
	        return scrollParent;
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/ - distance to closest positioned
	       * ancestor.  Does not account for margins by default like jQuery position.
	       *
	       * @param {element} elem - The element to caclulate the position on.
	       * @param {boolean=} [includeMargins=false] - Should margins be accounted
	       * for, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of offset parent</li>
	       *     <li>**left**: distance to left edge of offset parent</li>
	       *   </ul>
	       */
	      position: function(elem, includeMagins) {
	        elem = this.getRawNode(elem);
	
	        var elemOffset = this.offset(elem);
	        if (includeMagins) {
	          var elemStyle = $window.getComputedStyle(elem);
	          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	        }
	        var parent = this.offsetParent(elem);
	        var parentOffset = {top: 0, left: 0};
	
	        if (parent !== $document[0].documentElement) {
	          parentOffset = this.offset(parent);
	          parentOffset.top += parent.clientTop - parent.scrollTop;
	          parentOffset.left += parent.clientLeft - parent.scrollLeft;
	        }
	
	        return {
	          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	          top: Math.round(elemOffset.top - parentOffset.top),
	          left: Math.round(elemOffset.left - parentOffset.left)
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/ - distance to viewport.  Does
	       * not account for borders, margins, or padding on the body
	       * element.
	       *
	       * @param {element} elem - The element to calculate the offset on.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of viewport</li>
	       *     <li>**right**: distance to bottom edge of viewport</li>
	       *   </ul>
	       */
	      offset: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemBCR = elem.getBoundingClientRect();
	        return {
	          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	        };
	      },
	
	      /**
	       * Provides offset distance to the closest scrollable ancestor
	       * or viewport.  Accounts for border and scrollbar width.
	       *
	       * Right and bottom dimensions represent the distance to the
	       * respective edge of the viewport element.  If the element
	       * edge extends beyond the viewport, a negative value will be
	       * reported.
	       *
	       * @param {element} elem - The element to get the viewport offset for.
	       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	       * of the first scrollable element, default is false.
	       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	       * be accounted for, default is true.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: distance to the top content edge of viewport element</li>
	       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	       *     <li>**left**: distance to the left content edge of viewport element</li>
	       *     <li>**right**: distance to the right content edge of viewport element</li>
	       *   </ul>
	       */
	      viewportOffset: function(elem, useDocument, includePadding) {
	        elem = this.getRawNode(elem);
	        includePadding = includePadding !== false ? true : false;
	
	        var elemBCR = elem.getBoundingClientRect();
	        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};
	
	        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	        var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	        if (offsetParent === $document[0].documentElement) {
	          offsetBCR.top += $window.pageYOffset;
	          offsetBCR.left += $window.pageXOffset;
	        }
	        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	        if (includePadding) {
	          var offsetParentStyle = $window.getComputedStyle(offsetParent);
	          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	        }
	
	        return {
	          top: Math.round(elemBCR.top - offsetBCR.top),
	          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	          left: Math.round(elemBCR.left - offsetBCR.left),
	          right: Math.round(offsetBCR.right - elemBCR.right)
	        };
	      },
	
	      /**
	       * Provides an array of placement values parsed from a placement string.
	       * Along with the 'auto' indicator, supported placement strings are:
	       *   <ul>
	       *     <li>top: element on top, horizontally centered on host element.</li>
	       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	       *     <li>left: element on left, vertically centered on host element.</li>
	       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	       *     <li>right: element on right, vertically centered on host element.</li>
	       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	       *   </ul>
	       * A placement string with an 'auto' indicator is expected to be
	       * space separated from the placement, i.e: 'auto bottom-left'  If
	       * the primary and secondary placement values do not match 'top,
	       * bottom, left, right' then 'top' will be the primary placement and
	       * 'center' will be the secondary placement.  If 'auto' is passed, true
	       * will be returned as the 3rd value of the array.
	       *
	       * @param {string} placement - The placement string to parse.
	       *
	       * @returns {array} An array with the following values
	       * <ul>
	       *   <li>**[0]**: The primary placement.</li>
	       *   <li>**[1]**: The secondary placement.</li>
	       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	       * </ul>
	       */
	      parsePlacement: function(placement) {
	        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	        if (autoPlace) {
	          placement = placement.replace(PLACEMENT_REGEX.auto, '');
	        }
	
	        placement = placement.split('-');
	
	        placement[0] = placement[0] || 'top';
	        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	          placement[0] = 'top';
	        }
	
	        placement[1] = placement[1] || 'center';
	        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	          placement[1] = 'center';
	        }
	
	        if (autoPlace) {
	          placement[2] = true;
	        } else {
	          placement[2] = false;
	        }
	
	        return placement;
	      },
	
	      /**
	       * Provides coordinates for an element to be positioned relative to
	       * another element.  Passing 'auto' as part of the placement parameter
	       * will enable smart placement - where the element fits. i.e:
	       * 'auto left-top' will check to see if there is enough space to the left
	       * of the hostElem to fit the targetElem, if not place right (same for secondary
	       * top placement).  Available space is calculated using the viewportOffset
	       * function.
	       *
	       * @param {element} hostElem - The element to position against.
	       * @param {element} targetElem - The element to position.
	       * @param {string=} [placement=top] - The placement for the targetElem,
	       *   default is 'top'. 'center' is assumed as secondary placement for
	       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	       *   <ul>
	       *     <li>top</li>
	       *     <li>top-right</li>
	       *     <li>top-left</li>
	       *     <li>bottom</li>
	       *     <li>bottom-left</li>
	       *     <li>bottom-right</li>
	       *     <li>left</li>
	       *     <li>left-top</li>
	       *     <li>left-bottom</li>
	       *     <li>right</li>
	       *     <li>right-top</li>
	       *     <li>right-bottom</li>
	       *   </ul>
	       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	       *   be calculated from the body element, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: Value for targetElem top.</li>
	       *     <li>**left**: Value for targetElem left.</li>
	       *     <li>**placement**: The resolved placement.</li>
	       *   </ul>
	       */
	      positionElements: function(hostElem, targetElem, placement, appendToBody) {
	        hostElem = this.getRawNode(hostElem);
	        targetElem = this.getRawNode(targetElem);
	
	        // need to read from prop to support tests.
	        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	        placement = this.parsePlacement(placement);
	
	        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	        var targetElemPos = {top: 0, left: 0, placement: ''};
	
	        if (placement[2]) {
	          var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	          var targetElemStyle = $window.getComputedStyle(targetElem);
	          var adjustedSize = {
	            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	          };
	
	          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
	                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
	                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
	                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
	                         placement[0];
	
	          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
	                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
	                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
	                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
	                         placement[1];
	
	          if (placement[1] === 'center') {
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	                placement[1] = 'left';
	              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	                placement[1] = 'right';
	              }
	            } else {
	              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	                placement[1] = 'top';
	              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	                placement[1] = 'bottom';
	              }
	            }
	          }
	        }
	
	        switch (placement[0]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top - targetHeight;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left - targetWidth;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width;
	            break;
	        }
	
	        switch (placement[1]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	            break;
	          case 'center':
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	            } else {
	              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	            }
	            break;
	        }
	
	        targetElemPos.top = Math.round(targetElemPos.top);
	        targetElemPos.left = Math.round(targetElemPos.left);
	        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	        return targetElemPos;
	      },
	
	      /**
	       * Provides a way to adjust the top positioning after first
	       * render to correctly align element to top after content
	       * rendering causes resized element height
	       *
	       * @param {array} placementClasses - The array of strings of classes
	       * element should have.
	       * @param {object} containerPosition - The object with container
	       * position information
	       * @param {number} initialHeight - The initial height for the elem.
	       * @param {number} currentHeight - The current height for the elem.
	       */
	      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
	        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
	          return {
	            top: containerPosition.top - currentHeight + 'px'
	          };
	        }
	      },
	
	      /**
	       * Provides a way for positioning tooltip & dropdown
	       * arrows when using placement options beyond the standard
	       * left, right, top, or bottom.
	       *
	       * @param {element} elem - The tooltip/dropdown element.
	       * @param {string} placement - The placement for the elem.
	       */
	      positionArrow: function(elem, placement) {
	        elem = this.getRawNode(elem);
	
	        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	        if (!innerElem) {
	          return;
	        }
	
	        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	        if (!arrowElem) {
	          return;
	        }
	
	        var arrowCss = {
	          top: '',
	          bottom: '',
	          left: '',
	          right: ''
	        };
	
	        placement = this.parsePlacement(placement);
	        if (placement[1] === 'center') {
	          // no adjustment necessary - just reset styles
	          angular.element(arrowElem).css(arrowCss);
	          return;
	        }
	
	        var borderProp = 'border-' + placement[0] + '-width';
	        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	        var borderRadiusProp = 'border-';
	        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	          borderRadiusProp += placement[0] + '-' + placement[1];
	        } else {
	          borderRadiusProp += placement[1] + '-' + placement[0];
	        }
	        borderRadiusProp += '-radius';
	        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	        switch (placement[0]) {
	          case 'top':
	            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'bottom':
	            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'left':
	            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'right':
	            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	            break;
	        }
	
	        arrowCss[placement[1]] = borderRadius;
	
	        angular.element(arrowElem).css(arrowCss);
	      }
	    };
	  }]);


/***/ }),
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fbOl = __webpack_require__(302);
	
	var _fbOl2 = _interopRequireDefault(_fbOl);
	
	var _emptyItem = __webpack_require__(211);
	
	var _emptyItem2 = _interopRequireDefault(_emptyItem);
	
	var _fbLiSelect = __webpack_require__(440);
	
	var _fbLiSelect2 = _interopRequireDefault(_fbLiSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbOlSelect = {
	  template: __webpack_require__(819),
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	    */
	    name: '@',
	    childPlaceholder: '@',
	    allowChildKey: '@',
	    list: '<',
	    value: '<',
	    onUpdate: '&',
	    onSelect: '&',
	    onCreate: '&',
	    onToggleBookmark: '&'
	  },
	  controller: _fbOl2.default
	};
	
	exports.default = _angular2.default.module('components.fbOlSelect', [_fbLiSelect2.default, _emptyItem2.default]).component('fbOlSelect', fbOlSelect).name;

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var Lexica = {
		legal: {
			lexicon: 'legal',
			case: 'Case',
			legalIssues: 'Issues',
			issue: 'Issue',
			contributors: 'Contributors',
			contributor: 'Contributor',
			factDateish: 'Key Date',
			sources: 'Sources',
			tags: 'Tags',
			title: 'Title',
			content: 'Content',
			creationDate: 'Creation Date',
			memo: 'Memo',
			firm: 'Firm'
		},
		media: {
			lexicon: 'media',
			case: 'Project',
			legalIssues: 'Topics',
			issue: 'Topic',
			contributors: 'Collaborators',
			contributor: 'Collaborator',
			factDateish: 'Key Date',
			sources: 'Sources',
			tags: 'Tags',
			title: 'Title',
			content: 'Content',
			creationDate: 'Creation Date',
			memo: 'Doc',
			firm: 'Account'
		}
	};
	exports.default = angular.module('contants.lexica', []).constant('Lexica', Lexica).name;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _actionGuide = __webpack_require__(561);
	
	var _actionGuide2 = _interopRequireDefault(_actionGuide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(801);
	
	
	function ActionGuide(ActionGuideServ, $window, $timeout, $rootScope) {
	  return {
	    restrict: 'E',
	    template: __webpack_require__(833),
	    link: function link(scope, element, attrs) {
	
	      $timeout(function () {
	        var openerActionGuide;
	        scope.context = attrs.context;
	        if ($window.isFactWindow && $window.opener && $window.opener.angular) {
	          openerActionGuide = $window.opener.angular.element($window.opener.document.querySelector('[ng-app]')).injector().get('ActionGuideServ');
	        }
	        scope.actionGuide = openerActionGuide || ActionGuideServ;
	        // pass a callback so the service can search the given with a target selector
	        scope.actionGuide.connect(scope.context, function (target) {
	          return target === 'window' ? window : document.querySelector(target);
	        });
	        scope.actionGuide.setGuide('full');
	      });
	      $rootScope.$on('$routeChangeSuccess', function () {
	        scope.actionGuide.success();
	      });
	      $rootScope.$on('$routeChangeStart', function (e, next) {
	        if (!/home|fact/.test(next.$$route.originalPath)) {
	          element[0].remove();
	        }
	      });
	      scope.$on('$destroy', function () {
	        scope.actionGuide.unbindWatchers();
	      });
	    }
	  };
	}
	ActionGuide.$inject = ['ActionGuideServ', '$window', '$timeout', '$rootScope'];
	
	exports.default = _angular2.default.module('directives.lf-action-guide', [_analytics2.default, _actionGuide2.default]).directive('lfActionGuide', ActionGuide).name;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function lwOnScrollEnd() {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      var el = element[0];
	      var visibleHeight = el.offsetHeight;
	      var scrollableHeight = element.prop('scrollHeight');
	      var hiddenContentHeight = scrollableHeight - visibleHeight;
	      var threshold = 1000;
	      var busy = false;
	
	      var onScroll = function onScroll() {
	        if (busy) {
	          return;
	        }
	
	        visibleHeight = el.offsetHeight;
	        scrollableHeight = element.prop('scrollHeight');
	        hiddenContentHeight = scrollableHeight - visibleHeight;
	
	        if (hiddenContentHeight - el.scrollTop <= threshold) {
	          // Scroll is almost at the bottom. Loading more rows
	          busy = true;
	          scope.$eval(attrs.lwOnScrollEnd).then(function () {
	            busy = false;
	          });
	        }
	      };
	      scope.$on('$destroy', function () {
	        el.removeEventListener('scroll', onScroll);
	      });
	      el.addEventListener('scroll', onScroll);
	    }
	  };
	}
	exports.default = _angular2.default.module('directives.lw-on-scroll-end', []).directive('lwOnScrollEnd', lwOnScrollEnd).name;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmptyItem() {
		return function (array) {
			if (!array) {
				return;
			}
			if (array[0] && array[0].id === '__empty__') {
				array.splice(0, 1);
				return array;
			} else {
				return array.filter(function (item) {
					return item.id !== '__empty__';
				});
			}
		};
	}
	
	exports.default = _angular2.default.module('filters.empty-item', []).filter('emptyItem', EmptyItem).name;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EncodeUriFilter() {
		return function (component) {
			return encodeURIComponent(component);
		};
	}
	
	exports.default = _angular2.default.module('filters.encode-uri', []).filter('encodeURI', EncodeUriFilter).name;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lexica = __webpack_require__(208);
	
	var _lexica2 = _interopRequireDefault(_lexica);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LexiconFilter(Lexica, CurrentUser) {
		return function () {
			var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dialect';
			var plural = arguments[1];
			var textCase = arguments[2];
	
			var lexicon = CurrentUser.data.lexicon || 'legal'; // debug with media fallback
			var str = '' + (Lexica[lexicon][key] || key) + (plural ? 's' : '');
			if (textCase === 'upper') {
				str = str.toUpperCase();
			} else if (textCase === 'lower') {
				str = str.toLowerCase();
			}
			return str;
		};
	}
	LexiconFilter.$inject = ['Lexica', 'CurrentUser'];
	
	exports.default = _angular2.default.module('filters.lexicon', [_lexica2.default, _user2.default]).filter('lexicon', LexiconFilter).name;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _default = __webpack_require__(29);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentGrouping = function (_DefaultGrouping) {
	  (0, _inherits3.default)(ContentGrouping, _DefaultGrouping);
	
	  function ContentGrouping($sce) {
	    (0, _classCallCheck3.default)(this, ContentGrouping);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ContentGrouping.__proto__ || (0, _getPrototypeOf2.default)(ContentGrouping)).call(this));
	
	    _this.trust = $sce.trustAsHtml;
	
	    _this.key = 'content';
	    _this.displayName = 'Content';
	    _this.groupByPulldown = false;
	    _this.secondarySortable = false;
	    return _this;
	  }
	
	  // Content needs to be trusted as html to allow for style attrs on spans
	
	
	  (0, _createClass3.default)(ContentGrouping, [{
	    key: 'getDisplayText',
	    value: function getDisplayText(content) {
	      return this.trust(content);
	    }
	  }, {
	    key: 'getDocDisplayStyles',
	    value: function getDocDisplayStyles() {
	      var result = this.getDocDisplayStyles();
	      result['width'] = 'auto';
	      return result;
	    }
	  }, {
	    key: 'getDocDisplayText',
	    value: function getDocDisplayText(value) {
	      return this.getDisplayText(value);
	    }
	  }, {
	    key: 'getMemoText',
	    value: function getMemoText(value) {
	      return this.getDisplayText(value);
	    }
	  }]);
	  return ContentGrouping;
	}(_default2.default);
	
	ContentGrouping.$inject = ['$sce'];
	
	exports.default = _angular2.default.module('groupings.content-grouping', []).service('ContentGrouping', ContentGrouping).name;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(34);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _default = __webpack_require__(29);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreatorGrouping = function (_DefaultGrouping) {
	  (0, _inherits3.default)(CreatorGrouping, _DefaultGrouping);
	
	  function CreatorGrouping() {
	    (0, _classCallCheck3.default)(this, CreatorGrouping);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CreatorGrouping.__proto__ || (0, _getPrototypeOf2.default)(CreatorGrouping)).call(this));
	
	    _this.key = 'creator';
	    _this.displayName = 'Contributor';
	    _this.secondarySortable = false;
	
	    _this.columnsByGroup = (0, _get3.default)(CreatorGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(CreatorGrouping.prototype), 'setColumns', _this).call(_this, ['creationDate', 'title', 'content', 'sources', 'legalIssues', 'contributors', 'factDateish', 'tags']);
	    return _this;
	  }
	
	  (0, _createClass3.default)(CreatorGrouping, [{
	    key: 'getDisplayName',
	    value: function getDisplayName(creator) {
	      return creator.firstName + ' ' + creator.lastName;
	    }
	  }, {
	    key: 'getItemsByFact',
	    value: function getItemsByFact(fact) {
	      var items = [];
	      items.push(fact[this.key].id);
	      if (!items.length) {
	        items.push('ungrouped');
	      }
	
	      return items;
	    }
	  }, {
	    key: 'getDisplayText',
	    value: function getDisplayText(creator) {
	      return creator.firstName.substring(0, 1) + creator.lastName.substring(0, 1);
	    }
	  }, {
	    key: 'getDocDisplayText',
	    value: function getDocDisplayText(value) {
	      return this.getDisplayText(value);
	    }
	  }, {
	    key: 'getSortingValue',
	    value: function getSortingValue(value) {
	      return this.getDisplayText(value);
	    }
	  }, {
	    key: 'getMemoText',
	    value: function getMemoText(value) {
	      return this.getDisplayText(value);
	    }
	  }, {
	    key: 'getHeaderDisplayName',
	    value: function getHeaderDisplayName(value) {
	      return this.getDisplayName(value);
	    }
	  }]);
	  return CreatorGrouping;
	}(_default2.default);
	
	exports.default = _angular2.default.module('groupings.creator-grouping', []).service('CreatorGrouping', CreatorGrouping).name;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _content = __webpack_require__(214);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _contributors = __webpack_require__(129);
	
	var _contributors2 = _interopRequireDefault(_contributors);
	
	var _creationDate = __webpack_require__(130);
	
	var _creationDate2 = _interopRequireDefault(_creationDate);
	
	var _creator = __webpack_require__(215);
	
	var _creator2 = _interopRequireDefault(_creator);
	
	var _factDateish = __webpack_require__(115);
	
	var _factDateish2 = _interopRequireDefault(_factDateish);
	
	var _issues = __webpack_require__(132);
	
	var _issues2 = _interopRequireDefault(_issues);
	
	var _sources = __webpack_require__(133);
	
	var _sources2 = _interopRequireDefault(_sources);
	
	var _tags = __webpack_require__(134);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _title = __webpack_require__(217);
	
	var _title2 = _interopRequireDefault(_title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Groupings(ContentGrouping, ContributorsGrouping, CreationDateGrouping, CreatorGrouping, FactDateishGrouping, IssuesGrouping, SourcesGrouping, TagsGrouping, TitleGrouping) {
		return {
			'content': ContentGrouping,
			'contributors': ContributorsGrouping,
			'creationDate': CreationDateGrouping,
			'creator': CreatorGrouping,
			'factDateish': FactDateishGrouping,
			'legalIssues': IssuesGrouping,
			'sources': SourcesGrouping,
			'tags': TagsGrouping,
			'title': TitleGrouping
		};
	}
	Groupings.$inject = ['ContentGrouping', 'ContributorsGrouping', 'CreationDateGrouping', 'CreatorGrouping', 'FactDateishGrouping', 'IssuesGrouping', 'SourcesGrouping', 'TagsGrouping', 'TitleGrouping'];
	
	exports.default = angular.module('groupings.index', [_content2.default, _contributors2.default, _creationDate2.default, _creator2.default, _factDateish2.default, _issues2.default, _sources2.default, _tags2.default, _title2.default]).factory('Groupings', Groupings).name;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get2 = __webpack_require__(34);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _default = __webpack_require__(29);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TitleGrouping = function (_DefaultGrouping) {
		(0, _inherits3.default)(TitleGrouping, _DefaultGrouping);
	
		function TitleGrouping() {
			(0, _classCallCheck3.default)(this, TitleGrouping);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (TitleGrouping.__proto__ || (0, _getPrototypeOf2.default)(TitleGrouping)).call(this));
	
			_this.groupByPulldown = false;
			_this.key = 'title';
			_this.displayName = 'Title';
			_this.secondarySortable = true;
	
			_this.getDocDisplayText = (0, _get3.default)(TitleGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(TitleGrouping.prototype), 'getDisplayText', _this);
			_this.getSortingValue = (0, _get3.default)(TitleGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(TitleGrouping.prototype), 'getDisplayText', _this);
			_this.getMemoText = (0, _get3.default)(TitleGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(TitleGrouping.prototype), 'getDisplayText', _this);
			_this.getHeaderDisplayName = (0, _get3.default)(TitleGrouping.prototype.__proto__ || (0, _getPrototypeOf2.default)(TitleGrouping.prototype), 'getDisplayName', _this);
			return _this;
		}
	
		return TitleGrouping;
	}(_default2.default);
	
	exports.default = _angular2.default.module('groupings.title-grouping', []).service('TitleGrouping', TitleGrouping).name;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _map = __webpack_require__(318);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _account = __webpack_require__(75);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _accountMap = __webpack_require__(316);
	
	var _accountMap2 = _interopRequireDefault(_accountMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CaseMapFactory(Case, BaseMap, CurrentAccount, AccountMap) {
	  return function (_BaseMap) {
	    (0, _inherits3.default)(CaseMap, _BaseMap);
	
	    function CaseMap() {
	      (0, _classCallCheck3.default)(this, CaseMap);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (CaseMap.__proto__ || (0, _getPrototypeOf2.default)(CaseMap)).call(this, Case));
	
	      _this.setApi('/cases', null, {
	        get: {
	          method: 'GET',
	          url: '/cases',
	          success: [function (data) {
	            CurrentAccount.setData(data.accounts.current);
	            AccountMap.fromCollection(data.accounts.others);
	            _this.fromCollection(data.cases);
	          }]
	        },
	        getPublic: {
	          method: 'GET',
	          url: '/cases',
	          params: {
	            isPublic: true
	          },
	          success: [function () {}]
	        }
	      });
	      return _this;
	    }
	
	    return CaseMap;
	  }(BaseMap);
	}
	CaseMapFactory.$inject = ['Case', 'BaseMap', 'CurrentAccount', 'AccountMap'];
	
	exports.default = _angular2.default.module('maps.case', [_case2.default, _map2.default, _account2.default, _accountMap2.default]).factory('CaseMapFactory', CaseMapFactory).service('CaseMap', ['CaseMapFactory', function (CaseMapFactory) {
	  return new CaseMapFactory();
	}]).name;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FactFactory(Model, AnalyticsServ) {
	  return function (_Model) {
	    (0, _inherits3.default)(FactModel, _Model);
	
	    function FactModel() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      (0, _classCallCheck3.default)(this, FactModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (FactModel.__proto__ || (0, _getPrototypeOf2.default)(FactModel)).call(this, data));
	
	      _this.setApi('/case/:caseId/fact/:factId', {
	        caseId: '@caseId',
	        factId: '@id'
	      }, {
	        'create': {
	          method: 'POST',
	          success: [function (data) {
	            return _this.setData(data);
	          }, function (data) {
	            return AnalyticsServ.added('Fact');
	          }]
	        },
	        'list': {
	          method: 'GET',
	          isArray: true
	        },
	        'query': {
	          method: 'GET'
	        },
	        'update': {
	          method: 'PUT',
	          params: {
	            factId: '@id'
	          },
	          success: [function (data) {
	            return _this.setData(data);
	          }, function (data) {
	            return AnalyticsServ.updated('Fact');
	          }]
	        },
	        'addSource': {
	          method: 'PUT',
	          url: '/case/:caseId/fact/:factId/source/:sourceId'
	        },
	        'removeSource': {
	          method: 'DELETE',
	          url: '/case/:caseId/fact/:factId/source/:sourceId'
	        },
	        'addTag': {
	          method: 'PUT',
	          url: '/case/:caseId/fact/:factId/tag/:tagId'
	        },
	        'removeTag': {
	          method: 'DELETE',
	          url: '/case/:caseId/fact/:factId/tag/:tagId'
	        },
	        'delete': {
	          method: 'DELETE',
	          params: {
	            factId: '@id'
	          },
	          success: [function (data) {
	            return _this.setData(data);
	          }, function (data) {
	            return AnalyticsServ.removed('Fact');
	          }],
	          headers: {
	            'x-lynx-confirmationCode': function xLynxConfirmationCode() {
	              return _this.getData().confirmationCode;
	            },
	            'x-lynx-revisionNumber': function xLynxRevisionNumber() {
	              return _this.getData().revisionNumber;
	            }
	          },
	          fail: [function (response) {
	            _this.data.confirmationCode = response.data.confirmationCode;
	            // this.data.revisionNumber = response.data.revisionNumber;
	            _this.fail(response);
	          }]
	        }
	      });
	      return _this;
	    }
	
	    return FactModel;
	  }(Model);
	}
	FactFactory.$inject = ['Model', 'AnalyticsServ'];
	
	exports.default = _angular2.default.module('models.fact', [_model2.default, _analytics2.default]).factory('Fact', FactFactory).name;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tree = __webpack_require__(37);
	
	var _tree2 = _interopRequireDefault(_tree);
	
	var _contributors = __webpack_require__(129);
	
	var _contributors2 = _interopRequireDefault(_contributors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContributorsTreeFactory(TreeModel, ContributorsGrouping) {
	  return function (_TreeModel) {
	    (0, _inherits3.default)(ContributorsTreeModel, _TreeModel);
	
	    function ContributorsTreeModel() {
	      (0, _classCallCheck3.default)(this, ContributorsTreeModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (ContributorsTreeModel.__proto__ || (0, _getPrototypeOf2.default)(ContributorsTreeModel)).call(this));
	
	      _this.grouping = ContributorsGrouping;
	      _this.setApi("/case/:caseId/values/contributors", {
	        caseId: '@caseId'
	      }, { // actions
	        'get': {
	          method: 'GET',
	          isArray: true
	        }
	      });
	      return _this;
	    }
	
	    return ContributorsTreeModel;
	  }(TreeModel);
	}
	
	ContributorsTreeFactory.$inject = ['TreeModel', 'ContributorsGrouping'];
	
	exports.default = _angular2.default.module('models.contributors-tree', [_tree2.default, _contributors2.default]).factory('ContributorsTreeFactory', ContributorsTreeFactory).service('ContributorsTree', ['ContributorsTreeFactory', function (ContributorsTreeFactory) {
	  return new ContributorsTreeFactory();
	}]).name;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tree = __webpack_require__(37);
	
	var _tree2 = _interopRequireDefault(_tree);
	
	var _creationDate = __webpack_require__(130);
	
	var _creationDate2 = _interopRequireDefault(_creationDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CreationDateTreeFactory(TreeModel, CreationDateGrouping) {
	  return function (_TreeModel) {
	    (0, _inherits3.default)(CreationDateTreeModel, _TreeModel);
	
	    function CreationDateTreeModel() {
	      (0, _classCallCheck3.default)(this, CreationDateTreeModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (CreationDateTreeModel.__proto__ || (0, _getPrototypeOf2.default)(CreationDateTreeModel)).call(this));
	
	      _this.grouping = CreationDateGrouping;
	      _this.setApi("/case/:caseId/values/creationDate", {
	        caseId: '@caseId'
	      }, { // actions
	        'get': {
	          method: 'GET',
	          isArray: true
	        }
	      });
	      return _this;
	    }
	
	    return CreationDateTreeModel;
	  }(TreeModel);
	}
	
	CreationDateTreeFactory.$inject = ['TreeModel', 'CreationDateGrouping'];
	
	exports.default = _angular2.default.module('models.creation-date-tree', [_tree2.default, _creationDate2.default]).factory('CreationDateTreeFactory', CreationDateTreeFactory).service('CreationDateTree', ['CreationDateTreeFactory', function (CreationDateTreeFactory) {
	  return new CreationDateTreeFactory();
	}]).name;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tree = __webpack_require__(37);
	
	var _tree2 = _interopRequireDefault(_tree);
	
	var _factDateish = __webpack_require__(115);
	
	var _factDateish2 = _interopRequireDefault(_factDateish);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FactDateishTreeFactory(TreeModel, FactDateishGrouping) {
	  return function (_TreeModel) {
	    (0, _inherits3.default)(FactDateishTreeModel, _TreeModel);
	
	    function FactDateishTreeModel() {
	      (0, _classCallCheck3.default)(this, FactDateishTreeModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (FactDateishTreeModel.__proto__ || (0, _getPrototypeOf2.default)(FactDateishTreeModel)).call(this));
	
	      _this.grouping = FactDateishGrouping;
	      _this.setApi("/case/:caseId/values/factDateish", {
	        caseId: '@caseId'
	      }, { // actions
	        'get': {
	          method: 'GET',
	          isArray: true
	        }
	      });
	      return _this;
	    }
	
	    return FactDateishTreeModel;
	  }(TreeModel);
	}
	
	FactDateishTreeFactory.$inject = ['TreeModel', 'FactDateishGrouping'];
	
	exports.default = _angular2.default.module('models.fact-dateish-tree', [_tree2.default, _factDateish2.default]).factory('FactDateishTreeFactory', FactDateishTreeFactory).service('FactDateishTree', ['FactDateishTreeFactory', function (FactDateishTreeFactory) {
	  return new FactDateishTreeFactory();
	}]).name;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _case2 = __webpack_require__(36);
	
	var _case3 = _interopRequireDefault(_case2);
	
	var _errors = __webpack_require__(116);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _customer = __webpack_require__(135);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentStatus = function () {
		function PaymentStatus(CurrentCase, CurrentCustomer, Errors) {
			(0, _classCallCheck3.default)(this, PaymentStatus);
	
			this.errors = Errors;
	
			this.expireMessages = {
				user: {
					error: 'No payment attached',
					details: 'There is no payment attached. To access all functionality, please upgrade to a paid plan. <div><a class="btn btn-success pull-right" href="/app/#/account?tab=firm">Upgrade</a></div>'
				},
				case: {
					error: 'No payment attached',
					details: 'The trial period on this case has expired and/or there is no payment attached. To open all functionality for this case, please upgrade to a paid plan. <div><a class="btn btn-success pull-right" href="/app/#/account?tab=firm">Upgrade</a></div>'
				}
			};
			this.statusData = {
				user: function user(obj) {
					var testObj = obj || CurrentCustomer.data || {
						status: -1
					};
					return testObj.status;
				},
				case: function _case(obj) {
					var testObj = obj || CurrentCase.data || {
						subscription: {
							status: 0
						}
					};
					return testObj.subscription && testObj.subscription.status;
				}
			};
			this.warningData = {
				user: function user(obj) {
					var testObj = obj || CurrentCustomer.data || {
						hideStatusWarning: false
					};
					return testObj.hideStatusWarning;
				},
				case: function _case(obj) {
					var testObj = obj || CurrentCase.data || {
						hideStatusWarning: false
					};
					return testObj.subscription && testObj.subscription.hideWarning;
				}
			};
		}
	
		(0, _createClass3.default)(PaymentStatus, [{
			key: 'setType',
			value: function setType(type) {
				return type === 'user' ? 'user' : 'case';
			}
		}, {
			key: 'setExpiredMsg',
			value: function setExpiredMsg(type) {
				this.errors.data['/#/plan'] = this.expireMessages[this.setType(type)];
			}
		}, {
			key: 'getStatus',
			value: function getStatus(type, testObj) {
				return this.statusData[this.setType(type)](testObj);
			}
		}, {
			key: 'getStatusTxt',
			value: function getStatusTxt(type, testObj) {
				var s = this.statusData[this.setType(type)](testObj);
				return s > 0 ? 'TRIAL' : s < 0 ? 'UNPAID' : s === 0 ? 'PAID' : '';
			}
		}, {
			key: 'isExpired',
			value: function isExpired(type, testObj) {
				return this.statusData[this.setType(type)](testObj) < 0;
			}
		}, {
			key: 'isTrial',
			value: function isTrial(type, testObj) {
				return this.statusData[this.setType(type)](testObj) > 0;
			}
		}, {
			key: 'isValid',
			value: function isValid(type, testObj) {
				return this.statusData[this.setType(type)](testObj) === 0;
			}
		}, {
			key: 'showWarning',
			value: function showWarning(type, testObj) {
				return !this.warningData[this.setType(type)](testObj);
			}
		}]);
		return PaymentStatus;
	}();
	
	PaymentStatus.$inject = ['CurrentCase', 'CurrentCustomer', 'Errors'];
	
	exports.default = _angular2.default.module('services.payment-status', [_case3.default, _customer2.default]).service('PaymentStatusServ', PaymentStatus).name;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _version = __webpack_require__(159);
	
	var _version2 = _interopRequireDefault(_version);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Version = function () {
		function Version($window, $http, $interval, $q, VersionConst) {
			var _this = this;
	
			(0, _classCallCheck3.default)(this, Version);
	
			this.http = $http;
			this.q = $q;
			this.local = VersionConst;
			// Poll for update every 20 min
			$interval(function () {
				return _this.check();
			}, 1.2e6, 0, false);
		}
	
		(0, _createClass3.default)(Version, [{
			key: 'ping',
			value: function ping() {
				return this.http({
					url: '/manifest.json',
					method: 'GET'
				});
			}
		}, {
			key: 'check',
			value: function check() {
				var _this2 = this;
	
				var v = this.q.defer();
				this.ping().then(function (response) {
					_this2.origin = response.data.version;
					if (_this2.local && _this2.origin) {
						var local = _this2.local.split('.');
						var origin = _this2.origin.split('.');
	
						_this2.update = local.length !== origin.length || origin.some(function (val, i) {
							return val !== local[i];
						});
	
						v.resolve(_this2.update);
					} else {
						v.reject();
					}
				}, function () {
					v.reject();
				});
	
				return v.promise;
			}
		}]);
		return Version;
	}();
	
	Version.$inject = ['$window', '$http', '$interval', '$q', 'VersionConst'];
	
	exports.default = _angular2.default.module('services.version', [_version2.default]).service('VersionServ', Version).name;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(232), __esModule: true };

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(233), __esModule: true };

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(234), __esModule: true };

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(236), __esModule: true };

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(237), __esModule: true };

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(238), __esModule: true };

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(251);
	module.exports = __webpack_require__(9).Object.assign;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(252);
	var $Object = __webpack_require__(9).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(253);
	var $Object = __webpack_require__(9).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(254);
	var $Object = __webpack_require__(9).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(255);
	module.exports = __webpack_require__(9).Object.getPrototypeOf;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(256);
	module.exports = __webpack_require__(9).Object.setPrototypeOf;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(257);
	__webpack_require__(167);
	__webpack_require__(258);
	__webpack_require__(259);
	module.exports = __webpack_require__(9).Symbol;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(98);
	__webpack_require__(119);
	module.exports = __webpack_require__(97).f('iterator');


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 240 */
[918, 77, 23],
/* 241 */
[925, 38, 94, 66],
/* 242 */
[928, 15],
/* 243 */
[934, 79, 45, 80, 31, 23],
/* 244 */
[938, 38, 94, 66, 39, 78, 25],
/* 245 */
[941, 19, 32, 38, 17],
/* 246 */
[943, 27, 144],
/* 247 */
[951, 26, 32, 44, 93],
/* 248 */
[955, 55, 53],
/* 249 */
[965, 240, 23, 54, 9],
/* 250 */
[967, 239, 166, 54, 27, 118],
/* 251 */
[969, 18, 244],
/* 252 */
[970, 18, 79],
/* 253 */
[971, 18, 17, 19],
/* 254 */
[972, 27, 93, 67],
/* 255 */
[973, 39, 145, 67],
/* 256 */
[975, 18, 247],
/* 257 */
[977, 15, 30, 17, 18, 146, 143, 25, 69, 80, 49, 23, 97, 96, 241, 165, 32, 27, 70, 45, 79, 246, 93, 19, 38, 144, 66, 94, 92, 31],
/* 258 */
[981, 96],
/* 259 */
[982, 96],
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(28);
	var toAbsoluteIndex = __webpack_require__(108);
	var toLength = __webpack_require__(22);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 261 */
[917, 601],
/* 262 */
[921, 21, 105],
/* 263 */
[924, 12, 10],
/* 264 */
65,
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(14)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 266 */
[928, 10],
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	var setPrototypeOf = __webpack_require__(275).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 268 */
[931, 120, 14],
/* 269 */
[934, 102, 105, 121, 41, 14],
/* 270 */
[935, 101, 2, 42, 41, 40, 120, 269, 121, 47, 14],
/* 271 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 272 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var macrotask = __webpack_require__(281).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(50)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if (Observer) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(35);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 275 */
[951, 12, 8, 51, 46],
/* 276 */
[953, 179, 109],
/* 277 */
[955, 60, 58],
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(173);
	var defined = __webpack_require__(58);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(60);
	var defined = __webpack_require__(58);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 280 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(51);
	var invoke = __webpack_require__(341);
	var html = __webpack_require__(266);
	var cel = __webpack_require__(263);
	var global = __webpack_require__(10);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(50)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(10);
	var DESCRIPTORS = __webpack_require__(20);
	var LIBRARY = __webpack_require__(101);
	var $typed = __webpack_require__(181);
	var hide = __webpack_require__(41);
	var redefineAll = __webpack_require__(106);
	var fails = __webpack_require__(11);
	var anInstance = __webpack_require__(99);
	var toInteger = __webpack_require__(60);
	var toLength = __webpack_require__(22);
	var toIndex = __webpack_require__(359);
	var gOPN = __webpack_require__(103).f;
	var dP = __webpack_require__(21).f;
	var arrayFill = __webpack_require__(260);
	var setToStringTag = __webpack_require__(121);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 283 */
[962, 10, 57, 101, 360, 21],
/* 284 */
[965, 149, 14, 120, 57],
/* 285 */
[967, 82, 344, 120, 48, 270],
/* 286 */
182,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fbEditable = __webpack_require__(435);
	
	var _fbEditable2 = _interopRequireDefault(_fbEditable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbEditable = {
	  template: __webpack_require__(812),
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	    */
	    name: '@',
	    value: '<',
	    onUpdate: '&'
	  },
	  controller: _fbEditable2.default
	};
	
	exports.default = _angular2.default.module('components.fbEditable', []).component('fbEditable', fbEditable).name;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(76);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbLiCtrl = function () {
	  function fbLiCtrl($element, $timeout) {
	    (0, _classCallCheck3.default)(this, fbLiCtrl);
	
	    this.element = $element[0];
	    this.timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(fbLiCtrl, [{
	    key: '$onInit',
	    value: function $onInit() {
	      /*
	        Called on each controller after all the controllers on an element 
	        have been constructed and had their bindings initialized 
	        (and before the pre & post linking functions for the directives on this 
	        element). This is a good place to put initialization code for your controller.
	      */
	      this.reset();
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      /*
	        Called on a controller when its containing scope is destroyed. 
	        Use this hook for releasing external resources, watches and event handlers.
	      */
	
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      /*
	        Called after this controller's element and its children have been linked. 
	        Similar to the post-link function this hook can be used to set up 
	        DOM event handlers and do direct DOM manipulation. Note that child 
	        elements that contain templateUrl directives will not have been compiled 
	        and linked since they are waiting for their template to load 
	        asynchronously and their own compilation and linking has been suspended 
	        until that occurs. This hook can be considered analogous to the 
	        ngAfterViewInit and ngAfterContentInit hooks in Angular 2. Since the 
	        compilation process is rather different in Angular 1 there is no direct 
	        mapping and care should be taken when upgrading.
	      */
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changesObj) {
	      /*
	        Called whenever one-way bindings are updated. The changesObj is a hash 
	        whose keys are the names of the bound properties that have changed, and 
	        the values are an object of the form 
	        { currentValue, previousValue, isFirstChange() }. 
	        Use this hook to trigger updates within a component such as cloning the 
	        bound value to prevent accidental mutation of the outer value.
	      */
	      this.reset();
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      // isSelected used in management modals, for single-item select
	      // selected used in selection modals
	      this.editMode = false;
	      this.subEditMode = false;
	      this.newSubValue = '';
	      this.isSelected = this.selectedId === this.value.id;
	      if (this.selection) {
	        var index = this.selection.map(function (item) {
	          return item.id;
	        }).indexOf(this.value.id);
	        this.selected = index >= 0;
	        this.selectedValue = this.selected && this.selection[index];
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      if (this.newValue !== this.value.displayName && this.newValue.length) {
	        this.onUpdate({
	          newValue: (0, _assign2.default)(this.value, { displayName: this.newValue })
	        }).then(function () {
	          _this.reset();
	        });
	      } else {
	        this.reset();
	      }
	    }
	  }, {
	    key: 'submitSubValue',
	    value: function submitSubValue() {
	      var _this2 = this;
	
	      if (this.newSubValue && this.newSubValue.length) {
	        this.onCreate({ displayName: this.newSubValue, parent: this.value }).then(function () {
	          _this2.reset();
	        });
	      } else {
	        this.reset();
	      }
	    }
	  }, {
	    key: 'setEditMode',
	    value: function setEditMode(subEditMode) {
	      var _this3 = this;
	
	      if (subEditMode) {
	        this.subEditMode = true;
	      } else {
	        this.editMode = true;
	        this.newValue = angular.copy(this.value.displayName);
	
	        var width = this.element.querySelector('.editable-text').offsetWidth;
	        this.element.querySelector('.editable-field').style.width = width + 'px';
	      }
	
	      this.timeout(function () {
	        return _this3.element.querySelector(subEditMode ? 'input.sub-item' : 'input').focus();
	      });
	    }
	  }, {
	    key: 'setSelected',
	    value: function setSelected(e) {
	      // management modals
	      this.isSelected ? this.setEditMode() : this.onSelect({ id: this.value.id });
	    }
	  }, {
	    key: 'toggleSelected',
	    value: function toggleSelected(e) {
	      e.stopPropagation();
	      this.onSelect({ value: this.value });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e, subEditMode) {
	      e.stopImmediatePropagation();
	      e.preventDefault();
	      switch (e.type) {
	        case 'blur':
	          subEditMode ? this.submitSubValue() : this.submit();
	          break;
	        case 'keyup':
	          switch (e.keyCode) {
	            case 27:
	              this.reset();
	              break;
	            case 13:
	              subEditMode ? this.submitSubValue() : this.submit();
	              break;
	          }
	      }
	    }
	  }]);
	  return fbLiCtrl;
	}();
	
	exports.default = fbLiCtrl;
	
	fbLiCtrl.$inject = ['$element', '$timeout'];

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbOlCtrl = function () {
	  function fbOlCtrl($element, $timeout) {
	    (0, _classCallCheck3.default)(this, fbOlCtrl);
	
	    this.element = $element[0];
	    this.timeout = $timeout;
	    this.childPlaceholder = this.childPlaceholder || 'Enter Name';
	
	    this.uiTreeConfig = {
	      dropped: function dropped() {
	        // this.issuesTree.setData();
	      }
	    };
	    this.spliceTree = this.spliceTree.bind(this);
	    this.setSelected = this.setSelected.bind(this);
	    this.dragEnd = this.dragEnd.bind(this);
	    /*
	      Drag and Drop
	      The fb-ol controller is notified when:
	      - a source fb-li 
	        - is dragged (on drag, touchmove)
	        - is dropped (on drop, touchend)
	        - cancels drag (on dragcancel)
	      - a target fb-li 
	        - is dragged over (enter, over, leave)
	    */
	  }
	
	  (0, _createClass3.default)(fbOlCtrl, [{
	    key: '$onInit',
	    value: function $onInit() {
	      /*
	        Called on each controller after all the controllers on an element 
	        have been constructed and had their bindings initialized 
	        (and before the pre & post linking functions for the directives on this 
	        element). This is a good place to put initialization code for your controller.
	      */
	      // this.element.addEventListener('drag',e=>{
	      //     console.log(angular.element(e.target).controller('fbLi').value.displayName)
	
	      // })
	      /*this.element.addEventListener('dragend',this.dragEnd)
	      this.element.addEventListener('drag',e=>{
	        if (this.source !== e.target) {
	          this.source = e.target
	        }
	      })
	      this.element.addEventListener('dragover',e=>{
	        e.dataTransfer.setData('text','')
	        e.dataTransfer.effectAllowed = 'copy'
	        e.dataTransfer.dropEffect = 'copy'
	      })
	      this.element.addEventListener('dragover',e=>{
	        if (this.target !== e.target) {
	          this.resetDrag()
	          e.target.classList.add('drop-target')
	          this.target = e.target
	        }
	        if (this.dropBelow !== e.offsetY > (e.target.offsetHeight/2)) {
	          this.dropBelow = e.offsetY > (e.target.offsetHeight/2)
	          e.target.classList[this.dropBelow?'add':'remove']('drop-below')
	          e.target.classList[this.dropBelow?'remove':'add']('drop-above')
	        }
	        
	      })*/
	      this.reset();
	    }
	  }, {
	    key: 'resetDrag',
	    value: function resetDrag() {
	      /*if(this.target){
	        this.target.classList.remove('drop-target')
	        this.target.classList.remove('drop-above')
	        this.target.classList.remove('drop-below')
	      } */
	    }
	  }, {
	    key: 'dragEnd',
	    value: function dragEnd(e) {
	      // remove item from existing position, then add it at new position
	      /*this.timeout(()=>{
	        const target = angular.element(this.source).controller('fbLi').value
	        const source = angular.element(this.target).controller('fbLi').value
	        this.spliceTree(this.values, target)
	        this.spliceTree(this.values, source, target, this.dropBelow)
	        this.resetDrag()
	      })*/
	    }
	  }, {
	    key: 'spliceTree',
	    value: function spliceTree(list, target, source, after) {
	      // return match, walk nested
	      for (var i = 0; i < list.length; i++) {
	        if (list[i].id === target.id) {
	          source ? list.splice(i + (after ? 1 : 0), 0, source) : list.splice(i, 1);
	          break;
	        } else if (list[i].children) {
	          this.spliceTree(list[i].children, target, source, after);
	        }
	      }
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      /*
	        Called on a controller when its containing scope is destroyed. 
	        Use this hook for releasing external resources, watches and event handlers.
	      */
	      this.element.removeEventListener('dragend', this.dragEnd);
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      /*
	        Called after this controller's element and its children have been linked. 
	        Similar to the post-link function this hook can be used to set up 
	        DOM event handlers and do direct DOM manipulation. Note that child 
	        elements that contain templateUrl directives will not have been compiled 
	        and linked since they are waiting for their template to load 
	        asynchronously and their own compilation and linking has been suspended 
	        until that occurs. This hook can be considered analogous to the 
	        ngAfterViewInit and ngAfterContentInit hooks in Angular 2. Since the 
	        compilation process is rather different in Angular 1 there is no direct 
	        mapping and care should be taken when upgrading.
	      */
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changesObj) {
	      /*
	        Called whenever one-way bindings are updated. The changesObj is a hash 
	        whose keys are the names of the bound properties that have changed, and 
	        the values are an object of the form 
	        { currentValue, previousValue, isFirstChange() }. 
	        Use this hook to trigger updates within a component such as cloning the 
	        bound value to prevent accidental mutation of the outer value.
	      */
	      this.reset();
	    }
	  }, {
	    key: 'setSelected',
	    value: function setSelected(id) {
	      this.selectedId = id;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.dragTarget = {};
	      this.selected = {};
	      this.editMode = false;
	      this.newValue = this.value;
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      if (this.newValue !== this.value && this.newValue.length) {
	        this.onUpdate({ newValue: this.newValue }).then(function () {
	          _this.reset();
	        });
	      } else {
	        this.reset();
	      }
	    }
	  }, {
	    key: 'setEditMode',
	    value: function setEditMode(setOl) {
	      var _this2 = this;
	
	      if (setOl) {
	        this.editMode = true;
	
	        var width = this.element.querySelector('.editable-text').offsetWidth;
	        this.element.querySelector('.editable-field').style.width = width + 'px';
	        this.timeout(function () {
	          return _this2.element.querySelector('input').focus();
	        });
	      }
	    }
	  }, {
	    key: 'create',
	    value: function create(displayName, parent) {
	      return this.onCreate({ displayName: displayName, parent: parent });
	    }
	  }, {
	    key: 'update',
	    value: function update(newValue) {
	      return this.onUpdate({ newValue: newValue });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(value) {
	      this.onSelect({ value: value });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(value) {
	      this.onDelete({ value: value });
	    }
	  }, {
	    key: 'toggleBookmark',
	    value: function toggleBookmark(event, value, parent) {
	      event.stopPropagation();
	      this.onToggleBookmark({ value: value, parent: parent });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.stopImmediatePropagation();
	      e.preventDefault();
	      switch (e.type) {
	        case 'blur':
	          this.submit();
	          break;
	        case 'keyup':
	          switch (e.keyCode) {
	            case 27:
	              this.reset();
	              break;
	            case 13:
	              this.submit();
	              break;
	          }
	      }
	    }
	  }]);
	  return fbOlCtrl;
	}();
	
	exports.default = fbOlCtrl;
	
	fbOlCtrl.$inject = ['$element', '$timeout'];

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OnDelete() {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      element.bind('keydown keypress', function (event) {
	        if (event.which === 8) {
	          scope.$eval(attrs.fbOnDelete);
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      });
	    }
	  };
	}
	
	exports.default = _angular2.default.module('directives.on-delete', []).directive('fbOnDelete', OnDelete).name;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _caseMap = __webpack_require__(218);
	
	var _caseMap2 = _interopRequireDefault(_caseMap);
	
	var _clio = __webpack_require__(162);
	
	var _clio2 = _interopRequireDefault(_clio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lfCaseListCtrl = function () {
	  function lfCaseListCtrl($scope, $location, CaseMap, Clio) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, lfCaseListCtrl);
	
	    this.caseMap = CaseMap;
	    this.location = $location;
	    this.clioServ = Clio;
	
	    this.caseMap.subscribe(function (data) {
	      _this.cases = CaseMap.toArray();
	    });
	    $scope.$on('displayCases', function (e, displayCases) {
	      _this.toggleCases(displayCases);
	    });
	
	    if (!(this.case && this.case.id)) {
	      this.toggleCases();
	    }
	
	    // CaseMap.api.get()
	  }
	
	  (0, _createClass3.default)(lfCaseListCtrl, [{
	    key: '$onChanges',
	    value: function $onChanges(d) {}
	  }, {
	    key: 'toggleCases',
	    value: function toggleCases() {
	      var displayCases = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      this.asideCasesVisible = displayCases === null ? !this.asideCasesVisible : displayCases;
	
	      if (this.asideCasesVisible) {
	        this.caseMap.api.get();
	      }
	    }
	  }, {
	    key: 'syncClio',
	    value: function syncClio() {
	      var _this2 = this;
	
	      if (this.clioSyncInProgress) {
	        return;
	      }
	      this.clioSyncInProgress = true;
	      this.clioServ.sync({}, function () {
	        return _this2.caseMap.api.get().then(function () {
	          _this2.clioSyncInProgress = false;
	        });
	      });
	    }
	  }, {
	    key: 'setCase',
	    value: function setCase(caseId) {
	      this.location.path('/' + (this.route || 'home') + '/' + caseId);
	      this.toggleCases(false);
	    }
	  }]);
	  return lfCaseListCtrl;
	}();
	
	lfCaseListCtrl.$inject = ['$scope', '$location', 'CaseMap', 'Clio'];
	
	function lfCaseList($location, CaseMap) {
	  return {
	    restrict: 'E',
	    template: __webpack_require__(834),
	    scope: {},
	    bindToController: {
	      case: '<',
	      account: '<',
	      route: '@'
	    },
	    controllerAs: '$ctrl',
	    controller: lfCaseListCtrl
	  };
	}
	lfCaseList.$inject = ['$location', 'CaseMap'];
	
	exports.default = _angular2.default.module('directives.lfCaseList', [_caseMap2.default, _clio2.default]).directive('lfCaseList', lfCaseList).name;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _version = __webpack_require__(224);
	
	var _version2 = _interopRequireDefault(_version);
	
	var _lfUpdateNotification = __webpack_require__(479);
	
	var _lfUpdateNotification2 = _interopRequireDefault(_lfUpdateNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UpdateNotification() {
		return {
			restrict: 'A',
			template: __webpack_require__(838),
			controller: _lfUpdateNotification2.default
		};
	}
	
	exports.default = _angular2.default.module('directives.lf-update-notification', [_version2.default]).directive('lfUpdateNotification', UpdateNotification).name;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _paymentStatus = __webpack_require__(223);
	
	var _paymentStatus2 = _interopRequireDefault(_paymentStatus);
	
	var _customer = __webpack_require__(135);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PaymentEnable($rootScope, PaymentStatusServ, CurrentCustomer) {
	  return {
	    restrict: 'A',
	    link: {
	      pre: function pre(scope, element, attrs) {
	        var payment = PaymentStatusServ;
	        var setClass = function setClass() {
	          payment.isExpired(attrs.paymentEnable) ? element.addClass('payment-disabled') : element.removeClass('payment-disabled');
	        };
	        // Customer model is updated async. Wait for it to be set.
	        if (attrs.paymentEnable === 'user') {
	          CurrentCustomer.subscribe(setClass);
	        } else {
	          setClass();
	        }
	
	        element.bind('click', function (e) {
	
	          if (payment.isExpired(attrs.paymentEnable)) {
	            e.stopImmediatePropagation();
	            e.preventDefault();
	            PaymentStatusServ.setExpiredMsg(attrs.paymentEnable);
	            $rootScope.$apply();
	          }
	        });
	      }
	    }
	  };
	}
	PaymentEnable.$inject = ['$rootScope', 'PaymentStatusServ', 'CurrentCustomer'];
	
	exports.default = _angular2.default.module('directives.payment-enable', [_paymentStatus2.default]).directive('paymentEnable', PaymentEnable).name;

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StatusMessageCtrl;
	StatusMessageCtrl.$inject = ['$scope', 'CurrentCase', 'Errors'];
	
	function StatusMessageCtrl($scope, CurrentCase, Errors) {
	
	  $scope.errors = Errors;
	
	  $scope.alertType = function (messages) {
	    var result = "alert";
	    if (messages.message) {
	      result += " alert-danger";
	    }
	    return result;
	  };
	
	  $scope.messageText = function (messages) {
	    var result = messages.message;
	    return result;
	  };
	
	  $scope.refreshCase = function () {
	    if (CurrentCase.data.id) {
	      CurrentCase.api.get();
	    }
	  };
	  $scope.removeNotification = function (msgs, url) {
	    delete msgs[url];
	  };
	};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _errors = __webpack_require__(116);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _version = __webpack_require__(224);
	
	var _version2 = _interopRequireDefault(_version);
	
	var _statusMessage = __webpack_require__(307);
	
	var _statusMessage2 = _interopRequireDefault(_statusMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function StatusNav() {
		return {
			restrict: 'A',
			template: __webpack_require__(841),
			controller: _statusMessage2.default
		};
	}
	
	exports.default = _angular2.default.module('directives.status-nav', [_case2.default, _errors2.default, _version2.default]).directive('statusNav', StatusNav).name;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TitlecaseFilter() {
	  return function (s) {
	    s = s === undefined || s === null ? '' : s;
	    return s.toString().toLowerCase().replace(/\b([a-z])/g, function (ch) {
	      return ch.toUpperCase();
	    });
	  };
	}
	
	exports.default = _angular2.default.module('filters.titlecase-filter', []).filter('titlecase', TitlecaseFilter).name;

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AccountSetupModalCtrl;
	AccountSetupModalCtrl.$inject = ['$rootScope', '$scope', 'CurrentAccount'];
	
	function AccountSetupModalCtrl($rootScope, $scope, CurrentAccount) {
	
	  $scope.currentAccount = CurrentAccount;
	
	  $scope.submitButtonStates = {
	    false: '',
	    true: 'Submitting... <i class="font-icon-sm icon-spinner icon-spin">'
	  };
	};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _statusRow = __webpack_require__(114);
	
	var _statusRow2 = _interopRequireDefault(_statusRow);
	
	var _accountSetup = __webpack_require__(310);
	
	var _accountSetup2 = _interopRequireDefault(_accountSetup);
	
	var _accountSetup3 = __webpack_require__(485);
	
	var _accountSetup4 = _interopRequireDefault(_accountSetup3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.account-setup', [_case2.default, _statusRow2.default]).controller('AccountSetupCtrl', _accountSetup2.default).constant('AccountSetupModalConf', _accountSetup4.default).name;

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AuthCodeModalCtrl;
	AuthCodeModalCtrl.$inject = ['$scope', '$uibModalInstance', 'CurrentUser', '$timeout', 'phone'];
	
	function AuthCodeModalCtrl($scope, $uibModalInstance, CurrentUser, $timeout, phone) {
	
	  $scope.error = null;
	  $scope.busy = false;
	  $scope.authCode = '';
	  $scope.phone = phone;
	
	  $timeout(function () {
	    document.querySelector('.modal-container').querySelector('input[name="authCode"]').focus();
	  });
	
	  $scope.verifyAuthCode = function () {
	    if ($scope.busy) return;
	    $scope.busy = true;
	    CurrentUser.api.verifyAuthCode(null, {
	      token: $scope.authCode
	    }).then(function () {
	      CurrentUser.api.get().then(function (data) {
	        $uibModalInstance.close(data);
	      });
	    }, function (response) {
	      $scope.busy = false;
	      document.querySelector('.modal-container').querySelector('input[name="authCode"]').focus();
	      $scope.error = response.data;
	    });
	  };
	};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _referral = __webpack_require__(507);
	
	var _referral2 = _interopRequireDefault(_referral);
	
	var _referral3 = __webpack_require__(506);
	
	var _referral4 = _interopRequireDefault(_referral3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modals.referral', [_referral2.default]).constant('ReferralModalConf', _referral4.default).name;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signin = __webpack_require__(322);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _statusRow = __webpack_require__(114);
	
	var _statusRow2 = _interopRequireDefault(_statusRow);
	
	var _signin3 = __webpack_require__(514);
	
	var _signin4 = _interopRequireDefault(_signin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modals.sign-in', [_signin2.default, _statusRow2.default]).run(['$templateCache', function ($templateCache) {
		$templateCache.put('/signin/signin.fields.html', __webpack_require__(365));
	}]).constant('SigninModalConf', _signin4.default).name;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(575);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _source = __webpack_require__(320);
	
	var _source2 = _interopRequireDefault(_source);
	
	var _sources = __webpack_require__(137);
	
	var _sources2 = _interopRequireDefault(_sources);
	
	var _account = __webpack_require__(75);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _box = __webpack_require__(323);
	
	var _box2 = _interopRequireDefault(_box);
	
	var _dropbox = __webpack_require__(325);
	
	var _dropbox2 = _interopRequireDefault(_dropbox);
	
	var _clio = __webpack_require__(162);
	
	var _clio2 = _interopRequireDefault(_clio);
	
	var _sourceInfo = __webpack_require__(163);
	
	var _sourceInfo2 = _interopRequireDefault(_sourceInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SourcesCtrl = function () {
	  function SourcesCtrl($scope, $routeParams, $filter, $sanitize, Source, SourcesTree, CurrentAccount, Box, Dropbox, $timeout, $q, SourceInfoServ, $parse, $httpParamSerializerJQLike, Clio) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SourcesCtrl);
	
	    // account.integrations.box.connected determines Box type visibility
	    this.scope = $scope;
	    this.q = $q;
	    this.routeParams = $routeParams;
	    this.account = CurrentAccount;
	    this.filterName = $filter('filter');
	    this.orderBy = $filter('orderBy');
	    this.boxServ = Box;
	    this.dropboxServ = Dropbox;
	    this.clioServ = Clio;
	    this.model = Source;
	    this.sourceInfo = SourceInfoServ;
	    this.paramSerializer = $httpParamSerializerJQLike;
	
	    // default view settings
	    this.searchQuery = '';
	    this.typeFilter = '';
	    this.sortFilter = '-id';
	
	    // declare dropdown state so it can be toggled programatically
	    this.newSourceDropdown = {
	      isOpen: false
	    };
	
	    // Source type metadata used for display
	    var sourceType;
	    this.sourceIntegrations = {};
	    this.sourceTypes = (0, _keys2.default)(SourceInfoServ.sourceTypes).map(function (key) {
	      sourceType = SourceInfoServ.sourceTypes[key];
	      sourceType.name = key;
	      if (sourceType.integration && !(sourceType.disabled = !$parse('integrations.' + key + '.connected')(_this.account.data))) {
	        _this.sourceIntegrations[key] = sourceType;
	        _this.setCurrentFolder({}, key);
	      }
	      return sourceType;
	    });
	
	    this.sourcesTree = SourcesTree;
	    this.getSources();
	    $scope.$on('$routeChangeSuccess', this.getSources);
	  }
	
	  (0, _createClass3.default)(SourcesCtrl, [{
	    key: 'getSources',
	    value: function getSources() {
	      var _this2 = this;
	
	      if (this && this.routeParams.caseId) {
	        this.sourcesTree.api.get().then(function () {
	          _this2.sourcesTree.setData(_this2.getLinks(_this2.sourcesTree.data));
	          _this2.filterSources();
	        });
	      }
	    }
	  }, {
	    key: 'getLinks',
	    value: function getLinks(sourcesTree) {
	      var _this3 = this;
	
	      sourcesTree.forEach(function (sourceType) {
	        if (sourceType.children) {
	          sourceType.children = sourceType.children.map(function (source) {
	            return _this3.sourceInfo.getLink(source.data, _this3.routeParams.caseId);
	          });
	        }
	      });
	      return sourcesTree;
	    }
	  }, {
	    key: 'setCurrentFolder',
	    value: function setCurrentFolder(folder, format) {
	      folder = folder || {};
	      format = format || this.selectedSource.format;
	
	      var integration = this.sourceIntegrations[format];
	      integration.currentFolder = integration.currentFolder || {};
	
	      if (integration.currentFolder.updating) {
	        return;
	      }
	      integration.currentFolder.updating = true;
	      ({
	        'box': this.boxServ,
	        'dropbox': this.dropboxServ,
	        'clio': this.clioServ
	      })[format].getFolder({
	        id: folder.id
	      }, function (data) {
	        // actual resources have different structure, don't forget
	        // to change for real data
	        integration.currentFolder = data;
	        integration.currentFolder.pathCollection = data.pathCollection.reverse();
	        integration.currentFolder.updating = false;
	      }, function () {
	        integration.currentFolder.name = 'Error';
	        integration.currentFolder.entries = [{
	          name: 'Could not connect to ' + integration.displayName
	        }];
	        integration.currentFolder.updating = false;
	      });
	    }
	  }, {
	    key: 'selectBoxItem',
	    value: function selectBoxItem(item, format) {
	      var _this4 = this;
	
	      format = format || this.selectedSource.format;
	
	      if (item.itemType === 'folder') {
	        this.setCurrentFolder(item, format);
	      } else if (item.itemType === 'file') {
	        var source = new this.model(item);
	        source.api[{
	          'box': 'linkBoxFile',
	          'dropbox': 'linkDropboxFile',
	          'clio': 'linkClioFile'
	        }[format]]().then(function (data) {
	          _this4.updateModel(data);
	        }, function (response) {});
	      }
	    }
	  }, {
	    key: 'toggleDropdown',
	
	
	    // used to toggle the new Source dropdown
	    value: function toggleDropdown(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.newSourceDropdown.isOpen = !this.newSourceDropdown.isOpen;
	    }
	  }, {
	    key: 'updateModel',
	    value: function updateModel(data, isUpdate) {
	      this.selectedSource = this.sourceInfo.getLink(data, this.routeParams.caseId);
	      this.setDetail(this.selectedSource);
	
	      var formatIndex = this.sourcesTree.data.map(function (sourceType) {
	        return sourceType.id;
	      }).indexOf(this.selectedSource.format);
	
	      if (formatIndex === -1) {
	        // For the first source of its format
	        this.sourcesTree.data.push({
	          id: data.format,
	          displayName: this.sourceInfo.sourceTypes[this.selectedSource.format].displayName,
	          children: [this.selectedSource]
	        });
	      } else {
	        // Add or replace data in tree
	        var sourceType = this.sourcesTree.data[formatIndex];
	        var index = sourceType.children.map(function (child) {
	          return child.id;
	        }).indexOf(this.selectedSource.id);
	        if (index === -1) {
	          sourceType.children.push(this.selectedSource);
	        } else {
	          sourceType.children[index] = this.selectedSource;
	        }
	      }
	
	      this.toggle(this.selectedSource);
	      // the source list should be refreshed if updating a source.
	      // the filtered list should contain the new source after adding,
	      // regardless of filtering - temporarily add the new source onto
	      // the filtered list.
	      if (isUpdate) {
	        this.filterSources();
	      } else if (!this.filteredSources.some(function (source) {
	        // test if new source is in filtered list
	        // special-case (when re-uploading a file)
	        return source.id === data.id;
	      })) {
	
	        this.filteredSources.unshift(data);
	      }
	    }
	  }, {
	    key: 'addFiles',
	    value: function addFiles(files) {
	      var _this5 = this;
	
	      files.forEach(function (file) {
	        return _this5.updateModel(file);
	      });
	    }
	  }, {
	    key: 'saveSource',
	    value: function saveSource() {
	      var _this6 = this;
	
	      this.detail.updating = true;
	
	      // Set the note displayName to note text (until used throughout app)
	      if (this.selectedSource.format === 'note') {
	        this.selectedSource.displayName = this.selectedSource.text;
	      }
	
	      var newSource = new this.model(this.selectedSource);
	
	      if (newSource.data.id) {
	        var promise = newSource.api.update();
	        promise.then(function (data) {
	          _this6.updateModel(data, true);
	        }, function (r) {
	          _this6.detail.error = r.data.data;
	          _this6.detail.updating = false;
	        });
	        return promise;
	      } else {
	        var _promise = newSource.api.create({}, this.paramSerializer(newSource.data));
	        _promise.then(function (data) {
	          for (var i = 0; i < data.sources.length; i++) {
	            _this6.updateModel(data.sources[i]);
	          }
	        }, function (r) {
	          _this6.detail.error = r.data.data;
	          _this6.detail.updating = false;
	        });
	        return _promise;
	      }
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      // fb-source-selector component method
	      this.reset();
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changesObj) {
	      this.reset();
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      // fb-source-selector component method
	      this.newValue = this.value ? _angular2.default.copy(this.value) : [];
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(value) {
	      // fb-source-selector component method
	      var index = this.newValue.map(function (i) {
	        return i.id;
	      }).indexOf(value.id);
	      if (index >= 0) {
	        this.newValue.splice(index, 1);
	      } else {
	        this.newValue.push(value);
	      }
	      if (this.onUpdate) {
	        this.onUpdate({ newValue: this.newValue });
	      }
	    }
	  }, {
	    key: 'addBookmark',
	    value: function addBookmark(displayName, parent) {
	      // fb-source-selector component method
	      // called from fb-li-select, with source object passed as parent
	      var deferred = this.q.defer(); // promise for fb-li-select flow
	
	      // ensure displayName is valid, otherwise return rejected promise
	      var match = displayName.replace(/\s/g, '').match(/\d+(-\d+)?/g);
	      var page = match ? match[0] : null;
	
	      if (!page) {
	        deferred.reject();
	        return deferred.promise;
	      }
	
	      // update newValue, since bookmarks is an object property (unwatched)
	      this.reset();
	
	      // find the index of the source we are adding bookmarks to
	      var index = this.newValue.map(function (i) {
	        return i.id;
	      }).indexOf(parent.id);
	
	      // get or create the array of bookmarks
	      var bookmarks = index >= 0 ? this.newValue[index].bookmarks : [];
	      bookmarks = bookmarks || []; // ensure we have an array to push to
	      var bIndex = bookmarks.map(function (b) {
	        return b.page;
	      }).indexOf(page);
	      // add bookmark if not present
	      if (bIndex === -1) {
	        bookmarks.push({ page: page });
	      }
	      // add source if not selected
	      if (index === -1) {
	        this.newValue.push((0, _extends3.default)({}, parent, { bookmarks: bookmarks }));
	      } else {
	        this.newValue[index].bookmarks = bookmarks;
	      }
	
	      this.onUpdate({ newValue: this.newValue });
	
	      deferred.resolve();
	      return deferred.promise;
	    }
	  }, {
	    key: 'removeBookmark',
	    value: function removeBookmark(value, parent) {
	      // fb-source-selector component method
	      // get latest, since bookmarks is an obj prop, not an obj in wathed array
	      // called from fb-li, so source passed as parent, value is {page}
	      this.reset();
	
	      var index = this.newValue.map(function (i) {
	        return i.id;
	      }).indexOf(parent.id);
	
	      var bookmarks = this.newValue[index].bookmarks;
	      var bIndex = bookmarks.map(function (b) {
	        return b.page;
	      }).indexOf(value.page);
	
	      if (bIndex !== -1) {
	        bookmarks.splice(bIndex, 1);
	      }
	
	      this.newValue[index].bookmarks = bookmarks;
	
	      this.onUpdate({ newValue: this.newValue });
	    }
	  }, {
	    key: 'deleteSource',
	    value: function deleteSource(data) {
	      var _this7 = this;
	
	      if (window.confirm('Are you sure you want to delete ' + data.displayName + '?')) {
	
	        this.detail.updating = true;
	
	        var source = new this.model(data);
	        source.api.delete().then(function () {
	          // select the next Source in filtered Sources
	          var index = _this7.filteredSources.indexOf(_this7.selectedSource);
	
	          _this7.sourcesTree.remove(data);
	
	          _this7.filterSources();
	          _this7.setDetail(_this7.filteredSources[index]);
	
	          // focus the list item in the ui to reflect selected state
	          // $timeout(function () {
	          _angular2.default.element('#source-manager-list .active').focus();
	          // });
	        }, function () {
	          this.detail.updating = false;
	        });
	      }
	    }
	  }, {
	    key: 'selectDefault',
	    value: function selectDefault() {
	      // keep selection if selected Source is in filtered Sources
	      // otherwise set selected Source to first in filtered Sources
	      this.setDetail(this.filteredSources.indexOf(this.selectedSource) !== -1 ? this.selectedSource : this.filteredSources[0]);
	    }
	  }, {
	    key: 'getDetailPanel',
	    value: function getDetailPanel() {
	      // let panel = angular.element('#source-selector-sidebar-container');
	      // return {
	      //   element: panel,
	      //   background: panel.find('> .sidebar-background'),
	      //   list: panel.find('> .source-selector-sidebar')
	      // };
	    }
	  }, {
	    key: 'showDetailPanel',
	    value: function showDetailPanel() {
	      //   let panel = this.getDetailPanel();
	      //   panel.element.show();
	      //   panel.list.animate({
	      //     right: 0
	      //   });
	      //   panel.background.fadeIn();
	    }
	  }, {
	    key: 'hideDetailPanel',
	    value: function hideDetailPanel() {
	      // let panel = this.getDetailPanel();
	      // panel.background.fadeOut('fast');
	      // panel.list.animate({
	      //   right: '-30rem'
	      // }, () => {
	      //   panel.element.hide();
	      // });
	    }
	  }, {
	    key: 'setDetail',
	    value: function setDetail(source) {
	      // set the detail view to (new) Source
	
	      this.selectedSource = source && source.data ? source.data : source;
	      // keep a backup if user cancels edit after making changes
	      this.backupSource = _angular2.default.copy(source);
	
	      // newSource: detail view should show 'new'-specific fields
	      // editMode: detail view should show editable fields
	      this.detail = source && {
	        icon: this.filterName(this.sourceTypes, {
	          name: source.format
	        })[0].icon,
	        template: '/modals/sources/detail.' + source.format + '.html',
	        newSource: !source.id,
	        editMode: !source.id,
	        updating: false
	      };
	      if (source && this.detail.newSource) {
	        // this.showDetailPanel();
	      } else {
	        this.hideDetailPanel();
	      }
	    }
	  }, {
	    key: 'cancelDetail',
	    value: function cancelDetail() {
	      if (this.selectedSource.id) {
	        // cancel should reset detail to selected Source when editing
	        this.updateModel(this.backupSource, true);
	      } else {
	        // cancel should select default source when adding new
	        this.selectDefault();
	      }
	    }
	  }, {
	    key: 'newSource',
	    value: function newSource(selectedFormat) {
	      if (this.typeFilter) {
	        // the type filter should match the new Source's type
	        this.setTypeFilter(selectedFormat, true);
	      }
	
	      // set the detail with the new Source
	      this.setDetail({
	        format: selectedFormat
	      });
	
	      // $timeout(function () {
	      // New Source should be scrolled to if it is above view
	      // angular.element('#source-selector-list > .selector-list').animate({
	      //   scrollTop: 0
	      // });
	      // });
	    }
	  }, {
	    key: 'setTypeFilter',
	    value: function setTypeFilter(name, isNewSource) {
	      this.typeFilter = name;
	      this.filterSources(isNewSource);
	    }
	  }, {
	    key: 'setSearchFilter',
	    value: function setSearchFilter(search) {
	      this.searchQuery = search;
	      this.filterSources();
	    }
	  }, {
	    key: 'setSortFilter',
	    value: function setSortFilter(sortBy) {
	      // sort by sources id (last added), or by sortBy (+/- displayName)
	      if (this.sortFilter === sortBy) {
	        this.sortFilter = '-id';
	      } else {
	        this.sortFilter = sortBy;
	      }
	      this.filterSources();
	    }
	  }, {
	    key: 'filterSources',
	    value: function filterSources(isNewSource) {
	      var _this8 = this;
	
	      // convert object to array
	      this.filteredSources = new Array();
	      this.sourcesTree.data.filter(function (sourceType) {
	        return _this8.typeFilter ? sourceType.id === _this8.typeFilter : true;
	      }).forEach(function (sourceType) {
	        sourceType.children.forEach(function (child) {
	          child.format = sourceType.id;
	          _this8.filteredSources.push(child);
	        });
	      });
	
	      if (this.searchQuery) {
	        // filter by search query
	        this.filteredSources = this.filterName(this.filteredSources, {
	          displayName: this.searchQuery
	        });
	      }
	      // order by sortFilter
	      this.filteredSources = this.orderBy(this.filteredSources, this.sortFilter);
	      if (!isNewSource) {
	        // select default Source to open in detail panel
	        this.selectDefault();
	      }
	    }
	  }]);
	  return SourcesCtrl;
	}();
	
	;
	SourcesCtrl.$inject = ['$scope', '$routeParams', '$filter', '$sanitize', 'Source', 'SourcesTree', 'CurrentAccount', 'Box', 'Dropbox', '$timeout', '$q', 'SourceInfoServ', '$parse', '$httpParamSerializerJQLike', 'Clio'];
	
	exports.default = _angular2.default.module('controllers.sources', [_source2.default, _sources2.default, _account2.default, _box2.default, _dropbox2.default, _clio2.default, _sourceInfo2.default]).controller('SourcesCtrl', SourcesCtrl).name;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _map = __webpack_require__(318);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _account = __webpack_require__(75);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AccountMapFactory(Account, BaseMap) {
		return function (_BaseMap) {
			(0, _inherits3.default)(AccountMap, _BaseMap);
	
			function AccountMap() {
				(0, _classCallCheck3.default)(this, AccountMap);
				return (0, _possibleConstructorReturn3.default)(this, (AccountMap.__proto__ || (0, _getPrototypeOf2.default)(AccountMap)).call(this, Account));
			}
	
			return AccountMap;
		}(BaseMap);
	}
	AccountMapFactory.$inject = ['Account', 'BaseMap'];
	
	exports.default = _angular2.default.module('maps.account', [_account2.default, _map2.default]).factory('AccountMapFactory', AccountMapFactory).service('AccountMap', ['AccountMapFactory', function (AccountMapFactory) {
		return new AccountMapFactory();
	}]).name;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IssueFactory(Model, AnalyticsServ) {
		return function (_Model) {
			(0, _inherits3.default)(IssueModel, _Model);
	
			function IssueModel() {
				var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				(0, _classCallCheck3.default)(this, IssueModel);
	
				var _this = (0, _possibleConstructorReturn3.default)(this, (IssueModel.__proto__ || (0, _getPrototypeOf2.default)(IssueModel)).call(this, data));
	
				_this.setApi("/case/:caseId/issue/:issueId", {
					caseId: '@caseId',
					issueId: '@id'
				}, {
					'list': {
						method: 'GET',
						url: '/case/:caseId/issues',
						isArray: true
					},
					'create': {
						method: 'POST',
						success: [function (data) {
							return _this.setData(data);
						}, function (data) {
							return AnalyticsServ.added('Issue');
						}]
					},
					'read': {
						method: 'GET'
					},
					'update': {
						method: 'PUT',
						success: [function (data) {
							return _this.setData(data);
						}, function (data) {
							return AnalyticsServ.updated('Issue');
						}]
					},
					'delete': {
						method: 'DELETE',
						success: [function (data) {
							return _this.setData(data);
						}, function (data) {
							return AnalyticsServ.removed('Issue');
						}],
						headers: {
							'x-lynx-confirmationCode': function xLynxConfirmationCode() {
								return _this.getData().confirmationCode;
							}
						},
						fail: [function (response) {
							_this.data.confirmationCode = response.data.confirmationCode;
							_this.fail(response);
						}]
					}
				});
				return _this;
			}
	
			return IssueModel;
		}(Model);
	}
	
	IssueFactory.$inject = ['Model', 'AnalyticsServ'];
	
	exports.default = _angular2.default.module('models.issue', [_model2.default, _analytics2.default]).factory('Issue', IssueFactory).name;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _from = __webpack_require__(571);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _map = __webpack_require__(574);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MapFactory(Model) {
		return function (_Model) {
			(0, _inherits3.default)(BaseMap, _Model);
	
			function BaseMap(dataModel) {
				(0, _classCallCheck3.default)(this, BaseMap);
	
				var _this = (0, _possibleConstructorReturn3.default)(this, (BaseMap.__proto__ || (0, _getPrototypeOf2.default)(BaseMap)).call(this, new _map2.default()));
	
				_this.model = dataModel;
				return _this;
			}
	
			(0, _createClass3.default)(BaseMap, [{
				key: 'fromCollection',
				value: function fromCollection(collection) {
					var _this2 = this;
	
					this.data.clear();
					(0, _keys2.default)(collection).forEach(function (key) {
						_this2.data.set(key, new _this2.model(collection[key]));
					});
					this.setData();
					return this.data;
				}
			}, {
				key: 'toCollection',
				value: function toCollection() {}
			}, {
				key: 'toArray',
				value: function toArray() {
					return (0, _from2.default)(this.data.values()).map(function (val) {
						return val.data;
					});
				}
			}, {
				key: 'set',
				value: function set(item) {
					this.data.set(item.id, item);
				}
			}, {
				key: 'get',
				value: function get(id) {
					return this.data.get(id);
				}
			}]);
			return BaseMap;
		}(Model);
	}
	MapFactory.$inject = ['Model'];
	
	exports.default = _angular2.default.module('maps.base', [_model2.default]).factory('BaseMap', MapFactory).name;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MemberFactory(Model, AnalyticsServ) {
	  return function (_Model) {
	    (0, _inherits3.default)(MemberModel, _Model);
	
	    function MemberModel() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      (0, _classCallCheck3.default)(this, MemberModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (MemberModel.__proto__ || (0, _getPrototypeOf2.default)(MemberModel)).call(this, data));
	
	      _this.setApi('/customer/user/:memberId', {
	        memberId: '@id'
	      }, {
	        add: {
	          method: 'POST',
	          isArray: true,
	          params: {
	            newUser: function newUser() {
	              return _this.getData().newUser || false;
	            }
	          },
	          success: [function (data) {
	            return _this.setData(data);
	          }, function () {
	            return AnalyticsServ.added('Member');
	          }],
	          fail: [function (r) {
	            if (r.status === 404) {
	              _this.data.newUser = true;
	              _this.error = {};
	            } else {
	              _this.fail(r);
	            }
	          }]
	        },
	        update: {
	          method: 'PUT',
	          isArray: true,
	          success: [function () {
	            return _this.setData();
	          }, function () {
	            return AnalyticsServ.updated('Member');
	          }]
	        },
	        remove: {
	          method: 'DELETE',
	          isArray: true,
	          success: [function () {
	            return _this.setData();
	          }, function () {
	            return AnalyticsServ.removed('Member');
	          }]
	        }
	      });
	      return _this;
	    }
	
	    return MemberModel;
	  }(Model);
	}
	
	MemberFactory.$inject = ['Model', 'AnalyticsServ'];
	
	exports.default = _angular2.default.module('models.member', [_model2.default, _analytics2.default]).factory('Member', MemberFactory).name;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SourceFactory(Model, AnalyticsServ) {
		return function (_Model) {
			(0, _inherits3.default)(SourceModel, _Model);
	
			function SourceModel() {
				var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
				(0, _classCallCheck3.default)(this, SourceModel);
	
				var _this = (0, _possibleConstructorReturn3.default)(this, (SourceModel.__proto__ || (0, _getPrototypeOf2.default)(SourceModel)).call(this, data));
	
				_this.setApi("/case/:caseId/source/:sourceId", {
					caseId: '@caseId',
					sourceId: '@id'
				}, {
					'create': {
						method: 'POST',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
						},
						success: [function (data) {
							return _this.setData(data);
						}, function (data) {
							return AnalyticsServ.added('Source', {
								'Source Format': data.format
							});
						}]
					},
					'linkBoxFile': {
						url: '/case/:caseId/source/link/boxFile',
						method: 'PUT',
						success: [function (data) {
							return _this.setData(data);
						}, function (data) {
							return AnalyticsServ.added('Source', {
								'Source Format': data.format
							});
						}]
					},
					'linkDropboxFile': {
						url: '/case/:caseId/source/link/dropboxFile',
						method: 'PUT',
						success: [function (data) {
							return _this.setData(data);
						}, function (data) {
							return AnalyticsServ.added('Source', {
								'Source Format': data.format
							});
						}]
					},
					'linkClioFile': {
						url: '/case/:caseId/source/link/clioFile',
						method: 'PUT',
						success: [function (data) {
							return _this.setData(data);
						}, function (data) {
							return AnalyticsServ.added('Source', {
								'Source Format': data.format
							});
						}]
					},
					'update': {
						method: 'PUT',
						success: [function (data) {
							return _this.setData(data);
						}, function (data) {
							return AnalyticsServ.updated('Source');
						}]
					},
					'delete': {
						method: 'DELETE',
						success: [function () {
							return _this.setData();
						}, function () {
							return AnalyticsServ.removed('Source');
						}]
					}
				});
				return _this;
			}
	
			return SourceModel;
		}(Model);
	}
	SourceFactory.$inject = ['Model', 'AnalyticsServ'];
	
	exports.default = _angular2.default.module('models.source', [_model2.default, _analytics2.default]).factory('Source', SourceFactory).name;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TagFactory(Model, AnalyticsServ) {
	  return function (_Model) {
	    (0, _inherits3.default)(TagModel, _Model);
	
	    function TagModel() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      (0, _classCallCheck3.default)(this, TagModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (TagModel.__proto__ || (0, _getPrototypeOf2.default)(TagModel)).call(this, data));
	
	      _this.setApi('/case/:caseId/tag/:tagId', {
	        tagId: '@id',
	        caseId: '@caseId'
	      }, {
	        'create': {
	          method: 'POST',
	          success: [function (data) {
	            return _this.setData(data);
	          }, function (data) {
	            return AnalyticsServ.added('Tag');
	          }]
	        },
	        'update': {
	          method: 'PUT',
	          success: [function (data) {
	            return _this.setData(data);
	          }, function (data) {
	            return AnalyticsServ.updated('Tag');
	          }]
	        },
	        'delete': {
	          method: 'DELETE',
	          success: [function () {
	            return _this.setData();
	          }, function () {
	            return AnalyticsServ.removed('Tag');
	          }]
	        }
	      });
	      return _this;
	    }
	
	    return TagModel;
	  }(Model);
	}
	TagFactory.$inject = ['Model', 'AnalyticsServ'];
	
	exports.default = _angular2.default.module('models.tag', [_model2.default, _analytics2.default]).factory('Tag', TagFactory).name;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signin = __webpack_require__(551);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _signin3 = __webpack_require__(550);
	
	var _signin4 = _interopRequireDefault(_signin3);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lwPageFooter = __webpack_require__(88);
	
	var _lwPageFooter2 = _interopRequireDefault(_lwPageFooter);
	
	var _headerNav = __webpack_require__(87);
	
	var _headerNav2 = _interopRequireDefault(_headerNav);
	
	var _statusRow = __webpack_require__(114);
	
	var _statusRow2 = _interopRequireDefault(_statusRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.signin', [_user2.default, _lwPageFooter2.default, _headerNav2.default, _statusRow2.default]).run(['$templateCache', function ($templateCache) {
	  $templateCache.put('/signin/signin.fields.html', __webpack_require__(365));
	}]).config(_signin2.default).controller('SigninCtrl', _signin4.default).name;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularResource = __webpack_require__(62);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BoxServ($resource) {
		return $resource("/account/box", {
			id: '@id'
		}, {
			'getFolder': {
				method: 'GET',
				url: '/account/box/folder'
			},
			'getFile': {
				method: 'GET',
				url: '/account/box/file'
			},
			'disconnect': {
				method: 'DELETE'
			}
		});
	}
	BoxServ.$inject = ['$resource'];
	
	exports.default = _angular2.default.module('services.box', [_angularResource2.default]).factory('Box', BoxServ).name;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DateParserServ = undefined;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _nearley = __webpack_require__(809);
	
	var _dateParser = __webpack_require__(808);
	
	var _dateParser2 = _interopRequireDefault(_dateParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateProperties = ['year', 'month', 'date', 'hour', 'minute', 'second'];
	var monthShortNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
	var dayNames = ['sun', 'mon', 'tues', 'wed', 'thurs', 'fri', 'sat'];
	
	var tests = {
	  year: function year(y, time) {
	    return 1000 <= y && y <= 9999;
	  },
	  month: function month(m, time) {
	    return time && m - 1 === time.getMonth();
	  },
	  date: function date(d, time) {
	    return time && d === time.getDate();
	  },
	  hour: function hour(d, time) {
	    return time && d === time.getHours();
	  },
	  minute: function minute(d, time) {
	    return time && d === time.getMinutes();
	  },
	  second: function second(d, time) {
	    return time && d === time.getSeconds();
	  }
	};
	
	var DateParserServ = exports.DateParserServ = function () {
	  function DateParserServ() {
	    (0, _classCallCheck3.default)(this, DateParserServ);
	  }
	
	  (0, _createClass3.default)(DateParserServ, [{
	    key: 'transformHour',
	    value: function transformHour(date) {
	      if (!date) return;
	
	      if (date.hour) {
	        date.hour = date.hour % 12;
	      }
	      if (date.meridian) {
	        if (date.meridian === 'pm') {
	          date.hour += 12;
	        }
	        delete date.meridian;
	      }
	
	      return date;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(input) {
	      var parser = new _nearley.Parser(_dateParser2.default);
	      var dateObjs;
	      try {
	        // return new parser every time (current recommended method)
	        dateObjs = parser.feed(input.toLowerCase()).results[0] || [];
	      } catch (e) {
	        var token = e.token;
	
	        var value;
	        var offset;
	        if (token) {
	          value = token.value;
	          offset = token.offset;
	        } else {
	          value = e.message;
	        }
	        return [{ error: { value: value, offset: offset } }];
	      }
	      return dateObjs.map(this.transformHour.bind(this));
	    }
	  }, {
	    key: 'fromFactDateish',
	    value: function fromFactDateish(factDateish) {
	      // expects a fact dateish
	      var dateObjs = [];
	      if (factDateish) {
	        dateObjs.push(factDateish);
	
	        if (factDateish.factEndDateish) {
	          dateObjs.push(factDateish.factEndDateish);
	        }
	      }
	
	      return dateObjs;
	    }
	  }, {
	    key: 'toFactDateish',
	    value: function toFactDateish(dateObjs) {
	      // expects caller to merge returned object
	      var factDateish;
	      if (dateObjs[0]) {
	        factDateish = dateObjs[0];
	
	        if (dateObjs[1]) {
	          factDateish.factEndDateish = dateObjs[1];
	        } else if (factDateish.factEndDateish) {
	          delete factDateish.factEndDateish;
	        }
	      }
	
	      return factDateish;
	    }
	  }, {
	    key: 'validateDateObj',
	    value: function validateDateObj(d) {
	      if (!d || d && d.error) {
	        return false;
	      }
	      var time = d.year ? d.month ? d.date ? this.isNumber(d.hour) ? this.isNumber(d.minute) ? this.isNumber(d.second) ? new Date(d.year, d.month - 1, d.date, d.hour, d.minute, d.second) : new Date(d.year, d.month - 1, d.date, d.hour, d.minute) : new Date(d.year, d.month - 1, d.date, d.hour) : new Date(d.year, d.month - 1, d.date) : new Date(d.year, d.month - 1) : new Date(d.year) : null;
	
	      return dateProperties.filter(function (val) {
	        return (/\d/.test(d[val])
	        );
	      }).every(function (val) {
	        return tests[val](d[val], time);
	      });
	    }
	  }, {
	    key: 'validate',
	    value: function validate(dateObjs) {
	      if (dateObjs && dateObjs.length) {
	        return dateObjs.every(this.validateDateObj.bind(this));
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'capitalize',
	    value: function capitalize(s) {
	      return s.charAt(0).toUpperCase() + s.slice(1);
	    }
	  }, {
	    key: 'isNumber',
	    value: function isNumber(n) {
	      return typeof n === 'number';
	    }
	  }, {
	    key: 'zeroPad',
	    value: function zeroPad(n) {
	      // digits set to 2 (for month and date)
	      return Math.pow(10, Math.max(0, 2 - n.toString().length)).toString().substr(1) + n;
	    }
	  }, {
	    key: 'getComparator',
	    value: function getComparator(value) {
	      switch (value) {
	        case -1:
	          return 'before';
	        case 1:
	          return 'after';
	        default:
	          return value;
	      }
	    }
	  }, {
	    key: 'getHour',
	    value: function getHour(hour) {
	      return hour % 12 || 12;
	    }
	  }, {
	    key: 'getClock',
	    value: function getClock(hour) {
	      return hour > 11 ? 'pm' : 'am';
	    }
	  }, {
	    key: 'getDay',
	    value: function getDay(_ref) {
	      var year = _ref.year,
	          month = _ref.month,
	          date = _ref.date;
	
	      return this.capitalize(dayNames[new Date(year + '-' + this.zeroPad(month) + '-' + this.zeroPad(date)).getUTCDay()]);
	    }
	  }, {
	    key: 'formatDateItem',
	    value: function formatDateItem(type, value) {
	      switch (type) {
	        case 'month':
	          return this.capitalize(monthShortNames[value - 1]);
	        case 'hour':
	          return this.getHour(value);
	        case 'minute':
	        case 'second':
	          return this.zeroPad(value);
	        case 'clock':
	          return this.getClock(value);
	        case 'day':
	          return this.getDay(value);
	        case 'year':
	        case 'date':
	        default:
	          return value;
	      }
	    }
	  }, {
	    key: 'getDateString',
	    value: function getDateString(dateObj) {
	      var _this = this;
	
	      var comparator = dateObj.comparator,
	          year = dateObj.year,
	          month = dateObj.month,
	          date = dateObj.date,
	          hour = dateObj.hour,
	          minute = dateObj.minute,
	          second = dateObj.second;
	
	      var comparatorStr = comparator ? this.capitalize(this.getComparator(comparator)) + ' ' : '';
	
	      var getVal = function getVal(k, override) {
	        return _this.formatDateItem(k, dateObj[override || k]);
	      };
	
	      var dateStr = year ? month ? date ? this.isNumber(hour) ? this.isNumber(minute) ? this.isNumber(second) ? this.formatDateItem('day', dateObj) + ' ' + getVal('month') + ' ' + getVal('date') + ', ' + getVal('year') + ' at ' + getVal('hour') + ':' + getVal('minute') + ':' + getVal('second') + getVal('clock', 'hour') : this.formatDateItem('day', dateObj) + ' ' + getVal('month') + ' ' + getVal('date') + ', ' + getVal('year') + ' at ' + getVal('hour') + ':' + getVal('minute') + getVal('clock', 'hour') : this.formatDateItem('day', dateObj) + ' ' + getVal('month') + ' ' + getVal('date') + ', ' + getVal('year') + ' at ' + getVal('hour') + getVal('clock', 'hour') : this.formatDateItem('day', dateObj) + ' ' + getVal('month') + ' ' + getVal('date') + ', ' + getVal('year') : getVal('month') + ' ' + getVal('year') : '' + getVal('year') : null;
	      return comparatorStr + dateStr;
	    }
	  }, {
	    key: 'format',
	    value: function format(dateObjs) {
	      return dateObjs.map(this.getDateString.bind(this)).join(' - ');
	    }
	  }]);
	  return DateParserServ;
	}();
	
	exports.default = _angular2.default.module('services.date-parser', []).service('DateParserServ', DateParserServ).name;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularResource = __webpack_require__(62);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropboxServ($resource) {
		return $resource("/account/dropbox", {
			id: '@id'
		}, {
			'getFolder': {
				method: 'GET',
				url: '/account/dropbox/folder'
			},
			'getFile': {
				method: 'GET',
				url: '/account/dropbox/file'
			},
			'disconnect': {
				method: 'DELETE'
			}
		});
	}
	DropboxServ.$inject = ['$resource'];
	
	exports.default = _angular2.default.module('services.dropbox', [_angularResource2.default]).factory('Dropbox', DropboxServ).name;

/***/ }),
/* 326 */
99,
/* 327 */
[931, 54, 23],
/* 328 */
[933, 32],
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(31);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 330 */
[961, 26],
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(50);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(28);
	var toAbsoluteIndex = __webpack_require__(108);
	var toLength = __webpack_require__(22);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 333 */
[913, 100],
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(35);
	var toObject = __webpack_require__(28);
	var IObject = __webpack_require__(150);
	var toLength = __webpack_require__(22);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(35);
	var isObject = __webpack_require__(12);
	var invoke = __webpack_require__(341);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 336 */
[919, 21, 102, 106, 51, 99, 100, 270, 344, 107, 20, 83, 123],
/* 337 */
[920, 149, 333],
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(106);
	var getWeak = __webpack_require__(83).getWeak;
	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(12);
	var anInstance = __webpack_require__(99);
	var forOf = __webpack_require__(100);
	var createArrayMethod = __webpack_require__(56);
	var $has = __webpack_require__(40);
	var validate = __webpack_require__(123);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(172);
	var isObject = __webpack_require__(12);
	var toLength = __webpack_require__(22);
	var ctx = __webpack_require__(51);
	var IS_CONCAT_SPREADABLE = __webpack_require__(14)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 340 */
[929, 20, 11, 263],
/* 341 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(12);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 343 */
[933, 8],
/* 344 */
166,
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(272);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 348 */
[938, 104, 176, 151, 28, 150, 11],
/* 349 */
[941, 21, 8, 104, 20],
/* 350 */
[943, 48, 103],
/* 351 */
[946, 40, 48, 168, 276],
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(104);
	var toIObject = __webpack_require__(48);
	var isEnum = __webpack_require__(151).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(103);
	var gOPS = __webpack_require__(176);
	var anObject = __webpack_require__(8);
	var Reflect = __webpack_require__(10).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(10).parseFloat;
	var $trim = __webpack_require__(122).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(280) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(10).parseInt;
	var $trim = __webpack_require__(122).trim;
	var ws = __webpack_require__(280);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(12);
	var newPromiseCapability = __webpack_require__(274);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(22);
	var repeat = __webpack_require__(279);
	var defined = __webpack_require__(58);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(60);
	var toLength = __webpack_require__(22);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 360 */
[963, 14],
/* 361 */
[968, 336, 123, 169],
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(20) && /./g.flags != 'g') __webpack_require__(21).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(171)
	});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(336);
	var validate = __webpack_require__(123);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(169)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(56)(0);
	var redefine = __webpack_require__(42);
	var meta = __webpack_require__(83);
	var assign = __webpack_require__(348);
	var weak = __webpack_require__(338);
	var isObject = __webpack_require__(12);
	var fails = __webpack_require__(11);
	var validate = __webpack_require__(123);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(169)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card card-red-tint\" ng-if=\"signin.user.error\">\n    <div ng-bind-html=\"signin.user.error.error\"></div>\n    <div><small ng-bind=\"signin.user.error.details\"></small></div>\n</div>\n<div class=\"card\" ng-class=\"{'error':'card-red-tint','info':'card-blue-tint','success':'card-green-tint'}[signin.sms.feedback.type]\" ng-if=\"signin.sms.feedback\">\n    <div ng-bind-html=\"signin.sms.feedback.message\"></div>\n</div>\n<div class=\"grid grid-gutters\">\n    <div class=\"grid-item field\" ng-class=\"signin.user.error.data.email.error ? 'field-error' : ''\">\n        <input type=\"email\" placeholder=\"Email\" name=\"email\" ng-model=\"signin.user.data.email\">\n    </div>\n</div>\n<div class=\"grid grid-gutters\">\n    <div class=\"grid-item field\" ng-class=\"signin.user.error.data.password.error ? 'field-error' : ''\">\n        <input type=\"password\" placeholder=\"Password\" name=\"password\" ng-model=\"signin.user.data.password\">\n    </div>\n</div>\n<div class=\"grid grid-gutters\" ng-show=\"signin.codeEntryVisible\">\n    <div class=\"grid-item field\" ng-class=\"signin.user.error.data.mfaCode.error ? 'field-error' : ''\">\n        <input type=\"text\" ng-model=\"signin.user.data.mfaCode\" name=\"mfaCode\" placeholder=\"Auth Code\">\n    </div>\n    <div class=\"grid-item grid-item-fixed\">\n        <span class=\"field-text\">or</span>\n    </div>\n    <div class=\"grid-item grid-item-fixed\">\n        <button class=\"btn btn-sm btn-blue\" type=\"button\" ng-click=\"signin.sendSMS(true)\" ng-disabled=\"signin.sms.busy || signin.sms.done\" ng-bind=\"signin.sms.busy ? 'Sending' : signin.sms.done ? 'Sent' : 'Send SMS'\"></button>\n    </div>\n</div>\n<div class=\"grid grid-gutters\">\n    <div class=\"grid-item grid-item-fixed\">\n        <button type=\"submit\" ng-disabled=\"signin.user.busy\" class=\"btn btn-green\" ng-bind=\"signin.user.busy ? 'Signing In' : 'Sign In'\"></button>\n    </div>\n    <div class=\"grid-item\">\n        <div class=\"field field-text\">\n            <label>\n                <input autofill type=\"checkbox\" class=\"remember-me\" ng-model=\"signin.user.data.rememberMe\"> Remember Me\n            </label>\n        </div>\n    </div>\n</div>\n<div class=\"grid\">\n    <div class=\"grid-item\">\n        <ul class=\"list-unstyled\" style=\"margin-bottom: 0\">\n            <li ng-hide=\"signin.codeEntryVisible\">\n                <a href=\"\" ng-click=\"signin.showCodeEntry()\">Two-factor Authentication</a>\n            </li>\n            <li>\n                <a href=\"#/forgot\" title=\"Forgot Password\">Forgot Password</a>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(417);
	__webpack_require__(419);
	__webpack_require__(414);
	
	var MODULE_NAME = 'ui.bootstrap.module.modal';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.modal', 'uib/template/modal/window.html']);
	
	module.exports = MODULE_NAME;


/***/ }),
/* 413 */
[911, 412],
/* 414 */
/***/ (function(module, exports) {

	angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	  .provider('$uibResolve', function() {
	    var resolve = this;
	    this.resolver = null;
	
	    this.setResolver = function(resolver) {
	      this.resolver = resolver;
	    };
	
	    this.$get = ['$injector', '$q', function($injector, $q) {
	      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	      return {
	        resolve: function(invocables, locals, parent, self) {
	          if (resolver) {
	            return resolver.resolve(invocables, locals, parent, self);
	          }
	
	          var promises = [];
	
	          angular.forEach(invocables, function(value) {
	            if (angular.isFunction(value) || angular.isArray(value)) {
	              promises.push($q.resolve($injector.invoke(value)));
	            } else if (angular.isString(value)) {
	              promises.push($q.resolve($injector.get(value)));
	            } else {
	              promises.push($q.resolve(value));
	            }
	          });
	
	          return $q.all(promises).then(function(resolves) {
	            var resolveObj = {};
	            var resolveIter = 0;
	            angular.forEach(invocables, function(value, key) {
	              resolveObj[key] = resolves[resolveIter++];
	            });
	
	            return resolveObj;
	          });
	        }
	      };
	    }];
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
	  function($animate, $injector, $modalStack) {
	    return {
	      restrict: 'A',
	      compile: function(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      }
	    };
	
	    function linkFn(scope, element, attrs) {
	      if (attrs.modalInClass) {
	        $animate.addClass(element, attrs.modalInClass);
	
	        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	          var done = setIsAsync();
	          if (scope.modalOptions.animation) {
	            $animate.removeClass(element, attrs.modalInClass).then(done);
	          } else {
	            done();
	          }
	        });
	      }
	    }
	  }])
	
	  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
	  function($modalStack, $q, $animateCss, $document) {
	    return {
	      scope: {
	        index: '@'
	      },
	      restrict: 'A',
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'uib/template/modal/window.html';
	      },
	      link: function(scope, element, attrs) {
	        element.addClass(attrs.windowTopClass || '');
	        scope.size = attrs.size;
	
	        scope.close = function(evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop &&
	            modal.value.backdrop !== 'static' &&
	            evt.target === evt.currentTarget) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	
	        // moved from template to fix issue #2280
	        element.on('click', scope.close);
	
	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;
	
	        // Deferred object that will be resolved when this modal is rendered.
	        var modalRenderDeferObj = $q.defer();
	        // Resolve render promise post-digest
	        scope.$$postDigest(function() {
	          modalRenderDeferObj.resolve();
	        });
	
	        modalRenderDeferObj.promise.then(function() {
	          var animationPromise = null;
	
	          if (attrs.modalInClass) {
	            animationPromise = $animateCss(element, {
	              addClass: attrs.modalInClass
	            }).start();
	
	            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	              var done = setIsAsync();
	              $animateCss(element, {
	                removeClass: attrs.modalInClass
	              }).start().then(done);
	            });
	          }
	
	
	          $q.when(animationPromise).then(function() {
	            // Notify {@link $modalStack} that modal is rendered.
	            var modal = $modalStack.getTop();
	            if (modal) {
	              $modalStack.modalRendered(modal.key);
	            }
	
	            /**
	             * If something within the freshly-opened modal already has focus (perhaps via a
	             * directive that causes focus) then there's no need to try to focus anything.
	             */
	            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	              var inputWithAutofocus = element[0].querySelector('[autofocus]');
	              /**
	               * Auto-focusing of a freshly-opened modal element causes any child elements
	               * with the autofocus attribute to lose focus. This is an issue on touch
	               * based devices which will show and then hide the onscreen keyboard.
	               * Attempts to refocus the autofocus element via JavaScript will not reopen
	               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	               * the modal element if the modal does not contain an autofocus element.
	               */
	              if (inputWithAutofocus) {
	                inputWithAutofocus.focus();
	              } else {
	                element[0].focus();
	              }
	            }
	          });
	        });
	      }
	    };
	  }])
	
	  .directive('uibModalAnimationClass', function() {
	    return {
	      compile: function(tElement, tAttrs) {
	        if (tAttrs.modalAnimation) {
	          tElement.addClass(tAttrs.uibModalAnimationClass);
	        }
	      }
	    };
	  })
	
	  .directive('uibModalTransclude', ['$animate', function($animate) {
	    return {
	      link: function(scope, element, attrs, controller, transclude) {
	        transclude(scope.$parent, function(clone) {
	          element.empty();
	          $animate.enter(clone, element);
	        });
	      }
	    };
	  }])
	
	  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
	    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
	    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var openedClasses = $$multiMap.createNew();
	      var $modalStack = {
	        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	      };
	      var topModalIndex = 0;
	      var previousTopOpenedModal = null;
	      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';
	
	      //Modal focus behavior
	      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
	        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
	        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
	      var scrollbarPadding;
	      var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	      // TODO: extract into common dependency with tooltip
	      function snake_case(name) {
	        var separator = '-';
	        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	          return (pos ? separator : '') + letter.toLowerCase();
	        });
	      }
	
	      function isVisible(element) {
	        return !!(element.offsetWidth ||
	          element.offsetHeight ||
	          element.getClientRects().length);
	      }
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	
	        // If any backdrop exist, ensure that it's index is always
	        // right below the top modal
	        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
	          topBackdropIndex = topModalIndex;
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance, elementToReceiveFocus) {
	        var modalWindow = openedWindows.get(modalInstance).value;
	        var appendToElement = modalWindow.appendTo;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	        previousTopOpenedModal = openedWindows.top();
	        if (previousTopOpenedModal) {
	          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
	        }
	
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
	          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	          openedClasses.remove(modalBodyClass, modalInstance);
	          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
	          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
	          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	            if (scrollbarPadding.originalRight) {
	              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
	            } else {
	              appendToElement.css({paddingRight: ''});
	            }
	            scrollbarPadding = null;
	          }
	          toggleTopWindowClass(true);
	        }, modalWindow.closedDeferred);
	        checkRemoveBackdrop();
	
	        //move focus to specified element if available, or else to body
	        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	          elementToReceiveFocus.focus();
	        } else if (appendToElement.focus) {
	          appendToElement.focus();
	        }
	      }
	
	      // Add or remove "windowTopClass" from the top window in the stack
	      function toggleTopWindowClass(toggleSwitch) {
	        var modalWindow;
	
	        if (openedWindows.length() > 0) {
	          modalWindow = openedWindows.top().value;
	          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	        }
	      }
	
	      function checkRemoveBackdrop() {
	        //remove backdrop if no longer needed
	        if (backdropDomEl && backdropIndex() === -1) {
	          var backdropScopeRef = backdropScope;
	          removeAfterAnimate(backdropDomEl, backdropScope, function() {
	            backdropScopeRef = null;
	          });
	          backdropDomEl = undefined;
	          backdropScope = undefined;
	        }
	      }
	
	      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	        var asyncDeferred;
	        var asyncPromise = null;
	        var setIsAsync = function() {
	          if (!asyncDeferred) {
	            asyncDeferred = $q.defer();
	            asyncPromise = asyncDeferred.promise;
	          }
	
	          return function asyncDone() {
	            asyncDeferred.resolve();
	          };
	        };
	        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	        // Note that it's intentional that asyncPromise might be null.
	        // That's when setIsAsync has not been called during the
	        // NOW_CLOSING_EVENT broadcast.
	        return $q.when(asyncPromise).then(afterAnimating);
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          $animate.leave(domEl).then(function() {
	            if (done) {
	              done();
	            }
	
	            domEl.remove();
	            if (closedDeferred) {
	              closedDeferred.resolve();
	            }
	          });
	
	          scope.$destroy();
	        }
	      }
	
	      $document.on('keydown', keydownListener);
	
	      $rootScope.$on('$destroy', function() {
	        $document.off('keydown', keydownListener);
	      });
	
	      function keydownListener(evt) {
	        if (evt.isDefaultPrevented()) {
	          return evt;
	        }
	
	        var modal = openedWindows.top();
	        if (modal) {
	          switch (evt.which) {
	            case 27: {
	              if (modal.value.keyboard) {
	                evt.preventDefault();
	                $rootScope.$apply(function() {
	                  $modalStack.dismiss(modal.key, 'escape key press');
	                });
	              }
	              break;
	            }
	            case 9: {
	              var list = $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                  focusChanged = $modalStack.focusLastFocusableElement(list);
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt, list)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement(list);
	                }
	              }
	
	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	
	              break;
	            }
	          }
	        }
	      }
	
	      $modalStack.open = function(modalInstance, modal) {
	        var modalOpener = $document[0].activeElement,
	          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	        toggleTopWindowClass(false);
	
	        // Store the current top first, to determine what index we ought to use
	        // for the current top modal
	        previousTopOpenedModal = openedWindows.top();
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          renderDeferred: modal.renderDeferred,
	          closedDeferred: modal.closedDeferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard,
	          openedClass: modal.openedClass,
	          windowTopClass: modal.windowTopClass,
	          animation: modal.animation,
	          appendTo: modal.appendTo
	        });
	
	        openedClasses.put(modalBodyClass, modalInstance);
	
	        var appendToElement = modal.appendTo,
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.modalOptions = modal;
	          backdropScope.index = currBackdropIndex;
	          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	          backdropDomEl.attr({
	            'class': 'modal-backdrop',
	            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
	            'uib-modal-animation-class': 'fade',
	            'modal-in-class': 'in'
	          });
	          if (modal.backdropClass) {
	            backdropDomEl.addClass(modal.backdropClass);
	          }
	
	          if (modal.animation) {
	            backdropDomEl.attr('modal-animation', 'true');
	          }
	          $compile(backdropDomEl)(backdropScope);
	          $animate.enter(backdropDomEl, appendToElement);
	          if ($uibPosition.isScrollable(appendToElement)) {
	            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
	            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
	            }
	          }
	        }
	
	        var content;
	        if (modal.component) {
	          content = document.createElement(snake_case(modal.component.name));
	          content = angular.element(content);
	          content.attr({
	            resolve: '$resolve',
	            'modal-instance': '$uibModalInstance',
	            close: '$close($value)',
	            dismiss: '$dismiss($value)'
	          });
	        } else {
	          content = modal.content;
	        }
	
	        // Set the top modal index based on the index of the previous top modal
	        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
	        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	        angularDomEl.attr({
	          'class': 'modal',
	          'template-url': modal.windowTemplateUrl,
	          'window-top-class': modal.windowTopClass,
	          'role': 'dialog',
	          'aria-labelledby': modal.ariaLabelledBy,
	          'aria-describedby': modal.ariaDescribedBy,
	          'size': modal.size,
	          'index': topModalIndex,
	          'animate': 'animate',
	          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
	          'tabindex': -1,
	          'uib-modal-animation-class': 'fade',
	          'modal-in-class': 'in'
	        }).append(content);
	        if (modal.windowClass) {
	          angularDomEl.addClass(modal.windowClass);
	        }
	
	        if (modal.animation) {
	          angularDomEl.attr('modal-animation', 'true');
	        }
	
	        appendToElement.addClass(modalBodyClass);
	        if (modal.scope) {
	          // we need to explicitly add the modal index to the modal scope
	          // because it is needed by ngStyle to compute the zIndex property.
	          modal.scope.$$topModalIndex = topModalIndex;
	        }
	        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);
	
	        openedWindows.top().value.modalDomEl = angularDomEl;
	        openedWindows.top().value.modalOpener = modalOpener;
	
	        applyAriaHidden(angularDomEl);
	
	        function applyAriaHidden(el) {
	          if (!el || el[0].tagName === 'BODY') {
	            return;
	          }
	
	          getSiblings(el).forEach(function(sibling) {
	            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
	              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);
	
	            if (!ariaHiddenCount) {
	              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
	            }
	
	            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
	            sibling.setAttribute('aria-hidden', 'true');
	          });
	
	          return applyAriaHidden(el.parent());
	
	          function getSiblings(el) {
	            var children = el.parent() ? el.parent().children() : [];
	
	            return Array.prototype.filter.call(children, function(child) {
	              return child !== el[0];
	            });
	          }
	        }
	      };
	
	      function broadcastClosing(modalWindow, resultOrReason, closing) {
	        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	      }
	
	      function unhideBackgroundElements() {
	        Array.prototype.forEach.call(
	          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
	          function(hiddenEl) {
	            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
	              newHiddenCount = ariaHiddenCount - 1;
	            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);
	
	            if (!newHiddenCount) {
	              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
	              hiddenEl.removeAttribute('aria-hidden');
	            }
	          }
	        );
	      }
	
	      $modalStack.close = function(modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	
	        return !modalWindow;
	      };
	
	      $modalStack.dismiss = function(modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismissAll = function(reason) {
	        var topModal = this.getTop();
	        while (topModal && this.dismiss(topModal.key, reason)) {
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function() {
	        return openedWindows.top();
	      };
	
	      $modalStack.modalRendered = function(modalInstance) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.renderDeferred.resolve();
	        }
	      };
	
	      $modalStack.focusFirstFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[0].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.focusLastFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[list.length - 1].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.isModalFocused = function(evt, modalWindow) {
	        if (evt && modalWindow) {
	          var modalDomEl = modalWindow.value.modalDomEl;
	          if (modalDomEl && modalDomEl.length) {
	            return (evt.target || evt.srcElement) === modalDomEl[0];
	          }
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInFirstItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[0];
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInLastItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[list.length - 1];
	        }
	        return false;
	      };
	
	      $modalStack.loadFocusElementList = function(modalWindow) {
	        if (modalWindow) {
	          var modalDomE1 = modalWindow.value.modalDomEl;
	          if (modalDomE1 && modalDomE1.length) {
	            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
	            return elements ?
	              Array.prototype.filter.call(elements, function(element) {
	                return isVisible(element);
	              }) : elements;
	          }
	        }
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$uibModal', function() {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true
	      },
	      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
	        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $templateRequest(angular.isFunction(options.templateUrl) ?
	                options.templateUrl() : options.templateUrl);
	          }
	
	          var promiseChain = null;
	          $modal.getPromiseChain = function() {
	            return promiseChain;
	          };
	
	          $modal.open = function(modalOptions) {
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	            var modalClosedDeferred = $q.defer();
	            var modalRenderDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              closed: modalClosedDeferred.promise,
	              rendered: modalRenderDeferred.promise,
	              close: function (result) {
	                return $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                return $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	            if (!modalOptions.appendTo.length) {
	              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	            }
	
	            //verify options
	            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of component or template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise;
	            if (modalOptions.component) {
	              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
	            } else {
	              templateAndResolvePromise =
	                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	            }
	
	            function resolveWithTemplate() {
	              return templateAndResolvePromise;
	            }
	
	            // Wait for the resolution of the existing promise chain.
	            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	            // Then add to $modalStack and resolve opened.
	            // Finally clean up the chain variable if no subsequent modal has overwritten it.
	            var samePromise;
	            samePromise = promiseChain = $q.all([promiseChain])
	              .then(resolveWithTemplate, resolveWithTemplate)
	              .then(function resolveSuccess(tplAndVars) {
	                var providedScope = modalOptions.scope || $rootScope;
	
	                var modalScope = providedScope.$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                modalScope.$on('$destroy', function() {
	                  if (!modalScope.$$uibDestructionScheduled) {
	                    modalScope.$dismiss('$uibUnscheduledDestruction');
	                  }
	                });
	
	                var modal = {
	                  scope: modalScope,
	                  deferred: modalResultDeferred,
	                  renderDeferred: modalRenderDeferred,
	                  closedDeferred: modalClosedDeferred,
	                  animation: modalOptions.animation,
	                  backdrop: modalOptions.backdrop,
	                  keyboard: modalOptions.keyboard,
	                  backdropClass: modalOptions.backdropClass,
	                  windowTopClass: modalOptions.windowTopClass,
	                  windowClass: modalOptions.windowClass,
	                  windowTemplateUrl: modalOptions.windowTemplateUrl,
	                  ariaLabelledBy: modalOptions.ariaLabelledBy,
	                  ariaDescribedBy: modalOptions.ariaDescribedBy,
	                  size: modalOptions.size,
	                  openedClass: modalOptions.openedClass,
	                  appendTo: modalOptions.appendTo
	                };
	
	                var component = {};
	                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};
	
	                if (modalOptions.component) {
	                  constructLocals(component, false, true, false);
	                  component.name = modalOptions.component;
	                  modal.component = component;
	                } else if (modalOptions.controller) {
	                  constructLocals(ctrlLocals, true, false, true);
	
	                  // the third param will make the controller instantiate later,private api
	                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
	                  if (modalOptions.controllerAs && modalOptions.bindToController) {
	                    ctrlInstance = ctrlInstantiate.instance;
	                    ctrlInstance.$close = modalScope.$close;
	                    ctrlInstance.$dismiss = modalScope.$dismiss;
	                    angular.extend(ctrlInstance, {
	                      $resolve: ctrlLocals.$scope.$resolve
	                    }, providedScope);
	                  }
	
	                  ctrlInstance = ctrlInstantiate();
	
	                  if (angular.isFunction(ctrlInstance.$onInit)) {
	                    ctrlInstance.$onInit();
	                  }
	                }
	
	                if (!modalOptions.component) {
	                  modal.content = tplAndVars[0];
	                }
	
	                $modalStack.open(modalInstance, modal);
	                modalOpenedDeferred.resolve(true);
	
	                function constructLocals(obj, template, instanceOnScope, injectable) {
	                  obj.$scope = modalScope;
	                  obj.$scope.$resolve = {};
	                  if (instanceOnScope) {
	                    obj.$scope.$uibModalInstance = modalInstance;
	                  } else {
	                    obj.$uibModalInstance = modalInstance;
	                  }
	
	                  var resolves = template ? tplAndVars[1] : tplAndVars;
	                  angular.forEach(resolves, function(value, key) {
	                    if (injectable) {
	                      obj[key] = value;
	                    }
	
	                    obj.$scope.$resolve[key] = value;
	                  });
	                }
	            }, function resolveError(reason) {
	              modalOpenedDeferred.reject(reason);
	              modalResultDeferred.reject(reason);
	            })['finally'](function() {
	              if (promiseChain === samePromise) {
	                promiseChain = null;
	              }
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }
	      ]
	    };
	
	    return $modalProvider;
	  });


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(422);
	__webpack_require__(421);
	__webpack_require__(420);
	__webpack_require__(416);
	
	var MODULE_NAME = 'ui.bootstrap.module.progressbar';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.progressbar', 'uib/template/progressbar/progressbar.html', 'uib/template/progressbar/progress.html', 'uib/template/progressbar/bar.html']);
	
	module.exports = MODULE_NAME;


/***/ }),
/* 416 */
/***/ (function(module, exports) {

	angular.module('ui.bootstrap.progressbar', [])
	
	.constant('uibProgressConfig', {
	  animate: true,
	  max: 100
	})
	
	.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
	  var self = this,
	      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = getMaxOrDefault();
	
	  this.addBar = function(bar, element, attrs) {
	    if (!animate) {
	      element.css({'transition': 'none'});
	    }
	
	    this.bars.push(bar);
	
	    bar.max = getMaxOrDefault();
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function(value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function() {
	      var totalPercentage = self.bars.reduce(function(total, bar) {
	        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function() {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function(bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	    this.bars.forEach(function (bar) {
	      bar.recalculatePercentage();
	    });
	  };
	
	  //$attrs.$observe('maxParam', function(maxParam) {
	  $scope.$watch('maxParam', function(maxParam) {
	    self.bars.forEach(function(bar) {
	      bar.max = getMaxOrDefault();
	      bar.recalculatePercentage();
	    });
	  });
	
	  function getMaxOrDefault () {
	    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
	  }
	}])
	
	.directive('uibProgress', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    require: 'uibProgress',
	    scope: {
	      maxParam: '=?max'
	    },
	    templateUrl: 'uib/template/progressbar/progress.html'
	  };
	})
	
	.directive('uibBar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^uibProgress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, element, attrs);
	    }
	  };
	})
	
	.directive('uibProgressbar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    scope: {
	      value: '=',
	      maxParam: '=?max',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/progressbar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
	    }
	  };
	});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(418);
	
	var MODULE_NAME = 'ui.bootstrap.module.stackedMap';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.stackedMap']);
	
	module.exports = MODULE_NAME;


/***/ }),
/* 418 */
/***/ (function(module, exports) {

	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function() {
	    return {
	      createNew: function() {
	        var stack = [];
	
	        return {
	          add: function(key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function() {
	            return stack[stack.length - 1];
	          },
	          remove: function(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function() {
	            return stack.pop();
	          },
	          length: function() {
	            return stack.length;
	          }
	        };
	      }
	    };
	  });

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/modal/window.html",
	    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
	    "");
	}]);


/***/ }),
/* 420 */
/***/ (function(module, exports) {

	angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "");
	}]);


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
	}]);


/***/ }),
/* 422 */
/***/ (function(module, exports) {

	angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);


/***/ }),
/* 423 */
/***/ (function(module, exports) {

	/**
	 * @license Angular UI Tree v2.22.6
	 * (c) 2010-2017. https://github.com/angular-ui-tree/angular-ui-tree
	 * License: MIT
	 */
	(function () {
	  'use strict';
	
	  angular.module('ui.tree', [])
	    .constant('treeConfig', {
	      treeClass: 'angular-ui-tree',
	      emptyTreeClass: 'angular-ui-tree-empty',
	      dropzoneClass: 'angular-ui-tree-dropzone',
	      hiddenClass: 'angular-ui-tree-hidden',
	      nodesClass: 'angular-ui-tree-nodes',
	      nodeClass: 'angular-ui-tree-node',
	      handleClass: 'angular-ui-tree-handle',
	      placeholderClass: 'angular-ui-tree-placeholder',
	      dragClass: 'angular-ui-tree-drag',
	      dragThreshold: 3,
	      defaultCollapsed: false,
	      appendChildOnHover: true
	    });
	
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	
	    .controller('TreeHandleController', ['$scope', '$element',
	      function ($scope, $element) {
	        this.scope = $scope;
	
	        $scope.$element = $element;
	        $scope.$nodeScope = null;
	        $scope.$type = 'uiTreeHandle';
	
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	    .controller('TreeNodeController', ['$scope', '$element',
	      function ($scope, $element) {
	        this.scope = $scope;
	
	        $scope.$element = $element;
	        $scope.$modelValue = null; // Model value for node;
	        $scope.$parentNodeScope = null; // uiTreeNode Scope of parent node;
	        $scope.$childNodesScope = null; // uiTreeNodes Scope of child nodes.
	        $scope.$parentNodesScope = null; // uiTreeNodes Scope of parent nodes.
	        $scope.$treeScope = null; // uiTree scope
	        $scope.$handleScope = null; // it's handle scope
	        $scope.$type = 'uiTreeNode';
	        $scope.$$allowNodeDrop = false;
	        $scope.collapsed = false;
	        $scope.expandOnHover = false;
	
	        //Called by uiTreeNode Directive on load.
	        $scope.init = function (controllersArr) {
	          var treeNodesCtrl = controllersArr[0];
	          $scope.$treeScope = controllersArr[1] ? controllersArr[1].scope : null;
	
	          //Find the scope of it's parent node.
	          $scope.$parentNodeScope = treeNodesCtrl.scope.$nodeScope;
	
	          //modelValue for current node.
	          $scope.$modelValue = treeNodesCtrl.scope.$modelValue[$scope.$index];
	          $scope.$parentNodesScope = treeNodesCtrl.scope;
	
	          //Init sub nodes.
	          treeNodesCtrl.scope.initSubNode($scope);
	
	          $element.on('$destroy', function () {
	
	            //Destroy sub nodes.
	            treeNodesCtrl.scope.destroySubNode($scope);
	          });
	        };
	
	        //Return the index of child node in parent node (nodesScope).
	        $scope.index = function () {
	          return $scope.$parentNodesScope.$modelValue.indexOf($scope.$modelValue);
	        };
	
	        $scope.dragEnabled = function () {
	          return !($scope.$treeScope && !$scope.$treeScope.dragEnabled);
	        };
	
	        $scope.isSibling = function (targetNode) {
	          return $scope.$parentNodesScope == targetNode.$parentNodesScope;
	        };
	
	        $scope.isChild = function (targetNode) {
	          var nodes = $scope.childNodes();
	          return nodes && nodes.indexOf(targetNode) > -1;
	        };
	
	        //TODO(jcarter): This method is on uiTreeHelper already.
	        $scope.prev = function () {
	          var index = $scope.index();
	          if (index > 0) {
	            return $scope.siblings()[index - 1];
	          }
	          return null;
	        };
	
	        //Calls childNodes on parent.
	        $scope.siblings = function () {
	          return $scope.$parentNodesScope.childNodes();
	        };
	
	        $scope.childNodesCount = function () {
	          return $scope.childNodes() ? $scope.childNodes().length : 0;
	        };
	
	        $scope.hasChild = function () {
	          return $scope.childNodesCount() > 0;
	        };
	
	        $scope.childNodes = function () {
	          return $scope.$childNodesScope && $scope.$childNodesScope.$modelValue ?
	            $scope.$childNodesScope.childNodes() :
	            null;
	        };
	
	        $scope.accept = function (sourceNode, destIndex) {
	          return $scope.$childNodesScope &&
	            $scope.$childNodesScope.$modelValue &&
	            $scope.$childNodesScope.accept(sourceNode, destIndex);
	        };
	
	        $scope.remove = function () {
	          return $scope.$parentNodesScope.removeNode($scope);
	        };
	
	        $scope.toggle = function () {
	          $scope.collapsed = !$scope.collapsed;
	          $scope.$treeScope.$callbacks.toggle($scope.collapsed, $scope);
	        };
	
	        $scope.collapse = function () {
	          $scope.collapsed = true;
	        };
	
	        $scope.expand = function () {
	          $scope.collapsed = false;
	        };
	
	        $scope.depth = function () {
	          var parentNode = $scope.$parentNodeScope;
	          if (parentNode) {
	            return parentNode.depth() + 1;
	          }
	          return 1;
	        };
	
	        /**
	        * Returns the depth of the deepest subtree under this node
	        * @param scope a TreeNodesController scope object
	        * @returns Depth of all nodes *beneath* this node. If scope belongs to a leaf node, the
	        *   result is 0 (it has no subtree).
	        */
	        function countSubTreeDepth(scope) {
	          if (!scope) {
	            return 0;
	          }
	          var thisLevelDepth = 0,
	              childNodes = scope.childNodes(),
	              childNode,
	              childDepth,
	              i;
	          if (!childNodes || childNodes.length === 0) {
	            return 0;
	          }
	          for (i = childNodes.length - 1; i >= 0 ; i--) {
	            childNode = childNodes[i],
	            childDepth = 1 + countSubTreeDepth(childNode);
	            thisLevelDepth = Math.max(thisLevelDepth, childDepth);
	          }
	          return thisLevelDepth;
	        }
	
	        $scope.maxSubDepth = function () {
	          return $scope.$childNodesScope ? countSubTreeDepth($scope.$childNodesScope) : 0;
	        };
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	
	    .controller('TreeNodesController', ['$scope', '$element', '$timeout',
	      function ($scope, $element, $timeout) {
	        this.scope = $scope;
	
	        $scope.$element = $element;
	        $scope.$modelValue = null;
	        $scope.$nodeScope = null; // the scope of node which the nodes belongs to
	        $scope.$treeScope = null;
	        $scope.$type = 'uiTreeNodes';
	        $scope.$nodesMap = {};
	
	        $scope.nodropEnabled = false;
	        $scope.maxDepth = 0;
	        $scope.cloneEnabled = false;
	
	        $scope.initSubNode = function (subNode) {
	          if (!subNode.$modelValue) {
	            return null;
	          }
	          $scope.$nodesMap[subNode.$modelValue.$$hashKey] = subNode;
	        };
	
	        $scope.destroySubNode = function (subNode) {
	          if (!subNode.$modelValue) {
	            return null;
	          }
	          $scope.$nodesMap[subNode.$modelValue.$$hashKey] = null;
	        };
	
	        $scope.accept = function (sourceNode, destIndex) {
	          return $scope.$treeScope.$callbacks.accept(sourceNode, $scope, destIndex);
	        };
	
	        $scope.beforeDrag = function (sourceNode) {
	          return $scope.$treeScope.$callbacks.beforeDrag(sourceNode);
	        };
	
	        $scope.isParent = function (node) {
	          return node.$parentNodesScope == $scope;
	        };
	
	        $scope.hasChild = function () {
	          return $scope.$modelValue.length > 0;
	        };
	
	        //Called in apply method of UiTreeHelper.dragInfo.
	        $scope.removeNode = function (node) {
	          var index = $scope.$modelValue.indexOf(node.$modelValue);
	          if (index > -1) {
	            $timeout(function () {
	              $scope.$modelValue.splice(index, 1)[0];
	            });
	            return $scope.$treeScope.$callbacks.removed(node);
	          }
	          return null;
	        };
	
	        //Called in apply method of UiTreeHelper.dragInfo.
	        $scope.insertNode = function (index, nodeData) {
	          $timeout(function () {
	            $scope.$modelValue.splice(index, 0, nodeData);
	          });
	        };
	
	        $scope.childNodes = function () {
	          var i, nodes = [];
	          if ($scope.$modelValue) {
	            for (i = 0; i < $scope.$modelValue.length; i++) {
	              nodes.push($scope.$nodesMap[$scope.$modelValue[i].$$hashKey]);
	            }
	          }
	          return nodes;
	        };
	
	        $scope.depth = function () {
	          if ($scope.$nodeScope) {
	            return $scope.$nodeScope.depth();
	          }
	          return 0; // if it has no $nodeScope, it's root
	        };
	
	        // check if depth limit has reached
	        $scope.outOfDepth = function (sourceNode) {
	          var maxDepth = $scope.maxDepth || $scope.$treeScope.maxDepth;
	          if (maxDepth > 0) {
	            return $scope.depth() + sourceNode.maxSubDepth() + 1 > maxDepth;
	          }
	          return false;
	        };
	
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	
	    .controller('TreeController', ['$scope', '$element',
	      function ($scope, $element) {
	        this.scope = $scope;
	
	        $scope.$element = $element;
	        $scope.$nodesScope = null; // root nodes
	        $scope.$type = 'uiTree';
	        $scope.$emptyElm = null;
	        $scope.$dropzoneElm = null;
	        $scope.$callbacks = null;
	
	        $scope.dragEnabled = true;
	        $scope.emptyPlaceholderEnabled = true;
	        $scope.maxDepth = 0;
	        $scope.dragDelay = 0;
	        $scope.cloneEnabled = false;
	        $scope.nodropEnabled = false;
	        $scope.dropzoneEnabled = false;
	
	        // Check if it's a empty tree
	        $scope.isEmpty = function () {
	          return ($scope.$nodesScope && $scope.$nodesScope.$modelValue
	          && $scope.$nodesScope.$modelValue.length === 0);
	        };
	
	        // add placeholder to empty tree
	        $scope.place = function (placeElm) {
	          $scope.$nodesScope.$element.append(placeElm);
	          $scope.$emptyElm.remove();
	        };
	
	        this.resetEmptyElement = function () {
	          if ((!$scope.$nodesScope.$modelValue || $scope.$nodesScope.$modelValue.length === 0) &&
	            $scope.emptyPlaceholderEnabled) {
	            $element.append($scope.$emptyElm);
	          } else {
	            $scope.$emptyElm.remove();
	          }
	        };
	
	        this.resetDropzoneElement = function () {
	          if ((!$scope.$nodesScope.$modelValue || $scope.$nodesScope.$modelValue.length !== 0) &&
	            $scope.dropzoneEnabled) {
	            $element.append($scope.$dropzoneElm);
	          } else {
	            $scope.$dropzoneElm.remove();
	          }
	        };
	
	        $scope.resetEmptyElement = this.resetEmptyElement;
	        $scope.resetDropzoneElement = this.resetDropzoneElement;
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	    .directive('uiTree', ['treeConfig', '$window',
	      function (treeConfig, $window) {
	        return {
	          restrict: 'A',
	          scope: true,
	          controller: 'TreeController',
	          link: function (scope, element, attrs, ctrl) {
	            var callbacks = {
	              accept: null,
	              beforeDrag: null
	            },
	            config = {},
	            tdElm,
	            $trElm,
	            emptyElmColspan;
	
	            //Adding configured class to uiTree.
	            angular.extend(config, treeConfig);
	
	            if (config.treeClass) {
	              element.addClass(config.treeClass);
	            }
	
	            //Determining if uiTree is on a table.
	            if (element.prop('tagName').toLowerCase() === 'table') {
	              scope.$emptyElm = angular.element($window.document.createElement('tr'));
	              $trElm = element.find('tr');
	              
	              //If we can find a tr, then we can use its td children as the empty element colspan.
	              if ($trElm.length > 0) {
	                emptyElmColspan = angular.element($trElm).children().length;
	              } else {
	                
	                //If not, by setting a huge colspan we make sure it takes full width.
	                //TODO(jcarter): Check for negative side effects.
	                emptyElmColspan = 1000000;
	              }
	              tdElm = angular.element($window.document.createElement('td'))
	                .attr('colspan', emptyElmColspan);
	              scope.$emptyElm.append(tdElm);
	            } else {
	              scope.$emptyElm = angular.element($window.document.createElement('div'));
	              scope.$dropzoneElm = angular.element($window.document.createElement('div'));
	            }
	
	            if (config.emptyTreeClass) {
	              scope.$emptyElm.addClass(config.emptyTreeClass);
	            }
	            if (config.dropzoneClass) {
	              scope.$dropzoneElm.addClass(config.dropzoneClass);
	            }
	
	            scope.$watch('$nodesScope.$modelValue.length', function (val) {
	              if (!angular.isNumber(val)) {
	                return;
	              }
	
	              ctrl.resetEmptyElement();
	              ctrl.resetDropzoneElement();
	            }, true);
	
	            scope.$watch(attrs.dragEnabled, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.dragEnabled = val;
	              }
	            });
	
	            scope.$watch(attrs.emptyPlaceholderEnabled, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.emptyPlaceholderEnabled = val;
	                ctrl.resetEmptyElement();
	              }
	            });
	
	            scope.$watch(attrs.nodropEnabled, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.nodropEnabled = val;
	              }
	            });
	
	            scope.$watch(attrs.dropzoneEnabled, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.dropzoneEnabled = val;
	                ctrl.resetDropzoneElement();
	              }
	            });
	
	            scope.$watch(attrs.cloneEnabled, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.cloneEnabled = val;
	              }
	            });
	
	            scope.$watch(attrs.maxDepth, function (val) {
	              if ((typeof val) == 'number') {
	                scope.maxDepth = val;
	              }
	            });
	
	            scope.$watch(attrs.dragDelay, function (val) {
	              if ((typeof val) == 'number') {
	                scope.dragDelay = val;
	              }
	            });
	
	            /**
	             * Callback checks if the destination node can accept the dragged node.
	             * By default, ui-tree will check that 'data-nodrop-enabled' is not set for the
	             * destination ui-tree-nodes, and that the 'max-depth' attribute will not be exceeded
	             * if it is set on the ui-tree or ui-tree-nodes.
	             * This callback can be overridden, but callers must manually enforce nodrop and max-depth
	             * themselves if they need those to be enforced.
	             * @param sourceNodeScope Scope of the ui-tree-node being dragged
	             * @param destNodesScope Scope of the ui-tree-nodes where the node is hovering
	             * @param destIndex Index in the destination nodes array where the source node will drop
	             * @returns {boolean} True if the node is permitted to be dropped here
	             */
	            callbacks.accept = function (sourceNodeScope, destNodesScope, destIndex) {
	              return !(destNodesScope.nodropEnabled || destNodesScope.$treeScope.nodropEnabled || destNodesScope.outOfDepth(sourceNodeScope));
	            };
	
	            callbacks.beforeDrag = function (sourceNodeScope) {
	              return true;
	            };
	
	            callbacks.expandTimeoutStart = function()
	            {
	
	            };
	
	            callbacks.expandTimeoutCancel = function()
	            {
	
	            };
	
	            callbacks.expandTimeoutEnd = function()
	            {
	
	            };
	
	            callbacks.removed = function (node) {
	
	            };
	
	            /**
	             * Callback is fired when a node is successfully dropped in a new location
	             * @param event
	             */
	            callbacks.dropped = function (event) {
	
	            };
	
	            /**
	             * Callback is fired each time the user starts dragging a node
	             * @param event
	             */
	            callbacks.dragStart = function (event) {
	
	            };
	
	            /**
	             * Callback is fired each time a dragged node is moved with the mouse/touch.
	             * @param event
	             */
	            callbacks.dragMove = function (event) {
	
	            };
	
	            /**
	             * Callback is fired when the tree exits drag mode. If the user dropped a node, the drop may have been
	             * accepted or reverted.
	             * @param event
	             */
	            callbacks.dragStop = function (event) {
	
	            };
	
	            /**
	             * Callback is fired when a user drops a node (but prior to processing the drop action)
	             * beforeDrop can return a Promise, truthy, or falsy (returning nothing is falsy).
	             * If it returns falsy, or a resolve Promise, the node move is accepted
	             * If it returns truthy, or a rejected Promise, the node move is reverted
	             * @param event
	             * @returns {Boolean|Promise} Truthy (or rejected Promise) to cancel node move; falsy (or resolved promise)
	             */
	            callbacks.beforeDrop = function (event) {
	
	            };
	
	            /**
	             * Callback is fired when a user toggles node (but after processing the toggle action)
	             * @param sourceNodeScope
	             * @param collapsed
	             */
	            callbacks.toggle = function (collapsed, sourceNodeScope) {
	
	            };
	
	            scope.$watch(attrs.uiTree, function (newVal, oldVal) {
	              angular.forEach(newVal, function (value, key) {
	                if (callbacks[key]) {
	                  if (typeof value === 'function') {
	                    callbacks[key] = value;
	                  }
	                }
	              });
	
	              scope.$callbacks = callbacks;
	            }, true);
	
	
	          }
	        };
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	    .directive('uiTreeHandle', ['treeConfig',
	      function (treeConfig) {
	        return {
	          require: '^uiTreeNode',
	          restrict: 'A',
	          scope: true,
	          controller: 'TreeHandleController',
	          link: function (scope, element, attrs, treeNodeCtrl) {
	            var config = {};
	            angular.extend(config, treeConfig);
	            if (config.handleClass) {
	              element.addClass(config.handleClass);
	            }
	            // connect with the tree node.
	            if (scope != treeNodeCtrl.scope) {
	              scope.$nodeScope = treeNodeCtrl.scope;
	              treeNodeCtrl.scope.$handleScope = scope;
	            }
	          }
	        };
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	
	    .directive('uiTreeNode', ['treeConfig', 'UiTreeHelper', '$window', '$document', '$timeout', '$q',
	      function (treeConfig, UiTreeHelper, $window, $document, $timeout, $q) {
	        return {
	          require: ['^uiTreeNodes', '^uiTree'],
	          restrict: 'A',
	          controller: 'TreeNodeController',
	          link: function (scope, element, attrs, controllersArr) {
	            var config = {},
	              hasTouch = 'ontouchstart' in window,
	              firstMoving,
	              dragInfo,
	              pos,
	              placeElm,
	              hiddenPlaceElm,
	              dragElm,
	              scrollContainerElm,
	              unhover,
	              treeScope = null,
	              elements, // As a parameter for callbacks
	              dragDelaying = true,
	              dragStarted = false,
	              dragTimer = null,
	              body = document.body,
	              html = document.documentElement,
	              document_height,
	              document_width,
	              dragStart,
	              tagName,
	              dragMove,
	              dragEnd,
	              dragStartEvent,
	              dragMoveEvent,
	              dragEndEvent,
	              dragCancelEvent,
	              dragDelay,
	              bindDragStartEvents,
	              bindDragMoveEvents,
	              unbindDragMoveEvents,
	              keydownHandler,
	              isHandleChild,
	              el,
	              isUiTreeRoot,
	              treeOfOrigin;
	
	            //Adding configured class to ui-tree-node.
	            angular.extend(config, treeConfig);
	
	            if (config.nodeClass) {
	              element.addClass(config.nodeClass);
	            }
	
	            //Call init function in nodeCtrl, sets parent node and sets up sub nodes.
	            scope.init(controllersArr);
	
	            scope.collapsed = !!UiTreeHelper.getNodeAttribute(scope, 'collapsed') || treeConfig.defaultCollapsed;
	            scope.expandOnHover = !!UiTreeHelper.getNodeAttribute(scope, 'expandOnHover');
	            scope.scrollContainer = UiTreeHelper.getNodeAttribute(scope, 'scrollContainer') || attrs.scrollContainer || null;
	            scope.sourceOnly = scope.nodropEnabled || scope.$treeScope.nodropEnabled;
	
	            scope.$watch(attrs.collapsed, function (val) {
	              if ((typeof val) == 'boolean') {
	                scope.collapsed = val;
	              }
	            });
	
	            //Watches to trigger behavior based on actions and settings.
	            scope.$watch('collapsed', function (val) {
	              UiTreeHelper.setNodeAttribute(scope, 'collapsed', val);
	              attrs.$set('collapsed', val);
	            });
	
	            scope.$watch(attrs.expandOnHover, function(val) {
	              if ((typeof val) === 'boolean' || (typeof val) === 'number') {
	                scope.expandOnHover = val;
	              }
	            });
	
	            scope.$watch('expandOnHover', function (val) {
	              UiTreeHelper.setNodeAttribute(scope, 'expandOnHover', val);
	              attrs.$set('expandOnHover', val);
	            });
	
	            attrs.$observe('scrollContainer', function(val) {
	              if ((typeof val) === 'string') {
	                scope.scrollContainer = val;
	              }
	            });
	
	            scope.$watch('scrollContainer', function(val) {
	              UiTreeHelper.setNodeAttribute(scope, 'scrollContainer', val);
	              attrs.$set('scrollContainer', val);
	              scrollContainerElm = document.querySelector(val);
	            });
	
	            scope.$on('angular-ui-tree:collapse-all', function () {
	              scope.collapsed = true;
	            });
	
	            scope.$on('angular-ui-tree:expand-all', function () {
	              scope.collapsed = false;
	            });
	
	            /**
	             * Called when the user has grabbed a node and started dragging it.
	             *
	             * @param {MouseEvent} e event that is triggered by DOM.
	             * @return undefined?
	             */
	            dragStart = function (e) {
	
	              //Disable right click.
	              if (!hasTouch && (e.button === 2 || e.which === 3)) {
	                return;
	              }
	
	              //Event has already fired in other scope.
	              if (e.uiTreeDragging || (e.originalEvent && e.originalEvent.uiTreeDragging)) {
	                return;
	              }
	
	              //The node being dragged.
	              var eventElm = angular.element(e.target),
	                isHandleChild,
	                cloneElm,
	                eventElmTagName,
	                tagName,
	                eventObj,
	                tdElm,
	                hStyle,
	                isTreeNode,
	                isTreeNodeHandle;
	
	              //If the target element is a child element of a ui-tree-handle,
	              // use the containing handle element as target element.
	              isHandleChild = UiTreeHelper.treeNodeHandlerContainerOfElement(eventElm);
	              if (isHandleChild) {
	                eventElm = angular.element(isHandleChild);
	              }
	
	              cloneElm = element.clone();
	              isTreeNode = UiTreeHelper.elementIsTreeNode(eventElm);
	              isTreeNodeHandle = UiTreeHelper.elementIsTreeNodeHandle(eventElm);
	
	              //If we are not triggering mousedown on our uiTree or any of it's parts, return.
	              if (!isTreeNode && !isTreeNodeHandle) {
	                return;
	              }
	
	              //If we are not triggering mousedown on our uiTree or any of it's parts, return.
	              if (isTreeNode && UiTreeHelper.elementContainsTreeNodeHandler(eventElm)) {
	                return;
	              }
	
	              //Dragging not allowed on inputs or buttons.
	              eventElmTagName = eventElm.prop('tagName').toLowerCase();
	              if (eventElmTagName == 'input' ||
	                  eventElmTagName == 'textarea' ||
	                  eventElmTagName == 'button' ||
	                  eventElmTagName == 'select') {
	                return;
	              }
	
	              //Check if it or it's parents has a 'data-nodrag' attribute
	              el = angular.element(e.target);
	              isUiTreeRoot = el[0].attributes['ui-tree'];
	              while (el && el[0] && el[0] !== element && !isUiTreeRoot) {
	
	                //Checking that I can access attributes.
	                if (el[0].attributes) {
	                  isUiTreeRoot = el[0].attributes['ui-tree'];
	                }
	
	                //If the node mark as `nodrag`, DONOT drag it.
	                if (UiTreeHelper.nodrag(el)) {
	                  return;
	                }
	                el = el.parent();
	              }
	
	              //If users beforeDrag calback returns falsey, do not initiate.
	              if (!scope.beforeDrag(scope)) {
	                return;
	              }
	
	              //Set property checked at start of function to prevent running logic again.
	              e.uiTreeDragging = true;
	              if (e.originalEvent) {
	                e.originalEvent.uiTreeDragging = true;
	              }
	              e.preventDefault();
	
	              //Get original event if TouchEvent.
	              eventObj = UiTreeHelper.eventObj(e);
	
	              //Set boolean used to specify beginning of move.
	              firstMoving = true;
	
	              //Setting drag info properties and methods in scope of node being moved.
	              dragInfo = UiTreeHelper.dragInfo(scope);
	
	              //Setting original tree to adjust horizontal behavior in drag move.
	              treeOfOrigin = dragInfo.source.$treeScope.$id;
	
	              //Determine tage name of element ui-tree-node is on.
	              tagName = element.prop('tagName');
	
	              if (tagName.toLowerCase() === 'tr') {
	
	                //Create a new table column as placeholder.
	                placeElm = angular.element($window.document.createElement(tagName));
	
	                //Create a column placeholder and set colspan to whole row length.
	                tdElm = angular.element($window.document.createElement('td'))
	                    .addClass(config.placeholderClass)
	                    .attr('colspan', element[0].children.length);
	                placeElm.append(tdElm);
	              } else {
	
	                //If not a table just duplicate element and add placeholder class.
	                placeElm = angular.element($window.document.createElement(tagName))
	                    .addClass(config.placeholderClass);
	              }
	
	              //Create a hidden placeholder and add class from config.
	              hiddenPlaceElm = angular.element($window.document.createElement(tagName));
	              if (config.hiddenClass) {
	                hiddenPlaceElm.addClass(config.hiddenClass);
	              }
	
	              //Getting starting position of element being moved.
	              pos = UiTreeHelper.positionStarted(eventObj, element);
	              placeElm.css('height', element.prop('offsetHeight') + 'px');
	
	              //Creating drag element to represent node.
	              dragElm = angular.element($window.document.createElement(scope.$parentNodesScope.$element.prop('tagName')))
	                  .addClass(scope.$parentNodesScope.$element.attr('class')).addClass(config.dragClass);
	              dragElm.css('width', UiTreeHelper.width(element) + 'px');
	              dragElm.css('z-index', 9999);
	
	              //Prevents cursor to change rapidly in Opera 12.16 and IE when dragging an element.
	              hStyle = (element[0].querySelector('.angular-ui-tree-handle') || element[0]).currentStyle;
	              if (hStyle) {
	                document.body.setAttribute('ui-tree-cursor', $document.find('body').css('cursor') || '');
	                $document.find('body').css({'cursor': hStyle.cursor + '!important'});
	              }
	
	              //If tree is sourceOnly (noDragDrop) don't show placeholder when moving about it.
	              if (scope.sourceOnly) {
	                placeElm.css('display', 'none');
	              }
	
	              //Insert placeholder.
	              element.after(placeElm);
	              element.after(hiddenPlaceElm);
	              if (dragInfo.isClone() && scope.sourceOnly) {
	                dragElm.append(cloneElm);
	              } else {
	                dragElm.append(element);
	              }
	
	              //Create drag element.
	              $document.find('body').append(dragElm);
	
	              //Set drag elements position on screen.
	              dragElm.css({
	                'left': eventObj.pageX - pos.offsetX + 'px',
	                'top': eventObj.pageY - pos.offsetY + 'px'
	              });
	              elements = {
	                placeholder: placeElm,
	                dragging: dragElm
	              };
	
	              //Create all drag/move bindings.
	              bindDragMoveEvents();
	
	              //Fire dragStart callback.
	              scope.$apply(function () {
	                scope.$treeScope.$callbacks.dragStart(dragInfo.eventArgs(elements, pos));
	              });
	
	              //Get bounds of document.
	              document_height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	              document_width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
	            };
	
	            dragMove = function (e) {
	              var eventObj = UiTreeHelper.eventObj(e),
	                prev,
	                next,
	                leftElmPos,
	                topElmPos,
	                top_scroll,
	                bottom_scroll,
	                scrollContainerElmRect,
	                target,
	                targetX,
	                targetY,
	                displayElm,
	                targetNode,
	                targetElm,
	                isEmpty,
	                scrollDownBy,
	                scrollUpBy,
	                targetOffset,
	                targetBefore,
	                moveWithinTree,
	                targetBeforeBuffer,
	                targetHeight,
	                targetChildElm,
	                targetChildHeight,
	                isDropzone;
	
	              //If check ensures that drag element was created.
	              if (dragElm) {
	                e.preventDefault();
	
	                //Deselect anything (text, etc.) that was selected when move began.
	                if ($window.getSelection) {
	                  $window.getSelection().removeAllRanges();
	                } else if ($window.document.selection) {
	                  $window.document.selection.empty();
	                }
	
	                //Get top left positioning of element being moved.
	                leftElmPos = eventObj.pageX - pos.offsetX;
	                topElmPos = eventObj.pageY - pos.offsetY;
	
	                //dragElm can't leave the screen on the left.
	                if (leftElmPos < 0) {
	                  leftElmPos = 0;
	                }
	
	                //dragElm can't leave the screen on the top.
	                if (topElmPos < 0) {
	                  topElmPos = 0;
	                }
	
	                //dragElm can't leave the screen on the bottom.
	                if ((topElmPos + 10) > document_height) {
	                  topElmPos = document_height - 10;
	                }
	
	                //dragElm can't leave the screen on the right.
	                if ((leftElmPos + 10) > document_width) {
	                  leftElmPos = document_width - 10;
	                }
	
	                //Updating element being moved css.
	                dragElm.css({
	                  'left': leftElmPos + 'px',
	                  'top': topElmPos + 'px'
	                });
	
	                if (scrollContainerElm) {
	                  //Getting position to top and bottom of container element.
	                  scrollContainerElmRect = scrollContainerElm.getBoundingClientRect();
	                  top_scroll = scrollContainerElm.scrollTop;
	                  bottom_scroll = top_scroll + scrollContainerElm.clientHeight;
	
	                  //To scroll down if cursor y-position is greater than the bottom position of the container vertical scroll
	                  if (scrollContainerElmRect.bottom < eventObj.clientY && bottom_scroll < scrollContainerElm.scrollHeight) {
	                    scrollDownBy = Math.min(scrollContainerElm.scrollHeight - bottom_scroll, 10);
	                    scrollContainerElm.scrollTop += scrollDownBy;
	                  }
	
	                  //To scroll top if cursor y-position is less than the top position of the container vertical scroll
	                  if (scrollContainerElmRect.top > eventObj.clientY && top_scroll > 0) {
	                    scrollUpBy = Math.min(top_scroll, 10);
	                    scrollContainerElm.scrollTop -= scrollUpBy;
	                  }
	                } else {
	                  //Getting position to top and bottom of page.
	                  top_scroll = window.pageYOffset || $window.document.documentElement.scrollTop;
	                  bottom_scroll = top_scroll + (window.innerHeight || $window.document.clientHeight || $window.document.clientHeight);
	
	                  //To scroll down if cursor y-position is greater than the bottom position of the window vertical scroll
	                  if (bottom_scroll < eventObj.pageY && bottom_scroll < document_height) {
	                    scrollDownBy = Math.min(document_height - bottom_scroll, 10);
	                    window.scrollBy(0, scrollDownBy);
	                  }
	
	                  //To scroll top if cursor y-position is less than the top position of the window vertical scroll
	                  if (top_scroll > eventObj.pageY) {
	                    scrollUpBy = Math.min(top_scroll, 10);
	                    window.scrollBy(0, -scrollUpBy);
	                  }
	                }
	
	                //Calling service to update position coordinates based on move.
	                UiTreeHelper.positionMoved(e, pos, firstMoving);
	                if (firstMoving) {
	                  firstMoving = false;
	                  return;
	                }
	
	                //Setting X point for elementFromPoint.
	                targetX = eventObj.pageX - ($window.pageXOffset ||
	                    $window.document.body.scrollLeft ||
	                    $window.document.documentElement.scrollLeft) -
	                    ($window.document.documentElement.clientLeft || 0);
	
	                targetY = eventObj.pageY - ($window.pageYOffset ||
	                    $window.document.body.scrollTop ||
	                    $window.document.documentElement.scrollTop) -
	                    ($window.document.documentElement.clientTop || 0);
	
	                //Select the drag target. Because IE does not support CSS 'pointer-events: none', it will always
	                // pick the drag element itself as the target. To prevent this, we hide the drag element while
	                // selecting the target.
	                if (angular.isFunction(dragElm.hide)) {
	                  dragElm.hide();
	                } else {
	                  displayElm = dragElm[0].style.display;
	                  dragElm[0].style.display = 'none';
	                }
	
	                //When using elementFromPoint() inside an iframe, you have to call
	                // elementFromPoint() twice to make sure IE8 returns the correct value
	                //MDN: The elementFromPoint() method of the Document interface returns the topmost element at the specified coordinates.
	                $window.document.elementFromPoint(targetX, targetY);
	
	                //Set target element (element in specified x/y coordinates).
	                targetElm = angular.element($window.document.elementFromPoint(targetX, targetY));
	
	                //If the target element is a child element of a ui-tree-handle,
	                // use the containing handle element as target element
	                isHandleChild = UiTreeHelper.treeNodeHandlerContainerOfElement(targetElm);
	                if (isHandleChild) {
	                  targetElm = angular.element(isHandleChild);
	                }
	
	                if (angular.isFunction(dragElm.show)) {
	                  dragElm.show();
	                } else {
	                  dragElm[0].style.display = displayElm;
	                }
	
	                //Assigning scope to target you are moving draggable over.
	                if (UiTreeHelper.elementIsTree(targetElm)) {
	                  targetNode = targetElm.controller('uiTree').scope;
	                } else if (UiTreeHelper.elementIsTreeNodeHandle(targetElm)) {
	                  targetNode = targetElm.controller('uiTreeHandle').scope;
	                } else if (UiTreeHelper.elementIsTreeNode(targetElm)) {
	                  targetNode = targetElm.controller('uiTreeNode').scope;
	                } else if (UiTreeHelper.elementIsTreeNodes(targetElm)) {
	                  targetNode = targetElm.controller('uiTreeNodes').scope;
	                } else if (UiTreeHelper.elementIsPlaceholder(targetElm)) {
	                  targetNode = targetElm.controller('uiTreeNodes').scope;
	                } else if (UiTreeHelper.elementIsDropzone(targetElm)) {
	                  targetNode = targetElm.controller('uiTree').scope;
	                  isDropzone = true;
	                } else if (targetElm.controller('uiTreeNode')) {
	                  //Is a child element of a node.
	                  targetNode = targetElm.controller('uiTreeNode').scope;
	                }
	
	                moveWithinTree =  (targetNode && targetNode.$treeScope && targetNode.$treeScope.$id && targetNode.$treeScope.$id === treeOfOrigin);
	
	                /* (jcarter) Notes to developers:
	                 *  pos.dirAx is either 0 or 1
	                 *  1 means horizontal movement is happening
	                 *  0 means vertical movement is happening
	                 */
	
	                // Move nodes up and down in nesting level.
	                if (moveWithinTree && pos.dirAx) {
	
	                  // increase horizontal level if previous sibling exists and is not collapsed
	                  // example 1.1.1 becomes 1.2
	                  if (pos.distX > 0) {
	                    prev = dragInfo.prev();
	                    if (prev && !prev.collapsed
	                      && prev.accept(scope, prev.childNodesCount())) {
	                      prev.$childNodesScope.$element.append(placeElm);
	                      dragInfo.moveTo(prev.$childNodesScope, prev.childNodes(), prev.childNodesCount());
	                    }
	                  }
	
	                  // decrease horizontal level
	                  // example 1.2 become 1.1.1
	                  if (pos.distX < 0) {
	                    // we can't decrease a level if an item preceeds the current one
	                    next = dragInfo.next();
	                    if (!next) {
	                      target = dragInfo.parentNode(); // As a sibling of it's parent node
	                      if (target
	                        && target.$parentNodesScope.accept(scope, target.index() + 1)) {
	                        target.$element.after(placeElm);
	                        dragInfo.moveTo(target.$parentNodesScope, target.siblings(), target.index() + 1);
	                      }
	                    }
	                  }
	                } else { //Either in origin tree and moving horizontally OR you are moving within a new tree.
	
	                  //Check it's new position.
	                  isEmpty = false;
	
	                  //Exit if target is not a uiTree or child of one.
	                  if (!targetNode) {
	                    return;
	                  }
	
	                  //Show the placeholder if it was hidden for nodrop-enabled and this is a new tree
	                  if (targetNode.$treeScope && !targetNode.$parent.nodropEnabled && !targetNode.$treeScope.nodropEnabled) {
	                    placeElm.css('display', '');
	                  }
	
	                  //Set whether target tree is empty or not.
	                  if (targetNode.$type === 'uiTree' && targetNode.dragEnabled) {
	                    isEmpty = targetNode.isEmpty();
	                  }
	
	                  //If target is a handle set new target to handle's node.
	                  if (targetNode.$type === 'uiTreeHandle') {
	                    targetNode = targetNode.$nodeScope;
	                  }
	
	                  //Check if it is a uiTreeNode or it's an empty tree or it's a dropzone.
	                  if (targetNode.$type !== 'uiTreeNode' && !isEmpty && !isDropzone) {
	
	                    // Allow node to return to its original position if no longer hovering over target
	                    if (config.appendChildOnHover) {
	                      next = dragInfo.next();
	                      if (!next && unhover) {
	                        target = dragInfo.parentNode();
	                        target.$element.after(placeElm);
	                        dragInfo.moveTo(target.$parentNodesScope, target.siblings(), target.index() + 1);
	                        unhover = false;
	                      }
	                    }
	                    return;
	                  }
	
	                  //If placeholder move from empty tree, reset it.
	                  if (treeScope && placeElm.parent()[0] != treeScope.$element[0]) {
	                    treeScope.resetEmptyElement();
	                    treeScope.resetDropzoneElement();
	                    treeScope = null;
	                  }
	
	                  //It's an empty tree
	                  if (isEmpty) {
	                    treeScope = targetNode;
	                    if (targetNode.$nodesScope.accept(scope, 0)) {
	                      dragInfo.moveTo(targetNode.$nodesScope, targetNode.$nodesScope.childNodes(), 0);
	                    }
	                  //It's a dropzone
	                  } else if (isDropzone) {
	                    treeScope = targetNode;
	                    if (targetNode.$nodesScope.accept(scope, targetNode.$nodesScope.childNodes().length)) {
	                      dragInfo.moveTo(targetNode.$nodesScope, targetNode.$nodesScope.childNodes(), targetNode.$nodesScope.childNodes().length);
	                    }
	                  //Not empty and drag enabled.
	                  } else if (targetNode.dragEnabled()) {
	
	                      //Setting/Resetting data for exanding on hover.
	                      if (angular.isDefined(scope.expandTimeoutOn) && scope.expandTimeoutOn !== targetNode.id) {
	                        $timeout.cancel(scope.expandTimeout);
	                        delete scope.expandTimeout;
	                        delete scope.expandTimeoutOn;
	
	                        scope.$callbacks.expandTimeoutCancel();
	                      }
	
	                      //Determining if expansion is needed.
	                      if (targetNode.collapsed) {
	                        if (scope.expandOnHover === true || (angular.isNumber(scope.expandOnHover) && scope.expandOnHover === 0)) {
	                          targetNode.collapsed = false;
	                          targetNode.$treeScope.$callbacks.toggle(false, targetNode);
	                        } else if (scope.expandOnHover !== false && angular.isNumber(scope.expandOnHover) && scope.expandOnHover > 0) {
	
	                          //Triggering expansion.
	                          if (angular.isUndefined(scope.expandTimeoutOn)) {
	                            scope.expandTimeoutOn = targetNode.$id;
	
	                            scope.$callbacks.expandTimeoutStart();
	                            scope.expandTimeout = $timeout(function()
	                            {
	                              scope.$callbacks.expandTimeoutEnd();
	                              targetNode.collapsed = false;
	                              targetNode.$treeScope.$callbacks.toggle(false, targetNode);
	                            }, scope.expandOnHover);
	                          }
	                        }
	                      }
	
	                    //Get the element of ui-tree-node
	                    targetElm = targetNode.$element;
	                    targetOffset = UiTreeHelper.offset(targetElm);
	                    targetHeight = UiTreeHelper.height(targetElm);
	                    targetChildElm = targetNode.$childNodesScope ? targetNode.$childNodesScope.$element : null;
	                    targetChildHeight = targetChildElm ? UiTreeHelper.height(targetChildElm) : 0;
	                    targetHeight -= targetChildHeight;
	                    targetBeforeBuffer = config.appendChildOnHover ? targetHeight * 0.25 : UiTreeHelper.height(targetElm) / 2;
	                    targetBefore = eventObj.pageY < (targetOffset.top + targetBeforeBuffer);
	
	                    if (targetNode.$parentNodesScope.accept(scope, targetNode.index())) {
	                      if (targetBefore) {
	                        targetElm[0].parentNode.insertBefore(placeElm[0], targetElm[0]);
	                        dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index());
	                      } else {
	                        // Try to append as a child if dragged upwards onto targetNode
	                        if (config.appendChildOnHover && targetNode.accept(scope, targetNode.childNodesCount())) {
	                          targetNode.$childNodesScope.$element.prepend(placeElm);
	                          dragInfo.moveTo(targetNode.$childNodesScope, targetNode.childNodes(), 0);
	                          unhover = true;
	                        } else {
	                          targetElm.after(placeElm);
	                          dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index() + 1);
	                        }
	                      }
	
	                    //We have to check if it can add the dragging node as a child.
	                    } else if (!targetBefore && targetNode.accept(scope, targetNode.childNodesCount())) {
	                      targetNode.$childNodesScope.$element.append(placeElm);
	                      dragInfo.moveTo(targetNode.$childNodesScope, targetNode.childNodes(), targetNode.childNodesCount());
	                    }
	                  }
	                }
	
	                //Triggering dragMove callback.
	                scope.$apply(function () {
	                  scope.$treeScope.$callbacks.dragMove(dragInfo.eventArgs(elements, pos));
	                });
	              }
	            };
	
	            dragEnd = function (e) {
	
	              var dragEventArgs = dragInfo.eventArgs(elements, pos);
	
	              e.preventDefault();
	
	              //TODO(jcarter): Is dragStart need to be unbound?
	              unbindDragMoveEvents();
	
	              //This cancel the collapse/expand login running.
	              $timeout.cancel(scope.expandTimeout);
	
	              scope.$treeScope.$apply(function () {
	                $q.when(scope.$treeScope.$callbacks.beforeDrop(dragEventArgs))
	
	                     //Promise resolved (or callback didn't return false)
	                    .then(function (allowDrop) {
	                      if (allowDrop !== false && scope.$$allowNodeDrop) {
	                        //Node drop accepted.
	                        dragInfo.apply();
	
	                        //Fire the dropped callback only if the move was successful.
	                        scope.$treeScope.$callbacks.dropped(dragEventArgs);
	                      } else {
	                        //Drop canceled - revert the node to its original position.
	                        bindDragStartEvents();
	                      }
	                    })
	
	                    //Promise rejected - revert the node to its original position.
	                    .catch(function () {
	                      bindDragStartEvents();
	                    })
	                    .finally(function () {
	
	                      //Replace placeholder with newly dropped element.
	                      hiddenPlaceElm.replaceWith(scope.$element);
	                      placeElm.remove();
	
	                      //Remove drag element if still in DOM.
	                      if (dragElm) {
	                        dragElm.remove();
	                        dragElm = null;
	                      }
	
	                      //Fire dragStope callback.
	                      scope.$treeScope.$callbacks.dragStop(dragEventArgs);
	                      scope.$$allowNodeDrop = false;
	                      dragInfo = null;
	
	                      //Restore cursor in Opera 12.16 and IE
	                      var oldCur = document.body.getAttribute('ui-tree-cursor');
	                      if (oldCur !== null) {
	                        $document.find('body').css({'cursor': oldCur});
	                        document.body.removeAttribute('ui-tree-cursor');
	                      }
	                    });
	              });
	            };
	
	            dragStartEvent = function (e) {
	              if (scope.dragEnabled()) {
	                dragStart(e);
	              }
	            };
	
	            dragMoveEvent = function (e) {
	              dragMove(e);
	            };
	
	            dragEndEvent = function (e) {
	              scope.$$allowNodeDrop = true;
	              dragEnd(e);
	            };
	
	            dragCancelEvent = function (e) {
	              dragEnd(e);
	            };
	
	            dragDelay = (function () {
	              var to;
	
	              return {
	                exec: function (fn, ms) {
	                  if (!ms) {
	                    ms = 0;
	                  }
	                  this.cancel();
	                  to = $timeout(fn, ms);
	                },
	                cancel: function () {
	                  $timeout.cancel(to);
	                }
	              };
	            })();
	
	            keydownHandler = function (e) {
	              if (e.keyCode === 27) {
	                dragEndEvent(e);
	              }
	            };
	
	            /**
	             * Binds the mouse/touch events to enable drag start for this node.
	             */
	            //This is outside of bindDragMoveEvents because of the potential for a delay setting.
	            bindDragStartEvents = function () {
	              element.bind('touchstart mousedown', function (e) {
	                //Don't call drag delay if no delay was specified.
	                if (scope.dragDelay > 0) {
	                  dragDelay.exec(function () {
	                    dragStartEvent(e);
	                  }, scope.dragDelay);
	                } else {
	                  dragStartEvent(e);
	                }
	              });
	              element.bind('touchend touchcancel mouseup', function () {
	                if (scope.dragDelay > 0) {
	                  dragDelay.cancel();
	                }
	              });
	            };
	            bindDragStartEvents();
	
	            /**
	             * Binds mouse/touch events that handle moving/dropping this dragged node
	             */
	            bindDragMoveEvents = function () {
	              angular.element($document).bind('touchend', dragEndEvent);
	              angular.element($document).bind('touchcancel', dragEndEvent);
	              angular.element($document).bind('touchmove', dragMoveEvent);
	              angular.element($document).bind('mouseup', dragEndEvent);
	              angular.element($document).bind('mousemove', dragMoveEvent);
	              angular.element($document).bind('mouseleave', dragCancelEvent);
	              angular.element($document).bind('keydown', keydownHandler);
	            };
	
	            /**
	             * Unbinds mouse/touch events that handle moving/dropping this dragged node.
	             */
	            unbindDragMoveEvents = function () {
	              angular.element($document).unbind('touchend', dragEndEvent);
	              angular.element($document).unbind('touchcancel', dragEndEvent);
	              angular.element($document).unbind('touchmove', dragMoveEvent);
	              angular.element($document).unbind('mouseup', dragEndEvent);
	              angular.element($document).unbind('mousemove', dragMoveEvent);
	              angular.element($document).unbind('mouseleave', dragCancelEvent);
	              angular.element($document).unbind('keydown', keydownHandler);
	            };
	          }
	        };
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	    .directive('uiTreeNodes', ['treeConfig', '$window',
	      function (treeConfig) {
	        return {
	          require: ['ngModel', '?^uiTreeNode', '^uiTree'],
	          restrict: 'A',
	          scope: true,
	          controller: 'TreeNodesController',
	          link: function (scope, element, attrs, controllersArr) {
	
	            var config = {},
	                ngModel = controllersArr[0],
	                treeNodeCtrl = controllersArr[1],
	                treeCtrl = controllersArr[2];
	
	            angular.extend(config, treeConfig);
	            if (config.nodesClass) {
	              element.addClass(config.nodesClass);
	            }
	
	            if (treeNodeCtrl) {
	              treeNodeCtrl.scope.$childNodesScope = scope;
	              scope.$nodeScope = treeNodeCtrl.scope;
	            } else {
	              // find the root nodes if there is no parent node and have a parent ui-tree
	              treeCtrl.scope.$nodesScope = scope;
	            }
	            scope.$treeScope = treeCtrl.scope;
	
	            if (ngModel) {
	              ngModel.$render = function () {
	                scope.$modelValue = ngModel.$modelValue;
	              };
	            }
	
	            scope.$watch(function () {
	              return attrs.maxDepth;
	            }, function (val) {
	              if ((typeof val) == 'number') {
	                scope.maxDepth = val;
	              }
	            });
	
	            scope.$watch(function () {
	              return attrs.nodropEnabled;
	            }, function (newVal) {
	              if ((typeof newVal) != 'undefined') {
	                scope.nodropEnabled = true;
	              }
	            }, true);
	
	          }
	        };
	      }
	    ]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.tree')
	
	  /**
	   * @ngdoc service
	   * @name ui.tree.service:UiTreeHelper
	   * @requires ng.$document
	   * @requires ng.$window
	   *
	   * @description
	   * angular-ui-tree.
	   */
	    .factory('UiTreeHelper', ['$document', '$window', 'treeConfig',
	      function ($document, $window, treeConfig) {
	        return {
	
	          /**
	           * A hashtable used to storage data of nodes
	           * @type {Object}
	           */
	          nodesData: {},
	
	          setNodeAttribute: function (scope, attrName, val) {
	            if (!scope.$modelValue) {
	              return null;
	            }
	            var data = this.nodesData[scope.$modelValue.$$hashKey];
	            if (!data) {
	              data = {};
	              this.nodesData[scope.$modelValue.$$hashKey] = data;
	            }
	            data[attrName] = val;
	          },
	
	          getNodeAttribute: function (scope, attrName) {
	            if (!scope.$modelValue) {
	              return null;
	            }
	            var data = this.nodesData[scope.$modelValue.$$hashKey];
	            if (data) {
	              return data[attrName];
	            }
	            return null;
	          },
	
	          /**
	           * @ngdoc method
	           * @methodOf ui.tree.service:$nodrag
	           * @param  {Object} targetElm angular element
	           * @return {Bool} check if the node can be dragged.
	           */
	          nodrag: function (targetElm) {
	            if (typeof targetElm.attr('data-nodrag') != 'undefined') {
	              return targetElm.attr('data-nodrag') !== 'false';
	            }
	            return false;
	          },
	
	          /**
	           * Get the event object for touches.
	           * 
	           * @param  {MouseEvent|TouchEvent} e MouseEvent or TouchEvent that kicked off dragX method.
	           * @return {MouseEvent|TouchEvent} Object returned as original event object.
	           */
	          eventObj: function (e) {
	            var obj = e;
	            if (e.targetTouches !== undefined) {
	              //Set obj equal to the first Touch object in the TouchList.
	              obj = e.targetTouches.item(0);
	            //Logic to set obj to original TouchEvent.
	            } else if (e.originalEvent !== undefined && e.originalEvent.targetTouches !== undefined) {
	              obj = e.originalEvent.targetTouches.item(0);
	            }
	            return obj;
	          },
	
	          /**
	           * Generate object used to store data about node being moved.
	           * 
	           * {angular.$scope} node Scope of the node that is being moved.
	           */
	          dragInfo: function (node) {
	            return {
	              source: node,
	              sourceInfo: {
	                cloneModel: node.$treeScope.cloneEnabled === true ? angular.copy(node.$modelValue) : undefined,
	                nodeScope: node,
	                index: node.index(),
	                nodesScope: node.$parentNodesScope
	              },
	              index: node.index(),
	
	              //Slice(0) just duplicates an array.
	              siblings: node.siblings().slice(0),
	              parent: node.$parentNodesScope,
	
	              //Reset parent to source parent.
	              resetParent: function() {
	                this.parent = node.$parentNodesScope;
	              },
	
	              //Move the node to a new position, determining where the node will be inserted to when dropped happens here.
	              moveTo: function (parent, siblings, index) {
	                this.parent = parent;
	
	                //Duplicate siblings array.
	                this.siblings = siblings.slice(0);
	
	                //If source node is in the target nodes
	                var i = this.siblings.indexOf(this.source);
	                if (i > -1) {
	                  this.siblings.splice(i, 1);
	                  if (this.source.index() < index) {
	                    index--;
	                  }
	                }
	
	                this.siblings.splice(index, 0, this.source);
	                this.index = index;
	              },
	
	              //Get parent nodes nodeScope.
	              parentNode: function () {
	                return this.parent.$nodeScope;
	              },
	
	              //Get previous sibling node.
	              prev: function () {
	                if (this.index > 0) {
	                  return this.siblings[this.index - 1];
	                }
	
	                return null;
	              },
	
	              //Get next sibling node.
	              next: function () {
	                if (this.index < this.siblings.length - 1) {
	                  return this.siblings[this.index + 1];
	                }
	
	                return null;
	              },
	
	              //Return what cloneEnabled is set to on uiTree.
	              isClone: function () {
	                return this.source.$treeScope.cloneEnabled === true;
	              },
	
	              //Returns a copy of node passed in.
	              clonedNode: function (node) {
	                return angular.copy(node);
	              },
	
	              //Returns true if parent or index have changed (move happened within any uiTree).
	              isDirty: function () {
	                return this.source.$parentNodesScope != this.parent ||
	                  this.source.index() != this.index;
	              },
	
	              //Return whether node has a new parent (set on moveTo method).
	              isForeign: function () {
	                return this.source.$treeScope !== this.parent.$treeScope;
	              },
	
	              //Sets arguments passed to user callbacks.
	              eventArgs: function (elements, pos) {
	                return {
	                  source: this.sourceInfo,
	                  dest: {
	                    index: this.index,
	                    nodesScope: this.parent
	                  },
	                  elements: elements,
	                  pos: pos
	                };
	              },
	
	              //Method that actually manipulates the node being moved.
	              apply: function () {
	
	                var nodeData = this.source.$modelValue;
	
	                //Nodrop enabled on tree or parent
	                if (this.parent.nodropEnabled || this.parent.$treeScope.nodropEnabled) {
	                  return;
	                }
	
	                //Node was dropped in the same place - do nothing.
	                if (!this.isDirty()) {
	                  return;
	                }
	
	                //CloneEnabled and cross-tree so copy and do not remove from source.
	                if (this.isClone() && this.isForeign()) {
	                  this.parent.insertNode(this.index, this.sourceInfo.cloneModel);
	                //Any other case, remove and reinsert.
	                } else {
	                  this.source.remove();
	                  this.parent.insertNode(this.index, nodeData);
	                }
	              }
	            };
	          },
	
	          /**
	           * @ngdoc method
	           * @name ui.tree#height
	           * @methodOf ui.tree.service:UiTreeHelper
	           *
	           * @description
	           * Get the height of an element.
	           *
	           * @param {Object} element Angular element.
	           * @returns {String} Height
	           */
	          height: function (element) {
	            return element.prop('scrollHeight');
	          },
	
	          /**
	           * @ngdoc method
	           * @name ui.tree#width
	           * @methodOf ui.tree.service:UiTreeHelper
	           *
	           * @description
	           * Get the width of an element.
	           *
	           * @param {Object} element Angular element.
	           * @returns {String} Width
	           */
	          width: function (element) {
	            return element.prop('scrollWidth');
	          },
	
	          /**
	           * @ngdoc method
	           * @name ui.tree#offset
	           * @methodOf ui.nestedSortable.service:UiTreeHelper
	           *
	           * @description
	           * Get the offset values of an element.
	           *
	           * @param {Object} element Angular element.
	           * @returns {Object} Object with properties width, height, top and left
	           */
	          offset: function (element) {
	            var boundingClientRect = element[0].getBoundingClientRect();
	
	            return {
	              width: element.prop('offsetWidth'),
	              height: element.prop('offsetHeight'),
	              top: boundingClientRect.top + ($window.pageYOffset || $document[0].body.scrollTop || $document[0].documentElement.scrollTop),
	              left: boundingClientRect.left + ($window.pageXOffset || $document[0].body.scrollLeft || $document[0].documentElement.scrollLeft)
	            };
	          },
	
	          /**
	           * @ngdoc method
	           * @name ui.tree#positionStarted
	           * @methodOf ui.tree.service:UiTreeHelper
	           *
	           * @description
	           * Get the start position of the target element according to the provided event properties.
	           *
	           * @param {Object} e Event
	           * @param {Object} target Target element
	           * @returns {Object} Object with properties offsetX, offsetY, startX, startY, nowX and dirX.
	           */
	          positionStarted: function (e, target) {
	            var pos = {},
	            pageX = e.pageX,
	            pageY = e.pageY;
	
	            //Check to set correct data for TouchEvents
	            if (e.originalEvent && e.originalEvent.touches && (e.originalEvent.touches.length > 0)) {
	              pageX = e.originalEvent.touches[0].pageX;
	              pageY = e.originalEvent.touches[0].pageY;
	            }
	            pos.offsetX = pageX - this.offset(target).left;
	            pos.offsetY = pageY - this.offset(target).top;
	            pos.startX = pos.lastX = pageX;
	            pos.startY = pos.lastY = pageY;
	            pos.nowX = pos.nowY = pos.distX = pos.distY = pos.dirAx = 0;
	            pos.dirX = pos.dirY = pos.lastDirX = pos.lastDirY = pos.distAxX = pos.distAxY = 0;
	            return pos;
	          },
	
	          positionMoved: function (e, pos, firstMoving) {
	
	            var pageX = e.pageX,
	            pageY = e.pageY,
	            newAx;
	
	            //If there are multiple touch points, choose one to use as X and Y.
	            if (e.originalEvent && e.originalEvent.touches && (e.originalEvent.touches.length > 0)) {
	              pageX = e.originalEvent.touches[0].pageX;
	              pageY = e.originalEvent.touches[0].pageY;
	            }
	
	            //Mouse position last event.
	            pos.lastX = pos.nowX;
	            pos.lastY = pos.nowY;
	
	            //Mouse position this event.
	            pos.nowX = pageX;
	            pos.nowY = pageY;
	
	            //Distance mouse moved between events.          
	            pos.distX = pos.nowX - pos.lastX;
	            pos.distY = pos.nowY - pos.lastY;
	
	            //Direction mouse was moving.           
	            pos.lastDirX = pos.dirX;
	            pos.lastDirY = pos.dirY;
	
	            //Direction mouse is now moving (on both axis).          
	            pos.dirX = pos.distX === 0 ? 0 : pos.distX > 0 ? 1 : -1;
	            pos.dirY = pos.distY === 0 ? 0 : pos.distY > 0 ? 1 : -1;
	
	            //Axis mouse is now moving on.         
	            newAx = Math.abs(pos.distX) > Math.abs(pos.distY) ? 1 : 0;
	
	            //Do nothing on first move.
	            if (firstMoving) {
	              pos.dirAx = newAx;
	              pos.moving = true;
	              return;
	            }
	
	            //Calc distance moved on this axis (and direction).          
	            if (pos.dirAx !== newAx) {
	              pos.distAxX = 0;
	              pos.distAxY = 0;
	            } else {
	              pos.distAxX += Math.abs(pos.distX);
	              if (pos.dirX !== 0 && pos.dirX !== pos.lastDirX) {
	                pos.distAxX = 0;
	              }
	              pos.distAxY += Math.abs(pos.distY);
	              if (pos.dirY !== 0 && pos.dirY !== pos.lastDirY) {
	                pos.distAxY = 0;
	              }
	            }
	            pos.dirAx = newAx;
	          },
	
	          elementIsTreeNode: function (element) {
	            return typeof element.attr('ui-tree-node') !== 'undefined';
	          },
	
	          elementIsTreeNodeHandle: function (element) {
	            return typeof element.attr('ui-tree-handle') !== 'undefined';
	          },
	          elementIsTree: function (element) {
	            return typeof element.attr('ui-tree') !== 'undefined';
	          },
	          elementIsTreeNodes: function (element) {
	            return typeof element.attr('ui-tree-nodes') !== 'undefined';
	          },
	          elementIsPlaceholder: function (element) {
	            return element.hasClass(treeConfig.placeholderClass);
	          },
	          elementIsDropzone: function (element) {
	            return element.hasClass(treeConfig.dropzoneClass);
	          },
	          elementContainsTreeNodeHandler: function (element) {
	            return element[0].querySelectorAll('[ui-tree-handle]').length >= 1;
	          },
	          treeNodeHandlerContainerOfElement: function (element) {
	            return findFirstParentElementWithAttribute('ui-tree-handle', element[0]);
	          }
	        };
	      }
	    ]);
	
	  // TODO: optimize this loop
	  //(Jcarter): Suggest adding a parent element property on uiTree, then all these bubble
	  // to <html> can trigger to stop when they reach the parent.
	  function findFirstParentElementWithAttribute(attributeName, childObj) {
	    //Undefined if the mouse leaves the browser window
	    if (childObj === undefined) {
	      return null;
	    }
	    var testObj = childObj.parentNode,
	    count = 1,
	    //Check for setAttribute due to exception thrown by Firefox when a node is dragged outside the browser window
	    res = (typeof testObj.setAttribute === 'function' && testObj.hasAttribute(attributeName)) ? testObj : null;
	    while (testObj && typeof testObj.setAttribute === 'function' && !testObj.hasAttribute(attributeName)) {
	      testObj = testObj.parentNode;
	      res = testObj;
	      //Stop once we reach top of page.
	      if (testObj === document.documentElement) {
	        res = null;
	        break;
	      }
	      count++;
	    }
	    return res;
	  }
	
	})();

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(423);
	module.exports = 'ui.tree';


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = load;
	// Adapted from analytics.js-loader
	// https://github.com/vvo/analytics.js-loader/blob/master/index.js
	
	function load(opts) {
	  // Create a queue, but don't obliterate an existing one!
	  // Stripe prevents loading itself over itself
	  var stripeLoader = global.stripeLoader = global.stripeLoader || [];
	
	  // If the real stripeLoader.js is already on the page return.
	  if (stripeLoader.activate) return;
	
	  // If the snippet was invoked already show an error.
	  if (stripeLoader.invoked) {
	    if (window.console && console.error) {
	      console.error('stripeLoader snippet included twice.');
	    }
	    return;
	  }
	
	  // Invoked flag, to make sure the snippet
	  // is never invoked twice.
	  stripeLoader.invoked = true;
	
	  // Define a method to load stripeLoader.js from our CDN,
	  // and that will be sure to only ever load it once.
	  stripeLoader.load = function (key) {
	    var $script = __webpack_require__(890);
	    $script("https://js.stripe.com/v2/", function () {
	      Stripe.setPublishableKey(key);
	    });
	  };
	
	  // Load stripeLoader.js with your key, which will automatically
	  // load the tools you've enabled for your account. Boosh!
	  stripeLoader.load(opts.writeKey);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 426 */,
/* 427 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = factboxAppAuthModal;
	factboxAppAuthModal.$inject = ['$rootScope', '$route', '$parse', '$window', '$uibModal', 'SigninModalConf'];
	
	function factboxAppAuthModal($rootScope, $route, $parse, $window, $uibModal, SigninModalConf) {
	  $rootScope.authModal = function () {
	    if ($rootScope.authModalOpen || $parse('current.$$route.originalPath')($route) === '/signin') {
	      return;
	    }
	    $rootScope.authModalOpen = true;
	
	    var conf = SigninModalConf;
	
	    $uibModal.open(conf).result.then(function () {
	      $rootScope.authModalOpen = false;
	    }, function () {
	      $window.location.reload();
	    });
	  };
	}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debugInfoConfig;
	debugInfoConfig.$inject = ['$compileProvider'];
	
	// PRODUCTION global variable is defined in webpack config file
	// debugInfo should be disabled in production
	function debugInfoConfig($compileProvider) {
	  // $compileProvider.debugInfoEnabled(!PRODUCTION)
	}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = exceptionHandler;
	exceptionHandler.$inject = ['$provide'];
	
	function exceptionHandler($provide) {
		$provide.decorator("$exceptionHandler", ['$delegate', '$window', function ($delegate, $window) {
			return function (exception, cause) {
				$delegate(exception, cause);
				// Send angular errors to Rollbar
				if ($window.Rollbar) {
					$window.Rollbar.error(exception, {
						cause: cause
					});
				}
			};
		}]);
	};

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debugInfoConfig;
	debugInfoConfig.$inject = ['$compileProvider'];
	
	function debugInfoConfig($compileProvider) {
	  $compileProvider.preAssignBindingsEnabled(true);
	}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = factboxAppRouteChanges;
	factboxAppRouteChanges.$inject = ['$rootScope', '$parse', '$location', '$window', 'AnalyticsServ', '$uibModalStack', 'Errors'];
	function factboxAppRouteChanges($rootScope, $parse, $location, $window, AnalyticsServ, $uibModalStack, Errors) {
	  $rootScope.$on('$routeChangeStart', function (e, next, prev) {
	    var route = next.$$route;
	
	    if (route) {
	      $rootScope.app = route.app ? true : false;
	    }
	
	    $rootScope.loading = 'page';
	
	    // persist groupingAttr - save it before change
	    // $window.options = $window.options || {};
	
	    // $window.options.group = $rootScope.groupingAttr;
	    // $window.options.report = $rootScope.reportType;
	
	    $uibModalStack.dismissAll();
	  });
	  $rootScope.$on('$routeChangeSuccess', function (e, next, prev) {
	    var route = next.$$route;
	
	
	    $rootScope.loading = false;
	    if (!$location.search().finalDestination) {
	      // Clear errors on non-redirected successful route changes
	      Errors.data = {};
	    }
	
	    if (route) {
	      AnalyticsServ.page(route.originalPath, $location.search());
	
	      $rootScope.app = route.app ? true : false;
	
	      AnalyticsServ.setChatVisibility(false);
	      AnalyticsServ.setFirstSeen();
	    }
	  });
	  $rootScope.$on('$routeChangeError', function (e, current, next, response) {
	    // redirects user to login when $routeProvider resolve promises rejected
	    var route = current.$$route;
	
	
	    $rootScope.loading = false;
	
	    // Unauthorized handles 408 403 401
	    if (!(response && /408|401|403/.test(response.status))) {
	      if (route.originalPath.match(/^\/home/)) {
	        $location.url('/home');
	        $location.search('finalDestination', true);
	        AnalyticsServ.analytics.track('Redirected to Home', {
	          'Page': route.originalPath
	        });
	      } else if (route.originalPath.match(/^\/fact/)) {
	        $location.url('/fact');
	        $location.search('finalDestination', true);
	        AnalyticsServ.analytics.track('Redirected to Fact', {
	          'Page': route.originalPath
	        });
	      } else {
	        $location.path('/signin');
	        AnalyticsServ.analytics.track('Redirected to Sign In', {
	          'Page': route.originalPath
	        });
	      }
	    }
	  });
	}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = factboxAppRoutes;
	factboxAppRoutes.$inject = ['$routeProvider', '$locationProvider', '$httpProvider'];
	function factboxAppRoutes($routeProvider, $locationProvider, $httpProvider) {
		$locationProvider.html5Mode(false);
		$locationProvider.hashPrefix('');
		$routeProvider.when('/thankyou!', {
			redirectTo: function redirectTo() {
				return '/?welcome=thankyou!';
			}
		}).when('/thankyou', {
			redirectTo: function redirectTo() {
				return '/?welcome=thankyou';
			}
		}).when('/opt-out', {
			template: '<div style="text-align:center; width: 33%; margin: 16.5% auto 0;min-width:200px">' + 'You\'re all set. We tracked you visiting this page on AdRoll and Perfect Audience. ' + 'Return <a ng-click="openHome()" href>Home</a></div>'
		}).otherwise({
			redirectTo: function redirectTo() {
				return window.isFactWindow ? '/fact' : '/home';
			}
		});
		$httpProvider.interceptors.push('Unauthorized');
		$httpProvider.interceptors.push('ErrorFeedback');
		$httpProvider.interceptors.push('LoadingFeedback');
	}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbDateFieldCtrl = function () {
	  function fbDateFieldCtrl($element, $timeout, DateParserServ) {
	    (0, _classCallCheck3.default)(this, fbDateFieldCtrl);
	
	    this.element = $element[0];
	    this.timeout = $timeout;
	    this.dateParserServ = DateParserServ;
	    this.submit = this.submit.bind(this);
	    this.newDate = '';
	    this.editMode = false;
	    this.handleUpdate = this.handleUpdate.bind(this);
	    this.handleBlur = this.handleBlur.bind(this);
	    this.handleTab = this.handleTab.bind(this);
	  }
	
	  (0, _createClass3.default)(fbDateFieldCtrl, [{
	    key: '$onInit',
	    value: function $onInit() {
	      /*
	        Called on each controller after all the controllers on an element 
	        have been constructed and had their bindings initialized 
	        (and before the pre & post linking functions for the directives on this 
	        element). This is a good place to put initialization code for your controller.
	      */
	      this.fromFact(this.fbDateish);
	      this.element.addEventListener('keyup', this.handleTab);
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      /*
	        Called on a controller when its containing scope is destroyed. 
	        Use this hook for releasing external resources, watches and event handlers.
	      */
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(_ref) {
	      var fbDateish = _ref.fbDateish;
	
	      /*
	        Called whenever one-way bindings are updated. The changesObj is a hash 
	        whose keys are the names of the bound properties that have changed, and 
	        the values are an object of the form 
	        { currentValue, previousValue, isFirstChange() }. 
	        Use this hook to trigger updates within a component such as cloning the 
	        bound value to prevent accidental mutation of the outer value.
	      */
	      if (fbDateish.currentValue !== fbDateish.previousValue) {
	        this.fromFact(fbDateish.currentValue);
	      }
	    }
	  }, {
	    key: 'fromFact',
	    value: function fromFact(factDateish) {
	      this.parsedDate = this.dateParserServ.fromFactDateish(factDateish);
	      this.isValid = this.dateParserServ.validate(this.parsedDate);
	      this.formattedDate = this.dateParserServ.format(this.parsedDate);
	      this.newDate = this.formattedDate;
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      this.parsedDate = this.dateParserServ.parse(this.newDate);
	      this.isValid = this.dateParserServ.validate(this.parsedDate);
	      this.formattedDate = this.dateParserServ.format(this.parsedDate);
	    }
	  }, {
	    key: 'handleTab',
	    value: function handleTab(e) {
	      var _this = this;
	
	      if (e && e.type === 'keyup' && e.keyCode === 9) {
	        // tab
	        this.timeout(function () {
	          _this.setEditMode(true);
	        }, 0);
	      }
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(e) {
	      var _this2 = this;
	
	      this.timeout(function () {
	        _this2.handleUpdate(e);
	      }, 0);
	    }
	  }, {
	    key: 'setEditMode',
	    value: function setEditMode(editMode) {
	      this.editMode = editMode;
	      var input = this.element.querySelector('.editable-input');
	      if (editMode) {
	        this.timeout(function () {
	          return input.focus();
	        });
	        input.addEventListener('blur', this.handleBlur);
	        this.element.removeEventListener('keyup', this.handleTab);
	      } else {
	        input.removeEventListener('blur', this.handleBlur);
	        this.element.addEventListener('keyup', this.handleTab);
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.update();
	      this.newDate = this.formattedDate;
	      this.setEditMode(false);
	      if (this.isValid) {
	        this.updateFact({ factDateish: this.dateParserServ.toFactDateish(this.parsedDate) });
	      } else {
	        this.$onInit();
	      }
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate(e) {
	
	      if (!e) {
	        return;
	      }
	      switch (e.type) {
	        case 'keyup':
	          switch (e.keyCode) {
	            case 13: // enter
	            case 27:
	              // esc
	              this.submit();
	              break;
	            default:
	              break;
	          }
	          break;
	        case 'blur':
	          this.submit();
	          break;
	      }
	    }
	  }]);
	  return fbDateFieldCtrl;
	}();
	
	exports.default = fbDateFieldCtrl;
	
	fbDateFieldCtrl.$inject = ['$element', '$timeout', 'DateParserServ'];

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fbDateField = __webpack_require__(433);
	
	var _fbDateField2 = _interopRequireDefault(_fbDateField);
	
	var _factDateish = __webpack_require__(115);
	
	var _factDateish2 = _interopRequireDefault(_factDateish);
	
	var _dateParser = __webpack_require__(324);
	
	var _dateParser2 = _interopRequireDefault(_dateParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbDateField = {
	  template: __webpack_require__(811),
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	      
	      */
	    fbDateish: '<',
	    updateFact: '&'
	  },
	  controller: _fbDateField2.default
	};
	
	exports.default = _angular2.default.module('components.fbDateField', [_factDateish2.default, _dateParser2.default]).component('fbDateField', fbDateField).name;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbEditableCtrl = function () {
	  function fbEditableCtrl($element, $timeout) {
	    (0, _classCallCheck3.default)(this, fbEditableCtrl);
	
	    this.element = $element[0];
	    this.timeout = $timeout;
	  }
	
	  (0, _createClass3.default)(fbEditableCtrl, [{
	    key: '$onInit',
	    value: function $onInit() {
	      /*
	        Called on each controller after all the controllers on an element 
	        have been constructed and had their bindings initialized 
	        (and before the pre & post linking functions for the directives on this 
	        element). This is a good place to put initialization code for your controller.
	      */
	      this.reset();
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      /*
	        Called on a controller when its containing scope is destroyed. 
	        Use this hook for releasing external resources, watches and event handlers.
	      */
	
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      /*
	        Called after this controller's element and its children have been linked. 
	        Similar to the post-link function this hook can be used to set up 
	        DOM event handlers and do direct DOM manipulation. Note that child 
	        elements that contain templateUrl directives will not have been compiled 
	        and linked since they are waiting for their template to load 
	        asynchronously and their own compilation and linking has been suspended 
	        until that occurs. This hook can be considered analogous to the 
	        ngAfterViewInit and ngAfterContentInit hooks in Angular 2. Since the 
	        compilation process is rather different in Angular 1 there is no direct 
	        mapping and care should be taken when upgrading.
	      */
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changesObj) {
	      /*
	        Called whenever one-way bindings are updated. The changesObj is a hash 
	        whose keys are the names of the bound properties that have changed, and 
	        the values are an object of the form 
	        { currentValue, previousValue, isFirstChange() }. 
	        Use this hook to trigger updates within a component such as cloning the 
	        bound value to prevent accidental mutation of the outer value.
	      */
	      this.reset();
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.setEditMode();
	      this.newValue = this.value;
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      if (this.newValue !== this.value && this.newValue.length) {
	        this.onUpdate({ newValue: this.newValue }).then(function () {
	          _this.reset();
	        });
	      } else {
	        this.reset();
	      }
	    }
	  }, {
	    key: 'setEditMode',
	    value: function setEditMode(setEditable) {
	      // manually toggle styles to support focus on ipad 
	      // ng-show/hide does not work correctly
	
	      var text = this.element.querySelector('.editable-text');
	      var field = this.element.querySelector('.editable-field');
	
	      if (setEditable) {
	        var width = text.offsetWidth;
	        field.style.width = width - 1 + 'px'; // fix rounding error
	
	        field.classList.remove('ng-hide');
	        text.classList.add('ng-hide');
	
	        this.element.querySelector('.editable-input').focus();
	      } else {
	        field.classList.add('ng-hide');
	        text.classList.remove('ng-hide');
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.stopImmediatePropagation();
	      e.preventDefault();
	      switch (e.type) {
	        case 'blur':
	          this.submit();
	          break;
	        case 'keyup':
	          switch (e.keyCode) {
	            case 27:
	              this.reset();
	              break;
	            case 13:
	              this.submit();
	              break;
	          }
	      }
	    }
	  }]);
	  return fbEditableCtrl;
	}();
	
	exports.default = fbEditableCtrl;
	
	fbEditableCtrl.$inject = ['$element', '$timeout'];

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbFactCtrl = function () {
	  function fbFactCtrl($element, $timeout, $q, ExtractionServ, IssuesTreeFactory, SourcesTreeFactory, SourcesGrouping, TagsTreeFactory, $sanitize, DateParserServ) {
	    (0, _classCallCheck3.default)(this, fbFactCtrl);
	
	    this.extractionServ = ExtractionServ;
	    this.q = $q;
	    this.sanitize = $sanitize;
	    this.dateParserServ = DateParserServ;
	
	    this.issuesTree = new IssuesTreeFactory();
	    this.issuesTree.api.get();
	    this.tagsTree = new TagsTreeFactory();
	    this.sourcesTree = new SourcesTreeFactory();
	    this.sourcesGrouping = SourcesGrouping;
	
	    this.element = $element[0];
	    this.timeout = $timeout;
	
	    this.setFactField = this.setFactField.bind(this);
	  }
	
	  (0, _createClass3.default)(fbFactCtrl, [{
	    key: '$onInit',
	    value: function $onInit() {
	      /*
	        Called on each controller after all the controllers on an element 
	        have been constructed and had their bindings initialized 
	        (and before the pre & post linking functions for the directives on this 
	        element). This is a good place to put initialization code for your controller.
	      */
	      this.reset();
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      /*
	        Called on a controller when its containing scope is destroyed. 
	        Use this hook for releasing external resources, watches and event handlers.
	      */
	
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      /*
	        Called after this controller's element and its children have been linked. 
	        Similar to the post-link function this hook can be used to set up 
	        DOM event handlers and do direct DOM manipulation. Note that child 
	        elements that contain templateUrl directives will not have been compiled 
	        and linked since they are waiting for their template to load 
	        asynchronously and their own compilation and linking has been suspended 
	        until that occurs. This hook can be considered analogous to the 
	        ngAfterViewInit and ngAfterContentInit hooks in Angular 2. Since the 
	        compilation process is rather different in Angular 1 there is no direct 
	        mapping and care should be taken when upgrading.
	      */
	      // this.selectSources()
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changesObj) {
	      /*
	        Called whenever one-way bindings are updated. The changesObj is a hash 
	        whose keys are the names of the bound properties that have changed, and 
	        the values are an object of the form 
	        { currentValue, previousValue, isFirstChange() }. 
	        Use this hook to trigger updates within a component such as cloning the 
	        bound value to prevent accidental mutation of the outer value.
	      */
	      this.reset();
	    }
	  }, {
	    key: 'setFactField',
	    value: function setFactField(key, value) {
	      var p = this.q.defer();
	      this.newFact[key] = value;
	
	      if (key === 'sources') {
	        this.displaySources = this.sourcesGrouping.getFactItems(value, null, true);
	      }
	
	      p.resolve();
	      return p.promise;
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      if (this.newFact !== this.fact) {
	        if (!this.busy) {
	          this.busy = true;
	          // timeout to ensure correct date field blur updates fact before save
	          this.timeout(function () {
	            _this.onUpdate({ newFact: _this.newFact }).then(function () {
	              _this.reset();
	            }, function () {
	              _this.busy = false;
	            });
	          }, 0);
	        }
	      } else {
	        this.reset();
	      }
	    }
	  }, {
	    key: 'autofill',
	    value: function autofill(pasteData) {
	      var data = pasteData.html ? String(this.sanitize(pasteData.html)).replace(/<[^>]+>/gm, '') : pasteData.string ? pasteData.string : '';
	      if (data) {
	        var _extractionServ$extra = this.extractionServ.extract(data),
	            factDateish = _extractionServ$extra.factDateish,
	            title = _extractionServ$extra.title;
	
	        if (factDateish && !this.newFact.factDateish) {
	          this.setFactField('factDateish', this.dateParserServ.toFactDateish(factDateish));
	        }
	        if (title && !this.newFact.title) {
	          this.setFactField('title', title);
	        }
	      }
	    }
	  }, {
	    key: 'handleDateUpdate',
	    value: function handleDateUpdate(factDateish) {
	      if (factDateish) {
	        this.newFact.factDateish = factDateish;
	      } else {
	        delete this.newFact.factDateish;
	      }
	    }
	  }, {
	    key: 'showLayer',
	    value: function showLayer(name) {
	      this.layer = name;
	    }
	  }, {
	    key: 'preventDefault',
	    value: function preventDefault(e) {
	      e.stopPropagation();
	    }
	  }, {
	    key: 'selectIssues',
	    value: function selectIssues() {
	      this.issuesTree.api.get();
	      this.showLayer('issue');
	    }
	  }, {
	    key: 'selectTags',
	    value: function selectTags() {
	      this.tagsTree.api.get();
	      this.showLayer('tag');
	    }
	  }, {
	    key: 'selectSources',
	    value: function selectSources() {
	      this.sourcesTree.api.get();
	      this.showLayer('source');
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.layer = ''; // fact attr selector
	      this.busy = false; // fact saving indication
	      this.newFact = angular.copy(this.fact);
	      this.displaySources = this.sourcesGrouping.getFactItems(this.newFact.sources);
	    }
	  }]);
	  return fbFactCtrl;
	}();
	
	exports.default = fbFactCtrl;
	
	fbFactCtrl.$inject = ['$element', '$timeout', '$q', 'ExtractionServ', 'IssuesTreeFactory', 'SourcesTreeFactory', 'SourcesGrouping', 'TagsTreeFactory', '$sanitize', 'DateParserServ'];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _extraction = __webpack_require__(566);
	
	var _extraction2 = _interopRequireDefault(_extraction);
	
	var _fbFact = __webpack_require__(436);
	
	var _fbFact2 = _interopRequireDefault(_fbFact);
	
	var _fbTrix = __webpack_require__(450);
	
	var _fbTrix2 = _interopRequireDefault(_fbTrix);
	
	var _fbEditable = __webpack_require__(300);
	
	var _fbEditable2 = _interopRequireDefault(_fbEditable);
	
	var _fbDateField = __webpack_require__(434);
	
	var _fbDateField2 = _interopRequireDefault(_fbDateField);
	
	var _issues = __webpack_require__(136);
	
	var _issues2 = _interopRequireDefault(_issues);
	
	var _fbIssueSelect = __webpack_require__(439);
	
	var _fbIssueSelect2 = _interopRequireDefault(_fbIssueSelect);
	
	var _tags = __webpack_require__(138);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _fbTagSelect = __webpack_require__(448);
	
	var _fbTagSelect2 = _interopRequireDefault(_fbTagSelect);
	
	var _sources = __webpack_require__(137);
	
	var _sources2 = _interopRequireDefault(_sources);
	
	var _fbSourceSelect = __webpack_require__(446);
	
	var _fbSourceSelect2 = _interopRequireDefault(_fbSourceSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbFact = {
	  template: __webpack_require__(813),
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	    */
	    name: '@',
	    options: '<',
	    fact: '<',
	    case: '<',
	    onCancel: '&',
	    onNext: '&',
	    onUpdate: '&',
	    onToggleCases: '&',
	    onOpenCase: '&'
	  },
	  controller: _fbFact2.default
	};
	
	exports.default = _angular2.default.module('components.fbFact', [_extraction2.default, _fbTrix2.default, _fbEditable2.default, _fbDateField2.default, _fbIssueSelect2.default, _fbTagSelect2.default, _fbSourceSelect2.default, _issues2.default, _sources2.default, _tags2.default]).component('fbFact', fbFact).name;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbIssueSelectCtrl = function () {
	  function fbIssueSelectCtrl(Issue, $filter) {
	    (0, _classCallCheck3.default)(this, fbIssueSelectCtrl);
	
	    this.model = Issue;
	    this.orderBy = $filter('orderBy');
	    this.query = '';
	  }
	
	  (0, _createClass3.default)(fbIssueSelectCtrl, [{
	    key: '$onInit',
	    value: function $onInit() {
	      /*
	        Called on each controller after all the controllers on an element 
	        have been constructed and had their bindings initialized 
	        (and before the pre & post linking functions for the directives on this 
	        element). This is a good place to put initialization code for your controller.
	      */
	      this.reset();
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      /*
	        Called on a controller when its containing scope is destroyed. 
	        Use this hook for releasing external resources, watches and event handlers.
	      */
	
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      /*
	        Called after this controller's element and its children have been linked. 
	        Similar to the post-link function this hook can be used to set up 
	        DOM event handlers and do direct DOM manipulation. Note that child 
	        elements that contain templateUrl directives will not have been compiled 
	        and linked since they are waiting for their template to load 
	        asynchronously and their own compilation and linking has been suspended 
	        until that occurs. This hook can be considered analogous to the 
	        ngAfterViewInit and ngAfterContentInit hooks in Angular 2. Since the 
	        compilation process is rather different in Angular 1 there is no direct 
	        mapping and care should be taken when upgrading.
	      */
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changesObj) {
	      /*
	        Called whenever one-way bindings are updated. The changesObj is a hash 
	        whose keys are the names of the bound properties that have changed, and 
	        the values are an object of the form 
	        { currentValue, previousValue, isFirstChange() }. 
	        Use this hook to trigger updates within a component such as cloning the 
	        bound value to prevent accidental mutation of the outer value.
	      */
	      this.reset();
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.newValue = this.value ? angular.copy(this.value) : [];
	      this.setFilter();
	    }
	  }, {
	    key: 'filterChildren',
	    value: function filterChildren(search, tree) {
	      tree = tree || this.list.data || [];
	      var out = [];
	      var node;
	      for (var i = 0; i < tree.length; i++) {
	        node = tree[i];
	        if (node.displayName.toLowerCase().includes(search.displayName.toLowerCase())) {
	          out.push({ id: node.id, displayName: node.displayName });
	        }
	        if (node.children && node.children.length !== 0) {
	          out = out.concat(this.filterChildren(search, node.children));
	        }
	      }
	
	      return out;
	    }
	  }, {
	    key: 'sortChildren',
	    value: function sortChildren(tree, sort) {
	      var _this = this;
	
	      tree = this.orderBy(tree, sort);
	      tree.forEach(function (node) {
	        if (node.children && node.children.length !== 0) {
	          node.children = _this.sortChildren(node.children, sort);
	        }
	      });
	      return tree;
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter() {
	      this.filteredList = this.list.data || [];
	      if (this.query) {
	        this.filteredList = this.filterChildren({
	          displayName: this.query
	        });
	      }
	      if (this.sort) {
	        this.filteredList = this.sortChildren(this.filteredList, this.sort);
	      }
	    }
	  }, {
	    key: 'addIssue',
	    value: function addIssue(displayName, parent) {
	      var _this2 = this;
	
	      var parentId = parent && parent.id;
	      return new this.model({ displayName: displayName, parentId: parentId }).api.create().then(function (data) {
	        _this2.list.add(data, parent);
	        _this2.toggle(data);
	      });
	    }
	  }, {
	    key: 'createSubIssue',
	    value: function createSubIssue(displayName, parent) {
	      var _this3 = this;
	
	      var parentId = parent.id;
	      return new this.model({ displayName: displayName, parentId: parentId }).api.create().then(function (data) {
	        _this3.list.add(data, parent);
	        _this3.toggle(data);
	      });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(value) {
	      var id = value.id,
	          displayName = value.displayName;
	
	      var index = this.newValue.map(function (i) {
	        return i.id;
	      }).indexOf(id);
	      if (index >= 0) {
	        this.newValue.splice(index, 1);
	      } else {
	        this.newValue.push({ id: id, displayName: displayName });
	      }
	      this.onUpdate({ newValue: this.newValue });
	    }
	  }]);
	  return fbIssueSelectCtrl;
	}();
	
	exports.default = fbIssueSelectCtrl;
	
	fbIssueSelectCtrl.$inject = ['Issue', '$filter'];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fbIssueSelect = __webpack_require__(438);
	
	var _fbIssueSelect2 = _interopRequireDefault(_fbIssueSelect);
	
	var _fbOlSelect = __webpack_require__(207);
	
	var _fbOlSelect2 = _interopRequireDefault(_fbOlSelect);
	
	var _issue = __webpack_require__(317);
	
	var _issue2 = _interopRequireDefault(_issue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbIssueSelect = {
	  template: __webpack_require__(814),
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	    */
	    value: '<',
	    list: '<',
	    data: '<',
	    onUpdate: '&'
	  },
	  controller: _fbIssueSelect2.default
	};
	
	exports.default = _angular2.default.module('components.fbIssueSelect', [_fbOlSelect2.default, _issue2.default]).component('fbIssueSelect', fbIssueSelect).name;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fbLi = __webpack_require__(301);
	
	var _fbLi2 = _interopRequireDefault(_fbLi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbLiSelect = {
	  template: __webpack_require__(815),
	  require: {
	    fbOlSelectCtrl: '^fbOlSelect'
	  },
	  bindings: {
	    /* 
	      Bindings are bound to controller object (this.value)
	      Flow: Data down, events up
	      Data:
	      '<' - one-way data binding that should not be mutated (value)
	      Events: 
	      '&' - callback for a component event (onUpdate(newValue))
	      Comments:
	      '@' - static strings (label)
	    */
	    name: '@',
	    selection: '<',
	    value: '<',
	    onUpdate: '&',
	    onSelect: '&',
	    onCreate: '&'
	  },
	  controller: _fbLi2.default
	};
	
	exports.default = _angular2.default.module('components.fbLiSelect', []).component('fbLiSelect', fbLiSelect).name;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fbLi = __webpack_require__(301);
	
	var _fbLi2 = _interopRequireDefault(_fbLi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbLi = {
	  template: __webpack_require__(816),
	  require: {
	    fbOlCtrl: '^fbOl',
	    uiTree: '^uiTree'
	  },
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	    */
	    name: '@',
	    selectedId: '<',
	    value: '<',
	    onUpdate: '&',
	    onDelete: '&',
	    onSelect: '&',
	    onCreate: '&',
	    onDragover: '&'
	
	  },
	  controller: _fbLi2.default
	};
	
	exports.default = _angular2.default.module('components.fbLi', []).component('fbLi', fbLi).name;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbListFilterCtrl = function () {
	  function fbListFilterCtrl($element, $timeout, FactQuery) {
	    (0, _classCallCheck3.default)(this, fbListFilterCtrl);
	
	    this.element = $element[0];
	    this.timeout = $timeout;
	
	    this.factQuery = FactQuery;
	  }
	
	  (0, _createClass3.default)(fbListFilterCtrl, [{
	    key: '$onInit',
	    value: function $onInit() {
	      /*
	        Called on each controller after all the controllers on an element 
	        have been constructed and had their bindings initialized 
	        (and before the pre & post linking functions for the directives on this 
	        element). This is a good place to put initialization code for your controller.
	      */
	      this.reset();
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      /*
	        Called on a controller when its containing scope is destroyed. 
	        Use this hook for releasing external resources, watches and event handlers.
	      */
	
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      /*
	        Called after this controller's element and its children have been linked. 
	        Similar to the post-link function this hook can be used to set up 
	        DOM event handlers and do direct DOM manipulation. Note that child 
	        elements that contain templateUrl directives will not have been compiled 
	        and linked since they are waiting for their template to load 
	        asynchronously and their own compilation and linking has been suspended 
	        until that occurs. This hook can be considered analogous to the 
	        ngAfterViewInit and ngAfterContentInit hooks in Angular 2. Since the 
	        compilation process is rather different in Angular 1 there is no direct 
	        mapping and care should be taken when upgrading.
	      */
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changesObj) {
	      /*
	        Called whenever one-way bindings are updated. The changesObj is a hash 
	        whose keys are the names of the bound properties that have changed, and 
	        the values are an object of the form 
	        { currentValue, previousValue, isFirstChange() }. 
	        Use this hook to trigger updates within a component such as cloning the 
	        bound value to prevent accidental mutation of the outer value.
	      */
	      this.setHeight();
	    }
	  }, {
	    key: 'setHeight',
	    value: function setHeight() {
	      // subtract the input height from the generic filter body height
	      this.listHeight = this.height && parseInt(this.height.replace('px', '')) - 28.75 + 'px';
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.value = '';
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      if (this.value) {
	        var key = this.excludeMode ? 'excludes' : 'includes';
	        this.list[key] = this.list[key] || [];
	        this.list[key].push(this.value);
	
	        this.update();
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex() {
	      return this.factQuery.data.filterPipeline.map(function (f) {
	        return f.attribute;
	      }).indexOf(this.list.attribute);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this = this;
	
	      var i = this.getIndex();
	      this.factQuery.data.filterPipeline[i] = this.list;
	
	      this.factQuery.api.update().then(function () {
	        _this.reset();
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove(item, key) {
	      var i = this.list[key].indexOf(item);
	      this.list[key].splice(i, 1);
	      if (this.list[key].length === 0) {
	        // set empty state for key
	        this.list[key] = key === 'excludes' ? [] : null;
	      }
	      this.update();
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.list.includes = null;
	      this.list.excludes = [];
	
	      this.update();
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.stopImmediatePropagation();
	      e.preventDefault();
	      switch (e.keyCode) {
	        case 27:
	          this.reset();
	          break;
	        case 13:
	          this.submit();
	          break;
	      }
	    }
	  }]);
	  return fbListFilterCtrl;
	}();
	
	exports.default = fbListFilterCtrl;
	
	fbListFilterCtrl.$inject = ['$element', '$timeout', 'FactQuery'];

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fbListFilter = __webpack_require__(442);
	
	var _fbListFilter2 = _interopRequireDefault(_fbListFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbListFilter = {
	  template: __webpack_require__(817),
	  bindings: {
	    list: '<',
	    height: '<'
	  },
	  controller: _fbListFilter2.default,
	  require: {
	    filterListCtrl: '^lfFilterList'
	  }
	
	};
	
	exports.default = _angular2.default.module('components.fbListFilter', []).component('fbListFilter', fbListFilter).name;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbLoading = {
	  template: __webpack_require__(818),
	  bindings: {
	    value: '<'
	  }
	};
	
	exports.default = _angular2.default.module('components.fb-loading', []).component('fbLoading', fbLoading).name;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiTree = __webpack_require__(424);
	
	var _angularUiTree2 = _interopRequireDefault(_angularUiTree);
	
	__webpack_require__(804);
	
	var _fbOl = __webpack_require__(302);
	
	var _fbOl2 = _interopRequireDefault(_fbOl);
	
	var _emptyItem = __webpack_require__(211);
	
	var _emptyItem2 = _interopRequireDefault(_emptyItem);
	
	var _fbLi = __webpack_require__(441);
	
	var _fbLi2 = _interopRequireDefault(_fbLi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbOl = {
	  template: __webpack_require__(820),
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	    */
	    name: '@',
	    disableCreate: '@',
	    disableDrag: '@',
	    values: '<',
	    onCreate: '&',
	    onDelete: '&',
	    onUpdate: '&'
	  },
	  controller: _fbOl2.default
	};
	
	exports.default = _angular2.default.module('components.fbOl', [_fbLi2.default, _angularUiTree2.default, _emptyItem2.default]).component('fbOl', fbOl).name;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _sources = __webpack_require__(315);
	
	var _sources2 = _interopRequireDefault(_sources);
	
	var _fbOlSelect = __webpack_require__(207);
	
	var _fbOlSelect2 = _interopRequireDefault(_fbOlSelect);
	
	var _source = __webpack_require__(320);
	
	var _source2 = _interopRequireDefault(_source);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbSourceSelect = {
	  template: __webpack_require__(821),
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	    */
	    value: '<',
	    list: '<',
	    onUpdate: '&',
	    onAddBookmark: '&'
	
	  },
	  controller: 'SourcesCtrl',
	  controllerAs: 'sourcesCtrl'
	};
	// import fbSourceSelectCtrl from './fb-source-select.controller'
	exports.default = _angular2.default.module('components.fbSourceSelect', [_fbOlSelect2.default, _source2.default, _sources2.default]).component('fbSourceSelect', fbSourceSelect).name;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbTagSelectCtrl = function () {
	  function fbTagSelectCtrl(Tag, $filter) {
	    (0, _classCallCheck3.default)(this, fbTagSelectCtrl);
	
	    this.model = Tag;
	    this.orderBy = $filter('orderBy');
	    this.filterItems = $filter('filter');
	    this.query = '';
	  }
	
	  (0, _createClass3.default)(fbTagSelectCtrl, [{
	    key: '$onInit',
	    value: function $onInit() {
	      /*
	        Called on each controller after all the controllers on an element 
	        have been constructed and had their bindings initialized 
	        (and before the pre & post linking functions for the directives on this 
	        element). This is a good place to put initialization code for your controller.
	      */
	      this.reset();
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      /*
	        Called on a controller when its containing scope is destroyed. 
	        Use this hook for releasing external resources, watches and event handlers.
	      */
	
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      /*
	        Called after this controller's element and its children have been linked. 
	        Similar to the post-link function this hook can be used to set up 
	        DOM event handlers and do direct DOM manipulation. Note that child 
	        elements that contain templateUrl directives will not have been compiled 
	        and linked since they are waiting for their template to load 
	        asynchronously and their own compilation and linking has been suspended 
	        until that occurs. This hook can be considered analogous to the 
	        ngAfterViewInit and ngAfterContentInit hooks in Angular 2. Since the 
	        compilation process is rather different in Angular 1 there is no direct 
	        mapping and care should be taken when upgrading.
	      */
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changesObj) {
	      /*
	        Called whenever one-way bindings are updated. The changesObj is a hash 
	        whose keys are the names of the bound properties that have changed, and 
	        the values are an object of the form 
	        { currentValue, previousValue, isFirstChange() }. 
	        Use this hook to trigger updates within a component such as cloning the 
	        bound value to prevent accidental mutation of the outer value.
	      */
	      this.reset();
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.newValue = this.value ? angular.copy(this.value) : [];
	      this.setFilter();
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter() {
	      this.filteredList = this.list.data || [];
	      if (this.query) {
	        this.filteredList = this.filterItems(this.filteredList, {
	          displayName: this.query
	        });
	      }
	      if (this.sort) {
	        this.filteredList = this.orderBy(this.filteredList, this.sort);
	      }
	    }
	  }, {
	    key: 'addTag',
	    value: function addTag(displayName) {
	      var _this = this;
	
	      return new this.model({ displayName: displayName }).api.create().then(function (data) {
	        _this.list.add(data);
	        _this.toggle(data);
	      });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(value) {
	      var id = value.id,
	          displayName = value.displayName;
	
	      var index = this.newValue.map(function (i) {
	        return i.id;
	      }).indexOf(id);
	      if (index >= 0) {
	        this.newValue.splice(index, 1);
	      } else {
	        this.newValue.push({ id: id, displayName: displayName });
	      }
	      this.onUpdate({ newValue: this.newValue });
	    }
	  }]);
	  return fbTagSelectCtrl;
	}();
	
	exports.default = fbTagSelectCtrl;
	
	fbTagSelectCtrl.$inject = ['Tag', '$filter'];

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fbTagSelect = __webpack_require__(447);
	
	var _fbTagSelect2 = _interopRequireDefault(_fbTagSelect);
	
	var _fbOlSelect = __webpack_require__(207);
	
	var _fbOlSelect2 = _interopRequireDefault(_fbOlSelect);
	
	var _tag = __webpack_require__(321);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbTagSelect = {
	  template: __webpack_require__(822),
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	    */
	    value: '<',
	    list: '<',
	    data: '<',
	    onUpdate: '&'
	  },
	  controller: _fbTagSelect2.default
	};
	
	exports.default = _angular2.default.module('components.fbTagSelect', [_fbOlSelect2.default, _tag2.default]).component('fbTagSelect', fbTagSelect).name;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(889);
	
	__webpack_require__(805);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Trix Highlight functionality extension 
	Trix.config.textAttributes.highlight = {
	  inheritable: true,
	  tagName: 'mark',
	  style: {
	    "backgroundColor": "#FF0"
	  }
	  // Trix Highlight button HTML, gets inserted in fbTrix.setTrix()
	};var highlightBtn = '<button type="button" data-trix-key="h" class="highlight" data-trix-attribute="highlight" title="Highlight" tabindex="-1">H</button>';
	
	var fbTrix = function () {
	  function fbTrix($element) {
	    (0, _classCallCheck3.default)(this, fbTrix);
	
	    this.element = $element[0];
	    this.trix = this.element.querySelector('trix-editor');
	    this.trixContent = this.element.querySelector('#trix-content');
	
	    // Bind methods to this so init and destroy can ref same method
	    this.setModel = this.setModel.bind(this);
	    this.setTrix = this.setTrix.bind(this);
	    this.focus = this.focus.bind(this);
	    this.blur = this.blur.bind(this);
	    this.paste = this.paste.bind(this);
	    this.handleFile = this.handleFile.bind(this);
	  }
	
	  (0, _createClass3.default)(fbTrix, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      /*
	        Called on each controller after all the controllers on an element 
	        have been constructed and had their bindings initialized 
	        (and before the pre & post linking functions for the directives on this 
	        element). This is a good place to put initialization code for your controller.
	      */
	      this.trix.addEventListener('trix-initialize', this.setTrix);
	      this.trix.addEventListener('trix-change', this.setModel);
	      this.trix.addEventListener('trix-paste', this.paste);
	      this.trix.addEventListener('trix-focus', this.focus);
	      this.trix.addEventListener('trix-blur', this.blur);
	      this.trix.addEventListener('trix-file-accept', this.handleFile);
	      // this.element.addEventListener('focusin', this.focus)
	      // this.element.addEventListener('focusout', this.blur)
	
	      // this.ngModel.$render = () => {
	      // this.setTrix()
	      // }
	
	      this.ngModel.$render = function () {
	        _this.setTrix();
	      };
	
	      // 'trix-initialize','trix-change','trix-selection-change','trix-focus',
	      // 'trix-blur','trix-file-accept','trix-attachment-add',
	      // 'trix-attachment-remove',  
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      /*
	        Called on a controller when its containing scope is destroyed. 
	        Use this hook for releasing external resources, watches and event handlers.
	      */
	      this.trix.removeEventListener('trix-initialize', this.setTrix);
	      this.trix.removeEventListener('trix-change', this.setModel);
	      this.trix.removeEventListener('trix-paste', this.paste);
	      this.trix.removeEventListener('trix-focus', this.focus);
	      this.trix.removeEventListener('trix-blur', this.blur);
	      this.trix.removeEventListener('trix-file-accept', this.handleFile);
	      // this.element.removeEventListener('focusin', this.focus)
	      // this.element.removeEventListener('focusout', this.blur)
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      /*
	        Called after this controller's element and its children have been linked. 
	        Similar to the post-link function this hook can be used to set up 
	        DOM event handlers and do direct DOM manipulation. Note that child 
	        elements that contain templateUrl directives will not have been compiled 
	        and linked since they are waiting for their template to load 
	        asynchronously and their own compilation and linking has been suspended 
	        until that occurs. This hook can be considered analogous to the 
	        ngAfterViewInit and ngAfterContentInit hooks in Angular 2. Since the 
	        compilation process is rather different in Angular 1 there is no direct 
	        mapping and care should be taken when upgrading.
	      */
	
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changesObj) {
	      /*
	        Called whenever one-way bindings are updated. The changesObj is a hash 
	        whose keys are the names of the bound properties that have changed, and 
	        the values are an object of the form 
	        { currentValue, previousValue, isFirstChange() }. 
	        Use this hook to trigger updates within a component such as cloning the 
	        bound value to prevent accidental mutation of the outer value.
	      */
	      if (!changesObj.isFirstChange) {
	        // this.setTrix()
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.element.classList.add('focused');
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      // this.setModel()
	      // this.element.classList.remove('focused')
	    }
	  }, {
	    key: 'paste',
	    value: function paste(e) {
	      this.fbOnPaste({ pasteData: e.pasteData });
	    }
	  }, {
	    key: 'handleFile',
	    value: function handleFile(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {}
	  }, {
	    key: 'setTrix',
	    value: function setTrix() {
	      if (this.trix.editor) {
	        this.trix.editor.loadHTML(this.ngModel.$modelValue);
	        if (!this.addedHighlightBtn) {
	          this.addedHighlightBtn = true;
	          this.textToolbar = this.element.querySelector(".text_tools");
	          this.textToolbar.insertAdjacentHTML("beforeend", highlightBtn);
	        }
	      }
	    }
	  }, {
	    key: 'setModel',
	    value: function setModel() {
	      this.ngModel.$setViewValue(this.trixContent.value);
	    }
	  }]);
	  return fbTrix;
	}();
	
	exports.default = fbTrix;
	
	fbTrix.$inject = ['$element'];

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fbTrix = __webpack_require__(449);
	
	var _fbTrix2 = _interopRequireDefault(_fbTrix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbTrix = {
	  template: __webpack_require__(823),
	  require: { ngModel: 'ngModel' },
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	    */
	    fbOnPaste: '&',
	    fbTrixPreventFile: '@',
	    fbTrixInit: '&',
	    fbTrixChange: '&',
	    fbTrixSelectionChange: '&',
	    fbTrixFocus: '&',
	    fbTrixBlur: '&',
	    fbTrixFileAccept: '&',
	    fbTrixAttachmentAdd: '&',
	    fbTrixAttachmentRemove: '&'
	  },
	  controller: _fbTrix2.default
	};
	
	exports.default = _angular2.default.module('components.fb-trix', []).component('fbTrix', fbTrix).name;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbUploadCtrl = function () {
	  function fbUploadCtrl($element, $timeout, UploadServ, $routeParams, $window) {
	    (0, _classCallCheck3.default)(this, fbUploadCtrl);
	
	    this.uploadServ = UploadServ;
	    this.caseId = $routeParams.caseId;
	    this.element = $element[0];
	    this.timeout = $timeout;
	    this.window = $window;
	    this.sizeLimit = 250e6; // 250 MB
	    this.onFileDrop = this.onFileDrop.bind(this);
	    this.handleProgress = this.handleProgress.bind(this);
	    this.handleSuccess = this.handleSuccess.bind(this);
	    this.handleError = this.handleError.bind(this);
	    this.onInputChange = this.onInputChange.bind(this);
	  }
	
	  (0, _createClass3.default)(fbUploadCtrl, [{
	    key: '$onInit',
	    value: function $onInit() {
	      /*
	        Called on each controller after all the controllers on an element 
	        have been constructed and had their bindings initialized 
	        (and before the pre & post linking functions for the directives on this 
	        element). This is a good place to put initialization code for your controller.
	      */
	      this.reset();
	      this.uploadInput = this.element.querySelector('#fb-upload-input');
	      this.uploadInput.addEventListener('change', this.onInputChange);
	
	      this.element.addEventListener('drag dragstart dragend dragover dragenter dragleave', this.handleGlobalDrop, false);
	      this.element.addEventListener('drop', this.onFileDrop);
	
	      this.window.addEventListener('dragover', this.handleGlobalDrop, false);
	      this.window.addEventListener('drop', this.handleGlobalDrop, false);
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      /*
	        Called on a controller when its containing scope is destroyed. 
	        Use this hook for releasing external resources, watches and event handlers.
	      */
	      this.uploadInput.removeEventListener('change', this.onInputChange);
	
	      this.element.removeEventListener('drag dragstart dragend dragover dragenter dragleave', this.handleGlobalDrop, false);
	      this.element.removeEventListener('drop', this.onFileDrop);
	
	      this.window.removeEventListener('dragover', this.handleGlobalDrop);
	      this.window.removeEventListener('drop', this.handleGlobalDrop);
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      /*
	        Called after this controller's element and its children have been linked. 
	        Similar to the post-link function this hook can be used to set up 
	        DOM event handlers and do direct DOM manipulation. Note that child 
	        elements that contain templateUrl directives will not have been compiled 
	        and linked since they are waiting for their template to load 
	        asynchronously and their own compilation and linking has been suspended 
	        until that occurs. This hook can be considered analogous to the 
	        ngAfterViewInit and ngAfterContentInit hooks in Angular 2. Since the 
	        compilation process is rather different in Angular 1 there is no direct 
	        mapping and care should be taken when upgrading.
	      */
	    }
	  }, {
	    key: '$onChanges',
	    value: function $onChanges(changesObj) {
	      /*
	        Called whenever one-way bindings are updated. The changesObj is a hash 
	        whose keys are the names of the bound properties that have changed, and 
	        the values are an object of the form 
	        { currentValue, previousValue, isFirstChange() }. 
	        Use this hook to trigger updates within a component such as cloning the 
	        bound value to prevent accidental mutation of the outer value.
	      */
	      this.reset();
	    }
	  }, {
	    key: 'onFileDrop',
	    value: function onFileDrop(e) {
	      e.stopPropagation();
	      e.preventDefault();
	      var files = e.dataTransfer.files;
	      this.handleUpload(files);
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(e) {
	      var files = this.element.querySelector('#fb-upload-input').files;
	      this.handleUpload(files);
	    }
	  }, {
	    key: 'handleUpload',
	    value: function handleUpload(files) {
	      this.files = [];
	      for (var i = files.length - 1; i >= 0; i--) {
	        this.files.push(files[i]);
	      }
	      this.inProgress = true;
	      this.uploadServ.upload('/case/' + this.caseId + '/source', files, this.handleProgress).then(this.handleSuccess, this.handleError);
	    }
	  }, {
	    key: 'handleProgress',
	    value: function handleProgress(data) {
	      // callback for xhr upload progress event
	      this.progress = data.loaded / data.total * 100 + '%';
	    }
	  }, {
	    key: 'handleSuccess',
	    value: function handleSuccess(data) {
	      var _this = this;
	
	      this.inProgress = false;
	      this.success = true; // []
	
	      // data.sources -> add to list
	      this.onSuccess({ files: data.data.sources });
	
	      this.timeout(function () {
	        // reset after 2 seconds
	        _this.reset();
	      }, 3000);
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(response) {
	      this.inProgress = false;
	      this.error = response.data; // {}
	    }
	  }, {
	    key: 'handleGlobalDrop',
	    value: function handleGlobalDrop(e) {
	      e.stopPropagation();
	      e.preventDefault();
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.files = []; // name: test.aif, size: 284, type: audio/aiff, lastModifiedDate
	      this.progress = 0; // 0.0 ... 1.0
	      this.success = false;
	      this.error = null;
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      if (this.newValue !== this.value && this.newValue.length) {
	        this.onUpdate({ newValue: this.newValue }).then(function () {
	          _this2.reset();
	        });
	      } else {
	        this.reset();
	      }
	    }
	  }, {
	    key: 'setEditMode',
	    value: function setEditMode(setUpload) {
	      var _this3 = this;
	
	      if (setUpload) {
	        this.editMode = true;
	
	        var width = this.element.querySelector('.editable-text').offsetWidth;
	        this.element.querySelector('.editable-field').style.width = width + 'px';
	        this.timeout(function () {
	          return _this3.element.querySelector('input').focus();
	        });
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.stopImmediatePropagation();
	      e.preventDefault();
	      switch (e.type) {
	        case 'blur':
	          this.submit();
	          break;
	        case 'keyup':
	          switch (e.keyCode) {
	            case 27:
	              this.reset();
	              break;
	            case 13:
	              this.submit();
	              break;
	          }
	      }
	    }
	  }]);
	  return fbUploadCtrl;
	}();
	
	exports.default = fbUploadCtrl;
	
	fbUploadCtrl.$inject = ['$element', '$timeout', 'UploadServ', '$routeParams', '$window'];

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _upload = __webpack_require__(568);
	
	var _upload2 = _interopRequireDefault(_upload);
	
	var _fbUpload = __webpack_require__(451);
	
	var _fbUpload2 = _interopRequireDefault(_fbUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fbUpload = {
	  template: __webpack_require__(824),
	  bindings: {
	    /* 
	      Inputs
	      hero: '<',    // one-way binding, changing shoudln't update parent scope
	                       mutations to objects or arrays should occur in parent
	      comment: '@'  // for static strings
	      Outputs: & bindings, callbacks for component events
	      onDelete: '&'
	      onUpdate: '&'
	    */
	    name: '@',
	    value: '<',
	    onSuccess: '&'
	  },
	  controller: _fbUpload2.default
	};
	
	exports.default = _angular2.default.module('components.fbUpload', [_upload2.default]).component('fbUpload', fbUpload).name;

/***/ }),
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ActionGuide = {
	  steps: {
	    viewby: {
	      key: 'viewby',
	      context: 'home',
	      attach: {
	        target: 'lf-filter-tree header',
	        location: 'right-top'
	      },
	      watch: {
	        target: 'lf-filter-tree header .uib-dropdown-menu',
	        event: 'click'
	      },
	      hintStyle: {
	        left: '10px',
	        top: '25px',
	        transform: 'rotate(90deg)',
	        animationName: 'hintLeft'
	      }
	    },
	    selection: {
	      key: 'selection',
	      context: 'home',
	      attach: {
	        target: 'lf-filter-tree .filter-body',
	        location: 'right-top'
	      },
	      watch: {
	        target: 'lf-filter-tree .filter-body',
	        event: 'click'
	      },
	      hintStyle: {
	        left: '10px',
	        top: '10px',
	        transform: 'rotate(90deg)',
	        animationName: 'hintLeft'
	      }
	    },
	    format: {
	      key: 'format',
	      context: 'home',
	      attach: {
	        target: '#fact-view-toggle',
	        location: 'bottom-left'
	      },
	      watch: {
	        target: '#fact-view-toggle',
	        event: 'click'
	      },
	      hintStyle: {
	        left: '100px',
	        top: '5px',
	        transform: 'rotate(180deg)',
	        animationName: 'hintTop'
	      }
	    },
	    columns: {
	      key: 'columns',
	      context: 'home',
	      attach: {
	        target: '#column-visibility-toggle',
	        location: 'left-top'
	      },
	      watch: {
	        target: '#column-visibility-toggle .uib-dropdown-menu',
	        event: 'click'
	      },
	      hintStyle: {
	        right: '10px',
	        top: '5px',
	        transform: 'rotate(-90deg)',
	        animationName: 'hintRight'
	      }
	    },
	    generate: {
	      key: 'generate',
	      context: 'home',
	      attach: {
	        target: '#link-generate',
	        location: 'bottom-right'
	      },
	      watch: {
	        target: '#link-generate',
	        event: 'click'
	      },
	      hintStyle: {
	        right: '43px',
	        top: '5px',
	        transform: 'rotate(180deg)',
	        animationName: 'hintTop'
	      }
	    },
	    case: {
	      key: 'case',
	      context: 'home',
	      attach: {
	        target: '[ng-click="caseModal()"]',
	        location: 'bottom-left'
	      },
	      watch: {
	        target: 'window',
	        event: 'hashchange'
	      },
	      hintStyle: {
	        left: '50px',
	        top: '5px',
	        transform: 'rotate(180deg)',
	        animationName: 'hintTop'
	      }
	    },
	    fact: {
	      key: 'fact',
	      context: 'home',
	      attach: {
	        target: '#link-add-fact',
	        location: 'bottom-right'
	      },
	      watch: {
	        target: '#link-add-fact',
	        event: 'click'
	      },
	      hintStyle: {
	        right: '43px',
	        top: '5px',
	        transform: 'rotate(180deg)',
	        animationName: 'hintTop'
	      },
	      skipComplete: true
	    },
	    paste: {
	      key: 'paste',
	      context: 'fact',
	      attach: {
	        target: 'trix-editor',
	        location: 'top-left'
	      },
	      watch: {
	        target: 'trix-editor',
	        event: 'trix-paste'
	      },
	      hintStyle: {
	        left: '15px',
	        bottom: '5px',
	        animationName: 'hintBottom'
	      },
	      manualPosition: true,
	      elementStyle: {
	        top: '48px',
	        left: '112px'
	      }
	    },
	    save: {
	      key: 'save',
	      context: 'fact',
	      attach: {
	        target: '#add-fact',
	        location: 'bottom-right'
	      },
	      watch: {
	        target: '#add-fact',
	        event: 'click'
	      },
	      hintStyle: {
	        right: '18px',
	        top: '5px',
	        transform: 'rotate(180deg)',
	        animationName: 'hintTop'
	      }
	    },
	    navHome: {
	      key: 'navHome',
	      context: 'fact',
	      attach: {
	        target: '[ng-click="$ctrl.onOpenCase()"]',
	        location: 'bottom-left'
	      },
	      watch: {
	        target: '[ng-click="$ctrl.onOpenCase()"]',
	        event: 'click'
	      },
	      hintStyle: {
	        left: '20px',
	        top: '5px',
	        transform: 'rotate(180deg)',
	        animationName: 'hintTop'
	      },
	      skipComplete: true
	    },
	    conclusion: {
	      key: 'conclusion',
	      context: 'home',
	      attach: {
	        target: '.navbar-admin',
	        location: 'top-center'
	      },
	      watch: {
	        target: 'body',
	        event: 'click'
	      },
	      cta: 'Finish',
	      complete: true
	    },
	    close: {
	      key: 'close',
	      context: 'home',
	      attach: {
	        target: '#nav-item-info',
	        location: 'left-top'
	      },
	      watch: {
	        target: '[ng-click="actionGuide.finish()"]',
	        event: 'click'
	      },
	      hintStyle: {
	        right: '10px',
	        top: '5px',
	        transform: 'rotate(-90deg)',
	        animationName: 'hintRight'
	      },
	      cta: 'Close',
	      skipComplete: true
	    }
	  },
	  guides: {
	    full: ['viewby', 'selection', 'format', 'columns', 'generate', 'case', 'fact', 'paste', 'save', 'navHome'],
	    analysis: ['viewby', 'selection'],
	    output: ['format', 'columns', 'generate'],
	    input: ['case', 'fact', 'paste', 'save', 'navHome']
	  }
	};
	
	exports.default = angular.module('contants.action-guide', []).constant('ActionGuide', ActionGuide).name;

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var CallingCodes = [{
		"name": "United States of America (+1)",
		"code": "1"
	}, {
		"name": "Canada (+1)",
		"code": "1"
	}, {
		"name": "Russia (+7)",
		"code": "7"
	}, {
		"name": "Kazakhstan (+7)",
		"code": "7"
	}, {
		"name": "Egypt (+20)",
		"code": "20"
	}, {
		"name": "South Africa (+27)",
		"code": "27"
	}, {
		"name": "Greece (+30)",
		"code": "30"
	}, {
		"name": "Netherlands (+31)",
		"code": "31"
	}, {
		"name": "Belgium (+32)",
		"code": "32"
	}, {
		"name": "France (+33)",
		"code": "33"
	}, {
		"name": "Spain (+34)",
		"code": "34"
	}, {
		"name": "Hungary (+36)",
		"code": "36"
	}, {
		"name": "Italy (+39)",
		"code": "39"
	}, {
		"name": "Romania (+40)",
		"code": "40"
	}, {
		"name": "Switzerland (+41)",
		"code": "41"
	}, {
		"name": "Austria (+43)",
		"code": "43"
	}, {
		"name": "United Kingdom (+44)",
		"code": "44"
	}, {
		"name": "Guernsey (+44)",
		"code": "44"
	}, {
		"name": "Isle of Man (+44)",
		"code": "44"
	}, {
		"name": "Jersey (+44)",
		"code": "44"
	}, {
		"name": "Denmark (+45)",
		"code": "45"
	}, {
		"name": "Sweden (+46)",
		"code": "46"
	}, {
		"name": "Norway (+47)",
		"code": "47"
	}, {
		"name": "Poland (+48)",
		"code": "48"
	}, {
		"name": "Germany (+49)",
		"code": "49"
	}, {
		"name": "Peru (+51)",
		"code": "51"
	}, {
		"name": "Mexico (+52)",
		"code": "52"
	}, {
		"name": "Cuba (+53)",
		"code": "53"
	}, {
		"name": "Argentina (+54)",
		"code": "54"
	}, {
		"name": "Brazil (+55)",
		"code": "55"
	}, {
		"name": "Chile (+56)",
		"code": "56"
	}, {
		"name": "Colombia (+57)",
		"code": "57"
	}, {
		"name": "Venezuela (+58)",
		"code": "58"
	}, {
		"name": "Malaysia (+60)",
		"code": "60"
	}, {
		"name": "Australia (+61)",
		"code": "61"
	}, {
		"name": "Indonesia (+62)",
		"code": "62"
	}, {
		"name": "Philippines (+63)",
		"code": "63"
	}, {
		"name": "New Zealand (+64)",
		"code": "64"
	}, {
		"name": "Singapore (+65)",
		"code": "65"
	}, {
		"name": "Thailand (+66)",
		"code": "66"
	}, {
		"name": "Japan (+81)",
		"code": "81"
	}, {
		"name": "Korea (+South) (+82)",
		"code": "82"
	}, {
		"name": "Vietnam (+84)",
		"code": "84"
	}, {
		"name": "China (+86)",
		"code": "86"
	}, {
		"name": "Turkey (+90)",
		"code": "90"
	}, {
		"name": "India (+91)",
		"code": "91"
	}, {
		"name": "Pakistan (+92)",
		"code": "92"
	}, {
		"name": "Afghanistan (+93)",
		"code": "93"
	}, {
		"name": "Sri Lanka (+94)",
		"code": "94"
	}, {
		"name": "Myanmar (+95)",
		"code": "95"
	}, {
		"name": "Iran (+98)",
		"code": "98"
	}, {
		"name": "Morocco (+212)",
		"code": "212"
	}, {
		"name": "Algeria (+213)",
		"code": "213"
	}, {
		"name": "Tunisia (+216)",
		"code": "216"
	}, {
		"name": "Libya (+218)",
		"code": "218"
	}, {
		"name": "Gambia (+220)",
		"code": "220"
	}, {
		"name": "Senegal (+221)",
		"code": "221"
	}, {
		"name": "Mauritania (+222)",
		"code": "222"
	}, {
		"name": "Mali Republic (+223)",
		"code": "223"
	}, {
		"name": "Guinea (+224)",
		"code": "224"
	}, {
		"name": "Ivory Coast (+225)",
		"code": "225"
	}, {
		"name": "Burkina Faso (+226)",
		"code": "226"
	}, {
		"name": "Niger (+227)",
		"code": "227"
	}, {
		"name": "Togo (+228)",
		"code": "228"
	}, {
		"name": "Benin (+229)",
		"code": "229"
	}, {
		"name": "Mauritius (+230)",
		"code": "230"
	}, {
		"name": "Liberia (+231)",
		"code": "231"
	}, {
		"name": "Sierra Leone (+232)",
		"code": "232"
	}, {
		"name": "Ghana (+233)",
		"code": "233"
	}, {
		"name": "Nigeria (+234)",
		"code": "234"
	}, {
		"name": "Chad (+235)",
		"code": "235"
	}, {
		"name": "Central African Republic (+236)",
		"code": "236"
	}, {
		"name": "Cameroon (+237)",
		"code": "237"
	}, {
		"name": "Cape Verde Islands (+238)",
		"code": "238"
	}, {
		"name": "Sao Tome and Principe (+239)",
		"code": "239"
	}, {
		"name": "Gabon (+241)",
		"code": "241"
	}, {
		"name": "Congo, Democratic Republ (+243)",
		"code": "243"
	}, {
		"name": "Angola (+244)",
		"code": "244"
	}, {
		"name": "Guinea-Bissau (+245)",
		"code": "245"
	}, {
		"name": "Seychelles (+248)",
		"code": "248"
	}, {
		"name": "Sudan (+249)",
		"code": "249"
	}, {
		"name": "Rwanda (+250)",
		"code": "250"
	}, {
		"name": "Ethiopia (+251)",
		"code": "251"
	}, {
		"name": "Somalia (+252)",
		"code": "252"
	}, {
		"name": "Djibouti (+253)",
		"code": "253"
	}, {
		"name": "Kenya (+254)",
		"code": "254"
	}, {
		"name": "Tanzania (+255)",
		"code": "255"
	}, {
		"name": "Uganda (+256)",
		"code": "256"
	}, {
		"name": "Burundi (+257)",
		"code": "257"
	}, {
		"name": "Mozambique (+258)",
		"code": "258"
	}, {
		"name": "Zambia (+260)",
		"code": "260"
	}, {
		"name": "Madagascar (+261)",
		"code": "261"
	}, {
		"name": "Reunion (+262)",
		"code": "262"
	}, {
		"name": "Zimbabwe (+263)",
		"code": "263"
	}, {
		"name": "Namibia (+264)",
		"code": "264"
	}, {
		"name": "Malawi (+265)",
		"code": "265"
	}, {
		"name": "Lesotho (+266)",
		"code": "266"
	}, {
		"name": "Botswana (+267)",
		"code": "267"
	}, {
		"name": "Swaziland (+268)",
		"code": "268"
	}, {
		"name": "Mayotte Island (+269)",
		"code": "269"
	}, {
		"name": "Aruba (+297)",
		"code": "297"
	}, {
		"name": "Faroe Islands (+298)",
		"code": "298"
	}, {
		"name": "Greenland (+299)",
		"code": "299"
	}, {
		"name": "Gibraltar (+350)",
		"code": "350"
	}, {
		"name": "Portugal (+351)",
		"code": "351"
	}, {
		"name": "Luxembourg (+352)",
		"code": "352"
	}, {
		"name": "Ireland (+353)",
		"code": "353"
	}, {
		"name": "Iceland (+354)",
		"code": "354"
	}, {
		"name": "Albania (+355)",
		"code": "355"
	}, {
		"name": "Malta (+356)",
		"code": "356"
	}, {
		"name": "Cyprus (+357)",
		"code": "357"
	}, {
		"name": "Finland (+358)",
		"code": "358"
	}, {
		"name": "Bulgaria (+359)",
		"code": "359"
	}, {
		"name": "Lithuania (+370)",
		"code": "370"
	}, {
		"name": "Latvia (+371)",
		"code": "371"
	}, {
		"name": "Estonia (+372)",
		"code": "372"
	}, {
		"name": "Moldova (+373)",
		"code": "373"
	}, {
		"name": "Armenia (+374)",
		"code": "374"
	}, {
		"name": "Belarus (+375)",
		"code": "375"
	}, {
		"name": "Andorra (+376)",
		"code": "376"
	}, {
		"name": "Monaco (+377)",
		"code": "377"
	}, {
		"name": "San Marino (+378)",
		"code": "378"
	}, {
		"name": "Ukraine (+380)",
		"code": "380"
	}, {
		"name": "Serbia (+381)",
		"code": "381"
	}, {
		"name": "Montenegro (+382)",
		"code": "382"
	}, {
		"name": "Croatia (+385)",
		"code": "385"
	}, {
		"name": "Slovenia (+386)",
		"code": "386"
	}, {
		"name": "Bosnia-Herzegovina (+387)",
		"code": "387"
	}, {
		"name": "Macedonia (+389)",
		"code": "389"
	}, {
		"name": "Czech Republic (+420)",
		"code": "420"
	}, {
		"name": "Slovakia (+421)",
		"code": "421"
	}, {
		"name": "Liechtenstein (+423)",
		"code": "423"
	}, {
		"name": "Falkland Islands (+500)",
		"code": "500"
	}, {
		"name": "Belize (+501)",
		"code": "501"
	}, {
		"name": "Guatemala (+502)",
		"code": "502"
	}, {
		"name": "El Salvador (+503)",
		"code": "503"
	}, {
		"name": "Honduras (+504)",
		"code": "504"
	}, {
		"name": "Nicaragua (+505)",
		"code": "505"
	}, {
		"name": "Costa Rica (+506)",
		"code": "506"
	}, {
		"name": "Panama (+507)",
		"code": "507"
	}, {
		"name": "Haiti (+509)",
		"code": "509"
	}, {
		"name": "Guadeloupe (+590)",
		"code": "590"
	}, {
		"name": "Bolivia (+591)",
		"code": "591"
	}, {
		"name": "Guyana (+592)",
		"code": "592"
	}, {
		"name": "Ecuador (+593)",
		"code": "593"
	}, {
		"name": "French Guiana (+594)",
		"code": "594"
	}, {
		"name": "Paraguay (+595)",
		"code": "595"
	}, {
		"name": "Martinique (+596)",
		"code": "596"
	}, {
		"name": "Suriname (+597)",
		"code": "597"
	}, {
		"name": "Uruguay (+598)",
		"code": "598"
	}, {
		"name": "Netherlands Antilles (+599)",
		"code": "599"
	}, {
		"name": "Timor-Leste (+670)",
		"code": "670"
	}, {
		"name": "Guam (+1671)",
		"code": "1671"
	}, {
		"name": "Brunei (+673)",
		"code": "673"
	}, {
		"name": "Nauru (+674)",
		"code": "674"
	}, {
		"name": "Papua New Guinea (+675)",
		"code": "675"
	}, {
		"name": "Tonga (+676)",
		"code": "676"
	}, {
		"name": "Solomon Islands (+677)",
		"code": "677"
	}, {
		"name": "Vanuatu (+678)",
		"code": "678"
	}, {
		"name": "Fiji Islands (+679)",
		"code": "679"
	}, {
		"name": "Cook Islands (+682)",
		"code": "682"
	}, {
		"name": "Samoa (+685)",
		"code": "685"
	}, {
		"name": "New Caledonia (+687)",
		"code": "687"
	}, {
		"name": "French Polynesia (+689)",
		"code": "689"
	}, {
		"name": "Korea (+North) (+850)",
		"code": "850"
	}, {
		"name": "HongKong (+852)",
		"code": "852"
	}, {
		"name": "Macau (+853)",
		"code": "853"
	}, {
		"name": "Cambodia (+855)",
		"code": "855"
	}, {
		"name": "Laos (+856)",
		"code": "856"
	}, {
		"name": "Bangladesh (+880)",
		"code": "880"
	}, {
		"name": "International (+882)",
		"code": "882"
	}, {
		"name": "Taiwan (+886)",
		"code": "886"
	}, {
		"name": "Maldives (+960)",
		"code": "960"
	}, {
		"name": "Lebanon (+961)",
		"code": "961"
	}, {
		"name": "Jordan (+962)",
		"code": "962"
	}, {
		"name": "Syria (+963)",
		"code": "963"
	}, {
		"name": "Iraq (+964)",
		"code": "964"
	}, {
		"name": "Kuwait (+965)",
		"code": "965"
	}, {
		"name": "Saudi Arabia (+966)",
		"code": "966"
	}, {
		"name": "Yemen (+967)",
		"code": "967"
	}, {
		"name": "Oman (+968)",
		"code": "968"
	}, {
		"name": "Palestine (+970)",
		"code": "970"
	}, {
		"name": "United Arab Emirates (+971)",
		"code": "971"
	}, {
		"name": "Israel (+972)",
		"code": "972"
	}, {
		"name": "Bahrain (+973)",
		"code": "973"
	}, {
		"name": "Qatar (+974)",
		"code": "974"
	}, {
		"name": "Bhutan (+975)",
		"code": "975"
	}, {
		"name": "Mongolia (+976)",
		"code": "976"
	}, {
		"name": "Nepal (+977)",
		"code": "977"
	}, {
		"name": "Tajikistan (+992)",
		"code": "992"
	}, {
		"name": "Turkmenistan (+993)",
		"code": "993"
	}, {
		"name": "Azerbaijan (+994)",
		"code": "994"
	}, {
		"name": "Georgia (+995)",
		"code": "995"
	}, {
		"name": "Kyrgyzstan (+996)",
		"code": "996"
	}, {
		"name": "Uzbekistan (+998)",
		"code": "998"
	}, {
		"name": "Bahamas (+1242)",
		"code": "1242"
	}, {
		"name": "Barbados (+1246)",
		"code": "1246"
	}, {
		"name": "Anguilla (+1264)",
		"code": "1264"
	}, {
		"name": "Antigua and Barbuda (+1268)",
		"code": "1268"
	}, {
		"name": "Virgin Islands, British (+1284)",
		"code": "1284"
	}, {
		"name": "Cayman Islands (+1345)",
		"code": "1345"
	}, {
		"name": "Bermuda (+1441)",
		"code": "1441"
	}, {
		"name": "Grenada (+1473)",
		"code": "1473"
	}, {
		"name": "Turks and Caicos Islands (+1649)",
		"code": "1649"
	}, {
		"name": "Montserrat (+1664)",
		"code": "1664"
	}, {
		"name": "Saint Lucia (+1758)",
		"code": "1758"
	}, {
		"name": "Dominica (+1767)",
		"code": "1767"
	}, {
		"name": "St. Vincent and The Gren (+1784)",
		"code": "1784"
	}, {
		"name": "Puerto Rico (+1787)",
		"code": "1787"
	}, {
		"name": "Dominican Republic (+1809)",
		"code": "1809"
	}, {
		"name": "Dominican Republic2 (+1829)",
		"code": "1829"
	}, {
		"name": "Dominican Republic3 (+1849)",
		"code": "1849"
	}, {
		"name": "Trinidad and Tobago (+1868)",
		"code": "1868"
	}, {
		"name": "Saint Kitts and Nevis (+1869)",
		"code": "1869"
	}, {
		"name": "Jamaica (+1876)",
		"code": "1876"
	}, {
		"name": "Congo (+242)",
		"code": "242"
	}];
	exports.default = angular.module('contants.calling-codes', []).constant('CallingCodes', CallingCodes).name;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ExtractionConst = {
	  /*
	      regex 'genes' for building regex date format strings
	  */
	  matchers: {
	    shortYear: "(\\d{2})",
	    year: "(1[0-9]\\d{2}|2[0-9]\\d{2})",
	    month: "(\\d{1,2})",
	    dispMonth: "(january|february|march|april|may|june|july|august|september|october|november|december|jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)",
	    date: "(\\d{1,2})",
	    hour: "(\\d{1,2})",
	    min: "(\\d{2})",
	    sec: "(\\d{2})",
	    clock: "(pm)?",
	    sep: "[\\/\\-\.]",
	    gap: '.{1,2}',
	    space: '\\s?',
	    wordSpace: '\\D{1,25}'
	  },
	  /*
	  recognized date formats, consumed as regex strings in `parseDate`
	  */
	  tests: [['year'], ['dispMonth', ' ', 'year'], ['month', 'sep', 'date', 'sep', 'shortYear'], ['month', 'sep', 'date', 'sep', 'year'], ['dispMonth', ' ', 'date', 'gap', 'year'], ['hour', 'space', 'clock', 'wordSpace', 'dispMonth', ' ', 'date', ', ', 'year'], ['hour', ':', 'min', 'space', 'clock', 'wordSpace', 'dispMonth', ' ', 'date', ', ', 'year'], ['hour', ':', 'min', ':', 'sec', 'space', 'clock', 'wordSpace', 'dispMonth', ' ', 'date', ', ', 'year'], ['month', 'sep', 'date', 'sep', 'year', ' ', 'hour', 'space', 'clock'], ['month', 'sep', 'date', 'sep', 'year', ' ', 'hour', ':', 'min', 'space', 'clock'], ['month', 'sep', 'date', 'sep', 'year', ' ', 'hour', ':', 'min', ':', 'sec', 'space', 'clock'], ['dispMonth', ' ', 'date', ', ', 'year', 'wordSpace', 'hour', 'space', 'clock'], ['dispMonth', ' ', 'date', ', ', 'year', 'wordSpace', 'hour', ':', 'min', 'space', 'clock'], ['dispMonth', ' ', 'date', ', ', 'year', 'wordSpace', 'hour', ':', 'min', ':', 'sec', 'space', 'clock']]
	
	};
	exports.default = angular.module('contants.extraction', []).constant('ExtractionConst', ExtractionConst).name;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _account = __webpack_require__(75);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _customer = __webpack_require__(135);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _accountMap = __webpack_require__(316);
	
	var _accountMap2 = _interopRequireDefault(_accountMap);
	
	var _paymentStatus = __webpack_require__(223);
	
	var _paymentStatus2 = _interopRequireDefault(_paymentStatus);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _reload = __webpack_require__(139);
	
	var _reload2 = _interopRequireDefault(_reload);
	
	var _clio = __webpack_require__(162);
	
	var _clio2 = _interopRequireDefault(_clio);
	
	var _createCase = __webpack_require__(495);
	
	var _createCase2 = _interopRequireDefault(_createCase);
	
	var _referral = __webpack_require__(313);
	
	var _referral2 = _interopRequireDefault(_referral);
	
	var _subscriptionStatus = __webpack_require__(517);
	
	var _subscriptionStatus2 = _interopRequireDefault(_subscriptionStatus);
	
	var _accountSetup = __webpack_require__(311);
	
	var _accountSetup2 = _interopRequireDefault(_accountSetup);
	
	var _welcome = __webpack_require__(524);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	var _paymentEnable = __webpack_require__(306);
	
	var _paymentEnable2 = _interopRequireDefault(_paymentEnable);
	
	var _navbar = __webpack_require__(461);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function adminNav() {
	  return {
	    restrict: 'A',
	    template: __webpack_require__(827),
	    controller: _navbar2.default,
	    link: function link(scope) {
	      // scrollable-content directive watches this var
	      // which is set to true when rendered
	      scope.adminNavRendered = true;
	    }
	  };
	}
	
	exports.default = _angular2.default.module('directives.admin-nav', [_user2.default, _paymentEnable2.default, _case2.default, _paymentStatus2.default, _createCase2.default, _referral2.default, _accountMap2.default, _account2.default, _customer2.default, _analytics2.default, _accountSetup2.default, _subscriptionStatus2.default, _welcome2.default, _reload2.default, _clio2.default]).directive('adminNav', adminNav).name;

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = NavbarCtrl;
	NavbarCtrl.$inject = ['$scope', '$rootScope', '$location', 'Case', 'CurrentUser', '$uibModal', 'PaymentStatusServ', 'CreateCaseConf', 'ReferralModalConf', '$route', '$compile', 'AnalyticsServ', 'AccountMap', 'CurrentAccount', 'CurrentCustomer', 'AccountSetupModalConf', 'WelcomeModalConf', 'SubscriptionStatusModalConf', '$window', 'ReloadServ', 'Clio'];
	
	function NavbarCtrl($scope, $rootScope, $location, Case, CurrentUser, $uibModal, PaymentStatusServ, CreateCaseConf, ReferralModalConf, $route, $compile, AnalyticsServ, AccountMap, CurrentAccount, CurrentCustomer, AccountSetupModalConf, WelcomeModalConf, SubscriptionStatusModalConf, $window, ReloadServ, Clio) {
	  $scope.user = CurrentUser.data;
	
	  $scope.accountList = AccountMap.toArray();
	
	  $scope.currentAccount = CurrentAccount;
	  $scope.currentUser = CurrentUser;
	
	  var unwatchAccount = $scope.$watch(function () {
	    return CurrentAccount.data;
	  }, function (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      $scope.accountList = AccountMap.toArray();
	      // unwatchAccount();
	    }
	  });
	
	  CurrentCustomer.subscribe(function () {
	    $scope.trialStatus = {
	      daysRemaining: PaymentStatusServ.getStatus('user'),
	      isTrial: PaymentStatusServ.isTrial('user')
	    };
	    // Analytics User Property Paid should be set when Home Page is visited.
	    // Skipped for Visitors
	    if (CurrentCustomer.data.id) {
	      AnalyticsServ.setUser({
	        id: CurrentUser.data.id,
	        'Paid': PaymentStatusServ.isValid('user')
	      });
	    }
	  });
	
	  $scope.changeToCaseId = function (caseId) {
	    // first, clear out any existing status messages - they are about
	    // to become irrelevant!
	    $rootScope.statusMessages = {};
	    $scope.asideCasesVisible = !$scope.asideCasesVisible;
	    $location.path('/home/' + caseId);
	  };
	
	  $scope.openAccountPage = function () {
	    $location.path('/account');
	  };
	
	  // persisted past caseModal lifecycle
	  $scope.copyCaseId = '';
	  $scope.showFeedback = function () {
	    if ($window.UserVoice) {
	      $window.UserVoice.show();
	    }
	  };
	  $scope.caseModal = function () {
	    var m = $uibModal.open(CreateCaseConf);
	    m.result.then(function (data) {
	      $location.path('/home/' + data.id);
	    }, function () {});
	    return m;
	  };
	  $scope.syncClio = function () {
	    Clio.sync();
	  };
	
	  $scope.accountSetupModal = function () {
	    $uibModal.open(AccountSetupModalConf);
	  };
	
	  $scope.welcomeModal = function () {
	    analytics.track('Welcome Modal Opened');
	    var saveHidden = function saveHidden(guideStarted) {
	      $scope.currentUser.data.hideWelcome = true;
	      $scope.currentUser.api.update();
	      analytics.track('Welcome Modal Closed', {
	        'Guide Opened': guideStarted
	      });
	    };
	    if (!$rootScope.tourActive) {
	      $uibModal.open(WelcomeModalConf).result.then(function () {
	        return saveHidden(true);
	      }, function () {
	        return saveHidden(false);
	      });
	    }
	  };
	
	  if (!$scope.currentAccount.data.displayName) {
	    $scope.accountSetupModal();
	  }
	
	  $scope.subscriptionModal = function (_key, _object) {
	    // key is for the message - 'case', 'account', etc...
	    // object is the object to display messaging (optional)
	
	    // var referrer = {};
	
	    // if ($rootScope.user.referredBy) {
	
	    //   var referralExperiment = new OptimizelyExperiment('Referral CTA', 'Subscription Modal Clicked');
	
	    //   referralExperiment.activate().then(function (variationId) {
	    //     referrer.variation = variationId;
	    //   });
	
	    //   syncSrv.getReferrer($rootScope.user.referredBy).then(function (data) {
	    //     angular.extend(referrer, data);
	    //   });
	    // }
	    $uibModal.open(angular.extend(SubscriptionStatusModalConf, {
	      resolve: {
	        key: function key() {
	          return _key;
	        },
	        object: function object() {
	          return _object;
	        }
	      }
	    }));
	  };
	
	  $scope.referralModal = function () {
	    $scope.modal = $uibModal.open(ReferralModalConf);
	    analytics.track('Referral Modal Opened', {
	      Origin: 'Navbar'
	    });
	  };
	  $scope.signout = CurrentUser.api.signout;
	
	  $scope.changeAccount = function (account) {
	    CurrentUser.api.changeAccount({
	      accountId: account.id
	    }).then(function () {
	      ReloadServ.updateTabs();
	      if ($route.current.params.caseId) {
	        // Reload route, clear case when set. 
	        $route.updateParams({
	          caseId: null
	        });
	      } else {
	        $route.reload();
	      }
	    });
	  };
	
	  $scope.$on('$routeChangeSuccess', function () {
	    $scope.changing = false;
	  });
	
	  if (!CurrentUser.data.hideWelcome && !$rootScope.tourActive) {
	    $scope.welcomeModal();
	  }
	};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function caseEnable(CurrentCase) {
		return {
			restrict: 'A',
			link: function link(scope, element) {
				CurrentCase.data.id ? element.removeClass('disabled') : element.addClass('disabled');
			}
		};
	}
	caseEnable.$inject = ['CurrentCase'];
	
	exports.default = _angular2.default.module('directives.case-enable', [_case2.default]).directive('caseEnable', caseEnable).name;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _paymentStatus = __webpack_require__(223);
	
	var _paymentStatus2 = _interopRequireDefault(_paymentStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CaseStatus(PaymentStatusServ) {
		return {
			restrict: 'A',
			template: __webpack_require__(828),
			link: function link($scope) {
				$scope.casePaymentExpired = PaymentStatusServ.isExpired('case');
			}
		};
	}
	CaseStatus.$inject = ['PaymentStatusServ'];
	
	exports.default = _angular2.default.module('directives.case-status', [_paymentStatus2.default]).directive('caseStatus', CaseStatus).name;

/***/ }),
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HeaderNavCtrl;
	HeaderNavCtrl.$inject = ['$scope', '$location', '$window', 'CurrentUser', 'AnalyticsServ'];
	
	function HeaderNavCtrl($scope, $location, $window, CurrentUser, AnalyticsServ) {
	  $scope.actions = {
	    signup: {
	      text: 'Sign Up',
	      link: '/signup',
	      visible: false
	    },
	    signin: {
	      text: 'Sign In',
	      link: '/signin',
	      visible: false
	    }
	  };
	  $scope.signout = function () {
	    CurrentUser.api.signout();
	  };
	
	  $scope.navHome = function () {
	    if (CurrentUser.data.id && CurrentUser.data.email) {
	      $location.path('/home');
	    } else {
	      $window.location.href = '/';
	    }
	    AnalyticsServ.clicked('Home Icon', {
	      'Authenticated': !!CurrentUser.data.id
	    });
	  };
	
	  $scope.setActions = function (actions) {
	    var action;
	    if (actions && actions.length > 0) {
	      for (var i = 0; i < actions.length; i++) {
	        action = actions[i];
	        if (action && $scope.actions[action]) {
	
	          $scope.actions[action].visible = true;
	        }
	      }
	    }
	  };
	};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContributorEnable($rootScope, CurrentUser, CurrentCase) {
	  return {
	    restrict: 'A',
	    link: {
	      pre: function pre(scope, element) {
	        var isVisitor = function isVisitor() {
	          if (CurrentCase.data.hasOwnProperty('contributors')) {
	            // a visitor is not a case contributor or does not have an email
	            var _isVisitor = CurrentUser.data.hasOwnProperty('email') ? !CurrentCase.data.contributors.map(function (contributor) {
	              return contributor.email;
	            }).some(function (email) {
	              return email === CurrentUser.data.email;
	            }) : true;
	
	            $rootScope.isVisitor = _isVisitor;
	            return _isVisitor;
	          } else {
	            $rootScope.isVisitor = false;
	          }
	        };
	
	        isVisitor() ? element.addClass('contributor-disabled') : element.removeClass('contributor-disabled');
	
	        element.bind('click', function (e) {
	
	          if (isVisitor()) {
	            e.stopImmediatePropagation();
	            e.preventDefault();
	            $rootScope.$apply();
	            // set a message?
	          }
	        });
	      }
	    }
	  };
	}
	ContributorEnable.$inject = ['$rootScope', 'CurrentUser', 'CurrentCase'];
	
	exports.default = _angular2.default.module('directives.payment-enable', [_user2.default, _case2.default]).directive('lfContributorEnable', ContributorEnable).name;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterListController = function () {
	  function FilterListController($scope, FactQuery, Trees, AnalyticsServ) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, FilterListController);
	
	    this.scope = $scope;
	    this.trees = Trees;
	    this.collapsed = {};
	    this.factQuery = FactQuery;
	    this.analytics = AnalyticsServ;
	
	    this.factQuery.subscribe(function () {
	      _this.updateFilterLists();
	    });
	  }
	
	  (0, _createClass3.default)(FilterListController, [{
	    key: 'toggleCollapsed',
	    value: function toggleCollapsed(attr) {
	      var _this2 = this;
	
	      if (this.factQuery.data.filterPipeline.filter(function (f) {
	        return !_this2.collapsed[f.attribute];
	      }).length === 1 && !this.collapsed[attr]) {
	        // Prevent last filter collapse
	        return;
	      }
	      this.collapsed[attr] = !this.collapsed[attr];
	      this.computeFilterHeight();
	    }
	  }, {
	    key: 'setFilterLists',
	    value: function setFilterLists() {
	      var pipeline = this.factQuery.data.filterPipeline;
	      this.filterTrees = pipeline && pipeline.filter(function (f) {
	        return f.attribute !== 'keywords';
	      });
	      this.keywordFilter = pipeline && pipeline.filter(function (f) {
	        return f.attribute === 'keywords';
	      })[0];
	      this.enableFilterTreeRemoval = pipeline && this.filterTrees.length > 1;
	    }
	  }, {
	    key: 'setAvailableAttrs',
	    value: function setAvailableAttrs() {
	      if (!(this.filterTrees && this.filterTrees.length)) {
	        return;
	      }
	      var viewBy = this.filterTrees[0].attribute;
	      var viewByColumns = this.trees[viewBy].grouping.columnsByGroup.map(function (col) {
	        return col.key;
	      });
	      var trees = (0, _keys2.default)(this.trees);
	      var attrs = this.factQuery.data.filterPipeline.map(function (filter) {
	        return filter.attribute;
	      });
	      this.availableAttrs = viewByColumns.filter(function (attr) {
	        return trees.indexOf(attr) !== -1 && attrs.indexOf(attr) === -1;
	      });
	    }
	  }, {
	    key: 'computeFilterHeight',
	    value: function computeFilterHeight(filterListHeight) {
	      var _this3 = this;
	
	      this.scope.filterListHeight = filterListHeight || this.scope.filterListHeight;
	      var filterPipeline = this.factQuery.data.filterPipeline;
	      if (!filterPipeline) {
	        return;
	      }
	      var expandedFilters = filterPipeline.filter(function (f) {
	        return !_this3.collapsed[f.attribute];
	      }).length;
	      expandedFilters = expandedFilters === 1 ? 1.5 : expandedFilters;
	      var collapsedFilterHeight = 43;
	      var viewByOffset = 16;
	      var expandedFilterOffset = 39;
	
	      this.selectionListHeight = (this.scope.filterListHeight - viewByOffset - collapsedFilterHeight - filterPipeline.length * collapsedFilterHeight - expandedFilters * expandedFilterOffset) / expandedFilters + 'px';
	    }
	  }, {
	    key: 'addFilter',
	    value: function addFilter(attr) {
	      var _this4 = this;
	
	      if (this.factQuery.data.filterPipeline.length >= 6) {
	        return;
	      }
	
	      this.factQuery.data.filterPipeline.push({
	        "attribute": attr
	      });
	      this.updateFilterLists();
	      this.factQuery.api.update().then(function () {
	        _this4.analytics.added('Filter', {
	          'Filter Attribute': attr,
	          'View By Attribute': _this4.factQuery.data.filterPipeline[0].attribute,
	          'Filter Count': _this4.factQuery.data.filterPipeline.length - 1
	        });
	      });
	    }
	  }, {
	    key: 'updateFilterLists',
	    value: function updateFilterLists() {
	      this.setFilterLists();
	      this.setAvailableAttrs();
	      this.computeFilterHeight();
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(attr) {
	      return this.factQuery.data.filterPipeline.map(function (f) {
	        return f.attribute;
	      }).indexOf(attr);
	    }
	  }, {
	    key: 'removeFilter',
	    value: function removeFilter(attr) {
	      var _this5 = this;
	
	      // ensure one tree filter is always set
	      if (attr !== 'keywords' && !this.enableFilterTreeRemoval) {
	        return;
	      }
	      var index = this.getIndex(attr);
	      this.factQuery.data.filterPipeline.splice(index, 1);
	
	      this.updateFilterLists();
	
	      this.factQuery.api.update().then(function () {
	        _this5.analytics.removed('Filter');
	      });;
	    }
	  }]);
	  return FilterListController;
	}();
	
	exports.default = FilterListController;
	;
	
	FilterListController.$inject = ['$scope', 'FactQuery', 'Trees', 'AnalyticsServ'];

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filterList;
	
	var _filterList = __webpack_require__(473);
	
	var _filterList2 = _interopRequireDefault(_filterList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterList($window, $timeout) {
	  return {
	    restrict: 'E',
	    template: __webpack_require__(835),
	    controller: _filterList2.default,
	    controllerAs: 'filterListCtrl',
	    link: function link(scope, elem) {
	      var resizeRequest;
	
	      var setHeight = function setHeight() {
	        scope.filterListCtrl.computeFilterHeight(elem[0].scrollHeight);
	      };
	      var requestResize = function requestResize() {
	        if (resizeRequest) {
	          $timeout.cancel(resizeRequest);
	        }
	        resizeRequest = $timeout(setHeight, 100);
	      };
	      $window.addEventListener('resize', requestResize);
	      scope.$on('$destroy', function () {
	        $window.removeEventListener('resize', requestResize);
	      });
	      scope.$on('render', requestResize);
	      requestResize();
	    }
	  };
	}
	filterList.$inject = ['$window', '$timeout'];

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _trees = __webpack_require__(64);
	
	var _trees2 = _interopRequireDefault(_trees);
	
	var _factQuery = __webpack_require__(63);
	
	var _factQuery2 = _interopRequireDefault(_factQuery);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _lfFilterTree = __webpack_require__(478);
	
	var _lfFilterTree2 = _interopRequireDefault(_lfFilterTree);
	
	var _fbListFilter = __webpack_require__(443);
	
	var _fbListFilter2 = _interopRequireDefault(_fbListFilter);
	
	var _filterList = __webpack_require__(474);
	
	var _filterList2 = _interopRequireDefault(_filterList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('directives.lf-filter-list', [_lfFilterTree2.default, _fbListFilter2.default, _factQuery2.default, _trees2.default, _analytics2.default]).directive('lfFilterList', _filterList2.default).name;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterTreeCtrl = function () {
	  function FilterTreeCtrl($scope, $attrs, Trees, FactQuery) {
	    (0, _classCallCheck3.default)(this, FilterTreeCtrl);
	
	    this.filterIndex = $scope.$index;
	    this.factQuery = FactQuery;
	    this.trees = Trees;
	    this.filter = $scope.$eval($attrs.lfFilter);
	    this.parent = $scope.$eval($attrs.lfParent);
	
	    // Get the tree if not already fetched
	    if (this.trees[this.filter.attribute].data.length === 0) {
	      this.trees[this.filter.attribute].api.get();
	    }
	    this.allExcluded = this.getAllExcluded();
	    this.allCollapsed = this.getAllCollapsed();
	  }
	
	  (0, _createClass3.default)(FilterTreeCtrl, [{
	    key: 'toggleCollapsed',
	    value: function toggleCollapsed(node, event) {
	      event.stopImmediatePropagation();
	      event.preventDefault();
	      this.trees[this.filter.attribute].toggleCollapsed(node);
	      this.filter = this.trees[this.filter.attribute].findAllCollapsed(this.filter);
	      this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
	      this.allCollapsed = this.getAllCollapsed();
	      this.factQuery.api.update();
	    }
	  }, {
	    key: 'getAllCollapsed',
	    value: function getAllCollapsed() {
	      return this.filter.collapsed && this.filter.collapsed.length === 0 ? this.filter.uncollapsed === null ? false : true : undefined;
	    }
	  }, {
	    key: 'setAllCollapsed',
	    value: function setAllCollapsed(collapsed) {
	      this.trees[this.filter.attribute].setAllCollapsed(collapsed);
	      this.filter.uncollapsed = collapsed ? [] : null;
	      this.filter.collapsed = [];
	      this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
	      this.allCollapsed = this.getAllCollapsed();
	      this.factQuery.api.update();
	    }
	  }, {
	    key: 'toggleExcluded',
	    value: function toggleExcluded(node) {
	      this.trees[this.filter.attribute].toggleExcluded(node);
	      this.filter = this.trees[this.filter.attribute].findAllExcluded(this.filter);
	      this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
	      this.allExcluded = this.getAllExcluded();
	      this.factQuery.api.update();
	    }
	  }, {
	    key: 'getAllExcluded',
	    value: function getAllExcluded() {
	      return this.filter.excludes && this.filter.excludes.length === 0 ? this.filter.includes === null ? false : true : undefined;
	    }
	  }, {
	    key: 'setAllExcluded',
	    value: function setAllExcluded() {
	      var excluded = !this.allExcluded;
	      this.trees[this.filter.attribute].setAllExcluded(excluded);
	      this.filter.includes = excluded ? [] : null;
	      this.filter.excludes = [];
	      this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
	      this.allExcluded = this.getAllExcluded();
	      this.factQuery.api.update();
	    }
	  }, {
	    key: 'setViewBy',
	    value: function setViewBy(key) {
	      this.filter = {
	        attribute: key
	      };
	      this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
	      this.factQuery.api.update();
	    }
	  }, {
	    key: 'setSorting',
	    value: function setSorting(direction) {
	      if (this.filter.sort === direction) {
	        this.filter.sort = null;
	      } else {
	        this.filter.sort = direction;
	      }
	      this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
	      this.factQuery.api.update();
	    }
	  }]);
	  return FilterTreeCtrl;
	}();
	
	exports.default = FilterTreeCtrl;
	
	
	FilterTreeCtrl.$inject = ['$scope', '$attrs', 'Trees', 'FactQuery'];

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = filterTree;
	
	var _filterTree = __webpack_require__(476);
	
	var _filterTree2 = _interopRequireDefault(_filterTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterTree() {
	    return {
	        restrict: 'E',
	        template: __webpack_require__(836),
	        controller: _filterTree2.default,
	        require: '^filterListCtrl',
	        controllerAs: 'filterCtrl'
	    };
	}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _trees = __webpack_require__(64);
	
	var _trees2 = _interopRequireDefault(_trees);
	
	var _factQuery = __webpack_require__(63);
	
	var _factQuery2 = _interopRequireDefault(_factQuery);
	
	var _filterTree = __webpack_require__(477);
	
	var _filterTree2 = _interopRequireDefault(_filterTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(802);
	
	exports.default = _angular2.default.module('directives.lf-filter-tree', [_trees2.default, _factQuery2.default]).run(['$templateCache', function ($templateCache) {
	  $templateCache.put('/filter-tree/node.html', __webpack_require__(837));
	}]).directive('lfFilterTree', _filterTree2.default).name;

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UpdateNotificationCtrl;
	UpdateNotificationCtrl.$inject = ['$scope', '$window', 'VersionServ'];
	
	function UpdateNotificationCtrl($scope, $window, VersionServ) {
	
	  $scope.versionServ = VersionServ;
	
	  $scope.reload = function () {
	    $window.location.reload();
	  };
	};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function lwCounter() {
	  return {
	    restrict: 'E',
	    template: __webpack_require__(839),
	    scope: {
	      count: '='
	    },
	    transclude: true,
	    link: function link(scope, element, attrs) {
	      _angular2.default.element(element).addClass('counter');
	      /*
	        attrs
	        ----------------------------------------
	        name: The name of the thing being counted
	        list: The list or map of things to count
	       */
	      // scope.count = scope.list ? scope.list.size : 0;
	      scope.name = scope.$eval(attrs.name) + (scope.count !== 1 ? 's' : '');
	    }
	  };
	}
	
	exports.default = _angular2.default.module('directives.lfAccountList', []).directive('lwCounter', lwCounter).name;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TelFilter() {
		return function (tel) {
			var len = tel && tel.length;
			if (len !== 10) {
				return tel;
			} else {
				var num = tel.slice(len - 4);
				var city = tel.slice(len - 7, len - 4);
				var region = tel.slice(0, len - 7);
				return region + '-' + city + '-' + num;
			}
		};
	}
	
	exports.default = _angular2.default.module('filters.telephone', []).filter('tel', TelFilter).name;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _errors = __webpack_require__(116);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ErrorFeedback(Errors, $q) {
		return {
			request: function request(config) {
				// for all non-GET calls, clear out the messages for the URL
				// in the status messages object.  The thinking here is that
				// validation errors were probably populated for a prior
				// POST/PUT/DELETE to the same URL so on resubmit we want to
				// just clear out those messages and start fresh.
				if (config.method !== 'GET') {
					delete Errors.data[config.url];
				}
				return config;
			},
			responseError: function responseError(response) {
				switch (response.status) {
					case 402:
						Errors.data[response.config.url] = response.data;
						break;
					case 403:
						Errors.data[response.config.url] = {
							error: "Permission error",
							details: "You do not have access to that functionality at the moment."
						};
						break;
					case 422:
						Errors.data[response.config.url] = response.data;
						break;
					case 500:
						Errors.data[response.config.url] = {
							error: "There seems to be a problem.  Please try again."
						};
						break;
				}
				return $q.reject(response);
			}
		};
	}
	
	ErrorFeedback.$inject = ['Errors', '$q'];
	exports.default = _angular2.default.module('interceptors.error-feedback', [_errors2.default]).factory('ErrorFeedback', ErrorFeedback).name;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LoadingFeedback($rootScope, $q) {
		var setStatus = function setStatus(method, value) {
			if (method === 'POST') {
				$rootScope.loading = value;
			} else if (method === 'PUT') {
				$rootScope.loading = value;
			} else if (method !== 'GET') {
				$rootScope.loading = value;
			}
		};
		return {
			/*
	    For non-GET calls show the loading indicator
	   */
			request: function request(config) {
				// loading indicator should not be visible for fact-related interactions
				// since fact view has it's own indicator
				if (!/fact/.test(config.url)) {
					setStatus(config.method, true);
				}
				return config;
			},
			response: function response(_response) {
				setStatus(_response.config.method, false);
				return _response || $q.when(_response);
			},
			responseError: function responseError(response) {
				setStatus(response.config.method, false);
				return $q.reject(response);
			}
		};
	}
	LoadingFeedback.$inject = ['$rootScope', '$q'];
	exports.default = _angular2.default.module('interceptors.loading-feedback', []).factory('LoadingFeedback', LoadingFeedback).name;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signin = __webpack_require__(314);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Unauthorized($location, $rootScope, $q) {
	  return {
	    responseError: function responseError(response) {
	      switch (response.status) {
	        case 408:
	          $rootScope.authModal();
	          break;
	        case 403:
	          if (!/signin/.test($location.path())) {
	            if (!/^\/(fact|home)/.test($location.path())) {
	              $location.search('redirect', $location.url());
	            }
	            $location.path('/signin');
	          }
	          break;
	        case 401:
	          if (!/signin/.test($location.path())) {
	            if (!/^\/(fact|home)$/.test($location.path())) {
	              $location.search('redirect', $location.url());
	            }
	            $location.path('/signin');
	          }
	          break;
	      }
	      return $q.reject(response);
	    }
	  };
	}
	Unauthorized.$inject = ['$location', '$rootScope', '$q'];
	exports.default = _angular2.default.module('interceptors.unauthorized', [_signin2.default]).factory('Unauthorized', Unauthorized).name;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accountSetup = __webpack_require__(310);
	
	var _accountSetup2 = _interopRequireDefault(_accountSetup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  template: __webpack_require__(843),
	  controller: _accountSetup2.default,
	  windowTemplateUrl: '/modals/default/modal-container.html',
	  windowClass: 'modal-name-account modal-confirm'
	};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(844),
	  windowTemplateUrl: '/modals/default/modal-container.html',
	  windowClass: 'modal-sm'
	};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _archiveCase = __webpack_require__(486);
	
	var _archiveCase2 = _interopRequireDefault(_archiveCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modals.archive-case', []).constant('ArchiveCaseModalConf', _archiveCase2.default).name;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _authCode = __webpack_require__(312);
	
	var _authCode2 = _interopRequireDefault(_authCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		template: __webpack_require__(845),
		windowTemplateUrl: '/modals/default/modal-container.html',
		controller: _authCode2.default,
		windowClass: 'modal-sm'
	};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _authCode = __webpack_require__(312);
	
	var _authCode2 = _interopRequireDefault(_authCode);
	
	var _authCode3 = __webpack_require__(488);
	
	var _authCode4 = _interopRequireDefault(_authCode3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.auth-code', [_user2.default]).controller('AuthCodeModalCtrl', _authCode2.default).constant('AuthCodeModalConf', _authCode4.default).name;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(846),
	  controller: 'ContributorsCtrl',
	  controllerAs: 'contribCtrl',
	  windowClass: 'modal-contributors',
	  windowTemplateUrl: '/modals/default/modal-container.html'
	
	};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _contributor = __webpack_require__(527);
	
	var _contributor2 = _interopRequireDefault(_contributor);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContributorsCtrl = function () {
	  function ContributorsCtrl(Contributor, CurrentCase, $location, CurrentUser, $window, $timeout, $routeParams) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ContributorsCtrl);
	
	
	    this.user = CurrentUser.data;
	    this.routeParams = $routeParams;
	
	    this.location = $location;
	    this.window = $window;
	
	    this.model = Contributor;
	
	    // The contributors list is set by the current cases contributors
	    this.case = CurrentCase;
	    CurrentCase.subscribe(function () {
	      _this.contributorsList = CurrentCase.data.contributors;
	    });
	
	    this.timeout = $timeout;
	
	    this.addButtonStates = {
	      false: 'Add',
	      true: 'Adding... <i class="font-icon-sm icon-spinner icon-spin">'
	    };
	
	    this.initialize();
	  }
	
	  (0, _createClass3.default)(ContributorsCtrl, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.contributor = new this.model();
	    }
	  }, {
	    key: 'focus',
	    value: function focus(query) {
	      this.timeout(function () {
	        document.querySelector('.modal-container').querySelector(query).focus();
	      });
	    }
	  }, {
	    key: 'cancelNewContributor',
	    value: function cancelNewContributor() {
	      // unlock email field and focus it (since adding new locks it)
	      this.initialize();
	      this.focus('[name="email"]');
	    }
	  }, {
	    key: 'addContributor',
	    value: function addContributor() {
	      var _this2 = this;
	
	      // existing users added by email
	      // if user is new, email is locked to prevent trying to add existing
	
	      this.contributor.api.add().then(function (data) {
	
	        _this2.initialize();
	        _this2.case.setProp('contributors', data);
	      }, function (response) {
	        if (response.status === 404) {
	          _this2.focus('[name="firstName"]');
	        }
	      });
	    }
	  }, {
	    key: 'removeContributor',
	    value: function removeContributor(contributor) {
	      var _this3 = this;
	
	      if (contributor.id === this.user.id && !this.window.confirm("Are you sure you want to remove yourself from this case?")) {
	        return;
	      }
	      this.toRemove = new this.model(contributor);
	      this.toRemove.api.remove().then(function () {
	        if (_this3.user.id === contributor.id) {
	          _this3.location.search('noRedirect', true);
	          _this3.location.url('/home');
	        } else {
	          _this3.case.setProp('contributors', _this3.case.data.contributors.filter(function (c) {
	            return c.id !== contributor.id;
	          }));
	        }
	      });
	    }
	  }]);
	  return ContributorsCtrl;
	}();
	
	ContributorsCtrl.$inject = ['Contributor', 'CurrentCase', '$location', 'CurrentUser', '$window', '$timeout', '$routeParams'];
	
	exports.default = _angular2.default.module('controllers.contributors', [_case2.default, _contributor2.default]).controller('ContributorsCtrl', ContributorsCtrl).name;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _contributors = __webpack_require__(491);
	
	var _contributors2 = _interopRequireDefault(_contributors);
	
	var _contributors3 = __webpack_require__(490);
	
	var _contributors4 = _interopRequireDefault(_contributors3);
	
	var _titlecase = __webpack_require__(309);
	
	var _titlecase2 = _interopRequireDefault(_titlecase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modals.contributors', [_contributors2.default, _titlecase2.default]).constant('ContributorsModalConf', _contributors4.default).name;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createCase = __webpack_require__(494);
	
	var _createCase2 = _interopRequireDefault(_createCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  template: __webpack_require__(847),
	  controller: _createCase2.default,
	  windowClass: 'modal-create-case modal-sm',
	  windowTemplateUrl: '/modals/default/modal-container.html'
	
	};

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CreateCaseCtrl;
	CreateCaseCtrl.$inject = ['$scope', '$rootScope', '$location', 'Case', 'CurrentCase', 'CaseMap', '$sce', '$timeout'];
	
	function CreateCaseCtrl($scope, $rootScope, $location, Case, CurrentCase, CaseMap, $sce, $timeout) {
	
	  // The selected case copy source should stay set after closing the create
	  // case modal. If the selected case isn't available when reopening the
	  // modal, it should be set to the current case.
	  if (!$scope.selectedCase) {
	    $scope.selectedCase = CurrentCase.data || {};
	  }
	
	  $timeout(function () {
	    // focus on show, slight delay for safari and firefox
	    document.querySelector('#displayName').focus();
	  }, 100, false);
	
	  CaseMap.api.get().then(function (data) {
	    $scope.cases = CaseMap.toArray();
	  });
	
	  // copy.enabled shows copy options in the modal, and determines wether
	  // the a case should be created or copied.
	  $scope.copy = {
	    enabled: false,
	    options: {}
	  };
	
	  $scope.selectCase = function (caze) {
	    $scope.selectedCase = caze;
	  };
	
	  $scope.scratch = {};
	  $scope.createButtonStates = {
	    false: $sce.trustAsHtml('Create'),
	    true: $sce.trustAsHtml('Creating... <i class="font-icon-sm icon-spinner icon-spin">')
	  };
	
	  $scope.submit = function () {
	    // If user opts to copy, a case to copy from should be given
	    if ($scope.copy.enabled && !$scope.selectedCase.id) {
	      $scope.validations = {
	        caseId: {
	          error: 'Please select a case to copy.'
	        }
	      };
	      return;
	    }
	
	    // successful Create + Copy callback
	    var setCase = function setCase(data) {
	      CaseMap.set(data.id, data);
	
	      $scope.$close(data);
	    };
	    // unsuccessful Create + Copy callback
	    var setError = function setError(response) {
	      $scope.validations = response.data.data;
	    };
	
	    var newCase = new Case();
	    newCase.data.displayName = $scope.scratch.displayName;
	    if ($scope.copy.enabled) {
	
	      newCase.api.copy({
	        copyCaseId: $scope.selectedCase.id
	      }).then(setCase, setError);
	    } else {
	      newCase.data.status = 'active';
	      newCase.api.create().then(setCase, setError);
	    }
	  };
	}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _caseMap = __webpack_require__(218);
	
	var _caseMap2 = _interopRequireDefault(_caseMap);
	
	var _createCase = __webpack_require__(493);
	
	var _createCase2 = _interopRequireDefault(_createCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.create-case', [_case2.default, _caseMap2.default]).constant('CreateCaseConf', _createCase2.default).name;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(849),
	  windowClass: 'modal-sm',
	  windowTemplateUrl: '/modals/default/modal-container.html'
	
	};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _deleteFact = __webpack_require__(496);
	
	var _deleteFact2 = _interopRequireDefault(_deleteFact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modals.delete-fact', []).constant('DeleteFactModalConf', _deleteFact2.default).name;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fact = __webpack_require__(499);
	
	var _fact2 = _interopRequireDefault(_fact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  template: __webpack_require__(850),
	  windowTemplateUrl: '/modals/default/modal-container.html',
	  controller: _fact2.default,
	  controllerAs: '$ctrl',
	  backdrop: 'static',
	  keyboard: false,
	  windowClass: 'modal-fact'
	};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FactCtrl = function () {
	  function FactCtrl(Fact, currentFact, $uibModalInstance) {
	    (0, _classCallCheck3.default)(this, FactCtrl);
	
	    this.modal = $uibModalInstance;
	    this.fact = currentFact || {};
	    this.model = Fact;
	    this.editFact = this.editFact.bind(this);
	  }
	
	  (0, _createClass3.default)(FactCtrl, [{
	    key: 'editFact',
	    value: function editFact(data) {
	      var p = new this.model(data).api.update();
	      p.then(this.modal.close);
	      return p;
	    }
	  }]);
	  return FactCtrl;
	}();
	
	exports.default = FactCtrl;
	
	FactCtrl.$inject = ['Fact', 'currentFact', '$uibModalInstance'];

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fact = __webpack_require__(498);
	
	var _fact2 = _interopRequireDefault(_fact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modal.fact', []).constant('FactModalConf', _fact2.default).name;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fbOl = __webpack_require__(445);
	
	var _fbOl2 = _interopRequireDefault(_fbOl);
	
	var _emptyItem = __webpack_require__(211);
	
	var _emptyItem2 = _interopRequireDefault(_emptyItem);
	
	var _issue = __webpack_require__(317);
	
	var _issue2 = _interopRequireDefault(_issue);
	
	var _errors = __webpack_require__(116);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _issues = __webpack_require__(136);
	
	var _issues2 = _interopRequireDefault(_issues);
	
	var _issues3 = __webpack_require__(502);
	
	var _issues4 = _interopRequireDefault(_issues3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modal.issues', [_issue2.default, _errors2.default, _issues2.default, _emptyItem2.default, _fbOl2.default]).constant('IssuesModalConf', _issues4.default).name;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _issues = __webpack_require__(503);
	
	var _issues2 = _interopRequireDefault(_issues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  template: __webpack_require__(852),
	  controller: _issues2.default,
	  controllerAs: 'issuesCtrl',
	  windowClass: 'modal-issues',
	  windowTemplateUrl: '/modals/default/modal-container.html',
	  keyboard: false
	};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(76);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IssuesModalCtrl = function () {
	  function IssuesModalCtrl($routeParams, $uibModal, $filter, $q, IssuesTreeFactory, Issue, $timeout, Errors) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, IssuesModalCtrl);
	
	    this.openModal = $uibModal.open;
	    this.routeParams = $routeParams;
	    this.errors = Errors;
	    this.timeout = $timeout;
	
	    // View stuff
	    this.issuesTree = new IssuesTreeFactory();
	    this.issuesTree.api.get();
	    this.model = Issue;
	    this.newScratch = new this.model();
	    this.addChild = false;
	    this.addButtonStates = {
	      false: 'Add ' + $filter('lexicon')('issue'),
	      true: 'Adding... <i class="font-icon-sm icon-spinner icon-spin">'
	    };
	    this.treeSettings = {
	      dropped: function dropped() {
	        _this.issuesTree.setData();
	      }
	    };
	    this.focusIssueInput();
	  }
	
	  (0, _createClass3.default)(IssuesModalCtrl, [{
	    key: 'focusIssueInput',
	    value: function focusIssueInput() {
	      // this.timeout(() => {
	      //   angular.element('.top-issue-field input').focus();
	      // }, 0, false);
	    }
	  }, {
	    key: 'focusSubissueInput',
	    value: function focusSubissueInput() {
	      // this.timeout(() => {
	      //   angular.element('.sub-issue input').focus();
	      // }, 0, false);
	    }
	  }, {
	    key: 'cancelReassign',
	    value: function cancelReassign() {
	      delete this.reassign;
	    }
	  }, {
	    key: 'showSubissueForm',
	    value: function showSubissueForm(parent) {
	      parent.addChild = true;
	      this.addChild = true;
	      this.focusSubissueInput();
	    }
	  }, {
	    key: 'hideSubissueForm',
	    value: function hideSubissueForm(parent) {
	      parent.addChild = false;
	      this.addChild = false;
	      this.focusIssueInput();
	    }
	  }, {
	    key: 'updateIssueOrder',
	    value: function updateIssueOrder() {
	      return this.issuesTree.api.update({}, {
	        legalIssues: this.issuesTree.data
	      });
	    }
	  }, {
	    key: 'requestDelete',
	    value: function requestDelete(model) {
	      var _this2 = this;
	
	      // DELETE fails on first attempt with confirmation code
	      // which is included in the second attempt
	      return model.api.delete({
	        reassign: this.reassign ? this.reassign.data.to.id : null
	      }).then(function () {
	        // Remove issue on successful delete request
	        // track issue removed
	        if (_this2.reassign) {
	          model.data.children.forEach(function (node) {
	            _this2.issuesTree.add(node, _this2.reassign.data.to);
	          });
	        }
	        _this2.issuesTree.remove(model.data);
	        delete _this2.reassign;
	      }, function (response) {
	        // Open a Modal to confirm the delete request, offer alternatives
	
	        if (response.status === 412) {
	          _this2.openModal({
	            template: __webpack_require__(851),
	            windowTemplateUrl: '/modals/default/modal-container.html',
	            controller: ['$scope', function (scope) {
	              scope.hasFacts = response.data.explanationCode === 'factsAssociated';
	              scope.hasChildren = model.data.children && model.data.children.length > 0;
	            }]
	          }).result.then(function (action) {
	            if (action === 'delete') {
	              _this2.requestDelete(model);
	            } else {
	              _this2.reassign = model;
	            }
	          }, function () {
	            // cancel clears conf code, so next attempt prompts
	            delete model.data.confirmationCode;
	          });
	        }
	      });
	    }
	  }, {
	    key: 'deleteIssue',
	    value: function deleteIssue(issue) {
	      var _this3 = this;
	
	      var issueModel = new this.model(issue);
	
	      // First, update issue order before deleting, since
	      // server is unaware of current hierarchy
	      this.updateIssueOrder().then(function () {
	        _this3.requestDelete(issueModel);
	      }, function () {
	        _this3.errors.data['delete-issue'] = {
	          error: "Could not save issue order",
	          details: "Please try updating the issue order before deleting your issue."
	        };
	      });
	    }
	  }, {
	    key: 'updateIssue',
	    value: function updateIssue(issue) {
	      return new this.model(issue).api.update().then(function (data) {
	        return issue = (0, _assign2.default)(issue, data);
	      });
	    }
	  }, {
	    key: 'createRootIssue',
	    value: function createRootIssue(displayName) {
	      var _this4 = this;
	
	      return new this.model({ displayName: displayName }).api.create().then(function (data) {
	        return _this4.issuesTree.add(data);
	      });
	    }
	  }, {
	    key: 'createSubIssue',
	    value: function createSubIssue(displayName, parent) {
	      var _this5 = this;
	
	      var parentId = parent.id;
	      return new this.model({ displayName: displayName, parentId: parentId }).api.create().then(function (data) {
	        return _this5.issuesTree.add(data, parent);
	      });
	    }
	
	    /*createIssue(parent) {
	      //  Unused legacy method for reference
	      if (parent && parent.id) {
	        this.newScratch.data.parentId = parent.id;
	      }
	       this.updateIssueOrder().then(() => {
	        this.newScratch.api.create().then(() => {
	          // Insert new issue into tree
	          this.issuesTree.add(this.newScratch.data, parent);
	           // Clear view settings
	          if (parent) {
	            this.hideSubissueForm(parent);
	          }
	          this.newScratch.data = {};
	           this.updateIssueOrder();
	        }, response => {
	          this.validations = response.data.data;
	        });
	      }, () => {
	        this.errors.data['add-issue'] = {
	          error: "Could not save issue order",
	          details: "Please try updating the issue order before adding your issue."
	        };
	      });
	    }*/
	
	  }]);
	  return IssuesModalCtrl;
	}();
	
	exports.default = IssuesModalCtrl;
	
	IssuesModalCtrl.$inject = ['$routeParams', '$uibModal', '$filter', '$q', 'IssuesTreeFactory', 'Issue', '$timeout', 'Errors'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _payment = __webpack_require__(505);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modal.payment', []).constant('PaymentModalConf', _payment2.default).name;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(853),
	  windowClass: 'modal-payment modal-sm',
	  windowTemplateUrl: '/modals/default/modal-container.html'
	};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(854),
	  controller: 'ReferralCtrl',
	  windowClass: 'modal-md',
	  windowTemplateUrl: '/modals/default/modal-container.html'
	
	};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ReferralCtrl(CurrentUser, $scope, $timeout, $filter, $sanitize, $route) {
	  $scope.user = CurrentUser.data;
	  $scope.done = false;
	  $scope.busy = false;
	  $scope.referrerLinkVisible = false;
	  $scope.users = {
	    string: '',
	    list: []
	  };
	  $scope.response = {};
	  var focusInput = function focusInput() {
	    $timeout(function () {
	      document.querySelector('[name="emails"]').focus();
	    });
	  };
	  focusInput();
	
	  var getLink = function getLink() {
	    var baseUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	    return $sanitize(baseUrl + '/app/#/signup?referrer=' + $scope.user.referrerCode);
	  };
	  $scope.referrerLink = getLink();
	
	  $scope.users.getList = function () {
	    return $scope.users.string.split(',').map(function (email) {
	      return email.trim();
	    });
	  };
	  $scope.users.getString = function () {
	    return $scope.users.list.join(', ');
	  };
	
	  $scope.toggleReferrerLink = function () {
	    $scope.referrerLinkVisible = !$scope.referrerLinkVisible;
	  };
	
	  $scope.setResponse = function (data) {
	    var emails = [];
	    var error = false;
	    $scope.busy = false;
	
	    if (data.emails) {
	      emails = (0, _keys2.default)(data.emails).map(function (email) {
	        return data.emails[email];
	      });
	    } else {
	      error = true;
	    }
	    // set response message
	    $scope.response = {
	      invalid: $filter('filter')(emails, {
	        'status': '!true'
	      }),
	      sent: $filter('filter')(emails, {
	        'status': 'true'
	      }),
	      error: error
	    };
	    // set model value to invalid emails
	    $scope.users.list = $filter('filter')(emails, {
	      'status': '!sent'
	    }).map(function (user) {
	      return user.email;
	    });
	    $scope.users.string = $scope.users.getString();
	    focusInput();
	  };
	
	  $scope.inviteUsers = function () {
	    if ($scope.busy) {
	      return;
	    }
	    $scope.busy = true;
	    CurrentUser.api.invite({
	      emails: $scope.users.getList()
	    }, function (data) {
	      $scope.setResponse(data);
	      $scope.done = true;
	    }, function (response) {
	      $scope.setResponse(response.data, 'error');
	    });
	  };
	};
	ReferralCtrl.$inject = ['CurrentUser', '$scope', '$timeout', '$filter', '$sanitize', '$route'];
	
	exports.default = _angular2.default.module('controllers.referral', [_user2.default]).controller('ReferralCtrl', ReferralCtrl).name;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _removePhone = __webpack_require__(510);
	
	var _removePhone2 = _interopRequireDefault(_removePhone);
	
	var _removePhone3 = __webpack_require__(509);
	
	var _removePhone4 = _interopRequireDefault(_removePhone3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modal.remove-phone', []).controller('RemovePhoneController', _removePhone2.default).constant('RemovePhoneModalConf', _removePhone4.default).name;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		template: __webpack_require__(855),
		windowTemplateUrl: '/modals/default/modal-container.html',
		controller: 'RemovePhoneController',
		windowClass: 'modal-sm'
	};

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RemovePhoneController;
	RemovePhoneController.$inject = ['$scope', '$uibModalInstance', 'CurrentUser', '$timeout'];
	
	function RemovePhoneController($scope, $uibModalInstance, CurrentUser, $timeout) {
	
	  $scope.error = null;
	  $scope.busy = false;
	  $scope.password = '';
	
	  $timeout(function () {
	    document.querySelector('[name="password"]').focus();
	  });
	
	  $scope.removePhone = function () {
	    if ($scope.busy) return;
	    $scope.busy = true;
	    CurrentUser.api.removePhone(null, {
	      password: $scope.password
	    }).then(function () {
	      CurrentUser.api.get().then(function (data) {
	        $uibModalInstance.close(data);
	      });
	    }, function (response) {
	      $scope.busy = false;
	      document.querySelector('[name="password"]').focus();
	      $scope.error = response.data;
	    });
	  };
	}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _removeUser = __webpack_require__(512);
	
	var _removeUser2 = _interopRequireDefault(_removeUser);
	
	var _removeUser3 = __webpack_require__(513);
	
	var _removeUser4 = _interopRequireDefault(_removeUser3);
	
	var _customer = __webpack_require__(135);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _member = __webpack_require__(319);
	
	var _member2 = _interopRequireDefault(_member);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modal.remove-user', [_customer2.default, _user2.default, _member2.default]).controller('RemoveUserController', _removeUser4.default).constant('RemoveUserModalConf', _removeUser2.default).name;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(856),
	  windowTemplateUrl: '/modals/default/modal-container.html',
	  controller: 'RemoveUserController',
	  windowClass: 'modal-sm'
	};

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RemoveUserController;
	RemoveUserController.$inject = ['$scope', '$uibModalInstance', 'Member', 'selectedMember', 'CurrentCustomer', 'CurrentUser', '$window'];
	
	function RemoveUserController($scope, $uibModalInstance, Member, selectedMember, CurrentCustomer, CurrentUser, $window) {
	
	  $scope.busy = false;
	  $scope.selectedMember = selectedMember;
	  $scope.removeMember = function () {
	
	    if (selectedMember.id === CurrentUser.data.id && !$window.confirm("Are you sure you want to remove yourself?")) {
	      // prevent user self-removal
	      return;
	    }
	    var toRemove = new Member(selectedMember);
	    toRemove.api.remove().then(function (data) {
	
	      if (CurrentUser.data.id === selectedMember.id) {
	        $window.location.reload();
	      } else {
	        CurrentCustomer.setProp('users', data);
	        $scope.$close();
	      }
	    });
	  };
	}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(857),
	  controller: 'SigninCtrl',
	  controllerAs: 'signin',
	  windowClass: 'modal-sm',
	  windowTemplateUrl: '/modals/default/modal-container.html'
	};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _sources = __webpack_require__(315);
	
	var _sources2 = _interopRequireDefault(_sources);
	
	var _sources3 = __webpack_require__(516);
	
	var _sources4 = _interopRequireDefault(_sources3);
	
	var _truncate = __webpack_require__(160);
	
	var _truncate2 = _interopRequireDefault(_truncate);
	
	var _fbOnDelete = __webpack_require__(303);
	
	var _fbOnDelete2 = _interopRequireDefault(_fbOnDelete);
	
	var _fbUpload = __webpack_require__(452);
	
	var _fbUpload2 = _interopRequireDefault(_fbUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modals.sources', [_sources2.default, _fbOnDelete2.default, _truncate2.default, _fbUpload2.default]).run(['$templateCache', function ($templateCache) {
	  $templateCache.put('/modals/sources/detail.html', __webpack_require__(862));
	  $templateCache.put('/modals/sources/list-item.box.html', __webpack_require__(868));
	  $templateCache.put('/modals/sources/list-breadcrumb.box.html', __webpack_require__(867));
	  $templateCache.put('/modals/sources/list.html', __webpack_require__(869));
	  $templateCache.put('/modals/sources/type-nav.html', __webpack_require__(870));
	  $templateCache.put('/modals/sources/detail.box.html', __webpack_require__(858));
	  $templateCache.put('/modals/sources/detail.dropbox.html', __webpack_require__(860));
	  $templateCache.put('/modals/sources/detail.clio.html', __webpack_require__(859));
	  $templateCache.put('/modals/sources/detail.file.html', __webpack_require__(861));
	  $templateCache.put('/modals/sources/detail.link.html', __webpack_require__(863));
	  $templateCache.put('/modals/sources/detail.note.html', __webpack_require__(864));
	  $templateCache.put('/modals/sources/detail.person.html', __webpack_require__(865));
	  $templateCache.put('/modals/sources/detail.worksite.html', __webpack_require__(866));
	}]).constant('SourcesModalConf', _sources4.default).name;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(871),
	  controller: 'SourcesCtrl',
	  controllerAs: 'sourcesCtrl',
	  windowClass: 'modal-sources',
	  windowTemplateUrl: '/modals/default/modal-container.html'
	
	};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _subscriptionStatus = __webpack_require__(518);
	
	var _subscriptionStatus2 = _interopRequireDefault(_subscriptionStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modal.subscription-status', []).constant('SubscriptionStatusModalConf', _subscriptionStatus2.default).name;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(872),
	  windowClass: 'modal-sm',
	  windowTemplateUrl: '/modals/default/modal-container.html',
	
	  controller: ['$scope', '$timeout', '$location', 'key', 'object', function ($scope, $timeout, $location, key, object) {
	    $scope.key = key;
	    $scope.object = object;
	    // $scope.referrer = referrer;
	
	    $scope.upgrade = function () {
	      // if ($rootScope.user.referredBy) {
	      //   referralExperiment.track();
	      // }
	      $location.url('/account?tab=firm#plans');
	    };
	  }]
	};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _subscription = __webpack_require__(520);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modal.subscription', []).constant('SubscriptionModalConf', _subscription2.default).name;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(873),
	  windowClass: 'modal-subscription modal-sm',
	  windowTemplateUrl: '/modals/default/modal-container.html'
	};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tags = __webpack_require__(523);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _tags3 = __webpack_require__(522);
	
	var _tags4 = _interopRequireDefault(_tags3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('modals.tags', [_tags2.default]).constant('TagsModalConf', _tags4.default).name;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  template: __webpack_require__(875),
	  controller: 'TagsCtrl',
	  controllerAs: 'tagsCtrl',
	  windowTemplateUrl: '/modals/default/modal-container.html',
	
	  windowClass: 'modal-tags'
	};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(76);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tag = __webpack_require__(321);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _tags = __webpack_require__(138);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagsCtrl = function () {
	  function TagsCtrl($routeParams, $scope, $q, $filter, $timeout, Tag, TagsTree, $uibModal) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, TagsCtrl);
	
	    this.routeParams = $routeParams;
	    this.openModal = $uibModal.open;
	    this.q = $q;
	    this.timeout = $timeout;
	    this.filter = $filter('filter');
	    this.orderBy = $filter('orderBy');
	    this.model = Tag;
	    this.scope = $scope;
	
	    this.tags = TagsTree;
	
	    // default view settings
	    this.searchQuery = '';
	    this.sortFilter = '-id';
	    this.tagError = '';
	
	    $scope.$on('tagError', function (e, error) {
	      _this.tagError = error;
	      e.stopPropagation();
	    });
	    this.getTags();
	    $scope.$on('$routeChangeSuccess', this.getTags);
	
	    this.deleteTag = this.deleteTag.bind(this);
	  }
	
	  (0, _createClass3.default)(TagsCtrl, [{
	    key: 'getTags',
	    value: function getTags() {
	      var _this2 = this;
	
	      if (this && this.routeParams.caseId) {
	        this.tags.api.get().then(function () {
	          _this2.filterTags();
	        });
	      }
	    }
	  }, {
	    key: 'createTag',
	    value: function createTag(displayName) {
	      var _this3 = this;
	
	      var promise = new this.model({ displayName: displayName }).api.create();
	      promise.then(function (data) {
	        return _this3.tags.add(data);
	      });
	      return promise;
	    }
	  }, {
	    key: 'updateTag',
	    value: function updateTag(tag) {
	      return new this.model(tag).api.update().then(function (data) {
	        return tag = (0, _assign2.default)(tag, data);
	      });
	    }
	  }, {
	    key: 'deleteTag',
	    value: function deleteTag(tag) {
	      var _this4 = this;
	
	      var deferred = this.q.defer();
	
	      this.openModal({
	        template: __webpack_require__(874),
	        windowTemplateUrl: '/modals/default/modal-container.html'
	      }).result.then(function () {
	        new _this4.model(tag).api.delete().then(function () {
	          _this4.tags.remove(tag);
	          deferred.resolve();
	        });
	      }, function () {
	        deferred.reject();
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'updateModel',
	    value: function updateModel(data, isUpdate) {
	      this.selectedTag.data = data;
	      this.setDetail(this.selectedTag.data);
	
	      var index = this.tags.data.map(function (tag) {
	        return tag.id;
	      }).indexOf(this.selectedTag.data.id);
	
	      if (index === -1) {
	        this.tags.data.push(this.selectedTag.data);
	      } else {
	        this.tags.data[index] = this.selectedTag.data;
	      }
	
	      this.filterTags();
	      // the tag list should be refreshed if updating a tag.
	      // the filtered list should contain the new tag after adding,
	      // regardless of filtering - temporarily add the new tag onto
	      // the filtered list.
	      // if (isUpdate) {
	      //     this.filterTags();
	      // } else if (!this.filteredTags.some(function (tag) {
	      //         // test if new tag is in filtered list
	      //         // special-case (when re-uploading a file)
	      //         return tag.id === data.id;
	      //     })) {
	
	      //     this.filteredTags.unshift(data);
	      // }
	    }
	  }, {
	    key: 'saveTag',
	    value: function saveTag() {
	      var _this5 = this;
	
	      this.detail.updating = true;
	      var promise = this.selectedTag.api[this.selectedTag.data.id ? 'update' : 'create']();
	      promise.then(function (data) {
	        _this5.updateModel(data, _this5.selectedTag.data.id);
	        _this5.detail.updating = false;
	        _this5.toggleTag(data);
	      }, function (r) {
	        _this5.detail.error = r.data.data;
	        _this5.detail.updating = false;
	        _this5.setDialog('error', r.data.data.displayName.error);
	      });
	
	      return promise;
	    }
	  }, {
	    key: 'toggleTag',
	    value: function toggleTag(data) {
	      this.scope.factPage.toggleTag(data);
	    }
	
	    /*deleteTag(tag) {
	      if (window.confirm('Are you sure you want to delete ' + tag.displayName +
	          '?')) {
	         this.detail.updating = true;
	         Tag.delete({
	            caseId: this.currentCase.id,
	            tagId: tag.id
	          },
	          function () {
	            // select the next Tag in filtered Tags
	            var index = this.filteredTags.indexOf(this.selectedTag.data);
	            delete this.tags[tag.id];
	            this.filterTags();
	            this.setDetail(this.filteredTags[index]);
	             // focus the list item in the ui to reflect selected state
	            // $timeout(function () {
	            angular.element('#tag-manager-list .active').focus();
	            // });
	          },
	          function () {
	            this.detail.updating = false;
	          }
	        );
	      }
	    };*/
	
	  }, {
	    key: 'selectDefault',
	    value: function selectDefault() {
	      // keep selection if selected Tag is in filtered Tags
	      // otherwise set selected Tag to first in filtered Tags
	      this.setDetail(this.filteredTags.indexOf(this.selectedTag && this.selectedTag.data) !== -1 ? this.selectedTag.data : this.filteredTags[0]);
	    }
	  }, {
	    key: 'setDetail',
	    value: function setDetail(tag) {
	      // set the detail view to (new) Tag
	
	      this.selectedTag = new this.model(tag);
	      // keep a backup if user cancels edit after making changes
	      this.backupTag = _angular2.default.copy(tag);
	
	      // newTag: detail view should show 'new'-specific fields
	      // editMode: detail view should show editable fields
	      this.detail = tag && {
	        newTag: !tag.id,
	        editMode: !tag.id,
	        updating: false
	      };
	    }
	  }, {
	    key: 'cancelDetail',
	    value: function cancelDetail() {
	
	      if (this.selectedTag.data.id) {
	        // cancel should reset detail to selected Tag when editing
	        this.updateModel(this.backupTag, true);
	      } else {
	        // cancel should select default tag when adding new
	        this.selectDefault();
	      }
	    }
	  }, {
	    key: 'newTag',
	    value: function newTag() {
	      // set the detail with the new Tag
	      this.setDetail({});
	
	      this.timeout(function () {
	        // Name input should be focused for fast input
	        _angular2.default.element('#tag-selector-list .selector-list-new-input input').focus();
	
	        // New Source should be scrolled to if it is above view
	        _angular2.default.element('#tag-selector-list > .selector-list').animate({
	          scrollTop: 0
	        });
	      });
	    }
	  }, {
	    key: 'setSearchFilter',
	    value: function setSearchFilter(search) {
	      this.searchQuery = search;
	      this.filterTags();
	    }
	  }, {
	    key: 'setSortFilter',
	    value: function setSortFilter(sortBy) {
	      // sort by tag id (last added), or by sortBy (+/- displayName)
	      if (this.sortFilter === sortBy) {
	        this.sortFilter = '-id';
	      } else {
	        this.sortFilter = sortBy;
	      }
	      this.filterTags();
	    }
	  }, {
	    key: 'filterTags',
	    value: function filterTags() {
	      // convert object to array
	      this.filteredTags = this.tags.data;
	      if (this.searchQuery) {
	        // filter by search query
	        this.filteredTags = this.filter(this.filteredTags, {
	          displayName: this.searchQuery
	        });
	      }
	      // order by sortFilter
	      this.filteredTags = this.orderBy(this.filteredTags, this.sortFilter);
	
	      // select default Tag to open in detail panel
	      this.selectDefault();
	    }
	  }]);
	  return TagsCtrl;
	}();
	
	;
	TagsCtrl.$inject = ['$routeParams', '$scope', '$q', '$filter', '$timeout', 'Tag', 'TagsTree', '$uibModal'];
	
	exports.default = _angular2.default.module('controllers.tags', [_tag2.default, _tags2.default]).controller('TagsCtrl', TagsCtrl).name;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _welcome = __webpack_require__(525);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	var _lfActionGuide = __webpack_require__(209);
	
	var _lfActionGuide2 = _interopRequireDefault(_lfActionGuide);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.welcome', [_lfActionGuide2.default, _user2.default]).constant('WelcomeModalConf', _welcome2.default).name;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _welcome = __webpack_require__(526);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  template: __webpack_require__(876),
	  controller: _welcome2.default,
	  windowClass: 'modal-welcome modal-md',
	  windowTemplateUrl: '/modals/default/modal-container.html'
	
	};

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = WelcomeCtrl;
	WelcomeCtrl.$inject = ['$scope', '$rootScope', '$compile', 'CurrentUser'];
	
	function WelcomeCtrl($scope, $rootScope, $compile, CurrentUser) {
	  $scope.user = CurrentUser.data;
	  $scope.startTour = function () {
	    if (!document.querySelector('lf-action-guide')) {
	      var guide = $compile('<lf-action-guide context="home" />')($rootScope);
	      var body = document.querySelector('body');
	      body.insertBefore(guide[0], body.firstChild);
	    }
	    $scope.$close();
	  };
	}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _model = __webpack_require__(16);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContributorFactory(Model, AnalyticsServ) {
	  return function (_Model) {
	    (0, _inherits3.default)(ContributorModel, _Model);
	
	    function ContributorModel() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      (0, _classCallCheck3.default)(this, ContributorModel);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (ContributorModel.__proto__ || (0, _getPrototypeOf2.default)(ContributorModel)).call(this, data));
	
	      _this.setApi('/case/:caseId/contributor/:contributorId', {
	        caseId: '@caseId',
	        contributorId: '@id'
	      }, {
	        add: {
	          method: 'POST',
	          isArray: true,
	          params: {
	            newUser: function newUser() {
	              return _this.getData().newUser || false;
	            }
	          },
	          success: [function (data) {
	            return _this.setData(data);
	          }, function () {
	            return AnalyticsServ.added('Contributor');
	          }],
	          fail: [function (r) {
	            if (r.status === 404) {
	              _this.data.newUser = true;
	              _this.error = {};
	            } else {
	              _this.fail(r);
	            }
	          }]
	        },
	        remove: {
	          method: 'DELETE',
	          success: [function () {
	            return _this.setData();
	          }, function () {
	            return AnalyticsServ.removed('Contributor');
	          }]
	        }
	      });
	      return _this;
	    }
	
	    return ContributorModel;
	  }(Model);
	}
	
	ContributorFactory.$inject = ['Model', 'AnalyticsServ'];
	
	exports.default = _angular2.default.module('models.contributor', [_model2.default, _analytics2.default]).factory('Contributor', ContributorFactory).name;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AccountController;
	
	var _stripeLoader = __webpack_require__(425);
	
	var _stripeLoader2 = _interopRequireDefault(_stripeLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	AccountController.$inject = ['$rootScope', '$scope', 'Plans', 'Member', 'CurrentUser', 'Box', 'Dropbox', 'CurrentCustomer', 'Coupon', 'CurrentAccount', '$location', '$q', 'PaymentStatusServ', '$uibModal', '$window', '$route', '$timeout', '$parse', 'CallingCodes', 'AuthCodeModalConf', 'PaymentModalConf', 'SubscriptionModalConf', 'RemovePhoneModalConf', 'RemoveUserModalConf', 'ReferralModalConf', 'AnalyticsServ', 'Customer', 'AccountSetupModalConf', '$anchorScroll', 'Clio'];
	
	function AccountController($rootScope, $scope, Plans, Member, CurrentUser, Box, Dropbox, CurrentCustomer, Coupon, CurrentAccount, $location, $q, PaymentStatusServ, $uibModal, $window, $route, $timeout, $parse, CallingCodes, AuthCodeModalConf, PaymentModalConf, SubscriptionModalConf, RemovePhoneModalConf, RemoveUserModalConf, ReferralModalConf, AnalyticsServ, Customer, AccountSetupModalConf, $anchorScroll, Clio) {
	
	  (0, _stripeLoader2.default)({
	    writeKey: $window.conf.stripe
	  });
	
	  $scope.account = CurrentAccount.data;
	  $scope.user = CurrentUser.data;
	  CurrentCustomer.subscribe(function () {
	    $scope.customer = CurrentCustomer.data;
	    $scope.members = CurrentCustomer.data.users;
	    // user properties specific to firm (like role)
	    $scope.customer.user = CurrentCustomer.data.users.filter(function (user) {
	      return user.id === $scope.user.id;
	    })[0];
	    $scope.selectedPlan = $parse('customer.plan.name')($scope);
	    $scope.selectedPeriod = $parse('customer.plan.period')($scope) || 'month';
	    $scope.previewPeriod = $scope.selectedPeriod;
	    $scope.isTrial = $scope.selectedPlan === 'freeTrial';
	    $scope.isCustom = $scope.selectedPlan === 'custom';
	  });
	
	  $scope.referrer = {};
	  $scope.tab = 'profile';
	  Plans.getAll().then(function (plans) {
	    $scope.plans = plans.data;
	  });
	  $scope.settingCustomer = false;
	  $scope.customerDone = false;
	  $scope.countries = CallingCodes;
	
	  var getCountry = function getCountry(code) {
	    return $scope.countries.filter(function (c) {
	      return parseInt(c.code) === parseInt(code);
	    })[0] || $scope.countries[0];
	  };
	
	  $scope.showMemberEntry = function () {
	    $scope.showNewMember = true;
	    $scope.initializeNewMember();
	    $timeout(function () {
	      document.querySelector('[name="userEmail"]')[0].focus();
	    });
	  };
	  $scope.selectRole = function (role) {
	    $scope.newMember.data.role = role;
	  };
	  $scope.initializeNewMember = function () {
	    $scope.newMember = new Member({
	      role: 'contributor'
	    });
	  };
	  $scope.cancelNewMember = function () {
	    $scope.initializeNewMember();
	    $scope.showNewMember = false;
	  };
	  $scope.addMember = function () {
	    $scope.newMember.api.add().then(function (data) {
	      $scope.showNewMember = false;
	      CurrentCustomer.setProp('users', data);
	    }, function (response) {
	      if (response.status === 404) {
	        $timeout(function () {
	          document.querySelector('[name="newMemberFirstName"]')[0].focus();
	        });
	      }
	    });
	  };
	  $scope.updateMemberRole = function (member, role) {
	    if (member.id === $scope.user.id && !$window.confirm("Are you sure you want to change your role?")) {
	      // prevent user self-removal
	      return;
	    }
	    member.role = role;
	    $scope.currentMember = new Member(member);
	    $scope.currentMember.api.update().then(function (data) {
	      return CurrentCustomer.setProp('users', data);
	    });
	  };
	
	  $scope.selectedCountry = getCountry($scope.user.countryCode);
	  var oauthCompleted = $location.search()['oauth-completed'];
	  if (oauthCompleted) {
	    $scope.$emit('updateBrowser');
	    $scope.tab = oauthCompleted !== 'cliouser' ? 'firm' : 'profile';
	    $location.search('oauth-completed', null);
	  } else if ($location.search()['tab']) {
	    $scope.tab = $location.search()['tab'];
	  }
	
	  if ($scope.user.referredBy) {
	    // lookup referrer info and set data
	    CurrentUser.api.queryInviter($scope.user.referredBy).then(function (referrer) {
	      $scope.referrer = referrer;
	    });
	  }
	
	  // scratch area for change password functionality
	  $scope.change = {};
	
	  $scope.scrollTo = $anchorScroll;
	  $scope.showCouponEntry = function () {
	    $scope.coupon.code = '';
	    $scope.couponEntryVisible = true;
	  };
	  $scope.hideCouponEntry = function () {
	    $scope.couponEntryVisible = false;
	  };
	  $scope.showCouponValidation = function (res) {
	    var msg = $parse('data.data.code.error')(res) || $parse('status')(res);
	    $scope.validatingCoupon = false;
	    $scope.couponValidation = msg;
	    if ($parse('status')(res)) {
	      analytics.track('Coupon Validated', {
	        'Coupon': $parse('coupon.code')($scope)
	      });
	    }
	  };
	  $scope.hideCouponValidation = function () {
	    $scope.couponValidation = null;
	  };
	  $scope.validateCoupon = function () {
	    if ($scope.validatingCoupon) {
	      return;
	    }
	    $scope.validatingCoupon = true;
	    Coupon.validate({
	      code: $scope.coupon.code
	    }, $scope.showCouponValidation, $scope.showCouponValidation);
	  };
	
	  $scope.changePassword = function () {
	    CurrentUser.api.changePassword(null, $scope.change).then(function () {
	      $scope.change = {};
	      $scope.passwordValidations = {};
	      $scope.passwordValidations.success = 'Your password was updated.';
	      $scope.editPassword = 0;
	    }, function (response) {
	
	      $scope.passwordValidations = response.data;
	      $scope.change = {};
	    });
	  };
	
	  $scope.accountSetupModal = function () {
	    var conf = AccountSetupModalConf;
	    conf.windowTemplateUrl = '/modals/default/modal-container.html';
	
	    $uibModal.open(conf).result.then(function () {
	      $scope.account = CurrentAccount.data;
	    });
	  };
	
	  if (!$scope.account.displayName) {
	    $scope.accountSetupModal();
	  }
	
	  $scope.resetSelection = function () {
	    // object submitted to Stripe (via getStripeToken)
	    $scope.newCard = {
	      name: '',
	      number: '',
	      cvc: '',
	      exp_month: '',
	      exp_year: ''
	    };
	    $scope.coupon = {
	      code: ''
	    };
	
	    $scope.phone = {
	      country: getCountry($scope.user.countryCode),
	      phoneNumber: $scope.user.phoneNumber,
	      phoneInput: '',
	      busy: false,
	      edit: false,
	      error: null
	    };
	  };
	
	  $scope.resetSelection();
	
	  var getStripeToken = function getStripeToken(card) {
	    // takes a newCard object, returns a promise for Stripe's response
	
	    var s = $q.defer();
	
	    Stripe.card.createToken(card, function (status, response) {
	      $timeout(function () {
	        if (response.error) {
	          // reject: {message: '', param: '(key in newCard)'}
	          s.reject(response);
	        } else {
	          // resolve: {id: ''}
	          s.resolve(response);
	        }
	      });
	    });
	
	    return s.promise;
	  };
	
	  $scope.setPaymentError = function (res) {
	    // ui expects res.error = {message: '', param: '(key in newCard)'}
	    $scope.settingCustomer = false;
	    $scope.paymentValidations = res.error;
	  };
	
	  $scope.setSubscriptionError = function (res) {
	    // ui expects res.error = {message: '', param: '(key in newCard)'}
	    $scope.settingCustomer = false;
	    $scope.subscriptionValidations = res.error;
	  };
	
	  $scope.setSubscriptionSuccess = function (data) {
	    $scope.fromTrial = $scope.isTrial;
	    CurrentCustomer.setData(data);
	    $scope.settingCustomer = false;
	    $scope.customerDone = true;
	    $scope.resetSelection();
	    if (!$scope.fromTrial) {
	      $scope.modal.close();
	    }
	  };
	
	  $scope.selectPlan = function (plan) {
	    $scope.selectedPlan = plan;
	    // without payment (inferred from freeTrial),
	    // confirm plan and enter payment
	    // with payment, confirm plan
	    if ($scope.isTrial) {
	      $scope.setupPaymentModal();
	    } else {
	      $scope.setSubscriptionModal();
	    }
	  };
	
	  $scope.selectPeriod = function (period) {
	    $scope.selectedPeriod = period;
	    $scope.previewPeriod = period;
	    if (!$scope.isTrial) {
	      $scope.setSubscriptionModal();
	    }
	  };
	  $scope.selectPreviewPeriod = function (period) {
	    $scope.previewPeriod = period;
	  };
	  $scope.setCustomer = function (card) {
	    if ($scope.settingCustomer === true) {
	      return;
	    }
	    $scope.settingCustomer = true;
	    // setCustomer will attempt to tokenize card with Stripe when called
	    // with a card, otherwise it will just set plan and period
	    var method = $scope.isTrial ? 'create' : 'update';
	    var submit = {
	      email: $scope.user.email,
	      plan: {
	        name: $scope.selectedPlan,
	        period: $scope.previewPeriod
	      },
	      payment: {}
	
	    };
	    var setCustomer = function setCustomer(token) {
	      if (token) {
	        submit.payment.stripeToken = token.id;
	      }
	      if ($scope.coupon.code) {
	        submit.payment.couponCode = $scope.coupon.code;
	      }
	      var customer = new Customer(submit);
	      customer.api[method]().then($scope.setSubscriptionSuccess, $scope.setSubscriptionError);
	    };
	
	    if (card) {
	      // Stripe tokenizes card, then
	      // calls Customer.create/update with Stripe tokenized card
	      getStripeToken(card).then(setCustomer, $scope.setPaymentError);
	    } else {
	      setCustomer();
	    }
	  };
	
	  $scope.setupPaymentModal = function () {
	    $scope.customerDone = false;
	    $scope.modal = $uibModal.open(angular.extend(PaymentModalConf, {
	      scope: $scope
	    }));
	    $scope.modal.result.then($scope.resetSelection, $scope.resetSelection);
	  };
	
	  $scope.setSubscriptionModal = function () {
	    $scope.customerDone = false;
	    $scope.modal = $uibModal.open(angular.extend(SubscriptionModalConf, {
	      scope: $scope
	    }));
	    $scope.modal.result.then($scope.resetSelection, $scope.resetSelection);
	  };
	
	  $scope.setPhoneNumber = function () {
	    // formats input[tel] for submission
	    $scope.phone.phoneNumber = $scope.phone.phoneInput.replace(/\D/g, '');
	  };
	
	  $scope.editPhone = function () {
	    $scope.phone.edit = true;
	    $timeout(function () {
	      document.querySelector('[name="phoneNumber"]').focus();
	    });
	  };
	
	  $scope.addPhone = function () {
	    if ($scope.phone.busy) return;
	    $scope.phone.busy = true;
	    CurrentUser.api.addPhone({}, {
	      countryCode: $parse('phone.country.code')($scope),
	      phoneNumber: $parse('phone.phoneNumber')($scope)
	    }).then(function () {
	      $scope.phone.error = null;
	      $scope.authCodeModal();
	    }, function (response) {
	      $scope.phone.busy = false;
	      $scope.phone.error = response.data;
	    });
	  };
	
	  $scope.authCodeModal = function () {
	    $uibModal.open(angular.extend(AuthCodeModalConf, {
	      resolve: {
	        phone: function phone() {
	          return $scope.phone;
	        }
	      }
	    })).result.then(function (data) {
	      $scope.user = data;
	      $scope.resetSelection();
	    }, $scope.resetSelection);
	  };
	
	  $scope.removePhoneModal = function () {
	    $uibModal.open(RemovePhoneModalConf).result.then(function (data) {
	      $scope.user = data;
	      $scope.resetSelection();
	    }, $scope.resetSelection);
	  };
	
	  $scope.removeUserModal = function (member) {
	    $scope.selectedMember = member;
	    $uibModal.open(angular.extend(RemoveUserModalConf, {
	      resolve: {
	        selectedMember: function selectedMember() {
	          return member;
	        }
	      }
	    })).result.then(function () {
	      return $scope.selectedMember = {};
	    }, function () {
	      return $scope.selectedMember = {};
	    });
	  };
	
	  $scope.referralModal = function (origin) {
	    $scope.modal = $uibModal.open(angular.extend(ReferralModalConf, {
	      windowTemplateUrl: '/modals/default/modal-container.html'
	    }));
	    analytics.track('Referral Modal Opened', {
	      Origin: origin || 'Account Page'
	    });
	  };
	
	  $scope.openBoxAuth = function (e) {
	    e.stopPropagation();
	    e.preventDefault();
	    var boxId = window.conf.box;
	
	    $window.open("https://account.box.com/api/oauth2/authorize?response_type=code&client_id=" + boxId + "&box_login=" + $scope.user.email + "&state=" + $scope.user.currentAccountId, '_blank', 'height=700,width=525,status=no,scrollbars=no, resizable=yes');
	  };
	  $scope.disconnectBox = function (e) {
	    e.stopPropagation();
	    e.preventDefault();
	    Box.disconnect({}, function () {
	      $scope.$emit('updateBrowser');
	      $location.url('/account?oauth-completed=box');
	      document.location.reload();
	    }, function (response) {});
	  };
	
	  $scope.openDropboxAuth = function (e) {
	    e.stopPropagation();
	    e.preventDefault();
	    var dropboxId = window.conf.dropbox;
	    var redirectUri = window.conf.dropboxUri;
	    $window.open("https://www.dropbox.com/1/oauth2/authorize?response_type=code&state=" + $scope.user.currentAccountId + "&client_id=" + dropboxId + "&redirect_uri=" + redirectUri, '_blank', 'height=700,width=525,status=no,scrollbars=no, resizable=yes');
	  };
	  $scope.disconnectDropbox = function (e) {
	    e.stopPropagation();
	    e.preventDefault();
	    Dropbox.disconnect({}, function () {
	      $scope.$emit('updateBrowser');
	      $location.url('/account?oauth-completed=box');
	      document.location.reload();
	    }, function (response) {});
	  };
	
	  $scope.openClioAuth = function (e, isUserIntegration) {
	    e.stopPropagation();
	    e.preventDefault();
	    var clioId = window.conf.clio;
	    var redirectUri = window.conf.clioUri;
	    var state = isUserIntegration ? $scope.user.id : $scope.user.currentAccountId;
	    $window.open("https://app.goclio.com/oauth/authorize?response_type=code&state=" + state + "&client_id=" + clioId + "&redirect_uri=" + redirectUri + state, '_blank', 'height=700,width=525,status=no,scrollbars=yes, resizable=yes');
	  };
	  $scope.disconnectClio = function (e, isUserIntegration) {
	    e.stopPropagation();
	    e.preventDefault();
	    Clio[isUserIntegration ? 'userDisconnect' : 'disconnect']({}, function () {
	      $scope.$emit('updateBrowser');
	      $location.url('/account?oauth-completed=clio' + (isUserIntegration ? 'user' : ''));
	      document.location.reload();
	    }, function (response) {});
	  };
	
	  $scope.update = function () {
	    CurrentUser.api.update(null, $scope.user).then(function (data) {
	      $scope.user = data;
	      $scope.nameValidations = {};
	      $scope.nameValidations.success = 'Your profile was updated.';
	      $scope.edit = 0;
	      $scope.$emit('updateBrowser');
	    }, function (response) {
	      $scope.nameValidations = response.data;
	    });
	  };
	
	  $scope.cancelPassword = function () {
	    $scope.change = {};
	    $scope.passwordValidations = {};
	    $scope.editPassword = 0;
	  };
	}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  $routeProvider.when('/account', {
	    template: __webpack_require__(877),
	    controller: 'AccountCtrl',
	    reloadOnSearch: false,
	    app: true,
	    resolve: {
	      currentUser: ['CurrentUser', 'CurrentCustomer', 'CurrentAccount', '$q', function (CurrentUser, CurrentCustomer, CurrentAccount, $q) {
	        var deferred = $q.defer();
	        CurrentUser.api.get().then(function (user) {
	          if (user.email) {
	            $q.all([CurrentCustomer.api.get(), CurrentAccount.api.get()]).then(function () {
	              deferred.resolve(user);
	            }, function (response) {
	              return deferred.reject(response);
	            });
	          } else {
	            deferred.reject();
	          }
	        }, function (response) {
	          return deferred.reject(response);
	        });
	
	        return deferred.promise;
	      }]
	    }
	  });
	}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _account = __webpack_require__(529);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _account3 = __webpack_require__(528);
	
	var _account4 = _interopRequireDefault(_account3);
	
	var _callingCodes = __webpack_require__(458);
	
	var _callingCodes2 = _interopRequireDefault(_callingCodes);
	
	var _headerNav = __webpack_require__(87);
	
	var _headerNav2 = _interopRequireDefault(_headerNav);
	
	var _lwPageFooter = __webpack_require__(88);
	
	var _lwPageFooter2 = _interopRequireDefault(_lwPageFooter);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _customer = __webpack_require__(135);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _member = __webpack_require__(319);
	
	var _member2 = _interopRequireDefault(_member);
	
	var _authCode = __webpack_require__(489);
	
	var _authCode2 = _interopRequireDefault(_authCode);
	
	var _payment = __webpack_require__(504);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _subscription = __webpack_require__(519);
	
	var _subscription2 = _interopRequireDefault(_subscription);
	
	var _removePhone = __webpack_require__(508);
	
	var _removePhone2 = _interopRequireDefault(_removePhone);
	
	var _referral = __webpack_require__(313);
	
	var _referral2 = _interopRequireDefault(_referral);
	
	var _accountSetup = __webpack_require__(311);
	
	var _accountSetup2 = _interopRequireDefault(_accountSetup);
	
	var _removeUser = __webpack_require__(511);
	
	var _removeUser2 = _interopRequireDefault(_removeUser);
	
	var _tel = __webpack_require__(481);
	
	var _tel2 = _interopRequireDefault(_tel);
	
	var _titlecase = __webpack_require__(309);
	
	var _titlecase2 = _interopRequireDefault(_titlecase);
	
	var _plans = __webpack_require__(567);
	
	var _plans2 = _interopRequireDefault(_plans);
	
	var _box = __webpack_require__(323);
	
	var _box2 = _interopRequireDefault(_box);
	
	var _coupon = __webpack_require__(562);
	
	var _coupon2 = _interopRequireDefault(_coupon);
	
	var _dropbox = __webpack_require__(325);
	
	var _dropbox2 = _interopRequireDefault(_dropbox);
	
	var _clio = __webpack_require__(162);
	
	var _clio2 = _interopRequireDefault(_clio);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('pages.account', [_headerNav2.default, _lwPageFooter2.default, _callingCodes2.default, _user2.default, _customer2.default, _member2.default, _authCode2.default, _tel2.default, _plans2.default, _box2.default, _coupon2.default, _dropbox2.default, _payment2.default, _subscription2.default, _removePhone2.default, _removeUser2.default, _referral2.default, _titlecase2.default, _clio2.default]).controller('AccountCtrl', _account4.default).config(_account2.default).name;

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DownloadCtrl;
	DownloadCtrl.$inject = ['$scope', '$window', 'os', 'AnalyticsServ'];
	
	function DownloadCtrl($scope, $window, os, AnalyticsServ) {
	
	    $scope.trackDownload = function () {
	
	        AnalyticsServ.analytics.track('Desktop App Downloaded');
	
	        AnalyticsServ.analytics.identify({
	            'Desktop App Downloaded': new Date().toUTCString()
	        });
	    };
	
	    $scope.os = os;
	
	    $scope.showDeveloperHelp = function () {
	        $scope.developerHelpVisible = true;
	    };
	
	    var isStaging = $window.location.hostname.indexOf('staging') === 0;
	
	    // file path map to download in production or staging folder
	    var paths = {
	        mac: 'FactBox-64.zip',
	        windows: 'FactBox-Setup.exe'
	    };
	
	    // path is appended to a link to the s3 bucket on the download page
	    // which is displayed if the os is mac or windows
	    if (os === 'mac' || os === 'windows') {
	        $scope.path = (isStaging ? 'staging' : 'production') + '/' + paths[os];
	    }
	}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  $routeProvider.when('/download', {
	    template: __webpack_require__(878),
	    controller: 'DownloadCtrl',
	    app: true,
	    resolve: {
	      os: function os() {
	        var p = navigator.platform.toLowerCase();
	        var os = '';
	        if (p.indexOf('mac') !== -1) {
	          os = 'mac';
	        } else if (p.indexOf('win') !== -1) {
	          os = 'windows';
	        }
	        return os;
	      }
	    }
	  });
	}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _download = __webpack_require__(532);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _download3 = __webpack_require__(531);
	
	var _download4 = _interopRequireDefault(_download3);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _headerNav = __webpack_require__(87);
	
	var _headerNav2 = _interopRequireDefault(_headerNav);
	
	var _lwPageFooter = __webpack_require__(88);
	
	var _lwPageFooter2 = _interopRequireDefault(_lwPageFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.download', [_headerNav2.default, _lwPageFooter2.default, _analytics2.default]).config(_download2.default).controller('DownloadCtrl', _download4.default).name;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FactCtrl = function () {
	  function FactCtrl($window, Fact, currentFact, FactListFactory, FactList, $routeParams, isFactWindow, $scope, CurrentCase, $location, Browser, $compile) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, FactCtrl);
	
	    this.scope = $scope;
	    this.currentCase = CurrentCase;
	
	    this.setFact(currentFact);
	    this.model = Fact;
	
	    this.window = $window;
	    this.location = $location;
	    this.browser = Browser;
	    this.isFactWindow = isFactWindow;
	    $window.isFactWindow = this.isFactWindow;
	
	    this.refreshParent = this.refreshParent.bind(this);
	
	    this.factList = this.isFactWindow ? new FactListFactory() : FactList;
	    this.factList.subscribe(function () {
	
	      _this.facts = _this.factList.data.rows ? _this.factList.data.rows.filter(function (row) {
	        return row.row !== null;
	      }).map(function (row) {
	        return row.row;
	      }) : [];
	    });
	
	    this.factParity = {
	      sources: function sources(o1, o2) {
	        return o1 && o2 && o1.every(function (s, i) {
	          return o2[i] && s.id === o2[i].id;
	        });
	      },
	      factDateish: function factDateish(o1, o2) {
	        return o1 && o2 && ['year', 'month', 'date', 'hour', 'minute', 'second'].every(function (d) {
	          o2[d] = o2[d] || null; // undefined => null for comparison
	          o1[d] = o1[d] || null;
	          return o2[d] === o1[d];
	        });
	      }
	    };
	
	    if ($routeParams.caseId && this.isFactWindow) {
	      this.getFacts();
	    }
	    if ($location.search()['action-guide']) {
	      $location.search('action-guide', null);
	      var guide = $compile('<lf-action-guide context="fact" />')($scope);
	
	      var body = document.querySelector('body');
	      body.insertBefore(guide[0], body.firstChild);
	    }
	  }
	
	  (0, _createClass3.default)(FactCtrl, [{
	    key: 'refreshParent',
	    value: function refreshParent() {
	      if (this.window.opener && this.window.opener.angular) {
	        var openerCase = this.window.opener.angular.element(this.window.opener.document.querySelector('[ng-app]')).injector().get('CurrentCase');
	        if (openerCase) {
	          openerCase.api.get();
	        }
	      }
	    }
	  }, {
	    key: 'toggleCases',
	    value: function toggleCases() {
	      this.scope.$broadcast('displayCases');
	    }
	  }, {
	    key: 'addFact',
	    value: function addFact(data) {
	      var _this2 = this;
	
	      var p = new this.model(data).api[data.id ? 'update' : 'create']();
	      p.then(function () {
	        _this2.refreshParent();
	        _this2.factList.setFact(data);
	        _this2.fact = {};
	      });
	      return p;
	    }
	  }, {
	    key: 'editFact',
	    value: function editFact(data) {
	      return new this.model(data).api.update();
	    }
	  }, {
	    key: 'getFacts',
	    value: function getFacts() {
	      var _this3 = this;
	
	      this.factList.api.getFactsByCreationDate().then(function () {
	        _this3.facts = _this3.factList.data.rows.filter(function (row) {
	          return row.row !== null;
	        }).map(function (row) {
	          return row.row;
	        });
	      });
	    }
	  }, {
	    key: 'showFact',
	    value: function showFact(next, newFact) {
	      var _this4 = this;
	
	      // higher index is older
	      if (this.abandonChanges(newFact)) {
	        this.index = this.fact.id ? this.facts.indexOf(this.fact) + (next ? -1 : 1) : next ? -1 : 0;
	
	        if (this.index >= this.facts.length && !this.factList.data.lastResult) {
	          this.factList.loadMoreByCreationDate().then(function () {
	            _this4.setFact(_this4.facts[_this4.index]);
	          });
	        } else {
	          this.setFact(this.facts[this.index]);
	        }
	      }
	    }
	  }, {
	    key: 'setFact',
	    value: function setFact(fact) {
	      this.fact = fact || {};
	    }
	  }, {
	    key: 'openCase',
	    value: function openCase() {
	      var id = this.currentCase.id || '';
	
	      // from launcher, let launcher open link in default browser
	      if (typeof launcher !== 'undefined') {
	        launcher.openLink(this.location.protocol() + '://' + this.location.host() + (this.location.port() ? ':' + this.location.port() : '') + '/#' + '/home/' + id);
	        return;
	      }
	
	      var opener = this.window.opener;
	      if (this.browser.name === 'Internet Explorer') {
	        // does not refocus buried tab
	        this.window.open('#/home/' + id, '_blank').focus();
	      } else if (opener && this.browser.name === 'Firefox') {
	        // does not refocus buried tab
	        this.window.open('#/home/' + id, '_blank').focus();
	      } else {
	        this.window.open('#/home/' + id, 'FactBox').focus();
	      }
	    }
	  }, {
	    key: 'abandonChanges',
	    value: function abandonChanges(newFact) {
	      var _this5 = this;
	
	      var parity = ['content', 'legalIssues', 'sources', 'tags', 'title', 'factDateish'].every(function (key) {
	        return newFact[key] ? _this5.factParity[key] ? _this5.factParity[key](_this5.fact[key], newFact[key]) : angular.equals(_this5.fact[key], newFact[key]) : true;
	      });
	      return parity || this.window.confirm("You have unsaved changes. Abandon changes?");
	    }
	  }]);
	  return FactCtrl;
	}();
	
	exports.default = FactCtrl;
	
	FactCtrl.$inject = ['$window', 'Fact', 'currentFact', 'FactListFactory', 'FactList', '$routeParams', 'isFactWindow', '$scope', 'CurrentCase', '$location', 'Browser', '$compile'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  var conf = {
	    template: __webpack_require__(879),
	    controller: 'FactCtrl',
	    controllerAs: '$ctrl',
	    app: true,
	    chat: false,
	    reloadOnSearch: false,
	    resolve: {
	      isFactWindow: function isFactWindow() {
	        return true;
	      },
	      currentFact: function currentFact() {
	        return null;
	      },
	      currentUser: ['CurrentCase', 'CurrentUser', 'CurrentAccount', 'CurrentCustomer', '$route', '$location', '$q', function (CurrentCase, CurrentUser, CurrentAccount, CurrentCustomer, $route, $location, $q) {
	
	        var deferred = $q.defer();
	
	        CurrentUser.api.get().then(function (user) {
	          if ($route.current.params.caseId) {
	
	            if ($location.search().finalDestination) {
	              $location.search('finalDestination', null);
	            }
	
	            $q.all([CurrentCase.api.get({
	              caseId: $route.current.params.caseId
	            }), CurrentAccount.api.get()]).then(function () {
	              return deferred.resolve(user);
	            }, function (response) {
	              return deferred.reject(response);
	            });
	          } else {
	            var redirect = !$route.current.params.finalDestination;
	            redirect && $location.url(user.email ? user.lastCaseId ? '/fact/' + user.lastCaseId : '/fact?finalDestination=true' : '/signin');
	
	            CurrentCase.setCase();
	
	            CurrentAccount.api.get().then(function () {
	              deferred.resolve(user);
	            });
	          }
	
	          // Request customer and account but don't defer promise
	          CurrentCustomer.api.get();
	        }, function () {
	          return deferred.reject();
	        });
	
	        return deferred.promise;
	      }]
	    }
	  };
	  $routeProvider.when('/fact', conf).when('/fact/:caseId', conf);
	}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _fact = __webpack_require__(535);
	
	var _fact2 = _interopRequireDefault(_fact);
	
	var _fact3 = __webpack_require__(534);
	
	var _fact4 = _interopRequireDefault(_fact3);
	
	var _fbFact = __webpack_require__(437);
	
	var _fbFact2 = _interopRequireDefault(_fbFact);
	
	var _lfActionGuide = __webpack_require__(209);
	
	var _lfActionGuide2 = _interopRequireDefault(_lfActionGuide);
	
	var _lfCaseList = __webpack_require__(304);
	
	var _lfCaseList2 = _interopRequireDefault(_lfCaseList);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _lfUpdateNotification = __webpack_require__(305);
	
	var _lfUpdateNotification2 = _interopRequireDefault(_lfUpdateNotification);
	
	var _statusNav = __webpack_require__(308);
	
	var _statusNav2 = _interopRequireDefault(_statusNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.fact', [_fbFact2.default, _lfActionGuide2.default, _lfCaseList2.default, _lfUpdateNotification2.default, _statusNav2.default, _case2.default]).config(_fact2.default).controller('FactCtrl', _fact4.default).name;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ForgotCtrl = function () {
		function ForgotCtrl(User, $document, $timeout) {
			(0, _classCallCheck3.default)(this, ForgotCtrl);
	
			this.user = new User({
				email: ''
			});
			this.completed = false;
			$timeout(function () {
				$document[0].querySelector('[name="email"]').focus();
			});
		}
	
		(0, _createClass3.default)(ForgotCtrl, [{
			key: 'requestPasswordReset',
			value: function requestPasswordReset() {
				var _this = this;
	
				this.user.api.requestReset().then(function () {
					_this.completed = true;
				});
			}
		}]);
		return ForgotCtrl;
	}();
	
	exports.default = ForgotCtrl;
	
	ForgotCtrl.$inject = ['User', '$document', '$timeout'];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  $routeProvider.when('/forgot', {
	    template: __webpack_require__(880),
	    controller: 'ForgotCtrl',
	    controllerAs: 'forgot',
	    app: false
	  });
	}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _forgot = __webpack_require__(538);
	
	var _forgot2 = _interopRequireDefault(_forgot);
	
	var _forgot3 = __webpack_require__(537);
	
	var _forgot4 = _interopRequireDefault(_forgot3);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _headerNav = __webpack_require__(87);
	
	var _headerNav2 = _interopRequireDefault(_headerNav);
	
	var _lwPageFooter = __webpack_require__(88);
	
	var _lwPageFooter2 = _interopRequireDefault(_lwPageFooter);
	
	var _statusRow = __webpack_require__(114);
	
	var _statusRow2 = _interopRequireDefault(_statusRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.forgot', [_user2.default, _headerNav2.default, _lwPageFooter2.default, _statusRow2.default]).config(_forgot2.default).controller('ForgotCtrl', _forgot4.default).name;

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  $routeProvider.when('/help', {
	    redirectTo: function redirectTo() {
	      // redirect to help (server page)
	      window.location.href = "/help";
	    }
	  });
	}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _help = __webpack_require__(540);
	
	var _help2 = _interopRequireDefault(_help);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.help', []).config(_help2.default).name;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeController = function () {
	  function HomeController($scope, $rootScope, $filter, $timeout, CurrentCase, CurrentUser, $location, $compile, $parse, $uibModal, $routeParams, $window, $q, $templateCache, IssuesModalConf, SourcesModalConf, TagsModalConf, ContributorsModalConf, DeleteFactModalConf, FactModalConf, ExportServ, FactQuery, FactList, Groupings, Fact, ArchiveCaseModalConf) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HomeController);
	
	
	    this.scope = $scope;
	    this.location = $location;
	    this.export = ExportServ.export;
	    this.window = $window;
	    this.filterDate = $filter('date');
	    this.groupings = Groupings;
	
	    this.currentCase = CurrentCase;
	    this.factQuery = FactQuery;
	    this.factQuery.subscribe(function () {
	      if (_this.factQuery.data.filterPipeline) {
	        _this.viewBy = _this.factQuery.data.filterPipeline.filter(function (f) {
	          return f.attribute !== 'keywords';
	        })[0];
	        _this.orderBy = _this.factQuery.data.orderBy[0];
	      }
	      if (_this.factQuery.data.columns) {
	        _this.groupings[_this.viewBy.attribute].columnsByGroup.forEach(function (attr) {
	          attr.visible = _this.factQuery.data.columns.indexOf(attr.key) >= 0;
	        });
	      }
	      // Ensure a default is set
	      if (!_this.factQuery.data.format) {
	        _this.factQuery.data.format = 'table';
	      }
	      if (!_this.orderBy) {
	        _this.orderBy = {
	          attribute: 'factDateish'
	        };
	      }
	      _this.hiddenFacts = _this.factQuery.data.hidden;
	    });
	
	    this.factList = FactList;
	    this.factModel = Fact;
	
	    this.modalConf = {
	      issues: IssuesModalConf,
	      sources: SourcesModalConf,
	      tags: TagsModalConf,
	      contributors: ContributorsModalConf,
	      deleteFact: DeleteFactModalConf,
	      fact: FactModalConf,
	      archiveCase: ArchiveCaseModalConf
	    };
	    this.emptyAttrText = {
	      factDateish: 'Add a fact with a date',
	      sources: 'Add a source',
	      legalIssues: 'Add an issue',
	      tags: 'Add a tag',
	      contributors: 'Add a contributor',
	      content: 'Add a fact with content',
	      title: 'Add a fact with a title'
	    };
	    this.openModal = $uibModal.open;
	    this.currentDate = $filter('date')(new Date(), 'longDate');
	
	    // this.sourcesModal()
	  }
	
	  (0, _createClass3.default)(HomeController, [{
	    key: 'setCaseName',
	    value: function setCaseName(newValue) {
	      this.currentCase.setProp('displayName', newValue);
	      return this.currentCase.api.update();
	    }
	  }, {
	    key: 'archiveCase',
	    value: function archiveCase() {
	      var _this2 = this;
	
	      this.openModal(this.modalConf.archiveCase).result.then(function () {
	        _this2.currentCase.setProp('status', 'archived');
	        _this2.currentCase.api.update().then(function () {
	          _this2.location.search('finalDestination', true);
	          _this2.location.path('/home');
	        });
	      });
	    }
	  }, {
	    key: 'toggleCases',
	    value: function toggleCases() {
	      this.scope.$broadcast('displayCases');
	    }
	  }, {
	    key: 'caseModal',
	    value: function caseModal() {
	      this.scope.caseModal();
	    }
	  }, {
	    key: 'selectRow',
	    value: function selectRow(item, index) {
	      if (!item.row) {
	        return;
	      } else if (this.selectedRow && this.selectedRow.row === item.row && this.selectedRow.index === index) {
	        this.deselectRow();
	        return;
	      }
	      this.selectedRow = item;
	      this.selectedRow.index = index;
	    }
	  }, {
	    key: 'deselectRow',
	    value: function deselectRow() {
	      this.selectedRow = {};
	    }
	  }, {
	    key: 'editRow',
	    value: function editRow(item) {
	      var _this3 = this;
	
	      if (!item.row || this.scope.isVisitor) {
	        return;
	      }
	      this.selectedRow = item;
	      this.openModal(angular.extend(this.modalConf.fact, {
	        resolve: {
	          isFactWindow: function isFactWindow() {
	            return false;
	          },
	          currentFact: function currentFact() {
	            return _this3.selectedRow.row;
	          }
	        }
	      })).result.then(function () {
	        _this3.factList.reload(item.index);
	      });
	    }
	  }, {
	    key: 'deleteRow',
	    value: function deleteRow(item) {
	      var _this4 = this;
	
	      if (!item.row || this.scope.isVisitor) {
	        return;
	      }
	      var factModel = new this.factModel(item.row);
	
	      factModel.api.delete().then(function () {
	        // delete from fact list
	      }, function (response) {
	        if (response.status === 412) {
	          _this4.openModal(_this4.modalConf.deleteFact).result.then(function () {
	            factModel.api.delete().then(function () {
	              _this4.factList.removeFact(item.row);
	              _this4.deselectRow();
	            });
	          });
	        }
	      });
	    }
	  }, {
	    key: 'updateQuery',
	    value: function updateQuery(key, value) {
	      this.factQuery.data[key] = value;
	      this.factQuery.api.update();
	    }
	  }, {
	    key: 'setSorting',
	    value: function setSorting(key, order) {
	      if (!this.groupings[key].secondarySortable) {
	        return;
	      }
	      this.orderBy.attribute = key;
	      this.orderBy.order = order;
	      this.factQuery.data.orderBy[0] = this.orderBy;
	      this.factQuery.api.update();
	    }
	  }, {
	    key: 'toggleSorting',
	    value: function toggleSorting(key) {
	      var order = this.orderBy.attribute === key ? {
	        desc: 'asc',
	        asc: 'desc'
	      }[this.orderBy.order] : this.orderBy.order;
	
	      this.setSorting(key, order);
	    }
	  }, {
	    key: 'toggleColumn',
	    value: function toggleColumn(column) {
	      var _this5 = this;
	
	      var getCols = function getCols() {
	        return _this5.groupings[_this5.viewBy.attribute].columnsByGroup.filter(function (col) {
	          return col.visible;
	        });
	      };
	      // don't allow the last column to be hidden
	      if (getCols().length + (column.visible ? -1 : 1) <= 0) {
	        return;
	      }
	      column.visible = !column.visible;
	
	      var sortableCols = getCols().map(function (col) {
	        return _this5.groupings[col.key];
	      }).filter(function (col) {
	        return col.secondarySortable;
	      }).map(function (col) {
	        return col.key;
	      });
	
	      if (sortableCols.length === 0) {
	        this.orderBy.attribute = this.viewBy.attribute;
	      } else if (sortableCols.indexOf(this.orderBy.attribute) === -1 || this.orderBy.attribute === this.viewBy.attribute) {
	        this.orderBy.attribute = sortableCols[0];
	      }
	
	      this.factQuery.data.columns = getCols().map(function (col) {
	        return col.key;
	      });
	      this.factQuery.data.orderBy[0] = this.orderBy;
	      this.factQuery.api.update();
	    }
	  }, {
	    key: 'openAddFact',
	    value: function openAddFact() {
	      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      // Sets the name of the current window for Add Fact windows to reference
	      this.window.name = 'FactBox';
	      var url = '#/fact/' + (this.currentCase.data.id || id);
	      if (this.scope.guideEnabled) {
	        url += '?action-guide=true';
	      }
	      this.window.open(url, '_blank', 'height=448,width=672,status=no,scrollbars=no, resizable=yes');
	    }
	  }, {
	    key: 'issuesModal',
	    value: function issuesModal() {
	      var _this6 = this;
	
	      this.openModal(this.modalConf.issues).result.then(function () {
	        return _this6.currentCase.api.get();
	      }, function () {
	        return _this6.currentCase.api.get();
	      });
	    }
	  }, {
	    key: 'sourcesModal',
	    value: function sourcesModal() {
	      var _this7 = this;
	
	      this.openModal(this.modalConf.sources).result.then(function () {
	        return _this7.currentCase.api.get();
	      }, function () {
	        return _this7.currentCase.api.get();
	      });
	    }
	  }, {
	    key: 'tagsModal',
	    value: function tagsModal() {
	      var _this8 = this;
	
	      this.openModal(this.modalConf.tags).result.then(function () {
	        return _this8.currentCase.api.get();
	      }, function () {
	        return _this8.currentCase.api.get();
	      });
	    }
	  }, {
	    key: 'contributorsModal',
	    value: function contributorsModal() {
	      var _this9 = this;
	
	      this.openModal(this.modalConf.contributors).result.then(function () {
	        return _this9.currentCase.api.get();
	      }, function () {
	        return _this9.currentCase.api.get();
	      });
	    }
	  }, {
	    key: 'deleteFactModal',
	    value: function deleteFactModal() {
	      var _this10 = this;
	
	      this.openModal(this.modalConf.deleteFact).result.then(function () {
	        return _this10.currentCase.api.get();
	      }, function () {
	        return _this10.currentCase.api.get();
	      });
	    }
	  }, {
	    key: 'hideRow',
	    value: function hideRow(item) {
	      if (!item.row) {
	        return;
	      }
	      if (this.hiddenFacts.indexOf(item.row.id) === -1) {
	        this.hiddenFacts.push(item.row.id);
	        this.factList.removeFact(item.row);
	        this.deselectRow();
	        this.updateQuery('hidden', this.hiddenFacts);
	      }
	    }
	  }, {
	    key: 'unhideFacts',
	    value: function unhideFacts() {
	      this.hiddenFacts = [];
	      this.updateQuery('hidden', this.hiddenFacts);
	    }
	  }]);
	  return HomeController;
	}();
	
	exports.default = HomeController;
	;
	
	HomeController.$inject = ['$scope', '$rootScope', '$filter', '$timeout', 'CurrentCase', 'CurrentUser', '$location', '$compile', '$parse', '$uibModal', '$routeParams', '$window', '$q', '$templateCache', 'IssuesModalConf', 'SourcesModalConf', 'TagsModalConf', 'ContributorsModalConf', 'DeleteFactModalConf', 'FactModalConf', 'ExportServ', 'FactQuery', 'FactList', 'Groupings', 'Fact', 'ArchiveCaseModalConf'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  var conf = {
	    template: __webpack_require__(881),
	    controller: 'HomeController',
	    controllerAs: 'home',
	    app: true,
	    chat: false,
	    resolve: {
	      currentUser: ['CurrentCase', 'CurrentUser', 'CaseMap', 'CurrentCustomer', '$route', '$location', '$q', function (CurrentCase, CurrentUser, CaseMap, CurrentCustomer, $route, $location, $q) {
	
	        var deferred = $q.defer();
	
	        CurrentUser.api.get().then(function (user) {
	          if ($route.current.params.caseId) {
	
	            if ($location.search().finalDestination) {
	              $location.search('finalDestination', null);
	            }
	
	            $q.all([CurrentCase.api.get({
	              caseId: $route.current.params.caseId
	            }), CaseMap.api.get()]).then(function () {
	              return deferred.resolve(user);
	            }, function (response) {
	              return deferred.reject(response);
	            });
	          } else {
	            var redirect = !$route.current.params.finalDestination;
	            redirect && $location.url(user.email ? user.lastCaseId ? '/home/' + user.lastCaseId : '/home?finalDestination=true' : '/signin');
	
	            CurrentCase.setCase();
	
	            CaseMap.api.get().then(function () {
	              deferred.resolve(user);
	            });
	          }
	
	          // Request customer and account but don't defer promise
	          CurrentCustomer.api.get();
	        }, function () {
	          return deferred.reject();
	        });
	
	        return deferred.promise;
	      }]
	    }
	  };
	
	  $routeProvider.when('/home', conf).when('/home/:caseId', conf).when('/home/:caseId/fact/:factId', conf);
	};

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(543);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(542);
	
	var _home4 = _interopRequireDefault(_home3);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _account = __webpack_require__(75);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _caseMap = __webpack_require__(218);
	
	var _caseMap2 = _interopRequireDefault(_caseMap);
	
	var _case = __webpack_require__(36);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _factQuery = __webpack_require__(63);
	
	var _factQuery2 = _interopRequireDefault(_factQuery);
	
	var _fact = __webpack_require__(219);
	
	var _fact2 = _interopRequireDefault(_fact);
	
	var _factList = __webpack_require__(89);
	
	var _factList2 = _interopRequireDefault(_factList);
	
	var _groupings = __webpack_require__(216);
	
	var _groupings2 = _interopRequireDefault(_groupings);
	
	var _issues = __webpack_require__(501);
	
	var _issues2 = _interopRequireDefault(_issues);
	
	var _sources = __webpack_require__(515);
	
	var _sources2 = _interopRequireDefault(_sources);
	
	var _tags = __webpack_require__(521);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _contributors = __webpack_require__(492);
	
	var _contributors2 = _interopRequireDefault(_contributors);
	
	var _deleteFact = __webpack_require__(497);
	
	var _deleteFact2 = _interopRequireDefault(_deleteFact);
	
	var _fact3 = __webpack_require__(500);
	
	var _fact4 = _interopRequireDefault(_fact3);
	
	var _archiveCase = __webpack_require__(487);
	
	var _archiveCase2 = _interopRequireDefault(_archiveCase);
	
	var _export = __webpack_require__(565);
	
	var _export2 = _interopRequireDefault(_export);
	
	var _lfCaseList = __webpack_require__(304);
	
	var _lfCaseList2 = _interopRequireDefault(_lfCaseList);
	
	var _lfFilterList = __webpack_require__(475);
	
	var _lfFilterList2 = _interopRequireDefault(_lfFilterList);
	
	var _lwCounter = __webpack_require__(480);
	
	var _lwCounter2 = _interopRequireDefault(_lwCounter);
	
	var _adminNav = __webpack_require__(460);
	
	var _adminNav2 = _interopRequireDefault(_adminNav);
	
	var _caseEnable = __webpack_require__(462);
	
	var _caseEnable2 = _interopRequireDefault(_caseEnable);
	
	var _fbEditable = __webpack_require__(300);
	
	var _fbEditable2 = _interopRequireDefault(_fbEditable);
	
	var _lwOnScrollEnd = __webpack_require__(210);
	
	var _lwOnScrollEnd2 = _interopRequireDefault(_lwOnScrollEnd);
	
	var _fbOnDelete = __webpack_require__(303);
	
	var _fbOnDelete2 = _interopRequireDefault(_fbOnDelete);
	
	var _paymentEnable = __webpack_require__(306);
	
	var _paymentEnable2 = _interopRequireDefault(_paymentEnable);
	
	var _statusNav = __webpack_require__(308);
	
	var _statusNav2 = _interopRequireDefault(_statusNav);
	
	var _lfUpdateNotification = __webpack_require__(305);
	
	var _lfUpdateNotification2 = _interopRequireDefault(_lfUpdateNotification);
	
	var _caseStatus = __webpack_require__(463);
	
	var _caseStatus2 = _interopRequireDefault(_caseStatus);
	
	var _lfActionGuide = __webpack_require__(209);
	
	var _lfActionGuide2 = _interopRequireDefault(_lfActionGuide);
	
	var _lfContributorEnable = __webpack_require__(472);
	
	var _lfContributorEnable2 = _interopRequireDefault(_lfContributorEnable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.home', [_user2.default, _account2.default, _caseMap2.default, _case2.default, _factQuery2.default, _factList2.default, _lfCaseList2.default, _lfFilterList2.default, _lwCounter2.default, _adminNav2.default, _caseEnable2.default, _fbEditable2.default, _lwOnScrollEnd2.default, _fbOnDelete2.default, _paymentEnable2.default, _statusNav2.default, _lfUpdateNotification2.default, _issues2.default, _sources2.default, _tags2.default, _contributors2.default, _deleteFact2.default, _fact4.default, _export2.default, _caseStatus2.default, _groupings2.default, _fact2.default, _lfActionGuide2.default, _lfContributorEnable2.default, _archiveCase2.default]).config(_home2.default).controller('HomeController', _home4.default).name;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _oauthCompleted = __webpack_require__(546);
	
	var _oauthCompleted2 = _interopRequireDefault(_oauthCompleted);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.oauth-completed', []).config(_oauthCompleted2.default).name;

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  $routeProvider.when('/oauth-completed', {
	    resolve: {
	      updateParent: ['$window', '$location', function ($window, $location) {
	        // refresh parent window and close this child window
	        var opener = $window.opener;
	        var integration = $location.search()['integration'];
	
	        // the clio user auth flow may come from the welcome page or
	        // the account page. when it's from the welcome page, redirect home.
	        var path = integration === 'cliouser' && !/account/g.test(opener && opener.location.href) ? '/app/#/home' : '/app/#/account?oauth-completed=' + (integration || 'box');
	
	        if (opener) {
	          opener.location.href = path;
	          opener.location.reload();
	        } else {
	          $window.open(path);
	        }
	
	        $window.close();
	      }]
	    }
	  });
	}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _reset = __webpack_require__(549);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	var _reset3 = __webpack_require__(548);
	
	var _reset4 = _interopRequireDefault(_reset3);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _headerNav = __webpack_require__(87);
	
	var _headerNav2 = _interopRequireDefault(_headerNav);
	
	var _lwPageFooter = __webpack_require__(88);
	
	var _lwPageFooter2 = _interopRequireDefault(_lwPageFooter);
	
	var _statusRow = __webpack_require__(114);
	
	var _statusRow2 = _interopRequireDefault(_statusRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.reset', [_user2.default, _headerNav2.default, _lwPageFooter2.default, _statusRow2.default, _analytics2.default]).config(_reset2.default).controller('ResetCtrl', _reset4.default).name;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResetController = function () {
	  function ResetController($scope, $rootScope, $routeParams, $location, $window, User, AnalyticsServ) {
	    (0, _classCallCheck3.default)(this, ResetController);
	
	    this.location = $location;
	    this.window = $window;
	    this.analyticsServ = AnalyticsServ;
	    this.user = new User({
	      token: $routeParams.token,
	      welcome: $location.path() === '/welcome',
	      password: null
	    });
	    this.clioAuthFlow = $location.search()['authenticate-clio'];
	    this.redirect = $routeParams.path || '/home';
	    document.querySelector('[name="password"]').focus();
	  }
	
	  (0, _createClass3.default)(ResetController, [{
	    key: 'openClioAuth',
	    value: function openClioAuth(e) {
	      e.stopPropagation();
	      e.preventDefault();
	      var clioId = window.conf.clio;
	      var redirectUri = window.conf.clioUri;
	      this.window.open("https://app.goclio.com/oauth/authorize?response_type=code&state=" + this.user.data.id + "&client_id=" + clioId + "&redirect_uri=" + redirectUri + this.user.data.id, '_blank', 'height=700,width=525,status=no,scrollbars=no, resizable=yes');
	    }
	  }, {
	    key: 'setPassword',
	    value: function setPassword() {
	      var _this = this;
	
	      this.user.api.initPassword().then(function (data) {
	        _this.analyticsServ.signedUp(data, true);
	        if (_this.clioAuthFlow) {
	          _this.showClioAuthStep = true;
	        } else {
	          _this.location.url(_this.redirect);
	        }
	      });
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword() {
	      var _this2 = this;
	
	      this.user.api.resetPassword().then(function () {
	        _this2.analyticsServ.analytics.track('Password Reset');
	        _this2.location.url(_this2.redirect);
	      });
	    }
	  }]);
	  return ResetController;
	}();
	
	exports.default = ResetController;
	
	ResetController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', '$window', 'User', 'AnalyticsServ'];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  $routeProvider.when('/reset', {
	    template: __webpack_require__(882),
	    controller: 'ResetCtrl',
	    controllerAs: 'reset',
	    app: false
	  }).when('/welcome', {
	    template: __webpack_require__(883),
	    controller: 'ResetCtrl',
	    controllerAs: 'reset',
	    app: false
	  });
	}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SigninCtrl = function () {
	  function SigninCtrl($location, $scope, ReloadServ, CurrentUser, $window, $timeout, $routeParams) {
	    (0, _classCallCheck3.default)(this, SigninCtrl);
	
	    this.user = CurrentUser;
	    this.routeParams = $routeParams;
	    this.reloadServ = ReloadServ;
	    this.timeout = $timeout;
	    this.window = $window;
	    this.location = $location;
	    this.scope = $scope;
	
	    this.timeout(function () {
	      document.querySelectorAll('[name="email"]')[0].focus();
	    });
	
	    // this.user.api.get().then(user => {
	    //   $location.path('/home');
	    // });
	    this.resetSignup();
	  }
	
	  (0, _createClass3.default)(SigninCtrl, [{
	    key: 'resetSignup',
	    value: function resetSignup() {
	      this.user.data = {
	        rememberMe: true
	      };
	      this.sms = {
	        busy: false,
	        done: false
	      };
	      this.signUpConfirm = false;
	    }
	  }, {
	    key: 'showCodeEntry',
	    value: function showCodeEntry() {
	      this.codeEntryVisible = true;
	      this.timeout(function () {
	        document.querySelectorAll('[name="mfaCode"]')[0].focus();
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit(modal) {
	      var _this = this;
	
	      // delete this.statusMessages.mfaCode;
	
	      this.user.api.signin().then(function (data) {
	        _this.reloadServ.updateTabs();
	        // Set location destination and force a page reload to ensure latest
	        // Visit /mobile page if browser is mobile (passing path to redirect if user continues). 
	
	        // redirect user to requested path or home on login
	        if (modal) {
	          _this.scope.$close(data);
	        } else {
	          var redirectPath;
	          if (_this.routeParams.redirect) {
	            redirectPath = _this.routeParams.redirect;
	          } else {
	            redirectPath = _this.window.isFactWindow ? '/fact' : '/home';
	            if (_this.user.data.lastCaseId) {
	              redirectPath += '/' + _this.user.data.lastCaseId;
	            }
	          }
	
	          _this.window.location.href = '/app/#' + _this.location.url(redirectPath).url();
	          _this.window.location.reload();
	        }
	      }, function () {
	        if (_this.user.error.data && (_this.user.error.data.mfaCode || _this.user.error.details === 'Token is invalid.')) {
	          _this.showCodeEntry();
	        } else {
	          // on a failed login attempt, assume a bad password and clear out
	          // this field to allow the user to try again.
	          _this.user.data.password = '';
	        }
	      });
	    }
	  }, {
	    key: 'sendSMS',
	    value: function sendSMS(force) {
	      var _this2 = this;
	
	      if (this.sms.busy) return;
	      this.sms.busy = true;
	      this.user.api.sendSMS({
	        email: this.user.data.email,
	        force: !!force
	      }).then(function () {
	        _this2.sms.done = true;
	        _this2.sms.busy = false;
	        _this2.sms.feedback = {
	          type: 'success',
	          message: 'Please enter Auth Code sent via SMS'
	        };
	        _this2.showCodeEntry();
	      }, function (response) {
	        _this2.sms.busy = false;
	        if (response.status === 400) {
	          _this2.sms.feedback = {
	            type: 'error',
	            message: 'Please enter email'
	          };
	        } else if (response.status === 404) {
	          _this2.sms.feedback = {
	            type: 'info',
	            message: 'No authentication device found.'
	          };
	        }
	      });
	    }
	  }]);
	  return SigninCtrl;
	}();
	
	exports.default = SigninCtrl;
	
	SigninCtrl.$inject = ['$location', '$scope', 'ReloadServ', 'CurrentUser', '$window', '$timeout', '$routeParams'];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  $routeProvider.when('/signin', {
	    template: __webpack_require__(884),
	    controller: 'SigninCtrl',
	    controllerAs: 'signin',
	    app: false,
	    resolve: {
	      currentUser: ['CurrentUser', '$q', '$route', '$window', '$location', function (CurrentUser, $q, $route, $window, $location) {
	        var u = $q.defer();
	        CurrentUser.api.fetch().then(function (user) {
	          var redirectPath;
	          if ($route.current.params.redirect) {
	            redirectPath = $route.current.params.redirect;
	          } else {
	            redirectPath = $window.isFactWindow ? '/fact' : '/home';
	            if (user.lastCaseId) {
	              redirectPath += '/' + user.lastCaseId;
	            }
	          }
	          $location.url(redirectPath);
	        }, function () {
	          u.resolve();
	        });
	        return u.promise;
	      }]
	    }
	  });
	}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(554);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _signup3 = __webpack_require__(553);
	
	var _signup4 = _interopRequireDefault(_signup3);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _account = __webpack_require__(75);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _headerNav = __webpack_require__(87);
	
	var _headerNav2 = _interopRequireDefault(_headerNav);
	
	var _lwPageFooter = __webpack_require__(88);
	
	var _lwPageFooter2 = _interopRequireDefault(_lwPageFooter);
	
	var _statusRow = __webpack_require__(114);
	
	var _statusRow2 = _interopRequireDefault(_statusRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.signup', [_user2.default, _account2.default, _headerNav2.default, _lwPageFooter2.default, _statusRow2.default, _analytics2.default]).config(_signup2.default).controller('SignupCtrl', _signup4.default).name;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignupController = function () {
	  function SignupController(CurrentUser, CurrentAccount, $location, $window, $timeout, AnalyticsServ) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SignupController);
	
	    this.analyticsServ = AnalyticsServ;
	    this.location = $location;
	    this.window = $window;
	    this.user = CurrentUser;
	    this.account = CurrentAccount;
	    this.timeout = $timeout;
	    this.setAccountName = false;
	
	    this.variant = $location.search().variant;
	    this.lexicon = $location.search().lexicon;
	
	    var referrerCode = $location.search().referrer;
	    if (typeof referrerCode === 'string') {
	      // lookup referrer info and set data
	      this.user.api.queryInviter({ id: referrerCode }).then(function (referrer) {
	        _this.referrer = referrer;
	      });
	    }
	    this.user.setData({});
	    document.querySelectorAll('[name="firstName"]')[0].focus();
	  }
	
	  (0, _createClass3.default)(SignupController, [{
	    key: 'redirectHome',
	    value: function redirectHome() {
	      this.window.location.href = '/app/#' + this.location.url('/home').url();
	      this.window.location.reload();
	    }
	  }, {
	    key: 'signup',
	    value: function signup() {
	      var _this2 = this;
	
	      if (this.lexicon) {
	        this.user.data.lexicon = this.lexicon;
	      }
	      this.user.api.signup().then(function (data) {
	
	        _this2.account.api.get().then(function () {
	          if (!_this2.account.data.displayName) {
	            _this2.setAccountName = true;
	            _this2.timeout(function () {
	              document.querySelectorAll('[name="firm-name"]')[0].focus();
	            }, 0, false);
	          } else {
	            _this2.redirectHome();
	          }
	        });
	
	        _this2.analyticsServ.setUser({
	          id: data.id,
	          'Referred By': _this2.referrer && _this2.referrer.email,
	          'Variant': _this2.variant || 'default'
	        });
	      });
	    }
	  }, {
	    key: 'nameAccount',
	    value: function nameAccount() {
	      var _this3 = this;
	
	      this.account.api.update().then(function () {
	        _this3.redirectHome();
	      });
	    }
	  }]);
	  return SignupController;
	}();
	
	exports.default = SignupController;
	
	SignupController.$inject = ['CurrentUser', 'CurrentAccount', '$location', '$window', '$timeout', 'AnalyticsServ'];

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  $routeProvider.when('/signup', {
	    template: __webpack_require__(885),
	    controller: 'SignupCtrl',
	    controllerAs: 'signup',
	    app: false
	  });
	}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tutorial = __webpack_require__(557);
	
	var _tutorial2 = _interopRequireDefault(_tutorial);
	
	var _tutorial3 = __webpack_require__(556);
	
	var _tutorial4 = _interopRequireDefault(_tutorial3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.signin').config(_tutorial2.default).controller('TutorialCtrl', _tutorial4.default).name;

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = TutorialCtrl;
	TutorialCtrl.$inject = ['$rootScope', '$scope', '$window'];
	
	function TutorialCtrl($rootScope, $scope, $window) {
	    $scope.openAddFact = function () {
	        // Sets the name of the current window for Add Fact windows to reference
	        $window.name = 'Factbox BOC';
	        // prevent the fact window from navigating to case
	        $rootScope.preventCaseChange = true;
	        var url = '#/fact/';
	        $window.open(url, '_blank', 'height=525,width=475,status=no,scrollbars=no, resizable=yes');
	    };
	}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  $routeProvider.when('/boc', {
	    template: __webpack_require__(886),
	    controller: 'TutorialCtrl',
	    app: false
	  });
	}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _verify = __webpack_require__(560);
	
	var _verify2 = _interopRequireDefault(_verify);
	
	var _verify3 = __webpack_require__(559);
	
	var _verify4 = _interopRequireDefault(_verify3);
	
	var _user = __webpack_require__(24);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _reload = __webpack_require__(139);
	
	var _reload2 = _interopRequireDefault(_reload);
	
	var _headerNav = __webpack_require__(87);
	
	var _headerNav2 = _interopRequireDefault(_headerNav);
	
	var _lwPageFooter = __webpack_require__(88);
	
	var _lwPageFooter2 = _interopRequireDefault(_lwPageFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.verify', [_user2.default, _headerNav2.default, _lwPageFooter2.default, _reload2.default]).config(_verify2.default).controller('VerifyCtrl', _verify4.default).name;

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = VerifyCtrl;
	VerifyCtrl.$inject = ['$scope', 'verifiedUser'];
	
	function VerifyCtrl($scope, verifiedUser) {
		$scope.verifiedUser = verifiedUser;
	}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	routes.$inject = ['$routeProvider'];
	
	function routes($routeProvider) {
	  $routeProvider.when('/verify', {
	    template: __webpack_require__(887),
	    controller: 'VerifyCtrl',
	    reloadOnSearch: false,
	    app: true,
	    resolve: {
	      verifiedUser: ['CurrentUser', '$route', '$q', '$location', 'ReloadServ', function (CurrentUser, $route, $q, $location, ReloadServ) {
	        var v = $q.defer();
	        CurrentUser.api.get().then(function () {
	          if (CurrentUser.data.verified) {
	            // if user is verified, redirect user if path is passed
	            // or just display verified page
	            if ($route.current.params.path) {
	              $location.url($route.current.params.path);
	            } else {
	              v.resolve(CurrentUser);
	            }
	          } else if ($route.current.params.token) {
	            // if user has token, attempt verification, 
	            // on success, redirect user if path passed or
	            // just display verified page
	            CurrentUser.api.verify({
	              token: $route.current.params.token
	            }, function () {
	              ReloadServ.updateTabs();
	              if ($route.current.params.path) {
	                $location.path($route.current.params.path);
	              } else {
	                v.resolve(CurrentUser);
	              }
	            }, function () {
	              v.resolve({
	                error: 'account'
	              });
	            });
	          } else {
	            v.resolve({
	              error: 'token'
	            });
	          }
	        });
	        return v.promise;
	      }]
	    }
	  });
	}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(33);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(576);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _actionGuide = __webpack_require__(457);
	
	var _actionGuide2 = _interopRequireDefault(_actionGuide);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGuideServ = function () {
	  function ActionGuideServ(ActionGuide, AnalyticsServ, $rootScope) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ActionGuideServ);
	
	    this.analytics = analytics;
	    this.rootScope = $rootScope;
	    this.success = this.success.bind(this);
	    this.reset = function () {
	      _this.rootScope.guideEnabled = false;
	      _this.guides = ActionGuide.guides;
	      _this.steps = _angular2.default.copy(ActionGuide.steps);
	      _this.activeGuide = null;
	      _this.activeStep = null;
	      _this.activeIndex = null;
	      _this.unbinders = [];
	      _this.contexts = {};
	    };
	    this.reset();
	    this.anchors = {
	      element: {
	        pos: {
	          left: this.xy(-1, 0),
	          right: this.xy(0, 0),
	          top: this.xy(0, -1),
	          bottom: this.xy(0, 0),
	          center: this.xy(-0.5, -0.5)
	        },
	        align: {
	          left: this.xy(0, 0),
	          right: this.xy(-1, 0),
	          top: this.xy(0, 0),
	          bottom: this.xy(0, -1),
	          center: this.xy(-0.5, -0.5)
	        }
	      },
	      source: {
	        left: this.xy(0, 0),
	        right: this.xy(1, 0),
	        top: this.xy(0, 0),
	        bottom: this.xy(0, 1),
	        center: this.xy(0.5, 0.5)
	      }
	    };
	  }
	
	  (0, _createClass3.default)(ActionGuideServ, [{
	    key: 'xy',
	    value: function xy(left, top) {
	      return { left: left, top: top };
	    }
	  }, {
	    key: 'getCoordinates',
	    value: function getCoordinates(elem, target, location) {
	      var _location$split = location.split('-'),
	          _location$split2 = (0, _slicedToArray3.default)(_location$split, 2),
	          pos = _location$split2[0],
	          align = _location$split2[1];
	      // elem and target $() elems, location 'top-left'
	
	
	      var anchors = this.anchors;
	
	      var _target$getBoundingCl = target.getBoundingClientRect(),
	          offsetTop = _target$getBoundingCl.top,
	          offsetLeft = _target$getBoundingCl.left;
	
	      var top = offsetTop + target.scrollHeight * (anchors.source[pos].top + anchors.source[align].top) + elem.scrollHeight * (anchors.element.pos[pos].top + anchors.element.align[align].top);
	      var left = offsetLeft + target.scrollWidth * (anchors.source[pos].left + anchors.source[align].left) + elem.scrollWidth * (anchors.element.pos[pos].left + anchors.element.align[align].left);
	      return { top: top + 'px', left: left + 'px' };
	    }
	  }, {
	    key: 'success',
	    value: function success() {
	      if (this.activeStep) {
	        this.activeStep.complete = true;
	      }
	      if (this.activeStep.skipComplete) {
	        this.nextStep();
	      }
	    }
	  }, {
	    key: 'watch',
	    value: function watch() {
	      var _this2 = this;
	
	      var targetConext = this.contexts[this.activeStep.context];
	      if (!targetConext) {
	        return;
	      }
	      var target = targetConext(this.activeStep.watch.target);
	
	      this.unbinders.push(function () {
	        target.removeEventListener(_this2.activeStep.watch.event, _this2.success);
	      });
	      target.addEventListener(this.activeStep.watch.event, this.success);
	    }
	  }, {
	    key: 'attach',
	    value: function attach() {
	      var targetConext = this.contexts[this.activeStep.context];
	      if (!targetConext) {
	        return;
	      }
	      var target = targetConext(this.activeStep.attach.target);
	      var elem = targetConext('#action-guide-popover');
	
	      this.activeStep.elementStyle = this.activeStep.manualPosition ? this.activeStep.elementStyle : this.getCoordinates(elem, target, this.activeStep.attach.location);
	    }
	  }, {
	    key: 'connect',
	    value: function connect(context, contextualEval) {
	      this.contexts[context] = contextualEval;
	    }
	  }, {
	    key: 'setGuide',
	    value: function setGuide(key) {
	      var _this3 = this;
	
	      this.activeGuide = this.guides[key].map(function (step) {
	        return _this3.steps[step];
	      });
	      this.setStep(this.activeIndex || 0);
	      this.rootScope.guideEnabled = true;
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(index) {
	      this.activeIndex = index;
	      if (index <= this.activeGuide.length + 1) {
	        this.activeStep = index === this.activeGuide.length ? this.steps['conclusion'] : index === this.activeGuide.length + 1 ? this.steps['close'] : this.activeGuide[this.activeIndex];
	        this.watch();
	        this.attach();
	      } else {
	        this.close();
	      }
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep() {
	      this.unbindWatchers();
	      var index = this.activeIndex + 1;
	      this.setStep(index);
	    }
	  }, {
	    key: 'finish',
	    value: function finish() {
	      // trigger hide warning
	      this.setStep(this.activeGuide.length + 1);
	      this.watch();
	      this.attach();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      var _this4 = this;
	
	      this.unbindWatchers();
	      (0, _keys2.default)(this.contexts).map(function (key) {
	        _this4.contexts[key]('lf-action-guide').remove();
	      });
	
	      var completed = this.activeGuide.filter(function (step) {
	        return step.complete;
	      }).length;
	
	      this.analytics.track('Guide Closed', {
	        'Guide Completion Rate': completed / this.activeGuide.length
	      });
	      this.analytics.identify({
	        'Guide Completed': completed === this.activeGuide.length
	      });
	
	      this.reset();
	    }
	  }, {
	    key: 'unbindWatchers',
	    value: function unbindWatchers() {
	      this.unbinders.map(function (unbinder) {
	        return unbinder();
	      });
	      this.unbinders = [];
	    }
	  }]);
	  return ActionGuideServ;
	}();
	
	ActionGuideServ.$inject = ['ActionGuide', 'AnalyticsServ', '$rootScope'];
	
	exports.default = _angular2.default.module('services.action-guide', [_actionGuide2.default, _analytics2.default]).service('ActionGuideServ', ActionGuideServ).name;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularResource = __webpack_require__(62);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CouponServ($resource) {
		return $resource('/coupon', {}, {
			'validate': {
				method: 'GET'
			}
		});
	}
	CouponServ.$inject = ['$resource'];
	
	exports.default = _angular2.default.module('services.coupon', [_angularResource2.default]).service('Coupon', CouponServ).name;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var moo = __webpack_require__(807);
	
	module.exports = moo.compile({
	    comparator: ['>', '<', 'before', 'after'],
	    year: /[1-2]\d{3}/,
	    month_name: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december', 'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
	    day_name: ['sun', 'mon', 'tues', 'wed', 'thurs', 'fri', 'sat'],
	    digit_2: /\d{1,2}/,
	    meridian: ['am', 'pm'],
	    ordinal: ['st', 'nd', 'rd', 'th'],
	    at: ['at', '@'],
	    wschar: { match: /\s/, lineBreaks: true },
	    range: ['-', 'to'],
	    x: ['.', '/'],
	    comma: [','],
	    st: [':']
	});

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(76);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zeroPad = function zeroPad(value, digits) {
	  return Math.pow(10, Math.max(0, digits - value.toString().length)).toString().substr(1) + value;
	};
	
	var getCentury = function getCentury(value) {
	  var shortYear = parseInt(value);
	  return shortYear < 50 ? 2000 + shortYear : 1900 + shortYear;
	};
	
	var getMonthByName = function getMonthByName(value) {
	  return ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december', 'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'].indexOf(value) % 12 + 1;
	};
	
	var getComparator = function getComparator(value) {
	  switch (value) {
	    case 'before':
	    case '<':
	      return -1;
	    case '>':
	    case 'after':
	      return 1;
	    default:
	      return value;
	  }
	};
	
	var format = function format(type, value) {
	  switch (type) {
	    case 'comparator':
	      return getComparator(value.toString());
	    case 'month_name':
	      return getMonthByName(value.toString());
	    case 'year':
	    case 'month':
	    case 'date':
	    case 'hour':
	    case 'minute':
	    case 'second':
	      return parseInt(value);
	    case 'year_short':
	      return getCentury(value);
	    default:
	      return value;
	  }
	};
	var formatType = function formatType(typeName) {
	  switch (typeName) {
	    case 'month_name':
	      return 'month';
	    case 'year_short':
	      return 'year';
	    default:
	      return typeName;
	  }
	};
	var formatByType = function formatByType(type, value) {
	  return function (value) {
	    return {
	      type: formatType(type),
	      value: format(type, value)
	    };
	  };
	};
	
	var nil = function nil() {
	  return null;
	};
	
	var join = function join(data) {
	  return data.map(function (d) {
	    return d ? d.value ? d.value : d : d;
	  });
	};
	
	var merge = function merge(data) {
	  var i = 0;
	  return data.reduce(function (dateObjs, token) {
	    if (Array.isArray(token)) {
	      (0, _assign2.default)(dateObjs[i], merge(token)[0]);
	    } else if (token && token.type === 'range') {
	      i = 1;
	      dateObjs[i] = dateObjs[i] || {};
	    } else if (token) {
	      dateObjs[i][token.type] = token.value;
	    }
	    return dateObjs;
	  }, [{}]);
	};
	var mergeDate = function mergeDate(data) {
	  var i = 0;
	  return data.reduce(function (dateObjs, token) {
	    if (Array.isArray(token)) {
	      (0, _assign2.default)(dateObjs[i], mergeDate(token)[0]);
	    } else if (token && token.type === 'range') {
	      i = 1;
	      var _dateObjs$ = dateObjs[0],
	          year = _dateObjs$.year,
	          month = _dateObjs$.month,
	          date = _dateObjs$.date;
	
	      dateObjs[i] = { year: year, month: month, date: date };
	    } else if (token) {
	      dateObjs[i][token.type] = token.value;
	    }
	    return dateObjs;
	  }, [{}]);
	};
	
	var log = function log(data) {
	  console.log(data);
	  return data;
	};
	
	module.exports = { zeroPad: zeroPad, format: format, formatByType: formatByType, merge: merge, mergeDate: mergeDate, join: join, log: log, nil: nil };

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExportServ = function () {
	    function ExportServ() {
	        (0, _classCallCheck3.default)(this, ExportServ);
	    }
	
	    (0, _createClass3.default)(ExportServ, [{
	        key: 'export',
	        value: function _export(report, name, isLandscape) {
	            $('<form/>', {
	                action: '/generate',
	                method: 'POST',
	                enctype: 'multipart/form-data'
	            }).append($('<input/>', {
	                name: 'report',
	                value: report
	            })).append($('<input/>', {
	                name: 'name',
	                value: name
	            })).append($('<input/>', {
	                name: 'isLandscape',
	                value: isLandscape
	            })).appendTo('body').submit().remove();
	        }
	    }]);
	    return ExportServ;
	}();
	
	exports.default = _angular2.default.module('services.export', []).service('ExportServ', ExportServ).name;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _extraction = __webpack_require__(459);
	
	var _extraction2 = _interopRequireDefault(_extraction);
	
	var _dateParser = __webpack_require__(324);
	
	var _dateParser2 = _interopRequireDefault(_dateParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExtractionServ = function () {
	  function ExtractionServ(ExtractionConst, DateParserServ) {
	    (0, _classCallCheck3.default)(this, ExtractionServ);
	
	    this.dateParserServ = DateParserServ;
	    this.matchers = ExtractionConst.matchers;
	    this.tests = ExtractionConst.tests;
	  }
	
	  (0, _createClass3.default)(ExtractionServ, [{
	    key: 'extract',
	    value: function extract(value) {
	      var extracted = {};
	      var factDateish = this.parseDate(value);
	      var title = this.parseTitle(value);
	      if (title) {
	        extracted.title = title;
	      }
	      if (factDateish) {
	        extracted.factDateish = factDateish;
	      }
	      return extracted;
	    }
	  }, {
	    key: 'parseDate',
	    value: function parseDate(value) {
	      var _this = this;
	
	      // step through recognized date formats, and compare fact content
	      // against RegExp constructed from `tests`. If a match is found,
	      // call appropriate date property setters defined in `postions`.
	      var date;
	      var test;
	      var match;
	      for (var i = this.tests.length - 1; i >= 0; i--) {
	        test = new RegExp(this.tests[i].map(function (k) {
	          return _this.matchers[k] ? _this.matchers[k] : k;
	        }).join(''), 'i');
	
	        match = test.exec(value);
	        if (match) {
	          date = this.dateParserServ.parse(match[0]);
	          if (this.dateParserServ.validate(date)) {
	            return date;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'parseTitle',
	    value: function parseTitle(value) {
	      var words;
	      var ignore = ['a', 'and', 'at', 'by', 'for', 'in', 'into', 'is', 'it', 'of', 'on', 'such', 'that', 'the', 'their', 'then', 'there', 'these', 'they', 'this', 'to', 'was', 'will'];
	      var keyWordCount = 0;
	      var titleWords = [];
	
	      // get the first 250 chars,
	      // filter out html entities, links, and punctuation (except quotes, question, dashes)
	      // and split string into an array by spaces, tabs, returns
	      words = value.substr(0, 250).replace(/&[^\s]+?;|(http(s?)|www).+?(?=\s)|[^\s\w\?"'‘’“”''""‹›«»\-‒–—―]/g, '').split(/\s/g).filter(function (el) {
	        return el.length !== 0;
	      });
	
	      // return a title with at least 4 key words once text is longer
	      for (var i = 0; i < words.length; i++) {
	        titleWords.push(words[i]);
	        if (ignore.indexOf(words[i]) === -1) {
	          keyWordCount++;
	        }
	        if (keyWordCount >= 4 && titleWords[titleWords.length - 1] !== words[words.length - 1]) {
	          return titleWords.join(' ');
	        }
	      }
	    }
	  }]);
	  return ExtractionServ;
	}();
	
	ExtractionServ.$inject = ['ExtractionConst', 'DateParserServ'];
	
	exports.default = _angular2.default.module('services.extraction', [_extraction2.default, _dateParser2.default]).service('ExtractionServ', ExtractionServ).name;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularResource = __webpack_require__(62);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PlansServ($q, $http) {
		function addFilter(filter) {
			var defaults = $http.defaults.transformResponse;
			defaults = _angular2.default.isArray(defaults) ? defaults : [defaults];
			return defaults.concat(filter);
		}
	
		var Plan = function () {
			function Plan(plan) {
				(0, _classCallCheck3.default)(this, Plan);
	
				_angular2.default.extend(this, plan);
			}
	
			(0, _createClass3.default)(Plan, [{
				key: 'getStorageStr',
				value: function getStorageStr() {
					return this.limits.storageGB > 0 ? (this.limits.storageGB / 1000).toFixed(0) + ' TB' : 'Unlimited';
				}
			}, {
				key: 'getContributorStr',
				value: function getContributorStr() {
					return this.limits.contributors > 0 ? this.limits.contributors : 'Unlimited';
				}
			}]);
			return Plan;
		}();
	
		function getAll() {
			return $http({
				url: '/plans',
				method: 'GET',
				isArray: true,
				transformResponse: addFilter(function (data) {
					return data.map(function (plan) {
						return new Plan(plan);
					});
				})
			});
		}
		return {
			getAll: getAll
		};
	}
	PlansServ.$inject = ['$q', '$http'];
	
	exports.default = _angular2.default.module('services.plans', [_angularResource2.default]).factory('Plans', PlansServ).name;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UploadServ = function () {
	  function UploadServ($http) {
	    (0, _classCallCheck3.default)(this, UploadServ);
	
	    this.http = $http;
	  }
	
	  (0, _createClass3.default)(UploadServ, [{
	    key: 'upload',
	    value: function upload(endpoint, files, listener) {
	      var data = new FormData();
	      data.append('format', 'file');
	      for (var i = 0; i < files.length; i++) {
	        data.append('file', files[i]);
	      }
	      return this.http.post(endpoint, data, {
	        transformRequest: _angular2.default.identity,
	        headers: { 'Content-Type': undefined },
	        uploadEventHandlers: {
	          progress: listener
	        }
	      });
	    }
	  }]);
	  return UploadServ;
	}();
	
	UploadServ.$inject = ['$http'];
	
	exports.default = _angular2.default.module('services.upload', []).service('UploadServ', UploadServ).name;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(799);
	
	__webpack_require__(570);
	
	__webpack_require__(577);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(578), __esModule: true };

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(579), __esModule: true };

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(580), __esModule: true };

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(581), __esModule: true };

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(76);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(573);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(572);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(607);
	module.exports = __webpack_require__(57).RegExp.escape;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(98);
	__webpack_require__(596);
	module.exports = __webpack_require__(9).Array.from;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(119);
	__webpack_require__(98);
	module.exports = __webpack_require__(594);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(119);
	__webpack_require__(98);
	module.exports = __webpack_require__(595);


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(167);
	__webpack_require__(98);
	__webpack_require__(119);
	__webpack_require__(597);
	__webpack_require__(600);
	__webpack_require__(599);
	__webpack_require__(598);
	module.exports = __webpack_require__(9).Map;


/***/ }),
/* 582 */
[913, 164],
/* 583 */
[915, 44, 78, 39, 81, 585],
/* 584 */
[916, 26, 165, 23],
/* 585 */
[917, 584],
/* 586 */
[919, 19, 79, 329, 44, 326, 164, 118, 166, 593, 17, 143, 330],
/* 587 */
[920, 240, 582],
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var $export = __webpack_require__(18);
	var meta = __webpack_require__(143);
	var fails = __webpack_require__(25);
	var hide = __webpack_require__(31);
	var redefineAll = __webpack_require__(329);
	var forOf = __webpack_require__(164);
	var anInstance = __webpack_require__(326);
	var isObject = __webpack_require__(26);
	var setToStringTag = __webpack_require__(80);
	var dP = __webpack_require__(19).f;
	var each = __webpack_require__(583)(0);
	var DESCRIPTORS = __webpack_require__(17);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 589 */
[921, 19, 45],
/* 590 */
[936, 23],
/* 591 */
[949, 18, 117, 44, 164],
/* 592 */
[950, 18],
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var core = __webpack_require__(9);
	var dP = __webpack_require__(19);
	var DESCRIPTORS = __webpack_require__(17);
	var SPECIES = __webpack_require__(23)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(32);
	var get = __webpack_require__(249);
	module.exports = __webpack_require__(9).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(240);
	var ITERATOR = __webpack_require__(23)('iterator');
	var Iterators = __webpack_require__(54);
	module.exports = __webpack_require__(9).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 596 */
[966, 44, 18, 39, 328, 327, 81, 589, 249, 590],
/* 597 */
[968, 586, 330, 588],
/* 598 */
[978, 591],
/* 599 */
[979, 592],
/* 600 */
[980, 18, 587],
/* 601 */
[916, 12, 172, 14],
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(11);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(8);
	var toPrimitive = __webpack_require__(61);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 604 */
[925, 104, 176, 151],
/* 605 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 606 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(2);
	var $re = __webpack_require__(605)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(332) });
	
	__webpack_require__(82)('copyWithin');


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $every = __webpack_require__(56)(4);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { fill: __webpack_require__(260) });
	
	__webpack_require__(82)('fill');


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $filter = __webpack_require__(56)(2);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(56)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(82)(KEY);


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(56)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(82)(KEY);


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $forEach = __webpack_require__(56)(0);
	var STRICT = __webpack_require__(52)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 615 */
[966, 51, 2, 28, 343, 268, 22, 262, 284, 174],
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $indexOf = __webpack_require__(168)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(52)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(172) });


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(48);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(150) != Object || !__webpack_require__(52)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(48);
	var toInteger = __webpack_require__(60);
	var toLength = __webpack_require__(22);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(52)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $map = __webpack_require__(56)(1);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var createProperty = __webpack_require__(262);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(334);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(334);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var html = __webpack_require__(266);
	var cof = __webpack_require__(50);
	var toAbsoluteIndex = __webpack_require__(108);
	var toLength = __webpack_require__(22);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(11)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $some = __webpack_require__(56)(3);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(35);
	var toObject = __webpack_require__(28);
	var fails = __webpack_require__(11);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(52)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(107)('Array');


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(2);
	var toISOString = __webpack_require__(602);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(28);
	var toPrimitive = __webpack_require__(61);
	
	$export($export.P + $export.F * __webpack_require__(11)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(14)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(41)(proto, TO_PRIMITIVE, __webpack_require__(603));


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(42)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Function', { bind: __webpack_require__(335) });


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(47);
	var HAS_INSTANCE = __webpack_require__(14)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(21).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(21).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(20) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(2);
	var log1p = __webpack_require__(346);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(2);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(2);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(2);
	var sign = __webpack_require__(272);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(2);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(2);
	var $expm1 = __webpack_require__(271);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { fround: __webpack_require__(345) });


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(2);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(2);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(346) });


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { sign: __webpack_require__(272) });


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(271);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(271);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(10);
	var has = __webpack_require__(40);
	var cof = __webpack_require__(50);
	var inheritIfRequired = __webpack_require__(267);
	var toPrimitive = __webpack_require__(61);
	var fails = __webpack_require__(11);
	var gOPN = __webpack_require__(103).f;
	var gOPD = __webpack_require__(46).f;
	var dP = __webpack_require__(21).f;
	var $trim = __webpack_require__(122).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(102)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(20) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(42)(global, NUMBER, $Number);
	}


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(2);
	var _isFinite = __webpack_require__(10).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(342) });


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(2);
	var isInteger = __webpack_require__(342);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(354);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(355);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toInteger = __webpack_require__(60);
	var aNumberValue = __webpack_require__(331);
	var repeat = __webpack_require__(279);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(11)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $fails = __webpack_require__(11);
	var aNumberValue = __webpack_require__(331);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 665 */
[969, 2, 348],
/* 666 */
[970, 2, 102],
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(20), 'Object', { defineProperties: __webpack_require__(349) });


/***/ }),
/* 668 */
[971, 2, 20, 21],
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(12);
	var meta = __webpack_require__(83).onFreeze;
	
	__webpack_require__(59)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 670 */
[972, 48, 46, 59],
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(59)('getOwnPropertyNames', function () {
	  return __webpack_require__(350).f;
	});


/***/ }),
/* 672 */
[973, 28, 47, 59],
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(12);
	
	__webpack_require__(59)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(12);
	
	__webpack_require__(59)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(12);
	
	__webpack_require__(59)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { is: __webpack_require__(606) });


/***/ }),
/* 677 */
[974, 28, 104, 59],
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(12);
	var meta = __webpack_require__(83).onFreeze;
	
	__webpack_require__(59)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(12);
	var meta = __webpack_require__(83).onFreeze;
	
	__webpack_require__(59)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 680 */
[975, 2, 275],
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(149);
	var test = {};
	test[__webpack_require__(14)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(42)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(354);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(355);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(101);
	var global = __webpack_require__(10);
	var ctx = __webpack_require__(51);
	var classof = __webpack_require__(149);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(12);
	var aFunction = __webpack_require__(35);
	var anInstance = __webpack_require__(99);
	var forOf = __webpack_require__(100);
	var speciesConstructor = __webpack_require__(180);
	var task = __webpack_require__(281).set;
	var microtask = __webpack_require__(273)();
	var newPromiseCapabilityModule = __webpack_require__(274);
	var perform = __webpack_require__(356);
	var promiseResolve = __webpack_require__(357);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(14)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  if (promise._h == 1) return false;
	  var chain = promise._a || promise._c;
	  var i = 0;
	  var reaction;
	  while (chain.length > i) {
	    reaction = chain[i++];
	    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
	  } return true;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(106)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(121)($Promise, PROMISE);
	__webpack_require__(107)(PROMISE);
	Wrapper = __webpack_require__(57)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(174)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(35);
	var anObject = __webpack_require__(8);
	var rApply = (__webpack_require__(10).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(11)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(2);
	var create = __webpack_require__(102);
	var aFunction = __webpack_require__(35);
	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(12);
	var fails = __webpack_require__(11);
	var bind = __webpack_require__(335);
	var rConstruct = (__webpack_require__(10).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(21);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(8);
	var toPrimitive = __webpack_require__(61);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(2);
	var gOPD = __webpack_require__(46).f;
	var anObject = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(8);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(269)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(46);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(2);
	var getProto = __webpack_require__(47);
	var anObject = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(46);
	var getPrototypeOf = __webpack_require__(47);
	var has = __webpack_require__(40);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(12);
	var anObject = __webpack_require__(8);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(8);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(353) });


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(8);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(2);
	var setProto = __webpack_require__(275);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(21);
	var gOPD = __webpack_require__(46);
	var getPrototypeOf = __webpack_require__(47);
	var has = __webpack_require__(40);
	var $export = __webpack_require__(2);
	var createDesc = __webpack_require__(105);
	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(12);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var inheritIfRequired = __webpack_require__(267);
	var dP = __webpack_require__(21).f;
	var gOPN = __webpack_require__(103).f;
	var isRegExp = __webpack_require__(173);
	var $flags = __webpack_require__(171);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(20) && (!CORRECT_NEW || __webpack_require__(11)(function () {
	  re2[__webpack_require__(14)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(42)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(107)('RegExp');


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(170)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(170)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(170)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(170)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(173);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(362);
	var anObject = __webpack_require__(8);
	var $flags = __webpack_require__(171);
	var DESCRIPTORS = __webpack_require__(20);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(42)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(11)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(43)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(43)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(43)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(43)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(277)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(22);
	var context = __webpack_require__(278);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(265)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(43)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(43)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(43)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toAbsoluteIndex = __webpack_require__(108);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(2);
	var context = __webpack_require__(278);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(265)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(43)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 717 */
[976, 277, 270],
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(43)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(48);
	var toLength = __webpack_require__(22);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(279)
	});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(43)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(22);
	var context = __webpack_require__(278);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(265)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(43)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(43)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(43)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(122)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 727 */
[977, 10, 40, 20, 2, 42, 83, 11, 179, 121, 109, 14, 360, 283, 604, 172, 8, 48, 61, 105, 102, 350, 46, 21, 104, 103, 151, 176, 101, 41],
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $typed = __webpack_require__(181);
	var buffer = __webpack_require__(282);
	var anObject = __webpack_require__(8);
	var toAbsoluteIndex = __webpack_require__(108);
	var toLength = __webpack_require__(22);
	var isObject = __webpack_require__(12);
	var ArrayBuffer = __webpack_require__(10).ArrayBuffer;
	var speciesConstructor = __webpack_require__(180);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(11)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(107)(ARRAY_BUFFER);


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	$export($export.G + $export.W + $export.F * !__webpack_require__(181).ABV, {
	  DataView: __webpack_require__(282).DataView
	});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(338);
	var validate = __webpack_require__(123);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(169)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(339);
	var toObject = __webpack_require__(28);
	var toLength = __webpack_require__(22);
	var aFunction = __webpack_require__(35);
	var arraySpeciesCreate = __webpack_require__(261);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(82)('flatMap');


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(339);
	var toObject = __webpack_require__(28);
	var toLength = __webpack_require__(22);
	var toInteger = __webpack_require__(60);
	var arraySpeciesCreate = __webpack_require__(261);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(82)('flatten');


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(2);
	var $includes = __webpack_require__(168)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(82)('includes');


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(2);
	var microtask = __webpack_require__(273)();
	var process = __webpack_require__(10).process;
	var isNode = __webpack_require__(50)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(2);
	var cof = __webpack_require__(50);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.G, { global: __webpack_require__(10) });


/***/ }),
/* 746 */
[978, 177],
/* 747 */
[979, 178],
/* 748 */
[980, 2, 337],
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var scale = __webpack_require__(347);
	var fround = __webpack_require__(345);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { scale: __webpack_require__(347) });


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(28);
	var aFunction = __webpack_require__(35);
	var $defineProperty = __webpack_require__(21);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(20) && $export($export.P + __webpack_require__(175), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(28);
	var aFunction = __webpack_require__(35);
	var $defineProperty = __webpack_require__(21);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(20) && $export($export.P + __webpack_require__(175), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $entries = __webpack_require__(352)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(2);
	var ownKeys = __webpack_require__(353);
	var toIObject = __webpack_require__(48);
	var gOPD = __webpack_require__(46);
	var createProperty = __webpack_require__(262);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(28);
	var toPrimitive = __webpack_require__(61);
	var getPrototypeOf = __webpack_require__(47);
	var getOwnPropertyDescriptor = __webpack_require__(46).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(20) && $export($export.P + __webpack_require__(175), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(28);
	var toPrimitive = __webpack_require__(61);
	var getPrototypeOf = __webpack_require__(47);
	var getOwnPropertyDescriptor = __webpack_require__(46).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(20) && $export($export.P + __webpack_require__(175), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $values = __webpack_require__(352)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(2);
	var global = __webpack_require__(10);
	var core = __webpack_require__(57);
	var microtask = __webpack_require__(273)();
	var OBSERVABLE = __webpack_require__(14)('observable');
	var aFunction = __webpack_require__(35);
	var anObject = __webpack_require__(8);
	var anInstance = __webpack_require__(99);
	var redefineAll = __webpack_require__(106);
	var hide = __webpack_require__(41);
	var forOf = __webpack_require__(100);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(107)('Observable');


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(2);
	var core = __webpack_require__(57);
	var global = __webpack_require__(10);
	var speciesConstructor = __webpack_require__(180);
	var promiseResolve = __webpack_require__(357);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(2);
	var newPromiseCapability = __webpack_require__(274);
	var perform = __webpack_require__(356);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(8);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(8);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(363);
	var from = __webpack_require__(333);
	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(8);
	var getPrototypeOf = __webpack_require__(47);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(8);
	var getPrototypeOf = __webpack_require__(47);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(8);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(8);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(8);
	var getPrototypeOf = __webpack_require__(47);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(8);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(71);
	var anObject = __webpack_require__(8);
	var aFunction = __webpack_require__(35);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(177)('Set');


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(178)('Set');


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(337)('Set') });


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(277)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(2);
	var defined = __webpack_require__(58);
	var toLength = __webpack_require__(22);
	var isRegExp = __webpack_require__(173);
	var getFlags = __webpack_require__(171);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(269)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(358);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(358);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(122)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(122)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 789 */
[981, 283],
/* 790 */
[982, 283],
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.S, 'System', { global: __webpack_require__(10) });


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(177)('WeakMap');


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(178)('WeakMap');


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(177)('WeakSet');


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(178)('WeakSet');


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(285);
	var getKeys = __webpack_require__(104);
	var redefine = __webpack_require__(42);
	var global = __webpack_require__(10);
	var hide = __webpack_require__(41);
	var Iterators = __webpack_require__(120);
	var wks = __webpack_require__(14);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $task = __webpack_require__(281);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(10);
	var $export = __webpack_require__(2);
	var navigator = global.navigator;
	var slice = [].slice;
	var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(727);
	__webpack_require__(666);
	__webpack_require__(668);
	__webpack_require__(667);
	__webpack_require__(670);
	__webpack_require__(672);
	__webpack_require__(677);
	__webpack_require__(671);
	__webpack_require__(669);
	__webpack_require__(679);
	__webpack_require__(678);
	__webpack_require__(674);
	__webpack_require__(675);
	__webpack_require__(673);
	__webpack_require__(665);
	__webpack_require__(676);
	__webpack_require__(680);
	__webpack_require__(681);
	__webpack_require__(633);
	__webpack_require__(635);
	__webpack_require__(634);
	__webpack_require__(683);
	__webpack_require__(682);
	__webpack_require__(653);
	__webpack_require__(663);
	__webpack_require__(664);
	__webpack_require__(654);
	__webpack_require__(655);
	__webpack_require__(656);
	__webpack_require__(657);
	__webpack_require__(658);
	__webpack_require__(659);
	__webpack_require__(660);
	__webpack_require__(661);
	__webpack_require__(662);
	__webpack_require__(636);
	__webpack_require__(637);
	__webpack_require__(638);
	__webpack_require__(639);
	__webpack_require__(640);
	__webpack_require__(641);
	__webpack_require__(642);
	__webpack_require__(643);
	__webpack_require__(644);
	__webpack_require__(645);
	__webpack_require__(646);
	__webpack_require__(647);
	__webpack_require__(648);
	__webpack_require__(649);
	__webpack_require__(650);
	__webpack_require__(651);
	__webpack_require__(652);
	__webpack_require__(714);
	__webpack_require__(719);
	__webpack_require__(726);
	__webpack_require__(717);
	__webpack_require__(709);
	__webpack_require__(710);
	__webpack_require__(715);
	__webpack_require__(720);
	__webpack_require__(722);
	__webpack_require__(705);
	__webpack_require__(706);
	__webpack_require__(707);
	__webpack_require__(708);
	__webpack_require__(711);
	__webpack_require__(712);
	__webpack_require__(713);
	__webpack_require__(716);
	__webpack_require__(718);
	__webpack_require__(721);
	__webpack_require__(723);
	__webpack_require__(724);
	__webpack_require__(725);
	__webpack_require__(628);
	__webpack_require__(630);
	__webpack_require__(629);
	__webpack_require__(632);
	__webpack_require__(631);
	__webpack_require__(617);
	__webpack_require__(615);
	__webpack_require__(621);
	__webpack_require__(618);
	__webpack_require__(624);
	__webpack_require__(626);
	__webpack_require__(614);
	__webpack_require__(620);
	__webpack_require__(611);
	__webpack_require__(625);
	__webpack_require__(609);
	__webpack_require__(623);
	__webpack_require__(622);
	__webpack_require__(616);
	__webpack_require__(619);
	__webpack_require__(608);
	__webpack_require__(610);
	__webpack_require__(613);
	__webpack_require__(612);
	__webpack_require__(627);
	__webpack_require__(285);
	__webpack_require__(699);
	__webpack_require__(704);
	__webpack_require__(362);
	__webpack_require__(700);
	__webpack_require__(701);
	__webpack_require__(702);
	__webpack_require__(703);
	__webpack_require__(684);
	__webpack_require__(361);
	__webpack_require__(363);
	__webpack_require__(364);
	__webpack_require__(739);
	__webpack_require__(728);
	__webpack_require__(729);
	__webpack_require__(734);
	__webpack_require__(737);
	__webpack_require__(738);
	__webpack_require__(732);
	__webpack_require__(735);
	__webpack_require__(733);
	__webpack_require__(736);
	__webpack_require__(730);
	__webpack_require__(731);
	__webpack_require__(685);
	__webpack_require__(686);
	__webpack_require__(687);
	__webpack_require__(688);
	__webpack_require__(689);
	__webpack_require__(692);
	__webpack_require__(690);
	__webpack_require__(691);
	__webpack_require__(693);
	__webpack_require__(694);
	__webpack_require__(695);
	__webpack_require__(696);
	__webpack_require__(698);
	__webpack_require__(697);
	__webpack_require__(742);
	__webpack_require__(740);
	__webpack_require__(741);
	__webpack_require__(783);
	__webpack_require__(786);
	__webpack_require__(785);
	__webpack_require__(787);
	__webpack_require__(788);
	__webpack_require__(784);
	__webpack_require__(789);
	__webpack_require__(790);
	__webpack_require__(764);
	__webpack_require__(767);
	__webpack_require__(763);
	__webpack_require__(761);
	__webpack_require__(762);
	__webpack_require__(765);
	__webpack_require__(766);
	__webpack_require__(748);
	__webpack_require__(782);
	__webpack_require__(747);
	__webpack_require__(781);
	__webpack_require__(793);
	__webpack_require__(795);
	__webpack_require__(746);
	__webpack_require__(780);
	__webpack_require__(792);
	__webpack_require__(794);
	__webpack_require__(745);
	__webpack_require__(791);
	__webpack_require__(744);
	__webpack_require__(749);
	__webpack_require__(750);
	__webpack_require__(751);
	__webpack_require__(752);
	__webpack_require__(753);
	__webpack_require__(755);
	__webpack_require__(754);
	__webpack_require__(756);
	__webpack_require__(757);
	__webpack_require__(758);
	__webpack_require__(760);
	__webpack_require__(759);
	__webpack_require__(769);
	__webpack_require__(770);
	__webpack_require__(771);
	__webpack_require__(772);
	__webpack_require__(774);
	__webpack_require__(773);
	__webpack_require__(776);
	__webpack_require__(775);
	__webpack_require__(777);
	__webpack_require__(778);
	__webpack_require__(779);
	__webpack_require__(743);
	__webpack_require__(768);
	__webpack_require__(798);
	__webpack_require__(797);
	__webpack_require__(796);
	module.exports = __webpack_require__(57);


/***/ }),
/* 800 */,
/* 801 */
182,
/* 802 */
182,
/* 803 */,
/* 804 */
182,
/* 805 */
182,
/* 806 */,
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) /* global define */
	  } else if (typeof module === 'object' && module.exports) {
	    module.exports = factory()
	  } else {
	    root.moo = factory()
	  }
	}(this, function() {
	  'use strict';
	
	  var hasOwnProperty = Object.prototype.hasOwnProperty
	  var assign = typeof Object.assign === 'function' ? Object.assign :
	    // https://tc39.github.io/ecma262/#sec-object.assign
	    function(target, sources) {
	      if (target == null) {
	        throw new TypeError('Target cannot be null or undefined');
	      }
	      target = Object(target)
	
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i]
	        if (source == null) continue
	
	        for (var key in source) {
	          if (hasOwnProperty.call(source, key)) {
	            target[key] = source[key]
	          }
	        }
	      }
	      return target
	    }
	
	  var hasSticky = typeof new RegExp().sticky === 'boolean'
	
	  function isRegExp(o) { return o && o.constructor === RegExp }
	
	
	  function reEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
	  }
	  function reGroups(s) {
	    var re = new RegExp('|' + s)
	    return re.exec('').length - 1
	  }
	  function reCapture(s) {
	    return '(' + s + ')'
	  }
	  function reUnion(regexps) {
	    var source =  regexps.map(function(s) {
	      return "(?:" + s + ")"
	    }).join('|')
	    return "(?:" + source + ")"
	  }
	
	
	  function compareLength(a, b) {
	    return b.length - a.length
	  }
	
	  function regexpOrLiteral(obj) {
	    if (typeof obj === 'string') {
	      return '(?:' + reEscape(obj) + ')'
	
	    } else if (isRegExp(obj)) {
	      // TODO: consider /u support
	      if (obj.ignoreCase) { throw new Error('RegExp /i flag not allowed') }
	      if (obj.global) { throw new Error('RegExp /g flag is implied') }
	      if (obj.sticky) { throw new Error('RegExp /y flag is implied') }
	      if (obj.multiline) { throw new Error('RegExp /m flag is implied') }
	      return obj.source
	
	    } else {
	      throw new Error('not a pattern: ' + obj)
	    }
	  }
	
	  function objectToRules(object) {
	    var keys = Object.getOwnPropertyNames(object)
	    var result = []
	    for (var i=0; i<keys.length; i++) {
	      var key = keys[i]
	      result.push(ruleOptions(key, object[key]))
	    }
	    return result
	  }
	
	  function arrayToRules(array) {
	    var result = []
	    for (var i=0; i<array.length; i++) {
	      var obj = array[i]
	      if (!obj.name) {
	        throw new Error('Rule has no name: ' + JSON.stringify(obj))
	      }
	      result.push(ruleOptions(obj.name, obj))
	    }
	    return result
	  }
	
	  function ruleOptions(name, obj) {
	    if (typeof obj !== 'object' || Array.isArray(obj) || isRegExp(obj)) {
	      obj = { match: obj }
	    }
	
	    // nb. error implies lineBreaks
	    var options = assign({
	      tokenType: name,
	      lineBreaks: !!obj.error,
	      pop: false,
	      next: null,
	      push: null,
	      error: false,
	    }, obj)
	    options.keywords = null
	
	    // convert to array
	    var match = options.match
	    options.match = Array.isArray(match) ? match : match ? [match] : []
	    return options
	  }
	
	  function sortRules(rules) {
	    var result = []
	    for (var i=0; i<rules.length; i++) {
	      var options = rules[i]
	      var match = options.match
	
	      // sort literals by length to ensure longest match
	      var capturingPatterns = []
	      var patterns = []
	      var literals = []
	      for (var j=0; j<match.length; j++) {
	        var obj = match[j]
	        if (!isRegExp(obj)) literals.push(obj)
	        else if (reGroups(obj.source) > 0) capturingPatterns.push(obj)
	        else patterns.push(obj)
	      }
	      literals.sort(compareLength)
	
	      // append regexps to the end
	      options.match = literals.concat(patterns)
	      result.push(options)
	
	      // add each capturing regexp as a separate rule
	      for (var j=0; j<capturingPatterns.length; j++) {
	        result.push(assign({}, options, {
	          match: [capturingPatterns[j]],
	        }))
	      }
	    }
	    return result
	  }
	
	  function getIdentifier(literal, otherRules) {
	    for (var i=0; i<otherRules.length; i++) {
	      var rule = otherRules[i]
	      var match = rule.match
	      for (var j=0; j<match.length; j++) {
	        var pat = match[j]
	        if (!isRegExp(pat)) { continue }
	        var m = pat.exec(literal)
	        if (m && m[0] === literal) {
	          return rule
	        }
	      }
	    }
	  }
	
	  function compileRules(rules, hasStates) {
	    rules = Array.isArray(rules) ? arrayToRules(rules) : objectToRules(rules)
	
	    rules = sortRules(rules)
	
	    var errorRule = null
	    var groups = []
	    var parts = []
	    for (var i=0; i<rules.length; i++) {
	      var options = rules[i]
	
	      if (options.error) {
	        if (errorRule) {
	          throw new Error("Multiple error rules not allowed: (for token '" + options.tokenType + "')")
	        }
	        errorRule = options
	      }
	
	      // look for keywords
	      var match = options.match
	      var notKeywords = []
	      for (var j=0; j<match.length; j++) {
	        var word = match[j]
	        if (typeof word === 'string') {
	          // does it match an existing rule (e.g. identifier?)
	          var other = getIdentifier(word, rules)
	          if (other) {
	            if (!other.keywords) {
	              other.keywords = Object.create(null)
	            }
	            other.keywords[word] = options
	            continue
	          }
	        }
	        notKeywords.push(word)
	      }
	      options.match = notKeywords
	
	      // skip rules with no match
	      if (options.match.length === 0) {
	        continue
	      }
	      groups.push(options)
	
	      // convert to RegExp
	      var pat = reUnion(options.match.map(regexpOrLiteral))
	
	      // validate
	      var regexp = new RegExp(pat)
	      if (regexp.test("")) {
	        throw new Error("RegExp matches empty string: " + regexp)
	      }
	      var groupCount = reGroups(pat)
	      if (groupCount > 1) {
	        throw new Error("RegExp has more than one capture group: " + regexp)
	      }
	      if (!hasStates && (options.pop || options.push || options.next)) {
	        throw new Error("State-switching options are not allowed in stateless lexers (for token '" + options.tokenType + "')")
	      }
	
	      // try and detect rules matching newlines
	      if (!options.lineBreaks && regexp.test('\n')) {
	        throw new Error('Rule should declare lineBreaks: ' + regexp)
	      }
	
	      // store regex
	      var isCapture = !!groupCount
	      if (!isCapture) pat = reCapture(pat)
	      parts.push(pat)
	    }
	
	    var suffix = hasSticky ? '' : '|(?:)'
	    var flags = hasSticky ? 'ym' : 'gm'
	    var regexp = new RegExp(reUnion(parts) + suffix, flags)
	
	    return {regexp: regexp, groups: groups, error: errorRule}
	  }
	
	  function compile(rules) {
	    var result = compileRules(rules)
	    return new Lexer({start: result}, 'start')
	  }
	
	  function compileStates(states, start) {
	    var keys = Object.getOwnPropertyNames(states)
	    if (!start) start = keys[0]
	
	    var map = Object.create(null)
	    for (var i=0; i<keys.length; i++) {
	      var key = keys[i]
	      map[key] = compileRules(states[key], true)
	    }
	
	    for (var i=0; i<keys.length; i++) {
	      var groups = map[keys[i]].groups
	      for (var j=0; j<groups.length; j++) {
	        var g = groups[i]
	        var state = g && (g.push || g.next)
	        if (state && !map[state]) {
	          throw new Error("Missing state '" + state + "' (in token '" + g.tokenType + "' of state '" + keys[i] + "')")
	        }
	      }
	    }
	
	    return new Lexer(map, start)
	  }
	
	
	  var Lexer = function(states, state) {
	    this.startState = state
	    this.states = states
	    this.buffer = ''
	    this.stack = []
	    this.reset()
	  }
	
	  Lexer.prototype.setState = function(state) {
	    if (!state || this.state === state) return
	    this.state = state
	    var info = this.states[state]
	    this.groups = info.groups
	    this.error = info.error
	    this.re = info.regexp
	  }
	
	  Lexer.prototype.popState = function() {
	    this.setState(this.stack.pop())
	  }
	
	  Lexer.prototype.pushState = function(state) {
	    this.stack.push(this.state)
	    this.setState(state)
	  }
	
	  Lexer.prototype.eat = hasSticky ? function(re) { // assume re is /y
	    return re.exec(this.buffer)
	  } : function(re) { // assume re is /g
	    var match = re.exec(this.buffer)
	    // will always match, since we used the |(?:) trick
	    if (match[0].length === 0) {
	      return null
	    }
	    return match
	  }
	
	  function tokenToString() {
	    return this.value || this.type
	  }
	
	  Lexer.prototype.next = function() {
	    var re = this.re
	    var buffer = this.buffer
	
	    var index = re.lastIndex = this.index
	    if (index === buffer.length) {
	      return // EOF
	    }
	
	    var match = this.eat(re)
	    var group, value, text
	    if (match === null) {
	      group = this.error
	
	      // consume rest of buffer
	      text = value = buffer.slice(index)
	
	    } else {
	      text = match[0]
	      var groups = this.groups
	      for (var i = 0; i < groups.length; i++) {
	        value = match[i + 1]
	        if (value !== undefined) {
	          group = groups[i]
	          // TODO is `buffer` being leaked here?
	          break
	        }
	      }
	      // assert(i < groupCount)
	
	      // check for keywords
	      if (group.keywords) {
	        group = group.keywords[text] || group
	      }
	    }
	
	    // count line breaks
	    var lineBreaks = 0
	    if (!group || group.lineBreaks) {
	      var matchNL = /\n/g
	      var nl = 1
	      if (text === '\n') {
	        lineBreaks = 1
	      } else {
	        while (matchNL.exec(text)) { lineBreaks++; nl = matchNL.lastIndex }
	      }
	    }
	
	    var size = text.length
	    var token = {
	      type: group && group.tokenType,
	      value: value,
	      toString: tokenToString,
	      offset: index,
	      size: size,
	      lineBreaks: lineBreaks,
	      line: this.line,
	      col: this.col,
	    }
	
	    this.index += size
	    this.line += lineBreaks
	    if (lineBreaks !== 0) {
	      this.col = size - nl + 1
	    } else {
	      this.col += size
	    }
	    // throw, if no rule with {error: true}
	    if (!group) {
	      throw new Error(this.formatError(token, "invalid syntax"))
	    }
	
	    if (group.pop) this.popState()
	    else if (group.push) this.pushState(group.push)
	    else if (group.next) this.setState(group.next)
	    return token
	  }
	
	  if (typeof Symbol !== 'undefined' && Symbol.iterator) {
	    var LexerIterator = function(lexer) {
	      this.lexer = lexer
	    }
	
	    LexerIterator.prototype.next = function() {
	      var token = this.lexer.next()
	      return {value: token, done: !token}
	    }
	
	    Lexer.prototype[Symbol.iterator] = function() {
	      return new LexerIterator(this)
	    }
	  }
	
	  Lexer.prototype.formatError = function(token, message) {
	    var value = token.value
	    var index = token.offset
	    var eol = token.lineBreaks ? value.indexOf('\n') : value.length
	    var start = Math.max(0, index - token.col + 1)
	    var firstLine = this.buffer.substring(start, index + eol)
	    message += " at line " + token.line + " col " + token.col + ":\n\n"
	    message += "  " + firstLine + "\n"
	    message += "  " + Array(token.col).join(" ") + "^"
	    return message
	  }
	
	  Lexer.prototype.reset = function(data, info) {
	    this.buffer = data || ''
	    this.index = 0
	    this.line = info ? info.line : 1
	    this.col = info ? info.col : 1
	    this.setState(info ? info.state : this.startState)
	    return this
	  }
	
	  Lexer.prototype.save = function() {
	    return {
	      line: this.line,
	      col: this.col,
	      state: this.state,
	    }
	  }
	
	  Lexer.prototype.clone = function() {
	    return new Lexer(this.states, this.state)
	  }
	
	  Lexer.prototype.has = function(tokenType) {
	    for (var s in this.states) {
	      var groups = this.states[s].groups
	      for (var i=0; i<groups.length; i++) {
	        var group = groups[i]
	        if (group.tokenType === tokenType) return true
	        if (group.keywords) {
	          for (var k in group.keywords) {
	            if (group.keywords[k].tokenType === tokenType) return true
	          }
	        }
	      }
	    }
	    return false
	  }
	
	
	  return {
	    compile: compile,
	    states: compileStates,
	    error: Object.freeze({error: true}),
	  }
	
	}))


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated automatically by nearley
	// http://github.com/Hardmath123/nearley
	(function () {
	function id(x) {return x[0]; }
	
	var lexer = __webpack_require__(563);
	var utils = __webpack_require__(564);
	var grammar = {
	    Lexer: lexer,
	    ParserRules: [
	    {"name": "main", "symbols": ["comparator", "_", "datetime"], "postprocess": utils.merge},
	    {"name": "main$ebnf$1", "symbols": ["_"], "postprocess": id},
	    {"name": "main$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
	    {"name": "main$ebnf$2", "symbols": ["_"], "postprocess": id},
	    {"name": "main$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
	    {"name": "main", "symbols": ["datetime", "main$ebnf$1", (lexer.has("range") ? {type: "range"} : range), "main$ebnf$2", "datetime"], "postprocess": utils.merge},
	    {"name": "main$ebnf$3", "symbols": ["_"], "postprocess": id},
	    {"name": "main$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
	    {"name": "main$ebnf$4", "symbols": ["_"], "postprocess": id},
	    {"name": "main$ebnf$4", "symbols": [], "postprocess": function(d) {return null;}},
	    {"name": "main", "symbols": ["datetime", "main$ebnf$3", (lexer.has("range") ? {type: "range"} : range), "main$ebnf$4", "time"], "postprocess": utils.mergeDate},
	    {"name": "main", "symbols": ["datetime"], "postprocess": utils.merge},
	    {"name": "datetime", "symbols": ["date_exp"]},
	    {"name": "datetime$ebnf$1", "symbols": ["_"], "postprocess": id},
	    {"name": "datetime$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
	    {"name": "datetime$ebnf$2", "symbols": ["at"], "postprocess": id},
	    {"name": "datetime$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
	    {"name": "datetime", "symbols": ["date_exp", "datetime$ebnf$1", "datetime$ebnf$2", "_", "time"]},
	    {"name": "date_exp", "symbols": ["year"]},
	    {"name": "date_exp", "symbols": ["month_name", "_", "year"]},
	    {"name": "date_exp$ebnf$1", "symbols": ["day"], "postprocess": id},
	    {"name": "date_exp$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
	    {"name": "date_exp$ebnf$2", "symbols": ["ordinal"], "postprocess": id},
	    {"name": "date_exp$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
	    {"name": "date_exp$ebnf$3", "symbols": ["comma"], "postprocess": id},
	    {"name": "date_exp$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
	    {"name": "date_exp", "symbols": ["date_exp$ebnf$1", "month_name", "_", "date", "date_exp$ebnf$2", "date_exp$ebnf$3", "_", "year"]},
	    {"name": "date_exp", "symbols": ["month", "x", "date", "x", "year"]},
	    {"name": "date_exp", "symbols": ["month", "x", "date", "x", "year_short"]},
	    {"name": "date_exp", "symbols": ["month", "x", "year"]},
	    {"name": "date_exp", "symbols": ["month", "x", "year_short"]},
	    {"name": "time", "symbols": ["hour", "s", "meridian"]},
	    {"name": "time", "symbols": ["hour", "st", "minute", "s", "meridian"]},
	    {"name": "time", "symbols": ["hour", "st", "minute", "st", "second", "s", "meridian"]},
	    {"name": "day", "symbols": ["day_name", "_"]},
	    {"name": "comparator", "symbols": [(lexer.has("comparator") ? {type: "comparator"} : comparator)], "postprocess": utils.formatByType('comparator')},
	    {"name": "year", "symbols": [(lexer.has("year") ? {type: "year"} : year)], "postprocess": utils.formatByType('year')},
	    {"name": "year_short", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('year_short')},
	    {"name": "month", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('month')},
	    {"name": "month_name", "symbols": [(lexer.has("month_name") ? {type: "month_name"} : month_name)], "postprocess": utils.formatByType('month_name')},
	    {"name": "date", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('date')},
	    {"name": "day_name", "symbols": [(lexer.has("day_name") ? {type: "day_name"} : day_name)], "postprocess": utils.nil},
	    {"name": "ordinal", "symbols": [(lexer.has("ordinal") ? {type: "ordinal"} : ordinal)], "postprocess": utils.nil},
	    {"name": "hour", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('hour')},
	    {"name": "minute", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('minute')},
	    {"name": "second", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('second')},
	    {"name": "meridian$ebnf$1", "symbols": []},
	    {"name": "meridian$ebnf$1", "symbols": ["meridian$ebnf$1", (lexer.has("meridian") ? {type: "meridian"} : meridian)], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
	    {"name": "meridian", "symbols": ["meridian$ebnf$1"], "postprocess": id},
	    {"name": "comma", "symbols": [(lexer.has("comma") ? {type: "comma"} : comma)], "postprocess": utils.nil},
	    {"name": "at", "symbols": [(lexer.has("at") ? {type: "at"} : at)], "postprocess": utils.nil},
	    {"name": "sw", "symbols": [{"literal":" "}], "postprocess": utils.nil},
	    {"name": "x", "symbols": [(lexer.has("x") ? {type: "x"} : x)], "postprocess": utils.nil},
	    {"name": "s$ebnf$1", "symbols": []},
	    {"name": "s$ebnf$1", "symbols": ["s$ebnf$1", {"literal":" "}], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
	    {"name": "s", "symbols": ["s$ebnf$1"], "postprocess": utils.nil},
	    {"name": "_", "symbols": [(lexer.has("wschar") ? {type: "wschar"} : wschar)], "postprocess": utils.nil},
	    {"name": "st", "symbols": [(lexer.has("st") ? {type: "st"} : st)], "postprocess": utils.nil}
	]
	  , ParserStart: "main"
	}
	if (typeof module !== 'undefined'&& typeof module.exports !== 'undefined') {
	   module.exports = grammar;
	} else {
	   window.Grammar = grammar;
	}
	})();


/***/ }),
/* 809 */
/***/ (function(module, exports) {

	(function(root, factory) {
	    if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        root.nearley = factory();
	    }
	}(this, function() {
	
	function Rule(name, symbols, postprocess) {
	    this.id = ++Rule.highestId;
	    this.name = name;
	    this.symbols = symbols;        // a list of literal | regex class | nonterminal
	    this.postprocess = postprocess;
	    return this;
	}
	Rule.highestId = 0;
	
	Rule.prototype.toString = function(withCursorAt) {
	    function stringifySymbolSequence (e) {
	        return e.literal ? JSON.stringify(e.literal) :
	               e.type ? '%' + e.type : e.toString();
	    }
	    var symbolSequence = (typeof withCursorAt === "undefined")
	                         ? this.symbols.map(stringifySymbolSequence).join(' ')
	                         : (   this.symbols.slice(0, withCursorAt).map(stringifySymbolSequence).join(' ')
	                             + " ● "
	                             + this.symbols.slice(withCursorAt).map(stringifySymbolSequence).join(' ')     );
	    return this.name + " → " + symbolSequence;
	}
	
	
	// a State is a rule at a position from a given starting point in the input stream (reference)
	function State(rule, dot, reference, wantedBy) {
	    this.rule = rule;
	    this.dot = dot;
	    this.reference = reference;
	    this.data = [];
	    this.wantedBy = wantedBy;
	    this.isComplete = this.dot === rule.symbols.length;
	}
	
	State.prototype.toString = function() {
	    return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
	};
	
	State.prototype.nextState = function(child) {
	    var state = new State(this.rule, this.dot + 1, this.reference, this.wantedBy);
	    state.left = this;
	    state.right = child;
	    if (state.isComplete) {
	        state.data = state.build();
	    }
	    return state;
	};
	
	State.prototype.build = function() {
	    var children = [];
	    var node = this;
	    do {
	        children.push(node.right.data);
	        node = node.left;
	    } while (node.left);
	    children.reverse();
	    return children;
	};
	
	State.prototype.finish = function() {
	    if (this.rule.postprocess) {
	        this.data = this.rule.postprocess(this.data, this.reference, Parser.fail);
	    }
	};
	
	
	function Column(grammar, index) {
	    this.grammar = grammar;
	    this.index = index;
	    this.states = [];
	    this.wants = {}; // states indexed by the non-terminal they expect
	    this.scannable = []; // list of states that expect a token
	    this.completed = {}; // states that are nullable
	}
	
	
	Column.prototype.process = function(nextColumn) {
	    var states = this.states;
	    var wants = this.wants;
	    var completed = this.completed;
	
	    for (var w = 0; w < states.length; w++) { // nb. we push() during iteration
	        var state = states[w];
	
	        if (state.isComplete) {
	            state.finish();
	            if (state.data !== Parser.fail) {
	                // complete
	                var wantedBy = state.wantedBy;
	                for (var i = wantedBy.length; i--; ) { // this line is hot
	                    var left = wantedBy[i];
	                    this.complete(left, state);
	                }
	
	                // special-case nullables
	                if (state.reference === this.index) {
	                    // make sure future predictors of this rule get completed.
	                    var exp = state.rule.name;
	                    (this.completed[exp] = this.completed[exp] || []).push(state);
	                }
	            }
	
	        } else {
	            // queue scannable states
	            var exp = state.rule.symbols[state.dot];
	            if (typeof exp !== 'string') {
	                this.scannable.push(state);
	                continue;
	            }
	
	            // predict
	            if (wants[exp]) {
	                wants[exp].push(state);
	
	                if (completed.hasOwnProperty(exp)) {
	                    var nulls = completed[exp];
	                    for (var i = 0; i < nulls.length; i++) {
	                        var right = nulls[i];
	                        this.complete(state, right);
	                    }
	                }
	            } else {
	                wants[exp] = [state];
	                this.predict(exp);
	            }
	        }
	    }
	}
	
	Column.prototype.predict = function(exp) {
	    var rules = this.grammar.byName[exp] || [];
	
	    for (var i = 0; i < rules.length; i++) {
	        var r = rules[i];
	        var wantedBy = this.wants[exp];
	        var s = new State(r, 0, this.index, wantedBy);
	        this.states.push(s);
	    }
	}
	
	Column.prototype.complete = function(left, right) {
	    var inp = right.rule.name;
	    if (left.rule.symbols[left.dot] === inp) {
	        var copy = left.nextState(right);
	        this.states.push(copy);
	    }
	}
	
	
	function Grammar(rules, start) {
	    this.rules = rules;
	    this.start = start || this.rules[0].name;
	    var byName = this.byName = {};
	    this.rules.forEach(function(rule) {
	        if (!byName.hasOwnProperty(rule.name)) {
	            byName[rule.name] = [];
	        }
	        byName[rule.name].push(rule);
	    });
	}
	
	// So we can allow passing (rules, start) directly to Parser for backwards compatibility
	Grammar.fromCompiled = function(rules, start) {
	    var lexer = rules.Lexer;
	    if (rules.ParserStart) {
	      start = rules.ParserStart;
	      rules = rules.ParserRules;
	    }
	    var rules = rules.map(function (r) { return (new Rule(r.name, r.symbols, r.postprocess)); });
	    var g = new Grammar(rules, start);
	    g.lexer = lexer; // nb. storing lexer on Grammar is iffy, but unavoidable
	    return g;
	}
	
	
	function StreamLexer() {
	  this.reset("");
	}
	
	StreamLexer.prototype.reset = function(data, state) {
	    this.buffer = data;
	    this.index = 0;
	    this.line = state ? state.line : 1;
	    this.lastLineBreak = state ? -state.col : 0;
	}
	
	StreamLexer.prototype.next = function() {
	    if (this.index < this.buffer.length) {
	        var ch = this.buffer[this.index++];
	        if (ch === '\n') {
	          this.line += 1;
	          this.lastLineBreak = this.index;
	        }
	        return {value: ch};
	    }
	}
	
	StreamLexer.prototype.save = function() {
	  return {
	    line: this.line,
	    col: this.index - this.lastLineBreak,
	  }
	}
	
	StreamLexer.prototype.formatError = function(token, message) {
	    // nb. this gets called after consuming the offending token,
	    // so the culprit is index-1
	    var buffer = this.buffer;
	    if (typeof buffer === 'string') {
	        var nextLineBreak = buffer.indexOf('\n', this.index);
	        if (nextLineBreak === -1) nextLineBreak = buffer.length;
	        var line = buffer.substring(this.lastLineBreak, nextLineBreak)
	        var col = this.index - this.lastLineBreak;
	        message += " at line " + this.line + " col " + col + ":\n\n";
	        message += "  " + line + "\n"
	        message += "  " + Array(col).join(" ") + "^"
	        return message;
	    } else {
	        return message + " at index " + (this.index - 1);
	    }
	}
	
	
	function Parser(rules, start, options) {
	    if (rules instanceof Grammar) {
	        var grammar = rules;
	        var options = start;
	    } else {
	        var grammar = Grammar.fromCompiled(rules, start);
	    }
	    this.grammar = grammar;
	
	    // Read options
	    this.options = {
	        keepHistory: false,
	        lexer: grammar.lexer || new StreamLexer,
	    };
	    for (var key in (options || {})) {
	        this.options[key] = options[key];
	    }
	
	    // Setup lexer
	    this.lexer = this.options.lexer;
	    this.lexerState = undefined;
	
	    // Setup a table
	    var column = new Column(grammar, 0);
	    var table = this.table = [column];
	
	    // I could be expecting anything.
	    column.wants[grammar.start] = [];
	    column.predict(grammar.start);
	    // TODO what if start rule is nullable?
	    column.process();
	    this.current = 0; // token index
	}
	
	// create a reserved token for indicating a parse fail
	Parser.fail = {};
	
	Parser.prototype.feed = function(chunk) {
	    var lexer = this.lexer;
	    lexer.reset(chunk, this.lexerState);
	
	    var token;
	    while (token = lexer.next()) {
	        // We add new states to table[current+1]
	        var column = this.table[this.current];
	
	        // GC unused states
	        if (!this.options.keepHistory) {
	            delete this.table[this.current - 1];
	        }
	
	        var n = this.current + 1;
	        var nextColumn = new Column(this.grammar, n);
	        this.table.push(nextColumn);
	
	        // Advance all tokens that expect the symbol
	        var literal = token.value;
	        var value = lexer.constructor === StreamLexer ? token.value : token;
	        var scannable = column.scannable;
	        for (var w = scannable.length; w--; ) {
	            var state = scannable[w];
	            var expect = state.rule.symbols[state.dot];
	            // Try to consume the token
	            // either regex or literal
	            if (expect.test ? expect.test(value) :
	                expect.type ? expect.type === token.type
	                            : expect.literal === literal) {
	                // Add it
	                var next = state.nextState({data: value, token: token, isToken: true, reference: n - 1});
	                nextColumn.states.push(next);
	            }
	        }
	
	        // Next, for each of the rules, we either
	        // (a) complete it, and try to see if the reference row expected that
	        //     rule
	        // (b) predict the next nonterminal it expects by adding that
	        //     nonterminal's start state
	        // To prevent duplication, we also keep track of rules we have already
	        // added
	
	        nextColumn.process();
	
	        // If needed, throw an error:
	        if (nextColumn.states.length === 0) {
	            // No states at all! This is not good.
	            var message = this.lexer.formatError(token, "invalid syntax") + "\n";
	            message += "Unexpected " + (token.type ? token.type + " token: " : "");
	            message += JSON.stringify(token.value !== undefined ? token.value : token) + "\n";
	            var err = new Error(message);
	            err.offset = this.current;
	            err.token = token;
	            throw err;
	        }
	
	        // maybe save lexer state
	        if (this.options.keepHistory) {
	          column.lexerState = lexer.save()
	        }
	
	        this.current++;
	    }
	    if (column) {
	      this.lexerState = lexer.save()
	    }
	
	    // Incrementally keep track of results
	    this.results = this.finish();
	
	    // Allow chaining, for whatever it's worth
	    return this;
	};
	
	Parser.prototype.save = function() {
	    var column = this.table[this.current];
	    column.lexerState = this.lexerState;
	    return column;
	};
	
	Parser.prototype.restore = function(column) {
	    var index = column.index;
	    this.current = index;
	    this.table[index] = column;
	    this.table.splice(index + 1);
	    this.lexerState = column.lexerState;
	
	    // Incrementally keep track of results
	    this.results = this.finish();
	};
	
	// nb. deprecated: use save/restore instead!
	Parser.prototype.rewind = function(index) {
	    if (!this.options.keepHistory) {
	        throw new Error('set option `keepHistory` to enable rewinding')
	    }
	    // nb. recall column (table) indicies fall between token indicies.
	    //        col 0   --   token 0   --   col 1
	    this.restore(this.table[index]);
	};
	
	Parser.prototype.finish = function() {
	    // Return the possible parsings
	    var considerations = [];
	    var start = this.grammar.start;
	    var column = this.table[this.table.length - 1]
	    column.states.forEach(function (t) {
	        if (t.rule.name === start
	                && t.dot === t.rule.symbols.length
	                && t.reference === 0
	                && t.data !== Parser.fail) {
	            considerations.push(t);
	        }
	    });
	    return considerations.map(function(c) {return c.data; });
	};
	
	return {
	    Parser: Parser,
	    Grammar: Grammar,
	    Rule: Rule,
	};
	
	}));


/***/ }),
/* 810 */
/***/ (function(module, exports) {

	module.exports = "/*\nTrix 0.10.1\nCopyright © 2017 Basecamp, LLC\nhttp://trix-editor.org/\n */\n(function(){}).call(this),function(){var t;null==window.Set&&(window.Set=t=function(){function t(){this.clear()}return t.prototype.clear=function(){return this.values=[]},t.prototype.has=function(t){return-1!==this.values.indexOf(t)},t.prototype.add=function(t){return this.has(t)||this.values.push(t),this},t.prototype[\"delete\"]=function(t){var e;return-1===(e=this.values.indexOf(t))?!1:(this.values.splice(e,1),!0)},t.prototype.forEach=function(){var t;return(t=this.values).forEach.apply(t,arguments)},t}())}.call(this),function(t){function e(){}function n(t,e){return function(){t.apply(e,arguments)}}function o(t){if(\"object\"!=typeof this)throw new TypeError(\"Promises must be constructed via new\");if(\"function\"!=typeof t)throw new TypeError(\"not a function\");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],c(t,this)}function i(t,e){for(;3===t._state;)t=t._value;return 0===t._state?void t._deferreds.push(e):(t._handled=!0,void h(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null===n)return void(1===t._state?r:s)(e.promise,t._value);var o;try{o=n(t._value)}catch(i){return void s(e.promise,i)}r(e.promise,o)}))}function r(t,e){try{if(e===t)throw new TypeError(\"A promise cannot be resolved with itself.\");if(e&&(\"object\"==typeof e||\"function\"==typeof e)){var i=e.then;if(e instanceof o)return t._state=3,t._value=e,void a(t);if(\"function\"==typeof i)return void c(n(i,e),t)}t._state=1,t._value=e,a(t)}catch(r){s(t,r)}}function s(t,e){t._state=2,t._value=e,a(t)}function a(t){2===t._state&&0===t._deferreds.length&&setTimeout(function(){t._handled||p(t._value)},1);for(var e=0,n=t._deferreds.length;n>e;e++)i(t,t._deferreds[e]);t._deferreds=null}function u(t,e,n){this.onFulfilled=\"function\"==typeof t?t:null,this.onRejected=\"function\"==typeof e?e:null,this.promise=n}function c(t,e){var n=!1;try{t(function(t){n||(n=!0,r(e,t))},function(t){n||(n=!0,s(e,t))})}catch(o){if(n)return;n=!0,s(e,o)}}var l=setTimeout,h=\"function\"==typeof setImmediate&&setImmediate||function(t){l(t,1)},p=function(t){\"undefined\"!=typeof console&&console&&console.warn(\"Possible Unhandled Promise Rejection:\",t)};o.prototype[\"catch\"]=function(t){return this.then(null,t)},o.prototype.then=function(t,n){var r=new o(e);return i(this,new u(t,n,r)),r},o.all=function(t){var e=Array.prototype.slice.call(t);return new o(function(t,n){function o(r,s){try{if(s&&(\"object\"==typeof s||\"function\"==typeof s)){var a=s.then;if(\"function\"==typeof a)return void a.call(s,function(t){o(r,t)},n)}e[r]=s,0===--i&&t(e)}catch(u){n(u)}}if(0===e.length)return t([]);for(var i=e.length,r=0;r<e.length;r++)o(r,e[r])})},o.resolve=function(t){return t&&\"object\"==typeof t&&t.constructor===o?t:new o(function(e){e(t)})},o.reject=function(t){return new o(function(e,n){n(t)})},o.race=function(t){return new o(function(e,n){for(var o=0,i=t.length;i>o;o++)t[o].then(e,n)})},o._setImmediateFn=function(t){h=t},o._setUnhandledRejectionFn=function(t){p=t},\"undefined\"!=typeof module&&module.exports?module.exports=o:t.Promise||(t.Promise=o)}(this),/**\n * @license\n * Copyright (c) 2014 The Polymer Project Authors. All rights reserved.\n * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt\n * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt\n * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt\n * Code distributed by Google as part of the polymer project is also\n * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt\n */\n\"undefined\"==typeof WeakMap&&!function(){var t=Object.defineProperty,e=Date.now()%1e9,n=function(){this.name=\"__st\"+(1e9*Math.random()>>>0)+(e++ +\"__\")};n.prototype={set:function(e,n){var o=e[this.name];return o&&o[0]===e?o[1]=n:t(e,this.name,{value:[e,n],writable:!0}),this},get:function(t){var e;return(e=t[this.name])&&e[0]===t?e[1]:void 0},\"delete\":function(t){var e=t[this.name];return e&&e[0]===t?(e[0]=e[1]=void 0,!0):!1},has:function(t){var e=t[this.name];return e?e[0]===t:!1}},window.WeakMap=n}(),function(t){function e(t){A.push(t),b||(b=!0,g(o))}function n(t){return window.ShadowDOMPolyfill&&window.ShadowDOMPolyfill.wrapIfNeeded(t)||t}function o(){b=!1;var t=A;A=[],t.sort(function(t,e){return t.uid_-e.uid_});var e=!1;t.forEach(function(t){var n=t.takeRecords();i(t),n.length&&(t.callback_(n,t),e=!0)}),e&&o()}function i(t){t.nodes_.forEach(function(e){var n=m.get(e);n&&n.forEach(function(e){e.observer===t&&e.removeTransientObservers()})})}function r(t,e){for(var n=t;n;n=n.parentNode){var o=m.get(n);if(o)for(var i=0;i<o.length;i++){var r=o[i],s=r.options;if(n===t||s.subtree){var a=e(s);a&&r.enqueue(a)}}}}function s(t){this.callback_=t,this.nodes_=[],this.records_=[],this.uid_=++C}function a(t,e){this.type=t,this.target=e,this.addedNodes=[],this.removedNodes=[],this.previousSibling=null,this.nextSibling=null,this.attributeName=null,this.attributeNamespace=null,this.oldValue=null}function u(t){var e=new a(t.type,t.target);return e.addedNodes=t.addedNodes.slice(),e.removedNodes=t.removedNodes.slice(),e.previousSibling=t.previousSibling,e.nextSibling=t.nextSibling,e.attributeName=t.attributeName,e.attributeNamespace=t.attributeNamespace,e.oldValue=t.oldValue,e}function c(t,e){return w=new a(t,e)}function l(t){return x?x:(x=u(w),x.oldValue=t,x)}function h(){w=x=void 0}function p(t){return t===x||t===w}function d(t,e){return t===e?t:x&&p(t)?x:null}function f(t,e,n){this.observer=t,this.target=e,this.options=n,this.transientObservedNodes=[]}if(!t.JsMutationObserver){var g,m=new WeakMap;if(/Trident|Edge/.test(navigator.userAgent))g=setTimeout;else if(window.setImmediate)g=window.setImmediate;else{var y=[],v=String(Math.random());window.addEventListener(\"message\",function(t){if(t.data===v){var e=y;y=[],e.forEach(function(t){t()})}}),g=function(t){y.push(t),window.postMessage(v,\"*\")}}var b=!1,A=[],C=0;s.prototype={observe:function(t,e){if(t=n(t),!e.childList&&!e.attributes&&!e.characterData||e.attributeOldValue&&!e.attributes||e.attributeFilter&&e.attributeFilter.length&&!e.attributes||e.characterDataOldValue&&!e.characterData)throw new SyntaxError;var o=m.get(t);o||m.set(t,o=[]);for(var i,r=0;r<o.length;r++)if(o[r].observer===this){i=o[r],i.removeListeners(),i.options=e;break}i||(i=new f(this,t,e),o.push(i),this.nodes_.push(t)),i.addListeners()},disconnect:function(){this.nodes_.forEach(function(t){for(var e=m.get(t),n=0;n<e.length;n++){var o=e[n];if(o.observer===this){o.removeListeners(),e.splice(n,1);break}}},this),this.records_=[]},takeRecords:function(){var t=this.records_;return this.records_=[],t}};var w,x;f.prototype={enqueue:function(t){var n=this.observer.records_,o=n.length;if(n.length>0){var i=n[o-1],r=d(i,t);if(r)return void(n[o-1]=r)}else e(this.observer);n[o]=t},addListeners:function(){this.addListeners_(this.target)},addListeners_:function(t){var e=this.options;e.attributes&&t.addEventListener(\"DOMAttrModified\",this,!0),e.characterData&&t.addEventListener(\"DOMCharacterDataModified\",this,!0),e.childList&&t.addEventListener(\"DOMNodeInserted\",this,!0),(e.childList||e.subtree)&&t.addEventListener(\"DOMNodeRemoved\",this,!0)},removeListeners:function(){this.removeListeners_(this.target)},removeListeners_:function(t){var e=this.options;e.attributes&&t.removeEventListener(\"DOMAttrModified\",this,!0),e.characterData&&t.removeEventListener(\"DOMCharacterDataModified\",this,!0),e.childList&&t.removeEventListener(\"DOMNodeInserted\",this,!0),(e.childList||e.subtree)&&t.removeEventListener(\"DOMNodeRemoved\",this,!0)},addTransientObserver:function(t){if(t!==this.target){this.addListeners_(t),this.transientObservedNodes.push(t);var e=m.get(t);e||m.set(t,e=[]),e.push(this)}},removeTransientObservers:function(){var t=this.transientObservedNodes;this.transientObservedNodes=[],t.forEach(function(t){this.removeListeners_(t);for(var e=m.get(t),n=0;n<e.length;n++)if(e[n]===this){e.splice(n,1);break}},this)},handleEvent:function(t){switch(t.stopImmediatePropagation(),t.type){case\"DOMAttrModified\":var e=t.attrName,n=t.relatedNode.namespaceURI,o=t.target,i=new c(\"attributes\",o);i.attributeName=e,i.attributeNamespace=n;var s=t.attrChange===MutationEvent.ADDITION?null:t.prevValue;r(o,function(t){return!t.attributes||t.attributeFilter&&t.attributeFilter.length&&-1===t.attributeFilter.indexOf(e)&&-1===t.attributeFilter.indexOf(n)?void 0:t.attributeOldValue?l(s):i});break;case\"DOMCharacterDataModified\":var o=t.target,i=c(\"characterData\",o),s=t.prevValue;r(o,function(t){return t.characterData?t.characterDataOldValue?l(s):i:void 0});break;case\"DOMNodeRemoved\":this.addTransientObserver(t.target);case\"DOMNodeInserted\":var a,u,p=t.target;\"DOMNodeInserted\"===t.type?(a=[p],u=[]):(a=[],u=[p]);var d=p.previousSibling,f=p.nextSibling,i=c(\"childList\",t.target.parentNode);i.addedNodes=a,i.removedNodes=u,i.previousSibling=d,i.nextSibling=f,r(t.relatedNode,function(t){return t.childList?i:void 0})}h()}},t.JsMutationObserver=s,t.MutationObserver||(t.MutationObserver=s,s._isPolyfilled=!0)}}(self),function(){\"use strict\";if(!window.performance){var t=Date.now();window.performance={now:function(){return Date.now()-t}}}window.requestAnimationFrame||(window.requestAnimationFrame=function(){var t=window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame;return t?function(e){return t(function(){e(performance.now())})}:function(t){return window.setTimeout(t,1e3/60)}}()),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(){return window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame||function(t){clearTimeout(t)}}());var e=function(){var t=document.createEvent(\"Event\");return t.initEvent(\"foo\",!0,!0),t.preventDefault(),t.defaultPrevented}();if(!e){var n=Event.prototype.preventDefault;Event.prototype.preventDefault=function(){this.cancelable&&(n.call(this),Object.defineProperty(this,\"defaultPrevented\",{get:function(){return!0},configurable:!0}))}}var o=/Trident/.test(navigator.userAgent);if((!window.CustomEvent||o&&\"function\"!=typeof window.CustomEvent)&&(window.CustomEvent=function(t,e){e=e||{};var n=document.createEvent(\"CustomEvent\");return n.initCustomEvent(t,Boolean(e.bubbles),Boolean(e.cancelable),e.detail),n},window.CustomEvent.prototype=window.Event.prototype),!window.Event||o&&\"function\"!=typeof window.Event){var i=window.Event;window.Event=function(t,e){e=e||{};var n=document.createEvent(\"Event\");return n.initEvent(t,Boolean(e.bubbles),Boolean(e.cancelable)),n},window.Event.prototype=i.prototype}}(window.WebComponents),window.CustomElements=window.CustomElements||{flags:{}},function(t){var e=t.flags,n=[],o=function(t){n.push(t)},i=function(){n.forEach(function(e){e(t)})};t.addModule=o,t.initializeModules=i,t.hasNative=Boolean(document.registerElement),t.isIE=/Trident/.test(navigator.userAgent),t.useNative=!e.register&&t.hasNative&&!window.ShadowDOMPolyfill&&(!window.HTMLImports||window.HTMLImports.useNative)}(window.CustomElements),window.CustomElements.addModule(function(t){function e(t,e){n(t,function(t){return e(t)?!0:void o(t,e)}),o(t,e)}function n(t,e,o){var i=t.firstElementChild;if(!i)for(i=t.firstChild;i&&i.nodeType!==Node.ELEMENT_NODE;)i=i.nextSibling;for(;i;)e(i,o)!==!0&&n(i,e,o),i=i.nextElementSibling;return null}function o(t,n){for(var o=t.shadowRoot;o;)e(o,n),o=o.olderShadowRoot}function i(t,e){r(t,e,[])}function r(t,e,n){if(t=window.wrap(t),!(n.indexOf(t)>=0)){n.push(t);for(var o,i=t.querySelectorAll(\"link[rel=\"+s+\"]\"),a=0,u=i.length;u>a&&(o=i[a]);a++)o.import&&r(o.import,e,n);e(t)}}var s=window.HTMLImports?window.HTMLImports.IMPORT_LINK_TYPE:\"none\";t.forDocumentTree=i,t.forSubtree=e}),window.CustomElements.addModule(function(t){function e(t,e){return n(t,e)||o(t,e)}function n(e,n){return t.upgrade(e,n)?!0:void(n&&s(e))}function o(t,e){b(t,function(t){return n(t,e)?!0:void 0})}function i(t){x.push(t),w||(w=!0,setTimeout(r))}function r(){w=!1;for(var t,e=x,n=0,o=e.length;o>n&&(t=e[n]);n++)t();x=[]}function s(t){C?i(function(){a(t)}):a(t)}function a(t){t.__upgraded__&&!t.__attached&&(t.__attached=!0,t.attachedCallback&&t.attachedCallback())}function u(t){c(t),b(t,function(t){c(t)})}function c(t){C?i(function(){l(t)}):l(t)}function l(t){t.__upgraded__&&t.__attached&&(t.__attached=!1,t.detachedCallback&&t.detachedCallback())}function h(t){for(var e=t,n=window.wrap(document);e;){if(e==n)return!0;e=e.parentNode||e.nodeType===Node.DOCUMENT_FRAGMENT_NODE&&e.host}}function p(t){if(t.shadowRoot&&!t.shadowRoot.__watched){v.dom&&console.log(\"watching shadow-root for: \",t.localName);for(var e=t.shadowRoot;e;)g(e),e=e.olderShadowRoot}}function d(t,n){if(v.dom){var o=n[0];if(o&&\"childList\"===o.type&&o.addedNodes&&o.addedNodes){for(var i=o.addedNodes[0];i&&i!==document&&!i.host;)i=i.parentNode;var r=i&&(i.URL||i._URL||i.host&&i.host.localName)||\"\";r=r.split(\"/?\").shift().split(\"/\").pop()}console.group(\"mutations (%d) [%s]\",n.length,r||\"\")}var s=h(t);n.forEach(function(t){\"childList\"===t.type&&(E(t.addedNodes,function(t){t.localName&&e(t,s)}),E(t.removedNodes,function(t){t.localName&&u(t)}))}),v.dom&&console.groupEnd()}function f(t){for(t=window.wrap(t),t||(t=window.wrap(document));t.parentNode;)t=t.parentNode;var e=t.__observer;e&&(d(t,e.takeRecords()),r())}function g(t){if(!t.__observer){var e=new MutationObserver(d.bind(this,t));e.observe(t,{childList:!0,subtree:!0}),t.__observer=e}}function m(t){t=window.wrap(t),v.dom&&console.group(\"upgradeDocument: \",t.baseURI.split(\"/\").pop());var n=t===window.wrap(document);e(t,n),g(t),v.dom&&console.groupEnd()}function y(t){A(t,m)}var v=t.flags,b=t.forSubtree,A=t.forDocumentTree,C=window.MutationObserver._isPolyfilled&&v[\"throttle-attached\"];t.hasPolyfillMutations=C,t.hasThrottledAttached=C;var w=!1,x=[],E=Array.prototype.forEach.call.bind(Array.prototype.forEach),S=Element.prototype.createShadowRoot;S&&(Element.prototype.createShadowRoot=function(){var t=S.call(this);return window.CustomElements.watchShadow(this),t}),t.watchShadow=p,t.upgradeDocumentTree=y,t.upgradeDocument=m,t.upgradeSubtree=o,t.upgradeAll=e,t.attached=s,t.takeRecords=f}),window.CustomElements.addModule(function(t){function e(e,o){if(\"template\"===e.localName&&window.HTMLTemplateElement&&HTMLTemplateElement.decorate&&HTMLTemplateElement.decorate(e),!e.__upgraded__&&e.nodeType===Node.ELEMENT_NODE){var i=e.getAttribute(\"is\"),r=t.getRegisteredDefinition(e.localName)||t.getRegisteredDefinition(i);if(r&&(i&&r.tag==e.localName||!i&&!r.extends))return n(e,r,o)}}function n(e,n,i){return s.upgrade&&console.group(\"upgrade:\",e.localName),n.is&&e.setAttribute(\"is\",n.is),o(e,n),e.__upgraded__=!0,r(e),i&&t.attached(e),t.upgradeSubtree(e,i),s.upgrade&&console.groupEnd(),e}function o(t,e){Object.__proto__?t.__proto__=e.prototype:(i(t,e.prototype,e.native),t.__proto__=e.prototype)}function i(t,e,n){for(var o={},i=e;i!==n&&i!==HTMLElement.prototype;){for(var r,s=Object.getOwnPropertyNames(i),a=0;r=s[a];a++)o[r]||(Object.defineProperty(t,r,Object.getOwnPropertyDescriptor(i,r)),o[r]=1);i=Object.getPrototypeOf(i)}}function r(t){t.createdCallback&&t.createdCallback()}var s=t.flags;t.upgrade=e,t.upgradeWithDefinition=n,t.implementPrototype=o}),window.CustomElements.addModule(function(t){function e(e,o){var u=o||{};if(!e)throw new Error(\"document.registerElement: first argument `name` must not be empty\");if(e.indexOf(\"-\")<0)throw new Error(\"document.registerElement: first argument ('name') must contain a dash ('-'). Argument provided was '\"+String(e)+\"'.\");if(i(e))throw new Error(\"Failed to execute 'registerElement' on 'Document': Registration failed for type '\"+String(e)+\"'. The type name is invalid.\");if(c(e))throw new Error(\"DuplicateDefinitionError: a type with name '\"+String(e)+\"' is already registered\");return u.prototype||(u.prototype=Object.create(HTMLElement.prototype)),u.__name=e.toLowerCase(),u.extends&&(u.extends=u.extends.toLowerCase()),u.lifecycle=u.lifecycle||{},u.ancestry=r(u.extends),s(u),a(u),n(u.prototype),l(u.__name,u),u.ctor=h(u),u.ctor.prototype=u.prototype,u.prototype.constructor=u.ctor,t.ready&&m(document),u.ctor}function n(t){if(!t.setAttribute._polyfilled){var e=t.setAttribute;t.setAttribute=function(t,n){o.call(this,t,n,e)};var n=t.removeAttribute;t.removeAttribute=function(t){o.call(this,t,null,n)},t.setAttribute._polyfilled=!0}}function o(t,e,n){t=t.toLowerCase();var o=this.getAttribute(t);n.apply(this,arguments);var i=this.getAttribute(t);this.attributeChangedCallback&&i!==o&&this.attributeChangedCallback(t,o,i)}function i(t){for(var e=0;e<C.length;e++)if(t===C[e])return!0}function r(t){var e=c(t);return e?r(e.extends).concat([e]):[]}function s(t){for(var e,n=t.extends,o=0;e=t.ancestry[o];o++)n=e.is&&e.tag;t.tag=n||t.__name,n&&(t.is=t.__name)}function a(t){if(!Object.__proto__){var e=HTMLElement.prototype;if(t.is){var n=document.createElement(t.tag);e=Object.getPrototypeOf(n)}for(var o,i=t.prototype,r=!1;i;)i==e&&(r=!0),o=Object.getPrototypeOf(i),o&&(i.__proto__=o),i=o;r||console.warn(t.tag+\" prototype not found in prototype chain for \"+t.is),t.native=e}}function u(t){return v(E(t.tag),t)}function c(t){return t?w[t.toLowerCase()]:void 0}function l(t,e){w[t]=e}function h(t){return function(){return u(t)}}function p(t,e,n){return t===x?d(e,n):S(t,e)}function d(t,e){t&&(t=t.toLowerCase()),e&&(e=e.toLowerCase());var n=c(e||t);if(n){if(t==n.tag&&e==n.is)return new n.ctor;if(!e&&!n.is)return new n.ctor}var o;return e?(o=d(t),o.setAttribute(\"is\",e),o):(o=E(t),t.indexOf(\"-\")>=0&&b(o,HTMLElement),o)}function f(t,e){var n=t[e];t[e]=function(){var t=n.apply(this,arguments);return y(t),t}}var g,m=(t.isIE,t.upgradeDocumentTree),y=t.upgradeAll,v=t.upgradeWithDefinition,b=t.implementPrototype,A=t.useNative,C=[\"annotation-xml\",\"color-profile\",\"font-face\",\"font-face-src\",\"font-face-uri\",\"font-face-format\",\"font-face-name\",\"missing-glyph\"],w={},x=\"http://www.w3.org/1999/xhtml\",E=document.createElement.bind(document),S=document.createElementNS.bind(document);g=Object.__proto__||A?function(t,e){return t instanceof e}:function(t,e){if(t instanceof e)return!0;for(var n=t;n;){if(n===e.prototype)return!0;n=n.__proto__}return!1},f(Node.prototype,\"cloneNode\"),f(document,\"importNode\"),document.registerElement=e,document.createElement=d,document.createElementNS=p,t.registry=w,t.instanceof=g,t.reservedTagList=C,t.getRegisteredDefinition=c,document.register=document.registerElement}),function(t){function e(){r(window.wrap(document)),window.CustomElements.ready=!0;var t=window.requestAnimationFrame||function(t){setTimeout(t,16)};t(function(){setTimeout(function(){window.CustomElements.readyTime=Date.now(),window.HTMLImports&&(window.CustomElements.elapsed=window.CustomElements.readyTime-window.HTMLImports.readyTime),document.dispatchEvent(new CustomEvent(\"WebComponentsReady\",{bubbles:!0}))})})}{var n=t.useNative,o=t.initializeModules;t.isIE}if(n){var i=function(){};t.watchShadow=i,t.upgrade=i,t.upgradeAll=i,t.upgradeDocumentTree=i,t.upgradeSubtree=i,t.takeRecords=i,t.instanceof=function(t,e){return t instanceof e}}else o();var r=t.upgradeDocumentTree,s=t.upgradeDocument;if(window.wrap||(window.ShadowDOMPolyfill?(window.wrap=window.ShadowDOMPolyfill.wrapIfNeeded,window.unwrap=window.ShadowDOMPolyfill.unwrapIfNeeded):window.wrap=window.unwrap=function(t){return t}),window.HTMLImports&&(window.HTMLImports.__importsParsingHook=function(t){t.import&&s(wrap(t.import))}),\"complete\"===document.readyState||t.flags.eager)e();else if(\"interactive\"!==document.readyState||window.attachEvent||window.HTMLImports&&!window.HTMLImports.ready){var a=window.HTMLImports&&!window.HTMLImports.ready?\"HTMLImportsLoaded\":\"DOMContentLoaded\";window.addEventListener(a,e)}else e()}(window.CustomElements),function(){}.call(this),function(){var t=this;(function(){(function(){this.Trix={VERSION:\"0.10.1\",ZERO_WIDTH_SPACE:\"\\ufeff\",NON_BREAKING_SPACE:\"\\xa0\",OBJECT_REPLACEMENT_CHARACTER:\"\\ufffc\",config:{}}}).call(this)}).call(t);var e=t.Trix;(function(){(function(){e.BasicObject=function(){function t(){}var e,n,o;return t.proxyMethod=function(t){var o,i,r,s,a;return r=n(t),o=r.name,s=r.toMethod,a=r.toProperty,i=r.optional,this.prototype[o]=function(){var t,n;return t=null!=s?i?\"function\"==typeof this[s]?this[s]():void 0:this[s]():null!=a?this[a]:void 0,i?(n=null!=t?t[o]:void 0,null!=n?e.call(n,t,arguments):void 0):(n=t[o],e.call(n,t,arguments))}},n=function(t){var e,n;if(!(n=t.match(o)))throw new Error(\"can't parse @proxyMethod expression: \"+t);return e={name:n[4]},null!=n[2]?e.toMethod=n[1]:e.toProperty=n[1],null!=n[3]&&(e.optional=!0),e},e=Function.prototype.apply,o=/^(.+?)(\\(\\))?(\\?)?\\.(.+?)$/,t}()}).call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Object=function(n){function o(){this.id=++i}var i;return t(o,n),i=0,o.fromJSONString=function(t){return this.fromJSON(JSON.parse(t))},o.prototype.hasSameConstructorAs=function(t){return this.constructor===(null!=t?t.constructor:void 0)},o.prototype.isEqualTo=function(t){return this===t},o.prototype.inspect=function(){var t,e,n;return t=function(){var t,o,i;o=null!=(t=this.contentsForInspection())?t:{},i=[];for(e in o)n=o[e],i.push(e+\"=\"+n);return i}.call(this),\"#<\"+this.constructor.name+\":\"+this.id+(t.length?\" \"+t.join(\", \"):\"\")+\">\"},o.prototype.contentsForInspection=function(){},o.prototype.toJSONString=function(){return JSON.stringify(this)},o.prototype.toUTF16String=function(){return e.UTF16String.box(this)},o.prototype.getCacheKey=function(){return this.id.toString()},o}(e.BasicObject)}.call(this),function(){e.extend=function(t){var e,n;for(e in t)n=t[e],this[e]=n;return this}}.call(this),function(){e.extend({defer:function(t){return setTimeout(t,1)}})}.call(this),function(){var t,n;e.extend({normalizeSpaces:function(t){return t.replace(RegExp(\"\"+e.ZERO_WIDTH_SPACE,\"g\"),\"\").replace(RegExp(\"\"+e.NON_BREAKING_SPACE,\"g\"),\" \")},summarizeStringChange:function(t,o){var i,r,s,a;return t=e.UTF16String.box(t),o=e.UTF16String.box(o),o.length<t.length?(r=n(t,o),a=r[0],i=r[1]):(s=n(o,t),i=s[0],a=s[1]),{added:i,removed:a}}}),n=function(n,o){var i,r,s,a,u;return n.isEqualTo(o)?[\"\",\"\"]:(r=t(n,o),a=r.utf16String.length,s=a?(u=r.offset,r,i=n.codepoints.slice(0,u).concat(n.codepoints.slice(u+a)),t(o,e.UTF16String.fromCodepoints(i))):t(o,n),[r.utf16String.toString(),s.utf16String.toString()])},t=function(t,e){var n,o,i;for(n=0,o=t.length,i=e.length;o>n&&t.charAt(n).isEqualTo(e.charAt(n));)n++;for(;o>n+1&&t.charAt(o-1).isEqualTo(e.charAt(i-1));)o--,i--;return{utf16String:t.slice(n,o),offset:n}}}.call(this),function(){e.extend({copyObject:function(t){var e,n,o;null==t&&(t={}),n={};for(e in t)o=t[e],n[e]=o;return n},objectsAreEqual:function(t,e){var n,o;if(null==t&&(t={}),null==e&&(e={}),Object.keys(t).length!==Object.keys(e).length)return!1;for(n in t)if(o=t[n],o!==e[n])return!1;return!0}})}.call(this),function(){var t=[].slice;e.extend({arraysAreEqual:function(t,e){var n,o,i,r;if(null==t&&(t=[]),null==e&&(e=[]),t.length!==e.length)return!1;for(o=n=0,i=t.length;i>n;o=++n)if(r=t[o],r!==e[o])return!1;return!0},arrayStartsWith:function(t,n){return null==t&&(t=[]),null==n&&(n=[]),e.arraysAreEqual(t.slice(0,n.length),n)},spliceArray:function(){var e,n,o;return n=arguments[0],e=2<=arguments.length?t.call(arguments,1):[],o=n.slice(0),o.splice.apply(o,e),o},summarizeArrayChange:function(t,e){var n,o,i,r,s,a,u,c,l,h,p;for(null==t&&(t=[]),null==e&&(e=[]),n=[],h=[],i=new Set,r=0,u=t.length;u>r;r++)p=t[r],i.add(p);for(o=new Set,s=0,c=e.length;c>s;s++)p=e[s],o.add(p),i.has(p)||n.push(p);for(a=0,l=t.length;l>a;a++)p=t[a],o.has(p)||h.push(p);return{added:n,removed:h}}})}.call(this),function(){var t,n,o,i;t=null,n=null,i=null,o=null,e.extend({getAllAttributeNames:function(){return null!=t?t:t=e.getTextAttributeNames().concat(e.getBlockAttributeNames())},getBlockConfig:function(t){return e.config.blockAttributes[t]},getBlockAttributeNames:function(){return null!=n?n:n=Object.keys(e.config.blockAttributes)},getTextConfig:function(t){return e.config.textAttributes[t]},getTextAttributeNames:function(){return null!=i?i:i=Object.keys(e.config.textAttributes)},getListAttributeNames:function(){var t,n;return null!=o?o:o=function(){var o,i;o=e.config.blockAttributes,i=[];for(t in o)n=o[t].listAttribute,null!=n&&i.push(n);return i}()}})}.call(this),function(){var t,n,o,i,r,s=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=document.documentElement,n=null!=(o=null!=(i=null!=(r=t.matchesSelector)?r:t.webkitMatchesSelector)?i:t.msMatchesSelector)?o:t.mozMatchesSelector,e.extend({handleEvent:function(n,o){var i,r,s,a,u,c,l,h,p,d,f,g;return h=null!=o?o:{},c=h.onElement,u=h.matchingSelector,g=h.withCallback,a=h.inPhase,l=h.preventDefault,d=h.times,r=null!=c?c:t,p=u,i=g,f=\"capturing\"===a,s=function(t){var n;return null!=d&&0===--d&&s.destroy(),n=e.findClosestElementFromNode(t.target,{matchingSelector:p}),null!=n&&(null!=g&&g.call(n,t,n),l)?t.preventDefault():void 0},s.destroy=function(){return r.removeEventListener(n,s,f)},r.addEventListener(n,s,f),s},handleEventOnce:function(t,n){return null==n&&(n={}),n.times=1,e.handleEvent(t,n)},triggerEvent:function(n,o){var i,r,s,a,u,c,l;return l=null!=o?o:{},c=l.onElement,r=l.bubbles,s=l.cancelable,i=l.attributes,a=null!=c?c:t,r=r!==!1,s=s!==!1,u=document.createEvent(\"Events\"),u.initEvent(n,r,s),null!=i&&e.extend.call(u,i),a.dispatchEvent(u)},elementMatchesSelector:function(t,e){return 1===(null!=t?t.nodeType:void 0)?n.call(t,e):void 0},findClosestElementFromNode:function(t,n){var o,i,r;for(i=null!=n?n:{},o=i.matchingSelector,r=i.untilNode;null!=t&&t.nodeType!==Node.ELEMENT_NODE;)t=t.parentNode;if(null!=t){if(null==o)return t;if(t.closest&&null==r)return t.closest(o);for(;t&&t!==r;){if(e.elementMatchesSelector(t,o))return t;t=t.parentNode}}},findInnerElement:function(t){for(;null!=t?t.firstElementChild:void 0;)t=t.firstElementChild;return t},innerElementIsActive:function(t){return document.activeElement!==t&&e.elementContainsNode(t,document.activeElement)},elementContainsNode:function(t,e){if(t&&e)for(;e;){if(e===t)return!0;e=e.parentNode}},findNodeFromContainerAndOffset:function(t,e){var n;if(t)return t.nodeType===Node.TEXT_NODE?t:0===e?null!=(n=t.firstChild)?n:t:t.childNodes.item(e-1)},findElementFromContainerAndOffset:function(t,n){var o;return o=e.findNodeFromContainerAndOffset(t,n),e.findClosestElementFromNode(o)},findChildIndexOfNode:function(t){var e;if(null!=t?t.parentNode:void 0){for(e=0;t=t.previousSibling;)e++;return e}},walkTree:function(t,e){var n,o,i,r,s;return i=null!=e?e:{},o=i.onlyNodesOfType,r=i.usingFilter,n=i.expandEntityReferences,s=function(){switch(o){case\"element\":return NodeFilter.SHOW_ELEMENT;case\"text\":return NodeFilter.SHOW_TEXT;case\"comment\":return NodeFilter.SHOW_COMMENT;default:return NodeFilter.SHOW_ALL}}(),document.createTreeWalker(t,s,null!=r?r:null,n===!0)},tagName:function(t){var e;return null!=t&&null!=(e=t.tagName)?e.toLowerCase():void 0},makeElement:function(t,e){var n,o,i,r,s,a,u,c,l,h;if(null==e&&(e={}),\"object\"==typeof t?(e=t,t=e.tagName):e={attributes:e},o=document.createElement(t),null!=e.editable&&(null==e.attributes&&(e.attributes={}),e.attributes.contenteditable=e.editable),e.attributes){a=e.attributes;for(r in a)h=a[r],o.setAttribute(r,h)}if(e.style){u=e.style;for(r in u)h=u[r],o.style[r]=h}if(e.data){c=e.data;for(r in c)h=c[r],o.dataset[r]=h}if(e.className)for(l=e.className.split(\" \"),i=0,s=l.length;s>i;i++)n=l[i],o.classList.add(n);return e.textContent&&(o.textContent=e.textContent),o},cloneFragment:function(t){var e,n,o,i,r;for(e=document.createDocumentFragment(),r=t.childNodes,n=0,o=r.length;o>n;n++)i=r[n],e.appendChild(i.cloneNode(!0));return e},makeFragment:function(t){var e,n,o;for(null==t&&(t=\"\"),e=document.createElement(\"div\"),e.innerHTML=t,n=document.createDocumentFragment();o=e.firstChild;)n.appendChild(o);return n},getBlockTagNames:function(){var t,n;return null!=e.blockTagNames?e.blockTagNames:e.blockTagNames=function(){var o,i;o=e.config.blockAttributes,i=[];for(t in o)n=o[t],i.push(n.tagName);return i}()},nodeIsBlockContainer:function(t){return e.nodeIsBlockStartComment(null!=t?t.firstChild:void 0)},nodeProbablyIsBlockContainer:function(t){var n,o;return n=e.tagName(t),s.call(e.getBlockTagNames(),n)>=0&&(o=e.tagName(t.firstChild),s.call(e.getBlockTagNames(),o)<0)},nodeIsBlockStart:function(t,n){var o;return o=(null!=n?n:{strict:!0}).strict,o?e.nodeIsBlockStartComment(t):e.nodeIsBlockStartComment(t)||!e.nodeIsBlockStartComment(t.firstChild)&&e.nodeProbablyIsBlockContainer(t)},nodeIsBlockStartComment:function(t){return e.nodeIsCommentNode(t)&&\"block\"===(null!=t?t.data:void 0)},nodeIsCommentNode:function(t){return(null!=t?t.nodeType:void 0)===Node.COMMENT_NODE},nodeIsCursorTarget:function(t){return t?e.nodeIsTextNode(t)?t.data===e.ZERO_WIDTH_SPACE:e.nodeIsCursorTarget(t.firstChild):void 0},nodeIsAttachmentElement:function(t){return e.elementMatchesSelector(t,e.AttachmentView.attachmentSelector)},nodeIsEmptyTextNode:function(t){return e.nodeIsTextNode(t)&&\"\"===(null!=t?t.data:void 0)},nodeIsTextNode:function(t){return(null!=t?t.nodeType:void 0)===Node.TEXT_NODE}})}.call(this),function(){var t,n,o,i,r;t=e.copyObject,i=e.objectsAreEqual,e.extend({normalizeRange:o=function(t){var e;if(null!=t)return Array.isArray(t)||(t=[t,t]),[n(t[0]),n(null!=(e=t[1])?e:t[0])]},rangeIsCollapsed:function(t){var e,n,i;if(null!=t)return n=o(t),i=n[0],e=n[1],r(i,e)},rangesAreEqual:function(t,e){var n,i,s,a,u,c;if(null!=t&&null!=e)return s=o(t),i=s[0],n=s[1],a=o(e),c=a[0],u=a[1],r(i,c)&&r(n,u)}}),n=function(e){return\"number\"==typeof e?e:t(e)},r=function(t,e){return\"number\"==typeof t?t===e:i(t,e)}}.call(this),function(){var t,n,o,i;t={extendsTagName:\"div\",css:\"%t { display: block; }\"},e.registerElement=function(e,n){var r,s,a,u,c,l,h;return null==n&&(n={}),e=e.toLowerCase(),c=i(n),u=null!=(h=c.extendsTagName)?h:t.extendsTagName,delete c.extendsTagName,s=c.defaultCSS,delete c.defaultCSS,null!=s&&u===t.extendsTagName?s+=\"\\n\"+t.css:s=t.css,o(s,e),a=Object.getPrototypeOf(document.createElement(u)),a.__super__=a,l=Object.create(a,c),r=document.registerElement(e,{prototype:l}),Object.defineProperty(l,\"constructor\",{value:r}),r},o=function(t,e){var o;return o=n(e),o.textContent=t.replace(/%t/g,e)},n=function(t){var e;return e=document.createElement(\"style\"),e.setAttribute(\"type\",\"text/css\"),e.setAttribute(\"data-tag-name\",t.toLowerCase()),document.head.insertBefore(e,document.head.firstChild),e},i=function(t){var e,n,o;n={};for(e in t)o=t[e],n[e]=\"function\"==typeof o?{value:o}:o;return n}}.call(this),function(){var t,n;e.extend({getDOMSelection:function(){var t;return t=window.getSelection(),t.rangeCount>0?t:void 0},getDOMRange:function(){var n,o;return(n=null!=(o=e.getDOMSelection())?o.getRangeAt(0):void 0)&&!t(n)?n:void 0},setDOMRange:function(t){var n;return n=window.getSelection(),n.removeAllRanges(),n.addRange(t),e.selectionChangeObserver.update()}}),t=function(t){return n(t.startContainer)||n(t.endContainer)},n=function(t){return!Object.getPrototypeOf(t)}}.call(this),function(){}.call(this),function(){var t,n=function(t,e){function n(){this.constructor=t}for(var i in e)o.call(e,i)&&(t[i]=e[i]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},o={}.hasOwnProperty;t=e.arraysAreEqual,e.Hash=function(o){function i(t){null==t&&(t={}),this.values=s(t),i.__super__.constructor.apply(this,arguments)}var r,s,a,u,c;return n(i,o),i.fromCommonAttributesOfObjects=function(t){var e,n,o,i,s,a;if(null==t&&(t=[]),!t.length)return new this;for(e=r(t[0]),o=e.getKeys(),a=t.slice(1),n=0,i=a.length;i>n;n++)s=a[n],o=e.getKeysCommonToHash(r(s)),e=e.slice(o);return e},i.box=function(t){return r(t)},i.prototype.add=function(t,e){return this.merge(u(t,e))},i.prototype.remove=function(t){return new e.Hash(s(this.values,t))},i.prototype.get=function(t){return this.values[t]},i.prototype.has=function(t){return t in this.values},i.prototype.merge=function(t){return new e.Hash(a(this.values,c(t)))},i.prototype.slice=function(t){var n,o,i,r;for(r={},n=0,i=t.length;i>n;n++)o=t[n],this.has(o)&&(r[o]=this.values[o]);return new e.Hash(r)},i.prototype.getKeys=function(){return Object.keys(this.values)},i.prototype.getKeysCommonToHash=function(t){var e,n,o,i,s;for(t=r(t),i=this.getKeys(),s=[],e=0,o=i.length;o>e;e++)n=i[e],this.values[n]===t.values[n]&&s.push(n);return s},i.prototype.isEqualTo=function(e){return t(this.toArray(),r(e).toArray())},i.prototype.isEmpty=function(){return 0===this.getKeys().length},i.prototype.toArray=function(){var t,e,n;return(null!=this.array?this.array:this.array=function(){var o;e=[],o=this.values;for(t in o)n=o[t],e.push(t,n);return e}.call(this)).slice(0)},i.prototype.toObject=function(){return s(this.values)},i.prototype.toJSON=function(){return this.toObject()},i.prototype.contentsForInspection=function(){return{values:JSON.stringify(this.values)}},u=function(t,e){var n;return n={},n[t]=e,n},a=function(t,e){var n,o,i;o=s(t);for(n in e)i=e[n],o[n]=i;return o},s=function(t,e){var n,o,i,r,s;for(r={},s=Object.keys(t).sort(),n=0,i=s.length;i>n;n++)o=s[n],o!==e&&(r[o]=t[o]);return r},r=function(t){return t instanceof e.Hash?t:new e.Hash(t)},c=function(t){return t instanceof e.Hash?t.values:t},i}(e.Object)}.call(this),function(){e.ObjectGroup=function(){function t(t,e){var n,o;this.objects=null!=t?t:[],o=e.depth,n=e.asTree,n&&(this.depth=o,this.objects=this.constructor.groupObjects(this.objects,{asTree:n,depth:this.depth+1}))}return t.groupObjects=function(t,e){var n,o,i,r,s,a,u,c,l;for(null==t&&(t=[]),l=null!=e?e:{},i=l.depth,n=l.asTree,n&&null==i&&(i=0),c=[],s=0,a=t.length;a>s;s++){if(u=t[s],r){if((\"function\"==typeof u.canBeGrouped?u.canBeGrouped(i):void 0)&&(\"function\"==typeof(o=r[r.length-1]).canBeGroupedWith?o.canBeGroupedWith(u,i):void 0)){r.push(u);continue}c.push(new this(r,{depth:i,asTree:n})),r=null}(\"function\"==typeof u.canBeGrouped?u.canBeGrouped(i):void 0)?r=[u]:c.push(u)}return r&&c.push(new this(r,{depth:i,asTree:n})),c},t.prototype.getObjects=function(){return this.objects},t.prototype.getDepth=function(){return this.depth},t.prototype.getCacheKey=function(){var t,e,n,o,i;for(e=[\"objectGroup\"],i=this.getObjects(),t=0,n=i.length;n>t;t++)o=i[t],e.push(o.getCacheKey());return e.join(\"/\")},t}()}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.ObjectMap=function(e){function n(t){var e,n,o,i,r;for(null==t&&(t=[]),this.objects={},o=0,i=t.length;i>o;o++)r=t[o],n=JSON.stringify(r),null==(e=this.objects)[n]&&(e[n]=r)}return t(n,e),n.prototype.find=function(t){var e;return e=JSON.stringify(t),this.objects[e]},n}(e.BasicObject)}.call(this),function(){e.ElementStore=function(){function t(t){this.reset(t)}var e;return t.prototype.add=function(t){var n;return n=e(t),this.elements[n]=t},t.prototype.remove=function(t){var n,o;return n=e(t),(o=this.elements[n])?(delete this.elements[n],o):void 0},t.prototype.reset=function(t){var e,n,o;for(null==t&&(t=[]),this.elements={},n=0,o=t.length;o>n;n++)e=t[n],this.add(e);return t},e=function(t){return t.dataset.trixStoreKey},t}()}.call(this),function(){}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Operation=function(e){function n(){return n.__super__.constructor.apply(this,arguments)}return t(n,e),n.prototype.isPerforming=function(){return this.performing===!0},n.prototype.hasPerformed=function(){return this.performed===!0},n.prototype.hasSucceeded=function(){return this.performed&&this.succeeded},n.prototype.hasFailed=function(){return this.performed&&!this.succeeded},n.prototype.getPromise=function(){return null!=this.promise?this.promise:this.promise=new Promise(function(t){return function(e,n){return t.performing=!0,t.perform(function(o,i){return t.succeeded=o,t.performing=!1,t.performed=!0,t.succeeded?e(i):n(i)})}}(this))},n.prototype.perform=function(t){return t(!1)},n.prototype.release=function(){var t;return null!=(t=this.promise)&&\"function\"==typeof t.cancel&&t.cancel(),this.promise=null,this.performing=null,this.performed=null,this.succeeded=null\n},n.proxyMethod(\"getPromise().then\"),n.proxyMethod(\"getPromise().catch\"),n}(e.BasicObject)}.call(this),function(){var t,n,o,i,r,s=function(t,e){function n(){this.constructor=t}for(var o in e)a.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},a={}.hasOwnProperty;e.UTF16String=function(t){function e(t,e){this.ucs2String=t,this.codepoints=e,this.length=this.codepoints.length,this.ucs2Length=this.ucs2String.length}return s(e,t),e.box=function(t){return null==t&&(t=\"\"),t instanceof this?t:this.fromUCS2String(null!=t?t.toString():void 0)},e.fromUCS2String=function(t){return new this(t,i(t))},e.fromCodepoints=function(t){return new this(r(t),t)},e.prototype.offsetToUCS2Offset=function(t){return r(this.codepoints.slice(0,Math.max(0,t))).length},e.prototype.offsetFromUCS2Offset=function(t){return i(this.ucs2String.slice(0,Math.max(0,t))).length},e.prototype.slice=function(){var t;return this.constructor.fromCodepoints((t=this.codepoints).slice.apply(t,arguments))},e.prototype.charAt=function(t){return this.slice(t,t+1)},e.prototype.isEqualTo=function(t){return this.constructor.box(t).ucs2String===this.ucs2String},e.prototype.toJSON=function(){return this.ucs2String},e.prototype.getCacheKey=function(){return this.ucs2String},e.prototype.toString=function(){return this.ucs2String},e}(e.BasicObject),t=1===(\"function\"==typeof Array.from?Array.from(\"\\ud83d\\udc7c\").length:void 0),n=null!=(\"function\"==typeof\" \".codePointAt?\" \".codePointAt(0):void 0),o=\" \\ud83d\\udc7c\"===(\"function\"==typeof String.fromCodePoint?String.fromCodePoint(32,128124):void 0),i=t&&n?function(t){return Array.from(t).map(function(t){return t.codePointAt(0)})}:function(t){var e,n,o,i,r;for(i=[],e=0,o=t.length;o>e;)r=t.charCodeAt(e++),r>=55296&&56319>=r&&o>e&&(n=t.charCodeAt(e++),56320===(64512&n)?r=((1023&r)<<10)+(1023&n)+65536:e--),i.push(r);return i},r=o?function(t){return String.fromCodePoint.apply(String,t)}:function(t){var e,n,o;return e=function(){var e,i,r;for(r=[],e=0,i=t.length;i>e;e++)o=t[e],n=\"\",o>65535&&(o-=65536,n+=String.fromCharCode(o>>>10&1023|55296),o=56320|1023&o),r.push(n+String.fromCharCode(o));return r}(),e.join(\"\")}}.call(this),function(){}.call(this),function(){}.call(this),function(){e.config.lang={bold:\"Bold\",bullets:\"Bullets\",\"byte\":\"Byte\",bytes:\"Bytes\",captionPlaceholder:\"Type a caption here\\u2026\",captionPrompt:\"Add a caption\\u2026\",code:\"Code\",heading1:\"Heading\",indent:\"Increase Level\",italic:\"Italic\",link:\"Link\",numbers:\"Numbers\",outdent:\"Decrease Level\",quote:\"Quote\",redo:\"Redo\",remove:\"Remove\",strike:\"Strikethrough\",undo:\"Undo\",unlink:\"Unlink\",urlPlaceholder:\"Enter a URL\\u2026\",GB:\"GB\",KB:\"KB\",MB:\"MB\",PB:\"PB\",TB:\"TB\"}}.call(this),function(){e.config.css={classNames:{attachment:{container:\"attachment\",typePrefix:\"attachment-\",caption:\"caption\",captionEdited:\"caption-edited\",captionEditor:\"caption-editor\",editingCaption:\"caption-editing\",progressBar:\"progress\",removeButton:\"remove icon\",size:\"size\"}}}}.call(this),function(){var t;e.config.blockAttributes=t={\"default\":{tagName:\"div\",parse:!1},quote:{tagName:\"blockquote\",nestable:!0},heading1:{tagName:\"h1\",terminal:!0,breakOnReturn:!0,group:!1},code:{tagName:\"pre\",terminal:!0,text:{plaintext:!0}},bulletList:{tagName:\"ul\",parse:!1},bullet:{tagName:\"li\",listAttribute:\"bulletList\",group:!1,nestable:!0,test:function(n){return e.tagName(n.parentNode)===t[this.listAttribute].tagName}},numberList:{tagName:\"ol\",parse:!1},number:{tagName:\"li\",listAttribute:\"numberList\",group:!1,nestable:!0,test:function(n){return e.tagName(n.parentNode)===t[this.listAttribute].tagName}}}}.call(this),function(){var t,n;t=e.config.lang,n=[t.bytes,t.KB,t.MB,t.GB,t.TB,t.PB],e.config.fileSize={prefix:\"IEC\",precision:2,formatter:function(e){var o,i,r,s,a;switch(e){case 0:return\"0 \"+t.bytes;case 1:return\"1 \"+t.byte;default:return o=function(){switch(this.prefix){case\"SI\":return 1e3;case\"IEC\":return 1024}}.call(this),i=Math.floor(Math.log(e)/Math.log(o)),r=e/Math.pow(o,i),s=r.toFixed(this.precision),a=s.replace(/0*$/,\"\").replace(/\\.$/,\"\"),a+\" \"+n[i]}}}}.call(this),function(){e.config.textAttributes={bold:{tagName:\"strong\",inheritable:!0,parser:function(t){var e;return e=window.getComputedStyle(t),\"bold\"===e.fontWeight||e.fontWeight>=600}},italic:{tagName:\"em\",inheritable:!0,parser:function(t){var e;return e=window.getComputedStyle(t),\"italic\"===e.fontStyle}},href:{groupTagName:\"a\",parser:function(t){var n,o,i;return n=e.AttachmentView.attachmentSelector,i=\"a:not(\"+n+\")\",(o=e.findClosestElementFromNode(t,{matchingSelector:i}))?o.getAttribute(\"href\"):void 0}},strike:{tagName:\"del\",inheritable:!0},frozen:{style:{backgroundColor:\"highlight\"}}}}.call(this),function(){var t,n,o,i,r;r=\"[data-trix-serialize=false]\",i=[\"contenteditable\",\"data-trix-id\",\"data-trix-store-key\",\"data-trix-mutable\"],n=\"data-trix-serialized-attributes\",o=\"[\"+n+\"]\",t=new RegExp(\"<!--block-->\",\"g\"),e.extend({serializers:{\"application/json\":function(t){var n;if(t instanceof e.Document)n=t;else{if(!(t instanceof HTMLElement))throw new Error(\"unserializable object\");n=e.Document.fromHTML(t.innerHTML)}return n.toSerializableDocument().toJSONString()},\"text/html\":function(s){var a,u,c,l,h,p,d,f,g,m,y,v,b,A,C,w,x;if(s instanceof e.Document)l=e.DocumentView.render(s);else{if(!(s instanceof HTMLElement))throw new Error(\"unserializable object\");l=s.cloneNode(!0)}for(A=l.querySelectorAll(r),h=0,g=A.length;g>h;h++)c=A[h],c.parentNode.removeChild(c);for(p=0,m=i.length;m>p;p++)for(a=i[p],C=l.querySelectorAll(\"[\"+a+\"]\"),d=0,y=C.length;y>d;d++)c=C[d],c.removeAttribute(a);for(w=l.querySelectorAll(o),f=0,v=w.length;v>f;f++){c=w[f];try{u=JSON.parse(c.getAttribute(n)),c.removeAttribute(n);for(b in u)x=u[b],c.setAttribute(b,x)}catch(E){}}return l.innerHTML.replace(t,\"\")}},deserializers:{\"application/json\":function(t){return e.Document.fromJSONString(t)},\"text/html\":function(t){return e.Document.fromHTML(t)}},serializeToContentType:function(t,n){var o;if(o=e.serializers[n])return o(t);throw new Error(\"unknown content type: \"+n)},deserializeFromContentType:function(t,n){var o;if(o=e.deserializers[n])return o(t);throw new Error(\"unknown content type: \"+n)}})}.call(this),function(){var t,n;n=e.makeFragment,t=e.config.lang,e.config.toolbar={content:n('<div class=\"button_row\">\\n  <span class=\"button_group text_tools\">\\n    <button type=\"button\" class=\"icon bold\" data-trix-attribute=\"bold\" data-trix-key=\"b\" title=\"'+t.bold+'\">'+t.bold+'</button>\\n    <button type=\"button\" class=\"icon italic\" data-trix-attribute=\"italic\" data-trix-key=\"i\" title=\"'+t.italic+'\">'+t.italic+'</button>\\n    <button type=\"button\" class=\"icon strike\" data-trix-attribute=\"strike\" title=\"'+t.strike+'\">'+t.strike+'</button>\\n    <button type=\"button\" class=\"icon link\" data-trix-attribute=\"href\" data-trix-action=\"link\" data-trix-key=\"k\" title=\"'+t.link+'\">'+t.link+'</button>\\n  </span>\\n\\n  <span class=\"button_group block_tools\">\\n    <button type=\"button\" class=\"icon heading-1\" data-trix-attribute=\"heading1\" title=\"'+t.heading1+'\">'+t.heading1+'</button>\\n    <button type=\"button\" class=\"icon quote\" data-trix-attribute=\"quote\" title=\"'+t.quote+'\">'+t.quote+'</button>\\n    <button type=\"button\" class=\"icon code\" data-trix-attribute=\"code\" title=\"'+t.code+'\">'+t.code+'</button>\\n    <button type=\"button\" class=\"icon list bullets\" data-trix-attribute=\"bullet\" title=\"'+t.bullets+'\">'+t.bullets+'</button>\\n    <button type=\"button\" class=\"icon list numbers\" data-trix-attribute=\"number\" title=\"'+t.numbers+'\">'+t.numbers+'</button>\\n    <button type=\"button\" class=\"icon nesting-level decrease\" data-trix-action=\"decreaseNestingLevel\" title=\"'+t.outdent+'\">'+t.outdent+'</button>\\n    <button type=\"button\" class=\"icon nesting-level increase\" data-trix-action=\"increaseNestingLevel\" title=\"'+t.indent+'\">'+t.indent+'</button>\\n  </span>\\n\\n  <span class=\"button_group history_tools\">\\n    <button type=\"button\" class=\"icon undo\" data-trix-action=\"undo\" data-trix-key=\"z\" title=\"'+t.undo+'\">'+t.undo+'</button>\\n    <button type=\"button\" class=\"icon redo\" data-trix-action=\"redo\" data-trix-key=\"shift+z\" title=\"'+t.redo+'\">'+t.redo+'</button>\\n  </span>\\n</div>\\n\\n<div class=\"dialogs\">\\n  <div class=\"dialog link_dialog\" data-trix-attribute=\"href\" data-trix-dialog=\"href\">\\n    <div class=\"link_url_fields\">\\n      <input type=\"url\" required name=\"href\" placeholder=\"'+t.urlPlaceholder+'\">\\n      <div class=\"button_group\">\\n        <input type=\"button\" value=\"'+t.link+'\" data-trix-method=\"setAttribute\">\\n        <input type=\"button\" value=\"'+t.unlink+'\" data-trix-method=\"removeAttribute\">\\n      </div>\\n    </div>\\n  </div>\\n</div>')}}.call(this),function(){e.config.undoInterval=5e3}.call(this),function(){var t,n;t=e.makeElement,n={cursorTarget:t({tagName:\"span\",textContent:e.ZERO_WIDTH_SPACE,data:{trixSelection:!0,trixCursorTarget:!0,trixSerialize:!1}})},e.extend({selectionElements:{selector:\"[data-trix-selection]\",cssText:\"font-size: 0 !important;\\npadding: 0 !important;\\nmargin: 0 !important;\\nborder: none !important;\\nline-height: 0 !important;\",create:function(t){return n[t].cloneNode(!0)}}})}.call(this),function(){}.call(this),function(){var t;t=e.cloneFragment,e.registerElement(\"trix-toolbar\",{defaultCSS:\"%t {\\n  white-space: collapse;\\n}\\n\\n%t .dialog {\\n  display: none;\\n}\\n\\n%t .dialog.active {\\n  display: block;\\n}\\n\\n%t .dialog input.validate:invalid {\\n  background-color: #ffdddd;\\n}\\n\\n%t[native] {\\n  display: none;\\n}\",createdCallback:function(){return\"\"===this.innerHTML?this.appendChild(t(e.config.toolbar.content)):void 0}})}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty,o=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};e.ObjectView=function(n){function i(t,e){this.object=t,this.options=null!=e?e:{},this.childViews=[],this.rootView=this}return t(i,n),i.prototype.getNodes=function(){var t,e,n,o,i;for(null==this.nodes&&(this.nodes=this.createNodes()),o=this.nodes,i=[],t=0,e=o.length;e>t;t++)n=o[t],i.push(n.cloneNode(!0));return i},i.prototype.invalidate=function(){var t;return this.nodes=null,null!=(t=this.parentView)?t.invalidate():void 0},i.prototype.invalidateViewForObject=function(t){var e;return null!=(e=this.findViewForObject(t))?e.invalidate():void 0},i.prototype.findOrCreateCachedChildView=function(t,e){var n;return(n=this.getCachedViewForObject(e))?this.recordChildView(n):(n=this.createChildView.apply(this,arguments),this.cacheViewForObject(n,e)),n},i.prototype.createChildView=function(t,n,o){var i;return null==o&&(o={}),n instanceof e.ObjectGroup&&(o.viewClass=t,t=e.ObjectGroupView),i=new t(n,o),this.recordChildView(i)},i.prototype.recordChildView=function(t){return t.parentView=this,t.rootView=this.rootView,o.call(this.childViews,t)<0&&this.childViews.push(t),t},i.prototype.getAllChildViews=function(){var t,e,n,o,i;for(i=[],o=this.childViews,e=0,n=o.length;n>e;e++)t=o[e],i.push(t),i=i.concat(t.getAllChildViews());return i},i.prototype.findElement=function(){return this.findElementForObject(this.object)},i.prototype.findElementForObject=function(t){var e;return(e=null!=t?t.id:void 0)?this.rootView.element.querySelector(\"[data-trix-id='\"+e+\"']\"):void 0},i.prototype.findViewForObject=function(t){var e,n,o,i;for(o=this.getAllChildViews(),e=0,n=o.length;n>e;e++)if(i=o[e],i.object===t)return i},i.prototype.getViewCache=function(){return this.rootView!==this?this.rootView.getViewCache():this.isViewCachingEnabled()?null!=this.viewCache?this.viewCache:this.viewCache={}:void 0},i.prototype.isViewCachingEnabled=function(){return this.shouldCacheViews!==!1},i.prototype.enableViewCaching=function(){return this.shouldCacheViews=!0},i.prototype.disableViewCaching=function(){return this.shouldCacheViews=!1},i.prototype.getCachedViewForObject=function(t){var e;return null!=(e=this.getViewCache())?e[t.getCacheKey()]:void 0},i.prototype.cacheViewForObject=function(t,e){var n;return null!=(n=this.getViewCache())?n[e.getCacheKey()]=t:void 0},i.prototype.garbageCollectCachedViews=function(){var t,e,n,i,r,s;if(t=this.getViewCache()){s=this.getAllChildViews().concat(this),n=function(){var t,e,n;for(n=[],t=0,e=s.length;e>t;t++)r=s[t],n.push(r.object.getCacheKey());return n}(),i=[];for(e in t)o.call(n,e)<0&&i.push(delete t[e]);return i}},i}(e.BasicObject)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.ObjectGroupView=function(e){function n(){n.__super__.constructor.apply(this,arguments),this.objectGroup=this.object,this.viewClass=this.options.viewClass,delete this.options.viewClass}return t(n,e),n.prototype.getChildViews=function(){var t,e,n,o;if(!this.childViews.length)for(o=this.objectGroup.getObjects(),t=0,e=o.length;e>t;t++)n=o[t],this.findOrCreateCachedChildView(this.viewClass,n,this.options);return this.childViews},n.prototype.createNodes=function(){var t,e,n,o,i,r,s,a,u;for(t=this.createContainerElement(),s=this.getChildViews(),e=0,o=s.length;o>e;e++)for(u=s[e],a=u.getNodes(),n=0,i=a.length;i>n;n++)r=a[n],t.appendChild(r);return[t]},n.prototype.createContainerElement=function(t){return null==t&&(t=this.objectGroup.getDepth()),this.getChildViews()[0].createContainerElement(t)},n}(e.ObjectView)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Controller=function(e){function n(){return n.__super__.constructor.apply(this,arguments)}return t(n,e),n}(e.BasicObject)}.call(this),function(){var t,n,o,i,r,s,a=function(t,e){return function(){return t.apply(e,arguments)}},u=function(t,e){function n(){this.constructor=t}for(var o in e)c.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},c={}.hasOwnProperty,l=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=e.findClosestElementFromNode,o=e.nodeIsEmptyTextNode,n=e.nodeIsBlockStartComment,i=e.normalizeSpaces,r=e.summarizeStringChange,s=e.tagName,e.MutationObserver=function(e){function c(t){this.element=t,this.didMutate=a(this.didMutate,this),this.observer=new window.MutationObserver(this.didMutate),this.start()}var h,p,d,f;return u(c,e),p=\"data-trix-mutable\",d=\"[\"+p+\"]\",f={attributes:!0,childList:!0,characterData:!0,characterDataOldValue:!0,subtree:!0},c.prototype.start=function(){return this.reset(),this.observer.observe(this.element,f)},c.prototype.stop=function(){return this.observer.disconnect()},c.prototype.didMutate=function(t){var e,n;return(e=this.mutations).push.apply(e,this.findSignificantMutations(t)),this.mutations.length?(null!=(n=this.delegate)&&\"function\"==typeof n.elementDidMutate&&n.elementDidMutate(this.getMutationSummary()),this.reset()):void 0},c.prototype.reset=function(){return this.mutations=[]},c.prototype.findSignificantMutations=function(t){var e,n,o,i;for(i=[],e=0,n=t.length;n>e;e++)o=t[e],this.mutationIsSignificant(o)&&i.push(o);return i},c.prototype.mutationIsSignificant=function(t){var e,n,o,i;for(i=this.nodesModifiedByMutation(t),e=0,n=i.length;n>e;e++)if(o=i[e],this.nodeIsSignificant(o))return!0;return!1},c.prototype.nodeIsSignificant=function(t){return t!==this.element&&!this.nodeIsMutable(t)&&!o(t)},c.prototype.nodeIsMutable=function(e){return t(e,{matchingSelector:d})},c.prototype.nodesModifiedByMutation=function(t){var e;switch(e=[],t.type){case\"attributes\":t.attributeName!==p&&e.push(t.target);break;case\"characterData\":e.push(t.target.parentNode),e.push(t.target);break;case\"childList\":e.push.apply(e,t.addedNodes),e.push.apply(e,t.removedNodes)}return e},c.prototype.getMutationSummary=function(){return this.getTextMutationSummary()},c.prototype.getTextMutationSummary=function(){var t,e,n,o,i,r,s,a,u,c,h;for(a=this.getTextChangesFromCharacterData(),n=a.additions,i=a.deletions,h=this.getTextChangesFromChildList(),u=h.additions,r=0,s=u.length;s>r;r++)e=u[r],l.call(n,e)<0&&n.push(e);return i.push.apply(i,h.deletions),c={},(t=n.join(\"\"))&&(c.textAdded=t),(o=i.join(\"\"))&&(c.textDeleted=o),c},c.prototype.getMutationsByType=function(t){var e,n,o,i,r;for(i=this.mutations,r=[],e=0,n=i.length;n>e;e++)o=i[e],o.type===t&&r.push(o);return r},c.prototype.getTextChangesFromChildList=function(){var t,e,o,r,s,a,u,c,l,p,d;for(t=[],u=[],a=this.getMutationsByType(\"childList\"),e=0,r=a.length;r>e;e++)s=a[e],t.push.apply(t,s.addedNodes),u.push.apply(u,s.removedNodes);return c=0===t.length&&1===u.length&&n(u[0]),c?(p=[],d=[\"\\n\"]):(p=h(t),d=h(u)),{additions:function(){var t,e,n;for(n=[],o=t=0,e=p.length;e>t;o=++t)l=p[o],l!==d[o]&&n.push(i(l));return n}(),deletions:function(){var t,e,n;for(n=[],o=t=0,e=d.length;e>t;o=++t)l=d[o],l!==p[o]&&n.push(i(l));return n}()}},c.prototype.getTextChangesFromCharacterData=function(){var t,e,n,o,s,a,u,c;return e=this.getMutationsByType(\"characterData\"),e.length&&(c=e[0],n=e[e.length-1],s=i(c.oldValue),o=i(n.target.data),a=r(s,o),t=a.added,u=a.removed),{additions:t?[t]:[],deletions:u?[u]:[]}},h=function(t){var e,n,o,i;for(null==t&&(t=[]),i=[],e=0,n=t.length;n>e;e++)switch(o=t[e],o.nodeType){case Node.TEXT_NODE:i.push(o.data);break;case Node.ELEMENT_NODE:\"br\"===s(o)?i.push(\"\\n\"):i.push.apply(i,h(o.childNodes))}return i},c}(e.BasicObject)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.FileVerificationOperation=function(e){function n(t){this.file=t}return t(n,e),n.prototype.perform=function(t){var e;return e=new FileReader,e.onerror=function(){return t(!1)},e.onload=function(n){return function(){e.onerror=null;try{e.abort()}catch(o){}return t(!0,n.file)}}(this),e.readAsArrayBuffer(this.file)},n}(e.Operation)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.CompositionInput=function(e){function n(t){var e;this.inputController=t,e=this.inputController,this.responder=e.responder,this.delegate=e.delegate,this.inputSummary=e.inputSummary,this.data={}}return t(n,e),n.prototype.start=function(t){var e,n;return this.data.start=t,\"keypress\"===this.inputSummary.eventName&&this.inputSummary.textAdded&&null!=(e=this.responder)&&e.deleteInDirection(\"left\"),this.selectionIsExpanded()||(this.insertPlaceholder(),this.requestRender()),this.range=null!=(n=this.responder)?n.getSelectedRange():void 0},n.prototype.update=function(t){var e;return this.data.update=t,(e=this.selectPlaceholder())?(this.forgetPlaceholder(),this.range=e):void 0},n.prototype.end=function(t){var e,n,o,i;return this.data.end=t,this.forgetPlaceholder(),this.canApplyToDocument()?(this.setInputSummary({preferDocument:!0}),null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),null!=(n=this.responder)&&n.setSelectedRange(this.range),null!=(o=this.responder)&&o.insertString(this.data.end),null!=(i=this.responder)?i.setSelectedRange(this.range[0]+this.data.end.length):void 0):null!=this.data.start||null!=this.data.update?(this.requestReparse(),this.inputController.reset()):void 0},n.prototype.getEndData=function(){return this.data.end},n.prototype.isEnded=function(){return null!=this.getEndData()},n.prototype.canApplyToDocument=function(){var t,e;return 0===(null!=(t=this.data.start)?t.length:void 0)&&(null!=(e=this.data.end)?e.length:void 0)>0&&null!=this.range},n.proxyMethod(\"inputController.setInputSummary\"),n.proxyMethod(\"inputController.requestRender\"),n.proxyMethod(\"inputController.requestReparse\"),n.proxyMethod(\"responder?.selectionIsExpanded\"),n.proxyMethod(\"responder?.insertPlaceholder\"),n.proxyMethod(\"responder?.selectPlaceholder\"),n.proxyMethod(\"responder?.forgetPlaceholder\"),n}(e.BasicObject)}.call(this),function(){var t,n,o,i,r,s,a,u,c,l,h,p,d,f=function(t,e){function n(){this.constructor=t}for(var o in e)g.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},g={}.hasOwnProperty,m=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};i=e.handleEvent,c=e.makeElement,r=e.innerElementIsActive,l=e.objectsAreEqual,p=e.tagName,e.InputController=function(p){function d(t){var n;this.element=t,this.resetInputSummary(),this.mutationObserver=new e.MutationObserver(this.element),this.mutationObserver.delegate=this;for(n in this.events)i(n,{onElement:this.element,withCallback:this.handlerFor(n),inPhase:\"capturing\"})}var g;return f(d,p),g=0,d.keyNames={8:\"backspace\",9:\"tab\",13:\"return\",37:\"left\",39:\"right\",46:\"delete\",68:\"d\",72:\"h\",79:\"o\"},d.prototype.handlerFor=function(t){return function(e){return function(n){return e.handleInput(function(){return r(this.element)?void 0:(this.eventName=t,this.events[t].call(this,n))})}}(this)},d.prototype.setInputSummary=function(t){var e,n;null==t&&(t={}),this.inputSummary.eventName=this.eventName;for(e in t)n=t[e],this.inputSummary[e]=n;return this.inputSummary},d.prototype.resetInputSummary=function(){return this.inputSummary={}},d.prototype.reset=function(){return this.resetInputSummary(),e.selectionChangeObserver.reset()},d.prototype.editorWillSyncDocumentView=function(){return this.mutationObserver.stop()},d.prototype.editorDidSyncDocumentView=function(){return this.mutationObserver.start()},d.prototype.requestRender=function(){var t;return null!=(t=this.delegate)&&\"function\"==typeof t.inputControllerDidRequestRender?t.inputControllerDidRequestRender():void 0},d.prototype.requestReparse=function(){var t;return null!=(t=this.delegate)&&\"function\"==typeof t.inputControllerDidRequestReparse&&t.inputControllerDidRequestReparse(),this.requestRender()},d.prototype.elementDidMutate=function(t){var e;return this.isComposing()?null!=(e=this.delegate)&&\"function\"==typeof e.inputControllerDidAllowUnhandledInput?e.inputControllerDidAllowUnhandledInput():void 0:this.handleInput(function(){return this.mutationIsSignificant(t)&&(this.mutationIsExpected(t)?this.requestRender():this.requestReparse()),this.reset()})},d.prototype.mutationIsExpected=function(t){var e,n,o,i,r,s,a,u,c,l;return a=t.textAdded,u=t.textDeleted,this.inputSummary.preferDocument?!0:(e=null!=a?a===this.inputSummary.textAdded:!this.inputSummary.textAdded,n=null!=u?this.inputSummary.didDelete:!this.inputSummary.didDelete,c=\"\\n\"===a&&!e,l=\"\\n\"===u&&!n,s=c&&!l||l&&!c,s&&(i=this.getSelectedRange())&&(o=c?-1:1,null!=(r=this.responder)?r.positionIsBlockBreak(i[1]+o):void 0)?!0:e&&n)},d.prototype.mutationIsSignificant=function(t){var e,n,o;return o=Object.keys(t).length>0,e=\"\"===(null!=(n=this.compositionInput)?n.getEndData():void 0),o||!e},d.prototype.attachFiles=function(t){var n,o;return o=function(){var o,i,r;for(r=[],o=0,i=t.length;i>o;o++)n=t[o],r.push(new e.FileVerificationOperation(n));return r}(),Promise.all(o).then(function(t){return function(e){return t.handleInput(function(){var t,n;return null!=(t=this.delegate)&&t.inputControllerWillAttachFiles(),null!=(n=this.responder)&&n.insertFiles(e),this.requestRender()})}}(this))},d.prototype.events={keydown:function(t){var n,o,i,r,a,u,c,l,h;if(this.isComposing()||this.resetInputSummary(),r=this.constructor.keyNames[t.keyCode]){for(o=this.keys,l=[\"ctrl\",\"alt\",\"shift\",\"meta\"],i=0,u=l.length;u>i;i++)c=l[i],t[c+\"Key\"]&&(\"ctrl\"===c&&(c=\"control\"),o=null!=o?o[c]:void 0);null!=(null!=o?o[r]:void 0)&&(this.setInputSummary({keyName:r}),e.selectionChangeObserver.reset(),o[r].call(this,t))}return s(t)&&(n=String.fromCharCode(t.keyCode).toLowerCase())&&(a=function(){var e,n,o,i;for(o=[\"alt\",\"shift\"],i=[],e=0,n=o.length;n>e;e++)c=o[e],t[c+\"Key\"]&&i.push(c);return i}(),a.push(n),null!=(h=this.delegate)?h.inputControllerDidReceiveKeyboardCommand(a):void 0)?t.preventDefault():void 0},keypress:function(t){var e,n,o;if(null==this.inputSummary.eventName&&(!t.metaKey&&!t.ctrlKey||t.altKey)&&!u(t)&&!a(t))return null===t.which?e=String.fromCharCode(t.keyCode):0!==t.which&&0!==t.charCode&&(e=String.fromCharCode(t.charCode)),null!=e?(null!=(n=this.delegate)&&n.inputControllerWillPerformTyping(),null!=(o=this.responder)&&o.insertString(e),this.setInputSummary({textAdded:e,didDelete:this.selectionIsExpanded()})):void 0},textInput:function(t){var e,n,o,i;return e=t.data,i=this.inputSummary.textAdded,i&&i!==e&&i.toUpperCase()===e?(n=this.getSelectedRange(),this.setSelectedRange([n[0],n[1]+i.length]),null!=(o=this.responder)&&o.insertString(e),this.setInputSummary({textAdded:e}),this.setSelectedRange(n)):void 0},dragenter:function(t){return t.preventDefault()},dragstart:function(t){var e,n;return n=t.target,this.serializeSelectionToDataTransfer(t.dataTransfer),this.draggedRange=this.getSelectedRange(),null!=(e=this.delegate)&&\"function\"==typeof e.inputControllerDidStartDrag?e.inputControllerDidStartDrag():void 0},dragover:function(t){var e,n;return!this.draggedRange&&!this.canAcceptDataTransfer(t.dataTransfer)||(t.preventDefault(),e={x:t.clientX,y:t.clientY},l(e,this.draggingPoint))?void 0:(this.draggingPoint=e,null!=(n=this.delegate)&&\"function\"==typeof n.inputControllerDidReceiveDragOverPoint?n.inputControllerDidReceiveDragOverPoint(this.draggingPoint):void 0)},dragend:function(){var t;return null!=(t=this.delegate)&&\"function\"==typeof t.inputControllerDidCancelDrag&&t.inputControllerDidCancelDrag(),this.draggedRange=null,this.draggingPoint=null},drop:function(t){var n,o,i,r,s,a,u,c,l;return t.preventDefault(),i=null!=(s=t.dataTransfer)?s.files:void 0,r={x:t.clientX,y:t.clientY},null!=(a=this.responder)&&a.setLocationRangeFromPointRange(r),(null!=i?i.length:void 0)?this.attachFiles(i):this.draggedRange?(null!=(u=this.delegate)&&u.inputControllerWillMoveText(),null!=(c=this.responder)&&c.moveTextFromRange(this.draggedRange),this.draggedRange=null,this.requestRender()):(o=t.dataTransfer.getData(\"application/x-trix-document\"))&&(n=e.Document.fromJSONString(o),null!=(l=this.responder)&&l.insertDocument(n),this.requestRender()),this.draggedRange=null,this.draggingPoint=null},cut:function(t){var e;return this.serializeSelectionToDataTransfer(t.clipboardData)&&t.preventDefault(),null!=(e=this.delegate)&&e.inputControllerWillCutText(),this.deleteInDirection(\"backward\"),t.defaultPrevented?this.requestRender():void 0},copy:function(t){return this.serializeSelectionToDataTransfer(t.clipboardData)?t.preventDefault():void 0},paste:function(n){var i,r,s,a,u,c,l,p,d,f,y,v,b,A,C,w,x,E,S,k,R,L;return u=null!=(l=n.clipboardData)?l:n.testClipboardData,c={paste:u},null==u||h(n)?void this.getPastedHTMLUsingHiddenElement(function(t){return function(e){var n,o,i;return c.html=e,null!=(n=t.delegate)&&n.inputControllerWillPasteText(c),null!=(o=t.responder)&&o.insertHTML(e),t.requestRender(),null!=(i=t.delegate)?i.inputControllerDidPaste(c):void 0}}(this)):((s=u.getData(\"URL\"))?(L=u.getData(\"public.url-name\")||s,c.string=L,this.setInputSummary({textAdded:L,didDelete:this.selectionIsExpanded()}),null!=(p=this.delegate)&&p.inputControllerWillPasteText(c),null!=(A=this.responder)&&A.insertText(e.Text.textForStringWithAttributes(L,{href:s})),this.requestRender(),null!=(C=this.delegate)&&C.inputControllerDidPaste(c)):t(u)?(L=u.getData(\"text/plain\"),c.string=L,this.setInputSummary({textAdded:L,didDelete:this.selectionIsExpanded()}),null!=(w=this.delegate)&&w.inputControllerWillPasteText(c),null!=(x=this.responder)&&x.insertString(L),this.requestRender(),null!=(E=this.delegate)&&E.inputControllerDidPaste(c)):(a=u.getData(\"text/html\"))?(c.html=a,null!=(S=this.delegate)&&S.inputControllerWillPasteText(c),null!=(k=this.responder)&&k.insertHTML(a),this.requestRender(),null!=(R=this.delegate)&&R.inputControllerDidPaste(c)):m.call(u.types,\"Files\")>=0&&(r=null!=(d=u.items)&&null!=(f=d[0])&&\"function\"==typeof f.getAsFile?f.getAsFile():void 0)&&(!r.name&&(i=o(r))&&(r.name=\"pasted-file-\"+ ++g+\".\"+i),c.file=r,null!=(y=this.delegate)&&y.inputControllerWillAttachFiles(),null!=(v=this.responder)&&v.insertFile(r),this.requestRender(),null!=(b=this.delegate)&&b.inputControllerDidPaste(c)),n.preventDefault())},compositionstart:function(t){return this.getCompositionInput().start(t.data)},compositionupdate:function(t){return this.getCompositionInput().update(t.data)},compositionend:function(t){return this.getCompositionInput().end(t.data)},input:function(t){return t.stopPropagation()}},d.prototype.keys={backspace:function(t){var e;return null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),this.deleteInDirection(\"backward\",t)},\"delete\":function(t){var e;return null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),this.deleteInDirection(\"forward\",t)},\"return\":function(){var t,e;return this.setInputSummary({preferDocument:!0}),null!=(t=this.delegate)&&t.inputControllerWillPerformTyping(),null!=(e=this.responder)?e.insertLineBreak():void 0},tab:function(t){var e,n;return(null!=(e=this.responder)?e.canIncreaseNestingLevel():void 0)?(null!=(n=this.responder)&&n.increaseNestingLevel(),this.requestRender(),t.preventDefault()):void 0},left:function(t){var e;return this.selectionIsInCursorTarget()?(t.preventDefault(),null!=(e=this.responder)?e.moveCursorInDirection(\"backward\"):void 0):void 0},right:function(t){var e;return this.selectionIsInCursorTarget()?(t.preventDefault(),null!=(e=this.responder)?e.moveCursorInDirection(\"forward\"):void 0):void 0},control:{d:function(t){var e;return null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),this.deleteInDirection(\"forward\",t)},h:function(t){var e;return null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),this.deleteInDirection(\"backward\",t)},o:function(t){var e,n;return t.preventDefault(),null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),null!=(n=this.responder)&&n.insertString(\"\\n\",{updatePosition:!1}),this.requestRender()}},shift:{\"return\":function(t){var e,n;return null!=(e=this.delegate)&&e.inputControllerWillPerformTyping(),null!=(n=this.responder)&&n.insertString(\"\\n\"),this.requestRender(),t.preventDefault()},tab:function(t){var e,n;return(null!=(e=this.responder)?e.canDecreaseNestingLevel():void 0)?(null!=(n=this.responder)&&n.decreaseNestingLevel(),this.requestRender(),t.preventDefault()):void 0},left:function(t){return this.selectionIsInCursorTarget()?(t.preventDefault(),this.expandSelectionInDirection(\"backward\")):void 0},right:function(t){return this.selectionIsInCursorTarget()?(t.preventDefault(),this.expandSelectionInDirection(\"forward\")):void 0}},alt:{backspace:function(){var t;return this.setInputSummary({preferDocument:!1}),null!=(t=this.delegate)?t.inputControllerWillPerformTyping():void 0}},meta:{backspace:function(){var t;return this.setInputSummary({preferDocument:!1}),null!=(t=this.delegate)?t.inputControllerWillPerformTyping():void 0}}},d.prototype.handleInput=function(t){var e,n;try{return null!=(e=this.delegate)&&e.inputControllerWillHandleInput(),t.call(this)}finally{null!=(n=this.delegate)&&n.inputControllerDidHandleInput()}},d.prototype.getCompositionInput=function(){return this.isComposing()?this.compositionInput:this.compositionInput=new e.CompositionInput(this)},d.prototype.isComposing=function(){return null!=this.compositionInput&&!this.compositionInput.isEnded()},d.prototype.deleteInDirection=function(t,e){var n;return(null!=(n=this.responder)?n.deleteInDirection(t):void 0)!==!1?this.setInputSummary({didDelete:!0}):e?(e.preventDefault(),this.requestRender()):void 0},d.prototype.serializeSelectionToDataTransfer=function(t){var o,i;if(n(t))return o=null!=(i=this.responder)?i.getSelectedDocument().toSerializableDocument():void 0,t.setData(\"application/x-trix-document\",JSON.stringify(o)),t.setData(\"text/html\",e.DocumentView.render(o).innerHTML),t.setData(\"text/plain\",o.toString().replace(/\\n$/,\"\")),!0},d.prototype.canAcceptDataTransfer=function(t){var e,n,o,i,r,s;for(s={},i=null!=(o=null!=t?t.types:void 0)?o:[],e=0,n=i.length;n>e;e++)r=i[e],s[r]=!0;return s.Files||s[\"application/x-trix-document\"]||s[\"text/html\"]||s[\"text/plain\"]},d.prototype.getPastedHTMLUsingHiddenElement=function(t){var e,n,o;return n=this.getSelectedRange(),o={position:\"absolute\",left:window.pageXOffset+\"px\",top:window.pageYOffset+\"px\",opacity:0},e=c({style:o,tagName:\"div\",editable:!0}),document.body.appendChild(e),e.focus(),requestAnimationFrame(function(o){return function(){var i;return i=e.innerHTML,document.body.removeChild(e),o.setSelectedRange(n),t(i)}}(this))},d.proxyMethod(\"responder?.getSelectedRange\"),d.proxyMethod(\"responder?.setSelectedRange\"),d.proxyMethod(\"responder?.expandSelectionInDirection\"),d.proxyMethod(\"responder?.selectionIsInCursorTarget\"),d.proxyMethod(\"responder?.selectionIsExpanded\"),d\n}(e.BasicObject),o=function(t){var e,n;return null!=(e=t.type)&&null!=(n=e.match(/\\/(\\w+)$/))?n[1]:void 0},u=function(t){return t.metaKey&&t.altKey&&!t.shiftKey&&94===t.keyCode},a=function(t){return t.metaKey&&t.altKey&&t.shiftKey&&9674===t.keyCode},s=function(t){return/Mac|^iP/.test(navigator.platform)?t.metaKey:t.ctrlKey},h=function(t){var e,n;return(n=null!=(e=t.clipboardData)?e.types:void 0)?m.call(n,\"text/html\")<0&&(m.call(n,\"com.apple.webarchive\")>=0||m.call(n,\"com.apple.flat-rtfd\")>=0):void 0},t=function(t){var e,n,o;return o=t.getData(\"text/plain\"),n=t.getData(\"text/html\"),o&&n?(e=c(\"div\"),e.innerHTML=n,e.textContent===o?!e.querySelector(\":not(meta)\"):void 0):null!=o?o.length:void 0},d={\"application/x-trix-feature-detection\":\"test\"},n=function(t){var e,n;if(null!=(null!=t?t.setData:void 0)){for(e in d)if(n=d[e],t.setData(e,n),t.getData(e)!==n)return;return!0}}}.call(this),function(){var t,n,o,i,r,s,a=function(t,e){return function(){return t.apply(e,arguments)}},u=function(t,e){function n(){this.constructor=t}for(var o in e)c.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},c={}.hasOwnProperty;n=e.handleEvent,r=e.makeElement,s=e.tagName,o=e.InputController.keyNames,i=e.config.lang,t=e.config.css.classNames,e.AttachmentEditorController=function(e){function c(t,e,n){this.attachmentPiece=t,this.element=e,this.container=n,this.uninstall=a(this.uninstall,this),this.didKeyDownCaption=a(this.didKeyDownCaption,this),this.didChangeCaption=a(this.didChangeCaption,this),this.didClickCaption=a(this.didClickCaption,this),this.didClickRemoveButton=a(this.didClickRemoveButton,this),this.attachment=this.attachmentPiece.attachment,\"a\"===s(this.element)&&(this.element=this.element.firstChild),this.install()}var l;return u(c,e),l=function(t){return function(){var e;return e=t.apply(this,arguments),e[\"do\"](),null==this.undos&&(this.undos=[]),this.undos.push(e.undo)}},c.prototype.install=function(){return this.makeElementMutable(),this.attachment.isPreviewable()&&this.makeCaptionEditable(),this.addRemoveButton()},c.prototype.makeElementMutable=l(function(){return{\"do\":function(t){return function(){return t.element.dataset.trixMutable=!0}}(this),undo:function(t){return function(){return delete t.element.dataset.trixMutable}}(this)}}),c.prototype.makeCaptionEditable=l(function(){var t,e;return t=this.element.querySelector(\"figcaption\"),e=null,{\"do\":function(o){return function(){return e=n(\"click\",{onElement:t,withCallback:o.didClickCaption,inPhase:\"capturing\"})}}(this),undo:function(){return function(){return e.destroy()}}(this)}}),c.prototype.addRemoveButton=l(function(){var e;return e=r({tagName:\"button\",textContent:i.remove,className:t.attachment.removeButton,attributes:{type:\"button\",title:i.remove},data:{trixMutable:!0}}),n(\"click\",{onElement:e,withCallback:this.didClickRemoveButton}),{\"do\":function(t){return function(){return t.element.appendChild(e)}}(this),undo:function(t){return function(){return t.element.removeChild(e)}}(this)}}),c.prototype.editCaption=l(function(){var e,o,s,a,u;return a=r({tagName:\"textarea\",className:t.attachment.captionEditor,attributes:{placeholder:i.captionPlaceholder}}),a.value=this.attachmentPiece.getCaption(),u=a.cloneNode(),u.classList.add(\"trix-autoresize-clone\"),e=function(){return u.value=a.value,a.style.height=u.scrollHeight+\"px\"},n(\"input\",{onElement:a,withCallback:e}),n(\"keydown\",{onElement:a,withCallback:this.didKeyDownCaption}),n(\"change\",{onElement:a,withCallback:this.didChangeCaption}),n(\"blur\",{onElement:a,withCallback:this.uninstall}),s=this.element.querySelector(\"figcaption\"),o=s.cloneNode(),{\"do\":function(){return s.style.display=\"none\",o.appendChild(a),o.appendChild(u),o.classList.add(t.attachment.editingCaption),s.parentElement.insertBefore(o,s),e(),a.focus()},undo:function(){return o.parentNode.removeChild(o),s.style.display=null}}}),c.prototype.didClickRemoveButton=function(t){var e;return t.preventDefault(),t.stopPropagation(),null!=(e=this.delegate)?e.attachmentEditorDidRequestRemovalOfAttachment(this.attachment):void 0},c.prototype.didClickCaption=function(t){return t.preventDefault(),this.editCaption()},c.prototype.didChangeCaption=function(t){var e,n,o;return e=t.target.value.replace(/\\s/g,\" \").trim(),e?null!=(n=this.delegate)&&\"function\"==typeof n.attachmentEditorDidRequestUpdatingAttributesForAttachment?n.attachmentEditorDidRequestUpdatingAttributesForAttachment({caption:e},this.attachment):void 0:null!=(o=this.delegate)&&\"function\"==typeof o.attachmentEditorDidRequestRemovingAttributeForAttachment?o.attachmentEditorDidRequestRemovingAttributeForAttachment(\"caption\",this.attachment):void 0},c.prototype.didKeyDownCaption=function(t){var e;return\"return\"===o[t.keyCode]?(t.preventDefault(),this.didChangeCaption(t),null!=(e=this.delegate)&&\"function\"==typeof e.attachmentEditorDidRequestDeselectingAttachment?e.attachmentEditorDidRequestDeselectingAttachment(this.attachment):void 0):void 0},c.prototype.uninstall=function(){for(var t,e;e=this.undos.pop();)e();return null!=(t=this.delegate)?t.didUninstallAttachmentEditor(this):void 0},c}(e.BasicObject)}.call(this),function(){var t,n,o,i,r=function(t,e){function n(){this.constructor=t}for(var o in e)s.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},s={}.hasOwnProperty;o=e.makeElement,i=e.selectionElements,t=e.config.css.classNames,e.AttachmentView=function(e){function s(){s.__super__.constructor.apply(this,arguments),this.attachment=this.object,this.attachment.uploadProgressDelegate=this,this.attachmentPiece=this.options.piece}return r(s,e),s.attachmentSelector=\"[data-trix-attachment]\",s.prototype.createContentNodes=function(){return[]},s.prototype.createNodes=function(){var e,n,r,s,a,u,c,l,h,p,d;if(s=o({tagName:\"figure\",className:this.getClassName()}),this.attachment.hasContent())s.innerHTML=this.attachment.getContent();else for(p=this.createContentNodes(),u=0,l=p.length;l>u;u++)h=p[u],s.appendChild(h);s.appendChild(this.createCaptionElement()),n={trixAttachment:JSON.stringify(this.attachment),trixContentType:this.attachment.getContentType(),trixId:this.attachment.id},e=this.attachmentPiece.getAttributesForAttachment(),e.isEmpty()||(n.trixAttributes=JSON.stringify(e)),this.attachment.isPending()&&(this.progressElement=o({tagName:\"progress\",attributes:{\"class\":t.attachment.progressBar,value:this.attachment.getUploadProgress(),max:100},data:{trixMutable:!0,trixStoreKey:[\"progressElement\",this.attachment.id].join(\"/\")}}),s.appendChild(this.progressElement),n.trixSerialize=!1),(a=this.getHref())?(r=o(\"a\",{href:a}),r.appendChild(s)):r=s;for(c in n)d=n[c],r.dataset[c]=d;return r.setAttribute(\"contenteditable\",!1),[i.create(\"cursorTarget\"),r,i.create(\"cursorTarget\")]},s.prototype.createCaptionElement=function(){var e,n,i,r,s;return n=o({tagName:\"figcaption\",className:t.attachment.caption}),(e=this.attachmentPiece.getCaption())?(n.classList.add(t.attachment.captionEdited),n.textContent=e):(i=this.attachment.getFilename())&&(n.textContent=i,(r=this.attachment.getFormattedFilesize())&&(n.appendChild(document.createTextNode(\" \")),s=o({tagName:\"span\",className:t.attachment.size,textContent:r}),n.appendChild(s))),n},s.prototype.getClassName=function(){var e,n;return n=[t.attachment.container,\"\"+t.attachment.typePrefix+this.attachment.getType()],(e=this.attachment.getExtension())&&n.push(e),n.join(\" \")},s.prototype.getHref=function(){return n(this.attachment.getContent(),\"a\")?void 0:this.attachment.getHref()},s.prototype.findProgressElement=function(){var t;return null!=(t=this.findElement())?t.querySelector(\"progress\"):void 0},s.prototype.attachmentDidChangeUploadProgress=function(){var t,e;return e=this.attachment.getUploadProgress(),null!=(t=this.findProgressElement())?t.value=e:void 0},s}(e.ObjectView),n=function(t,e){var n;return n=o(\"div\"),n.innerHTML=null!=t?t:\"\",n.querySelector(e)}}.call(this),function(){var t,n=function(t,e){function n(){this.constructor=t}for(var i in e)o.call(e,i)&&(t[i]=e[i]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},o={}.hasOwnProperty;t=e.makeElement,e.PreviewableAttachmentView=function(e){function o(){o.__super__.constructor.apply(this,arguments),this.attachment.previewDelegate=this}return n(o,e),o.prototype.createContentNodes=function(){return this.image=t({tagName:\"img\",attributes:{src:\"\"},data:{trixMutable:!0}}),this.refresh(this.image),[this.image]},o.prototype.refresh=function(t){var e;return null==t&&(t=null!=(e=this.findElement())?e.querySelector(\"img\"):void 0),t?this.updateAttributesForImage(t):void 0},o.prototype.updateAttributesForImage=function(t){var e,n,o,i,r,s;return r=this.attachment.getURL(),n=this.attachment.getPreviewURL(),t.src=n||r,n===r?t.removeAttribute(\"data-trix-serialized-attributes\"):(o=JSON.stringify({src:r}),t.setAttribute(\"data-trix-serialized-attributes\",o)),s=this.attachment.getWidth(),e=this.attachment.getHeight(),null!=s&&(t.width=s),null!=e&&(t.height=e),i=[\"imageElement\",this.attachment.id,t.src,t.width,t.height].join(\"/\"),t.dataset.trixStoreKey=i},o.prototype.attachmentDidChangePreviewURL=function(){return this.refresh(this.image),this.refresh()},o}(e.AttachmentView)}.call(this),function(){var t,n,o,i=function(t,e){function n(){this.constructor=t}for(var o in e)r.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},r={}.hasOwnProperty;o=e.makeElement,t=e.findInnerElement,n=e.getTextConfig,e.PieceView=function(r){function s(){var t;s.__super__.constructor.apply(this,arguments),this.piece=this.object,this.attributes=this.piece.getAttributes(),t=this.options,this.textConfig=t.textConfig,this.context=t.context,this.piece.attachment?this.attachment=this.piece.attachment:this.string=this.piece.toString()}var a;return i(s,r),s.prototype.createNodes=function(){var e,n,o,i,r,s;if(s=this.attachment?this.createAttachmentNodes():this.createStringNodes(),e=this.createElement()){for(o=t(e),n=0,i=s.length;i>n;n++)r=s[n],o.appendChild(r);s=[e]}return s},s.prototype.createAttachmentNodes=function(){var t,n;return t=this.attachment.isPreviewable()?e.PreviewableAttachmentView:e.AttachmentView,n=this.createChildView(t,this.piece.attachment,{piece:this.piece}),n.getNodes()},s.prototype.createStringNodes=function(){var t,e,n,i,r,s,a,u,c,l;if(null!=(u=this.textConfig)?u.plaintext:void 0)return[document.createTextNode(this.string)];for(a=[],c=this.string.split(\"\\n\"),n=e=0,i=c.length;i>e;n=++e)l=c[n],n>0&&(t=o(\"br\"),a.push(t)),(r=l.length)&&(s=document.createTextNode(this.preserveSpaces(l)),a.push(s));return a},s.prototype.createElement=function(){var t,e,i,r,s,a,u,c;for(r in this.attributes)if((t=n(r))&&(t.tagName&&(s=o(t.tagName),i?(i.appendChild(s),i=s):e=i=s),t.style))if(u){a=t.style;for(r in a)c=a[r],u[r]=c}else u=t.style;if(u){null==e&&(e=o(\"span\"));for(r in u)c=u[r],e.style[r]=c}return e},s.prototype.createContainerElement=function(){var t,e,i,r,s;r=this.attributes;for(i in r)if(s=r[i],(e=n(i))&&e.groupTagName)return t={},t[i]=s,o(e.groupTagName,t)},a=e.NON_BREAKING_SPACE,s.prototype.preserveSpaces=function(t){return this.context.isLast&&(t=t.replace(/\\ $/,a)),t=t.replace(/(\\S)\\ {3}(\\S)/g,\"$1 \"+a+\" $2\").replace(/\\ {2}/g,a+\" \").replace(/\\ {2}/g,\" \"+a),(this.context.isFirst||this.context.followsWhitespace)&&(t=t.replace(/^\\ /,a)),t},s}(e.ObjectView)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.TextView=function(n){function o(){o.__super__.constructor.apply(this,arguments),this.text=this.object,this.textConfig=this.options.textConfig}var i;return t(o,n),o.prototype.createNodes=function(){var t,n,o,r,s,a,u,c,l,h;for(a=[],c=e.ObjectGroup.groupObjects(this.getPieces()),r=c.length-1,o=n=0,s=c.length;s>n;o=++n)u=c[o],t={},0===o&&(t.isFirst=!0),o===r&&(t.isLast=!0),i(l)&&(t.followsWhitespace=!0),h=this.findOrCreateCachedChildView(e.PieceView,u,{textConfig:this.textConfig,context:t}),a.push.apply(a,h.getNodes()),l=u;return a},o.prototype.getPieces=function(){var t,e,n,o,i;for(o=this.text.getPieces(),i=[],t=0,e=o.length;e>t;t++)n=o[t],n.hasAttribute(\"blockBreak\")||i.push(n);return i},i=function(t){return/\\s$/.test(null!=t?t.toString():void 0)},o}(e.ObjectView)}.call(this),function(){var t,n,o=function(t,e){function n(){this.constructor=t}for(var o in e)i.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},i={}.hasOwnProperty;n=e.makeElement,t=e.getBlockConfig,e.BlockView=function(i){function r(){r.__super__.constructor.apply(this,arguments),this.block=this.object,this.attributes=this.block.getAttributes()}return o(r,i),r.prototype.createNodes=function(){var o,i,r,s,a,u,c,l,h;if(o=document.createComment(\"block\"),u=[o],this.block.isEmpty()?u.push(n(\"br\")):(l=null!=(c=t(this.block.getLastAttribute()))?c.text:void 0,h=this.findOrCreateCachedChildView(e.TextView,this.block.text,{textConfig:l}),u.push.apply(u,h.getNodes()),this.shouldAddExtraNewlineElement()&&u.push(n(\"br\"))),this.attributes.length)return u;for(i=n(e.config.blockAttributes[\"default\"].tagName),r=0,s=u.length;s>r;r++)a=u[r],i.appendChild(a);return[i]},r.prototype.createContainerElement=function(e){var o,i;return o=this.attributes[e],i=t(o),n(i.tagName)},r.prototype.shouldAddExtraNewlineElement=function(){return/\\n\\n$/.test(this.block.toString())},r}(e.ObjectView)}.call(this),function(){var t,n,o=function(t,e){function n(){this.constructor=t}for(var o in e)i.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},i={}.hasOwnProperty;t=e.defer,n=e.makeElement,e.DocumentView=function(i){function r(){r.__super__.constructor.apply(this,arguments),this.element=this.options.element,this.elementStore=new e.ElementStore,this.setDocument(this.object)}var s,a,u;return o(r,i),r.render=function(t){var e,o;return e=n(\"div\"),o=new this(t,{element:e}),o.render(),o.sync(),e},r.prototype.setDocument=function(t){return t.isEqualTo(this.document)?void 0:this.document=this.object=t},r.prototype.render=function(){var t,o,i,r,s,a,u;if(this.childViews=[],this.shadowElement=n(\"div\"),!this.document.isEmpty()){for(s=e.ObjectGroup.groupObjects(this.document.getBlocks(),{asTree:!0}),a=[],t=0,o=s.length;o>t;t++)r=s[t],u=this.findOrCreateCachedChildView(e.BlockView,r),a.push(function(){var t,e,n,o;for(n=u.getNodes(),o=[],t=0,e=n.length;e>t;t++)i=n[t],o.push(this.shadowElement.appendChild(i));return o}.call(this));return a}},r.prototype.isSynced=function(){return s(this.shadowElement,this.element)},r.prototype.sync=function(){var t;for(t=this.createDocumentFragmentForSync();this.element.lastChild;)this.element.removeChild(this.element.lastChild);return this.element.appendChild(t),this.didSync()},r.prototype.didSync=function(){return this.elementStore.reset(a(this.element)),t(function(t){return function(){return t.garbageCollectCachedViews()}}(this))},r.prototype.createDocumentFragmentForSync=function(){var t,e,n,o,i,r,s,u,c,l;for(e=document.createDocumentFragment(),u=this.shadowElement.childNodes,n=0,i=u.length;i>n;n++)s=u[n],e.appendChild(s.cloneNode(!0));for(c=a(e),o=0,r=c.length;r>o;o++)t=c[o],(l=this.elementStore.remove(t))&&t.parentNode.replaceChild(l,t);return e},a=function(t){return t.querySelectorAll(\"[data-trix-store-key]\")},s=function(t,e){return u(t.innerHTML)===u(e.innerHTML)},u=function(t){return t.replace(/&nbsp;/g,\" \")},r}(e.ObjectView)}.call(this),function(){var t,n,o,i,r=function(t,e){return function(){return t.apply(e,arguments)}},s=function(t,e){function n(){this.constructor=t}for(var o in e)a.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},a={}.hasOwnProperty;o=e.handleEvent,i=e.innerElementIsActive,n=e.defer,t=e.AttachmentView.attachmentSelector,e.CompositionController=function(a){function u(n,i){this.element=n,this.composition=i,this.didClickAttachment=r(this.didClickAttachment,this),this.didBlur=r(this.didBlur,this),this.didFocus=r(this.didFocus,this),this.documentView=new e.DocumentView(this.composition.document,{element:this.element}),o(\"focus\",{onElement:this.element,withCallback:this.didFocus}),o(\"blur\",{onElement:this.element,withCallback:this.didBlur}),o(\"click\",{onElement:this.element,matchingSelector:\"a[contenteditable=false]\",preventDefault:!0}),o(\"mousedown\",{onElement:this.element,matchingSelector:t,withCallback:this.didClickAttachment}),o(\"click\",{onElement:this.element,matchingSelector:\"a\"+t,preventDefault:!0})}return s(u,a),u.prototype.didFocus=function(){var t,e,n;return t=function(t){return function(){var e;return t.focused?void 0:(t.focused=!0,null!=(e=t.delegate)&&\"function\"==typeof e.compositionControllerDidFocus?e.compositionControllerDidFocus():void 0)}}(this),null!=(e=null!=(n=this.blurPromise)?n.then(t):void 0)?e:t()},u.prototype.didBlur=function(){return this.blurPromise=new Promise(function(t){return function(e){return n(function(){var n;return i(t.element)||(t.focused=null,null!=(n=t.delegate)&&\"function\"==typeof n.compositionControllerDidBlur&&n.compositionControllerDidBlur()),t.blurPromise=null,e()})}}(this))},u.prototype.didClickAttachment=function(t,e){var n,o;return n=this.findAttachmentForElement(e),null!=(o=this.delegate)&&\"function\"==typeof o.compositionControllerDidSelectAttachment?o.compositionControllerDidSelectAttachment(n):void 0},u.prototype.render=function(){var t,e,n;return this.revision!==this.composition.revision&&(this.documentView.setDocument(this.composition.document),this.documentView.render(),this.revision=this.composition.revision),this.documentView.isSynced()||(null!=(t=this.delegate)&&\"function\"==typeof t.compositionControllerWillSyncDocumentView&&t.compositionControllerWillSyncDocumentView(),this.documentView.sync(),this.reinstallAttachmentEditor(),null!=(e=this.delegate)&&\"function\"==typeof e.compositionControllerDidSyncDocumentView&&e.compositionControllerDidSyncDocumentView()),null!=(n=this.delegate)&&\"function\"==typeof n.compositionControllerDidRender?n.compositionControllerDidRender():void 0},u.prototype.rerenderViewForObject=function(t){return this.invalidateViewForObject(t),this.render()},u.prototype.invalidateViewForObject=function(t){return this.documentView.invalidateViewForObject(t)},u.prototype.isViewCachingEnabled=function(){return this.documentView.isViewCachingEnabled()},u.prototype.enableViewCaching=function(){return this.documentView.enableViewCaching()},u.prototype.disableViewCaching=function(){return this.documentView.disableViewCaching()},u.prototype.refreshViewCache=function(){return this.documentView.garbageCollectCachedViews()},u.prototype.installAttachmentEditorForAttachment=function(t){var n,o,i;if((null!=(i=this.attachmentEditor)?i.attachment:void 0)!==t&&(o=this.documentView.findElementForObject(t)))return this.uninstallAttachmentEditor(),n=this.composition.document.getAttachmentPieceForAttachment(t),this.attachmentEditor=new e.AttachmentEditorController(n,o,this.element),this.attachmentEditor.delegate=this},u.prototype.uninstallAttachmentEditor=function(){var t;return null!=(t=this.attachmentEditor)?t.uninstall():void 0},u.prototype.reinstallAttachmentEditor=function(){var t;return this.attachmentEditor?(t=this.attachmentEditor.attachment,this.uninstallAttachmentEditor(),this.installAttachmentEditorForAttachment(t)):void 0},u.prototype.editAttachmentCaption=function(){var t;return null!=(t=this.attachmentEditor)?t.editCaption():void 0},u.prototype.didUninstallAttachmentEditor=function(){return this.attachmentEditor=null,this.render()},u.prototype.attachmentEditorDidRequestUpdatingAttributesForAttachment=function(t,e){var n;return null!=(n=this.delegate)&&\"function\"==typeof n.compositionControllerWillUpdateAttachment&&n.compositionControllerWillUpdateAttachment(e),this.composition.updateAttributesForAttachment(t,e)},u.prototype.attachmentEditorDidRequestRemovingAttributeForAttachment=function(t,e){var n;return null!=(n=this.delegate)&&\"function\"==typeof n.compositionControllerWillUpdateAttachment&&n.compositionControllerWillUpdateAttachment(e),this.composition.removeAttributeForAttachment(t,e)},u.prototype.attachmentEditorDidRequestRemovalOfAttachment=function(t){var e;return null!=(e=this.delegate)&&\"function\"==typeof e.compositionControllerDidRequestRemovalOfAttachment?e.compositionControllerDidRequestRemovalOfAttachment(t):void 0},u.prototype.attachmentEditorDidRequestDeselectingAttachment=function(t){var e;return null!=(e=this.delegate)&&\"function\"==typeof e.compositionControllerDidRequestDeselectingAttachment?e.compositionControllerDidRequestDeselectingAttachment(t):void 0},u.prototype.findAttachmentForElement=function(t){return this.composition.document.getAttachmentById(parseInt(t.dataset.trixId,10))},u}(e.BasicObject)}.call(this),function(){var t,n,o,i=function(t,e){return function(){return t.apply(e,arguments)}},r=function(t,e){function n(){this.constructor=t}for(var o in e)s.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},s={}.hasOwnProperty;n=e.handleEvent,o=e.triggerEvent,t=e.findClosestElementFromNode,e.ToolbarController=function(e){function s(t){this.element=t,this.didKeyDownDialogInput=i(this.didKeyDownDialogInput,this),this.didClickDialogButton=i(this.didClickDialogButton,this),this.didClickAttributeButton=i(this.didClickAttributeButton,this),this.didClickActionButton=i(this.didClickActionButton,this),this.attributes={},this.actions={},this.resetDialogInputs(),n(\"mousedown\",{onElement:this.element,matchingSelector:a,withCallback:this.didClickActionButton}),n(\"mousedown\",{onElement:this.element,matchingSelector:c,withCallback:this.didClickAttributeButton}),n(\"click\",{onElement:this.element,matchingSelector:y,preventDefault:!0}),n(\"click\",{onElement:this.element,matchingSelector:l,withCallback:this.didClickDialogButton}),n(\"keydown\",{onElement:this.element,matchingSelector:h,withCallback:this.didKeyDownDialogInput})}var a,u,c,l,h,p,d,f,g,m,y;return r(s,e),a=\"button[data-trix-action]\",c=\"button[data-trix-attribute]\",y=[a,c].join(\", \"),p=\".dialog[data-trix-dialog]\",u=p+\".active\",l=p+\" input[data-trix-method]\",h=p+\" input[type=text], \"+p+\" input[type=url]\",s.prototype.didClickActionButton=function(t,e){var n,o,i;return null!=(o=this.delegate)&&o.toolbarDidClickButton(),t.preventDefault(),n=d(e),this.getDialog(n)?this.toggleDialog(n):null!=(i=this.delegate)?i.toolbarDidInvokeAction(n):void 0},s.prototype.didClickAttributeButton=function(t,e){var n,o,i;return null!=(o=this.delegate)&&o.toolbarDidClickButton(),t.preventDefault(),n=f(e),this.getDialog(n)?this.toggleDialog(n):null!=(i=this.delegate)&&i.toolbarDidToggleAttribute(n),this.refreshAttributeButtons()},s.prototype.didClickDialogButton=function(e,n){var o,i;return o=t(n,{matchingSelector:p}),i=n.getAttribute(\"data-trix-method\"),this[i].call(this,o)},s.prototype.didKeyDownDialogInput=function(t,e){var n,o;return 13===t.keyCode&&(t.preventDefault(),n=e.getAttribute(\"name\"),o=this.getDialog(n),this.setAttribute(o)),27===t.keyCode?(t.preventDefault(),this.hideDialog()):void 0},s.prototype.updateActions=function(t){return this.actions=t,this.refreshActionButtons()},s.prototype.refreshActionButtons=function(){return this.eachActionButton(function(t){return function(e,n){return e.disabled=t.actions[n]===!1}}(this))},s.prototype.eachActionButton=function(t){var e,n,o,i,r;for(i=this.element.querySelectorAll(a),r=[],n=0,o=i.length;o>n;n++)e=i[n],r.push(t(e,d(e)));return r},s.prototype.updateAttributes=function(t){return this.attributes=t,this.refreshAttributeButtons()},s.prototype.refreshAttributeButtons=function(){return this.eachAttributeButton(function(t){return function(e,n){return e.disabled=t.attributes[n]===!1,t.attributes[n]||t.dialogIsVisible(n)?e.classList.add(\"active\"):e.classList.remove(\"active\")}}(this))},s.prototype.eachAttributeButton=function(t){var e,n,o,i,r;for(i=this.element.querySelectorAll(c),r=[],n=0,o=i.length;o>n;n++)e=i[n],r.push(t(e,f(e)));return r},s.prototype.applyKeyboardCommand=function(t){var e,n,i,r,s,a,u;for(s=JSON.stringify(t.sort()),u=this.element.querySelectorAll(\"[data-trix-key]\"),r=0,a=u.length;a>r;r++)if(e=u[r],i=e.getAttribute(\"data-trix-key\").split(\"+\"),n=JSON.stringify(i.sort()),n===s)return o(\"mousedown\",{onElement:e}),!0;return!1},s.prototype.dialogIsVisible=function(t){var e;return(e=this.getDialog(t))?e.classList.contains(\"active\"):void 0},s.prototype.toggleDialog=function(t){return this.dialogIsVisible(t)?this.hideDialog():this.showDialog(t)},s.prototype.showDialog=function(t){var e,n,o,i,r,s,a,u,c,l;for(this.hideDialog(),null!=(a=this.delegate)&&a.toolbarWillShowDialog(),o=this.getDialog(t),o.classList.add(\"active\"),u=o.querySelectorAll(\"input[disabled]\"),i=0,s=u.length;s>i;i++)n=u[i],n.removeAttribute(\"disabled\");return(e=f(o))&&(r=m(o,t))&&(r.value=null!=(c=this.attributes[e])?c:\"\",r.select()),null!=(l=this.delegate)?l.toolbarDidShowDialog(t):void 0},s.prototype.setAttribute=function(t){var e,n,o;return e=f(t),n=m(t,e),n.willValidate&&!n.checkValidity()?(n.classList.add(\"validate\"),n.focus()):(null!=(o=this.delegate)&&o.toolbarDidUpdateAttribute(e,n.value),this.hideDialog())},s.prototype.removeAttribute=function(t){var e,n;return e=f(t),null!=(n=this.delegate)&&n.toolbarDidRemoveAttribute(e),this.hideDialog()},s.prototype.hideDialog=function(){var t,e;return(t=this.element.querySelector(u))?(t.classList.remove(\"active\"),this.resetDialogInputs(),null!=(e=this.delegate)?e.toolbarDidHideDialog(g(t)):void 0):void 0},s.prototype.resetDialogInputs=function(){var t,e,n,o,i;for(o=this.element.querySelectorAll(h),i=[],t=0,n=o.length;n>t;t++)e=o[t],e.setAttribute(\"disabled\",\"disabled\"),i.push(e.classList.remove(\"validate\"));return i},s.prototype.getDialog=function(t){return this.element.querySelector(\".dialog[data-trix-dialog=\"+t+\"]\")},m=function(t,e){return null==e&&(e=f(t)),t.querySelector(\"input[name='\"+e+\"']\")},d=function(t){return t.getAttribute(\"data-trix-action\")},f=function(t){return t.getAttribute(\"data-trix-attribute\")},g=function(t){return t.getAttribute(\"data-trix-dialog\")},s}(e.BasicObject)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.ImagePreloadOperation=function(e){function n(t){this.url=t}return t(n,e),n.prototype.perform=function(t){var e;return e=new Image,e.onload=function(n){return function(){return e.width=n.width=e.naturalWidth,e.height=n.height=e.naturalHeight,t(!0,e)}}(this),e.onerror=function(){return t(!1)},e.src=this.url},n}(e.Operation)}.call(this),function(){var t=function(t,e){return function(){return t.apply(e,arguments)}},n=function(t,e){function n(){this.constructor=t}for(var i in e)o.call(e,i)&&(t[i]=e[i]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},o={}.hasOwnProperty;e.Attachment=function(o){function i(n){null==n&&(n={}),this.releaseFile=t(this.releaseFile,this),i.__super__.constructor.apply(this,arguments),this.attributes=e.Hash.box(n),this.didChangeAttributes()}return n(i,o),i.previewablePattern=/^image(\\/(gif|png|jpe?g)|$)/,i.attachmentForFile=function(t){var e,n;return n=this.attributesForFile(t),e=new this(n),e.setFile(t),e},i.attributesForFile=function(t){return new e.Hash({filename:t.name,filesize:t.size,contentType:t.type})},i.fromJSON=function(t){return new this(t)},i.prototype.getAttribute=function(t){return this.attributes.get(t)},i.prototype.hasAttribute=function(t){return this.attributes.has(t)},i.prototype.getAttributes=function(){return this.attributes.toObject()},i.prototype.setAttributes=function(t){var e,n;return null==t&&(t={}),e=this.attributes.merge(t),this.attributes.isEqualTo(e)?void 0:(this.attributes=e,this.didChangeAttributes(),null!=(n=this.delegate)&&\"function\"==typeof n.attachmentDidChangeAttributes?n.attachmentDidChangeAttributes(this):void 0)},i.prototype.didChangeAttributes=function(){return this.isPreviewable()?this.preloadURL():void 0},i.prototype.isPending=function(){return null!=this.file&&!(this.getURL()||this.getHref())},i.prototype.isPreviewable=function(){return this.attributes.has(\"previewable\")?this.attributes.get(\"previewable\"):this.constructor.previewablePattern.test(this.getContentType())},i.prototype.getType=function(){return this.hasContent()?\"content\":this.isPreviewable()?\"preview\":\"file\"},i.prototype.getURL=function(){return this.attributes.get(\"url\")},i.prototype.getHref=function(){return this.attributes.get(\"href\")},i.prototype.getFilename=function(){var t;return null!=(t=this.attributes.get(\"filename\"))?t:\"\"},i.prototype.getFilesize=function(){return this.attributes.get(\"filesize\")},i.prototype.getFormattedFilesize=function(){var t;return t=this.attributes.get(\"filesize\"),\"number\"==typeof t?e.config.fileSize.formatter(t):\"\"},i.prototype.getExtension=function(){var t;return null!=(t=this.getFilename().match(/\\.(\\w+)$/))?t[1].toLowerCase():void 0},i.prototype.getContentType=function(){return this.attributes.get(\"contentType\")},i.prototype.hasContent=function(){return this.attributes.has(\"content\")},i.prototype.getContent=function(){return this.attributes.get(\"content\")},i.prototype.getWidth=function(){return this.attributes.get(\"width\")},i.prototype.getHeight=function(){return this.attributes.get(\"height\")},i.prototype.getFile=function(){return this.file},i.prototype.setFile=function(t){return this.file=t,this.isPreviewable()?this.preloadFile():void 0},i.prototype.releaseFile=function(){return this.releasePreloadedFile(),this.file=null},i.prototype.getUploadProgress=function(){var t;return null!=(t=this.uploadProgress)?t:0},i.prototype.setUploadProgress=function(t){var e;return this.uploadProgress!==t?(this.uploadProgress=t,null!=(e=this.uploadProgressDelegate)&&\"function\"==typeof e.attachmentDidChangeUploadProgress?e.attachmentDidChangeUploadProgress(this):void 0):void 0},i.prototype.toJSON=function(){return this.getAttributes()},i.prototype.getCacheKey=function(){return[i.__super__.getCacheKey.apply(this,arguments),this.attributes.getCacheKey(),this.getPreviewURL()].join(\"/\")},i.prototype.getPreviewURL=function(){return this.previewURL||this.preloadingURL},i.prototype.setPreviewURL=function(t){var e,n;return t!==this.getPreviewURL()?(this.previewURL=t,null!=(e=this.previewDelegate)&&\"function\"==typeof e.attachmentDidChangePreviewURL&&e.attachmentDidChangePreviewURL(this),null!=(n=this.delegate)&&\"function\"==typeof n.attachmentDidChangePreviewURL?n.attachmentDidChangePreviewURL(this):void 0):void 0},i.prototype.preloadURL=function(){return this.preload(this.getURL(),this.releaseFile)},i.prototype.preloadFile=function(){return this.file?(this.fileObjectURL=URL.createObjectURL(this.file),this.preload(this.fileObjectURL)):void 0},i.prototype.releasePreloadedFile=function(){return this.fileObjectURL?(URL.revokeObjectURL(this.fileObjectURL),this.fileObjectURL=null):void 0},i.prototype.preload=function(t,n){var o;return t&&t!==this.getPreviewURL()?(this.preloadingURL=t,o=new e.ImagePreloadOperation(t),o.then(function(e){return function(o){var i,r;return r=o.width,i=o.height,e.setAttributes({width:r,height:i}),e.preloadingURL=null,e.setPreviewURL(t),\"function\"==typeof n?n():void 0}}(this))):void 0},i}(e.Object)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Piece=function(n){function o(t,n){null==n&&(n={}),o.__super__.constructor.apply(this,arguments),this.attributes=e.Hash.box(n)}return t(o,n),o.types={},o.registerType=function(t,e){return e.type=t,this.types[t]=e},o.fromJSON=function(t){var e;return(e=this.types[t.type])?e.fromJSON(t):void 0},o.prototype.copyWithAttributes=function(t){return new this.constructor(this.getValue(),t)},o.prototype.copyWithAdditionalAttributes=function(t){return this.copyWithAttributes(this.attributes.merge(t))},o.prototype.copyWithoutAttribute=function(t){return this.copyWithAttributes(this.attributes.remove(t))},o.prototype.copy=function(){return this.copyWithAttributes(this.attributes)},o.prototype.getAttribute=function(t){return this.attributes.get(t)},o.prototype.getAttributesHash=function(){return this.attributes},o.prototype.getAttributes=function(){return this.attributes.toObject()},o.prototype.getCommonAttributes=function(){var t,e,n;return(n=pieceList.getPieceAtIndex(0))?(t=n.attributes,e=t.getKeys(),pieceList.eachPiece(function(n){return e=t.getKeysCommonToHash(n.attributes),t=t.slice(e)}),t.toObject()):{}},o.prototype.hasAttribute=function(t){return this.attributes.has(t)},o.prototype.hasSameStringValueAsPiece=function(t){return null!=t&&this.toString()===t.toString()\n},o.prototype.hasSameAttributesAsPiece=function(t){return null!=t&&(this.attributes===t.attributes||this.attributes.isEqualTo(t.attributes))},o.prototype.isBlockBreak=function(){return!1},o.prototype.isEqualTo=function(t){return o.__super__.isEqualTo.apply(this,arguments)||this.hasSameConstructorAs(t)&&this.hasSameStringValueAsPiece(t)&&this.hasSameAttributesAsPiece(t)},o.prototype.isEmpty=function(){return 0===this.length},o.prototype.isSerializable=function(){return!0},o.prototype.toJSON=function(){return{type:this.constructor.type,attributes:this.getAttributes()}},o.prototype.contentsForInspection=function(){return{type:this.constructor.type,attributes:this.attributes.inspect()}},o.prototype.canBeGrouped=function(){return this.hasAttribute(\"href\")},o.prototype.canBeGroupedWith=function(t){return this.getAttribute(\"href\")===t.getAttribute(\"href\")},o.prototype.getLength=function(){return this.length},o.prototype.canBeConsolidatedWith=function(){return!1},o}(e.Object)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Piece.registerType(\"attachment\",e.AttachmentPiece=function(n){function o(t){this.attachment=t,o.__super__.constructor.apply(this,arguments),this.length=1,this.ensureAttachmentExclusivelyHasAttribute(\"href\")}return t(o,n),o.fromJSON=function(t){return new this(e.Attachment.fromJSON(t.attachment),t.attributes)},o.prototype.ensureAttachmentExclusivelyHasAttribute=function(t){return this.hasAttribute(t)&&this.attachment.hasAttribute(t)?this.attributes=this.attributes.remove(t):void 0},o.prototype.getValue=function(){return this.attachment},o.prototype.isSerializable=function(){return!this.attachment.isPending()},o.prototype.getCaption=function(){var t;return null!=(t=this.attributes.get(\"caption\"))?t:\"\"},o.prototype.getAttributesForAttachment=function(){return this.attributes.slice([\"caption\"])},o.prototype.canBeGrouped=function(){return o.__super__.canBeGrouped.apply(this,arguments)&&!this.attachment.hasAttribute(\"href\")},o.prototype.isEqualTo=function(t){var e;return o.__super__.isEqualTo.apply(this,arguments)&&this.attachment.id===(null!=t&&null!=(e=t.attachment)?e.id:void 0)},o.prototype.toString=function(){return e.OBJECT_REPLACEMENT_CHARACTER},o.prototype.toJSON=function(){var t;return t=o.__super__.toJSON.apply(this,arguments),t.attachment=this.attachment,t},o.prototype.getCacheKey=function(){return[o.__super__.getCacheKey.apply(this,arguments),this.attachment.getCacheKey()].join(\"/\")},o.prototype.toConsole=function(){return JSON.stringify(this.toString())},o}(e.Piece))}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Piece.registerType(\"string\",e.StringPiece=function(e){function n(t){n.__super__.constructor.apply(this,arguments),this.string=t,this.length=this.string.length}return t(n,e),n.fromJSON=function(t){return new this(t.string,t.attributes)},n.prototype.getValue=function(){return this.string},n.prototype.toString=function(){return this.string.toString()},n.prototype.isBlockBreak=function(){return\"\\n\"===this.toString()&&this.getAttribute(\"blockBreak\")===!0},n.prototype.toJSON=function(){var t;return t=n.__super__.toJSON.apply(this,arguments),t.string=this.string,t},n.prototype.canBeConsolidatedWith=function(t){return null!=t&&this.hasSameConstructorAs(t)&&this.hasSameAttributesAsPiece(t)},n.prototype.consolidateWith=function(t){return new this.constructor(this.toString()+t.toString(),this.attributes)},n.prototype.splitAtOffset=function(t){var e,n;return 0===t?(e=null,n=this):t===this.length?(e=this,n=null):(e=new this.constructor(this.string.slice(0,t),this.attributes),n=new this.constructor(this.string.slice(t),this.attributes)),[e,n]},n.prototype.toConsole=function(){var t;return t=this.string,t.length>15&&(t=t.slice(0,14)+\"\\u2026\"),JSON.stringify(t.toString())},n}(e.Piece))}.call(this),function(){var t,n=function(t,e){function n(){this.constructor=t}for(var i in e)o.call(e,i)&&(t[i]=e[i]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},o={}.hasOwnProperty,i=[].slice;t=e.spliceArray,e.SplittableList=function(e){function o(t){null==t&&(t=[]),o.__super__.constructor.apply(this,arguments),this.objects=t.slice(0),this.length=this.objects.length}var r,s,a;return n(o,e),o.box=function(t){return t instanceof this?t:new this(t)},o.prototype.indexOf=function(t){return this.objects.indexOf(t)},o.prototype.splice=function(){var e;return e=1<=arguments.length?i.call(arguments,0):[],new this.constructor(t.apply(null,[this.objects].concat(i.call(e))))},o.prototype.eachObject=function(t){var e,n,o,i,r,s;for(r=this.objects,s=[],n=e=0,o=r.length;o>e;n=++e)i=r[n],s.push(t(i,n));return s},o.prototype.insertObjectAtIndex=function(t,e){return this.splice(e,0,t)},o.prototype.insertSplittableListAtIndex=function(t,e){return this.splice.apply(this,[e,0].concat(i.call(t.objects)))},o.prototype.insertSplittableListAtPosition=function(t,e){var n,o,i;return i=this.splitObjectAtPosition(e),o=i[0],n=i[1],new this.constructor(o).insertSplittableListAtIndex(t,n)},o.prototype.editObjectAtIndex=function(t,e){return this.replaceObjectAtIndex(e(this.objects[t]),t)},o.prototype.replaceObjectAtIndex=function(t,e){return this.splice(e,1,t)},o.prototype.removeObjectAtIndex=function(t){return this.splice(t,1)},o.prototype.getObjectAtIndex=function(t){return this.objects[t]},o.prototype.getSplittableListInRange=function(t){var e,n,o,i;return o=this.splitObjectsAtRange(t),n=o[0],e=o[1],i=o[2],new this.constructor(n.slice(e,i+1))},o.prototype.selectSplittableList=function(t){var e,n;return n=function(){var n,o,i,r;for(i=this.objects,r=[],n=0,o=i.length;o>n;n++)e=i[n],t(e)&&r.push(e);return r}.call(this),new this.constructor(n)},o.prototype.removeObjectsInRange=function(t){var e,n,o,i;return o=this.splitObjectsAtRange(t),n=o[0],e=o[1],i=o[2],new this.constructor(n).splice(e,i-e+1)},o.prototype.transformObjectsInRange=function(t,e){var n,o,i,r,s,a,u;return s=this.splitObjectsAtRange(t),r=s[0],o=s[1],a=s[2],u=function(){var t,s,u;for(u=[],n=t=0,s=r.length;s>t;n=++t)i=r[n],u.push(n>=o&&a>=n?e(i):i);return u}(),new this.constructor(u)},o.prototype.splitObjectsAtRange=function(t){var e,n,o,i,s,u;return i=this.splitObjectAtPosition(a(t)),n=i[0],e=i[1],o=i[2],s=new this.constructor(n).splitObjectAtPosition(r(t)+o),n=s[0],u=s[1],[n,e,u-1]},o.prototype.getObjectAtPosition=function(t){var e,n,o;return o=this.findIndexAndOffsetAtPosition(t),e=o.index,n=o.offset,this.objects[e]},o.prototype.splitObjectAtPosition=function(t){var e,n,o,i,r,s,a,u,c,l;return s=this.findIndexAndOffsetAtPosition(t),e=s.index,r=s.offset,i=this.objects.slice(0),null!=e?0===r?(c=e,l=0):(o=this.getObjectAtIndex(e),a=o.splitAtOffset(r),n=a[0],u=a[1],i.splice(e,1,n,u),c=e+1,l=n.getLength()-r):(c=i.length,l=0),[i,c,l]},o.prototype.consolidate=function(){var t,e,n,o,i,r;for(o=[],i=this.objects[0],r=this.objects.slice(1),t=0,e=r.length;e>t;t++)n=r[t],(\"function\"==typeof i.canBeConsolidatedWith?i.canBeConsolidatedWith(n):void 0)?i=i.consolidateWith(n):(o.push(i),i=n);return null!=i&&o.push(i),new this.constructor(o)},o.prototype.consolidateFromIndexToIndex=function(t,e){var n,o,r;return o=this.objects.slice(0),r=o.slice(t,e+1),n=new this.constructor(r).consolidate().toArray(),this.splice.apply(this,[t,r.length].concat(i.call(n)))},o.prototype.findIndexAndOffsetAtPosition=function(t){var e,n,o,i,r,s,a;for(e=0,a=this.objects,o=n=0,i=a.length;i>n;o=++n){if(s=a[o],r=e+s.getLength(),t>=e&&r>t)return{index:o,offset:t-e};e=r}return{index:null,offset:null}},o.prototype.findPositionAtIndexAndOffset=function(t,e){var n,o,i,r,s,a;for(s=0,a=this.objects,n=o=0,i=a.length;i>o;n=++o)if(r=a[n],t>n)s+=r.getLength();else if(n===t){s+=e;break}return s},o.prototype.getEndPosition=function(){var t,e;return null!=this.endPosition?this.endPosition:this.endPosition=function(){var n,o,i;for(e=0,i=this.objects,n=0,o=i.length;o>n;n++)t=i[n],e+=t.getLength();return e}.call(this)},o.prototype.toString=function(){return this.objects.join(\"\")},o.prototype.toArray=function(){return this.objects.slice(0)},o.prototype.toJSON=function(){return this.toArray()},o.prototype.isEqualTo=function(t){return o.__super__.isEqualTo.apply(this,arguments)||s(this.objects,null!=t?t.objects:void 0)},s=function(t,e){var n,o,i,r,s;if(null==e&&(e=[]),t.length!==e.length)return!1;for(s=!0,o=n=0,i=t.length;i>n;o=++n)r=t[o],s&&!r.isEqualTo(e[o])&&(s=!1);return s},o.prototype.contentsForInspection=function(){var t;return{objects:\"[\"+function(){var e,n,o,i;for(o=this.objects,i=[],e=0,n=o.length;n>e;e++)t=o[e],i.push(t.inspect());return i}.call(this).join(\", \")+\"]\"}},a=function(t){return t[0]},r=function(t){return t[1]},o}(e.Object)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.Text=function(n){function o(t){var n;null==t&&(t=[]),o.__super__.constructor.apply(this,arguments),this.pieceList=new e.SplittableList(function(){var e,o,i;for(i=[],e=0,o=t.length;o>e;e++)n=t[e],n.isEmpty()||i.push(n);return i}())}return t(o,n),o.textForAttachmentWithAttributes=function(t,n){var o;return o=new e.AttachmentPiece(t,n),new this([o])},o.textForStringWithAttributes=function(t,n){var o;return o=new e.StringPiece(t,n),new this([o])},o.fromJSON=function(t){var n,o;return o=function(){var o,i,r;for(r=[],o=0,i=t.length;i>o;o++)n=t[o],r.push(e.Piece.fromJSON(n));return r}(),new this(o)},o.prototype.copy=function(){return this.copyWithPieceList(this.pieceList)},o.prototype.copyWithPieceList=function(t){return new this.constructor(t.consolidate().toArray())},o.prototype.copyUsingObjectMap=function(t){var e,n;return n=function(){var n,o,i,r,s;for(i=this.getPieces(),s=[],n=0,o=i.length;o>n;n++)e=i[n],s.push(null!=(r=t.find(e))?r:e);return s}.call(this),new this.constructor(n)},o.prototype.appendText=function(t){return this.insertTextAtPosition(t,this.getLength())},o.prototype.insertTextAtPosition=function(t,e){return this.copyWithPieceList(this.pieceList.insertSplittableListAtPosition(t.pieceList,e))},o.prototype.removeTextAtRange=function(t){return this.copyWithPieceList(this.pieceList.removeObjectsInRange(t))},o.prototype.replaceTextAtRange=function(t,e){return this.removeTextAtRange(e).insertTextAtPosition(t,e[0])},o.prototype.moveTextFromRangeToPosition=function(t,e){var n,o;if(!(t[0]<=e&&e<=t[1]))return o=this.getTextAtRange(t),n=o.getLength(),t[0]<e&&(e-=n),this.removeTextAtRange(t).insertTextAtPosition(o,e)},o.prototype.addAttributeAtRange=function(t,e,n){var o;return o={},o[t]=e,this.addAttributesAtRange(o,n)},o.prototype.addAttributesAtRange=function(t,e){return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e,function(e){return e.copyWithAdditionalAttributes(t)}))},o.prototype.removeAttributeAtRange=function(t,e){return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e,function(e){return e.copyWithoutAttribute(t)}))},o.prototype.setAttributesAtRange=function(t,e){return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e,function(e){return e.copyWithAttributes(t)}))},o.prototype.getAttributesAtPosition=function(t){var e,n;return null!=(e=null!=(n=this.pieceList.getObjectAtPosition(t))?n.getAttributes():void 0)?e:{}},o.prototype.getCommonAttributes=function(){var t,n;return t=function(){var t,e,o,i;for(o=this.pieceList.toArray(),i=[],t=0,e=o.length;e>t;t++)n=o[t],i.push(n.getAttributes());return i}.call(this),e.Hash.fromCommonAttributesOfObjects(t).toObject()},o.prototype.getCommonAttributesAtRange=function(t){var e;return null!=(e=this.getTextAtRange(t).getCommonAttributes())?e:{}},o.prototype.getExpandedRangeForAttributeAtOffset=function(t,e){var n,o,i;for(n=i=e,o=this.getLength();n>0&&this.getCommonAttributesAtRange([n-1,i])[t];)n--;for(;o>i&&this.getCommonAttributesAtRange([e,i+1])[t];)i++;return[n,i]},o.prototype.getTextAtRange=function(t){return this.copyWithPieceList(this.pieceList.getSplittableListInRange(t))},o.prototype.getStringAtRange=function(t){return this.pieceList.getSplittableListInRange(t).toString()},o.prototype.getStringAtPosition=function(t){return this.getStringAtRange([t,t+1])},o.prototype.startsWithString=function(t){return this.getStringAtRange([0,t.length])===t},o.prototype.endsWithString=function(t){var e;return e=this.getLength(),this.getStringAtRange([e-t.length,e])===t},o.prototype.getAttachmentPieces=function(){var t,e,n,o,i;for(o=this.pieceList.toArray(),i=[],t=0,e=o.length;e>t;t++)n=o[t],null!=n.attachment&&i.push(n);return i},o.prototype.getAttachments=function(){var t,e,n,o,i;for(o=this.getAttachmentPieces(),i=[],t=0,e=o.length;e>t;t++)n=o[t],i.push(n.attachment);return i},o.prototype.getAttachmentAndPositionById=function(t){var e,n,o,i,r,s;for(i=0,r=this.pieceList.toArray(),e=0,n=r.length;n>e;e++){if(o=r[e],(null!=(s=o.attachment)?s.id:void 0)===t)return{attachment:o.attachment,position:i};i+=o.length}return{attachment:null,position:null}},o.prototype.getAttachmentById=function(t){var e,n,o;return o=this.getAttachmentAndPositionById(t),e=o.attachment,n=o.position,e},o.prototype.getRangeOfAttachment=function(t){var e,n;return n=this.getAttachmentAndPositionById(t.id),t=n.attachment,e=n.position,null!=t?[e,e+1]:void 0},o.prototype.updateAttributesForAttachment=function(t,e){var n;return(n=this.getRangeOfAttachment(e))?this.addAttributesAtRange(t,n):this},o.prototype.getLength=function(){return this.pieceList.getEndPosition()},o.prototype.isEmpty=function(){return 0===this.getLength()},o.prototype.isEqualTo=function(t){var e;return o.__super__.isEqualTo.apply(this,arguments)||(null!=t&&null!=(e=t.pieceList)?e.isEqualTo(this.pieceList):void 0)},o.prototype.isBlockBreak=function(){return 1===this.getLength()&&this.pieceList.getObjectAtIndex(0).isBlockBreak()},o.prototype.eachPiece=function(t){return this.pieceList.eachObject(t)},o.prototype.getPieces=function(){return this.pieceList.toArray()},o.prototype.getPieceAtPosition=function(t){return this.pieceList.getObjectAtPosition(t)},o.prototype.contentsForInspection=function(){return{pieceList:this.pieceList.inspect()}},o.prototype.toSerializableText=function(){var t;return t=this.pieceList.selectSplittableList(function(t){return t.isSerializable()}),this.copyWithPieceList(t)},o.prototype.toString=function(){return this.pieceList.toString()},o.prototype.toJSON=function(){return this.pieceList.toJSON()},o.prototype.toConsole=function(){var t;return JSON.stringify(function(){var e,n,o,i;for(o=this.pieceList.toArray(),i=[],e=0,n=o.length;n>e;e++)t=o[e],i.push(JSON.parse(t.toConsole()));return i}.call(this))},o}(e.Object)}.call(this),function(){var t,n,o,i,r,s=function(t,e){function n(){this.constructor=t}for(var o in e)a.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},a={}.hasOwnProperty,u=[].slice,c=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=e.arraysAreEqual,r=e.spliceArray,o=e.getBlockConfig,n=e.getBlockAttributeNames,i=e.getListAttributeNames,e.Block=function(n){function a(t,n){null==t&&(t=new e.Text),null==n&&(n=[]),a.__super__.constructor.apply(this,arguments),this.text=h(t),this.attributes=n}var l,h,p,d,f,g,m,y,v;return s(a,n),a.fromJSON=function(t){var n;return n=e.Text.fromJSON(t.text),new this(n,t.attributes)},a.prototype.isEmpty=function(){return this.text.isBlockBreak()},a.prototype.isEqualTo=function(e){return a.__super__.isEqualTo.apply(this,arguments)||this.text.isEqualTo(null!=e?e.text:void 0)&&t(this.attributes,null!=e?e.attributes:void 0)},a.prototype.copyWithText=function(t){return new this.constructor(t,this.attributes)},a.prototype.copyWithoutText=function(){return this.copyWithText(null)},a.prototype.copyWithAttributes=function(t){return new this.constructor(this.text,t)},a.prototype.copyUsingObjectMap=function(t){var e;return this.copyWithText((e=t.find(this.text))?e:this.text.copyUsingObjectMap(t))},a.prototype.addAttribute=function(t){var e;return e=this.attributes.concat(d(t)),this.copyWithAttributes(e)},a.prototype.removeAttribute=function(t){var e,n;return n=o(t).listAttribute,e=g(g(this.attributes,t),n),this.copyWithAttributes(e)},a.prototype.removeLastAttribute=function(){return this.removeAttribute(this.getLastAttribute())},a.prototype.getLastAttribute=function(){return f(this.attributes)},a.prototype.getAttributes=function(){return this.attributes.slice(0)},a.prototype.getAttributeLevel=function(){return this.attributes.length},a.prototype.getAttributeAtLevel=function(t){return this.attributes[t-1]},a.prototype.hasAttributes=function(){return this.getAttributeLevel()>0},a.prototype.getLastNestableAttribute=function(){return f(this.getNestableAttributes())},a.prototype.getNestableAttributes=function(){var t,e,n,i,r;for(i=this.attributes,r=[],e=0,n=i.length;n>e;e++)t=i[e],o(t).nestable&&r.push(t);return r},a.prototype.getNestingLevel=function(){return this.getNestableAttributes().length},a.prototype.decreaseNestingLevel=function(){var t;return(t=this.getLastNestableAttribute())?this.removeAttribute(t):this},a.prototype.increaseNestingLevel=function(){var t,e,n;return(t=this.getLastNestableAttribute())?(n=this.attributes.lastIndexOf(t),e=r.apply(null,[this.attributes,n+1,0].concat(u.call(d(t)))),this.copyWithAttributes(e)):this},a.prototype.getListItemAttributes=function(){var t,e,n,i,r;for(i=this.attributes,r=[],e=0,n=i.length;n>e;e++)t=i[e],o(t).listAttribute&&r.push(t);return r},a.prototype.isListItem=function(){var t;return null!=(t=o(this.getLastAttribute()))?t.listAttribute:void 0},a.prototype.isTerminalBlock=function(){var t;return null!=(t=o(this.getLastAttribute()))?t.terminal:void 0},a.prototype.breaksOnReturn=function(){var t;return null!=(t=o(this.getLastAttribute()))?t.breakOnReturn:void 0},a.prototype.findLineBreakInDirectionFromPosition=function(t,e){var n,o;return o=this.toString(),n=function(){switch(t){case\"forward\":return o.indexOf(\"\\n\",e);case\"backward\":return o.slice(0,e).lastIndexOf(\"\\n\")}}(),-1!==n?n:void 0},a.prototype.contentsForInspection=function(){return{text:this.text.inspect(),attributes:this.attributes}},a.prototype.toString=function(){return this.text.toString()},a.prototype.toJSON=function(){return{text:this.text,attributes:this.attributes}},a.prototype.getLength=function(){return this.text.getLength()},a.prototype.canBeConsolidatedWith=function(t){return!this.hasAttributes()&&!t.hasAttributes()},a.prototype.consolidateWith=function(t){var n,o;return n=e.Text.textForStringWithAttributes(\"\\n\"),o=this.getTextWithoutBlockBreak().appendText(n),this.copyWithText(o.appendText(t.text))},a.prototype.splitAtOffset=function(t){var e,n;return 0===t?(e=null,n=this):t===this.getLength()?(e=this,n=null):(e=this.copyWithText(this.text.getTextAtRange([0,t])),n=this.copyWithText(this.text.getTextAtRange([t,this.getLength()]))),[e,n]},a.prototype.getBlockBreakPosition=function(){return this.text.getLength()-1},a.prototype.getTextWithoutBlockBreak=function(){return m(this.text)?this.text.getTextAtRange([0,this.getBlockBreakPosition()]):this.text.copy()},a.prototype.canBeGrouped=function(t){return this.attributes[t]},a.prototype.canBeGroupedWith=function(t,e){var n,r,s,a;return s=t.getAttributes(),r=s[e],n=this.attributes[e],n===r&&!(o(n).group===!1&&(a=s[e+1],c.call(i(),a)<0))},h=function(t){return t=v(t),t=l(t)},v=function(t){var n,o,i,r,s,a;return r=!1,a=t.getPieces(),o=2<=a.length?u.call(a,0,n=a.length-1):(n=0,[]),i=a[n++],null==i?t:(o=function(){var t,e,n;for(n=[],t=0,e=o.length;e>t;t++)s=o[t],s.isBlockBreak()?(r=!0,n.push(y(s))):n.push(s);return n}(),r?new e.Text(u.call(o).concat([i])):t)},p=e.Text.textForStringWithAttributes(\"\\n\",{blockBreak:!0}),l=function(t){return m(t)?t:t.appendText(p)},m=function(t){var e,n;return n=t.getLength(),0===n?!1:(e=t.getTextAtRange([n-1,n]),e.isBlockBreak())},y=function(t){return t.copyWithoutAttribute(\"blockBreak\")},d=function(t){var e;return e=o(t).listAttribute,null!=e?[e,t]:[t]},f=function(t){return t.slice(-1)[0]},g=function(t,e){var n;return n=t.lastIndexOf(e),-1===n?t:r(t,n,1)},a}(e.Object)}.call(this),function(){var t,n,o,i,r,s,a,u,c,l=function(t,e){function n(){this.constructor=t}for(var o in e)h.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},h={}.hasOwnProperty,p=[].slice,d=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=e.arraysAreEqual,a=e.normalizeSpaces,r=e.makeElement,u=e.tagName,i=e.getBlockTagNames,c=e.walkTree,o=e.findClosestElementFromNode,n=e.elementContainsNode,s=e.nodeIsAttachmentElement,e.HTMLParser=function(h){function f(t,e){this.html=t,this.referenceElement=(null!=e?e:{}).referenceElement,this.blocks=[],this.blockElements=[],this.processedElements=[]}var g,m,y,v,b,A,C,w,x,E,S,k,R,L,D,O;return l(f,h),g=\"style href src width height class\".split(\" \"),f.parse=function(t,e){var n;return n=new this(t,e),n.parse(),n},f.prototype.getDocument=function(){return e.Document.fromJSON(this.blocks)},f.prototype.parse=function(){var t,e;try{for(this.createHiddenContainer(),t=R(this.html),this.containerElement.innerHTML=t,e=c(this.containerElement,{usingFilter:E});e.nextNode();)this.processNode(e.currentNode);return this.translateBlockElementMarginsToNewlines()}finally{this.removeHiddenContainer()}},f.prototype.createHiddenContainer=function(){return this.referenceElement?(this.containerElement=this.referenceElement.cloneNode(!1),this.containerElement.removeAttribute(\"id\"),this.containerElement.setAttribute(\"data-trix-internal\",\"\"),this.containerElement.style.display=\"none\",this.referenceElement.parentNode.insertBefore(this.containerElement,this.referenceElement.nextSibling)):(this.containerElement=r({tagName:\"div\",style:{display:\"none\"}}),document.body.appendChild(this.containerElement))},f.prototype.removeHiddenContainer=function(){return this.containerElement.parentNode.removeChild(this.containerElement)},R=function(t){var e,n,o,i,r,s,a,u,l,h,f,m,y,v,A,C;for(t=t.replace(/<\\/html[^>]*>[^]*$/i,\"</html>\"),n=document.implementation.createHTMLDocument(\"\"),n.documentElement.innerHTML=t,e=n.body,o=n.head,y=o.querySelectorAll(\"style\"),i=0,a=y.length;a>i;i++)A=y[i],e.appendChild(A);for(m=[],C=c(e);C.nextNode();)switch(f=C.currentNode,f.nodeType){case Node.ELEMENT_NODE:if(b(f))m.push(f);else for(v=p.call(f.attributes),r=0,u=v.length;u>r;r++)h=v[r].name,d.call(g,h)>=0||0===h.indexOf(\"data-trix\")||f.removeAttribute(h);break;case Node.COMMENT_NODE:m.push(f)}for(s=0,l=m.length;l>s;s++)f=m[s],f.parentNode.removeChild(f);return e.innerHTML},b=function(t){return(null!=t?t.nodeType:void 0)!==Node.ELEMENT_NODE||s(t)?void 0:\"script\"===u(t)||\"false\"===t.getAttribute(\"data-trix-serialize\")},E=function(t){return\"style\"===u(t)?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT},f.prototype.processNode=function(t){switch(t.nodeType){case Node.TEXT_NODE:return this.processTextNode(t);case Node.ELEMENT_NODE:return this.appendBlockForElement(t),this.processElement(t)}},f.prototype.appendBlockForElement=function(e){var o,i,r,s;if(r=this.isBlockElement(e),i=n(this.currentBlockElement,e),r&&!this.isBlockElement(e.firstChild)){if(!(this.isInsignificantTextNode(e.firstChild)&&this.isBlockElement(e.firstElementChild)||(o=this.getBlockAttributes(e),i&&t(o,this.currentBlock.attributes))))return this.currentBlock=this.appendBlockForAttributesWithElement(o,e),this.currentBlockElement=e}else if(this.currentBlockElement&&!i&&!r)return(s=this.findParentBlockElement(e))?this.appendBlockForElement(s):(this.currentBlock=this.appendEmptyBlock(),this.currentBlockElement=null)},f.prototype.findParentBlockElement=function(t){var e;for(e=t.parentElement;e&&e!==this.containerElement;){if(this.isBlockElement(e)&&d.call(this.blockElements,e)>=0)return e;e=e.parentElement}return null},f.prototype.processTextNode=function(t){var e,n;return this.isInsignificantTextNode(t)?void 0:(n=t.data,v(t.parentNode)||(n=L(n),D(null!=(e=t.previousSibling)?e.textContent:void 0)&&(n=x(n))),this.appendStringWithAttributes(n,this.getTextAttributes(t.parentNode)))},f.prototype.processElement=function(t){var e,n,o,i,r;if(s(t))return e=A(t),Object.keys(e).length&&(i=this.getTextAttributes(t),this.appendAttachmentWithAttributes(e,i),t.innerHTML=\"\"),this.processedElements.push(t);switch(u(t)){case\"br\":return this.isExtraBR(t)||this.isBlockElement(t.nextSibling)||this.appendStringWithAttributes(\"\\n\",this.getTextAttributes(t)),this.processedElements.push(t);case\"img\":e={url:t.getAttribute(\"src\"),contentType:\"image\"},o=w(t);for(n in o)r=o[n],e[n]=r;return this.appendAttachmentWithAttributes(e,this.getTextAttributes(t)),this.processedElements.push(t);case\"tr\":if(t.parentNode.firstChild!==t)return this.appendStringWithAttributes(\"\\n\");break;case\"td\":if(t.parentNode.firstChild!==t)return this.appendStringWithAttributes(\" | \")}},f.prototype.appendBlockForAttributesWithElement=function(t,e){var n;return this.blockElements.push(e),n=m(t),this.blocks.push(n),n},f.prototype.appendEmptyBlock=function(){return this.appendBlockForAttributesWithElement([],null)},f.prototype.appendStringWithAttributes=function(t,e){return this.appendPiece(k(t,e))},f.prototype.appendAttachmentWithAttributes=function(t,e){return this.appendPiece(S(t,e))},f.prototype.appendPiece=function(t){return 0===this.blocks.length&&this.appendEmptyBlock(),this.blocks[this.blocks.length-1].text.push(t)},f.prototype.appendStringToTextAtIndex=function(t,e){var n,o;return o=this.blocks[e].text,n=o[o.length-1],\"string\"===(null!=n?n.type:void 0)?n.string+=t:o.push(k(t))},f.prototype.prependStringToTextAtIndex=function(t,e){var n,o;return o=this.blocks[e].text,n=o[0],\"string\"===(null!=n?n.type:void 0)?n.string=t+n.string:o.unshift(k(t))},k=function(t,e){var n;return null==e&&(e={}),n=\"string\",t=a(t),{string:t,attributes:e,type:n}},S=function(t,e){var n;return null==e&&(e={}),n=\"attachment\",{attachment:t,attributes:e,type:n}},m=function(t){var e;return null==t&&(t={}),e=[],{text:e,attributes:t}},f.prototype.getTextAttributes=function(t){var n,i,r,a,u,c,l,h,p,d,f,g,m;r={},d=e.config.textAttributes;for(n in d)if(u=d[n],u.tagName&&o(t,{matchingSelector:u.tagName,untilNode:this.containerElement}))r[n]=!0;else if(u.parser&&(m=u.parser(t))){for(i=!1,f=this.findBlockElementAncestors(t),c=0,p=f.length;p>c;c++)if(a=f[c],u.parser(a)===m){i=!0;break}i||(r[n]=m)}if(s(t)&&(l=t.getAttribute(\"data-trix-attributes\"))){g=JSON.parse(l);for(h in g)m=g[h],r[h]=m}return r},f.prototype.getBlockAttributes=function(t){var n,o,i,r;for(o=[];t&&t!==this.containerElement;){r=e.config.blockAttributes;for(n in r)i=r[n],i.parse!==!1&&u(t)===i.tagName&&((\"function\"==typeof i.test?i.test(t):void 0)||!i.test)&&(o.push(n),i.listAttribute&&o.push(i.listAttribute));t=t.parentNode}return o.reverse()},f.prototype.findBlockElementAncestors=function(t){var e,n;for(e=[];t&&t!==this.containerElement;)n=u(t),d.call(i(),n)>=0&&e.push(t),t=t.parentNode;return e},A=function(t){return JSON.parse(t.getAttribute(\"data-trix-attachment\"))},w=function(t){var e,n,o;return o=t.getAttribute(\"width\"),n=t.getAttribute(\"height\"),e={},o&&(e.width=parseInt(o,10)),n&&(e.height=parseInt(n,10)),e},f.prototype.isBlockElement=function(t){var e;if((null!=t?t.nodeType:void 0)===Node.ELEMENT_NODE&&!o(t,{matchingSelector:\"td\",untilNode:this.containerElement}))return e=u(t),d.call(i(),e)>=0||\"block\"===window.getComputedStyle(t).display},f.prototype.isInsignificantTextNode=function(t){return(null!=t?t.nodeType:void 0)===Node.TEXT_NODE&&O(t.data)&&!v(t.parentNode)?!t.previousSibling||this.isBlockElement(t.previousSibling)||!t.nextSibling||this.isBlockElement(t.nextSibling):void 0},f.prototype.isExtraBR=function(t){return\"br\"===u(t)&&this.isBlockElement(t.parentNode)&&t.parentNode.lastChild===t},v=function(t){var e;return e=window.getComputedStyle(t).whiteSpace,\"pre\"===e||\"pre-wrap\"===e||\"pre-line\"===e},f.prototype.translateBlockElementMarginsToNewlines=function(){var t,e,n,o,i,r,s,a;for(e=this.getMarginOfDefaultBlockElement(),s=this.blocks,a=[],o=n=0,i=s.length;i>n;o=++n)t=s[o],(r=this.getMarginOfBlockElementAtIndex(o))&&(r.top>2*e.top&&this.prependStringToTextAtIndex(\"\\n\",o),a.push(r.bottom>2*e.bottom?this.appendStringToTextAtIndex(\"\\n\",o):void 0));return a},f.prototype.getMarginOfBlockElementAtIndex=function(t){var e,n;return!(e=this.blockElements[t])||(n=u(e),d.call(i(),n)>=0||d.call(this.processedElements,e)>=0)?void 0:C(e)},f.prototype.getMarginOfDefaultBlockElement=function(){var t;return t=r(e.config.blockAttributes[\"default\"].tagName),this.containerElement.appendChild(t),C(t)},C=function(t){var e;return e=window.getComputedStyle(t),\"block\"===e.display?{top:parseInt(e.marginTop),bottom:parseInt(e.marginBottom)}:void 0},y=RegExp(\"[^\\\\S\"+e.NON_BREAKING_SPACE+\"]\"),L=function(t){return t.replace(RegExp(\"\"+y.source,\"g\"),\" \").replace(/\\ {2,}/g,\" \")},x=function(t){return t.replace(RegExp(\"^\"+y.source+\"+\"),\"\")},O=function(t){return RegExp(\"^\"+y.source+\"*$\").test(t)},D=function(t){return/\\s$/.test(t)},f}(e.BasicObject)}.call(this),function(){var t,n,o,i,r=function(t,e){function n(){this.constructor=t}for(var o in e)s.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},s={}.hasOwnProperty,a=[].slice,u=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=e.arraysAreEqual,o=e.normalizeRange,i=e.rangeIsCollapsed,n=e.getBlockConfig,e.Document=function(s){function c(t){null==t&&(t=[]),c.__super__.constructor.apply(this,arguments),0===t.length&&(t=[new e.Block]),this.blockList=e.SplittableList.box(t)}var l;return r(c,s),c.fromJSON=function(t){var n,o;return o=function(){var o,i,r;for(r=[],o=0,i=t.length;i>o;o++)n=t[o],r.push(e.Block.fromJSON(n));return r}(),new this(o)},c.fromHTML=function(t,n){return e.HTMLParser.parse(t,n).getDocument()},c.fromString=function(t,n){var o;return o=e.Text.textForStringWithAttributes(t,n),new this([new e.Block(o)])},c.prototype.isEmpty=function(){var t;return 1===this.blockList.length&&(t=this.getBlockAtIndex(0),t.isEmpty()&&!t.hasAttributes())},c.prototype.copy=function(t){var e;return null==t&&(t={}),e=t.consolidateBlocks?this.blockList.consolidate().toArray():this.blockList.toArray(),new this.constructor(e)},c.prototype.copyUsingObjectsFromDocument=function(t){var n;return n=new e.ObjectMap(t.getObjects()),this.copyUsingObjectMap(n)},c.prototype.copyUsingObjectMap=function(t){var e,n,o;return n=function(){var n,i,r,s;for(r=this.getBlocks(),s=[],n=0,i=r.length;i>n;n++)e=r[n],s.push((o=t.find(e))?o:e.copyUsingObjectMap(t));return s}.call(this),new this.constructor(n)},c.prototype.copyWithBaseBlockAttributes=function(t){var e,n,o;return null==t&&(t=[]),o=function(){var o,i,r,s;for(r=this.getBlocks(),s=[],o=0,i=r.length;i>o;o++)n=r[o],e=t.concat(n.getAttributes()),s.push(n.copyWithAttributes(e));return s}.call(this),new this.constructor(o)},c.prototype.replaceBlock=function(t,e){var n;return n=this.blockList.indexOf(t),-1===n?this:new this.constructor(this.blockList.replaceObjectAtIndex(e,n))},c.prototype.insertDocumentAtRange=function(t,e){var n,r,s,a,u,c,l;return r=t.blockList,u=(e=o(e))[0],c=this.locationFromPosition(u),s=c.index,a=c.offset,l=this,n=this.getBlockAtPosition(u),i(e)&&n.isEmpty()&&!n.hasAttributes()?l=new this.constructor(l.blockList.removeObjectAtIndex(s)):n.getBlockBreakPosition()===a&&u++,l=l.removeTextAtRange(e),new this.constructor(l.blockList.insertSplittableListAtPosition(r,u))},c.prototype.mergeDocumentAtRange=function(e,n){var i,r,s,a,u,c,l,h,p,d,f,g;return f=(n=o(n))[0],d=this.locationFromPosition(f),r=this.getBlockAtIndex(d.index).getAttributes(),i=e.getBaseBlockAttributes(),g=r.slice(-i.length),t(i,g)?(l=r.slice(0,-i.length),c=e.copyWithBaseBlockAttributes(l)):c=e.copy({consolidateBlocks:!0}).copyWithBaseBlockAttributes(r),s=c.getBlockCount(),a=c.getBlockAtIndex(0),t(r,a.getAttributes())?(u=a.getTextWithoutBlockBreak(),p=this.insertTextAtRange(u,n),s>1&&(c=new this.constructor(c.getBlocks().slice(1)),h=f+u.getLength(),p=p.insertDocumentAtRange(c,h))):p=this.insertDocumentAtRange(c,n),p},c.prototype.insertTextAtRange=function(t,e){var n,i,r,s,a;return a=(e=o(e))[0],s=this.locationFromPosition(a),i=s.index,r=s.offset,n=this.removeTextAtRange(e),new this.constructor(n.blockList.editObjectAtIndex(i,function(e){return e.copyWithText(e.text.insertTextAtPosition(t,r))}))},c.prototype.removeTextAtRange=function(t){var e,n,r,s,a,u,c,l,h,p,d,f,g,m,y,v,b,A,C,w,x;return p=t=o(t),l=p[0],A=p[1],i(t)?this:(d=this.locationRangeFromRange(t),u=d[0],v=d[1],a=u.index,c=u.offset,s=this.getBlockAtIndex(a),y=v.index,b=v.offset,m=this.getBlockAtIndex(y),f=A-l===1&&s.getBlockBreakPosition()===c&&m.getBlockBreakPosition()!==b&&\"\\n\"===m.text.getStringAtPosition(b),f?r=this.blockList.editObjectAtIndex(y,function(t){return t.copyWithText(t.text.removeTextAtRange([b,b+1]))\n}):(h=s.text.getTextAtRange([0,c]),C=m.text.getTextAtRange([b,m.getLength()]),w=h.appendText(C),g=a!==y&&0===c,x=g&&s.getAttributeLevel()>=m.getAttributeLevel(),n=x?m.copyWithText(w):s.copyWithText(w),e=y+1-a,r=this.blockList.splice(a,e,n)),new this.constructor(r))},c.prototype.moveTextFromRangeToPosition=function(t,e){var n,i,r,s,u,c,l,h,p,d;if(c=t=o(t),p=c[0],r=c[1],e>=p&&r>=e)return this;if(i=this.getDocumentAtRange(t),h=this.removeTextAtRange(t),u=e>p,u&&(e-=i.getLength()),!h.firstBlockInRangeIsEntirelySelected(t)){if(l=i.getBlocks(),s=l[0],n=2<=l.length?a.call(l,1):[],0===n.length?(d=s.getTextWithoutBlockBreak(),u&&(e+=1)):d=s.text,h=h.insertTextAtRange(d,e),0===n.length)return h;i=new this.constructor(n),e+=d.getLength()}return h.insertDocumentAtRange(i,e)},c.prototype.addAttributeAtRange=function(t,e,o){var i;return i=this.blockList,this.eachBlockAtRange(o,function(o,r,s){return i=i.editObjectAtIndex(s,function(){return n(t)?o.addAttribute(t,e):r[0]===r[1]?o:o.copyWithText(o.text.addAttributeAtRange(t,e,r))})}),new this.constructor(i)},c.prototype.addAttribute=function(t,e){var n;return n=this.blockList,this.eachBlock(function(o,i){return n=n.editObjectAtIndex(i,function(){return o.addAttribute(t,e)})}),new this.constructor(n)},c.prototype.removeAttributeAtRange=function(t,e){var o;return o=this.blockList,this.eachBlockAtRange(e,function(e,i,r){return n(t)?o=o.editObjectAtIndex(r,function(){return e.removeAttribute(t)}):i[0]!==i[1]?o=o.editObjectAtIndex(r,function(){return e.copyWithText(e.text.removeAttributeAtRange(t,i))}):void 0}),new this.constructor(o)},c.prototype.updateAttributesForAttachment=function(t,e){var n,o,i,r;return i=(o=this.getRangeOfAttachment(e))[0],n=this.locationFromPosition(i).index,r=this.getTextAtIndex(n),new this.constructor(this.blockList.editObjectAtIndex(n,function(n){return n.copyWithText(r.updateAttributesForAttachment(t,e))}))},c.prototype.removeAttributeForAttachment=function(t,e){var n;return n=this.getRangeOfAttachment(e),this.removeAttributeAtRange(t,n)},c.prototype.insertBlockBreakAtRange=function(t){var n,i,r,s;return s=(t=o(t))[0],r=this.locationFromPosition(s).offset,i=this.removeTextAtRange(t),0===r&&(n=[new e.Block]),new this.constructor(i.blockList.insertSplittableListAtPosition(new e.SplittableList(n),s))},c.prototype.applyBlockAttributeAtRange=function(t,e,o){var i,r,s,a;return s=this.expandRangeToLineBreaksAndSplitBlocks(o),r=s.document,o=s.range,i=n(t),i.listAttribute?(r=r.removeLastListAttributeAtRange(o,{exceptAttributeName:t}),a=r.convertLineBreaksToBlockBreaksInRange(o),r=a.document,o=a.range):r=i.terminal?r.removeLastTerminalAttributeAtRange(o):r.consolidateBlocksAtRange(o),r.addAttributeAtRange(t,e,o)},c.prototype.removeLastListAttributeAtRange=function(t,e){var o;return null==e&&(e={}),o=this.blockList,this.eachBlockAtRange(t,function(t,i,r){var s;if((s=t.getLastAttribute())&&n(s).listAttribute&&s!==e.exceptAttributeName)return o=o.editObjectAtIndex(r,function(){return t.removeAttribute(s)})}),new this.constructor(o)},c.prototype.removeLastTerminalAttributeAtRange=function(t){var e;return e=this.blockList,this.eachBlockAtRange(t,function(t,o,i){var r;if((r=t.getLastAttribute())&&n(r).terminal)return e=e.editObjectAtIndex(i,function(){return t.removeAttribute(r)})}),new this.constructor(e)},c.prototype.firstBlockInRangeIsEntirelySelected=function(t){var e,n,i,r,s,a;return r=t=o(t),a=r[0],e=r[1],n=this.locationFromPosition(a),s=this.locationFromPosition(e),0===n.offset&&n.index<s.index?!0:n.index===s.index?(i=this.getBlockAtIndex(n.index).getLength(),0===n.offset&&s.offset===i):!1},c.prototype.expandRangeToLineBreaksAndSplitBlocks=function(t){var e,n,i,r,s,a,u,c,l;return a=t=o(t),l=a[0],r=a[1],c=this.locationFromPosition(l),i=this.locationFromPosition(r),e=this,u=e.getBlockAtIndex(c.index),null!=(c.offset=u.findLineBreakInDirectionFromPosition(\"backward\",c.offset))&&(s=e.positionFromLocation(c),e=e.insertBlockBreakAtRange([s,s+1]),i.index+=1,i.offset-=e.getBlockAtIndex(c.index).getLength(),c.index+=1),c.offset=0,0===i.offset&&i.index>c.index?(i.index-=1,i.offset=e.getBlockAtIndex(i.index).getBlockBreakPosition()):(n=e.getBlockAtIndex(i.index),\"\\n\"===n.text.getStringAtRange([i.offset-1,i.offset])?i.offset-=1:i.offset=n.findLineBreakInDirectionFromPosition(\"forward\",i.offset),i.offset!==n.getBlockBreakPosition()&&(s=e.positionFromLocation(i),e=e.insertBlockBreakAtRange([s,s+1]))),l=e.positionFromLocation(c),r=e.positionFromLocation(i),t=o([l,r]),{document:e,range:t}},c.prototype.convertLineBreaksToBlockBreaksInRange=function(t){var e,n,i;return n=(t=o(t))[0],i=this.getStringAtRange(t).slice(0,-1),e=this,i.replace(/.*?\\n/g,function(t){return n+=t.length,e=e.insertBlockBreakAtRange([n-1,n])}),{document:e,range:t}},c.prototype.consolidateBlocksAtRange=function(t){var e,n,i,r,s;return i=t=o(t),s=i[0],n=i[1],r=this.locationFromPosition(s).index,e=this.locationFromPosition(n).index,new this.constructor(this.blockList.consolidateFromIndexToIndex(r,e))},c.prototype.getDocumentAtRange=function(t){var e;return t=o(t),e=this.blockList.getSplittableListInRange(t).toArray(),new this.constructor(e)},c.prototype.getStringAtRange=function(t){return this.getDocumentAtRange(t).toString()},c.prototype.getBlockAtIndex=function(t){return this.blockList.getObjectAtIndex(t)},c.prototype.getBlockAtPosition=function(t){var e;return e=this.locationFromPosition(t).index,this.getBlockAtIndex(e)},c.prototype.getTextAtIndex=function(t){var e;return null!=(e=this.getBlockAtIndex(t))?e.text:void 0},c.prototype.getTextAtPosition=function(t){var e;return e=this.locationFromPosition(t).index,this.getTextAtIndex(e)},c.prototype.getPieceAtPosition=function(t){var e,n,o;return o=this.locationFromPosition(t),e=o.index,n=o.offset,this.getTextAtIndex(e).getPieceAtPosition(n)},c.prototype.getCharacterAtPosition=function(t){var e,n,o;return o=this.locationFromPosition(t),e=o.index,n=o.offset,this.getTextAtIndex(e).getStringAtRange([n,n+1])},c.prototype.getLength=function(){return this.blockList.getEndPosition()},c.prototype.getBlocks=function(){return this.blockList.toArray()},c.prototype.getBlockCount=function(){return this.blockList.length},c.prototype.getEditCount=function(){return this.editCount},c.prototype.eachBlock=function(t){return this.blockList.eachObject(t)},c.prototype.eachBlockAtRange=function(t,e){var n,i,r,s,a,u,c,l,h,p,d,f;if(u=t=o(t),d=u[0],r=u[1],p=this.locationFromPosition(d),i=this.locationFromPosition(r),p.index===i.index)return n=this.getBlockAtIndex(p.index),f=[p.offset,i.offset],e(n,f,p.index);for(h=[],a=s=c=p.index,l=i.index;l>=c?l>=s:s>=l;a=l>=c?++s:--s)(n=this.getBlockAtIndex(a))?(f=function(){switch(a){case p.index:return[p.offset,n.text.getLength()];case i.index:return[0,i.offset];default:return[0,n.text.getLength()]}}(),h.push(e(n,f,a))):h.push(void 0);return h},c.prototype.getCommonAttributesAtRange=function(t){var n,r,s;return r=(t=o(t))[0],i(t)?this.getCommonAttributesAtPosition(r):(s=[],n=[],this.eachBlockAtRange(t,function(t,e){return e[0]!==e[1]?(s.push(t.text.getCommonAttributesAtRange(e)),n.push(l(t))):void 0}),e.Hash.fromCommonAttributesOfObjects(s).merge(e.Hash.fromCommonAttributesOfObjects(n)).toObject())},c.prototype.getCommonAttributesAtPosition=function(t){var n,o,i,r,s,a,c,h,p,d;if(p=this.locationFromPosition(t),s=p.index,h=p.offset,i=this.getBlockAtIndex(s),!i)return{};r=l(i),n=i.text.getAttributesAtPosition(h),o=i.text.getAttributesAtPosition(h-1),a=function(){var t,n;t=e.config.textAttributes,n=[];for(c in t)d=t[c],d.inheritable&&n.push(c);return n}();for(c in o)d=o[c],(d===n[c]||u.call(a,c)>=0)&&(r[c]=d);return r},c.prototype.getRangeOfCommonAttributeAtPosition=function(t,e){var n,i,r,s,a,u,c,l,h;return a=this.locationFromPosition(e),r=a.index,s=a.offset,h=this.getTextAtIndex(r),u=h.getExpandedRangeForAttributeAtOffset(t,s),l=u[0],i=u[1],c=this.positionFromLocation({index:r,offset:l}),n=this.positionFromLocation({index:r,offset:i}),o([c,n])},c.prototype.getBaseBlockAttributes=function(){var t,e,n,o,i,r,s;for(t=this.getBlockAtIndex(0).getAttributes(),n=o=1,s=this.getBlockCount();s>=1?s>o:o>s;n=s>=1?++o:--o)e=this.getBlockAtIndex(n).getAttributes(),r=Math.min(t.length,e.length),t=function(){var n,o,s;for(s=[],i=n=0,o=r;(o>=0?o>n:n>o)&&e[i]===t[i];i=o>=0?++n:--n)s.push(e[i]);return s}();return t},l=function(t){var e,n;return n={},(e=t.getLastAttribute())&&(n[e]=!0),n},c.prototype.getAttachmentById=function(t){var e,n,o,i;for(i=this.getAttachments(),n=0,o=i.length;o>n;n++)if(e=i[n],e.id===t)return e},c.prototype.getAttachmentPieces=function(){var t;return t=[],this.blockList.eachObject(function(e){var n;return n=e.text,t=t.concat(n.getAttachmentPieces())}),t},c.prototype.getAttachments=function(){var t,e,n,o,i;for(o=this.getAttachmentPieces(),i=[],t=0,e=o.length;e>t;t++)n=o[t],i.push(n.attachment);return i},c.prototype.getRangeOfAttachment=function(t){var e,n,i,r,s,a,u;for(r=0,s=this.blockList.toArray(),n=e=0,i=s.length;i>e;n=++e){if(a=s[n].text,u=a.getRangeOfAttachment(t))return o([r+u[0],r+u[1]]);r+=a.getLength()}},c.prototype.getLocationRangeOfAttachment=function(t){var e;return e=this.getRangeOfAttachment(t),this.locationRangeFromRange(e)},c.prototype.getAttachmentPieceForAttachment=function(t){var e,n,o,i;for(i=this.getAttachmentPieces(),e=0,n=i.length;n>e;e++)if(o=i[e],o.attachment===t)return o},c.prototype.locationFromPosition=function(t){var e,n;return n=this.blockList.findIndexAndOffsetAtPosition(Math.max(0,t)),null!=n.index?n:(e=this.getBlocks(),{index:e.length-1,offset:e[e.length-1].getLength()})},c.prototype.positionFromLocation=function(t){return this.blockList.findPositionAtIndexAndOffset(t.index,t.offset)},c.prototype.locationRangeFromPosition=function(t){return o(this.locationFromPosition(t))},c.prototype.locationRangeFromRange=function(t){var e,n,i,r;if(t=o(t))return r=t[0],n=t[1],i=this.locationFromPosition(r),e=this.locationFromPosition(n),o([i,e])},c.prototype.rangeFromLocationRange=function(t){var e,n;return t=o(t),e=this.positionFromLocation(t[0]),i(t)||(n=this.positionFromLocation(t[1])),o([e,n])},c.prototype.isEqualTo=function(t){return this.blockList.isEqualTo(null!=t?t.blockList:void 0)},c.prototype.getTexts=function(){var t,e,n,o,i;for(o=this.getBlocks(),i=[],e=0,n=o.length;n>e;e++)t=o[e],i.push(t.text);return i},c.prototype.getPieces=function(){var t,e,n,o,i;for(n=[],o=this.getTexts(),t=0,e=o.length;e>t;t++)i=o[t],n.push.apply(n,i.getPieces());return n},c.prototype.getObjects=function(){return this.getBlocks().concat(this.getTexts()).concat(this.getPieces())},c.prototype.toSerializableDocument=function(){var t;return t=[],this.blockList.eachObject(function(e){return t.push(e.copyWithText(e.text.toSerializableText()))}),new this.constructor(t)},c.prototype.toString=function(){return this.blockList.toString()},c.prototype.toJSON=function(){return this.blockList.toJSON()},c.prototype.toConsole=function(){var t;return JSON.stringify(function(){var e,n,o,i;for(o=this.blockList.toArray(),i=[],e=0,n=o.length;n>e;e++)t=o[e],i.push(JSON.parse(t.text.toConsole()));return i}.call(this))},c}(e.Object)}.call(this),function(){e.LineBreakInsertion=function(){function t(t){var e;this.composition=t,this.document=this.composition.document,e=this.composition.getSelectedRange(),this.startPosition=e[0],this.endPosition=e[1],this.startLocation=this.document.locationFromPosition(this.startPosition),this.endLocation=this.document.locationFromPosition(this.endPosition),this.block=this.document.getBlockAtIndex(this.endLocation.index),this.breaksOnReturn=this.block.breaksOnReturn(),this.previousCharacter=this.block.text.getStringAtPosition(this.endLocation.offset-1),this.nextCharacter=this.block.text.getStringAtPosition(this.endLocation.offset)}return t.prototype.shouldInsertBlockBreak=function(){return this.block.hasAttributes()&&this.block.isListItem()&&!this.block.isEmpty()?0!==this.startLocation.offset:this.breaksOnReturn&&\"\\n\"!==this.nextCharacter},t.prototype.shouldBreakFormattedBlock=function(){return this.block.hasAttributes()&&!this.block.isListItem()&&(this.breaksOnReturn&&\"\\n\"===this.nextCharacter||\"\\n\"===this.previousCharacter)},t.prototype.shouldDecreaseListLevel=function(){return this.block.hasAttributes()&&this.block.isListItem()&&this.block.isEmpty()},t.prototype.shouldPrependListItem=function(){return this.block.isListItem()&&0===this.startLocation.offset&&!this.block.isEmpty()},t.prototype.shouldRemoveLastBlockAttribute=function(){return this.block.hasAttributes()&&!this.block.isListItem()&&this.block.isEmpty()},t}()}.call(this),function(){var t,n,o,i,r,s,a,u,c,l,h=function(t,e){function n(){this.constructor=t}for(var o in e)p.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},p={}.hasOwnProperty;s=e.normalizeRange,c=e.rangesAreEqual,u=e.rangeIsCollapsed,a=e.objectsAreEqual,t=e.arrayStartsWith,l=e.summarizeArrayChange,o=e.getAllAttributeNames,i=e.getBlockConfig,r=e.getTextConfig,n=e.extend,e.Composition=function(p){function d(){this.document=new e.Document,this.attachments=[],this.currentAttributes={},this.revision=0}var f;return h(d,p),d.prototype.setDocument=function(t){var e;return t.isEqualTo(this.document)?void 0:(this.document=t,this.refreshAttachments(),this.revision++,null!=(e=this.delegate)&&\"function\"==typeof e.compositionDidChangeDocument?e.compositionDidChangeDocument(t):void 0)},d.prototype.getSnapshot=function(){return{document:this.document,selectedRange:this.getSelectedRange()}},d.prototype.loadSnapshot=function(t){var n,o,i,r;return n=t.document,r=t.selectedRange,null!=(o=this.delegate)&&\"function\"==typeof o.compositionWillLoadSnapshot&&o.compositionWillLoadSnapshot(),this.setDocument(null!=n?n:new e.Document),this.setSelection(null!=r?r:[0,0]),null!=(i=this.delegate)&&\"function\"==typeof i.compositionDidLoadSnapshot?i.compositionDidLoadSnapshot():void 0},d.prototype.insertText=function(t,e){var n,o,i,r;return r=(null!=e?e:{updatePosition:!0}).updatePosition,o=this.getSelectedRange(),this.setDocument(this.document.insertTextAtRange(t,o)),i=o[0],n=i+t.getLength(),r&&this.setSelection(n),this.notifyDelegateOfInsertionAtRange([i,n])},d.prototype.insertBlock=function(t){var n;return null==t&&(t=new e.Block),n=new e.Document([t]),this.insertDocument(n)},d.prototype.insertDocument=function(t){var n,o,i;return null==t&&(t=new e.Document),o=this.getSelectedRange(),this.setDocument(this.document.insertDocumentAtRange(t,o)),i=o[0],n=i+t.getLength(),this.setSelection(n),this.notifyDelegateOfInsertionAtRange([i,n])},d.prototype.insertString=function(t,n){var o,i;return o=this.getCurrentTextAttributes(),i=e.Text.textForStringWithAttributes(t,o),this.insertText(i,n)},d.prototype.insertBlockBreak=function(){var t,e,n;return e=this.getSelectedRange(),this.setDocument(this.document.insertBlockBreakAtRange(e)),n=e[0],t=n+1,this.setSelection(t),this.notifyDelegateOfInsertionAtRange([n,t])},d.prototype.insertLineBreak=function(){var t,n;return n=new e.LineBreakInsertion(this),n.shouldDecreaseListLevel()?(this.decreaseListLevel(),this.setSelection(n.startPosition)):n.shouldPrependListItem()?(t=new e.Document([n.block.copyWithoutText()]),this.insertDocument(t)):n.shouldInsertBlockBreak()?this.insertBlockBreak():n.shouldRemoveLastBlockAttribute()?this.removeLastBlockAttribute():n.shouldBreakFormattedBlock()?this.breakFormattedBlock(n):this.insertString(\"\\n\")},d.prototype.insertHTML=function(t){var n,o,i,r,s;return s=this.getPosition(),r=this.document.getLength(),n=e.Document.fromHTML(t),this.setDocument(this.document.mergeDocumentAtRange(n,this.getSelectedRange())),o=this.document.getLength(),i=s+(o-r),this.setSelection(i),this.notifyDelegateOfInsertionAtRange([i,i])},d.prototype.replaceHTML=function(t){var n,o,i;return n=e.Document.fromHTML(t).copyUsingObjectsFromDocument(this.document),o=this.getLocationRange({strict:!1}),i=this.document.rangeFromLocationRange(o),this.setDocument(n),this.setSelection(i)},d.prototype.insertFile=function(t){var n,o;return(null!=(o=this.delegate)?o.compositionShouldAcceptFile(t):void 0)?(n=e.Attachment.attachmentForFile(t),this.insertAttachment(n)):void 0},d.prototype.insertFiles=function(t){var n,o,i,r,s,a,u;for(u=new e.Text,r=0,s=t.length;s>r;r++)i=t[r],(null!=(a=this.delegate)?a.compositionShouldAcceptFile(i):void 0)&&(n=e.Attachment.attachmentForFile(i),o=e.Text.textForAttachmentWithAttributes(n,this.currentAttributes),u=u.appendText(o));return this.insertText(u)},d.prototype.insertAttachment=function(t){var n;return n=e.Text.textForAttachmentWithAttributes(t,this.currentAttributes),this.insertText(n)},d.prototype.deleteInDirection=function(t){var e,n,o,i,r,s,a;return i=this.getLocationRange(),r=this.getSelectedRange(),s=u(r),s?o=\"backward\"===t&&0===i[0].offset:a=i[0].index!==i[1].index,o&&this.canDecreaseBlockAttributeLevel()&&(n=this.getBlock(),n.isListItem()?this.decreaseListLevel():this.decreaseBlockAttributeLevel(),this.setSelection(r[0]),n.isEmpty())?!1:(s&&(r=this.getExpandedRangeInDirection(t),\"backward\"===t&&(e=this.getAttachmentAtRange(r))),e?(this.editAttachment(e),!1):(this.setDocument(this.document.removeTextAtRange(r)),this.setSelection(r[0]),o||a?!1:void 0))},d.prototype.moveTextFromRange=function(t){var e;return e=this.getSelectedRange()[0],this.setDocument(this.document.moveTextFromRangeToPosition(t,e)),this.setSelection(e)},d.prototype.removeAttachment=function(t){var e;return(e=this.document.getRangeOfAttachment(t))?(this.stopEditingAttachment(),this.setDocument(this.document.removeTextAtRange(e)),this.setSelection(e[0])):void 0},d.prototype.removeLastBlockAttribute=function(){var t,e,n,o;return n=this.getSelectedRange(),o=n[0],e=n[1],t=this.document.getBlockAtPosition(e),this.removeCurrentAttribute(t.getLastAttribute()),this.setSelection(o)},f=\" \",d.prototype.insertPlaceholder=function(){return this.placeholderPosition=this.getPosition(),this.insertString(f)},d.prototype.selectPlaceholder=function(){return null!=this.placeholderPosition?(this.setSelectedRange([this.placeholderPosition,this.placeholderPosition+f.length]),this.getSelectedRange()):void 0},d.prototype.forgetPlaceholder=function(){return this.placeholderPosition=null},d.prototype.hasCurrentAttribute=function(t){var e;return e=this.currentAttributes[t],null!=e&&e!==!1},d.prototype.toggleCurrentAttribute=function(t){var e;return(e=!this.currentAttributes[t])?this.setCurrentAttribute(t,e):this.removeCurrentAttribute(t)},d.prototype.canSetCurrentAttribute=function(t){return i(t)?this.canSetCurrentBlockAttribute(t):this.canSetCurrentTextAttribute(t)},d.prototype.canSetCurrentTextAttribute=function(t){switch(t){case\"href\":return!this.selectionContainsAttachmentWithAttribute(t);default:return!0}},d.prototype.canSetCurrentBlockAttribute=function(){var t;if(t=this.getBlock())return!t.isTerminalBlock()},d.prototype.setCurrentAttribute=function(t,e){return i(t)?this.setBlockAttribute(t,e):(this.setTextAttribute(t,e),this.currentAttributes[t]=e,this.notifyDelegateOfCurrentAttributesChange())},d.prototype.setTextAttribute=function(t,n){var o,i,r,s;if(i=this.getSelectedRange())return r=i[0],o=i[1],r!==o?this.setDocument(this.document.addAttributeAtRange(t,n,i)):\"href\"===t?(s=e.Text.textForStringWithAttributes(n,{href:n}),this.insertText(s)):void 0},d.prototype.setBlockAttribute=function(t,e){var n,o;if(o=this.getSelectedRange())return this.canSetCurrentAttribute(t)?(n=this.getBlock(),this.setDocument(this.document.applyBlockAttributeAtRange(t,e,o)),this.setSelection(o)):void 0},d.prototype.removeCurrentAttribute=function(t){return i(t)?(this.removeBlockAttribute(t),this.updateCurrentAttributes()):(this.removeTextAttribute(t),delete this.currentAttributes[t],this.notifyDelegateOfCurrentAttributesChange())},d.prototype.removeTextAttribute=function(t){var e;if(e=this.getSelectedRange())return this.setDocument(this.document.removeAttributeAtRange(t,e))},d.prototype.removeBlockAttribute=function(t){var e;if(e=this.getSelectedRange())return this.setDocument(this.document.removeAttributeAtRange(t,e))},d.prototype.canDecreaseNestingLevel=function(){var t;return(null!=(t=this.getBlock())?t.getNestingLevel():void 0)>0},d.prototype.canIncreaseNestingLevel=function(){var e,n,o;if(e=this.getBlock())return(null!=(o=i(e.getLastNestableAttribute()))?o.listAttribute:0)?(n=this.getPreviousBlock())?t(n.getListItemAttributes(),e.getListItemAttributes()):void 0:e.getNestingLevel()>0},d.prototype.decreaseNestingLevel=function(){var t;if(t=this.getBlock())return this.setDocument(this.document.replaceBlock(t,t.decreaseNestingLevel()))},d.prototype.increaseNestingLevel=function(){var t;if(t=this.getBlock())return this.setDocument(this.document.replaceBlock(t,t.increaseNestingLevel()))},d.prototype.canDecreaseBlockAttributeLevel=function(){var t;return(null!=(t=this.getBlock())?t.getAttributeLevel():void 0)>0},d.prototype.decreaseBlockAttributeLevel=function(){var t,e;return(t=null!=(e=this.getBlock())?e.getLastAttribute():void 0)?this.removeCurrentAttribute(t):void 0},d.prototype.decreaseListLevel=function(){var t,e,n,o,i,r;for(r=this.getSelectedRange()[0],i=this.document.locationFromPosition(r).index,n=i,t=this.getBlock().getAttributeLevel();(e=this.document.getBlockAtIndex(n+1))&&e.isListItem()&&e.getAttributeLevel()>t;)n++;return r=this.document.positionFromLocation({index:i,offset:0}),o=this.document.positionFromLocation({index:n,offset:0}),this.setDocument(this.document.removeLastListAttributeAtRange([r,o]))},d.prototype.updateCurrentAttributes=function(){var t,e,n,i,r,s;if(s=this.getSelectedRange({ignoreLock:!0})){for(e=this.document.getCommonAttributesAtRange(s),r=o(),n=0,i=r.length;i>n;n++)t=r[n],e[t]||this.canSetCurrentAttribute(t)||(e[t]=!1);if(!a(e,this.currentAttributes))return this.currentAttributes=e,this.notifyDelegateOfCurrentAttributesChange()}},d.prototype.getCurrentAttributes=function(){return n.call({},this.currentAttributes)},d.prototype.getCurrentTextAttributes=function(){var t,e,n,o;t={},n=this.currentAttributes;for(e in n)o=n[e],r(e)&&(t[e]=o);return t},d.prototype.freezeSelection=function(){return this.setCurrentAttribute(\"frozen\",!0)},d.prototype.thawSelection=function(){return this.removeCurrentAttribute(\"frozen\")},d.prototype.hasFrozenSelection=function(){return this.hasCurrentAttribute(\"frozen\")},d.proxyMethod(\"getSelectionManager().getPointRange\"),d.proxyMethod(\"getSelectionManager().setLocationRangeFromPointRange\"),d.proxyMethod(\"getSelectionManager().locationIsCursorTarget\"),d.proxyMethod(\"getSelectionManager().selectionIsExpanded\"),d.proxyMethod(\"delegate?.getSelectionManager\"),d.prototype.setSelection=function(t){var e,n;return e=this.document.locationRangeFromRange(t),null!=(n=this.delegate)?n.compositionDidRequestChangingSelectionToLocationRange(e):void 0},d.prototype.getSelectedRange=function(){var t;return(t=this.getLocationRange())?this.document.rangeFromLocationRange(t):void 0},d.prototype.setSelectedRange=function(t){var e;return e=this.document.locationRangeFromRange(t),this.getSelectionManager().setLocationRange(e)},d.prototype.getPosition=function(){var t;return(t=this.getLocationRange())?this.document.positionFromLocation(t[0]):void 0},d.prototype.getLocationRange=function(t){var e;return null!=(e=this.getSelectionManager().getLocationRange(t))?e:s({index:0,offset:0})},d.prototype.getExpandedRangeInDirection=function(t){var e,n,o;return n=this.getSelectedRange(),o=n[0],e=n[1],\"backward\"===t?o=this.translateUTF16PositionFromOffset(o,-1):e=this.translateUTF16PositionFromOffset(e,1),s([o,e])},d.prototype.moveCursorInDirection=function(t){var e,n,o,i;return this.editingAttachment?o=this.document.getRangeOfAttachment(this.editingAttachment):(i=this.getSelectedRange(),o=this.getExpandedRangeInDirection(t),n=!c(i,o)),this.setSelectedRange(\"backward\"===t?o[0]:o[1]),n&&(e=this.getAttachmentAtRange(o))?this.editAttachment(e):void 0},d.prototype.expandSelectionInDirection=function(t){var e;return e=this.getExpandedRangeInDirection(t),this.setSelectedRange(e)},d.prototype.expandSelectionForEditing=function(){return this.hasCurrentAttribute(\"href\")?this.expandSelectionAroundCommonAttribute(\"href\"):void 0},d.prototype.expandSelectionAroundCommonAttribute=function(t){var e,n;return e=this.getPosition(),n=this.document.getRangeOfCommonAttributeAtPosition(t,e),this.setSelectedRange(n)},d.prototype.selectionContainsAttachmentWithAttribute=function(t){var e,n,o,i,r;if(r=this.getSelectedRange()){for(i=this.document.getDocumentAtRange(r).getAttachments(),n=0,o=i.length;o>n;n++)if(e=i[n],e.hasAttribute(t))return!0;return!1}},d.prototype.selectionIsInCursorTarget=function(){return this.editingAttachment||this.positionIsCursorTarget(this.getPosition())},d.prototype.positionIsCursorTarget=function(t){var e;return(e=this.document.locationFromPosition(t))?this.locationIsCursorTarget(e):void 0},d.prototype.positionIsBlockBreak=function(t){var e;return null!=(e=this.document.getPieceAtPosition(t))?e.isBlockBreak():void 0},d.prototype.getSelectedDocument=function(){var t;return(t=this.getSelectedRange())?this.document.getDocumentAtRange(t):void 0},d.prototype.getAttachments=function(){return this.attachments.slice(0)},d.prototype.refreshAttachments=function(){var t,e,n,o,i,r,s,a,u,c,h,p;for(n=this.document.getAttachments(),a=l(this.attachments,n),t=a.added,h=a.removed,this.attachments=n,o=0,r=h.length;r>o;o++)e=h[o],e.delegate=null,null!=(u=this.delegate)&&\"function\"==typeof u.compositionDidRemoveAttachment&&u.compositionDidRemoveAttachment(e);for(p=[],i=0,s=t.length;s>i;i++)e=t[i],e.delegate=this,p.push(null!=(c=this.delegate)&&\"function\"==typeof c.compositionDidAddAttachment?c.compositionDidAddAttachment(e):void 0);return p},d.prototype.attachmentDidChangeAttributes=function(t){var e;return this.revision++,null!=(e=this.delegate)&&\"function\"==typeof e.compositionDidEditAttachment?e.compositionDidEditAttachment(t):void 0},d.prototype.attachmentDidChangePreviewURL=function(t){var e;return this.revision++,null!=(e=this.delegate)&&\"function\"==typeof e.compositionDidChangeAttachmentPreviewURL?e.compositionDidChangeAttachmentPreviewURL(t):void 0},d.prototype.editAttachment=function(t){var e;if(t!==this.editingAttachment)return this.stopEditingAttachment(),this.editingAttachment=t,null!=(e=this.delegate)&&\"function\"==typeof e.compositionDidStartEditingAttachment?e.compositionDidStartEditingAttachment(this.editingAttachment):void 0},d.prototype.stopEditingAttachment=function(){var t;if(this.editingAttachment)return null!=(t=this.delegate)&&\"function\"==typeof t.compositionDidStopEditingAttachment&&t.compositionDidStopEditingAttachment(this.editingAttachment),this.editingAttachment=null},d.prototype.canEditAttachmentCaption=function(){var t;return null!=(t=this.editingAttachment)?t.isPreviewable():void 0},d.prototype.updateAttributesForAttachment=function(t,e){return this.setDocument(this.document.updateAttributesForAttachment(t,e))},d.prototype.removeAttributeForAttachment=function(t,e){return this.setDocument(this.document.removeAttributeForAttachment(t,e))},d.prototype.breakFormattedBlock=function(t){var n,o,i,r,s;return o=t.document,n=t.block,r=t.startPosition,s=[r-1,r],n.getBlockBreakPosition()===t.startLocation.offset?(n.breaksOnReturn()&&\"\\n\"===t.nextCharacter?r+=1:o=o.removeTextAtRange(s),s=[r,r]):\"\\n\"===t.nextCharacter?\"\\n\"===t.previousCharacter?s=[r-1,r+1]:(s=[r,r+1],r+=1):t.startLocation.offset-1!==0&&(r+=1),i=new e.Document([n.removeLastAttribute().copyWithoutText()]),this.setDocument(o.insertDocumentAtRange(i,s)),this.setSelection(r)},d.prototype.getPreviousBlock=function(){var t,e;return(e=this.getLocationRange())&&(t=e[0].index,t>0)?this.document.getBlockAtIndex(t-1):void 0},d.prototype.getBlock=function(){var t;return(t=this.getLocationRange())?this.document.getBlockAtIndex(t[0].index):void 0},d.prototype.getAttachmentAtRange=function(t){var n;return n=this.document.getDocumentAtRange(t),n.toString()===e.OBJECT_REPLACEMENT_CHARACTER+\"\\n\"?n.getAttachments()[0]:void 0},d.prototype.notifyDelegateOfCurrentAttributesChange=function(){var t;return null!=(t=this.delegate)&&\"function\"==typeof t.compositionDidChangeCurrentAttributes?t.compositionDidChangeCurrentAttributes(this.currentAttributes):void 0},d.prototype.notifyDelegateOfInsertionAtRange=function(t){var e;return null!=(e=this.delegate)&&\"function\"==typeof e.compositionDidPerformInsertionAtRange?e.compositionDidPerformInsertionAtRange(t):void 0},d.prototype.translateUTF16PositionFromOffset=function(t,e){var n,o;return o=this.document.toUTF16String(),n=o.offsetFromUCS2Offset(t),o.offsetToUCS2Offset(n+e)},d}(e.BasicObject)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.UndoManager=function(e){function n(t){this.composition=t,this.undoEntries=[],this.redoEntries=[]}var o;return t(n,e),n.prototype.recordUndoEntry=function(t,e){var n,i,r,s,a;return s=null!=e?e:{},i=s.context,n=s.consolidatable,r=this.undoEntries.slice(-1)[0],n&&o(r,t,i)?void 0:(a=this.createEntry({description:t,context:i}),this.undoEntries.push(a),this.redoEntries=[])},n.prototype.undo=function(){var t,e;return(e=this.undoEntries.pop())?(t=this.createEntry(e),this.redoEntries.push(t),this.composition.loadSnapshot(e.snapshot)):void 0},n.prototype.redo=function(){var t,e;return(t=this.redoEntries.pop())?(e=this.createEntry(t),this.undoEntries.push(e),this.composition.loadSnapshot(t.snapshot)):void 0},n.prototype.canUndo=function(){return this.undoEntries.length>0},n.prototype.canRedo=function(){return this.redoEntries.length>0},n.prototype.createEntry=function(t){var e,n,o;return o=null!=t?t:{},n=o.description,e=o.context,{description:null!=n?n.toString():void 0,context:JSON.stringify(e),snapshot:this.composition.getSnapshot()}},o=function(t,e,n){return(null!=t?t.description:void 0)===(null!=e?e.toString():void 0)&&(null!=t?t.context:void 0)===JSON.stringify(n)},n}(e.BasicObject)}.call(this),function(){e.Editor=function(){function t(t,n,o){this.composition=t,this.selectionManager=n,this.element=o,this.undoManager=new e.UndoManager(this.composition)}return t.prototype.loadDocument=function(t){return this.loadSnapshot({document:t,selectedRange:[0,0]})},t.prototype.loadHTML=function(t){return null==t&&(t=\"\"),this.loadDocument(e.Document.fromHTML(t,{referenceElement:this.element}))},t.prototype.loadJSON=function(t){var n,o;return n=t.document,o=t.selectedRange,n=e.Document.fromJSON(n),this.loadSnapshot({document:n,selectedRange:o})},t.prototype.loadSnapshot=function(t){return this.undoManager=new e.UndoManager(this.composition),this.composition.loadSnapshot(t)},t.prototype.getDocument=function(){return this.composition.document},t.prototype.getSelectedDocument=function(){return this.composition.getSelectedDocument()},t.prototype.getSnapshot=function(){return this.composition.getSnapshot()},t.prototype.toJSON=function(){return this.getSnapshot()},t.prototype.deleteInDirection=function(t){return this.composition.deleteInDirection(t)},t.prototype.insertAttachment=function(t){return this.composition.insertAttachment(t)},t.prototype.insertDocument=function(t){return this.composition.insertDocument(t)},t.prototype.insertFile=function(t){return this.composition.insertFile(t)},t.prototype.insertHTML=function(t){return this.composition.insertHTML(t)},t.prototype.insertString=function(t){return this.composition.insertString(t)},t.prototype.insertText=function(t){return this.composition.insertText(t)},t.prototype.insertLineBreak=function(){return this.composition.insertLineBreak()},t.prototype.getSelectedRange=function(){return this.composition.getSelectedRange()},t.prototype.getPosition=function(){return this.composition.getPosition()},t.prototype.getClientRectAtPosition=function(t){var e;return e=this.getDocument().locationRangeFromRange([t,t+1]),this.selectionManager.getClientRectAtLocationRange(e)},t.prototype.expandSelectionInDirection=function(t){return this.composition.expandSelectionInDirection(t)},t.prototype.moveCursorInDirection=function(t){return this.composition.moveCursorInDirection(t)},t.prototype.setSelectedRange=function(t){return this.composition.setSelectedRange(t)},t.prototype.activateAttribute=function(t,e){return null==e&&(e=!0),this.composition.setCurrentAttribute(t,e)},t.prototype.attributeIsActive=function(t){return this.composition.hasCurrentAttribute(t)},t.prototype.canActivateAttribute=function(t){return this.composition.canSetCurrentAttribute(t)},t.prototype.deactivateAttribute=function(t){return this.composition.removeCurrentAttribute(t)},t.prototype.canDecreaseNestingLevel=function(){return this.composition.canDecreaseNestingLevel()},t.prototype.canIncreaseNestingLevel=function(){return this.composition.canIncreaseNestingLevel()\n},t.prototype.decreaseNestingLevel=function(){return this.canDecreaseNestingLevel()?this.composition.decreaseNestingLevel():void 0},t.prototype.increaseNestingLevel=function(){return this.canIncreaseNestingLevel()?this.composition.increaseNestingLevel():void 0},t.prototype.canDecreaseIndentationLevel=function(){return this.canDecreaseNestingLevel()},t.prototype.canIncreaseIndentationLevel=function(){return this.canIncreaseNestingLevel()},t.prototype.decreaseIndentationLevel=function(){return this.decreaseNestingLevel()},t.prototype.increaseIndentationLevel=function(){return this.increaseNestingLevel()},t.prototype.canRedo=function(){return this.undoManager.canRedo()},t.prototype.canUndo=function(){return this.undoManager.canUndo()},t.prototype.recordUndoEntry=function(t,e){var n,o,i;return i=null!=e?e:{},o=i.context,n=i.consolidatable,this.undoManager.recordUndoEntry(t,{context:o,consolidatable:n})},t.prototype.redo=function(){return this.canRedo()?this.undoManager.redo():void 0},t.prototype.undo=function(){return this.canUndo()?this.undoManager.undo():void 0},t}()}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.ManagedAttachment=function(e){function n(t,e){var n;this.attachmentManager=t,this.attachment=e,n=this.attachment,this.id=n.id,this.file=n.file}return t(n,e),n.prototype.remove=function(){return this.attachmentManager.requestRemovalOfAttachment(this.attachment)},n.proxyMethod(\"attachment.getAttribute\"),n.proxyMethod(\"attachment.hasAttribute\"),n.proxyMethod(\"attachment.setAttribute\"),n.proxyMethod(\"attachment.getAttributes\"),n.proxyMethod(\"attachment.setAttributes\"),n.proxyMethod(\"attachment.isPending\"),n.proxyMethod(\"attachment.isPreviewable\"),n.proxyMethod(\"attachment.getURL\"),n.proxyMethod(\"attachment.getHref\"),n.proxyMethod(\"attachment.getFilename\"),n.proxyMethod(\"attachment.getFilesize\"),n.proxyMethod(\"attachment.getFormattedFilesize\"),n.proxyMethod(\"attachment.getExtension\"),n.proxyMethod(\"attachment.getContentType\"),n.proxyMethod(\"attachment.getFile\"),n.proxyMethod(\"attachment.setFile\"),n.proxyMethod(\"attachment.releaseFile\"),n.proxyMethod(\"attachment.getUploadProgress\"),n.proxyMethod(\"attachment.setUploadProgress\"),n}(e.BasicObject)}.call(this),function(){var t=function(t,e){function o(){this.constructor=t}for(var i in e)n.call(e,i)&&(t[i]=e[i]);return o.prototype=e.prototype,t.prototype=new o,t.__super__=e.prototype,t},n={}.hasOwnProperty;e.AttachmentManager=function(n){function o(t){var e,n,o;for(null==t&&(t=[]),this.managedAttachments={},n=0,o=t.length;o>n;n++)e=t[n],this.manageAttachment(e)}return t(o,n),o.prototype.getAttachments=function(){var t,e,n,o;n=this.managedAttachments,o=[];for(e in n)t=n[e],o.push(t);return o},o.prototype.manageAttachment=function(t){var n,o;return null!=(n=this.managedAttachments)[o=t.id]?n[o]:n[o]=new e.ManagedAttachment(this,t)},o.prototype.attachmentIsManaged=function(t){return t.id in this.managedAttachments},o.prototype.requestRemovalOfAttachment=function(t){var e;return this.attachmentIsManaged(t)&&null!=(e=this.delegate)&&\"function\"==typeof e.attachmentManagerDidRequestRemovalOfAttachment?e.attachmentManagerDidRequestRemovalOfAttachment(t):void 0},o.prototype.unmanageAttachment=function(t){var e;return e=this.managedAttachments[t.id],delete this.managedAttachments[t.id],e},o}(e.BasicObject)}.call(this),function(){var t,n,o,i,r,s,a,u,c,l,h;t=e.elementContainsNode,n=e.findChildIndexOfNode,r=e.nodeIsBlockStart,s=e.nodeIsBlockStartComment,i=e.nodeIsBlockContainer,a=e.nodeIsCursorTarget,u=e.nodeIsEmptyTextNode,c=e.nodeIsTextNode,o=e.nodeIsAttachmentElement,l=e.tagName,h=e.walkTree,e.LocationMapper=function(){function e(t){this.element=t}var p,d,f,g;return e.prototype.findLocationFromContainerAndOffset=function(e,o,i){var s,u,l,p,g,m,y;for(m=(null!=i?i:{strict:!0}).strict,u=0,l=!1,p={index:0,offset:0},(s=this.findAttachmentElementParentForNode(e))&&(e=s.parentNode,o=n(s)),y=h(this.element,{usingFilter:f});y.nextNode();){if(g=y.currentNode,g===e&&c(e)){a(g)||(p.offset+=o);break}if(g.parentNode===e){if(u++===o)break}else if(!t(e,g)&&u>0)break;r(g,{strict:m})?(l&&p.index++,p.offset=0,l=!0):p.offset+=d(g)}return p},e.prototype.findContainerAndOffsetFromLocation=function(t){var e,o,s,a,u,l;if(0===t.index&&0===t.offset){for(e=this.element,a=0;e.firstChild;)if(e=e.firstChild,i(e)){a=1;break}return[e,a]}if(u=this.findNodeAndOffsetFromLocation(t),o=u[0],s=u[1],o){if(c(o))e=o,l=o.textContent,a=t.offset-s;else{if(e=o.parentNode,!r(o.previousSibling)&&!i(e))for(;o===e.lastChild&&(o=e,e=e.parentNode,!i(e)););a=n(o),0!==t.offset&&a++}return[e,a]}},e.prototype.findNodeAndOffsetFromLocation=function(t){var e,n,o,i,r,s,u,l;for(u=0,l=this.getSignificantNodesForIndex(t.index),n=0,o=l.length;o>n;n++){if(e=l[n],i=d(e),t.offset<=u+i)if(c(e)){if(r=e,s=u,t.offset===s&&a(r))break}else r||(r=e,s=u);if(u+=i,u>t.offset)break}return[r,s]},e.prototype.findAttachmentElementParentForNode=function(t){for(;t&&t!==this.element;){if(o(t))return t;t=t.parentNode}},e.prototype.getSignificantNodesForIndex=function(t){var e,n,o,i,r;for(o=[],r=h(this.element,{usingFilter:p}),i=!1;r.nextNode();)if(n=r.currentNode,s(n)){if(\"undefined\"!=typeof e&&null!==e?e++:e=0,e===t)i=!0;else if(i)break}else i&&o.push(n);return o},d=function(t){var e;return t.nodeType===Node.TEXT_NODE?a(t)?0:(e=t.textContent,e.length):\"br\"===l(t)||o(t)?1:0},p=function(t){return g(t)===NodeFilter.FILTER_ACCEPT?f(t):NodeFilter.FILTER_REJECT},g=function(t){return u(t)?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT},f=function(t){return o(t.parentNode)?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT},e}()}.call(this),function(){var t,n,o=[].slice;t=e.getDOMRange,n=e.setDOMRange,e.PointMapper=function(){function e(){}return e.prototype.createDOMRangeFromPoint=function(e){var o,i,r,s,a,u,c,l;if(c=e.x,l=e.y,document.caretPositionFromPoint)return a=document.caretPositionFromPoint(c,l),r=a.offsetNode,i=a.offset,o=document.createRange(),o.setStart(r,i),o;if(document.caretRangeFromPoint)return document.caretRangeFromPoint(c,l);if(document.body.createTextRange){s=t();try{u=document.body.createTextRange(),u.moveToPoint(c,l),u.select()}catch(h){}return o=t(),n(s),o}},e.prototype.getClientRectsForDOMRange=function(t){var e,n,i;return n=o.call(t.getClientRects()),i=n[0],e=n[n.length-1],[i,e]},e}()}.call(this),function(){var t,n=function(t,e){return function(){return t.apply(e,arguments)}},o=function(t,e){function n(){this.constructor=t}for(var o in e)i.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},i={}.hasOwnProperty,r=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=e.getDOMRange,e.SelectionChangeObserver=function(e){function i(){this.run=n(this.run,this),this.update=n(this.update,this),this.selectionManagers=[]}var s;return o(i,e),i.prototype.start=function(){return this.started?void 0:(this.started=!0,\"onselectionchange\"in document?document.addEventListener(\"selectionchange\",this.update,!0):this.run())},i.prototype.stop=function(){return this.started?(this.started=!1,document.removeEventListener(\"selectionchange\",this.update,!0)):void 0},i.prototype.registerSelectionManager=function(t){return r.call(this.selectionManagers,t)<0?(this.selectionManagers.push(t),this.start()):void 0},i.prototype.unregisterSelectionManager=function(t){var e;return this.selectionManagers=function(){var n,o,i,r;for(i=this.selectionManagers,r=[],n=0,o=i.length;o>n;n++)e=i[n],e!==t&&r.push(e);return r}.call(this),0===this.selectionManagers.length?this.stop():void 0},i.prototype.notifySelectionManagersOfSelectionChange=function(){var t,e,n,o,i;for(n=this.selectionManagers,o=[],t=0,e=n.length;e>t;t++)i=n[t],o.push(i.selectionDidChange());return o},i.prototype.update=function(){var e;return e=t(),s(e,this.domRange)?void 0:(this.domRange=e,this.notifySelectionManagersOfSelectionChange())},i.prototype.reset=function(){return this.domRange=null,this.update()},i.prototype.run=function(){return this.started?(this.update(),requestAnimationFrame(this.run)):void 0},s=function(t,e){return(null!=t?t.startContainer:void 0)===(null!=e?e.startContainer:void 0)&&(null!=t?t.startOffset:void 0)===(null!=e?e.startOffset:void 0)&&(null!=t?t.endContainer:void 0)===(null!=e?e.endContainer:void 0)&&(null!=t?t.endOffset:void 0)===(null!=e?e.endOffset:void 0)},i}(e.BasicObject),null==e.selectionChangeObserver&&(e.selectionChangeObserver=new e.SelectionChangeObserver)}.call(this),function(){var t,n,o,i,r,s,a,u,c,l,h=function(t,e){return function(){return t.apply(e,arguments)}},p=function(t,e){function n(){this.constructor=t}for(var o in e)d.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},d={}.hasOwnProperty;o=e.getDOMSelection,n=e.getDOMRange,l=e.setDOMRange,t=e.elementContainsNode,s=e.nodeIsCursorTarget,r=e.innerElementIsActive,i=e.handleEvent,a=e.normalizeRange,u=e.rangeIsCollapsed,c=e.rangesAreEqual,e.SelectionManager=function(d){function f(t){this.element=t,this.selectionDidChange=h(this.selectionDidChange,this),this.didMouseDown=h(this.didMouseDown,this),this.locationMapper=new e.LocationMapper(this.element),this.pointMapper=new e.PointMapper,this.lockCount=0,i(\"mousedown\",{onElement:this.element,withCallback:this.didMouseDown})}return p(f,d),f.prototype.getLocationRange=function(t){var e,o;return null==t&&(t={}),e=t.strict===!1?this.createLocationRangeFromDOMRange(n(),{strict:!1}):t.ignoreLock?this.currentLocationRange:null!=(o=this.lockedLocationRange)?o:this.currentLocationRange},f.prototype.setLocationRange=function(t){var e;if(!this.lockedLocationRange)return t=a(t),(e=this.createDOMRangeFromLocationRange(t))?(l(e),this.updateCurrentLocationRange(t)):void 0},f.prototype.setLocationRangeFromPointRange=function(t){var e,n;return t=a(t),n=this.getLocationAtPoint(t[0]),e=this.getLocationAtPoint(t[1]),this.setLocationRange([n,e])},f.prototype.getClientRectAtLocationRange=function(t){var e;return(e=this.createDOMRangeFromLocationRange(t))?this.getClientRectsForDOMRange(e)[1]:void 0},f.prototype.locationIsCursorTarget=function(t){var e,n,o;return o=this.findNodeAndOffsetFromLocation(t),e=o[0],n=o[1],s(e)},f.prototype.lock=function(){return 0===this.lockCount++?(this.updateCurrentLocationRange(),this.lockedLocationRange=this.getLocationRange()):void 0},f.prototype.unlock=function(){var t;return 0===--this.lockCount&&(t=this.lockedLocationRange,this.lockedLocationRange=null,null!=t)?this.setLocationRange(t):void 0},f.prototype.clearSelection=function(){var t;return null!=(t=o())?t.removeAllRanges():void 0},f.prototype.selectionIsCollapsed=function(){var t;return(null!=(t=n())?t.collapsed:void 0)===!0},f.prototype.selectionIsExpanded=function(){return!this.selectionIsCollapsed()},f.proxyMethod(\"locationMapper.findLocationFromContainerAndOffset\"),f.proxyMethod(\"locationMapper.findContainerAndOffsetFromLocation\"),f.proxyMethod(\"locationMapper.findNodeAndOffsetFromLocation\"),f.proxyMethod(\"pointMapper.createDOMRangeFromPoint\"),f.proxyMethod(\"pointMapper.getClientRectsForDOMRange\"),f.prototype.didMouseDown=function(){return this.pauseTemporarily()},f.prototype.pauseTemporarily=function(){var e,n,o,r;return this.paused=!0,n=function(e){return function(){var n,i,s;for(e.paused=!1,clearTimeout(r),i=0,s=o.length;s>i;i++)n=o[i],n.destroy();return t(document,e.element)?e.selectionDidChange():void 0}}(this),r=setTimeout(n,200),o=function(){var t,o,r,s;for(r=[\"mousemove\",\"keydown\"],s=[],t=0,o=r.length;o>t;t++)e=r[t],s.push(i(e,{onElement:document,withCallback:n}));return s}()},f.prototype.selectionDidChange=function(){return this.paused||r(this.element)?void 0:this.updateCurrentLocationRange()},f.prototype.updateCurrentLocationRange=function(t){var e;return(null!=t?t:t=this.createLocationRangeFromDOMRange(n()))&&!c(t,this.currentLocationRange)?(this.currentLocationRange=t,null!=(e=this.delegate)&&\"function\"==typeof e.locationRangeDidChange?e.locationRangeDidChange(this.currentLocationRange.slice(0)):void 0):void 0},f.prototype.createDOMRangeFromLocationRange=function(t){var e,n,o,i;return o=this.findContainerAndOffsetFromLocation(t[0]),n=u(t)?o:null!=(i=this.findContainerAndOffsetFromLocation(t[1]))?i:o,null!=o&&null!=n?(e=document.createRange(),e.setStart.apply(e,o),e.setEnd.apply(e,n),e):void 0},f.prototype.createLocationRangeFromDOMRange=function(t,e){var n,o;if(null!=t&&this.domRangeWithinElement(t)&&(o=this.findLocationFromContainerAndOffset(t.startContainer,t.startOffset,e)))return t.collapsed||(n=this.findLocationFromContainerAndOffset(t.endContainer,t.endOffset,e)),a([o,n])},f.prototype.getLocationAtPoint=function(t){var e,n;return(e=this.createDOMRangeFromPoint(t))&&null!=(n=this.createLocationRangeFromDOMRange(e))?n[0]:void 0},f.prototype.domRangeWithinElement=function(e){return e.collapsed?t(this.element,e.startContainer):t(this.element,e.startContainer)&&t(this.element,e.endContainer)},f}(e.BasicObject)}.call(this),function(){var t,n,o,i=function(t,e){function n(){this.constructor=t}for(var o in e)r.call(e,o)&&(t[o]=e[o]);return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},r={}.hasOwnProperty,s=[].slice;n=e.rangeIsCollapsed,o=e.rangesAreEqual,t=e.objectsAreEqual,e.EditorController=function(r){function a(t){var n,o;this.editorElement=t.editorElement,n=t.document,o=t.html,this.selectionManager=new e.SelectionManager(this.editorElement),this.selectionManager.delegate=this,this.composition=new e.Composition,this.composition.delegate=this,this.attachmentManager=new e.AttachmentManager(this.composition.getAttachments()),this.attachmentManager.delegate=this,this.inputController=new e.InputController(this.editorElement),this.inputController.delegate=this,this.inputController.responder=this.composition,this.compositionController=new e.CompositionController(this.editorElement,this.composition),this.compositionController.delegate=this,this.toolbarController=new e.ToolbarController(this.editorElement.toolbarElement),this.toolbarController.delegate=this,this.editor=new e.Editor(this.composition,this.selectionManager,this.editorElement),null!=n?this.editor.loadDocument(n):this.editor.loadHTML(o)}return i(a,r),a.prototype.registerSelectionManager=function(){return e.selectionChangeObserver.registerSelectionManager(this.selectionManager)},a.prototype.unregisterSelectionManager=function(){return e.selectionChangeObserver.unregisterSelectionManager(this.selectionManager)},a.prototype.compositionDidChangeDocument=function(){return this.editorElement.notify(\"document-change\"),this.handlingInput?void 0:this.render()},a.prototype.compositionDidChangeCurrentAttributes=function(t){return this.currentAttributes=t,this.toolbarController.updateAttributes(this.currentAttributes),this.updateCurrentActions(),this.editorElement.notify(\"attributes-change\",{attributes:this.currentAttributes})},a.prototype.compositionDidPerformInsertionAtRange=function(t){return this.pasting?this.pastedRange=t:void 0},a.prototype.compositionShouldAcceptFile=function(t){return this.editorElement.notify(\"file-accept\",{file:t})},a.prototype.compositionDidAddAttachment=function(t){var e;return e=this.attachmentManager.manageAttachment(t),this.editorElement.notify(\"attachment-add\",{attachment:e})},a.prototype.compositionDidEditAttachment=function(t){var e;return this.compositionController.rerenderViewForObject(t),e=this.attachmentManager.manageAttachment(t),this.editorElement.notify(\"attachment-edit\",{attachment:e}),this.editorElement.notify(\"change\")},a.prototype.compositionDidChangeAttachmentPreviewURL=function(t){return this.compositionController.invalidateViewForObject(t),this.editorElement.notify(\"change\")},a.prototype.compositionDidRemoveAttachment=function(t){var e;return e=this.attachmentManager.unmanageAttachment(t),this.editorElement.notify(\"attachment-remove\",{attachment:e})},a.prototype.compositionDidStartEditingAttachment=function(t){return this.attachmentLocationRange=this.composition.document.getLocationRangeOfAttachment(t),this.compositionController.installAttachmentEditorForAttachment(t),this.selectionManager.setLocationRange(this.attachmentLocationRange)},a.prototype.compositionDidStopEditingAttachment=function(){return this.compositionController.uninstallAttachmentEditor(),this.attachmentLocationRange=null},a.prototype.compositionDidRequestChangingSelectionToLocationRange=function(t){return!this.loadingSnapshot||this.isFocused()?(this.requestedLocationRange=t,this.compositionRevisionWhenLocationRangeRequested=this.composition.revision,this.handlingInput?void 0:this.render()):void 0},a.prototype.compositionWillLoadSnapshot=function(){return this.loadingSnapshot=!0},a.prototype.compositionDidLoadSnapshot=function(){return this.compositionController.refreshViewCache(),this.render(),this.loadingSnapshot=!1},a.prototype.getSelectionManager=function(){return this.selectionManager},a.proxyMethod(\"getSelectionManager().setLocationRange\"),a.proxyMethod(\"getSelectionManager().getLocationRange\"),a.prototype.attachmentManagerDidRequestRemovalOfAttachment=function(t){return this.removeAttachment(t)},a.prototype.compositionControllerWillSyncDocumentView=function(){return this.inputController.editorWillSyncDocumentView(),this.selectionManager.lock(),this.selectionManager.clearSelection()},a.prototype.compositionControllerDidSyncDocumentView=function(){return this.inputController.editorDidSyncDocumentView(),this.selectionManager.unlock(),this.updateCurrentActions(),this.editorElement.notify(\"sync\")},a.prototype.compositionControllerDidRender=function(){return null!=this.requestedLocationRange&&(this.compositionRevisionWhenLocationRangeRequested===this.composition.revision&&this.selectionManager.setLocationRange(this.requestedLocationRange),this.requestedLocationRange=null,this.compositionRevisionWhenLocationRangeRequested=null),this.renderedCompositionRevision!==this.composition.revision&&(this.composition.updateCurrentAttributes(),this.editorElement.notify(\"render\")),this.renderedCompositionRevision=this.composition.revision},a.prototype.compositionControllerDidFocus=function(){return this.toolbarController.hideDialog(),this.editorElement.notify(\"focus\")},a.prototype.compositionControllerDidBlur=function(){return this.editorElement.notify(\"blur\")},a.prototype.compositionControllerDidSelectAttachment=function(t){return this.composition.editAttachment(t)},a.prototype.compositionControllerDidRequestDeselectingAttachment=function(t){var e,n;return e=null!=(n=this.attachmentLocationRange)?n:this.composition.document.getLocationRangeOfAttachment(t),this.selectionManager.setLocationRange(e[1])},a.prototype.compositionControllerWillUpdateAttachment=function(t){return this.editor.recordUndoEntry(\"Edit Attachment\",{context:t.id,consolidatable:!0})},a.prototype.compositionControllerDidRequestRemovalOfAttachment=function(t){return this.removeAttachment(t)},a.prototype.inputControllerWillHandleInput=function(){return this.handlingInput=!0,this.requestedRender=!1},a.prototype.inputControllerDidRequestRender=function(){return this.requestedRender=!0},a.prototype.inputControllerDidHandleInput=function(){return this.handlingInput=!1,this.requestedRender?(this.requestedRender=!1,this.render()):void 0},a.prototype.inputControllerDidAllowUnhandledInput=function(){return this.editorElement.notify(\"change\")},a.prototype.inputControllerDidRequestReparse=function(){return this.reparse()},a.prototype.inputControllerWillPerformTyping=function(){return this.recordTypingUndoEntry()},a.prototype.inputControllerWillCutText=function(){return this.editor.recordUndoEntry(\"Cut\")},a.prototype.inputControllerWillPasteText=function(){return this.editor.recordUndoEntry(\"Paste\"),this.pasting=!0},a.prototype.inputControllerDidPaste=function(t){var e;return e=this.pastedRange,this.pastedRange=null,this.pasting=null,this.editorElement.notify(\"paste\",{pasteData:t,range:e})},a.prototype.inputControllerWillMoveText=function(){return this.editor.recordUndoEntry(\"Move\")},a.prototype.inputControllerWillAttachFiles=function(){return this.editor.recordUndoEntry(\"Drop Files\")},a.prototype.inputControllerDidReceiveKeyboardCommand=function(t){return this.toolbarController.applyKeyboardCommand(t)},a.prototype.inputControllerDidStartDrag=function(){return this.locationRangeBeforeDrag=this.selectionManager.getLocationRange()},a.prototype.inputControllerDidReceiveDragOverPoint=function(t){return this.selectionManager.setLocationRangeFromPointRange(t)},a.prototype.inputControllerDidCancelDrag=function(){return this.selectionManager.setLocationRange(this.locationRangeBeforeDrag),this.locationRangeBeforeDrag=null},a.prototype.locationRangeDidChange=function(t){return this.composition.updateCurrentAttributes(),this.updateCurrentActions(),this.attachmentLocationRange&&!o(this.attachmentLocationRange,t)&&this.composition.stopEditingAttachment(),this.editorElement.notify(\"selection-change\")},a.prototype.toolbarDidClickButton=function(){return this.getLocationRange()?void 0:this.setLocationRange({index:0,offset:0})},a.prototype.toolbarDidInvokeAction=function(t){return this.invokeAction(t)},a.prototype.toolbarDidToggleAttribute=function(t){return this.recordFormattingUndoEntry(),this.composition.toggleCurrentAttribute(t),this.render(),this.selectionFrozen?void 0:this.editorElement.focus()},a.prototype.toolbarDidUpdateAttribute=function(t,e){return this.recordFormattingUndoEntry(),this.composition.setCurrentAttribute(t,e),this.render(),this.selectionFrozen?void 0:this.editorElement.focus()},a.prototype.toolbarDidRemoveAttribute=function(t){return this.recordFormattingUndoEntry(),this.composition.removeCurrentAttribute(t),this.render(),this.selectionFrozen?void 0:this.editorElement.focus()},a.prototype.toolbarWillShowDialog=function(){return this.composition.expandSelectionForEditing(),this.freezeSelection()},a.prototype.toolbarDidShowDialog=function(t){return this.editorElement.notify(\"toolbar-dialog-show\",{dialogName:t})},a.prototype.toolbarDidHideDialog=function(t){return this.thawSelection(),this.editorElement.focus(),this.editorElement.notify(\"toolbar-dialog-hide\",{dialogName:t})},a.prototype.freezeSelection=function(){return this.selectionFrozen?void 0:(this.selectionManager.lock(),this.composition.freezeSelection(),this.selectionFrozen=!0,this.render())},a.prototype.thawSelection=function(){return this.selectionFrozen?(this.composition.thawSelection(),this.selectionManager.unlock(),this.selectionFrozen=!1,this.render()):void 0},a.prototype.actions={undo:{test:function(){return this.editor.canUndo()},perform:function(){return this.editor.undo()}},redo:{test:function(){return this.editor.canRedo()},perform:function(){return this.editor.redo()}},link:{test:function(){return this.editor.canActivateAttribute(\"href\")}},increaseNestingLevel:{test:function(){return this.editor.canIncreaseNestingLevel()},perform:function(){return this.editor.increaseNestingLevel()&&this.render()}},decreaseNestingLevel:{test:function(){return this.editor.canDecreaseNestingLevel()},perform:function(){return this.editor.decreaseNestingLevel()&&this.render()}},increaseBlockLevel:{test:function(){return this.editor.canIncreaseNestingLevel()},perform:function(){return this.editor.increaseNestingLevel()&&this.render()}},decreaseBlockLevel:{test:function(){return this.editor.canDecreaseNestingLevel()},perform:function(){return this.editor.decreaseNestingLevel()&&this.render()}}},a.prototype.canInvokeAction=function(t){var e,n;return this.actionIsExternal(t)?!0:!!(null!=(e=this.actions[t])&&null!=(n=e.test)?n.call(this):void 0)},a.prototype.invokeAction=function(t){var e,n;return this.actionIsExternal(t)?this.editorElement.notify(\"action-invoke\",{actionName:t}):null!=(e=this.actions[t])&&null!=(n=e.perform)?n.call(this):void 0},a.prototype.actionIsExternal=function(t){return/^x-./.test(t)},a.prototype.getCurrentActions=function(){var t,e;e={};for(t in this.actions)e[t]=this.canInvokeAction(t);return e},a.prototype.updateCurrentActions=function(){var e;return e=this.getCurrentActions(),t(e,this.currentActions)?void 0:(this.currentActions=e,this.toolbarController.updateActions(this.currentActions),this.editorElement.notify(\"actions-change\",{actions:this.currentActions}))},a.prototype.reparse=function(){return this.composition.replaceHTML(this.editorElement.innerHTML)},a.prototype.render=function(){return this.compositionController.render()},a.prototype.removeAttachment=function(t){return this.editor.recordUndoEntry(\"Delete Attachment\"),this.composition.removeAttachment(t),this.render()},a.prototype.recordFormattingUndoEntry=function(){var t;return t=this.selectionManager.getLocationRange(),n(t)?void 0:this.editor.recordUndoEntry(\"Formatting\",{context:this.getUndoContext(),consolidatable:!0})},a.prototype.recordTypingUndoEntry=function(){return this.editor.recordUndoEntry(\"Typing\",{context:this.getUndoContext(this.currentAttributes),consolidatable:!0})},a.prototype.getUndoContext=function(){var t;return t=1<=arguments.length?s.call(arguments,0):[],[this.getLocationContext(),this.getTimeContext()].concat(s.call(t))},a.prototype.getLocationContext=function(){var t;return t=this.selectionManager.getLocationRange(),n(t)?t[0].index:t},a.prototype.getTimeContext=function(){return e.config.undoInterval>0?Math.floor((new Date).getTime()/e.config.undoInterval):0},a.prototype.isFocused=function(){var t;return this.editorElement===(null!=(t=this.editorElement.ownerDocument)?t.activeElement:void 0)},a}(e.Controller)}.call(this),function(){var t,n,o,i,r,s;i=e.makeElement,r=e.selectionElements,s=e.triggerEvent,n=e.handleEvent,o=e.handleEventOnce,t=e.AttachmentView.attachmentSelector,e.registerElement(\"trix-editor\",function(){var a,u,c,l,h,p;return l=0,a=function(t){return!document.querySelector(\":focus\")&&t.hasAttribute(\"autofocus\")&&document.querySelector(\"[autofocus]\")===t?t.focus():void 0},h=function(t){return t.hasAttribute(\"contenteditable\")?void 0:(t.setAttribute(\"contenteditable\",\"\"),o(\"focus\",{onElement:t,withCallback:function(){return u(t)}}))},u=function(t){return c(t),p(t)},c=function(t){return(\"function\"==typeof document.queryCommandSupported?document.queryCommandSupported(\"enableObjectResizing\"):void 0)?(document.execCommand(\"enableObjectResizing\",!1,!1),n(\"mscontrolselect\",{onElement:t,preventDefault:!0})):void 0},p=function(){var t;return(\"function\"==typeof document.queryCommandSupported?document.queryCommandSupported(\"DefaultParagraphSeparator\"):void 0)&&(t=e.config.blockAttributes[\"default\"].tagName,\"div\"===t||\"p\"===t)?document.execCommand(\"DefaultParagraphSeparator\",!1,t):void 0},{defaultCSS:\"%t:empty:not(:focus)::before {\\n  content: attr(placeholder);\\n  color: graytext;\\n}\\n\\n%t a[contenteditable=false] {\\n  cursor: text;\\n}\\n\\n%t img {\\n  max-width: 100%;\\n  height: auto;\\n}\\n\\n%t \"+t+\" figcaption textarea {\\n  resize: none;\\n}\\n\\n%t \"+t+\" figcaption textarea.trix-autoresize-clone {\\n  position: absolute;\\n  left: -9999px;\\n  max-height: 0px;\\n}\\n\\n%t \"+t+'[data-trix-mutable] figcaption:empty::before {\\n  content: \"'+e.config.lang.captionPrompt+'\";\\n  color: graytext;\\n}\\n\\n%t '+r.selector+\" { \"+r.cssText+\" }\",trixId:{get:function(){return this.hasAttribute(\"trix-id\")?this.getAttribute(\"trix-id\"):(this.setAttribute(\"trix-id\",++l),this.trixId)}},toolbarElement:{get:function(){var t,e,n;return this.hasAttribute(\"toolbar\")?null!=(e=this.ownerDocument)?e.getElementById(this.getAttribute(\"toolbar\")):void 0:this.parentElement?(n=\"trix-toolbar-\"+this.trixId,this.setAttribute(\"toolbar\",n),t=i(\"trix-toolbar\",{id:n}),this.parentElement.insertBefore(t,this),t):void 0}},inputElement:{get:function(){var t,e,n;return this.hasAttribute(\"input\")?null!=(n=this.ownerDocument)?n.getElementById(this.getAttribute(\"input\")):void 0:this.parentElement?(e=\"trix-input-\"+this.trixId,this.setAttribute(\"input\",e),t=i(\"input\",{type:\"hidden\",id:e}),this.parentElement.insertBefore(t,this.nextElementSibling),t):void 0}},editor:{get:function(){var t;return null!=(t=this.editorController)?t.editor:void 0}},name:{get:function(){var t;return null!=(t=this.inputElement)?t.name:void 0}},value:{get:function(){var t;return null!=(t=this.inputElement)?t.value:void 0},set:function(t){var e;return this.defaultValue=t,null!=(e=this.editor)?e.loadHTML(this.defaultValue):void 0}},notify:function(t,n){var o;switch(t){case\"document-change\":this.documentChangedSinceLastRender=!0;break;case\"render\":this.documentChangedSinceLastRender&&(this.documentChangedSinceLastRender=!1,this.notify(\"change\"));break;case\"change\":case\"attachment-add\":case\"attachment-edit\":case\"attachment-remove\":null!=(o=this.inputElement)&&(o.value=e.serializeToContentType(this,\"text/html\"))}return this.editorController?s(\"trix-\"+t,{onElement:this,attributes:n}):void 0},createdCallback:function(){return h(this)},attachedCallback:function(){return this.hasAttribute(\"data-trix-internal\")?void 0:(null==this.editorController&&(this.editorController=new e.EditorController({editorElement:this,html:this.defaultValue=this.value})),this.editorController.registerSelectionManager(),this.registerResetListener(),a(this),requestAnimationFrame(function(t){return function(){return t.notify(\"initialize\")}}(this)))},detachedCallback:function(){var t;return null!=(t=this.editorController)&&t.unregisterSelectionManager(),this.unregisterResetListener()},registerResetListener:function(){return this.resetListener=this.resetBubbled.bind(this),window.addEventListener(\"reset\",this.resetListener,!1)},unregisterResetListener:function(){return window.removeEventListener(\"reset\",this.resetListener,!1)},resetBubbled:function(t){var e;return t.target!==(null!=(e=this.inputElement)?e.form:void 0)||t.defaultPrevented?void 0:this.reset()},reset:function(){return this.value=this.defaultValue}}}())}.call(this),function(){}.call(this)}).call(this),\"object\"==typeof module&&module.exports?module.exports=e:\"function\"==typeof define&&define.amd&&define(e)}.call(this);"

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"editable-field field-block-line editable-field--date\" tabindex=\"0\">\n    <div class=\"grid-item\" ng-hide=\"$ctrl.editMode\" ng-bind=\"$ctrl.formattedDate || 'Enter Key Date'\" ng-click=\"$ctrl.setEditMode(true)\"></div>\n    <input class=\"editable-input\" ng-show=\"$ctrl.editMode\" type=\"text\" placeholder=\"Enter Key Date\" ng-change=\"$ctrl.update($ctrl.newDate)\" ng-keyup=\"$ctrl.handleUpdate($event)\" ng-model-options=\"{debounce: 250}\" ng-model=\"$ctrl.newDate\" />\n    <div class=\"input-context-menu\" ng-show=\"$ctrl.editMode\">\n      <div class=\"input-context-menu--header\">\n        <div ng-show=\"!$ctrl.parsedDate[0].year\">Write a date in the <b>smart date field</b></div>\n        <div ng-show=\"$ctrl.parsedDate[0].year\">\n            <div class=\"grid\">\n                <div style=\"padding: 0 0.5em\" class=\"grid-item grid-item-1of9 text-right\">\n                    {{ $ctrl.parsedDate[1] ? 'From' \n                        : $ctrl.parsedDate[0].comparator === -1 ? 'Before' \n                        : $ctrl.parsedDate[0].comparator === 1 ? 'After'\n                        : 'Date'}}\n                </div>\n                <div class=\"grid-item grid-item-2of3\">\n                    <div class=\"grid text-center is-relative-full\">\n                        <div class=\"label-container label--background disabled grid is-absolute-full\">\n                            <div class=\"grid-item-1of6\">--</div>\n                            <div class=\"grid-item-1of6\">--</div>\n                            <div class=\"grid-item-1of6\">--</div>\n                            <div class=\"grid-item-1of6\">--</div>\n                            <div class=\"grid-item-1of6\">--</div>\n                            <div class=\"grid-item-1of6\">--</div>\n                        </div>\n                        <div class=\"label-container grid is-relative-full\">\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[0].year\">\n                                {{ $ctrl.parsedDate[0].year }}\n                            </div>\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[0].month\">\n                                {{ $ctrl.parsedDate[0].month }}\n                            </div>\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[0].date\">\n                                {{ $ctrl.parsedDate[0].date }}\n                            </div>\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[0].hour\">\n                                {{ $ctrl.parsedDate[0].hour }}\n                            </div>\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[0].minute\">\n                                {{ $ctrl.parsedDate[0].minute }}\n                            </div>\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[0].second\">\n                                {{ $ctrl.parsedDate[0].second }}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div style=\"padding: 0 0.5em\" class=\"grid-item grid-item-1of9 grid-item-offset-1of9 text-right\">\n                    <span class=\"label\" ng-show=\"$ctrl.parsedDate[0].year\" ng-class=\"{true: 'label-green', false: 'label-red'}[$ctrl.isValid]\">{{$ctrl.isValid ? 'Valid' : 'Invalid'}}</span>\n                </div>\n            </div>\n            <div class=\"grid\" ng-show=\"$ctrl.parsedDate[1].year\">\n                <div style=\"padding: 0 0.5em\" class=\"grid-item grid-item-1of9 text-right\">\n                    {{ $ctrl.parsedDate[1] ? 'To' : '' }}\n                </div>\n                <div class=\"grid-item grid-item-2of3\">\n                    <div class=\"grid text-center is-relative-full\">\n                        <div class=\"label-container label--background disabled grid is-absolute-full\">\n                            <div class=\"grid-item-1of6\">--</div>\n                            <div class=\"grid-item-1of6\">--</div>\n                            <div class=\"grid-item-1of6\">--</div>\n                            <div class=\"grid-item-1of6\">--</div>\n                            <div class=\"grid-item-1of6\">--</div>\n                            <div class=\"grid-item-1of6\">--</div>\n                        </div>\n                        <div class=\"label-container grid is-relative-full\">\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[1].year\">\n                                {{ $ctrl.parsedDate[1].year }}\n                            </div>\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[1].month\">\n                                {{ $ctrl.parsedDate[1].month }}\n                            </div>\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[1].date\">\n                                {{ $ctrl.parsedDate[1].date }}\n                            </div>\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[1].hour\">\n                                {{ $ctrl.parsedDate[1].hour }}\n                            </div>\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[1].minute\">\n                                {{ $ctrl.parsedDate[1].minute }}\n                            </div>\n                            <div class=\"label label-blue grid-item-1of6\" \n                                ng-if=\"$ctrl.parsedDate[1].second\">\n                                {{ $ctrl.parsedDate[1].second }}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"grid text-center\">\n                <div ng-class=\"{'disabled': !($ctrl.parsedDate[0].year || $ctrl.parsedDate[1].year)}\" class=\"grid-item grid-item-1of9 grid-item-offset-1of9\">Year</div>\n                <div ng-class=\"{'disabled': !($ctrl.parsedDate[0].month || $ctrl.parsedDate[1].month)}\" class=\"grid-item grid-item-1of9\">Month</div>\n                <div ng-class=\"{'disabled': !($ctrl.parsedDate[0].date|| $ctrl.parsedDate[1].date)}\" class=\"grid-item grid-item-1of9\">Day</div>\n                <div ng-class=\"{'disabled': !($ctrl.parsedDate[0].hour >= 0 || $ctrl.parsedDate[1].hour >= 0)}\" class=\"grid-item grid-item-1of9\">Hour</div>\n                <div ng-class=\"{'disabled': !($ctrl.parsedDate[0].minute >= 0 || $ctrl.parsedDate[1].minute >= 0)}\" class=\"grid-item grid-item-1of9\">Min</div>\n                <div ng-class=\"{'disabled': !($ctrl.parsedDate[0].second >= 0 || $ctrl.parsedDate[1].second >= 0)}\" class=\"grid-item grid-item-1of9\">Sec</div>\n            </div>\n        </div>\n      </div>\n      <div class=\"input-context-menu--body\">\n        <div class=\"grid\">\n            <div class=\"grid-item grid-item-1of9 text-right\" style=\"padding-right: 0.5em\">\n                Formats\n            </div>\n            <div class=\"grid-item grid-item-8of9\">\n                <span class=\"label-group-connected\">\n                    <span class=\"label label-gray\">Condition</span>\n                    <span class=\"label label-gray\">Datetime</span>\n                    <hr>\n                </span>\n                <span class=\"label-group-connected\">\n                    <span class=\"label label-gray\">Datetime</span>\n                    <span class=\"label label-gray\">Range</span>\n                    <span class=\"label label-gray\">Datetime</span>\n                    <hr>\n                </span>\n                <span class=\"label-group-connected\">\n                    <span class=\"label label-gray\">Datetime</span>\n                    <span class=\"label label-gray\">Range</span>\n                    <span class=\"label label-gray\">Time</span>\n                    <hr>\n                </span>\n            </div>\n        </div>\n        <hr>\n        <div class=\"grid\">\n            <div class=\"grid-item grid-item-1of9 text-right\" style=\"padding-right: 0.5em\">\n                Condition\n            </div>\n            <div class=\"grid-item grid-item-8of9\">\n                Before, After, <, > \n            </div>\n        </div>\n        <div class=\"grid\">\n            <div class=\"grid-item grid-item-1of9 text-right\" style=\"padding-right: 0.5em\">\n                Datetime\n            </div>\n            <div class=\"grid-item grid-item-8of9\">\n                <div>\n                    2/21/2012 7:42:06am\n                </div>\n                <div>\n                    Jan 2, 2012 at 6pm\n                </div>\n                <div>\n                    March 2016\n                </div>\n            </div>\n        </div>\n        <div class=\"grid\">\n            <div class=\"grid-item grid-item-1of9 text-right\" style=\"padding-right: 0.5em\">\n                Range\n            </div>\n            <div class=\"grid-item grid-item-2of3\">\n                to, -\n            </div>\n        </div>\n      </div>\n    </div>\n</div>\n"

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"editable-field\">\n    <input class=\"editable-input\" type=\"text\" ng-trim=\"true\" placeholder=\"Enter Name\" ng-keyup=\"$ctrl.handleSubmit($event)\" ng-blur=\"$ctrl.handleSubmit($event)\" ng-model=\"$ctrl.newValue\" />\n</div>\n<div class=\"editable-text\" ng-click=\"$ctrl.setEditMode(true)\" ng-bind=\"$ctrl.newValue || $ctrl.name\"></div>\n"

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	module.exports = "<!-- <lf-action-guide context=\"fact\" /> -->\n<!-- <div lf-update-notification></div> -->\n<div class=\"grid grid-fill grid-nowrap column\" style=\"background-color:#ffffff\">\n    <div class=\"modal-header grid-item-fixed small\">\n        <div class=\"grid\">\n            <div class=\"grid-item-fixed\">\n                <b class=\"btn\" ng-if=\"$ctrl.options.window\" ng-click=\"$ctrl.onOpenCase()\">FactBox</b>\n                <div ng-if=\"!$ctrl.options.window\" class=\"nav-item-text\">\n                    <b>Edit Fact</b>\n                </div>\n            </div>\n            <div class=\"grid-item\">\n                <span class=\"btn\" ng-if=\"$ctrl.options.window\" ng-click=\"$ctrl.onToggleCases()\">\n                    {{$ctrl.case.displayName || 'All '+ ('case'|lexicon:true)}} <span class=\"lf-caret\"></span>\n                </span>\n            </div>\n            <div class=\"grid-item-fixed\">\n                <div class=\"nav-item-text\" ng-show=\"$ctrl.busy\">\n                    <div class=\"spinner text-action\" style=\"display: inline-block;\">\n                        <div class=\"double-bounce1\"></div>\n                        <div class=\"double-bounce2\"></div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"grid-item-fixed\">\n                <div class=\"btn\" ng-if=\"!$ctrl.options.window\" ng-click=\"$ctrl.onCancel()\" ng-bind=\"'Close'\"></div>\n                <div class=\"btn\" ng-if=\"$ctrl.options.window\" ng-click=\"$ctrl.onNext({next: false, newFact: $ctrl.newFact})\" ng-bind=\"'Prev'\"></div>\n                <div class=\"btn\" ng-if=\"$ctrl.options.window\" ng-click=\"$ctrl.onNext({next: true, newFact: $ctrl.newFact})\" ng-bind=\"'Next'\"></div>\n                <div class=\"btn text-action\" ng-click=\"$ctrl.submit()\" id=\"add-fact\" ng-bind=\"$ctrl.busy ? 'Saving' : 'Save'\"></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"grid-item container-grid-fill\">\n        <div id=\"fact\" class=\"grid grid-fill column grid-nowrap\">\n            <div class=\"grid-item-fixed\">\n                <!-- <div class=\"grid\"> -->\n                <!-- <div class=\"grid-item btn\">Case name</div> -->\n                <div class=\"btn field-block-line btn-list-overflow\" ng-click=\"$ctrl.selectIssues()\" style=\"display: flex; flex-flow: row wrap;\">\n                    <div ng-repeat=\"issue in $ctrl.newFact.legalIssues\" ng-bind=\"::$ctrl.issuesTree.findNode(issue.id).headerDisplayName\" style=\"margin: 0px 6px;\" ></div>\n                    <div ng-if=\"!$ctrl.newFact.legalIssues.length\">Organize Later</div>\n                </div>\n                <!-- </div> -->\n                <div class=\"editable-field field-block-line\">\n                    <input class=\"editable-input\" type=\"text\" ng-trim=\"true\" placeholder=\"Enter Title\" ng-model=\"$ctrl.newFact.title\" />\n                </div>\n                <fb-date-field fb-dateish=\"$ctrl.newFact.factDateish\" update-fact=\"$ctrl.handleDateUpdate(factDateish)\" name=\"Set key date\"></fb-date-field>\n            </div>\n            <fb-trix class=\"grid-item trix-container\" ng-model=\"$ctrl.newFact.content\" fb-on-paste=\"$ctrl.autofill(pasteData)\"></fb-trix>\n            <div class=\"grid-item-fixed grid field-block-line field-block-line-top\">\n                <div class=\"grid-item btn btn-list-overflow\" style=\"display: flex; flex-flow: row wrap;\">\n                    <div ng-repeat=\"source in $ctrl.displaySources track by $index\" ng-bind-html=\"source\" style=\"margin: 0px 6px;\"></div>\n                    <div ng-click=\"$ctrl.selectSources()\">Set Sources</div>\n                </div>\n                <div class=\"grid-item btn text-right btn-list-overflow\" ng-click=\"$ctrl.selectTags()\" style=\"display: flex; flex-flow: row wrap;\">\n                    <div ng-repeat=\"tag in $ctrl.newFact.tags\" ng-bind=\"tag.displayName\" style=\"margin: 0px 6px;\"></div>\n                    <div>Set Tags</div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div ng-if=\"$ctrl.layer\" ng-click=\"$ctrl.showLayer('')\" ng-switch=\"$ctrl.layer\" class=\"modal-layer open select-layer\" ng-class=\"{'tag':'select-layer-right'}[$ctrl.layer]\">\n    <div class=\"modal-container\" ng-click=\"$ctrl.preventDefault($event)\">\n        <fb-issue-select value=\"$ctrl.newFact.legalIssues\" on-update=\"$ctrl.setFactField('legalIssues',newValue)\" list=\"$ctrl.issuesTree\" data=\"$ctrl.issuesTree.data\" ng-switch-when=\"issue\"></fb-issue-select>\n        <fb-source-select value=\"$ctrl.newFact.sources\" on-update=\"$ctrl.setFactField('sources',newValue)\" list=\"$ctrl.sourcesTree\" on-add-bookmark=\"$ctrl.addBookmark(displayName, parent)\" ng-switch-when=\"source\"></fb-source-select>\n        <fb-tag-select value=\"$ctrl.newFact.tags\" on-update=\"$ctrl.setFactField('tags',newValue)\" list=\"$ctrl.tagsTree\" data=\"$ctrl.tagsTree.data\" ng-switch-when=\"tag\"></fb-tag-select>\n    </div>\n</div>\n"

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-body grid grid-fill grid-nowrap column\">\n    <div class=\"grid-item-fixed\">\n        <div class=\"grid\">\n            <div class=\"grid-item nav-item-text\">\n                <b>Select {{::'issue'|lexicon:true}}</b>\n            </div>\n        </div>\n        <div class=\"field\">\n            <input type=\"text\" placeholder=\"Filter\" ng-model-options=\"{debounce: 150}\" ng-model=\"$ctrl.query\" ng-change=\"$ctrl.setFilter()\"/>\n        </div>\n        <fb-editable name=\"Add Issue\" class=\"text-action top-issue-field\" on-update=\"$ctrl.addIssue(newValue)\"></fb-editable>\n        <div class=\"text-assist nav-item-text\" ng-show=\"$ctrl.list.busy && !$ctrl.data.length\">Loading&hellip;</div>\n    </div>\n    <div class=\"grid-item\">\n        <fb-ol-select class=\"node-list\" on-delete=\"$ctrl.deleteIssue(value)\" on-select=\"$ctrl.toggle(value)\" value=\"$ctrl.value\" on-create=\"$ctrl.createSubIssue(displayName,parent)\" list=\"$ctrl.filteredList\" allow-child-key=\"id\"></fb-ol-select>\n    </div>\n</div>\n"

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"grid node\">\n    <div class=\"grid-item editable-text\" ng-class=\"{'selected':$ctrl.selected}\" ng-bind=\"::$ctrl.value.displayName\" ng-click=\"$ctrl.toggleSelected($event)\"></div>\n    <div class=\"grid-item-fixed add-child\" ng-if=\"::$ctrl.value[$ctrl.fbOlSelectCtrl.allowChildKey]\">\n        <span class=\"text-action btn btn-condensed\" ng-click=\"$ctrl.setEditMode(true)\"><span title=\"Add\" class=\"icon icon-add-circle\"></span></span>\n    </div>\n</div>\n<div class=\"node-list\" ng-show=\"$ctrl.subEditMode\">\n    <div class=\"editable-field\">\n        <input class=\"editable-input sub-item\" type=\"text\" ng-trim=\"true\" placeholder=\"{{::$ctrl.fbOlSelectCtrl.childPlaceholder}}\" ng-keyup=\"$ctrl.handleSubmit($event, true)\" ng-blur=\"$ctrl.handleSubmit($event, true)\" ng-model=\"$ctrl.newSubValue\" />\n    </div>\n</div>\n<div class=\"node-list\" ng-if=\"$ctrl.value.children.length\">\n    <fb-li-select value=\"item\" on-select=\"$ctrl.fbOlSelectCtrl.toggle(value)\" on-create=\"$ctrl.fbOlSelectCtrl.create(displayName, parent)\" selection=\"$ctrl.fbOlSelectCtrl.value\" ng-repeat=\"item in $ctrl.value.children track by item.id\"></fb-li-select>\n</div>\n<!-- Source List bookmark special case -->\n<div class=\"node-list\" ng-if=\"$ctrl.selectedValue.bookmarks.length\">\n    <div class=\"editable-text\" ng-class=\"{'selected':$ctrl.selected}\" ng-repeat=\"item in $ctrl.selectedValue.bookmarks\" ng-click=\"$ctrl.fbOlSelectCtrl.toggleBookmark($event,item, $ctrl.selectedValue)\">Page {{::item.page}}</div>\n</div>\n"

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"grid list-item\" ng-class=\"{'selected-list-item': $ctrl.isSelected}\">\n    <div class=\"grid-item editable-field\" ng-show=\"$ctrl.editMode\">\n        <input class=\"editable-input\" type=\"text\" ng-trim=\"true\" placeholder=\"Enter Name\" ng-keyup=\"$ctrl.handleSubmit($event)\" ng-blur=\"$ctrl.handleSubmit($event)\" ng-model=\"$ctrl.newValue\" />\n    </div>\n    <div class=\"grid-item editable-text\" ui-tree-handle ng-bind=\"$ctrl.value.displayName\" ng-click=\"$ctrl.setSelected($event)\" ng-hide=\"$ctrl.editMode\"></div>\n    <div class=\"grid-item-fixed\" ng-show=\"$ctrl.isSelected\">\n        <span class=\"text-action btn btn-condensed\" ng-click=\"$ctrl.setEditMode()\"><span title=\"Edit\" class=\"icon icon-edit\"></span></span>\n        <span class=\"text-action btn btn-condensed\" ng-click=\"$ctrl.onDelete({value: $ctrl.value})\"><span title=\"Delete\" class=\"icon icon-delete\"></span></span>\n        <span ng-if=\"::!$ctrl.fbOlCtrl.disableCreate\" class=\"text-action btn btn-condensed\" ng-click=\"$ctrl.setEditMode(true)\"><span title=\"Add\" class=\"icon icon-add-circle\"></span></span>\n    </div>\n</div>\n<div class=\"node-list\" ng-show=\"$ctrl.subEditMode\">\n    <div class=\"editable-field\">\n        <input class=\"editable-input sub-item\" type=\"text\" ng-trim=\"true\" placeholder=\"Enter Name\" ng-keyup=\"$ctrl.handleSubmit($event, true)\" ng-blur=\"$ctrl.handleSubmit($event, true)\" ng-model=\"$ctrl.newSubValue\" />\n    </div>\n</div>\n<div ui-tree data-drag-delay=\"200\">\n    <div class=\"node-list\" ui-tree-nodes=\"\" ng-model=\"$ctrl.value.children\">\n        <fb-li value=\"item\" ng-repeat=\"item in $ctrl.value.children\" ui-tree-node selected-id=\"$ctrl.fbOlCtrl.selectedId\" on-delete=\"$ctrl.fbOlCtrl.delete(value)\" on-select=\"$ctrl.fbOlCtrl.setSelected(id)\" on-create=\"$ctrl.fbOlCtrl.create(displayName, parent)\" on-update=\"$ctrl.fbOlCtrl.update(newValue)\"></fb-li>\n    </div>\n</div>\n"

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"filter-tree\" ng-class=\"{'expanded': !$ctrl.filterListCtrl.collapsed[$ctrl.list.attribute]}\">\n    <header ng-click=\"$ctrl.filterListCtrl.toggleCollapsed($ctrl.list.attribute)\">\n        <div class=\"grid\">\n            <div class=\"grid-item filter-dropdown\">\n                <div class=\"filter-label\">Filter</div>\n                <div>Keywords</div>\n            </div>\n            <div class=\"grid-item-fixed filter-settings\">\n                <div uib-dropdown ng-click=\"$event.stopPropagation()\">\n                    <span class=\"btn btn-condensed\" uib-dropdown-toggle><span class=\"icon icon-settings\"></span></span>\n                    <ul class=\"uib-dropdown-menu dropdown-menu-right\" aria-labelledby=\"simple-dropdown\">\n                        <li ng-click=\"$ctrl.filterListCtrl.removeFilter($ctrl.list.attribute)\">Remove Filter</li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </header>\n    <div class=\"filter-body\">\n        <div class=\"field\" style=\"padding:0 1em\">\n            <input type=\"text\" placeholder=\"Add Keyword\" ng-trim=\"true\" ng-keyup=\"$ctrl.handleSubmit($event)\" ng-model=\"$ctrl.value\" />\n            <span class=\"btn btn-condensed\" title=\"Toggle Exclude\" ng-click=\"$ctrl.excludeMode = !$ctrl.excludeMode\"><span class=\"icon\" ng-class=\"$ctrl.excludeMode ? 'icon-remove-circle-blue' : 'icon-remove-circle'\"></span></span>\n        </div>\n        <div class=\"filter-list\" ng-style=\"{'height': $ctrl.listHeight}\">\n            <span ng-show=\"$ctrl.list.includes.length\" class=\"filter-label\">Include</span>\n            <ul class=\"list-unstyled\">\n                <li ng-click=\"$ctrl.remove(item,'includes')\" ng-repeat=\"item in $ctrl.list.includes\"><span ng-bind=\"item\"></span></li>\n            </ul>\n            <div ng-show=\"$ctrl.list.excludes.length\" class=\"filter-label\">Exclude</div>\n            <ul class=\"list-unstyled\">\n                <li ng-click=\"$ctrl.remove(item,'excludes')\" ng-repeat=\"item in $ctrl.list.excludes\"><span ng-bind=\"item\"></span></li>\n            </ul>\n            <p style=\"padding:0 1.75rem\" class=\"text-assist text-center\" ng-if=\"!$ctrl.list.excludes.length && !$ctrl.list.includes.length \">\n                Add keywords to filter Fact title and content.\n            </p>\n        </div>\n    </div>\n    <footer>\n        <div class=\"small\" style=\"padding-left:0.75rem\">\n            <div class=\"btn\" ng-click=\"$ctrl.clear()\">Clear All</div>\n        </div>\n    </footer>\n</div>\n"

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"small btn grid btn-darkteal\" ng-show=\"$root.loading\" class=\"ng-hide\">\n    <span>Loading</span>\n    <div class=\"spinner\" style=\"display: inline-block;\">\n        <div class=\"double-bounce1\"></div>\n        <div class=\"double-bounce2\"></div>\n    </div>\n</div>\n"

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	module.exports = "<fb-li-select value=\"item\" on-select=\"$ctrl.toggle(value)\" selection=\"$ctrl.value\" on-create=\"$ctrl.create(displayName, parent)\" ng-repeat=\"item in $ctrl.list | emptyItem track by item.id\"></fb-li-select>\n"

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	module.exports = "<div ui-tree data-drag-delay=\"200\" drag-enabled=\"::!$ctrl.disableDrag\">\n    <div class=\"node-list\" ui-tree-nodes=\"\" ng-model=\"$ctrl.values\">\n        <fb-li value=\"item\" ng-repeat=\"item in $ctrl.values | emptyItem\" selected-id=\"$ctrl.selectedId\" ui-tree-node on-create=\"$ctrl.create(displayName, parent)\" on-update=\"$ctrl.update(newValue)\" on-delete=\"$ctrl.delete(value)\" on-select=\"$ctrl.setSelected(id)\"></fb-li>\n    </div>\n</div>\n<!-- <div ui-tree=\"$ctrl.uiTreeOptions\">\n  <ol ui-tree-nodes ng-model=\"$ctrl.values\">\n    <fb-li ui-tree-node value=\"item\" selected=\"$ctrl.selected.id===item.id\" on-select=\"$ctrl.setSelected(newValue)\" ng-repeat=\"item in $ctrl.values | emptyItem track by item.id\"></fb-li>\n  </ol>\n</div> -->\n"

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-body grid grid-fill grid-nowrap column\" ng-hide=\"sourcesCtrl.detail.editMode\">\n    <div class=\"grid-item-fixed\">\n        <div class=\"grid\">\n            <div class=\"grid-item nav-item-text\">\n                <b>Select {{::'source'|lexicon:true}}</b>\n            </div>\n        </div>\n        <div class=\"field\">\n            <input type=\"text\" placeholder=\"Search Titles\" ng-model=\"sourcesCtrl.searchQuery\" ng-model-options=\"{debounce: 150}\" ng-change=\"sourcesCtrl.setSearchFilter(sourcesCtrl.searchQuery)\">\n            <div class=\"grid-item-fixed\" uib-dropdown>\n                <div class=\"btn\" uib-dropdown-toggle>{{sourcesCtrl.typeFilter ? (sourcesCtrl.sourceTypes | filter: {name: sourcesCtrl.typeFilter} : true)[0].pluralName : 'All Sources'}} <span class=\"lf-caret\"></span></div>\n                <ul class=\"uib-dropdown-menu\" role=\"menu\">\n                    <li uib-dropdown-toggle ng-class=\"{'active':!sourcesCtrl.typeFilter}\" ng-click=\"sourcesCtrl.setTypeFilter()\">All Sources</li>\n                    <li uib-dropdown-toggle ng-if=\"!type.disabled\" ng-repeat=\"type in sourcesCtrl.sourceTypes\" ng-class=\"{'active':sourcesCtrl.typeFilter === type.name}\" class=\"btn btn-block\" ng-click=\"sourcesCtrl.setTypeFilter(type.name)\">\n                        <span ng-class=\"type.icon\"></span> {{type.pluralName}}\n                </ul>\n            </div>\n        </div>\n        <div class=\"grid-item-fixed\" uib-dropdown>\n            <div class=\"btn btn-block text-action\" uib-dropdown-toggle>Add Source</div>\n            <ul class=\"uib-dropdown-menu\" role=\"menu\">\n                <li uib-dropdown-toggle ng-if=\"!type.disabled\" ng-repeat=\"type in sourcesCtrl.sourceTypes\" ng-click=\"sourcesCtrl.newSource(type.name)\">New {{type.displayName}}</li>\n            </ul>\n        </div>\n        <div class=\"text-assist nav-item-text\" ng-show=\"sourcesCtrl.list.busy && !sourcesCtrl.list.data.length\">Loading&hellip;</div>\n    </div>\n    <div class=\"grid-item\">\n        <fb-ol-select class=\"node-list\" on-select=\"sourcesCtrl.toggle(value)\" on-create=\"sourcesCtrl.addBookmark(displayName, parent)\" value=\"sourcesCtrl.value\" list=\"sourcesCtrl.filteredSources\" on-toggle-bookmark=\"sourcesCtrl.removeBookmark(value, parent)\" child-placeholder=\"Enter Page Number\" allow-child-key=\"bookmarksEnabled\"></fb-ol-select>\n    </div>\n</div>\n<div class=\"modal-body grid grid-fill grid-nowrap column\" ng-show=\"sourcesCtrl.detail.editMode\">\n    <div class=\"grid-item-fixed nav-item-text\">\n        <b>Add {{::'source'|lexicon}}</b>\n    </div>\n    <ng-include class=\"grid-item container-grid-fill\" src=\"sourcesCtrl.detail.template\"></ng-include>\n    <div class=\"grid-item-fixed row\">\n        <span class=\"btn\" ng-click=\"sourcesCtrl.cancelDetail()\">Cancel</span>\n        <span ng-click=\"sourcesCtrl.saveSource()\" class=\"btn text-action\">Save</span>\n    </div>\n</div>\n"

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-body grid grid-fill grid-nowrap column\">\n    <div class=\"grid-item-fixed\">\n        <div class=\"grid\">\n            <div class=\"grid-item nav-item-text\">\n                <b>Select {{::'tag'|lexicon:true}}</b>\n            </div>\n        </div>\n        <div class=\"field\">\n            <input type=\"text\" placeholder=\"Filter\" ng-model=\"$ctrl.query\" ng-model-options=\"{debounce: 150}\" ng-change=\"$ctrl.setFilter()\"/>\n        </div>\n        <fb-editable name=\"Add Tag\" class=\"text-action top-tag-field\" on-update=\"$ctrl.addTag(newValue)\"></fb-editable>\n        <div class=\"text-assist nav-item-text\" ng-show=\"$ctrl.list.busy && !$ctrl.data.length\">Loading&hellip;</div>\n    </div>\n    <div class=\"grid-item\">\n        <fb-ol-select class=\"node-list\" on-delete=\"$ctrl.deleteTag(value)\" on-select=\"$ctrl.toggle(value)\" value=\"$ctrl.value\" list=\"$ctrl.filteredList\"></fb-ol-select>\n    </div>\n</div>\n"

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	module.exports = "<trix-editor input=\"trix-content\" placeholder=\"Write your fact here\"></trix-editor>\n<input id=\"trix-content\" type=\"hidden\" name=\"content\">"

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	module.exports = "\n  <label for=\"fb-upload-input\" class=\"row dropzone btn btn-block text-center text-action\">\n    <p>Choose Files</p>\n    <p class=\"small text-assist\">or drag them here</p>\n    <input style=\"display:none\" type=\"file\" id=\"fb-upload-input\" multiple ng-show=\"!$ctrl.files.length\">\n  </label>\n\n\n  <div class=\"progress\" ng-show=\"$ctrl.inProgress\">\n    <div class=\"progress-loaded\" ng-style=\"{'width':$ctrl.progress}\"></div>\n  </div>\n\n  <ol class=\"list-unstyled\" ng-show=\"$ctrl.files.length\">\n    <li ng-repeat=\"file in $ctrl.files\" ng-bind=\"file.name\"></li>\n  </ol>\n"

/***/ }),
/* 825 */,
/* 826 */,
/* 827 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar-admin header-darkteal small\">\n    <div class=\"grid\">\n        <div class=\"grid-item-fixed nav-btn-container\">\n            <lf-case-list route=\"home\" account=\"currentAccount.data\" case=\"home.currentCase.data\"></lf-case-list>\n            <button type=\"button\" class=\"btn btn-lighten\" ng-click=\"home.toggleCases()\">\n                All {{::'case'|lexicon : true}}\n            </button>\n        </div>\n        <div class=\"grid-item-fixed nav-text\" ng-hide=\"accountList.length > 0\" ng-bind=\"currentAccount.data.displayName\"></div>\n        <div class=\"grid-item-fixed\" ng-show=\"accountList.length > 0\" uib-dropdown>\n            <div uib-dropdown-toggle class=\"btn nav-text\" ng-class=\"{true: 'disabled'}[currentUser.busy]\">{{ currentUser.busy ? 'Loading...' : currentAccount.data.displayName }} <span class=\"lf-caret\"></span></div>\n            <ul class=\"uib-dropdown-menu\">\n                <li ng-repeat=\"account in accountList\" ng-click=\"changeAccount(account)\" ng-bind=\"account.displayName\"></li>\n            </ul>\n        </div>\n        <div class=\"grid-item\"></div>\n        <div class=\"grid-item-fixed nav-text\" ng-click=\"subscriptionModal('trial',trialStatus)\" ng-if=\"trialStatus.isTrial\">\n            <span class=\"label label-default\">\n                Trial {{trialStatus.daysRemaining}} days left\n            </span>\n        </div>\n        <div class=\"grid-item-fixed nav-btn-container\" ng-if=\"user.email\">\n            <span class=\"btn btn-lighten\" payment-enable=\"user\" lf-contributor-enable ng-click=\"caseModal()\">\n                Create {{::'case'|lexicon}}\n            </span>\n        </div>\n        <div class=\"grid-item-fixed\" uib-dropdown id=\"nav-item-info\" ng-if=\"user.email\">\n            <div class=\"btn nav-text\" uib-dropdown-toggle>\n                Info\n            </div>\n            <ul class=\"uib-dropdown-menu uib-dropdown-menu-right\">\n                <li>\n                    <a target=\"_blank\" href=\"/help\">\n                        Help Page\n                    </a>\n                </li>\n                <li ng-click=\"welcomeModal()\">\n                    Overview Guide\n                </li>\n            </ul>\n        </div>\n        <div class=\"grid-item-fixed\" uib-dropdown ng-if=\"user.email\">\n            <div uib-dropdown-toggle id=\"user-dropdown\" class=\"uib-dropdown-toggle btn nav-text\">\n                {{ ::user.firstName }} {{ ::user.lastName}} <span class=\"lf-caret\"></span>\n            </div>\n            <ul uib-dropdown-menu class=\"uib-dropdown-menu dropdown-menu-right uib-dropdown-menu-right\">\n                <li uib-dropdown-item lf-contributor-enable ng-click=\"openAccountPage()\">\n                    User Profile\n                </li>\n                <li uib-dropdown-item ng-click=\"showFeedback()\">\n                    Feedback\n                </li>\n                <li ng-if=\"currentAccount.data.integrations.clio.connected\" ng-click=\"syncClio()\">\n                    Sync Clio Data\n                </li>\n                <li uib-dropdown-item ng-click=\"signout()\">\n                    Sign Out\n                </li>\n            </ul>\n        </div>\n        <div ng-if=\"!user.email\" class=\"grid-item-fixed nav-btn-container\">\n            <a href=\"/app/#/signup\" class=\"btn btn-lighten\">\n            Sign Up\n            </a>\n        </div>\n        <div ng-if=\"!user.email\">\n            <a class=\"btn nav-text\" href=\"/app/#/signin\">Sign In</a>\n        </div>\n</nav>\n</div>\n</nav>\n"

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"grid-item-fixed nav-item-text\">\n    <span class=\"label label-red clickable\" ng-click=\"subscriptionModal('case',home.currentCase.data)\" ng-show=\"home.currentCase.data.id && casePaymentExpired\">Read Only</span>\n    <span ng-show=\"home.currentCase.data.public\" class=\"label label-gold\">Public</span>\n</div>\n"

/***/ }),
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"grid navbar-pages\">\n    <div class=\"grid-item-fixed nav-btn-container\">\n        <span class=\"btn\" ng-click=\"navHome()\">\n            <b>FactBox</b>\n        </span>\n    </div>\n    <div class=\"grid-item-fixed nav-btn-container-small\" ng-if=\"links\">\n        <a class=\"btn\" href=\"/features\">Features</a>\n    </div>\n    <div class=\"grid-item-fixed  nav-btn-container-small small-grid-show\" ng-if=\"links\">\n        <a class=\"btn\" href=\"/pricing\">Pricing</a>\n    </div>\n    <div class=\"grid-item-fixed  nav-btn-container-small large-grid-show\" ng-if=\"links\">\n        <a class=\"btn\" href=\"/demo\">Demo</a>\n    </div>\n    <div class=\"grid-item-fixed  nav-btn-container-small med-grid-show\" ng-if=\"links\">\n        <a class=\"btn\" href=\"/about\">About Us</a>\n    </div>\n    <div class=\"grid-item\"></div>\n    <div class=\"grid-item-fixed med-grid-show\" ng-if=\"actions.signin.visible\">\n        <a href=\"#/signin\" class=\"btn nav-text\">\n            Sign in\n        </a>\n    </div>\n    <span ng-if=\"actions.signup.visible\" class=\"grid-item-fixed nav-btn-container-small\">\n        <a href=\"#/signup\" class=\"btn btn-gold cta-action\">Free Trial</a>\n    </span>\n    <div ng-if=\"userMenu\" class=\"grid-item-fixed\" uib-dropdown>\n        <div uib-dropdown-toggle id=\"user-dropdown\" class=\"uib-dropdown-toggle btn nav-text\">\n            {{ user.firstName }} {{ user.lastName}} <span class=\"lf-caret\"></span>\n        </div>\n        <ul uib-dropdown-menu class=\"uib-dropdown-menu dropdown-menu-right uib-dropdown-menu-right\">\n            <li>\n                <a target=\"_blank\" href=\"/help\">Help Page</a>\n            </li>\n            <li uib-dropdown-item ng-click=\"signout()\">\n                Sign Out\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	module.exports = "<!-- action guide status navbar -->\n<div class=\"container-action-guide small\">\n    <div class=\"nav-action-guide grid-item\">\n        <div class=\"grid-item-fixed\">\n            FactBox Mastery\n        </div>\n        <div class=\"grid-item step-container\">\n            <div ng-repeat=\"step in actionGuide.activeGuide\" class=\"indicator indicator-green\" ng-class=\"step.complete ? 'indicator-full' :step.key===actionGuide.activeStep.key ? 'indicator-idle':'indicator-empty' \">\n                <div class=\"circle circle-lg circle-inverted\">\n                    <div class=\"fill fill-green\">\n                        <div class=\"icon-check-thin\" style=\"margin-top: -1px\" ng-if=\"step.complete\"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"nav-action-guide-close\"><span class=\"btn btn-sm\" ng-click=\"actionGuide.finish()\">Close</span></div>\n</div>\n<!-- action guide popover -->\n<div id=\"action-guide-popover\" ng-style=\"actionGuide.activeStep.elementStyle\" ng-class=\"actionGuide.activeStep.complete ? 'action-guide-popover-success':''\" ng-show=\"context === actionGuide.activeStep.context && actionGuide.activeStep.key\">\n    <div class=\"hint-arrow\" ng-show=\"actionGuide.activeStep.hintStyle && !actionGuide.activeStep.complete\" ng-style=\"actionGuide.activeStep.hintStyle\"></div>\n    <div ng-switch=\"actionGuide.activeStep.key\">\n        <div ng-switch-when=\"viewby\">\n            <div class=\"text-center\"><b>View Your Facts</b></div>\n            <div ng-hide=\"actionGuide.activeStep.complete\">\n                The current view is “View By <b>{{::'issue'|lexicon}}s</b>.” Click on the word <b>{{::'issue'|lexicon}}s</b> to reveal a dropdown, then select Sources.\n            </div>\n            <div ng-show=\"actionGuide.activeStep.complete\" class=\"text-center\">\n                See how the view changes?\n            </div>\n        </div>\n        <div ng-switch-when=\"selection\">\n            <div class=\"text-center\"><b>Deselect Item</b></div>\n            <div ng-hide=\"actionGuide.activeStep.complete\">\n                Hide a group of facts by clicking the corresponding item in the list.\n            </div>\n            <div ng-show=\"actionGuide.activeStep.complete\">\n            </div>\n        </div>\n        <div ng-switch-when=\"format\">\n            <div class=\"text-center\"><b>Toggle Fact List View</b></div>\n            <div ng-hide=\"actionGuide.activeStep.complete\">\n                Prepare your view for report generation.\n                <br/>View facts as a {{::'memo'|lexicon}} by clicking {{::'memo'|lexicon}}.\n            </div>\n            <div ng-show=\"actionGuide.activeStep.complete\" class=\"text-center\">\n                See how the layout of your facts changed?\n            </div>\n        </div>\n        <div ng-switch-when=\"columns\">\n            <div class=\"text-center\"><b>Hide Columns/Fields</b></div>\n            <div ng-hide=\"actionGuide.activeStep.complete\">\n                Refine your report by showing or hiding columns (fields in {{'memo'|lexicon}} view). Click on Columns/Fields to choose what information types are included. For now, toggle {{'issue'|lexicon}}s.\n            </div>\n            <div ng-show=\"actionGuide.activeStep.complete\" class=\"text-center\">\n                This is starting to look like something we could submit!\n            </div>\n        </div>\n        <div ng-switch-when=\"generate\">\n            <div class=\"text-center\"><b>Generate</b></div>\n            <div ng-hide=\"actionGuide.activeStep.complete\">\n                Click Generate to get a fully editable Word doc of what's in your fact view.\n            </div>\n            <div ng-show=\"actionGuide.activeStep.complete\" class=\"text-center\">\n                Your work product was just added to your Downloads folder. You can review it after the guide.\n            </div>\n        </div>\n        <div ng-switch-when=\"case\">\n            <div class=\"text-center\"><b>Create a {{'case'|lexicon}}</b></div>\n            <div ng-hide=\"actionGuide.activeStep.complete\">\n                Now, let's start with a fresh new {{'case'|lexicon:false:'lower'}} to add content. Click Create {{'case'|lexicon}} and set a name. 'Tutorial {{'case'|lexicon}}' will do; you can change the name or delete the {{'case'|lexicon:false:'lower'}} whenever you like.\n            </div>\n            <div ng-show=\"actionGuide.activeStep.complete\" class=\"text-center\">\n                You can access your {{'case'|lexicon}}s by clicking \"All {{'case'|lexicon}}s\" in the upper left.\n            </div>\n        </div>\n        <div ng-switch-when=\"fact\">\n            <div class=\"text-center\"><b>Open the Add Fact Window</b></div>\n            <div ng-hide=\"actionGuide.activeStep.complete\">\n                To add facts, ideas or notes to your {{'case'|lexicon:false:'lower'}}, click Add Fact.\n            </div>\n            <div ng-show=\"actionGuide.activeStep.complete\">\n            </div>\n        </div>\n        <div ng-switch-when=\"paste\">\n            <div class=\"text-center\"><b>Copy and Paste Content</b></div>\n            <div ng-hide=\"actionGuide.activeStep.complete\">\n                Copy a snippet from a document or this <a href=\"#/boc\" target=\"_blank\">Sample Document</a> and paste it into the Fact Content area.\n            </div>\n            <div ng-show=\"actionGuide.activeStep.complete\" class=\"text-center\">\n                You can also add content and formatting by typing directly.\n            </div>\n        </div>\n        <div ng-switch-when=\"save\">\n            <div class=\"text-center\"><b>Save the Fact</b></div>\n            <div ng-hide=\"actionGuide.activeStep.complete\">\n                Click Save to add the Fact to the {{'case'|lexicon}}. Back in the {{'case'|lexicon}} view, you'll notice the new Fact appears in the fact list.\n            </div>\n            <div ng-show=\"actionGuide.activeStep.complete\" class=\"text-center\">\n                After you click save, the Add Fact Window is ready for the next fact.\n            </div>\n        </div>\n        <div ng-switch-when=\"navHome\">\n            <div class=\"text-center\"><b>See the {{'case'|lexicon}}</b></div>\n            <div ng-hide=\"actionGuide.activeStep.complete\">\n                Click the FactBox icon to see the new Facts in your {{'case'|lexicon:false:'lower'}}.\n            </div>\n            <div ng-show=\"actionGuide.activeStep.complete\">\n            </div>\n        </div>\n        <div ng-switch-when=\"conclusion\">\n            <div class=\"text-center\"><b>Great Job!</b></div>\n            <div class=\"text-center\">\n                Those are the FactBox basics. Congratulations! You're on your way to building more effective {{'case'|lexicon}}s.\n            </div>\n        </div>\n        <div ng-switch-when=\"close\">\n            <div class=\"text-center\"><b>One Last Thing!</b></div>\n            <div class=\"text-center\">\n                To learn more, visit our Help Page. Click Overview Guide to re-run this overview.\n            </div>\n        </div>\n        <div ng-show=\"actionGuide.activeStep.complete\" class=\"text-center\">\n            <div style=\"font-size: 48px\" class=\"icon-check-thin\"></div>\n        </div>\n    </div>\n    <div class=\"text-center\">\n        <span class=\"btn\" ng-hide=\"{'fact':true,'navHome':true}[actionGuide.activeStep.key]\" ng-class=\"actionGuide.activeStep.complete?'btn-green':'btn-outline'\" ng-click=\"actionGuide.nextStep()\" ng-bind=\"actionGuide.activeStep.cta ? actionGuide.activeStep.cta : actionGuide.activeStep.complete?'Next Step':'Skip'\"></span>\n    </div>\n</div>\n"

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"case-list-container\" ng-class=\"{visible: $ctrl.asideCasesVisible}\">\n    <div id=\"case-list\" class=\"grid grid-fill grid-nowrap column\">\n        <div class=\"modal-header grid-item-fixed\">\n            <div class=\"grid\">\n                <div class=\"grid-item nav-item-text\">\n                    <b>All {{::'case'|lexicon:true}}</b>\n                    <div ng-if=\"$ctrl.caseMap.busy\" class=\"spinner text-action\" style=\"display: inline-block;\">\n                        <div class=\"double-bounce1\"></div>\n                        <div class=\"double-bounce2\"></div>\n                    </div>\n                </div>\n                <div class=\"grid-item-fixed\">\n                    <span class=\"btn\" ng-click=\"$ctrl.toggleCases()\">Close</span>\n                </div>\n            </div>\n        </div>\n        <div class=\"modal-body grid-item\">\n            <div style=\"padding-bottom: 1em;\" ng-if=\"$ctrl.account.integrations.clio.connected\">\n                <button type=\"button\" class=\"btn btn-outline btn-sm btn-block text-blue\" ng-click=\"$ctrl.syncClio()\">\n                    <div ng-hide=\"$ctrl.clioSyncInProgress\">Sync Clio Matters</div>\n                    <div ng-show=\"$ctrl.clioSyncInProgress\" class=\"spinner text-action\" style=\"display: inline-block;\">\n                        <div class=\"double-bounce1\"></div>\n                        <div class=\"double-bounce2\"></div>\n                    </div>\n                </button>\n            </div>\n            <div ng-show=\"!invitedCasesWarning && invitedCasesCount() > 0 && !user.verified\">\n                <div class=\"clickable pull-right\" ng-click=\"invitedCasesWarning = !invitedCasesWarning\"><i class=\"glyphicon glyphicon-remove\"></i></div>\n                <b>{{invitedCasesCount()}} Hidden {{::'case'|lexicon:invitedCasesCount() !== 1}}</b>\n                <br/> Verify your email to access {{::'case'|lexicon:true}} you have been invited to.\n                <br/>\n                <a href ng-click=\"verifyModal()\">More Info <i class=\"icon-chevron-right\"></i></a>\n            </div>\n            <ul class=\"list-unstyled\">\n                <li ng-repeat=\"c in $ctrl.cases | filter:{status:'active'} | orderBy:'displayName'\" ng-class=\"{'selected':c.id === $ctrl.case.id}\" ng-click=\"$ctrl.setCase(c.id)\" class=\"btn btn-block\">\n                    <div ng-bind=\"::c.displayName\"></div>\n                    <div ng-if=\"c.clioCaseId\"><small class=\"text-assist\"><i class=\"icon icon-clio\"></i> Clio Matter</small></div>\n                </li>\n                <li class=\"nav-item-text\" ng-hide=\"$ctrl.cases.length\">\n                    Loading {{::'case'|lexicon:true}}\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"filter-list-container\">\n    <lf-filter-tree lf-parent=\"filterListCtrl\" lf-filter=\"filter\" ng-repeat=\"filter in filterListCtrl.filterTrees\"></lf-filter-tree>\n    <fb-list-filter list=\"filterListCtrl.keywordFilter\" height=\"filterListCtrl.selectionListHeight\" ng-if=\"filterListCtrl.keywordFilter\"></fb-list-filter>\n    <div class=\"dropup row navbar\" uib-dropdown ng-if=\"filterListCtrl.filterTrees\">\n        <div uib-dropdown-toggle class=\"btn btn-block\">\n            <span class=\"filter-name-padded\">Add Filter</span>\n        </div>\n        <ul class=\"uib-dropdown-menu dropdown-menu-top\" aria-labelledby=\"simple-dropdown\">\n            <li ng-click=\"filterListCtrl.addFilter(attr)\" ng-repeat=\"attr in filterListCtrl.availableAttrs track by attr\">\n                <a href>{{::attr|lexicon}}</a>\n            </li>\n            <li ng-hide=\"filterListCtrl.keywordFilter\" ng-click=\"filterListCtrl.addFilter('keywords')\">\n                <a href>Keyword</a>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"filter-tree\" ng-class=\"{'expanded': !filterListCtrl.collapsed[filterCtrl.filter.attribute], 'primary':$index === 0}\">\n    <header ng-click=\"filterListCtrl.toggleCollapsed(filterCtrl.filter.attribute)\">\n        <div class=\"grid\">\n            <div class=\"grid-item filter-dropdown\">\n                <!-- <i class=\"filter-icon icon-filter\" ng-if=\"$index !== 0\"></i> -->\n                <div class=\"filter-label\" ng-bind=\"$index === 0 ? 'View By':'Filter'\"></div>\n                <div uib-dropdown ng-click=\"$event.stopPropagation()\">\n                    <div class=\"\" uib-dropdown-toggle>\n                        {{filterCtrl.filter.attribute|lexicon}} <i class=\"lf-caret\"></i>\n                    </div>\n                    <ul uib-dropdown-toggle class=\"uib-dropdown-menu\" aria-labelledby=\"simple-dropdown\">\n                        <li ng-click=\"filterCtrl.setViewBy(attr)\" ng-repeat=\"attr in filterListCtrl.availableAttrs track by attr\">{{::attr|lexicon}}</li>\n                    </ul>\n                </div>\n            </div>\n            <div class=\"grid-item-fixed filter-settings\">\n                <div uib-dropdown ng-click=\"$event.stopPropagation()\">\n                    <span class=\"btn btn-condensed\" uib-dropdown-toggle><span class=\"icon icon-settings\"></span></span>\n                    <!-- <span class=\"filter-options icon icon-cog\" uib-dropdown-toggle></span> -->\n                    <ul class=\"uib-dropdown-menu dropdown-menu-right\" aria-labelledby=\"simple-dropdown\">\n                        <li ng-click=\"filterCtrl.parent.removeFilter(filterCtrl.filter.attribute)\" ng-show=\"filterCtrl.parent.enableFilterTreeRemoval\">Remove Filter</li>\n                        <li ng-click=\"home.currentCase.getOutline(filterCtrl.filter.attribute,filterCtrl.factQuery.data.id)\">Generate List</li>\n                        <li class=\"divider\"></li>\n                        <li ng-click=\"filterCtrl.setAllCollapsed(true)\">Collapse All</li>\n                        <li ng-click=\"filterCtrl.setAllCollapsed(false)\">Uncollapse All</li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </header>\n    <div class=\"filter-body\">\n        <!-- <div class=\"filter-separator\"></div> -->\n        <ol class=\"select-list\" ng-style=\"{'height': filterListCtrl.selectionListHeight}\">\n            <li ng-if=\"!filterCtrl.trees[filterCtrl.filter.attribute].data.length\" class=\"filter-placeholder\">\n                <p class=\"filter-placeholder-text\" ng-if=\"filterCtrl.trees[filterCtrl.filter.attribute].busy\">Loading</p>\n                <p ng-if=\"!filterCtrl.trees[filterCtrl.filter.attribute].busy\" class=\"filter-placeholder-text\">No {{::filterCtrl.filter.attribute|lexicon}}{{{factDateish: 's',creationDate: 's'}[filterCtrl.filter.attribute]}} Found</p>\n            </li>\n            <ng-include ng-repeat=\"node in filterCtrl.trees[filterCtrl.filter.attribute].data track by $index\" src=\"'/filter-tree/node.html'\"></ng-include>\n        </ol>\n    </div>\n    <footer>\n        <div class=\"grid small\">\n            <div class=\"grid-item-fixed select-indicator\" ng-class=\"filterCtrl.allExcluded === true ? '' : filterCtrl.allExcluded === false ? 'selected' : 'half'\" ng-click=\"filterCtrl.setAllExcluded()\">\n            </div>\n            <div class=\"grid-item-fixed\" ng-hide=\"filterCtrl.filter.attribute === 'sources'\">\n                <span class=\"btn btn-condensed\" ng-click=\"filterCtrl.setSorting('asc')\" ng-class=\"{'asc':'active'}[filterCtrl.filter.sort]\"><span class=\"icon icon-arrow-up\"></span></span>\n                <span class=\"btn btn-condensed\" ng-click=\"filterCtrl.setSorting('desc')\" ng-class=\"{'desc':'active'}[filterCtrl.filter.sort]\"><span class=\"icon icon-arrow-down\"></span></span>\n            </div>\n            <div class=\"grid-item text-right\">\n                <span class=\"btn\" lf-contributor-enable ng-if=\"{'legalIssues':true,'tags':true,'sources':true,'creator':true\n                }[filterCtrl.filter.attribute] ? true : false\" ng-click=\"home[{legalIssues: 'issuesModal',tags: 'tagsModal',sources: 'sourcesModal',creator: 'contributorsModal'}[filterCtrl.filter.attribute]]()\">Manage</span>\n            </div>\n        </div>\n    </footer>\n</div>\n"

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	module.exports = "<li class=\"select-indicator item-node \" ng-click=\"filterCtrl.toggleExcluded(node) \" ng-class=\"{ 'selected':!node.excluded} \">\n    <span ng-bind=\"node.displayName \"></span>\n    <div ng-click=\"filterCtrl.toggleCollapsed(node, $event) \" ng-if=\"node.children.length \" ng-class=\"{ 'collapsed':node.collapsed} \" class=\"collapse-action \">\n        <div class=\"collapsed-indicator \">\n            <span ng-show=\"node.collapsed \">&hellip;</span>\n            <span ng-hide=\"node.collapsed \">&#8722;</span>\n        </div>\n    </div>\n</li>\n<ol ng-if=\"node.children.length\" ng-hide=\"node.collapsed\">\n    <ng-include ng-repeat=\"node in node.children track by $index\" src=\" '/filter-tree/node.html' \"></ng-include>\n</ol>\n"

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"small modal-container\" ng-show=\"versionServ.update\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>FactBox update available</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <div class=\"btn text-action\" ng-click=\"reload()\">Reload</div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	module.exports = "<span ng-bind=\"count || 'Add'\"></span> {{name}}\n"

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	module.exports = "<footer class=\"footer footer-darkteal\">\n    <div class=\"container\">\n        <div class=\"grid grid-full grid-gutters large-grid-fit\">\n            <div class=\"grid-item\">\n                <p class=\"text-tinted\">Company</p>\n                <ul class=\"list-unstyled list-ellipsis\">\n                    <li>\n                        <a class=\"company\" href=\"/about\" target=\"_blank\" title=\"\">About Us</a>\n                    </li>\n                </ul>\n            </div>\n            <div class=\"grid-item\">\n                <p class=\"text-tinted\">Pages</p>\n                <ul class=\"list-unstyled list-ellipsis\">\n                    <li>\n                        <a href=\"/privacy-policy\" title=\"\">Privacy &amp; Online<br/>Security Policy</a>\n                    </li>\n                    <li>\n                        <a href=\"/saas-agreement\" title=\"\">SaaS Agreement</a>\n                    </li>\n                </ul>\n            </div>\n            <div class=\"grid-item\">\n                <p class=\"text-tinted\">Contact</p>\n                <ul class=\"list-unstyled list-ellipsis\">\n                    <li><a rel=\"nofollow\" href=\"mailto:team@getfactbox.com?subject=FactBox\">team@getfactbox.com</a>\n                        <br>\n                    </li>\n                    <li><a rel=\"nofollow\" href=\"tel:14152879922\" title=\"\">&#43;1 (415) 287-9922</a></li>\n                </ul>\n            </div>\n            <div class=\"grid-item\">\n                <p class=\"text-tinted\">Connect</p>\n                <ul class=\"list-unstyled list-ellipsis\">\n                    <li><a href=\"http://blog.getfactbox.com\" title=\"Blog\" target=\"_blank\">Blog</a></li>\n                    <li><a href=\"https://www.linkedin.com/company/factbox\" title=\"LinkedIn\" target=\"_blank\">LinkedIn</a></li>\n                    <li><a href=\"https://twitter.com/getfactbox\" title=\"Twitter\" target=\"_blank\">Twitter</a></li>\n                    <li><a href=\"https://plus.google.com/109969463407946037709\" rel=\"publisher\" target=\"_blank\">Google&#43;</a></li>\n                </ul>\n            </div>\n        </div>\n        <div>\n            <i style=\"font-size:2em\" class=\" icon-factbox-combo \"></i></div>\n        <p>&copy; 2016 Lynx Workflow, Inc. All rights reserved.</p>\n    </div>\n</footer>\n"

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"small modal-container\" ng-show=\"currentCase.hasUpdates\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>{{::'case'|lexicon}} Update Available</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <div class=\"btn text-action\" ng-click=\"$emit('refreshCase')\">Reload</div>\n        </div>\n    </div>\n</div>\n<div class=\"small modal-container\" ng-repeat=\"(url, message) in errors.data\" ng-hide=\"message.data\" ng-class=\"{ 'card-red':message.error, 'card-green':message.success}\">\n    <div class=\"grid\">\n        <span class=\"grid-item nav-item-text\">\n            <b ng-bind=\"message.error || message.warning|| message.success\"></b>\n        </span>\n        <div class=\"grid-item-fixed\">\n            <div class=\"btn\" ng-show=\"message.details\" ng-click=\"showDescription = !showDescription\">More</div>\n            <div class=\"btn\" ng-click=\"removeNotification(errors.data, url)\">Close</div>\n        </div>\n    </div>\n    <div ng-show=\"showDescription\" class=\"nav-item-text\" ng-bind-html=\"message.details\"></div>\n</div>\n"

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card card-red-tint\" ng-repeat=\"(url, message) in errors.data\" ng-if=\"message.error || message.details\">\n    <div ng-bind-html=\"message.error\"></div>\n    <div><small ng-bind=\"message.details\"></small></div>\n</div>\n"

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"modal card card-default\" role=\"form\" novalidate ng-submit=\"currentAccount.api.update().then($close())\">\n    <h3>What is the name of your firm?</h3>\n    <p>We use this information for data security and easy collaboration.</p>\n    <div status-row></div>\n    <div class=\"grid grid-gutters\">\n        <div class=\"grid-item field\" ng-class=\"currentAccount.error.data.displayName.error ? 'field-error' : ''\">\n            <input type=\"text\" ng-model=\"currentAccount.data.displayName\" placeholder=\"Firm Name\" name=\"firm-name\">\n        </div>\n    </div>\n    <button type=\"submit\" ng-disabled=\"{{currentAccount.busy}}\" class=\"btn btn-green btn-block\">Submit</button>\n</form>\n"

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Are you sure?</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <div class=\"btn\" ng-click=\"$dismiss('cancel')\">Cancel</div>\n            <div class=\"btn btn-red\" ng-click=\"$close('ok')\">Archive</div>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body\">\n    <p class=\"modal-text\">\n        Archiving this {{::'case'|lexicon:false:'lower'}} will remove it from your list of currently active {{::'case'|lexicon:true}}.\n    </p>\n</div>\n"

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"verifyAuthCode()\">\n<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Verify Phone</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$dismiss()\">Close</span>\n            <button type=\"submit\" ng-disabled=\"busy\" class=\"btn btn-blue btn-sm\" ng-bind=\"busy ? 'Submitting' : 'Submit'\"></button>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body\">\n    <div class=\"text-center row\">\n        +{{phone.country.code}} {{phone.phoneNumber | tel}}\n    </div>\n    <div class=\"field\" ng-class=\"error.error ? 'field-error' : ''\">\n        <input type=\"text\" ng-model=\"authCode\" name=\"authCode\" placeholder=\"Auth Code\">\n    </div>\n    <p class=\"modal-text\" ng-hide=\"error.error\">Please enter the auth code sent to your device.</p>\n    <div class=\"row text-red\" role=\"alert\" ng-show=\"error.error\">\n        <div class=\"modal-text\">\n            <p ng-bind=\"error.error\"></p>\n            <small ng-bind=\"error.details\"></small>\n        </div>\n    </div>\n</div>\n</form>"

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b ng-if=\"contribCtrl.user.verified\">Manage {{::'contributors'|lexicon}}</b>\n            <b ng-if=\"!contribCtrl.user.verified\">Verify your email address</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$close()\">Close</span>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body\" ng-if=\"contribCtrl.user.verified\">\n    <form role=\"form\" novalidate name=\"addContributorForm\" ng-submit=\"contribCtrl.addContributor()\">\n        <div class=\"field row\">\n            <input type=\"text\" placeholder=\"Email\" ng-model=\"contribCtrl.contributor.data.email\" />\n            <span class=\"btn\">Cancel</span>\n            <!-- <span class=\"btn\">Add</span> -->\n            <button type=\"submit\" class=\"btn btn-green\" ng-bind-html=\"contribCtrl.addButtonStates[contribCtrl.contributor.busy || false]\" ng-disabled=\"contribCtrl.contributor.busy\"></button>\n        </div>\n        <!-- <div class=\"form-group\" ng-class=\"{'has-error':contribCtrl.contributor.error.data.email.error}\" style=\"margin-bottom: 0\">\n            <label class=\"control-label\" for=\"email\">Email:</label>\n            <div class=\"input-group\">\n                <input type=\"email\" name=\"email\" class=\"form-control\" ng-disabled=\"contribCtrl.contributor.data.newUser\" ng-model=\"contribCtrl.contributor.data.email\" required>\n                <span class=\"input-group-btn\">\n                <button ng-show=\"contribCtrl.contributor.data.newUser\" type=\"button\" class=\"btn btn-default\" ng-click=\"contribCtrl.cancelNewContributor()\">Cancel</button>\n                \n                </span>\n            </div>\n            <label class=\"control-label\" for=\"email\">{{ contribCtrl.contributor.error.data.email.error }}</label> -->\n        <!-- </div> -->\n        <div ng-show=\"contribCtrl.contributor.data.newUser\">\n            <div class=\"grid grid-gutters\" style=\"margin-bottom: 0\">\n                <div class=\"grid-item field field-block\" ng-class=\"{'has-error':contribCtrl.contributor.error.data.firstName.error!==undefined}\">\n                    <input type=\"text\" placeholder=\"First Name\" name=\"firstName\" ng-model=\"contribCtrl.contributor.data.firstName\" required>\n                    <label ng-show=\"contribCtrl.contributor.error.data.firstName.error\" for=\"firstName\">{{ contribCtrl.contributor.error.data.firstName.error }}</label>\n                </div>\n                <div class=\"grid-item field field-block\" ng-class=\"{'has-error':contribCtrl.contributor.error.data.lastName.error!==undefined}\">\n                    <input type=\"text\" placeholder=\"Last Name\" name=\"lastName\" ng-model=\"contribCtrl.contributor.data.lastName\" required>\n                    <label ng-show=\"contribCtrl.contributor.error.data.lastName.error\" for=\"lastName\">{{ contribCtrl.contributor.error.data.lastName.error }}</label>\n                </div>\n            </div>\n            <div class=\"card card-blue-tint\" style=\"margin-top: 0\">\n                New {{::'contributor'|lexicon:false:'lower'}} detected. To invite <b>{{contributor.email}}</b> to this {{::'case'|lexicon}}, please enter details above. The {{::'contributor'|lexicon:false:'lower'}} will receive an email invite.\n            </div>\n        </div>\n    </form>\n    <table id=\"contributors\" class=\"table\">\n        <thead>\n            <tr>\n                <th class=\"name\">Name</th>\n                <th class=\"email\">Email</th>\n                <th class=\"remove\"></th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr ng-repeat-start=\"contributor in contribCtrl.contributorsList\" ng-hide=\"contributor.showRemove\">\n                <td class=\"name\" title=\"{{contributor.firstName}} {{contributor.lastName}}\">\n                    <span class=\"table-item-text\">\n                    {{contributor.firstName}} {{contributor.lastName}}\n                </span>\n                </td>\n                <td class=\"email\" title=\"{{contributor.email}}\">\n                    <span class=\"table-item-text\">\n                    {{contributor.email}}\n                </span>\n                </td>\n                <td class=\"remove\">\n                    <span class=\"btn\" ng-class=\"contribCtrl.contributorsList.length === 1 || contribCtrl.toRemove.busy ? 'disabled' : ''\" ng-click=\"contributor.showRemove = true\">Remove</span>\n                </td>\n            </tr>\n            <tr ng-repeat-end ng-show=\"contributor.showRemove\">\n                <td colspan=\"3\">\n                    <div class=\"grid\">\n                        <div class=\"grid-item\">\n                            <div class=\"table-item-text\">\n                                Remove <b>{{contributor.firstName}} {{contributor.lastName}}</b>?\n                            </div>\n                        </div>\n                        <div class=\"grid-item text-right\">\n                            <span class=\"btn\" ng-click=\"contributor.showRemove = false\">Cancel</span>\n                            <span class=\"btn\" ng-class=\"contribCtrl.contributorsList.length === 1 || contribCtrl.toRemove.busy ? 'disabled' : ''\" ng-click=\"contribCtrl.removeContributor(contributor)\">Remove</span>\n                        </div>\n                    </div>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n<div class=\"modal-body\" ng-if=\"!contribCtrl.user.verified\">\n    <div class=\"nav-item-text\">\n        <p>Please verify your address using the link provided in the confirmation email. For security purposes, FactBox requires users to verify their email address to manage {{::'contributors'|lexicon}}.</p>\n        <p>If you did not recieve the confirmation email, please contact us:</p>\n        <ul>\n            <li><a href=\"tel:4152879922\" title=\"\">(415) 287-9922</a></li>\n            <li><a href=\"mailto:tech@lynxworkflow.com?subject=Account Verification Email&body=I have signed up for FactBox, but have not received a verification email or cannot find it. Please verify my account.\">tech@lynxworkflow.com</a></li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	module.exports = "<form role=\"form\" ng-submit=\"submit()\">\n    <div class=\"grid modal-header row\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Create a {{::'case'|lexicon}}</b>\n        </div>\n        <div class=\"grid-item grid-item-fixed\">\n            <a class=\"pull-left btn btn-muted btn-round\" ng-click=\"$dismiss()\">Cancel</a>\n            <button type=\"submit\" class=\"btn btn-green\" ng-bind-html=\"createButtonStates[adding || false]\" ng-disabled=\"adding\"></button>\n        </div>\n    </div>\n    <div class=\"modal-body\">\n        <div ng-class=\"validations.displayName.error ? 'has-error':''\" class=\"field\">\n            <!-- <label class=\"control-label\" for=\"displayName\">{{::'case'|lexicon}} name</label> -->\n            <input placeholder=\"{{::'case'|lexicon}} name\" type=\"text\" class=\"field-entry\" id=\"displayName\" name=\"displayName\" ng-model=\"scratch.displayName\">\n            <!-- <div class=\"control-label\" ng-bind=\"validations.displayName.error\"></div> -->\n        </div>\n        <div class=\"field row\">\n            <label>\n                <input type=\"checkbox\" ng-model=\"copy.enabled\"> Copy an existing {{::'case'|lexicon:false:'lower'}}\n            </label>\n        </div>\n        <div uib-dropdown class=\"uib-dropdown dropdown-copy-case\" ng-class=\"validations.caseId.error ? 'has-error':''\" ng-if=\"copy.enabled\">\n            <button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle>\n                {{selectedCase.displayName || 'Select '+('case'|lexicon)}}\n                <div class=\"caret-container\"><span class=\"caret\"></span>\n                </div>\n            </button>\n            <div class=\"control-label\" ng-bind=\"validations.caseId.error\"></div>\n            <ul class=\"uib-dropdown-menu\" role=\"menu\">\n                <li ng-repeat=\"case in cases | filter:{status:'active'} | orderBy:'displayName'\">\n                    <a ng-click=\"selectCase(case)\" ng-bind=\"case.displayName\"></a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</form>\n"

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	module.exports = "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal-layer\" ng-style=\"{'z-index': 1050 + index*10}\" modal-in-class=\"open\" ng-click=\"close($event)\">\n    <div>\n        <div class=\"modal-container\" uib-modal-transclude></div>\n    </div>\n</div>\n"

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Delete Fact</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$dismiss()\">Cancel</span>\n            <span class=\"btn btn-red\" ng-click=\"$close()\">Delete</span>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body text-center\">\n  <p class=\"modal-text\">Deleting cannot be undone.</p>\n</div>"

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	module.exports = "<fb-fact fact=\"$ctrl.fact\" on-update=\"$ctrl.editFact(newFact)\" on-cancel=\"$dismiss()\"></fb-fact>\n"

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Delete {{::'issue'|lexicon}}</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <!-- <span class=\"btn\" ng-click=\"$dismiss()\">Close</span> -->\n        </div>\n    </div>\n</div>\n<div class=\"modal-body text-center\">\n    <h3>Are you sure you want to delete this {{::'issue'|lexicon:false:'lower'}}?</h3>\n    <p ng-show=\"hasChildren\">This {{::'issue'|lexicon:false:'lower'}} has sub{{::'issue'|lexicon:true:'lower'}}. Delete all will remove this {{::'issue'|lexicon:false:'lower'}} and all sub{{::'issue'|lexicon:true:'lower'}}. Reassign will reassign sub{{::'issue'|lexicon:true:'lower'}} and fact associations to a different {{::'issue'|lexicon:false:'lower'}}.</p>\n    <p ng-hide=\"hasChildren\">This cannot be undone. <span ng-show=\"hasFacts\">Associated Facts will be moved to 'Organize Later' unless reassigned.</span></p>\n    <button class=\"btn \" ng-click=\"$dismiss('cancel')\">Cancel</button>\n    <button class=\"btn btn-red \" ng-click=\"$close('delete')\">Delete {{hasChildren ? 'All' : ''}}\n    </button>\n    <button ng-show=\"hasFacts || hasChildren\" class=\"btn btn-green \" ng-click=\"$close('reassign')\">Reassign</button>\n</div>\n"

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Manage {{::'issue'|lexicon:true}}</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$dismiss()\">Close</span>\n            <span class=\"btn btn-blue\" ng-click=\"issuesCtrl.updateIssueOrder().then($close)\">Save</span>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body\">\n    <div ng-hide=\"issuesCtrl.addChild || issuesCtrl.reassign\">\n        <fb-editable name=\"Add Issue\" class=\"text-action top-issue-field\" on-update=\"issuesCtrl.createRootIssue(newValue)\"></fb-editable>\n    </div>\n    <div ng-show=\"issuesCtrl.reassign\">\n        <p><b>Please select {{(('lexicon'|lexicon)==='media')?'a':'an'}} {{::'issue'|lexicon:false:'lower'}} to reassign all of the facts and sub-{{::'issue'|lexicon:true:'lower'}} of \"{{issuesCtrl.reassign.data.displayName}}\" to:</b></p>\n        <ol class=\"select-list node-list modal-list\">\n            <ng-include ng-repeat=\"issue in issuesCtrl.issuesTree.data | emptyItem track by issue.id\" src=\"'issue-node.html'\"></ng-include>\n        </ol>\n    </div>\n    <fb-ol ng-hide=\"issuesCtrl.reassign\" class=\"modal-list\" on-delete=\"issuesCtrl.deleteIssue(value)\" on-create=\"issuesCtrl.createSubIssue(displayName,parent)\" on-update=\"issuesCtrl.updateIssue(newValue)\" values=\"issuesCtrl.issuesTree.data\"></fb-ol>\n    <div class=\"text-assist nav-item-text\">\n        <div ng-show=\"issuesCtrl.issuesTree.busy && !issuesCtrl.issuesTree.data.length\">\n            Loading {{::'issue'|lexicon:true}}&hellip;\n        </div>\n        <div ng-hide=\"issuesCtrl.issuesTree.data.length > 0 || issuesCtrl.issuesTree.busy\">\n            No {{::'issue'|lexicon:true}} Found\n        </div>\n    </div>\n    <div ng-show=\"issuesCtrl.reassign\">\n        <button ng-disabled=\"!issuesCtrl.reassign.data.to\" class=\"btn btn-success btn-round\" ng-click=\"issuesCtrl.requestDelete(issuesCtrl.reassign)\">Reassign</button>\n        <button class=\"btn btn-default btn-round\" ng-click=\"issuesCtrl.cancelReassign()\">Cancel</button>\n    </div>\n</div>\n<!-- Reassign node template -->\n<script type=\"text/ng-template\" id=\"issue-node.html\">\n    <li class=\"select-indicator item-node\" ng-class=\"issuesCtrl.reassign.data.to.id === issue.id?'disabled selected':''\">\n        <span ng-click=\"issuesCtrl.reassign.data.to = issue\" ng-bind=\"issue.displayName\"></span>\n        <ol ng-class=\"{'disabled': issuesCtrl.reassign.data.id === issue.id, hidden: collapsed}\" ng-if=\"issue.children.length\">\n            <ng-include ng-repeat=\"issue in issue.children\" src=\"'issue-node.html'\">\n            </ng-include>\n        </ol>\n    </li>\n</script>\n"

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-body\">\n    <div ng-hide=\"customerDone\">\n        <div class=\"card card-red-tint\" role=\"alert\" ng-if=\"paymentValidations.message\"><small ng-bind=\"paymentValidations.message\"></small></div>\n        <div ng-show=\"selectedPlan !== customer.plan.name\">\n            <p>Selected Plan: {{(plans | filter: {name: selectedPlan})[0].displayName}} Plan Billed {{{'year':'Yearly','month':'Monthly'}[previewPeriod]}}</p>\n        </div>\n        <div class=\"grid grid-gutters\">\n            <div class=\"grid-item\">\n                <label for=\"name\">Name</label>\n                <div class=\"field\" ng-class=\"{'name':'field-error'}[paymentValidations.param]\">\n                    <input type=\"text\" ng-model=\"newCard.name\" placeholder=\"Name on Card\" id=\"name\">\n                </div>\n            </div>\n        </div>\n        <div class=\"grid grid-gutters\">\n            <div class=\"grid-item\">\n                <label for=\"number\">Card</label>\n                <div class=\"field\" ng-class=\"{'number':'field-error'}[paymentValidations.param]\">\n                    <input type=\"text\" ng-model=\"newCard.number\" placeholder=\"Card Number\" id=\"number\">\n                </div>\n            </div>\n        </div>\n        <div class=\"grid grid-gutters\">\n            <div class=\"grid-item\">\n                <label for=\"exp_month\">Month</label>\n                <div class=\"field\" ng-class=\"{'exp_month':'field-error'}[paymentValidations.param]\">\n                    <input type=\"text\" ng-model=\"newCard.exp_month\" placeholder=\"MM\" id=\"exp_month\">\n                </div>\n            </div>\n            <div class=\"grid-item\">\n                <label for=\"exp_year\">Year</label>\n                <div class=\"field\" ng-class=\"{'exp_year':'field-error'}[paymentValidations.param]\">\n                    <input type=\"text\" ng-model=\"newCard.exp_year\" placeholder=\"YYYY\" id=\"exp_year\">\n                </div>\n            </div>\n            <div class=\"grid-item\"></div>\n            <div class=\"grid-item\">\n                <label for=\"cvc\">Code</label>\n                <div class=\"field\" ng-class=\"{'cvc':'field-error'}[paymentValidations.param]\">\n                    <input type=\"text\" ng-model=\"newCard.cvc\" placeholder=\"CVC\" id=\"cvc\">\n                </div>\n            </div>\n        </div>\n        <div class=\"grid grid-gutters\">\n            <div class=\"grid-item\">\n                <div class=\"text-right\">\n                    <small><a href=\"\" ng-click=\"showCouponEntry()\" ng-hide=\"couponEntryVisible\">Access Code</a></small>\n                </div>\n                <div ng-show=\"couponEntryVisible\" class=\"card card-blue-tint\" style=\"margin: 0\">\n                    <div ng-hide=\"couponValidation\">\n                        <form class=\"field\" ng-submit=\"validateCoupon()\">\n                            <input type=\"text\" ng-model=\"coupon.code\" placeholder=\"Access Code\" id=\"access-code\">\n                            <small><button class=\"btn btn-blue\" type=\"submit\">Validate</button></small>\n                        </form>\n                        <a href=\"\" ng-click=\"hideCouponEntry()\">Cancel</a>\n                    </div>\n                    <div ng-show=\"couponValidation\">\n                        <div>{{couponValidation}}</div>\n                        <a href=\"\" ng-click=\"hideCouponValidation()\">Reenter Code</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <button class=\"btn btn-green btn-block\" type=\"button\" ng-click=\"setCustomer(newCard)\" ng-disabled=\"settingCustomer\">{{settingCustomer ? 'Processing...' : 'Submit'}}</button>\n    </div>\n    <div ng-show=\"customerDone\">\n        <div class=\"grid grid-gutters\">\n            <h3 ng-show=\"fromTrial\" class=\"grid-item\"><i class=\"icon-check-thin\" style=\"padding-right:0.5em\"></i> {{(plans | filter: {name: selectedPlan})[0].displayName}} Plan Added</h3>\n            <h3 ng-hide=\"fromTrial\" class=\"grid-item\">Payment Updated</h3>\n            <div class=\"grid-item grid-item-fixed\">\n                <i ng-click=\"$dismiss()\" class=\"clickable icon-close\"></i>\n            </div>\n        </div>\n        <p ng-show=\"fromTrial\">Your account was upgraded to a {{(plans | filter: {name: selectedPlan})[0].displayName}} Plan, billed {{selectedPeriod}}ly. </p>\n        <p ng-show=\"fromTrial\">Would you like a free month of FactBox? Get one free month for every colleague you refer who signs up and adds a paid plan.</p>\n        <p ng-hide=\"fromTrial\">The payment information for your account was updated.</p>\n        <div class=\"text-right\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"modal.close()\">Close</button>\n            <button ng-show=\"fromTrial\" type=\"button\" class=\"btn btn-blue\" ng-click=\"modal.close();referralModal('Payment Modal')\">Refer a Colleague</button>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Give a month, get a month!</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$dismiss()\">Close</span>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body\">\n    <div class=\"modal-text\">\n        <p>When you refer colleagues that are new to FactBox and they sign up for a paid plan, you both get one month free!</p>\n    </div>\n    <div class=\"alert alert-danger card card-red-tint\" ng-show=\"response.error\"><i class=\"glyphicon glyphicon-exclamation-sign\"></i> Error sending emails, please try again.</div>\n    <div class=\"alert alert-success card card-green-tint\" ng-show=\"response.sent.length > 0\"><i class=\"glyphicon glyphicon-ok-sign\"></i> {{response.sent.length}} email{{response.sent.length > 1 ? 's' : ''}} sent.</div>\n    <div class=\"alert alert-warning card card-gold-tint\" ng-show=\"response.invalid.length > 0\">\n        <i class=\"glyphicon glyphicon-exclamation-sign\"></i> {{response.invalid.length}} email{{response.invalid.length > 1 ? 's' : ''}} not sent:\n        <ul class=\"list\">\n            <li ng-repeat=\"email in response.invalid\">{{email.email}}</li>\n        </ul>\n    </div>\n    <form ng-submit=\"inviteUsers()\">\n        <div ng-class=\"response.error ? 'has-error': response.invalid.length > 0 ? 'has-warning':response.sent.length > 0 ? 'has-success' : ''\" class=\"form-group grid-item\">\n            <label class=\"field-text\" for=\"emails\">Emails</label>\n            <div class=\"field\">\n                <textarea placeholder=\"Comma-separated list\" type=\"text\" class=\"form-control\" id=\"emails\" name=\"emails\" ng-model=\"users.string\"></textarea>\n            </div>\n            <div class=\"field-text\" ng-bind=\"response.message\"></div>\n        </div>\n        <button class=\"btn btn-primary btn-green btn-block\" ng-disabled=\"busy\" type=\"submit\"><i class=\"glyphicon glyphicon-envelope\"></i> {{busy ? 'Sending' : done ? 'Send More' : 'Send'}}</button>\n    </form>\n    <div class=\"row text-center\">\n        <span class=\"text-action\" ng-click=\"toggleReferrerLink()\">{{referrerLinkVisible ? 'Hide' : 'Show'}} your unique referral link</span>\n    </div>\n    <div class=\"field\" ng-show=\"referrerLinkVisible\">\n        <code style=\"height:auto\" class=\"field-entry\" ng-bind=\"referrerLink\"></code>\n    </div>\n</div>\n"

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"removePhone()\">\n<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Remove Phone</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$dismiss()\">Cancel</span>\n            <button type=\"submit\" ng-disabled=\"busy\" class=\"btn btn-blue btn-sm\" ng-bind=\"busy ? 'Confirming' : 'Confirm'\"></button>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body\">\n    <div class=\"field\" ng-class=\"error.error ? 'field-error' : ''\">\n        <input type=\"password\" name=\"password\" ng-model=\"password\" placeholder=\"Password\">\n    </div>\n    <p class=\"modal-text\" ng-hide=\"error\">Please enter your password to confirm.</p>\n    <div class=\"row text-red\" role=\"alert\" ng-show=\"error.error\">\n        <div class=\"modal-text\">\n            <p ng-bind=\"error.error\"></p>\n            <small ng-bind=\"error.details\"></small>\n        </div>\n    </div>\n</div>\n\n</form>"

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Remove User</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$dismiss()\">Close</span>\n            <button type=\"button\" ng-click=\"removeMember(selectedMember)\" ng-disabled=\"busy\" class=\"btn btn-red\" ng-bind=\"busy ? 'Removing' : 'Remove'\"></button>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body\">\n    <p class=\"modal-text\" ng-hide=\"error.error\">Are you sure you want to remove <b>{{::selectedMember.displayName}}</b> from your {{::'firm'|lexicon}}?</p>\n    <p class=\"modal-text text-red\" ng-show=\"error.error\" ng-bind=\"error.error\"></p>\n</div>\n"

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Re-establish Session</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$dismiss()\">Close</span>\n        </div>\n    </div>\n</div>\n<form class=\"modal-body\" role=\"form\" novalidate name=\"signinForm\" ng-submit=\"signin.submit(true)\">\n    <div status-row></div>\n    <ng-include src=\"'/signin/signin.fields.html'\"></ng-include>\n</form>\n"

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"nav-item-text\" ng-hide=\"sourcesCtrl.detail.newSource\">\n    <a ng-href=\"{{sourcesCtrl.selectedSource.link}}\" target=\"_blank\" ng-bind=\"sourcesCtrl.selectedSource.displayName\" title=\"{{sourcesCtrl.selectedSource.displayName}}\" target=\"_blank\"></a>\n</div>\n<div ng-show=\"sourcesCtrl.detail.editMode\" class=\"grid grid-nowrap grid-fill column\" ng-class=\"{true: 'box-list-updating'}[sourcesCtrl.sourceIntegrations[sourcesCtrl.selectedSource.format].currentFolder.updating]\">\n  <div class=\"grid-item-fixed nav-item-text\" ng-include=\"'/modals/sources/list-breadcrumb.box.html'\"></div>\n  <div class=\"grid-item nav-item-text\" ng-show=\"sourcesCtrl.detail.newSource\" ng-include=\"'/modals/sources/list-item.box.html'\">\n  </div>\n</div>\n"

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	module.exports = "<div ng-include=\"'/modals/sources/detail.box.html'\"></div>"

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	module.exports = "<div ng-include=\"'/modals/sources/detail.box.html'\"></div>\n"

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"field\" ng-class=\"{'field-error' : sourcesCtrl.detail.error.displayName.error}\" ng-show=\"sourcesCtrl.detail.editMode && !sourcesCtrl.detail.newSource\">\n    <input type=\"text\" class=\"form-control\" id=\"displayName\" placeholder=\"Enter File Name\" ng-model=\"sourcesCtrl.selectedSource.displayName\">\n    <label class=\"control-label\" for=\"name\" ng-show=\"sourcesCtrl.detail.error.displayName.error\" ng-bind=\"sourcesCtrl.detail.error.displayName.error\"></label>\n</div>\n<div class=\"nav-item-text\" ng-hide=\"sourcesCtrl.detail.editMode\">\n    <a ng-href=\"{{sourcesCtrl.selectedSource.link}}\" ng-bind=\"sourcesCtrl.selectedSource.displayName\" target=\"_blank\"></a>\n</div>\n<fb-upload ng-show=\"sourcesCtrl.detail.newSource\" on-success=\"sourcesCtrl.addFiles(files)\"></fb-upload>\n"

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"grid column row full-height\">\n    <div class=\"nav-source-detail\">\n        <div class=\"pull-left\" ng-show=\"sourcesCtrl.selectedSource\">\n            <h2 class=\"text-grid-center\"><i class=\"icon\" ng-class=\"sourcesCtrl.detail.icon\"></i></h2>\n        </div>\n        <!-- <div class=\"btn-group btn-group-sm pull-right\" uib-dropdown is-open=\"sourcesCtrl.newSourceDropdown.isOpen\">\n            <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"sourcesCtrl.typeFilter ? sourcesCtrl.newSource(sourcesCtrl.typeFilter): sourcesCtrl.toggleDropdown($event)\">New {{(sourcesCtrl.sourceTypes | filter: {name: sourcesCtrl.typeFilter} : true)[0].displayName}}</button>\n            <button type=\"button\" uib-dropdown-toggle class=\"btn btn-sm btn-default uib-dropdown-toggle\">\n                <span class=\"caret\"></span>\n                <span class=\"sr-only\">Toggle Dropdown</span>\n            </button>\n            <ul class=\"uib-dropdown-menu uib-dropdown-menu-right\" role=\"menu\">\n                <li ng-if=\"!type.disabled\" ng-repeat=\"type in sourcesCtrl.sourceTypes\" ng-click=\"sourcesCtrl.newSource(type.name)\"><a href>New {{type.displayName}}</a>\n                </li>\n            </ul>\n        </div> -->\n    </div>\n    <div class=\"grid-item\" id=\"source-manager-detail-form\">\n        <div ng-hide=\"sourcesCtrl.selectedSource\">\n            <h3 class=\"text-center\">No Source Selected</h3>\n        </div>\n        <div ng-show=\"sourcesCtrl.selectedSource\">\n            <div ng-include=\"sourcesCtrl.detail.template\"></div>\n        </div>\n    </div>\n    <div ng-show=\"sourcesCtrl.selectedSource\" class=\"nav-source-detail\" ng-class=\"{true:'disabled'}[detail.updating]\" ng-disabled=\"sourcesCtrl.detail.updating\">\n        <button type=\"button\" ng-click=\"sourcesCtrl.saveSource()\" class=\"btn btn-sm btn-default\" ng-show=\"sourcesCtrl.detail.editMode\">Save</button>\n        <button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"sourcesCtrl.detail.editMode\" ng-click=\"sourcesCtrl.cancelDetail()\">Cancel</button>\n        <button type=\"button\" class=\"btn btn-sm btn-default\" ng-hide=\"sourcesCtrl.detail.editMode\" ng-click=\"sourcesCtrl.detail.editMode = true\">Edit</button>\n        <button type=\"button\" class=\"btn btn-sm btn-default\" ng-hide=\"sourcesCtrl.detail.editMode\" ng-click=\"sourcesCtrl.deleteSource(sourcesCtrl.selectedSource)\">Delete</button>\n    </div>\n</div>\n"

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"field field-block\" ng-class=\"sourcesCtrl.detail.error.displayName.error ? 'field-error' : ''\">    \n    <input ng-show=\"sourcesCtrl.detail.editMode\" type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"Enter Name\" ng-model=\"sourcesCtrl.selectedSource.displayName\">\n    <label for=\"name\" ng-show=\"sourcesCtrl.detail.error.displayName.error\" ng-bind=\"sourcesCtrl.detail.error.displayName.error\"></label>\n</div>\n<div class=\"field field-block\" ng-class=\"sourcesCtrl.detail.error.url.error ? 'field-error' : ''\">    \n    <input ng-show=\"sourcesCtrl.detail.newSource\" type=\"text\" class=\"form-control\" id=\"url\" placeholder=\"Enter URL\" ng-model=\"sourcesCtrl.selectedSource.url\">\n    <label for=\"url\" ng-show=\"sourcesCtrl.detail.error.url.error\" ng-bind=\"sourcesCtrl.detail.error.url.error\"></label>\n</div>\n<div class=\"nav-item-text\" ng-hide=\"sourcesCtrl.detail.editMode\" class=\"ellipsis-overflow\" ng-bind=\"sourcesCtrl.selectedSource.displayName\"></div>\n<div class=\"nav-item-text\" ng-hide=\"sourcesCtrl.detail.newSource\" class=\"ellipsis-overflow\">\n    <a ng-href=\"{{sourcesCtrl.selectedSource.link}}\" ng-bind=\"sourcesCtrl.selectedSource.url\" target=\"_blank\"></a>\n</div>"

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	module.exports = "<p class=\"nav-item-text\" ng-hide=\"sourcesCtrl.detail.editMode\" ng-bind=\"sourcesCtrl.selectedSource.text\"></p>\n<div class=\"field field-block\" ng-class=\"sourcesCtrl.detail.error.text.error ? 'field-error' : ''\">\n  <textarea ng-show=\"sourcesCtrl.detail.editMode\" type=\"text\" class=\"form-control\" id=\"text\" placeholder=\"Enter Note\" ng-model=\"sourcesCtrl.selectedSource.text\"></textarea>\n  <label for=\"text\" ng-if=\"sourcesCtrl.detail.error.text.error\" ng-bind=\"sourcesCtrl.detail.error.text.error\"></label>\n</div>"

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	module.exports = "<div ng-show=\"sourcesCtrl.detail.editMode\">\n    <div class=\"field field-block\" ng-class=\"sourcesCtrl.detail.error.displayName.error ? 'field-error' : ''\">\n        <input type=\"text\" id=\"name\" placeholder=\"Enter Name\" ng-model=\"sourcesCtrl.selectedSource.displayName\">\n        <label for=\"name\" ng-show=\"sourcesCtrl.detail.error.displayName.error\" ng-bind=\"sourcesCtrl.detail.error.displayName.error\"></label>\n    </div>\n    <div class=\"field field-block\" ng-class=\"sourcesCtrl.detail.error.role.error ? 'field-error' : ''\">\n        <textarea type=\"text\" id=\"role\" placeholder=\"Enter Role\" ng-model=\"sourcesCtrl.selectedSource.role\"></textarea>\n        <label for=\"role\" ng-show=\"sourcesCtrl.detail.error.role.error\" ng-bind=\"sourcesCtrl.detail.error.role.error\"></label>\n    </div>\n    <div class=\"field field-block\">\n        <input type=\"email\" id=\"email\" placeholder=\"Enter Email\" ng-model=\"sourcesCtrl.selectedSource.email\">\n    </div>\n    <div class=\"field field-block\">\n        <input type=\"text\" id=\"phone\" placeholder=\"Enter Phone\" ng-model=\"sourcesCtrl.selectedSource.phone\">\n    </div>\n    <div class=\"field field-block\" ng-class=\"sourcesCtrl.detail.error.address.error ? 'field-error' : ''\">\n        <textarea type=\"text\" id=\"address\" placeholder=\"Enter Address\" ng-model=\"sourcesCtrl.selectedSource.address\"></textarea>\n        <label for=\"address\" ng-show=\"sourcesCtrl.detail.error.address.error\" ng-bind=\"sourcesCtrl.detail.error.address.error\"></label>\n    </div>\n</div>\n<div ng-hide=\"sourcesCtrl.detail.editMode\" class=\"nav-item-text\">\n    <p ng-bind=\"sourcesCtrl.selectedSource.displayName\"></p>\n    <p ng-bind=\"sourcesCtrl.selectedSource.role\"></p>\n    <p ng-bind=\"sourcesCtrl.selectedSource.email\"></p>\n    <p ng-bind=\"sourcesCtrl.selectedSource.phone\"></p>\n    <p ng-bind=\"sourcesCtrl.selectedSource.address\"></p>\n</div>\n"

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"field\" ng-class=\"{'field-error' : sourcesCtrl.detail.error.displayName.error}\" ng-show=\"sourcesCtrl.detail.editMode && !sourcesCtrl.detail.newSource\">\n    <input type=\"text\" id=\"displayName\" placeholder=\"Enter iManage Doc Name\" ng-model=\"sourcesCtrl.selectedSource.displayName\">\n    <label class=\"control-label\" for=\"name\" ng-show=\"sourcesCtrl.detail.error.displayName.error\" ng-bind=\"sourcesCtrl.detail.error.displayName.error\"></label>\n</div>\n<div class=\"nav-text\" ng-hide=\"sourcesCtrl.detail.editMode\">\n    <a ng-href=\"{{sourcesCtrl.selectedSource.link}}\" ng-bind=\"sourcesCtrl.selectedSource.displayName\" target=\"_blank\"></a>\n</div>\n<fb-upload ng-show=\"sourcesCtrl.detail.newSource\" on-success=\"sourcesCtrl.addFiles(files)\"></fb-upload>"

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports = "<span ng-if=\"sourcesCtrl.sourceIntegrations[sourcesCtrl.selectedSource.format].currentFolder.pathCollection[1]\" ng-click=\"sourcesCtrl.setCurrentFolder(sourcesCtrl.sourceIntegrations[sourcesCtrl.selectedSource.format].currentFolder.pathCollection[1])\">\n    <span class=\"text-blue\" ng-bind-html=\"sourcesCtrl.sourceIntegrations[sourcesCtrl.selectedSource.format].currentFolder.pathCollection[1].name | truncate : 15\"></span><span class=\"text-assist\">/</span>\n\n</span>\n<span ng-if=\"sourcesCtrl.sourceIntegrations[sourcesCtrl.selectedSource.format].currentFolder.pathCollection[0]\" ng-click=\"sourcesCtrl.setCurrentFolder(sourcesCtrl.sourceIntegrations[sourcesCtrl.selectedSource.format].currentFolder.pathCollection[0])\">\n    <span class=\"text-blue\" ng-bind-html=\"sourcesCtrl.sourceIntegrations[sourcesCtrl.selectedSource.format].currentFolder.pathCollection[0].name | truncate : 15\"></span><span class=\"text-assist\">/</span>\n</span>\n<span ng-bind-html=\"sourcesCtrl.sourceIntegrations[sourcesCtrl.selectedSource.format].currentFolder.name || 'Updating' | truncate : 15\"></span>\n"

/***/ }),
/* 868 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ellipsis-overflow\" ng-class=\"{'folder':'box-folder','file':'box-file'}[item.itemType]\" ng-repeat=\"item in sourcesCtrl.sourceIntegrations[sourcesCtrl.selectedSource.format].currentFolder.entries | orderBy : 'name'\" tabindex=\"{{$index}}\" ng-click=\"sourcesCtrl.selectBoxItem(item)\">\n    <span title=\"{{item.name}}\" class=\"ellipsis-overflow\"><span class=\"icon\" ng-class=\"'icon-'+item.itemType\"></span> {{item.name}}</span>\n</div>\n<div ng-hide=\"sourcesCtrl.sourceIntegrations[sourcesCtrl.selectedSource.format].currentFolder.entries.length > 0\" class=\"disabled\"><a href>No Files</a>\n</div>\n"

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	module.exports = "<!-- <div class=\"grid column row full-height\">\n    <div class=\"nav-sort-search input-group input-group-sm\">\n        <div class=\"input-group-btn input-group-sm\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"sourcesCtrl.setSortFilter('+displayName')\" ng-class=\"{'active':sourcesCtrl.sortFilter === '+displayName'}\">\n                <i class=\"glyphicon glyphicon-sort-by-alphabet\"></i>\n            </button>\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"sourcesCtrl.setSortFilter('-displayName')\" ng-class=\"{'active':sourcesCtrl.sortFilter === '-displayName'}\">\n                <i class=\"glyphicon glyphicon-sort-by-alphabet-alt\"></i>\n            </button>\n        </div>\n        <input type=\"text\" class=\"form-control\" placeholder=\"Search\" ng-model=\"sourcesCtrl.searchQuery\" ng-change=\"sourcesCtrl.setSearchFilter(sourcesCtrl.searchQuery)\">\n    </div>\n    <div class=\"grid-item\" id=\"source-manager-list\"> -->\n<ul class=\"list-unstyled\">\n    <li class=\"active\" ng-repeat=\"type in sourcesCtrl.sourceTypes | filter:{name: sourcesCtrl.selectedSource.format} : true\" ng-show=\"sourcesCtrl.detail.newSource\"><a href><i>New {{type.displayName}}</i></a>\n    </li>\n    <li class=\"ellipsis-overflow\" ng-repeat=\"source in sourcesCtrl.filteredSources\" ng-click=\"sourcesCtrl.setDetail(source)\" tabindex=\"{{$index}}\" fb-on-delete=\"sourcesCtrl.deleteSource(source)\" ng-class=\"sourcesCtrl.selectedSource.id === source.id ? 'active' : 'clickable'\">\n        <a href ng-bind=\"source.displayName\" class=\"ellipsis-overflow\"></a>\n    </li>\n    <li ng-show=\"sourcesCtrl.sourcesTree.busy && !sourcesCtrl.sourcesTree.data.length\" class=\"disabled\"><a href>Loading Sources&hellip;</a></li>\n    <li ng-hide=\"sourcesCtrl.filteredSources.length > 0 || sourcesCtrl.detail.newSource || sourcesCtrl.sourcesTree.busy\" class=\"disabled\"><a href>No Sources Found</a>\n    </li>\n    <li ng-repeat=\"type in sourcesCtrl.sourceTypes | filter:{name: sourcesCtrl.typeFilter} : true\" ng-hide=\"sourcesCtrl.filteredSources.length > 0 || sourcesCtrl.detail.newSource\" ng-click=\"sourcesCtrl.newSource(type.name)\"><a href>Add {{type.displayName}}<i class=\"icon-chevron-right\"></i></a>\n    </li>\n</ul>\n<!--     </div>\n</div>\n -->\n"

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"grid\">\n    <div class=\"grid-item-fixed\" uib-dropdown>\n        <button uib-dropdown-toggle type=\"button\" class=\"btn btn-default uib-dropdown-toggle\">{{!sourcesCtrl.typeFilter ? 'All Sources' : (sourcesCtrl.sourceTypes | filter: {name: sourcesCtrl.typeFilter} : true)[0].pluralName}} <span class=\"caret\"></span>\n        </button>\n        <ul class=\"uib-dropdown-menu\" role=\"menu\">\n            <li ng-class=\"{'active':!sourcesCtrl.typeFilter}\" ng-click=\"sourcesCtrl.setTypeFilter()\">\n                <a href>All Sources</a>\n            </li>\n            <li ng-if=\"!type.disabled\" ng-repeat=\"type in sourcesCtrl.sourceTypes\" ng-class=\"{'active':sourcesCtrl.typeFilter === type.name}\" ng-click=\"sourcesCtrl.setTypeFilter(type.name)\">\n                <a href><i ng-class=\"type.icon\"></i> {{type.pluralName}}</a>\n            </li>\n        </ul>\n    </div>\n    <div class=\"grid-item\">\n        <div class=\"field\">\n            <div class=\"btn-group\">\n                <span class=\"btn\" ng-click=\"sourcesCtrl.setSortFilter('+displayName')\" ng-class=\"{'active':sourcesCtrl.sortFilter === '+displayName'}\">\n                  Asc\n              </span>\n                <span class=\"btn\" ng-click=\"sourcesCtrl.setSortFilter('-displayName')\" ng-class=\"{'active':sourcesCtrl.sortFilter === '-displayName'}\">\n                  Desc\n              </span>\n            </div>\n            <input type=\"text\" placeholder=\"Filter Sources\" ng-model=\"sourcesCtrl.searchQuery\" ng-change=\"sourcesCtrl.setSearchFilter(sourcesCtrl.searchQuery)\">\n        </div>\n    </div>\n    <div class=\"grid-item-fixed\">\n        <div uib-dropdown is-open=\"sourcesCtrl.newSourceDropdown.isOpen\">\n            <div class=\"btn-group\">\n                <button type=\"button\" class=\"btn\" ng-click=\"sourcesCtrl.typeFilter ? sourcesCtrl.newSource(sourcesCtrl.typeFilter): sourcesCtrl.toggleDropdown($event)\">New {{(sourcesCtrl.sourceTypes | filter: {name: sourcesCtrl.typeFilter} : true)[0].displayName}}</button>\n                <button type=\"button\" uib-dropdown-toggle class=\"btn btn-sm btn-default uib-dropdown-toggle\">\n                    <span class=\"lf-caret\"></span>\n                    <!-- <span class=\"sr-only\">Toggle Dropdown</span> -->\n                </button>\n            </div>\n            <ul class=\"uib-dropdown-menu dropdown-menu-right\" role=\"menu\">\n                <li ng-if=\"!type.disabled\" ng-repeat=\"type in sourcesCtrl.sourceTypes\" ng-click=\"sourcesCtrl.newSource(type.name)\"><a href>New {{type.displayName}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n<!-- <div class=\"row\">\n    <ul class=\"nav nav-select\">\n        <li ng-class=\"{'active':!sourcesCtrl.typeFilter}\" ng-click=\"sourcesCtrl.setTypeFilter()\" style=\"margin:12px 0\"><a href>All Sources</a>\n        </li>\n        <li ng-if=\"!type.disabled\" ng-repeat=\"type in sourcesCtrl.sourceTypes\" ng-class=\"{'active':sourcesCtrl.typeFilter === type.name}\" ng-click=\"sourcesCtrl.setTypeFilter(type.name)\">\n            <a href><i ng-class=\"type.icon\"></i> {{type.pluralName}}</a>\n        </li>\n    </ul>\n</div>\n -->\n"

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"grid grid-nowrap grid-fill column\">\n    <div class=\"grid-item-fixed modal-header\">\n        <div class=\"grid\">\n            <div class=\"grid-item nav-item-text\">\n                <b>Manage Sources</b>\n            </div>\n            <div class=\"grid-item-fixed\">\n                <span class=\"btn\" ng-click=\"$close()\">Close</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"grid-item container-grid-fill\">\n        <div id=\"source-manager\" class=\"grid grid-fill grid-nowrap\">\n            <!-- <div class=\"col-xs-3\" id=\"source-manager-type-nav\" ng-include=\"'/modals/sources/type-nav.html'\"></div>\n            <div class=\"col-xs-4\" id=\"source-manager-list-nav\" ng-include=\"'/modals/sources/list.html'\"></div>\n            <div class=\"col-xs-5\" id=\"source-manager-detail\" ng-include=\"'/modals/sources/detail.html'\"></div> -->\n            <!-- Nav -->\n            <div class=\"grid-item grid-item-1of4 sidebar-left row navbar\">\n                <div ng-class=\"{'selected':!sourcesCtrl.typeFilter}\" class=\"btn btn-block\" ng-click=\"sourcesCtrl.setTypeFilter()\">\n                    All Sources\n                </div>\n                <div ng-if=\"!type.disabled\" ng-repeat=\"type in sourcesCtrl.sourceTypes\" ng-class=\"{'selected':sourcesCtrl.typeFilter === type.name}\" class=\"btn btn-block\" ng-click=\"sourcesCtrl.setTypeFilter(type.name)\">\n                    <span ng-class=\"type.icon\"></span> {{type.pluralName}}\n                </div>\n            </div>\n            <!-- List -->\n            <div class=\"grid-item container-grid-fill\">\n                <div class=\"grid column grid-fill grid-nowrap\">\n                    <div class=\"grid-item-fixed field navbar row\" style=\"padding-bottom: 0\">\n                        <!-- <div class=\"btn-group\">\n                            <span class=\"btn\" ng-click=\"sourcesCtrl.setSortFilter('+displayName')\" ng-class=\"{'selected':sourcesCtrl.sortFilter === '+displayName'}\">\n                              Asc\n                          </span>\n                            <span class=\"btn\" ng-click=\"sourcesCtrl.setSortFilter('-displayName')\" ng-class=\"{'selected':sourcesCtrl.sortFilter === '-displayName'}\">\n                              Desc\n                          </span>\n                        </div> -->\n                        <input type=\"text\" placeholder=\"Filter Sources\" ng-model=\"sourcesCtrl.searchQuery\" ng-change=\"sourcesCtrl.setSearchFilter(sourcesCtrl.searchQuery)\">\n                    </div>\n                    <div class=\"grid-item navbar\" style=\"padding-top:0.25em;padding-bottom: 0.25em;\">\n                        <div class=\"node-list\" id=\"source-list\">\n                            <div ng-repeat=\"source in sourcesCtrl.filteredSources\" ng-click=\"sourcesCtrl.setDetail(source)\" tabindex=\"{{$index}}\" fb-on-delete=\"sourcesCtrl.deleteSource(source)\" ng-class=\"sourcesCtrl.selectedSource.id === source.id ? 'selected' : 'clickable'\" class=\"btn btn-block\" ng-bind=\"source.displayName\">\n                            </div>\n                            <div ng-show=\"sourcesCtrl.sourcesTree.busy && !sourcesCtrl.sourcesTree.data.length\" class=\"disabled\" class=\"text-assist nav-item-text\">Loading Sources&hellip;</div>\n                            <div ng-hide=\"sourcesCtrl.filteredSources.length > 0 || sourcesCtrl.detail.newSource || sourcesCtrl.sourcesTree.busy\">\n                                <div class=\"text-assist nav-item-text\">No Sources Found</div>\n                                <div class=\"text-action btn btn-block\" ng-repeat=\"type in sourcesCtrl.sourceTypes | filter:{name: sourcesCtrl.typeFilter} : true\" ng-click=\"sourcesCtrl.newSource(type.name)\">Add {{type.displayName}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <!-- Detail -->\n            <div class=\"grid-item container-grid-fill sidebar-right\">\n                <div class=\"grid grid-fill column grid-nowrap\">\n                    <div class=\"grid-item-fixed navbar row\" style=\"padding-bottom:0.25em\">\n                        <div uib-dropdown is-open=\"sourcesCtrl.newSourceDropdown.isOpen\">\n                            <div class=\"btn-group\">\n                                <span class=\"btn btn-outline\" ng-click=\"sourcesCtrl.typeFilter ? sourcesCtrl.newSource(sourcesCtrl.typeFilter): sourcesCtrl.toggleDropdown($event)\">Add {{(sourcesCtrl.sourceTypes | filter: {name: sourcesCtrl.typeFilter} : true)[0].displayName}} Source</span>\n                                <span uib-dropdown-toggle class=\"btn btn-condensed btn-outline\">\n                                        <span class=\"lf-caret\"></span>\n                                <!-- <span class=\"sr-only\">Toggle Dropdown</span> -->\n                                </span>\n                            </div>\n                            <ul class=\"uib-dropdown-menu\" role=\"menu\">\n                                <li ng-if=\"!type.disabled\" ng-repeat=\"type in sourcesCtrl.sourceTypes\" ng-click=\"sourcesCtrl.newSource(type.name)\">New {{type.displayName}}</li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div ng-hide=\"sourcesCtrl.selectedSource\" class=\"navbar row grid-item\">\n                        <div class=\"nav-item-text\">No Source Selected</div>\n                    </div>\n                    <ng-include class=\"grid-item container-grid-fill navbar\" ng-show=\"sourcesCtrl.selectedSource\" src=\"sourcesCtrl.detail.template\"></ng-include>\n                    <div ng-show=\"sourcesCtrl.selectedSource\" class=\"grid-item-fixed grid navbar row\">\n                        <div class=\"grid-item text-assist nav-item-text\">\n                            <i class=\"icon assist-icon\" ng-class=\"sourcesCtrl.detail.icon\"></i>\n                        </div>\n                        <div class=\"grid-item-fixed\" ng-class=\"{'disabled':detail.updating}\" ng-disabled=\"sourcesCtrl.detail.updating\">\n                            <span class=\"btn\" ng-show=\"sourcesCtrl.detail.editMode\" ng-click=\"sourcesCtrl.cancelDetail()\">Cancel</span>\n                            <span ng-click=\"sourcesCtrl.saveSource()\" class=\"btn text-action\" ng-show=\"sourcesCtrl.detail.editMode\">Save</span>\n                            <span class=\"btn\" ng-hide=\"sourcesCtrl.detail.editMode\" ng-click=\"sourcesCtrl.deleteSource(sourcesCtrl.selectedSource)\">Delete</span>\n                            <span class=\"btn text-action\" ng-hide=\"sourcesCtrl.detail.editMode\" ng-click=\"sourcesCtrl.detail.editMode = true\">Edit</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b ng-bind=\"::{'account':'Your account plan has expired.','case':'Add a Plan','trial':'Upgrade to a Paid Plan'}[key]\"></b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$dismiss()\">Close</span>\n            <span class=\"btn btn-blue\" ng-click=\"upgrade()\">Upgrade</span>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body text-center\">\n    <div class=\"nav-item-text\" ng-switch=\"::key\">\n        <p ng-switch-when=\"account\">You can still contribute to the {{::'case'|lexicon:true}} to which you were invited. However, to access full functionality on {{::'case'|lexicon:true}} you created or to create new {{::'case'|lexicon:true}}. Please upgrade to a paid plan.</p>\n        <p ng-switch-when=\"case\">There is currently no payment attached to this case, '{{object.displayName}}'. Please upgrade to a paid plan.</p>\n        <p ng-switch-when=\"trial\">There are currently {{object.daysRemaining}} days remaining in your trial. Upgrade to a paid plan today!</p>\n    </div>\n    <div class=\"alert alert-success\" ng-if=\"::referrer.email\">\n        <i class=\"icon-gift\"></i> <span ng-show=\"referrer.variation === 0\">By adding a Plan, you'll get your first month of FactBox free.</span> <span ng-hide=\"referrer.variation === 0\">You'll get your first month of FactBox free and your referrer, {{referrer.email}}, will get their next month free!</span>\n    </div>\n</div>\n"

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"modal-body\" role=\"form\" ng-submit=\"setCustomer()\">\n    <p ng-if=\"selectedPlan !== customer.plan.name\">Your plan will be updated to:</p>\n    <div class=\"card card-blue-tint text-center\" ng-if=\"selectedPlan !== customer.plan.name\"><b>{{(plans | filter: {name: selectedPlan})[0].displayName}}</b></div>\n    <p ng-if=\"selectedPeriod !== customer.plan.period\">Your billing period will be updated to:</p>\n    <div class=\"card card-blue-tint text-center\" ng-if=\"selectedPeriod !== customer.plan.period\"><b>{{{'year':'Yearly','month':'Monthly'}[selectedPeriod]}}</b></div>\n    <button ng-disabled=\"settingCustomer\" class=\"btn btn-green btn-block\" type=\"submit\">{{settingCustomer ? 'Updating' : 'Update'}} {{selectedPeriod !== customer.plan.period ? 'Billing Period' : 'Plan'}}{{settingCustomer ? '...' : ''}}</button>\n</form>\n"

/***/ }),
/* 874 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"nav-item-text\">\n        <b>Delete Tag</b>\n    </div>\n</div>\n<div class=\"modal-body text-center\">\n    <h4>Deleting can't be undone.</h4>\n    <span class=\"btn\" ng-click=\"$dismiss()\">Cancel</span>\n    <span class=\"btn btn-red\" ng-click=\"$close()\">Delete</span>\n</div>\n"

/***/ }),
/* 875 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>Manage Tags</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <span class=\"btn\" ng-click=\"$close()\">Close</span>\n        </div>\n    </div>\n</div>\n<div class=\"modal-body\">\n    <fb-editable class=\"text-action\" name=\"Add Tag\" on-update=\"tagsCtrl.createTag(newValue)\"></fb-editable>\n    <div class=\"text-assist nav-item-text\" ng-show=\"tagsCtrl.tags.busy && !tagsCtrl.tags.data.length\">Loading&hellip;</div>\n    <fb-ol class=\"modal-list\" disable-create=\"true\" disable-drag=\"true\" on-delete=\"tagsCtrl.deleteTag(value)\" on-update=\"tagsCtrl.updateTag(newValue)\" values=\"tagsCtrl.tags.data\"></fb-ol>\n</div>\n"

/***/ }),
/* 876 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-body\" ng-hide=\"fallbackVisible\" style=\"padding: 2em 3.375em\">\n    <h1>Hi {{user.firstName}}!</h1>\n    <p>Welcome to FactBox – we’re glad you’re here. Would you like an overview?\n    </p>\n    <p>\n        We’ll quickly guide you through the basics in FactBox and help you create and add facts to your first case. Ready?</p>\n    <button class=\"btn btn-green\" type=\"button\" ng-click=\"startTour()\">Start the Overview</button>\n    <button class=\"btn\" id=\"skip-guide\" type=\"button\" ng-click=\"fallbackVisible = true\">Skip</button>\n</div>\n<div class=\"modal-body\" ng-show=\"fallbackVisible\" style=\"padding: 2em 3.375em\">\n    <h1>One Last Thing!</h1>\n    <p>\n        To learn more, click the <small><i class=\"glyphicon glyphicon-info-sign\"></i></small> in the top right corner of the window. From there, you can run the Overview Guide or visit the Help Page.\n    </p>\n    <button class=\"btn\" id=\"close-overview\" type=\"button\" ng-click=\"$dismiss()\">Close</button>\n</div>\n"

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	module.exports = "<header-nav user-menu=\"true\" class=\"small header-darkteal navbar-admin\"></header-nav>\n<main class=\"page-content\">\n    <section class=\"section-nav header-darkteal\">\n        <div class=\"container\">\n            <h1 class=\"text-center\">Account Profile</h1>\n            <nav class=\"nav-btn-container text-center\">\n                <span class=\"btn\" ng-class=\"{'profile':'active'}[tab]\" ng-click=\"tab='profile'\">\n                My Profile</span>\n                <span class=\"btn\" ng-class=\"{'firm':'active'}[tab]\" ng-click=\"tab='firm'\">\n                My {{::'firm'|lexicon}}</span>\n            </nav>\n        </div>\n    </section>\n    <section class=\"section section-default tint-gray\">\n        <div class=\"container\">\n            <div ng-show=\"tab === 'profile'\">\n                <form role=\"form\" ng-submit=\"update()\">\n                    <div class=\"grid grid-gutters grid-center\">\n                        <div class=\"grid-item\">\n                            <h3>User Info</h3>\n                        </div>\n                        <div class=\"grid-item grid-item-fixed\">\n                            <button class=\"btn btn-default\" ng-hide=\"edit\" type=\"button\" ng-click=\"edit = 1\">Edit</button>\n                            <button class=\"btn btn-green\" ng-show=\"edit\" type=\"submit\">Done</button>\n                        </div>\n                    </div>\n                    <div class=\"card card-default \">\n                        <div class=\"card card-red-tint\" ng-show=\"nameValidations.error\" ng-bind=\"nameValidations.error\"></div>\n                        <div class=\"card card-green-tint\" ng-show=\"nameValidations.success\" ng-bind=\"nameValidations.success\"></div>\n                        <div>\n                            <div class=\"grid grid-gutters\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">First Name</div>\n                                <div class=\"grid-item\" ng-hide=\"edit\" ng-bind=\"user.firstName\"></div>\n                                <div class=\"grid-item field\">\n                                    <input type=\"text\" name=\"firstName\" ng-model=\"user.firstName\" ng-show=\"edit\">\n                                </div>\n                            </div>\n                            <div class=\"grid grid-gutters\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Last Name</div>\n                                <div class=\"grid-item\" ng-hide=\"edit\" ng-bind=\"user.lastName\"></div>\n                                <div class=\"grid-item field\">\n                                    <input type=\"text\" name=\"lastName\" ng-model=\"user.lastName\" ng-show=\"edit\">\n                                </div>\n                            </div>\n                            <div class=\"grid grid-gutters\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Email</div>\n                                <div class=\"grid-item\">\n                                    <span ng-bind=\"user.email\"></span>\n                                </div>\n                                <div class=\"grid-item grid-item-fixed\">\n                                    <span class=\"label\" ng-click=\"verifyModal(user.verified)\" ng-class=\"user.verified ? 'label-green' : 'label-gold clickable'\" ng-bind=\"user.verified ? 'Verified' : 'Unverified'\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n                <form role=\"form\" ng-submit=\"changePassword()\">\n                    <div class=\"grid grid-gutters grid-center\">\n                        <div class=\"grid-item\">\n                            <h2>Password</h2>\n                        </div>\n                        <div class=\"grid-item grid-item-fixed\">\n                            <button class=\"btn btn-default\" ng-hide=\"editPassword\" type=\"button\" ng-click=\"editPassword = 1\">Change</button>\n                            <button class=\"btn btn-default\" ng-show=\"editPassword\" type=\"button\" ng-click=\"cancelPassword()\">Cancel</button>\n                            <button ng-show=\"editPassword\" class=\"btn btn-green\" type=\"submit\">Submit</button>\n                        </div>\n                    </div>\n                    <div class=\"card card-default \">\n                        <div class=\"card card-red-tint\" ng-show=\"passwordValidations.error\" ng-bind=\"passwordValidations.error\"></div>\n                        <div class=\"card card-green-tint\" ng-show=\"passwordValidations.success\" ng-bind=\"passwordValidations.success\"></div>\n                        <div>\n                            <div class=\"grid grid-gutters\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Current Password</div>\n                                <div class=\"grid-item\" ng-hide=\"editPassword\">&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;</div>\n                                <div class=\"grid-item field\" ng-class=\"passwordValidations.password.error ? 'field-error' : ''\">\n                                    <input ng-show=\"editPassword\" type=\"password\" ng-model=\"change.password\">\n                                </div>\n                            </div>\n                            <div ng-show=\"editPassword\" class=\"grid grid-gutters\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">New Password</div>\n                                <div class=\"grid-item field\" ng-class=\"passwordValidations.newPassword.error ? 'field-error' : ''\">\n                                    <input ng-show=\"editPassword\" type=\"password\" ng-model=\"change.newPassword\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n                <form role=\"form\" ng-submit=\"addPhone()\">\n                    <div class=\"grid grid-gutters grid-center\">\n                        <div class=\"grid-item\">\n                            <h2>Two-Factor Authentication</h2>\n                        </div>\n                    </div>\n                    <div class=\"card card-default \">\n                        <div class=\"card card-red-tint\" role=\"alert\" ng-show=\"phone.error\">\n                            <p ng-bind=\"phone.error.error\"></p>\n                            <small ng-bind=\"phone.error.details\"></small>\n                        </div>\n                        <div ng-hide=\"phone.phoneNumber || phone.error\">\n                            <p>Adding your phone number enables two-factor authentication on your user account. When signing in, you'll be prompted to enter the code sent to your device by <a href=\"https://www.authy.com/users\" target=\"_blank\">Authy</a> via the Authy app or SMS.</p>\n                        </div>\n                        <div ng-show=\"phone.phoneNumber\">\n                            <p>Two-factor authentication is enabled on your user account. When signing in, you'll be prompted to enter the code sent to your device by <a href=\"https://www.authy.com/users\" target=\"_blank\">Authy</a> via the Authy app or SMS.</p>\n                            <p>If you use the desktop app, be sure to get the latest version <a href=\"/app/#/download\" target=\"_blank\">here</a>. Two-factor authentication requires the current version.</p>\n                        </div>\n                        <div class=\"grid grid-gutters\" ng-show=\"phone.edit\">\n                            <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Country</div>\n                            <div class=\"grid-item field\">\n                                <select class=\"field-select\" ng-model=\"phone.country\" ng-options=\"country as country.name for country in countries\">\n                                </select>\n                            </div>\n                        </div>\n                        <div class=\"grid grid-gutters\">\n                            <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Phone Number</div>\n                            <div class=\"grid-item\" ng-hide=\"phone.edit\">\n                                <span ng-show=\"phone.phoneNumber\">+{{phone.country.code}} {{phone.phoneNumber | tel}}</span>\n                                <a href=\"\" class=\"inline-space\" ng-click=\"removePhoneModal()\" ng-show=\"phone.phoneNumber\">Remove</i></a>\n                                <a href=\"\" ng-click=\"editPhone()\" ng-hide=\"phone.phoneNumber\">Add Phone <i class=\"icon-circle-plus\"></i></a>\n                            </div>\n                            <div class=\"grid-item field\" ng-class=\"phone.error.details ? 'field-error' : ''\" ng-show=\"phone.edit\">\n                                <input type=\"tel\" class=\"field-entry\" name=\"phoneNumber\" ng-model=\"phone.phoneInput\" ng-change=\"setPhoneNumber()\">\n                            </div>\n                            <div class=\"grid-item grid-item-fixed\" ng-show=\"phone.edit\">\n                                <button class=\"btn btn-blue btn-sm\" type=\"submit\" ng-disabled=\"phone.busy\" ng-bind=\"phone.busy ? 'Verifying' : 'Verify'\"></button>\n                                <a href=\"\" class=\"inline-space\" ng-click=\"phone.edit = false\">Cancel</a>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n                <div class=\"r row-spaced\">\n                    <h3 ng-show=\"user.integrations.clio.available\" class=\"account-heading\">User Integrations</h3>\n                    <div ng-show=\"user.integrations.clio.available\" class=\"card card-default \">\n                        <!-- Clio Integration Container -->\n                        <div class=\"grid\" ng-click=\"showClio = !showClio\">\n                            <div class=\"grid-item grid-item-fixed\">\n                                <div class=\"integration-image image-source-clio\" style=\"width:75.5px\"></div>\n                            </div>\n                            <div class=\"grid-item text-right\">\n                                <a style=\"padding-right: 1em\" href=\"\">Info</a>\n                                <span>\n                                    <button ng-hide=\"user.integrations.clio.connected\" type=\"button\" class=\"btn btn-green\" ng-click=\"openClioAuth($event,true)\">Connect</button>\n                                    <button ng-show=\"user.integrations.clio.connected\" type=\"button\" class=\"btn btn-default\" ng-click=\"disconnectClio($event,true)\">Disconnect</button>\n                                </span>\n                            </div>\n                        </div>\n                        <div ng-show=\"showClio\">\n                            <!-- Clio Integration Context -->\n                            <p>\n                                <a href=\"https://www.goclio.com/\" target=\"_blank\">Website</a>\n                                <a ng-href=\"/help#integrations\" target=\"_blank\">Help</a>\n                            </p>\n                            <!-- Clio Integration Information -->\n                            <p>\n                                Automatically track your time working on Clio Matters in FactBox.\n                            </p>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Integrates With</div>\n                                <div class=\"grid-item\">Cases and Sources</div>\n                            </div>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Account</div>\n                                <div class=\"grid-item\" ng-bind=\"user.integrations.clio.connectedAs || 'Unknown'\"></div>\n                            </div>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Status</div>\n                                <div class=\"grid-item\"><span class=\"label\" ng-class=\"user.integrations.clio.connected ? 'label-green' : 'label-gold'\" ng-bind=\"user.integrations.clio.connected ? 'Connected' : 'Not Connected'\"></span></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-show=\"tab === 'firm'\">\n                <h2><b ng-bind=\"account.displayName\"></b></h2>\n                <div class=\"r row-spaced\">\n                    <div class=\"card card-default\">\n                        <h3>Members</h3>\n                        <!-- <div class=\"grid grid-gutters\">\n                            <div class=\"grid-item\">\n                                <p ng-bind=\"customer.statusMessage\"></p>\n                            </div>\n                        </div> -->\n                        <div class=\"grid grid-gutters\" ng-hide=\"showNewMember\">\n                            <div class=\"grid-item\">\n                                <p ng-show=\"customer.plan.limits.contributors\">\n                                    Your {{ ::'firm' | lexicon }} is currently using {{members.length}} of the {{customer.plan.limits.contributors}} Member{{customer.plan.limits.contributors !== 1?'s':''}} allowed by your Plan. <a ng-show=\"members.length > customer.plan.limits.contributors\" href ng-click=\"scrollTo('plans')\">Upgrade</a>\n                                </p>\n                                <p ng-hide=\"customer.plan.limits.contributors\">\n                                    Your {{ ::'firm' | lexicon }} currently has {{members.length}} Member{{members.length !== 1?'s':''}}.\n                                </p>\n                                <p ng-show=\"customer.user.role === 'admin' && !user.verified\">\n                                    <small class=\"text-blue\">\n                                        Please verify your email address to manage {{::'contributors'|lexicon}}. <a href=\"\" ng-click=\"showMemberEntry()\">More Info</a>\n                                    </small>\n                                </p>\n                            </div>\n                            <div class=\"grid-item grid-item-fixed\" ng-show=\"customer.user.role === 'admin'\">\n                                <button class=\"btn btn-green\" type=\"button\" ng-click=\"showMemberEntry()\">Add</button>\n                            </div>\n                        </div>\n                        <div ng-if=\"showNewMember && !user.verified\" class=\"card card-blue\">\n                            <p>Please verify your email address using the link provided in the confirmation email. For security purposes, FactBox requires users to verify their email address to manage members.</p>\n                            <p>If you did not recieve the confirmation email, please contact us:</p>\n                            <ul class=\"list-unstyled\">\n                                <li><a style=\"color:white\" href=\"tel:4152879922\" title=\"\">(415) 287-9922</a></li>\n                                <li><a style=\"color:white\" href=\"mailto:tech@lynxworkflow.com?subject=Account Verification Email&body=I have signed up for FactBox, but have not received a verification email or cannot find it. Please verify my account.\">tech@lynxworkflow.com</a></li>\n                            </ul>\n                            <button class=\"btn btn-lighten\" type=\"button\" tabindex=\"-1\" ng-click=\"cancelNewMember()\">Close</button>\n                        </div>\n                        <form role=\"form\" novalidate name=\"newMemberForm\" ng-submit=\"addMember()\" class=\"grid grid-gutters grid-full large-grid-fit\" ng-show=\"showNewMember && user.verified\">\n                            <div class=\"grid-item\">\n                                <div class=\"grid grid-gutters\">\n                                    <div class=\"grid-item field\">\n                                        <input type=\"email\" ng-disabled=\"newMember.data.newUser\" class=\"input-lg\" placeholder=\"Email\" name=\"userEmail\" ng-model=\"newMember.data.email\">\n                                    </div>\n                                    <div class=\"grid-item grid-item-fixed\">\n                                        <span uib-dropdown>\n                                            <div class=\"btn btn-default\" uib-dropdown-toggle>{{newMember.data.role | lexicon | titlecase}} <i class=\"lf-caret\"></i>\n                                            </div>\n                                            <ul class=\"uib-dropdown-menu dropdown-menu-gray\" class=\"\">\n                                                <li uib-dropdown-item ng-repeat=\"role in customer.roleNames\">\n                                                    <a href ng-click=\"selectRole(role)\" ng-bind=\"role | lexicon | titlecase\"></a>\n                                                </li>\n                                            </ul>\n                                        </span>\n                                    </div>\n                                </div>\n                                <div class=\"grid grid-gutters\" ng-show=\"newMember.data.newUser\">\n                                    <div class=\"grid-item field\" ng-class=\"{'field-error': newMember.error.data.firstName.error}\">\n                                        <input type=\"text\" ng-disabled=\"newMember.busy\" placeholder=\"First Name\" name=\"newMemberFirstName\" ng-model=\"newMember.data.firstName\">\n                                    </div>\n                                    <div class=\"grid-item field\" ng-class=\"{'field-error': newMember.error.data.lastName.error}\">\n                                        <input type=\"text\" ng-disabled=\"newMember.busy\" placeholder=\"Last Name\" name=\"lastName\" ng-model=\"newMember.data.lastName\">\n                                    </div>\n                                </div>\n                                <div class=\"grid\" ng-show=\"newMember.data.newUser\">\n                                    <small>\n                                        <a href=\"mailto:team@getfactbox.com?subject=FactBox Bulk Add Users\">Contact us</a> if you would like to bulk add members.\n                                    </small>\n                                </div>\n                            </div>\n                            <div class=\"grid-item grid-item-fixed\" style=\"flex:none\">\n                                <button class=\"btn btn-default\" type=\"button\" tabindex=\"-1\" ng-click=\"cancelNewMember()\">Cancel</button>\n                                <button class=\"btn btn-green\" type=\"submit\" ng-disabled=\"newMember.busy\" ng-bind=\"newMember.busy ? 'Adding...' : 'Add'\"></button>\n                            </div>\n                        </form>\n                        <div class=\" table-container\">\n                            <table class=\"table\">\n                                <thead>\n                                    <tr>\n                                        <th class=\"text-left\">Name</th>\n                                        <th class=\"text-left\">Email</th>\n                                        <th class=\"text-left\" colspan=\"2\">Role</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr ng-repeat=\"member in members | orderBy: 'lastName' | orderBy:'email'\" ng-class=\"{'section-red-tint':selectedMember.id===member.id}\">\n                                        <td>{{::member.firstName}} {{::member.lastName}}</td>\n                                        <td class=\"ellipsis-overflow\">\n                                            <a ng-href=\"mailto:{{member.email}}\" ng-bind=\"member.email\"></a> <span class=\"label\" ng-class=\"member.verified ? 'label-green' : 'label-gold'\" ng-bind=\"member.verified ? 'Verified' : 'Unverified'\"></span>\n                                        </td>\n                                        <td>\n                                            <span ng-hide=\"customer.user.role === 'admin' && members.length !== 1 && user.verified\" ng-bind=\"::member.role | lexicon | titlecase\"></span>\n                                            <div ng-show=\"customer.user.role === 'admin' && members.length !== 1 && user.verified\" uib-dropdown>\n                                                <div class=\"\" uib-dropdown-toggle>{{::member.role | lexicon | titlecase}} <i class=\"lf-caret\"></i>\n                                                </div>\n                                                <ul class=\"uib-dropdown-menu dropdown-menu-gray\" class=\"\">\n                                                    <li uib-dropdown-item ng-repeat=\"role in customer.roleNames\">\n                                                        <a href ng-click=\"updateMemberRole(member,role)\" ng-bind=\"role | lexicon | titlecase\"></a>\n                                                    </li>\n                                                </ul>\n                                            </div>\n                                        </td>\n                                        <td class=\"text-right\">\n                                            <button type=\"button\" ng-if=\"customer.user.role === 'admin'\" ng-disabled=\"customer.users.length === 1 || !user.verified\" ng-click=\"removeUserModal(member)\" class=\"btn btn-default btn-sm\">Remove</button>\n                                        </td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                    <p ng-if=\"customer.user.role !== 'admin'\"><small>Looking for {{'firm'|lexicon}} settings? Ask an Admin Member to assign you the Admin Role. Learn more about Member Roles <a target=\"_blank\" href=\"/help#member-roles\">here</a>.</small></p>\n                    <!-- Plan -->\n                    <div class=\"card card-default\">\n                        <h3 id=\"plans\">Plan</h3>\n                        <div ng-if=\"referrer.id && isTrial\" class=\"card card-blue-tint\">\n                            <div class=\"grid grid-gutters \">\n                                <div class=\"grid-item grid-item-fixed\">\n                                    <i class=\"icon-gift\"></i>\n                                </div>\n                                <div class=\"grid-item\">\n                                    By adding a Plan, you'll get your first month free. Your referrer, {{referrer.firstName}} {{referrer.lastName}} ({{referrer.email}}), will also get one month free!\n                                </div>\n                            </div>\n                        </div>\n                        <p ng-bind=\"customer.statusMessage\"></p>\n                        <div class=\"grid grid-full large-grid-fit grid-gutters\" ng-hide=\"isCustom || isTrial\">\n                            <div class=\"grid-item\" style=\"flex:2\">\n                                <h4>Your Plan</h4>\n                                <div class=\"current-plan card-group\">\n                                    <div class=\"card card-outline card-default\">\n                                        <h5 ng-bind=\"customer.plan.displayName\"></h5>\n                                        <ul>\n                                            <li ng-repeat=\"feature in customer.plan.features\" ng-bind=\"feature\"></li>\n                                        </ul>\n                                    </div>\n                                    <div class=\"card card-default card-outline\">${{customer.plan.price[selectedPeriod]}} {{customer.plan.name ==='perUserPro' || customer.plan.name ==='factbox' ? '/ Member':''}} / Month</div>\n                                </div>\n                            </div>\n                            <div class=\"grid-item\">\n                                <h4>Billing Period</h4>\n                                <div class=\"card card-outline card-default\">\n                                    <div ng-show=\"customer.user.role == 'admin'\">\n                                        <label style=\"display:block\">\n                                            <input type=\"radio\" ng-model=\"selectedPeriod\" value=\"month\" ng-change=\"selectPeriod('month')\"> Monthly\n                                        </label>\n                                        <label style=\"display:block\">\n                                            <input type=\"radio\" ng-model=\"selectedPeriod\" value=\"year\" ng-change=\"selectPeriod('year')\"> Yearly\n                                        </label>\n                                    </div>\n                                    <div ng-hide=\"customer.user.role == 'admin'\" ng-bind=\"{'month':'Monthly','year':'Yearly'}[selectedPeriod]\"></div>\n                                </div>\n                                <div ng-if=\"customer.user.role === 'admin'\">\n                                    <h4>Credit Card</h4>\n                                    <div class=\"card card-outline card-default\">\n                                        <a href=\"\" ng-click=\"setupPaymentModal()\">Update Card</a>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <a ng-hide=\"showAvailable || isTrial || isCustom || customer.plan.name ==='perUserPro' || customer.plan.name ==='factbox' || customer.user.role !== 'admin'\" ng-click=\"showAvailable = true\">\n                            Show Available Plans\n                        </a>\n                        <h4 ng-show=\"showAvailable || isTrial || isCustom\">\n                            Available Plans\n                        </h4>\n                        <div ng-show=\"showAvailable || isTrial || isCustom\">\n                            <label class=\"radio-inline\">\n                                <input type=\"radio\" ng-model=\"previewPeriod\" value=\"month\" ng-change=\"selectPreviewPeriod('month')\"> Monthly\n                            </label>\n                            <label class=\"radio-inline\">\n                                <input type=\"radio\" ng-model=\"previewPeriod\" value=\"year\" ng-change=\"selectPreviewPeriod('year')\"> Yearly (2 months free)\n                            </label>\n                            <div class=\"grid grid-gutters large-grid-1of2 grid-fit\" style=\"margin-top: 0;\">\n                                <div class=\"grid-item\" ng-repeat=\"plan in plans | orderBy:plan.price.year\">\n                                    <div class=\"available-plan card-group\">\n                                        <div class=\"card card-outline card-default\">\n                                            <h5 ng-bind=\"plan.displayName\"></h5>\n                                            <small>\n                                            <ul>\n                                                <li ng-repeat=\"feature in plan.features\" ng-bind=\"feature\"></li>\n                                            </ul>\n                                            </small>\n                                        </div>\n                                        <div class=\"card card-outline card-default\">\n                                            <div ng-hide=\"previewPeriod ==='month'\" class=\"grid grid-center\">\n                                                <div class=\"grid-item\">\n                                                    ${{plan.price[previewPeriod]}} / Member / Year (2 months free)\n                                                </div>\n                                                <div ng-if=\"plan.name !== customer.plan.name && customer.user.role === 'admin'\" class=\"grid-item grid-item-fixed\">\n                                                    <button class=\"btn btn-green btn-sm\" type=\"button\" ng-click=\"selectPlan(plan.name)\">Select</button>\n                                                </div>\n                                            </div>\n                                            <div ng-hide=\"previewPeriod ==='year'\" class=\"grid grid-center\">\n                                                <div class=\"grid-item\">\n                                                    ${{plan.price[previewPeriod]}} / Member / Month\n                                                </div>\n                                                <div ng-if=\"plan.name !== customer.plan.name && customer.user.role === 'admin'\" class=\"grid-item grid-item-fixed\">\n                                                    <button class=\"btn btn-green btn-sm\" type=\"button\" ng-click=\"selectPlan(plan.name)\">Select</button>\n                                                </div>\n                                            </div>\n\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <button type=\"button\" ng-hide=\"isTrial\" class=\"btn btn-blue\" ng-click=\"referralModal()\"><i class=\"icon-gift\"></i> Refer a Colleague</button>\n                    </div>\n                </div>\n                <!-- <div class=\"r row-spaced\">\n                        <h3 class=\"account-heading\">Billing History</h3>\n                        <table class=\"table table-condensed\">\n                            <thead>\n                                <tr>\n                                    <th>Date</th>\n                                    <th>Item</th>\n                                    <th>Payment</th>\n                                    <th>Amount</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr>\n                                    <td>3/1/2016</td>\n                                    <td>Small Team</td>\n                                    <td><a href=\"\">View Invoice</a></td>\n                                    <td>$179</td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div> -->\n                <div class=\"r row-spaced\">\n                    <h3 class=\"account-heading\">Integrations</h3>\n                    <div ng-show=\"account.integrations.box.available\" class=\"card card-default \">\n                        <!-- Box Integration Container -->\n                        <div class=\"grid\" ng-click=\"showBox = !showBox\">\n                            <div class=\"grid-item grid-item-fixed\">\n                                <div class=\"integration-image image-source-box\" style=\"width:58.5px\"></div>\n                            </div>\n                            <div class=\"grid-item text-right\">\n                                <a style=\"padding-right: 1em\" href=\"\">Info</a>\n                                <span ng-if=\"customer.user.role === 'admin'\">\n                                    <button ng-hide=\"account.integrations.box.connected\" type=\"button\" class=\"btn btn-green\" ng-click=\"openBoxAuth($event)\">Connect</button>\n                                    <button ng-show=\"account.integrations.box.connected\" type=\"button\" class=\"btn btn-default\" ng-click=\"disconnectBox($event)\">Disconnect</button>\n                                </span>\n                            </div>\n                        </div>\n                        <div ng-show=\"showBox\">\n                            <!-- Box Integration Context -->\n                            <p>\n                                <a href=\"https://www.box.com/home/\" target=\"_blank\">Website</a>\n                                <a href=\"/help#integrations\" target=\"_blank\">Help</a>\n                            </p>\n                            <!-- Box Integration Information -->\n                            <p>\n                                Access your Box files directly in FactBox with our one-click integration.\n                            </p>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Integrates With</div>\n                                <div class=\"grid-item\">Sources</div>\n                            </div>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Account</div>\n                                <div class=\"grid-item\" ng-bind=\"account.integrations.box.connectedAs || 'Unknown'\"></div>\n                            </div>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Status</div>\n                                <div class=\"grid-item\"><span class=\"label\" ng-class=\"account.integrations.box.connected ? 'label-green' : 'label-gold'\" ng-bind=\"account.integrations.box.connected ? 'Connected' : 'Not Connected'\"></span></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-show=\"account.integrations.dropbox.available\" class=\"card card-default \">\n                        <!-- Dropbox Integration Container -->\n                        <div class=\"grid\" ng-click=\"showDropbox = !showDropbox\">\n                            <div class=\"grid-item grid-item-fixed\">\n                                <div class=\"integration-image image-source-dropbox\" style=\"width:118.5px\"></div>\n                            </div>\n                            <div class=\"grid-item text-right\">\n                                <a style=\"padding-right: 1em\" href=\"\">Info</a>\n                                <span ng-if=\"customer.user.role === 'admin'\">\n                                    <button ng-hide=\"account.integrations.dropbox.connected\" type=\"button\" class=\"btn btn-green\" ng-click=\"openDropboxAuth($event)\">Connect</button>\n                                    <button ng-show=\"account.integrations.dropbox.connected\" type=\"button\" class=\"btn btn-default\" ng-click=\"disconnectDropbox($event)\">Disconnect</button>\n                                </span>\n                            </div>\n                        </div>\n                        <div ng-show=\"showDropbox\">\n                            <!-- Dropbox Integration Context -->\n                            <p>\n                                <a href=\"https://www.dropbox.com/\" target=\"_blank\">Website</a>\n                                <a ng-href=\"/help#integrations\" target=\"_blank\">Help</a>\n                            </p>\n                            <!-- Dropbox Integration Information -->\n                            <p>\n                                Access your Dropbox files directly in FactBox with our one-click integration.\n                            </p>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Integrates With</div>\n                                <div class=\"grid-item\">Sources</div>\n                            </div>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Account</div>\n                                <div class=\"grid-item\" ng-bind=\"account.integrations.dropbox.connectedAs || 'Unknown'\"></div>\n                            </div>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Status</div>\n                                <div class=\"grid-item\"><span class=\"label\" ng-class=\"account.integrations.dropbox.connected ? 'label-green' : 'label-gold'\" ng-bind=\"account.integrations.dropbox.connected ? 'Connected' : 'Not Connected'\"></span></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-show=\"account.integrations.clio.available\" class=\"card card-default \">\n                        <!-- Clio Integration Container -->\n                        <div class=\"grid\" ng-click=\"showClio = !showClio\">\n                            <div class=\"grid-item grid-item-fixed\">\n                                <div class=\"integration-image image-source-clio\" style=\"width:75.5px\"></div>\n                            </div>\n                            <div class=\"grid-item text-right\">\n                                <a style=\"padding-right: 1em\" href=\"\">Info</a>\n                                <span ng-if=\"customer.user.role === 'admin'\">\n                                        <button ng-hide=\"account.integrations.clio.connected\" type=\"button\" class=\"btn btn-green\" ng-click=\"openClioAuth($event)\">Connect</button>\n                                        <button ng-show=\"account.integrations.clio.connected\" type=\"button\" class=\"btn btn-default\" ng-click=\"disconnectClio($event)\">Disconnect</button>\n                                    </span>\n                            </div>\n                        </div>\n                        <div ng-show=\"showClio\">\n                            <!-- Clio Integration Context -->\n                            <p>\n                                <a href=\"https://www.goclio.com/\" target=\"_blank\">Website</a>\n                                <a ng-href=\"/help#integrations\" target=\"_blank\">Help</a>\n                            </p>\n                            <!-- Clio Integration Information -->\n                            <p>\n                                Automatically create FactBox Cases when Clio Matters are created, access your Clio files directly in FactBox and sync Clio contacts as People Sources in FactBox cases.\n                            </p>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Integrates With</div>\n                                <div class=\"grid-item\">Cases and Sources</div>\n                            </div>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Account</div>\n                                <div class=\"grid-item\" ng-bind=\"account.integrations.clio.connectedAs || 'Unknown'\"></div>\n                            </div>\n                            <div class=\"grid\">\n                                <div class=\"grid-item grid-item-fixed\" style=\"width:6em\">Status</div>\n                                <div class=\"grid-item\"><span class=\"label\" ng-class=\"account.integrations.clio.connected ? 'label-green' : 'label-gold'\" ng-bind=\"account.integrations.clio.connected ? 'Connected' : 'Not Connected'\"></span></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        </div>\n    </section>\n</main>\n<lw-page-footer></lw-page-footer>\n"

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	module.exports = "<header-nav actions=\"signin\"></header-nav>\n<main class=\"page-content tint-gray\">\n    <section class=\"section-page-min-height\">\n        <div class=\"container container-text\">\n            <div class=\"download-icon\"></div>\n            <h2>Download FactBox</h2>\n            <p>Download our app to open FactBox and start taking notes directly from your desktop. You will have easy access to FactBox no matter what other programs you have running.</p>\n            <p><a ng-show=\"{'windows':true,'mac':true}[os]\" ng-href=\"https://factbox-launcher-update.s3.amazonaws.com/{{path}}\" title=\"Download FactBox\" class=\"btn btn-green btn-lg\" ng-click=\"trackDownload()\">Download FactBox</a></p>\n            <p><small ng-bind=\"{'mac':'for Mac','windows':'for Windows'}[os]\"></small></p>\n            <div class=\"grid grid-gutters grid-full large-grid-fit\" ng-if=\"os === 'windows'\">\n                <div class=\"grid-item\">\n                    <div class=\"download-step download-step-1\"></div>\n                    <div class=\"caption\">\n                        <h3>Download and Install</h3>\n                        <p>Click the FactBox file in the downloads window.</p>\n                    </div>\n                </div>\n                <div class=\"grid-item\">\n                    <div class=\"download-step download-step-2\"></div>\n                    <div class=\"caption\">\n                        <h3>Run the installer</h3>\n                        <p>Follow the steps in the installer.</p>\n                    </div>\n                </div>\n                <div class=\"grid-item\">\n                    <div class=\"download-step download-step-3\"></div>\n                    <div class=\"caption\">\n                        <h3>Get Started</h3>\n                        <p>Launch FactBox in your browser right from your Desktop!</p>\n                    </div>\n                </div>\n            </div>\n    </section>\n</main>\n<lw-page-footer></lw-page-footer>\n"

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	module.exports = "<!-- <div lf-update-notification></div> -->\n<div status-nav></div>\n<fb-fact options=\"{window:true}\" fact=\"$ctrl.fact\" case=\"$ctrl.currentCase.data\" on-update=\"$ctrl.addFact(newFact)\" on-next=\"$ctrl.showFact(next, newFact)\" on-toggle-cases=\"$ctrl.toggleCases()\" on-cancel=\"$dismiss()\" on-open-case=\"$ctrl.openCase()\"></fb-fact>\n<lf-case-list route=\"fact\" case=\"$ctrl.currentCase.data\"></lf-case-list>\n"

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	module.exports = "<header-nav actions=\"signin\"></header-nav>\n<main class=\"page-content\">\n    <section class=\"section-page-min-height\">\n        <div class=\"container container-single-card\">\n            <div class=\"grid grid-full large-grid-fit\">\n                <div class=\"grid-item\">\n                    <form ng-hide=\"forgot.completed\" role=\"form\" novalidate ng-submit=\"forgot.requestPasswordReset()\">\n                        <h1>Reset Your Password</h1>\n                        <p>Please enter your email address below. We'll send you a message containing instructions on how to reset your password.</p>\n                        <div class=\"card card-red-tint\" ng-if=\"forgot.user.error.error\">\n                            <div ng-bind-html=\"forgot.user.error.error\"></div>\n                            <div><small ng-bind=\"forgot.user.error.details\"></small></div>\n                        </div>\n                        <div class=\"field-error\" ng-show=\"forgot.user.error.data.email.error\" ng-bind=\"forgot.user.error.data.email.error\"></div>\n                        <div class=\"grid grid-gutters\">\n                            <div class=\"grid-item field\" ng-class=\"forgot.user.error.data.email.error ? 'field-error' : ''\">\n                                <input type=\"email\" placeholder=\"Email\" name=\"email\" ng-model=\"forgot.user.data.email\">\n                            </div>\n                        </div>\n                        <button type=\"submit\" ng-disabled=\"{{forgot.user.busy}}\" class=\"btn btn-green\">Send Reset</button>\n                    </form>\n                    <div ng-show=\"forgot.completed\">\n                        <h1>Password reset email sent</h1>\n                        <p>Please check your email to proceed.</p>\n                        <div class=\"card card-default text-center\">\n                            <h3 class=\"text-ellipsis\">{{forgot.user.data.email}}</h3>\n                            <p>This email contains a link to reset your password.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n</main>\n<lw-page-footer></lw-page-footer>\n"

/***/ }),
/* 881 */
/***/ (function(module, exports) {

	module.exports = "<!-- <div lf-update-notification></div> -->\n<div status-nav></div>\n<div class=\"grid grid-fill column\">\n    <div class=\"grid-item-fixed\">\n        <div admin-nav></div>\n        <!-- Title Bar -->\n        <div class=\"navbar-manage header-darkteal\">\n            <!-- <div class=\"container container-header\"> -->\n            <div class=\"grid\">\n                <div class=\"grid-item-fixed nav-btn-container grid\" id=\"case-name\">\n                    <fb-editable value=\"home.currentCase.data.displayName\" on-update=\"home.setCaseName(newValue)\" class=\"grid-item\"></fb-editable>\n                    <div case-status></div>\n                    <div class=\"grid-item-fixed archive\" ng-if=\"home.currentCase.data.displayName && !$root.isVisitor\">\n                        <div class=\"btn btn-condensed\" title=\"Archive\" ng-click=\"home.archiveCase()\">\n                            <span class=\" icon icon-delete-white\"></span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"grid-item\">\n                    <lw-counter lf-contributor-enable name=\"::'issue'|lexicon\" count=\"home.currentCase.data.counts.legalIssues\" class=\"btn nav-text\" ng-click=\"home.issuesModal()\" payment-enable></lw-counter>\n                    <lw-counter lf-contributor-enable name=\"'Source'\" count=\"home.currentCase.data.counts.sources\" class=\"btn nav-text\" ng-click=\"home.sourcesModal()\" payment-enable></lw-counter>\n                    <lw-counter lf-contributor-enable name=\"'Tag'\" count=\"home.currentCase.data.counts.tags\" class=\"btn nav-text\" ng-click=\"home.tagsModal()\" payment-enable></lw-counter>\n                    <lw-counter lf-contributor-enable name=\"::'contributor'|lexicon\" count=\"home.currentCase.data.counts.contributors\" id=\"manage-contributors\" class=\"btn nav-text\" ng-click=\"home.contributorsModal()\" payment-enable></lw-counter>\n                    <lw-counter class=\"btn nav-text\" lf-contributor-enable name=\"'Fact'\" count=\"home.currentCase.data.counts.facts\"></lw-counter>\n                </div>\n                <div class=\"grid-item-fixed\" ng-if=\"home.currentCase.data.clioMatterId\">\n                    <a class=\"btn nav-text\" ng-href=\"https://app.goclio.com/matters/{{home.currentCase.data.clioMatterId}}\" target=\"_blank\"><i class=\"icon icon-clio-white\"></i> Open in Clio</a>\n                </div>\n            </div>\n            <!-- </div> -->\n        </div>\n    </div>\n    <div class=\"grid-item grid\">\n        <lf-filter-list class=\"grid-item-fixed sidebar-left\" case-enable></lf-filter-list>\n        <div class=\"grid-item container-grid-fill\">\n            <div class=\"grid column grid-fill\">\n                <div class=\"grid-item-fixed\">\n                    <div class=\"header navbar navbar-top\" ng-class=\"'navbar-view-'+home.factQuery.data.format\">\n                        <div class=\"grid\">\n                            <div class=\"grid-item-fixed btn-group\" id=\"fact-view-toggle\">\n                                <span ng-click=\"home.updateQuery('format','table')\" class=\"btn btn-outline\" ng-class=\"{'table':'active'}[home.factQuery.data.format]\">\n                                            Table\n                                        </span>\n                                <span ng-click=\"home.updateQuery('format','memo')\" class=\"btn btn-outline\" ng-class=\"{'memo':'active'}[home.factQuery.data.format]\">\n                                        {{::'memo'|lexicon}}\n                                    </span>\n                            </div>\n                            <div class=\"grid-item grid grid-justify-center\">\n                                <div class=\"grid-item-fixed\">\n                                    <span id=\"column-visibility-toggle\" uib-dropdown>\n                                        <span class=\"btn btn-outline\" case-enable uib-dropdown-toggle>\n                                            Show <span ng-bind=\"{'memo':'Fields','table':'Columns'}[home.factQuery.data.format]\"></span> <span class=\"lf-caret\"></span>\n                                    </span>\n                                    <ul class=\"uib-dropdown-menu\" role=\"menu\">\n                                        <li ng-repeat=\"col in home.groupings[home.viewBy.attribute].columnsByGroup track by col.key\" ng-click=\"home.toggleColumn(col)\" class=\"select-indicator\" ng-class=\"{'selected':home.factQuery.data.columns.indexOf(col.key) > -1}\">\n                                            {{::col.key|lexicon}}\n                                        </li>\n                                    </ul>\n                                    </span>\n                                    <span uib-dropdown>\n                                        <span class=\"btn btn-outline\" uib-dropdown-toggle case-enable>\n                                            Sort {{home.orderBy.attribute|lexicon}} {{home.orderBy.order === 'desc' ? 'Desc' : 'Asc'}}</i> <span class=\"lf-caret\"></span>\n                                    </span>\n                                    <ul class=\"uib-dropdown-menu\" role=\"menu\">\n                                        <li class=\"select-indicator\" ng-repeat-start=\"key in home.factQuery.data.columns track by key\" ng-if=\"home.groupings[key].secondarySortable\" ng-class=\"{'selected':home.orderBy.attribute === key && home.orderBy.order === 'asc'}\" ng-click=\"home.setSorting(key, 'asc')\">\n                                            {{::key|lexicon}} Ascending\n                                        </li>\n                                        <li class=\"select-indicator\" ng-repeat-end ng-if=\"home.groupings[key].secondarySortable\" ng-class=\"{'selected':home.orderBy.attribute === key && home.orderBy.order === 'desc'}\" ng-click=\"home.setSorting(key, 'desc')\">\n                                            {{::key|lexicon}} Descending\n                                        </li>\n                                    </ul>\n                                    </span>\n                                </div>\n                            </div>\n                            <!-- Action buttons -->\n                            <div class=\"grid-item-fixed text-right\">\n                                <button type=\"button\" class=\"btn btn-green \" id=\"link-add-fact\" lf-contributor-enable payment-enable ng-click=\"home.openAddFact()\">Add Fact</button>\n                                <button type=\"button\" class=\"btn btn-green \" id=\"link-generate\" case-enable payment-enable ng-click=\"home.currentCase.getReport()\">Generate</button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"grid-item container-grid-fill\">\n                    <div class=\"grid-fill\" style=\"overflow:hidden\">\n                        <div ng-if=\"home.factQuery.data.format === 'table'\" class=\"container-full table-factbox-section\">\n                            <div class=\"table-factbox-header-bg\"></div>\n                            <div class=\"table-factbox-container\" lw-on-scroll-end=\"home.factList.loadMore()\">\n                                <table class=\"table table-factbox\" id=\"table-facts\">\n                                    <thead>\n                                        <tr class=\"table-header\">\n                                            <th ng-repeat=\"key in home.factQuery.data.columns track by key\" ng-class=\"'col-'+key\" ng-click=\"home.toggleSorting(key)\">\n                                                <div class=\"th-inner\">\n                                                    <div ng-class=\"{'disabled' : !home.groupings[key].secondarySortable}\">\n                                                        {{ ::key|lexicon }}\n                                                        <span ng-show=\"home.orderBy.attribute === key\" class=\"glyphicon\" ng-class=\"{'desc':'glyphicon-arrow-down','asc':'glyphicon-arrow-up'}[home.orderBy.order]\">\n                                                        </span>\n                                                    </div>\n                                                </div>\n                                            </th>\n                                        </tr>\n                                    </thead>\n                                    <tbody>\n                                        <tr ng-repeat=\"item in home.factList.data.rows track by $index\" ng-class=\"{'active':home.selectedRow.row.id === item.row.id,'fact-row':item.row,'row-heading':item.separator}\" ng-click=\"home.selectRow(item,$index)\" ng-dblclick=\"home.editRow(item)\" fb-on-delete=\"home.deleteRow(item)\">\n                                            <th ng-if=\"item.separator\" class=\"fact-grouping-table-header\" scope=\"rowgroup\" colspan=\"{{home.factQuery.data.columns.length}}\">\n                                                <div title=\"{{item.separator.displayName}}\" class=\"ellipsis-overflow\" ng-bind-html=\"item.separator.displayName\"></div>\n                                            </th>\n                                            <td ng-if=\"item.row\" ng-repeat=\"column in home.factQuery.data.columns track by column\" ng-class=\"'col-' + column\">\n                                                <div ng-if=\"home.selectedRow.row.id === item.row.id && $first\" class=\"table-fact-options-container\">\n                                                    <div class=\"fact-options\">\n                                                        <div class=\"text-action\" lf-contributor-enable payment-enable ng-click=\"home.editRow(item)\">Edit</div>\n                                                        <div class=\"text-action\" ng-click=\"home.hideRow(item)\">Hide</div>\n                                                        <div class=\"text-action\" lf-contributor-enable ng-click=\"home.deleteRow(item)\">Delete</div>\n                                                    </div>\n                                                </div>\n                                                <div ng-bind-html=\"home.groupings[column].getDisplayText(item.row[column],branch.id)\"></div>\n                                            </td>\n                                        </tr>\n                                        <tr ng-if=\"home.factList.data.rows.length === 0\">\n                                            <td colspan=\"{{home.factQuery.data.columns.length}}\">\n                                                <div class=\"fact-list-empty-state text-action clickable\" ng-click=\"home.openAddFact()\">\n                                                    Add the first fact\n                                                </div>\n                                            </td>\n                                        </tr>\n                                        <tr class=\"info text-center\" ng-show=\"home.factList.busy\">\n                                            <td colspan=\"{{home.factQuery.data.columns.length}}\">\n                                                <div class=\"card card-default text-center text-action\" role=\"alert\">\n                                                    Loading More Facts\n                                                    <div class=\"spinner\" style=\"display: inline-block;\">\n                                                        <div class=\"double-bounce1\"></div>\n                                                        <div class=\"double-bounce2\"></div>\n                                                    </div>\n                                                </div>\n                                            </td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </div>\n                        </div>\n                        <div ng-if=\"home.factQuery.data.format === 'memo'\" class=\"container container-full container-memo\" lw-on-scroll-end=\"home.factList.loadMore()\">\n                            <div ng-repeat=\"item in home.factList.data.rows track by $index\">\n                                <div class=\"memo-row\">\n                                    <h1 ng-if=\"item.separator\" ng-bind=\"item.separator.displayName\"></h1>\n                                </div>\n                                <!-- Fact iterator -->\n                                <div class=\"fact-row\" ng-class=\"{'active':home.selectedRow.row.id === item.row.id}\" ng-if=\"item.row\" ng-click=\"home.selectRow(item,$index)\" ng-dblclick=\"home.editRow(item)\" fb-on-delete=\"home.deleteRow(item)\">\n                                    <div class=\"memo-row\">\n                                        <!-- Fact attributes -->\n                                        <!-- Sorted Field: Title -->\n                                        <div class=\"fact\">\n                                            <h2 ng-if=\"home.factQuery.data.columns.indexOf(home.orderBy.attribute) !== -1\">\n                                                <span ng-bind-html=\"home.groupings[home.orderBy.attribute].getMemoText(item.row[home.orderBy.attribute]) || 'No '+ home.groupings[home.orderBy.attribute].displayName\">\n                                                </span>\n                                                <span ng-if=\"home.orderBy.attribute !== 'title' && item.row['title']\">: </span>\n                                                <span ng-if=\"home.orderBy.attribute !== 'title'\" ng-bind-html=\"home.groupings['title'].getMemoText(item.row['title'])\">\n                                                </span>\n                                            </h2>\n                                            <!-- Content -->\n                                            <p ng-if=\"home.factQuery.data.columns.indexOf('content') !== -1\" ng-bind-html=\"home.groupings['content'].getMemoText(item.row['content'])\"></p>\n                                            <!-- Other fields -->\n                                            <ul>\n                                                <li ng-repeat=\"key in home.factQuery.data.columns track by key\" ng-if=\"home.factQuery.data.columns.indexOf(key) !== -1 && home.groupings[key].getMemoText(item.row[key],branch.id) && key !== 'title' && key !== 'content'\">\n                                                    {{::key|lexicon}}: <span ng-bind-html=\"home.groupings[key].getMemoText(item.row[key])\"></span>\n                                                </li>\n                                            </ul>\n                                        </div>\n                                        <div ng-if=\"home.selectedRow.index === $index\" class=\"memo-fact-options-container\">\n                                            <ul class=\"memo-fact-options\">\n                                                <li class=\"text-action\" ng-click=\"home.editRow(item)\">Edit</li>\n                                                <li class=\"text-action\" ng-click=\"home.hideRow(item)\">Hide</li>\n                                                <li class=\"text-action\" ng-click=\"home.deleteRow(item)\">Delete</li>\n                                            </ul>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div>\n                                <div class=\"memo-row\" ng-if=\"home.factList.data.rows.length === 0\">\n                                    <h2 ng-bind=\"home.currentCase.data.displayName\"></h2>\n                                    <div class=\"fact-list-empty-state text-action clickable\" ng-click=\"home.openAddFact()\">\n                                        Add the first fact\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"memo-row\" ng-show=\"home.factList.busy\">\n                                <div class=\"card card-default text-center text-action\" role=\"alert\">\n                                    Loading More Facts\n                                    <div class=\"spinner\" style=\"display: inline-block;\">\n                                        <div class=\"double-bounce1\"></div>\n                                        <div class=\"double-bounce2\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-show=\"home.hiddenFacts.length > 0\" class=\"grid-item-fixed \">\n                    <div class=\"text-right navbar navbar-bottom row\">\n                        <span class=\"nav-item-text\">{{home.hiddenFacts.length}} hidden Fact{{home.hiddenFacts.length > 1 ?'s':''}}</span>\n                        <button type=\"button\" class=\"btn btn-outline btn-action\" ng-click=\"home.unhideFacts()\">Unhide</button>\n                    </div>\n                </div>\n            </div>\n            <!-- </div> -->\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 882 */
/***/ (function(module, exports) {

	module.exports = "<header-nav actions=\"signin\"></header-nav>\n<main class=\"page-content\">\n    <section class=\"section-page-min-height\">\n        <div class=\"container container-single-card\">\n            <div class=\"grid grid-full large-grid-fit\">\n                <div class=\"grid-item\">\n                    <form role=\"form\" novalidate name=\"resetForm\" ng-submit=\"reset.resetPassword()\">\n                        <h1>Set Password</h1>\n                        <p>Please enter your new password below.</p>\n                        <div class=\"card card-red-tint\" ng-if=\"reset.user.error.error\">\n                            <div ng-bind-html=\"reset.user.error.error\"></div>\n                            <div><small ng-bind=\"reset.user.error.details\"></small></div>\n                        </div>\n                        <div class=\"grid grid-gutters\">\n                            <div class=\"grid-item\">\n                                <div class=\"field\" ng-class=\"reset.user.data.password.error ? 'field-error' : ''\">\n                                    <input type=\"password\" placeholder=\"New Password\" name=\"password\" ng-model=\"reset.user.data.password\" ng-minlength=\"8\" ng-pattern=\"/(?=.*[A-Z])(?=.*\\d)/\">\n                                </div>\n                                <small class=\"text-red\" ng-show=\"resetForm.password.$error.required && resetForm.password.$dirty && !reset.user.data.password.error\">Required</small>\n                                <small class=\"text-gold\" ng-show=\"!resetForm.password.$error.required &&resetForm.password.$error.minlength && resetForm.password.$dirty && !reset.user.data.password.error\">Passwords must be at least 8 characters.</small>\n                                <small class=\"text-gold\" ng-show=\"!resetForm.password.$error.required && !resetForm.password.$error.minlength && resetForm.password.$error.pattern && resetForm.password.$dirty && !reset.user.data.password.error\">Password must contain an upper case letter and a number.</small>\n                                <small class=\"text-red\" ng-show=\"reset.user.data.password.error\" ng-bind=\"reset.user.data.password.error\"></small>\n                            </div>\n                        </div>\n                        <button type=\"submit\" ng-disabled=\"{{reset.user.busy}}\" class=\"btn btn-green\">Submit</button>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </section>\n</main>\n<lw-page-footer></lw-page-footer>\n"

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	module.exports = "<header-nav actions=\"signin\"></header-nav>\n<main class=\"page-content tint-gray\">\n    <section class=\"section-page-min-height\">\n        <div class=\"container container-single-card\">\n            <div class=\"grid grid-full large-grid-fit\">\n                <div class=\"grid-item\">\n                    <form ng-hide=\"reset.showClioAuthStep\" role=\"form\" novalidate name=\"resetForm\" ng-submit=\"reset.setPassword()\">\n                        <div ng-if=\"!reset.clioAuthFlow\">\n                            <h2>Just one more step!</h2>\n                            <p>We are glad that you’ve decided to give FactBox a try! You will be too. Just set a password below to get started!</p>\n                        </div>\n                        <div ng-if=\"reset.clioAuthFlow\">\n                            <h2>Just two more steps!</h2>\n                            <p>First, set a password for your FactBox account below. Then, you will be prompted to connect your Clio account.</p>\n                        </div>\n                        <p>Your 7-day trial will start today unless you or your firm already have an active plan.</p>\n                        <div class=\"card card-red-tint\" ng-if=\"reset.user.error.error\">\n                            <div ng-bind-html=\"reset.user.error.error\"></div>\n                            <div><small ng-bind=\"reset.user.error.details\"></small></div>\n                        </div>\n                        <div class=\"grid grid-gutters\">\n                            <div class=\"grid-item\">\n                                <div class=\"field\" ng-class=\"reset.user.data.password.error ? 'field-error' : ''\">\n                                    <input type=\"password\" placeholder=\"New Password\" name=\"password\" ng-model=\"reset.user.data.password\" ng-minlength=\"8\" ng-pattern=\"/(?=.*[A-Z])(?=.*\\d)/\">\n                                </div>\n                                <small class=\"text-red\" ng-show=\"resetForm.password.$error.required && resetForm.password.$dirty && !reset.user.data.password.error\">Required</small>\n                                <small class=\"text-gold\" ng-show=\"!resetForm.password.$error.required &&resetForm.password.$error.minlength && resetForm.password.$dirty && !reset.user.data.password.error\">Passwords must be at least 8 characters.</small>\n                                <small class=\"text-gold\" ng-show=\"!resetForm.password.$error.required && !resetForm.password.$error.minlength && resetForm.password.$error.pattern && resetForm.password.$dirty && !reset.user.data.password.error\">Password must contain an upper case letter and a number.</small>\n                                <small class=\"text-red\" ng-show=\"reset.user.data.password.error\" ng-bind=\"reset.user.data.password.error\"></small>\n                            </div>\n                        </div>\n                        <p><small>By signing up, you are agreeing to the <a href=\"/saas-agreement\">Software as a Service Agreement</a>.</small></p>\n                        <button type=\"submit\" ng-disabled=\"{{reset.user.busy}}\" class=\"btn btn-green\">Continue</button>\n                    </form>\n                    <div ng-if=\"reset.showClioAuthStep\">\n                        <h2>One last step.</h2>\n                        <p>Now, click the button below to open an window to your Clio account.</p>\n                        <button type=\"button\" ng-click=\"reset.openClioAuth($event)\" class=\"btn btn-green\">Connect to Clio</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n</main>\n<lw-page-footer></lw-page-footer>\n"

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	module.exports = "<header-nav actions=\"signup\"></header-nav>\n<main class=\"page-content\">\n    <section class=\"section-page-min-height\">\n        <div class=\"container container-single-card\">\n            <div class=\"grid grid-full large-grid-fit\">\n                <div class=\"grid-item\">\n                    <h1>Welcome Back</h1>\n                    <p>You’re one step closer to a headache-free life.</p>\n                    <form role=\"form\" novalidate name=\"signinForm\" ng-submit=\"signin.submit()\">\n                        <ng-include src=\"'/signin/signin.fields.html'\"></ng-include>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </section>\n</main>\n<lw-page-footer></lw-page-footer>\n"

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	module.exports = "<header-nav actions=\"signin\"></header-nav>\n<main class=\"page-content\">\n    <section class=\"section-page-min-height\">\n        <div class=\"container container-single-card\">\n            <div class=\"grid grid-full large-grid-fit\">\n                <div class=\"grid-item\" ng-hide=\"signup.setAccountName\">\n                    <div class=\"card card-green-tint\" ng-if=\"signup.variant\" ng-switch=\"signup.variant\">\n                        <span ng-switch-when=\"manage\" id=\"manage\" class=\"signup-variant\">\n                            Ready to organize your casework? Create your FactBox account using the form below.\n                        </span>\n                        <span ng-switch-when=\"trial-sof\" id=\"trial-sof\" class=\"signup-variant\">\n                            Almost there! Use the form below to create your account.\n                        </span>\n                        <span ng-switch-when=\"lawyer-legal\" id=\"lawyer-legal\" class=\"signup-variant\">\n                            Ready to simplify your practice? Use the form below to create your FactBox account.\n                        </span>\n                        <span ng-switch-when=\"capterra\" id=\"capterra\" class=\"signup-variant\">\n                            Ready to manage your cases? Create your account using the form below.\n                        </span>\n                        <span ng-switch-when=\"solo\" id=\"solo\" class=\"signup-variant\">\n                            Create your account below and start winning more of your cases.\n                        </span>\n                    </div>\n                    <form class=\"\" role=\"form\" novalidate name=\"signupForm\" ng-submit=\"signup.signup()\">\n                        <h1>Free Trial</h1>\n                        <p ng-if=\"!signup.variant\">\n                            Sign Up to start your free trial today!\n                        </p>\n                        <div ng-if=\"referrer.id\" class=\"card card-small card-blue-tint\"><i class=\"icon-gift\"></i> Referred by {{referrer.firstName}} {{referrer.lastName}} ({{referrer.email}})\n                        </div>\n                        <!-- <div status-row></div> -->\n                        <div class=\"card card-red-tint\" ng-if=\"signup.user.error.details\" ng-bind=\"signup.user.error.details\"></div>\n                        <div class=\"grid grid-gutters\">\n                            <div class=\"grid-item field\" ng-class=\"signup.user.error.data.firstName.error ? 'field-error' : ''\">\n                                <input type=\"text\" placeholder=\"First Name\" name=\"firstName\" ng-model=\"signup.user.data.firstName\">\n                            </div>\n                            <div class=\"grid-item field\" ng-class=\"signup.user.error.data.lastName.error ? 'field-error' : ''\">\n                                <input type=\"text\" placeholder=\"Last Name\" name=\"lastName\" ng-model=\"signup.user.data.lastName\">\n                            </div>\n                        </div>\n                        <div class=\"grid grid-gutters\">\n                            <div class=\"grid-item\">\n                                <div class=\"field\" ng-class=\"signup.user.error.data.email.error ? 'field-error' : ''\">\n                                    <input type=\"email\" placeholder=\"Work Email\" name=\"email\" ng-model=\"signup.user.data.email\">\n                                </div>\n                                <small class=\"text-blue\">After sign up, check this email for your verification link.</small>\n                            </div>\n                        </div>\n                        <div class=\"grid grid-gutters\">\n                            <div class=\"grid-item\">\n                                <div class=\"field\" ng-class=\"signup.user.error.data.password.error ? 'field-error' : ''\">\n                                    <input type=\"password\" placeholder=\"Password\" name=\"password\" ng-model=\"signup.user.data.password\" ng-minlength=\"8\" ng-pattern=\"/(?=.*[A-Z])(?=.*\\d)/\">\n                                </div>\n                                <small class=\"text-red\" ng-show=\"signupForm.password.$error.required && signupForm.password.$dirty && !signup.user.error.data.password.error\">Required</small>\n                                <small class=\"text-gold\" ng-show=\"!signupForm.password.$error.required &&signupForm.password.$error.minlength && signupForm.password.$dirty && !signup.user.error.data.password.error\">Passwords must be at least 8 characters.</small>\n                                <small class=\"text-gold\" ng-show=\"!signupForm.password.$error.required && !signupForm.password.$error.minlength && signupForm.password.$error.pattern && signupForm.password.$dirty && !signup.user.error.data.password.error\">Password must contain an upper case letter and a number.</small>\n                                <small class=\"text-red\" ng-show=\"signup.user.error.data.password.error\" ng-bind=\"signup.user.error.data.password.error\"></small>\n                            </div>\n                        </div>\n                        <div class=\"grid grid-gutters\">\n                            <div class=\"grid-item\">\n                                <small>By signing up, you are agreeing to the <a href=\"/saas-agreement\">Software as a Service Agreement</a>.</small>\n                            </div>\n                        </div>\n                        <button type=\"submit\" name=\"set-user\" ng-disabled=\"signup.user.busy\" class=\"btn btn-green\">Continue</button>\n                    </form>\n                </div>\n                <div class=\"grid-item\" ng-show=\"signup.setAccountName\">\n                    <form role=\"form\" novalidate ng-submit=\"signup.nameAccount().then($close())\">\n                        <h3>What is the name of your firm?</h3>\n                        <h5>We use this information for data security and easy collaboration.</h5>\n                        <div class=\"grid grid-gutters\">\n                            <div class=\"grid-item field\" ng-class=\"signup.account.error.data.displayName.error ? 'field-error' : ''\">\n                                <input type=\"text\" ng-model=\"signup.account.data.displayName\" placeholder=\"Firm Name\" name=\"firm-name\">\n                            </div>\n                        </div>\n                        <button type=\"submit\" name=\"set-account\" ng-disabled=\"{{signup.account.busy}}\" class=\"btn btn-green\">Continue</button>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </section>\n</main>\n<lw-page-footer></lw-page-footer>\n"

/***/ }),
/* 886 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"memo-container\" style=\"background-color:white;box-shadow:none\">\n    <div class=\"memo-page\" style=\"border:none;box-shadow:none;margin:0px auto\">\n        <a ng-click=\"openAddFact()\">Add Fact</a>\n        <ul class=\"list-unstyled\">\n            <li><a class=\"btn btn-round btn-outline btn-inv navbar-btn navbar-right\" ng-click=\"openAddFact()\">Add Fact</a></li>\n            <li><a href=\"https://factbox-tutorial.s3.amazonaws.com/NCAA%20Manual%20Article%2012%20Amateurism.pdf\" target=\"_blank\">NCAA Manual Article 12 Amateurism</a></li>\n            <li><a href=\"https://factbox-tutorial.s3.amazonaws.com/1970%20Omaha%20NE%20column%20Johnny%20Football.pdf\" target=\"_blank\">1970 Omaha NE column Johnny Football</a></li>\n        </ul>\n            <div class=\"WordSection1\"><p class=\"Heading\" style=\"margin-left:1.0in;text-indent:-1.0in\"><span style=\"mso-bidi-font-size:12.0pt;  font-weight:normal\">SECTIONS 1, 2 AND 45 REFUSAL – MERELY ORNAMENTAL<o:p></o:p></span></p>    <span style=\"mso-bookmark:fpa_QU9_1_05222013_32027PM\"></span>    <p class=\"MsoNormal\" style=\"text-align:justify\"><o:p>&nbsp;</o:p></p>    <p class=\"MsoNormal\" style=\"text-align:justify\"><span style=\"color:black\">Registration is  refused because the applied-for mark as used on the specimen of record (1) is  merely a decorative or ornamental feature of applicant’s clothing; and (2) does  not function as a trademark to indicate the source of applicant’s clothing and  to identify and distinguish applicant’s clothing from others.<span style=\"mso-spacerun:yes\">&nbsp; </span>Trademark Act Sections 1, 2, and 45, 15  U.S.C. &sect;1051-1052, 1127; <i>see<span style=\"letter-spacing:-.15pt\"> </span></i><i style=\"mso-bidi-font-style:normal\">In re Lululemon Athletica Can. Inc.</i>, 105  USPQ2d 1684, 1689 (TTAB 2013); <i><span style=\"letter-spacing:-.15pt\">In re  Pro-Line Corp.</span></i><span style=\"letter-spacing:-.15pt\">, 28 USPQ2d 1141,  1142 (TTAB 1993); </span>TMEP &sect;904.07(b), 1202.03 <i>et seq.</i><span style=\"letter-spacing:-.15pt\"><o:p></o:p></span></span></p>    <p class=\"MsoNormal\" style=\"text-align:justify\"><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><span style=\"color:black;letter-spacing:-.15pt\"><o:p>&nbsp;</o:p></span></span></p>    <p class=\"MsoNormal\" style=\"text-align:justify\"><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><span style=\"mso-fareast-font-family:&quot;Times New Roman&quot;;letter-spacing:-.15pt\">When  evaluating a mark that appears to be ornamental, the size, location, dominance,  and significance of the alleged mark as applied to the goods are all relevant  factors in determining the commercial impression of the applied-for mark.<span style=\"mso-spacerun:yes\">&nbsp; </span><i style=\"mso-bidi-font-style:normal\">See,</i>  <i style=\"mso-bidi-font-style:normal\">e.g.</i>,<i style=\"mso-bidi-font-style:  normal\"> </i></span><i style=\"mso-bidi-font-style:normal\"><span style=\"color:black\">In re Lululemon Athletica Can. Inc.</span></i><span style=\"color:black\">, 105 USPQ2d at 1687 (quoting <i style=\"mso-bidi-font-style:  normal\">In re Right-On Co.</i>, 87 USPQ2d 1152, 1156 (TTAB 2008)); </span></span><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><i style=\"mso-bidi-font-style:  normal\"><span style=\"mso-fareast-font-family:&quot;Times New Roman&quot;;letter-spacing:  -.15pt\">In re Dimitri’s Inc</span></i></span><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><span style=\"mso-fareast-font-family:&quot;Times New Roman&quot;;letter-spacing:-.15pt\">., 9  USPQ2d 1666, 1667 (TTAB 1988); TMEP &sect;1202.03(a).<o:p></o:p></span></span></p>    <p class=\"MsoNormal\" style=\"text-align:justify\"><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><span style=\"color:black;letter-spacing:-.15pt\"><o:p>&nbsp;</o:p></span></span></p>    <p class=\"MsoNormal\" style=\"text-align:justify\"><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><span style=\"color:black\">With respect to clothing, consumers may recognize small  designs or discrete wording as trademarks, rather than as merely ornamental  features, when located, for example, on the pocket or breast area of a  shirt.<span style=\"mso-spacerun:yes\">&nbsp; </span><i style=\"mso-bidi-font-style:  normal\">See</i> TMEP &sect;1202.03(a).<span style=\"mso-spacerun:yes\">&nbsp;  </span>Consumers may not, however, perceive larger designs or slogans as  trademarks when such matter is prominently displayed across the front of a  t-shirt.<span style=\"mso-spacerun:yes\">&nbsp; </span><i>See</i> <i>In re Pro-Line  Corp.</i>, 28 USPQ2d at 1142 (holding BLACKER THE COLLEGE SWEETER THE KNOWLEDGE  centered in large letters across most of the upper half of a shirt, to be a  primarily ornamental slogan that was not likely to be perceived as a source  indicator); <i>In re Dimitri’s Inc.</i>, 9 USPQ2d at 1667-68 (holding SUMO used  in connection with stylized depictions of sumo wrestlers and displayed in large  lettering across the top-center portion of t-shirts and caps, to be an  ornamental feature of the goods that did not function as a trademark); TMEP  &sect;1202.03(a), (b), (f)(i), (f)(ii).<o:p></o:p></span></span></p>    <p class=\"MsoNormal\" style=\"text-align:justify\"><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><span style=\"color:black\"><o:p>&nbsp;</o:p></span></span></p>    <p class=\"MsoNormal\"><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><span style=\"color:black\">In this case, the submitted specimen shows the applied-for  mark, JOHNNY FOOTBALL, located directly on the upper-center area of the front  of the shirt, where ornamental elements often appear.<span style=\"mso-spacerun:yes\">&nbsp; </span><i>See </i>TMEP &sect;1202.03(a), (b).<span style=\"mso-spacerun:yes\">&nbsp; </span>Furthermore, the mark is displayed in a  relatively large size on the clothing such that it dominates the overall  appearance of the goods.<span style=\"mso-spacerun:yes\">&nbsp; </span><o:p></o:p></span></span></p>    <p class=\"MsoNormal\" style=\"text-align:justify\"><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><span style=\"color:black\"><o:p>&nbsp;</o:p></span></span></p>    <p class=\"MsoNormal\" style=\"text-align:justify\"><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><span style=\"color:black\">Therefore, consumers would view the applied-for mark as a  decorative or ornamental feature of the goods, rather than as a trademark to  indicate the source of applicant’s goods and to distinguish them from others.<o:p></o:p></span></span></p>    <p class=\"MsoNormal\" style=\"text-align:justify\"><span style=\"mso-bookmark:fpa_Q9_7_1_05222013_32246PM\"><span style=\"mso-fareast-font-family:&quot;Times New Roman&quot;\"><o:p>&nbsp;</o:p></span></span></p></div>\n            <b>Excerpt From:</b>\n            <a href=\"http://tsdr.uspto.gov/documentviewer?caseId=sn85839336&docId=OOA20130522154309#docIndex=4&page=1\" title=\"\">U.S. TRADEMARK APPLICATION NO. 85839336 - JOHNNY FOOTBALL - N/A</a>\n    </div>\n</div>"

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	module.exports = "<header-nav user-menu=\"true\"></header-nav>\n<main class=\"page-content tint-gray\">\n    <section class=\"section-page-min-height\">\n        <div class=\"container container-single-card\">\n            <div class=\"grid grid-full large-grid-fit\">\n                <div class=\"grid-item text-center\">\n                    <div class=\"card card-default tint-green\">\n                        <h2 ng-bind=\"{'account':'Verification Failed','token':'Unverified Account', undefined:'Thanks for verifying'}[verifiedUser.error]\"></h2>\n                        <p ng-bind=\"{'account':'Please confirm the email you are verifying is the email you are signed in with.','token':'Please check your account email for the verification link.', undefined:'You may now close this window.'}[verifiedUser.error]\"></p>\n                        <div class=\"card card-default tint-darkteal text-center\" ng-show=\"verifiedUser.email\">\n                            <h3 class=\"text-ellipsis\">{{verifiedUser.email}}</h3>\n                            <p>This email address is verified.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n</main>\n<lw-page-footer></lw-page-footer>\n"

/***/ }),
/* 888 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		function log(error) {
			(typeof console !== "undefined")
			&& (console.error || console.log)("[Script Loader]", error);
		}
	
		// Check for IE =< 8
		function isIE() {
			return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
		}
	
		try {
			if (typeof execScript !== "undefined" && isIE()) {
				execScript(src);
			} else if (typeof eval !== "undefined") {
				eval.call(null, src);
			} else {
				log("EvalError: No eval function available");
			}
		} catch (error) {
			log(error);
		}
	}


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(888)(__webpack_require__(810))

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el)
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ }),
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(182);
	module.exports = __webpack_require__(__webpack_module_template_argument_0__);


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var forOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var IObject = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toLength = __webpack_require__(__webpack_module_template_argument_3__);
	var asc = __webpack_require__(__webpack_module_template_argument_4__);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var isArray = __webpack_require__(__webpack_module_template_argument_1__);
	var SPECIES = __webpack_require__(__webpack_module_template_argument_2__)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__) {

	'use strict';
	var dP = __webpack_require__(__webpack_module_template_argument_0__).f;
	var create = __webpack_require__(__webpack_module_template_argument_1__);
	var redefineAll = __webpack_require__(__webpack_module_template_argument_2__);
	var ctx = __webpack_require__(__webpack_module_template_argument_3__);
	var anInstance = __webpack_require__(__webpack_module_template_argument_4__);
	var forOf = __webpack_require__(__webpack_module_template_argument_5__);
	var $iterDefine = __webpack_require__(__webpack_module_template_argument_6__);
	var step = __webpack_require__(__webpack_module_template_argument_7__);
	var setSpecies = __webpack_require__(__webpack_module_template_argument_8__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_9__);
	var fastKey = __webpack_require__(__webpack_module_template_argument_10__).fastKey;
	var validate = __webpack_require__(__webpack_module_template_argument_11__);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var from = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var call = __webpack_require__(__webpack_module_template_argument_1__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_2__);
	var anObject = __webpack_require__(__webpack_module_template_argument_3__);
	var toLength = __webpack_require__(__webpack_module_template_argument_4__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_5__);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_5__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_6__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_7__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_8__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_9__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	var toObject = __webpack_require__(__webpack_module_template_argument_3__);
	var IObject = __webpack_require__(__webpack_module_template_argument_4__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_5__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var fails = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_1__);
	var ctx = __webpack_require__(__webpack_module_template_argument_2__);
	var forOf = __webpack_require__(__webpack_module_template_argument_3__);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	var strong = __webpack_require__(__webpack_module_template_argument_0__);
	var validate = __webpack_require__(__webpack_module_template_argument_1__);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(__webpack_module_template_argument_2__)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_1__), 'Object', { defineProperty: __webpack_require__(__webpack_module_template_argument_2__).f });


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getOwnPropertyDescriptor = __webpack_require__(__webpack_module_template_argument_1__).f;
	
	__webpack_require__(__webpack_module_template_argument_2__)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getPrototypeOf = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_17__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_18__);
	var _create = __webpack_require__(__webpack_module_template_argument_19__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_20__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_21__);
	var $DP = __webpack_require__(__webpack_module_template_argument_22__);
	var $keys = __webpack_require__(__webpack_module_template_argument_23__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_24__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_25__).f = $propertyIsEnumerable;
	  __webpack_require__(__webpack_module_template_argument_26__).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_27__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_28__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(__webpack_module_template_argument_0__)('Map');


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(__webpack_module_template_argument_0__)('Map');


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(__webpack_module_template_argument_1__)('Map') });


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ })
]);


// WEBPACK FOOTER //
// factbox-app.bundle.js